var JT = Object.defineProperty;
var kd = (e) => {
  throw TypeError(e);
};
var ZT = (e, t, n) => t in e ? JT(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var k = (e, t, n) => ZT(e, typeof t != "symbol" ? t + "" : t, n), Rd = (e, t, n) => t.has(e) || kd("Cannot " + n);
var Rs = (e, t, n) => (Rd(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Ps = (e, t, n) => t.has(e) ? kd("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Os = (e, t, n, r) => (Rd(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import * as A from "react";
import Ze, { createContext as Tt, useContext as mt, useRef as Ke, useCallback as ne, useMemo as se, useState as ce, useReducer as e1, useLayoutEffect as os, useSyncExternalStore as t1, useDebugValue as n1, useEffect as _e, memo as de, Fragment as Pd, useId as r1, forwardRef as Je, createElement as ec, Component as s1, useImperativeHandle as i1 } from "react";
import { useTranslate as a1, useLanguage as o1, defineTranslateKeys as u1 } from "@winnin/i18n";
import "@winnin/ds-modal/styles.css";
import { Modal as Ds } from "@winnin/ds-modal";
import * as so from "react-dom";
import c1 from "react-dom";
import { CreatorCard as Vr } from "@winnin/ds-creator-card";
import "@winnin/ds-creator-card/styles.css";
import { VideoCard as Yr } from "@winnin/ds-video-card";
import "@winnin/ds-video-card/styles.css";
import { Icon as l1 } from "@winnin/ds-icon";
import { ColumnsChart as d1, LineChart as h1, SyncMultipleDonut as f1 } from "@winnin/ds-charts";
import { analyticsTracker as zi } from "@winnin/analytics";
import { featureFlagsClient as Od } from "@winnin/feature-flags";
import { useHistory as em, useLocation as p1 } from "react-router-dom";
function Dr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vi = { exports: {} }, Ls = {};
var Dd;
function m1() {
  if (Dd) return Ls;
  Dd = 1;
  var e = Ze, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(o, u, c) {
    var l, h = {}, m = null, p = null;
    c !== void 0 && (m = "" + c), u.key !== void 0 && (m = "" + u.key), u.ref !== void 0 && (p = u.ref);
    for (l in u) r.call(u, l) && !i.hasOwnProperty(l) && (h[l] = u[l]);
    if (o && o.defaultProps) for (l in u = o.defaultProps, u) h[l] === void 0 && (h[l] = u[l]);
    return { $$typeof: t, type: o, key: m, ref: p, props: h, _owner: s.current };
  }
  return Ls.Fragment = n, Ls.jsx = a, Ls.jsxs = a, Ls;
}
var Ms = {};
var Ld;
function g1() {
  return Ld || (Ld = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Ze, t = /* @__PURE__ */ Symbol.for("react.element"), n = /* @__PURE__ */ Symbol.for("react.portal"), r = /* @__PURE__ */ Symbol.for("react.fragment"), s = /* @__PURE__ */ Symbol.for("react.strict_mode"), i = /* @__PURE__ */ Symbol.for("react.profiler"), a = /* @__PURE__ */ Symbol.for("react.provider"), o = /* @__PURE__ */ Symbol.for("react.context"), u = /* @__PURE__ */ Symbol.for("react.forward_ref"), c = /* @__PURE__ */ Symbol.for("react.suspense"), l = /* @__PURE__ */ Symbol.for("react.suspense_list"), h = /* @__PURE__ */ Symbol.for("react.memo"), m = /* @__PURE__ */ Symbol.for("react.lazy"), p = /* @__PURE__ */ Symbol.for("react.offscreen"), E = Symbol.iterator, g = "@@iterator";
    function _(N) {
      if (N === null || typeof N != "object")
        return null;
      var Q = E && N[E] || N[g];
      return typeof Q == "function" ? Q : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(N) {
      {
        for (var Q = arguments.length, ie = new Array(Q > 1 ? Q - 1 : 0), Ee = 1; Ee < Q; Ee++)
          ie[Ee - 1] = arguments[Ee];
        C("error", N, ie);
      }
    }
    function C(N, Q, ie) {
      {
        var Ee = b.ReactDebugCurrentFrame, $e = Ee.getStackAddendum();
        $e !== "" && (Q += "%s", ie = ie.concat([$e]));
        var Ye = ie.map(function(De) {
          return String(De);
        });
        Ye.unshift("Warning: " + Q), Function.prototype.apply.call(console[N], console, Ye);
      }
    }
    var R = !1, D = !1, w = !1, O = !1, U = !1, q;
    q = /* @__PURE__ */ Symbol.for("react.module.reference");
    function P(N) {
      return !!(typeof N == "string" || typeof N == "function" || N === r || N === i || U || N === s || N === c || N === l || O || N === p || R || D || w || typeof N == "object" && N !== null && (N.$$typeof === m || N.$$typeof === h || N.$$typeof === a || N.$$typeof === o || N.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      N.$$typeof === q || N.getModuleId !== void 0));
    }
    function z(N, Q, ie) {
      var Ee = N.displayName;
      if (Ee)
        return Ee;
      var $e = Q.displayName || Q.name || "";
      return $e !== "" ? ie + "(" + $e + ")" : ie;
    }
    function G(N) {
      return N.displayName || "Context";
    }
    function F(N) {
      if (N == null)
        return null;
      if (typeof N.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof N == "function")
        return N.displayName || N.name || null;
      if (typeof N == "string")
        return N;
      switch (N) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case o:
            var Q = N;
            return G(Q) + ".Consumer";
          case a:
            var ie = N;
            return G(ie._context) + ".Provider";
          case u:
            return z(N, N.render, "ForwardRef");
          case h:
            var Ee = N.displayName || null;
            return Ee !== null ? Ee : F(N.type) || "Memo";
          case m: {
            var $e = N, Ye = $e._payload, De = $e._init;
            try {
              return F(De(Ye));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var M = Object.assign, H = 0, B, Y, $, Z, y, fe, Ce;
    function v() {
    }
    v.__reactDisabledLog = !0;
    function Se() {
      {
        if (H === 0) {
          B = console.log, Y = console.info, $ = console.warn, Z = console.error, y = console.group, fe = console.groupCollapsed, Ce = console.groupEnd;
          var N = {
            configurable: !0,
            enumerable: !0,
            value: v,
            writable: !0
          };
          Object.defineProperties(console, {
            info: N,
            log: N,
            warn: N,
            error: N,
            group: N,
            groupCollapsed: N,
            groupEnd: N
          });
        }
        H++;
      }
    }
    function Te() {
      {
        if (H--, H === 0) {
          var N = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: M({}, N, {
              value: B
            }),
            info: M({}, N, {
              value: Y
            }),
            warn: M({}, N, {
              value: $
            }),
            error: M({}, N, {
              value: Z
            }),
            group: M({}, N, {
              value: y
            }),
            groupCollapsed: M({}, N, {
              value: fe
            }),
            groupEnd: M({}, N, {
              value: Ce
            })
          });
        }
        H < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = b.ReactCurrentDispatcher, re;
    function Ae(N, Q, ie) {
      {
        if (re === void 0)
          try {
            throw Error();
          } catch ($e) {
            var Ee = $e.stack.trim().match(/\n( *(at )?)/);
            re = Ee && Ee[1] || "";
          }
        return `
` + re + N;
      }
    }
    var he = !1, le;
    {
      var ye = typeof WeakMap == "function" ? WeakMap : Map;
      le = new ye();
    }
    function Pe(N, Q) {
      if (!N || he)
        return "";
      {
        var ie = le.get(N);
        if (ie !== void 0)
          return ie;
      }
      var Ee;
      he = !0;
      var $e = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ye;
      Ye = pe.current, pe.current = null, Se();
      try {
        if (Q) {
          var De = function() {
            throw Error();
          };
          if (Object.defineProperty(De.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(De, []);
            } catch (It) {
              Ee = It;
            }
            Reflect.construct(N, [], De);
          } else {
            try {
              De.call();
            } catch (It) {
              Ee = It;
            }
            N.call(De.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (It) {
            Ee = It;
          }
          N();
        }
      } catch (It) {
        if (It && Ee && typeof It.stack == "string") {
          for (var Oe = It.stack.split(`
`), Ct = Ee.stack.split(`
`), tt = Oe.length - 1, rt = Ct.length - 1; tt >= 1 && rt >= 0 && Oe[tt] !== Ct[rt]; )
            rt--;
          for (; tt >= 1 && rt >= 0; tt--, rt--)
            if (Oe[tt] !== Ct[rt]) {
              if (tt !== 1 || rt !== 1)
                do
                  if (tt--, rt--, rt < 0 || Oe[tt] !== Ct[rt]) {
                    var Vt = `
` + Oe[tt].replace(" at new ", " at ");
                    return N.displayName && Vt.includes("<anonymous>") && (Vt = Vt.replace("<anonymous>", N.displayName)), typeof N == "function" && le.set(N, Vt), Vt;
                  }
                while (tt >= 1 && rt >= 0);
              break;
            }
        }
      } finally {
        he = !1, pe.current = Ye, Te(), Error.prepareStackTrace = $e;
      }
      var zr = N ? N.displayName || N.name : "", gr = zr ? Ae(zr) : "";
      return typeof N == "function" && le.set(N, gr), gr;
    }
    function qe(N, Q, ie) {
      return Pe(N, !1);
    }
    function gt(N) {
      var Q = N.prototype;
      return !!(Q && Q.isReactComponent);
    }
    function Xt(N, Q, ie) {
      if (N == null)
        return "";
      if (typeof N == "function")
        return Pe(N, gt(N));
      if (typeof N == "string")
        return Ae(N);
      switch (N) {
        case c:
          return Ae("Suspense");
        case l:
          return Ae("SuspenseList");
      }
      if (typeof N == "object")
        switch (N.$$typeof) {
          case u:
            return qe(N.render);
          case h:
            return Xt(N.type, Q, ie);
          case m: {
            var Ee = N, $e = Ee._payload, Ye = Ee._init;
            try {
              return Xt(Ye($e), Q, ie);
            } catch {
            }
          }
        }
      return "";
    }
    var zt = Object.prototype.hasOwnProperty, Sn = {}, Fi = b.ReactDebugCurrentFrame;
    function fr(N) {
      if (N) {
        var Q = N._owner, ie = Xt(N.type, N._source, Q ? Q.type : null);
        Fi.setExtraStackFrame(ie);
      } else
        Fi.setExtraStackFrame(null);
    }
    function ji(N, Q, ie, Ee, $e) {
      {
        var Ye = Function.call.bind(zt);
        for (var De in N)
          if (Ye(N, De)) {
            var Oe = void 0;
            try {
              if (typeof N[De] != "function") {
                var Ct = Error((Ee || "React class") + ": " + ie + " type `" + De + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof N[De] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ct.name = "Invariant Violation", Ct;
              }
              Oe = N[De](Q, De, Ee, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (tt) {
              Oe = tt;
            }
            Oe && !(Oe instanceof Error) && (fr($e), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ee || "React class", ie, De, typeof Oe), fr(null)), Oe instanceof Error && !(Oe.message in Sn) && (Sn[Oe.message] = !0, fr($e), T("Failed %s type: %s", ie, Oe.message), fr(null));
          }
      }
    }
    var Ko = Array.isArray;
    function ks(N) {
      return Ko(N);
    }
    function Qo(N) {
      {
        var Q = typeof Symbol == "function" && Symbol.toStringTag, ie = Q && N[Symbol.toStringTag] || N.constructor.name || "Object";
        return ie;
      }
    }
    function Xo(N) {
      try {
        return $i(N), !1;
      } catch {
        return !0;
      }
    }
    function $i(N) {
      return "" + N;
    }
    function V(N) {
      if (Xo(N))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qo(N)), $i(N);
    }
    var ee = b.ReactCurrentOwner, xe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ve, je;
    function Ot(N) {
      if (zt.call(N, "ref")) {
        var Q = Object.getOwnPropertyDescriptor(N, "ref").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return N.ref !== void 0;
    }
    function wn(N) {
      if (zt.call(N, "key")) {
        var Q = Object.getOwnPropertyDescriptor(N, "key").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return N.key !== void 0;
    }
    function Jt(N, Q) {
      typeof N.ref == "string" && ee.current;
    }
    function pr(N, Q) {
      {
        var ie = function() {
          ve || (ve = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        ie.isReactWarning = !0, Object.defineProperty(N, "key", {
          get: ie,
          configurable: !0
        });
      }
    }
    function mr(N, Q) {
      {
        var ie = function() {
          je || (je = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        ie.isReactWarning = !0, Object.defineProperty(N, "ref", {
          get: ie,
          configurable: !0
        });
      }
    }
    var xt = function(N, Q, ie, Ee, $e, Ye, De) {
      var Oe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: N,
        key: Q,
        ref: ie,
        props: De,
        // Record the component responsible for creating this element.
        _owner: Ye
      };
      return Oe._store = {}, Object.defineProperty(Oe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Oe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ee
      }), Object.defineProperty(Oe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $e
      }), Object.freeze && (Object.freeze(Oe.props), Object.freeze(Oe)), Oe;
    };
    function jn(N, Q, ie, Ee, $e) {
      {
        var Ye, De = {}, Oe = null, Ct = null;
        ie !== void 0 && (V(ie), Oe = "" + ie), wn(Q) && (V(Q.key), Oe = "" + Q.key), Ot(Q) && (Ct = Q.ref, Jt(Q, $e));
        for (Ye in Q)
          zt.call(Q, Ye) && !xe.hasOwnProperty(Ye) && (De[Ye] = Q[Ye]);
        if (N && N.defaultProps) {
          var tt = N.defaultProps;
          for (Ye in tt)
            De[Ye] === void 0 && (De[Ye] = tt[Ye]);
        }
        if (Oe || Ct) {
          var rt = typeof N == "function" ? N.displayName || N.name || "Unknown" : N;
          Oe && pr(De, rt), Ct && mr(De, rt);
        }
        return xt(N, Oe, Ct, $e, Ee, ee.current, De);
      }
    }
    var Dt = b.ReactCurrentOwner, xd = b.ReactDebugCurrentFrame;
    function $r(N) {
      if (N) {
        var Q = N._owner, ie = Xt(N.type, N._source, Q ? Q.type : null);
        xd.setExtraStackFrame(ie);
      } else
        xd.setExtraStackFrame(null);
    }
    var Jo;
    Jo = !1;
    function Zo(N) {
      return typeof N == "object" && N !== null && N.$$typeof === t;
    }
    function Cd() {
      {
        if (Dt.current) {
          var N = F(Dt.current.type);
          if (N)
            return `

Check the render method of \`` + N + "`.";
        }
        return "";
      }
    }
    function $T(N) {
      return "";
    }
    var Sd = {};
    function zT(N) {
      {
        var Q = Cd();
        if (!Q) {
          var ie = typeof N == "string" ? N : N.displayName || N.name;
          ie && (Q = `

Check the top-level render call using <` + ie + ">.");
        }
        return Q;
      }
    }
    function wd(N, Q) {
      {
        if (!N._store || N._store.validated || N.key != null)
          return;
        N._store.validated = !0;
        var ie = zT(Q);
        if (Sd[ie])
          return;
        Sd[ie] = !0;
        var Ee = "";
        N && N._owner && N._owner !== Dt.current && (Ee = " It was passed a child from " + F(N._owner.type) + "."), $r(N), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, Ee), $r(null);
      }
    }
    function Id(N, Q) {
      {
        if (typeof N != "object")
          return;
        if (ks(N))
          for (var ie = 0; ie < N.length; ie++) {
            var Ee = N[ie];
            Zo(Ee) && wd(Ee, Q);
          }
        else if (Zo(N))
          N._store && (N._store.validated = !0);
        else if (N) {
          var $e = _(N);
          if (typeof $e == "function" && $e !== N.entries)
            for (var Ye = $e.call(N), De; !(De = Ye.next()).done; )
              Zo(De.value) && wd(De.value, Q);
        }
      }
    }
    function VT(N) {
      {
        var Q = N.type;
        if (Q == null || typeof Q == "string")
          return;
        var ie;
        if (typeof Q == "function")
          ie = Q.propTypes;
        else if (typeof Q == "object" && (Q.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Q.$$typeof === h))
          ie = Q.propTypes;
        else
          return;
        if (ie) {
          var Ee = F(Q);
          ji(ie, N.props, "prop", Ee, N);
        } else if (Q.PropTypes !== void 0 && !Jo) {
          Jo = !0;
          var $e = F(Q);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $e || "Unknown");
        }
        typeof Q.getDefaultProps == "function" && !Q.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function YT(N) {
      {
        for (var Q = Object.keys(N.props), ie = 0; ie < Q.length; ie++) {
          var Ee = Q[ie];
          if (Ee !== "children" && Ee !== "key") {
            $r(N), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ee), $r(null);
            break;
          }
        }
        N.ref !== null && ($r(N), T("Invalid attribute `ref` supplied to `React.Fragment`."), $r(null));
      }
    }
    var vd = {};
    function Nd(N, Q, ie, Ee, $e, Ye) {
      {
        var De = P(N);
        if (!De) {
          var Oe = "";
          (N === void 0 || typeof N == "object" && N !== null && Object.keys(N).length === 0) && (Oe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ct = $T();
          Ct ? Oe += Ct : Oe += Cd();
          var tt;
          N === null ? tt = "null" : ks(N) ? tt = "array" : N !== void 0 && N.$$typeof === t ? (tt = "<" + (F(N.type) || "Unknown") + " />", Oe = " Did you accidentally export a JSX literal instead of a component?") : tt = typeof N, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", tt, Oe);
        }
        var rt = jn(N, Q, ie, $e, Ye);
        if (rt == null)
          return rt;
        if (De) {
          var Vt = Q.children;
          if (Vt !== void 0)
            if (Ee)
              if (ks(Vt)) {
                for (var zr = 0; zr < Vt.length; zr++)
                  Id(Vt[zr], N);
                Object.freeze && Object.freeze(Vt);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Id(Vt, N);
        }
        if (zt.call(Q, "key")) {
          var gr = F(N), It = Object.keys(Q).filter(function(XT) {
            return XT !== "key";
          }), eu = It.length > 0 ? "{key: someKey, " + It.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!vd[gr + eu]) {
            var QT = It.length > 0 ? "{" + It.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, eu, gr, QT, gr), vd[gr + eu] = !0;
          }
        }
        return N === r ? YT(rt) : VT(rt), rt;
      }
    }
    function GT(N, Q, ie) {
      return Nd(N, Q, ie, !0);
    }
    function WT(N, Q, ie) {
      return Nd(N, Q, ie, !1);
    }
    var qT = WT, KT = GT;
    Ms.Fragment = r, Ms.jsx = qT, Ms.jsxs = KT;
  })()), Ms;
}
var Md;
function E1() {
  return Md || (Md = 1, process.env.NODE_ENV === "production" ? Vi.exports = m1() : Vi.exports = g1()), Vi.exports;
}
var d = E1();
const tm = Tt(null), at = () => {
  const e = mt(tm);
  if (!e)
    throw new Error("useAccessContext must be used within an AccessContextProvider");
  return e;
}, b1 = {
  "center-stage": "Center Stage",
  "side-chat": "Side Chat",
  "soa-chat": "SOA Chat",
  "demand-intelligence": "Demand Intelligence"
}, nm = Tt(null), Es = () => {
  const e = mt(nm);
  if (!e)
    throw new Error("useMixpanelSendMessageSettings must be used within a MixpanelSendMessageSettingsProvider");
  return e;
}, _1 = ({ children: e }) => {
  const t = Ke(null), n = Ke(null), r = Ke(null), s = Ke(null), i = ne(({ origin: g }) => {
    t.current = b1[g] || null;
  }, []), a = ne(({ page: g }) => {
    n.current = g;
  }, []), o = ne((g) => {
    r.current = g;
  }, []), u = ne(() => t.current, []), c = ne(() => n.current, []), l = ne(() => !!r.current, []), h = ne(() => {
    r.current = null, n.current = null, s.current = null;
  }, []), m = ne((g) => {
    s.current = g;
  }, []), p = ne(() => !!s.current, []), E = {
    setOrigin: i,
    getOrigin: u,
    setPage: a,
    getPage: c,
    setIsPrePrompt: o,
    checkIsPrePrompt: l,
    resetIsPrePrompt: h,
    setIsProactiveMessage: m,
    checkIsProactiveMessage: p
  };
  return /* @__PURE__ */ d.jsx(nm.Provider, { value: E, children: e });
}, rm = Tt(void 0), Vc = () => {
  const e = mt(rm);
  if (!e)
    throw new Error("usePrePromptParams must be used within a PrePromptParamsProvider");
  return e;
}, T1 = ({ children: e }) => {
  const t = Ke(null), n = ne((a) => {
    t.current = a;
  }, []), r = ne(() => t.current, []), s = ne(() => {
    t.current = null;
  }, []), i = se(
    () => ({
      setQuickPromptId: n,
      getQuickPromptId: r,
      resetPrePromptParams: s
    }),
    [r, s, n]
  );
  return /* @__PURE__ */ d.jsx(rm.Provider, { value: i, children: e });
}, sm = Tt(void 0), im = () => {
  const e = mt(sm);
  if (!e)
    throw new Error("useThreadRunningState must be used within a ThreadRunningStateProvider");
  return e;
}, am = Tt(void 0), om = () => {
  const e = mt(am);
  if (!e)
    throw new Error("useZaiChatSectionStates must be used within a ZaiChatSectionStatesProvider");
  return e;
}, A1 = ({ children: e }) => {
  const [t, n] = ce({}), r = ne(
    (c) => t[c]?.threadId,
    [t]
  ), s = ne(({ contextKey: c, id: l }) => {
    n((h) => ({
      ...h,
      [c]: {
        ...h[c] || {},
        threadId: l
      }
    }));
  }, []), i = ne(
    (c) => t[c]?.lastPrompt,
    [t]
  ), a = ne(({ contextKey: c, prompt: l }) => {
    n((h) => ({
      ...h,
      [c]: {
        ...h[c] || {},
        lastPrompt: l
      }
    }));
  }, []), o = ne(
    (c) => Object.values(t).some((l) => l.threadId === c),
    [t]
  ), u = se(
    () => ({
      getCurrentThreadId: r,
      setCurrentThreadId: s,
      getLastPrompt: i,
      setLastPrompt: a,
      isSectionThreadId: o
    }),
    [r, s, i, a, o]
  );
  return /* @__PURE__ */ d.jsx(am.Provider, { value: u, children: e });
}, y1 = ({
  children: e,
  onBackgroundThreadComplete: t,
  isChatVisible: n
}) => {
  const [r, s] = ce({}), { isSectionThreadId: i } = om(), a = ne(({ threadId: l, isRunning: h }) => {
    s((m) => {
      if (!!m[l] === h) return m;
      if (!h) {
        const { [l]: p, ...E } = m;
        return E;
      }
      return { ...m, [l]: !0 };
    });
  }, []), o = ne(
    ({ threadId: l, isActiveThread: h, title: m }) => {
      if (!t || i(l)) return;
      (!h || !n?.()) && t(l, m);
    },
    [t, n, i]
  ), u = ne(
    (l) => !!(l && r[l]),
    [r]
  ), c = se(
    () => ({ isThreadRunning: u, setThreadRunning: a, notifyIfBackground: o }),
    [u, a, o]
  );
  return /* @__PURE__ */ d.jsx(sm.Provider, { value: c, children: e });
};
function Hd(e) {
  const t = [];
  for (const n of e.effectTasks)
    try {
      n();
    } catch (r) {
      t.push(r);
    }
  if (t.length > 0) {
    if (t.length === 1)
      throw t[0];
    for (const n of t)
      console.error(n);
    throw new AggregateError(t, "Errors during commit");
  }
}
function um(e) {
  const t = [];
  for (const n of e.cells)
    if (n?.type === "effect" && (n.deps = null, n.cleanup))
      try {
        n.cleanup?.();
      } catch (r) {
        t.push(r);
      } finally {
        n.cleanup = void 0;
      }
  if (t.length > 0) {
    if (t.length === 1)
      throw t[0];
    for (const n of t)
      console.error(n);
    throw new AggregateError(t, "Errors during cleanup");
  }
}
const Dn = typeof process < "u" && (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test");
let xr = null;
function x1(e, t) {
  e.currentIndex = 0;
  const n = xr;
  xr = e;
  try {
    if (t(), e.isFirstRender = !1, e.cells.length !== e.currentIndex)
      throw new Error(`Rendered ${e.currentIndex} hooks but expected ${e.cells.length}. Hooks must be called in the exact same order in every render.`);
  } finally {
    xr = n;
  }
}
function er() {
  if (!xr)
    throw new Error("No resource fiber available");
  return xr;
}
function C1(e) {
  return Dn ? xr?.devStrictMode ? xr.isFirstRender ? "child" : "root" : e ? "root" : null : null;
}
function S1(e, t) {
  const n = e[cm];
  if (!n)
    throw new Error("ResourceElement.type is not a valid Resource");
  return n(t);
}
const cm = /* @__PURE__ */ Symbol("fnSymbol");
function li(e, t, n = void 0, r = C1(!1)) {
  return {
    type: e,
    root: t,
    markDirty: n,
    devStrictMode: r,
    cells: [],
    currentIndex: 0,
    renderContext: void 0,
    isFirstRender: !0,
    isMounted: !1,
    isNeverMounted: !0
  };
}
function ns(e) {
  if (!e.isMounted)
    throw new Error("Tried to unmount a fiber that is already unmounted");
  e.isMounted = !1, um(e);
}
function Pn(e, t) {
  const n = {
    effectTasks: [],
    props: t,
    output: void 0
  };
  return x1(e, () => {
    e.renderContext = n;
    try {
      n.output = S1(e.type, t);
    } finally {
      e.renderContext = void 0;
    }
  }), n;
}
function us(e, t) {
  e.isMounted = !0, Dn && e.isNeverMounted && e.devStrictMode === "root" && (e.isNeverMounted = !1, Hd(t), um(e)), e.isNeverMounted = !1, Hd(t);
}
const lm = (e) => ({
  version: 0,
  committedVersion: 0,
  dispatchUpdate: e,
  changelog: [],
  dirtyCells: []
}), Pa = (e) => {
  for (const t of e.dirtyCells)
    t.dirty = !1, t.queue.clear(), t.current = t.workInProgress;
  e.committedVersion = e.version, e.changelog.length = 0, e.dirtyCells.length = 0;
}, Qs = (e, t) => {
  const n = e.version > t;
  if (e.version = t, n) {
    for (const r of e.dirtyCells)
      r.dirty = !1, r.queue.clear(), r.workInProgress = r.current;
    if (e.dirtyCells.length = 0, t === e.committedVersion)
      e.changelog.length = 0;
    else {
      if (e.committedVersion > t)
        throw new Error("Version is less than committed version");
      for (; e.committedVersion + e.changelog.length > t; )
        e.changelog.pop();
      e.changelog.forEach((r) => r()), Pa(e);
    }
  }
}, Bd = (e, t) => {
  t.dirty || (t.dirty = !0, e.markDirty?.(), e.root.dirtyCells.push(t));
}, w1 = () => {
  if (!Dn)
    return null;
  const e = Ke(0), t = e.current === 0;
  return ce(() => e.current++), e.current !== 2 ? null : t ? "child" : "root";
};
function I1(e) {
  const t = se(() => lm((o) => r(o)), []), [n, r] = e1((o, u) => (Qs(t, o), o + (u() ? 1 : 0)), 0);
  Qs(t, n);
  const s = w1(), i = se(() => (e.key, li(e.type, t, void 0, s)), [e.type, e.key, t, s]), a = Pn(i, e.props);
  return os(() => () => ns(i), [i]), os(() => {
    Pa(t), us(i, a);
  }), a.output;
}
function Fe(e) {
  const t = (n) => ({
    type: t,
    props: n
  });
  return t[cm] = e, t;
}
function Ln(e, t) {
  return { ...t, key: e };
}
const dm = (e, t) => {
  const n = er(), r = n.currentIndex++;
  if (!n.isFirstRender && r >= n.cells.length)
    throw new Error("Rendered more hooks than during the previous render. Hooks must be called in the exact same order in every render.");
  let s = n.cells[r];
  if (s || (s = t(), n.cells[r] = s), s.type !== e)
    throw new Error("Hook order changed between renders");
  return s;
}, v1 = (e) => {
  er().renderContext.effectTasks.push(e);
}, N1 = (e, t) => {
  if (e.renderContext)
    throw new Error("Resource updated during render");
  if (e.isNeverMounted)
    throw new Error("Resource updated before mount");
  e.root.dispatchUpdate(() => {
    const n = t();
    return n ? (n(), e.root.changelog.push(n), !0) : !1;
  });
};
function hm(e, t, n, r) {
  const s = dm("reducer", () => {
    const o = er(), u = r ? r(n) : n;
    return Dn && o.devStrictMode && r && r(n), {
      type: "reducer",
      queue: /* @__PURE__ */ new Set(),
      dirty: !1,
      workInProgress: u,
      current: u,
      reducer: e,
      dispatch: (c) => {
        const l = {
          action: c,
          hasEagerState: !1,
          eagerState: void 0
        };
        N1(o, () => o.root.dirtyCells.length === 0 && !l.hasEagerState && (l.eagerState = e(s.workInProgress, c), l.hasEagerState = !0, Object.is(s.current, l.eagerState)) ? null : () => {
          Bd(o, s), s.queue.add(l);
        });
      }
    };
  }), i = er(), a = e === s.reducer;
  s.reducer = e;
  for (const o of s.queue)
    (!o.hasEagerState || !a) && (o.eagerState = e(s.workInProgress, o.action), o.hasEagerState = !0), Dn && i.devStrictMode && e(s.workInProgress, o.action), s.workInProgress = o.eagerState;
  if (s.queue.clear(), t) {
    const o = t(s.workInProgress);
    Object.is(o, s.workInProgress) || (Bd(i, s), s.workInProgress = o);
  }
  return [s.workInProgress, s.dispatch];
}
function k1(e, t, n) {
  return hm(e, void 0, t, n);
}
function R1(e, t, n, r) {
  return hm(e, t, n, r);
}
const P1 = (e, t) => typeof t == "function" ? t(e) : t, O1 = (e) => typeof e == "function" ? e() : e;
function Tn(e) {
  return k1(P1, e, O1);
}
const fm = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!Object.is(e[n], t[n]))
      return !1;
  return !0;
}, D1 = () => ({
  type: "effect",
  cleanup: void 0,
  deps: null
  // null means the effect has never been run
});
function ft(e, t) {
  const n = dm("effect", D1);
  if (!(t && n.deps && fm(n.deps, t))) {
    if (n.deps !== null && !!t != !!n.deps)
      throw new Error("tapEffect called with and without dependencies across re-renders");
    v1(() => {
      const r = [];
      try {
        n.cleanup?.();
      } catch (s) {
        r.push(s);
      } finally {
        n.cleanup = void 0;
      }
      try {
        const s = e();
        if (s !== void 0 && typeof s != "function")
          throw new Error(`An effect function must either return a cleanup function or nothing. Received: ${typeof s}`);
        n.cleanup = s;
      } catch (s) {
        r.push(s);
      }
      if (n.deps = t, r.length > 0) {
        if (r.length === 1)
          throw r[0];
        for (const s of r)
          console.error(s);
        throw new AggregateError(r, "Errors during commit");
      }
    });
  }
}
function Xn(e) {
  const [t] = Tn(() => ({
    current: e
  }));
  return t;
}
function Cr(e, t) {
  const [n] = Tn(e);
  return n;
}
const L1 = () => {
  throw new Error("Memo reducer should not be called");
}, Me = (e, t) => {
  const n = er(), [r] = R1(L1, (s) => {
    if (s && fm(s.deps, t))
      return s;
    const i = e();
    return Dn && n.devStrictMode && e(), { value: i, deps: t };
  }, null);
  return r.value;
}, io = (e, t) => Me(() => e, t);
function Yc(e) {
  const t = Xn(e);
  if (ft(() => {
    t.current = e;
  }), Dn) {
    const n = er();
    return io(((...r) => {
      if (n.renderContext)
        throw new Error("tapEffectEvent cannot be called during render");
      return t.current(...r);
    }), [n]);
  }
  return t.current;
}
function Ft(e, t) {
  const n = er(), r = Xn(0), s = Me(() => (e.key, li(e.type, n.root, () => {
    r.current++, n.markDirty?.();
  })), [e.type, e.key, n]), i = t ? (
    // biome-ignore lint/correctness/useExhaustiveDependencies: user provided deps instead of prop identity
    Me(() => Pn(s, e.props), [s, ...t, r.current])
  ) : Pn(s, e.props);
  return ft(() => () => ns(s), [s]), ft(() => {
    us(s, i);
  }, [s, i]), i.output;
}
function Gc(e, t) {
  const n = Xn(0), r = n.current, s = Cr(er), i = Cr(() => () => {
    n.current++, s.markDirty?.();
  }), a = Cr(() => /* @__PURE__ */ new Map()), o = t ? (
    // biome-ignore lint/correctness/useExhaustiveDependencies: library code
    io(e, t)
  ) : e, u = Me(() => {
    const c = o(), l = /* @__PURE__ */ new Set(), h = [];
    let m = 0;
    for (let p = 0; p < c.length; p++) {
      const E = c[p], g = E.key;
      if (g === void 0)
        throw new Error(`tapResources did not provide a key for array at index ${p}`);
      if (l.has(g))
        throw new Error(`Duplicate key ${g} in tapResources`);
      l.add(g);
      let _ = a.get(g);
      if (_)
        if (_.fiber.type !== E.type) {
          const b = li(E.type, s.root, i), T = Pn(b, E.props);
          _.next = [b, T], h.push(T.output);
        } else
          _.next = Pn(_.fiber, E.props), h.push(_.next.output);
      else {
        const b = li(E.type, s.root, i), T = Pn(b, E.props);
        _ = {
          fiber: b,
          next: T
        }, m++, a.set(g, _), h.push(T.output);
      }
    }
    if (a.size > h.length - m)
      for (const p of a.keys())
        l.has(p) || (a.get(p).next = "delete");
    return h;
  }, [o, r]);
  return ft(() => () => {
    for (const c of a.keys()) {
      const l = a.get(c).fiber;
      ns(l);
    }
  }, []), ft(() => {
    for (const [c, l] of a.entries())
      l.next === "delete" ? (l.fiber.isMounted && ns(l.fiber), a.delete(c)) : Array.isArray(l.next) ? (ns(l.fiber), l.fiber = l.next[0], us(l.fiber, l.next[1])) : us(l.fiber, l.next);
  }, [u]), u;
}
const M1 = 50;
let En = {
  schedulers: /* @__PURE__ */ new Set([]),
  isScheduled: !1
};
class H1 {
  constructor(t) {
    k(this, "_task");
    k(this, "_isDirty", !1);
    this._task = t;
  }
  get isDirty() {
    return this._isDirty;
  }
  markDirty() {
    this._isDirty = !0, En.schedulers.add(this), B1();
  }
  runTask() {
    this._isDirty = !1, this._task();
  }
}
const B1 = () => {
  En.isScheduled || (En.isScheduled = !0, U1());
}, tc = () => {
  try {
    const e = [];
    let t = 0;
    for (const n of En.schedulers)
      if (En.schedulers.delete(n), !!n.isDirty) {
        if (t++, t > M1)
          throw new Error("Maximum update depth exceeded. This can happen when a resource repeatedly calls setState inside tapEffect.");
        try {
          n.runTask();
        } catch (r) {
          e.push(r);
        }
      }
    if (e.length > 0) {
      if (e.length === 1)
        throw e[0];
      for (const n of e)
        console.error(n);
      throw new AggregateError(e, "Errors occurred during flushSync");
    }
  } finally {
    En.schedulers.clear(), En.isScheduled = !1;
  }
}, U1 = (() => {
  if (typeof MessageChannel < "u") {
    const e = new MessageChannel();
    return e.port1.onmessage = tc, () => e.port2.postMessage(null);
  }
  return () => setTimeout(tc, 0);
})(), F1 = (e) => {
  const t = En;
  En = {
    schedulers: /* @__PURE__ */ new Set([]),
    isScheduled: !0
  };
  try {
    const n = e();
    return tc(), n;
  } finally {
    En = t;
  }
}, j1 = (e) => {
  const t = Cr(() => new H1(() => c(null))), n = Cr(() => []), r = Me(() => (e.key, li(e.type, lm((l) => {
    !t.isDirty && !l() || (n.push(l), t.markDirty());
  }))), [e.type, e.key]);
  Qs(r.root, r.root.committedVersion);
  const s = Pn(r, e.props), i = Xn(!1), a = Xn(e.props), o = Xn(s.output), u = Cr(() => /* @__PURE__ */ new Set()), c = Yc((l) => {
    if (l === null && (Qs(r.root, 2), Qs(r.root, 1), n.forEach((h) => {
      Dn && r.devStrictMode && h(), h();
    }), Dn && r.devStrictMode && Pn(r, a.current), l = Pn(r, a.current)), t.isDirty)
      throw new Error("Scheduler is dirty, this should never happen");
    Pa(r.root), n.length = 0, i.current && us(r, l), !(t.isDirty || o.current === l.output) && (o.current = l.output, u.forEach((h) => h()));
  });
  return ft(() => (i.current = !0, () => {
    i.current = !1, ns(r);
  }), [r]), ft(() => {
    a.current = s.props, Pa(r.root), us(r, s), !(t.isDirty || o.current === s.output) && (o.current = s.output, u.forEach((l) => l()));
  }), Me(() => ({
    getValue: () => o.current,
    subscribe: (l) => (u.add(l), () => u.delete(l))
  }), []);
}, Xs = /* @__PURE__ */ Symbol("tap.Context"), pm = (e) => ({
  [Xs]: e
}), mm = (e, t, n) => {
  const r = e[Xs];
  e[Xs] = t;
  try {
    return n();
  } finally {
    e[Xs] = r;
  }
}, gm = (e) => e[Xs], nc = /* @__PURE__ */ Symbol("assistant-ui.store.clientIndex"), $1 = (e) => e[nc], Em = pm([]), Wc = () => gm(Em), z1 = (e, t) => {
  const n = Wc(), r = Me(() => [...n, e], [n, e]);
  return mm(Em, r, t);
}, V1 = /* @__PURE__ */ new Set(["$$typeof", "nodeType", "then"]), ao = (e, t) => {
  if (e === Symbol.toStringTag)
    return t;
  if (typeof e != "symbol") {
    if (e === "toJSON")
      return () => t;
    if (!V1.has(e))
      return !1;
  }
};
class qc {
  getOwnPropertyDescriptor(t, n) {
    const r = this.get(t, n);
    if (r !== void 0)
      return {
        value: r,
        writable: !1,
        enumerable: !0,
        configurable: !1
      };
  }
  set() {
    return !1;
  }
  setPrototypeOf() {
    return !1;
  }
  defineProperty() {
    return !1;
  }
  deleteProperty() {
    return !1;
  }
  preventExtensions() {
    return !1;
  }
}
const bm = (e) => {
  const t = Fe(e);
  return (n) => {
    const r = t(n);
    return n.key === void 0 ? r : Ln(n.key, r);
  };
}, Oa = /* @__PURE__ */ Symbol("assistant-ui.store.getValue"), Y1 = (e) => {
  const t = e[Oa];
  if (!t)
    throw new Error("Client scope contains a non-client resource. Ensure your Derived get() returns a client created with tapClientResource(), not a plain resource.");
  return t.getState?.();
}, Ud = /* @__PURE__ */ new Map();
function G1(e) {
  let t = Ud.get(e);
  return t || (t = function(...n) {
    if (!this || typeof this != "object")
      throw new Error(`Method "${String(e)}" called without proper context. This may indicate the function was called incorrectly.`);
    const r = this[Oa];
    if (!r)
      throw new Error(`Method "${String(e)}" called on invalid client proxy. Ensure you are calling this method on a valid client instance.`);
    const s = r[e];
    if (!s)
      throw new Error(`Method "${String(e)}" is not implemented.`);
    if (typeof s != "function")
      throw new Error(`"${String(e)}" is not a function.`);
    return s(...n);
  }, Ud.set(e, t)), t;
}
class W1 extends qc {
  constructor(n, r) {
    super();
    k(this, "outputRef");
    k(this, "index");
    k(this, "boundFns");
    k(this, "cachedReceiver");
    this.outputRef = n, this.index = r;
  }
  get(n, r, s) {
    if (r === Oa)
      return this.outputRef.current;
    if (r === nc)
      return this.index;
    const i = ao(r, "ClientProxy");
    if (i !== !1)
      return i;
    const a = this.outputRef.current[r];
    if (typeof a == "function") {
      this.cachedReceiver !== s && (this.boundFns = /* @__PURE__ */ new Map(), this.cachedReceiver = s);
      let o = this.boundFns.get(r);
      return o || (o = G1(r).bind(s), this.boundFns.set(r, o)), o;
    }
    return a;
  }
  ownKeys() {
    return Object.keys(this.outputRef.current);
  }
  has(n, r) {
    return r === Oa || r === nc ? !0 : r in this.outputRef.current;
  }
}
const _m = bm((e) => {
  const t = Xn(null), n = Wc().length, r = Me(() => new Proxy({}, new W1(t, n)), [n]), s = z1(r, () => Ft(e));
  t.current || (t.current = s), ft(() => {
    t.current = s;
  });
  const i = s.getState?.();
  return { methods: r, state: i, key: e.key };
}), oo = (e) => Ft(_m(e)), Js = /* @__PURE__ */ Symbol("assistant-ui.store.proxiedAssistantState"), tu = (e) => e === "on" || e === "subscribe" || typeof e == "symbol", Tm = (e) => {
  class t extends qc {
    get(r, s) {
      const i = ao(s, "AssistantState");
      if (i !== !1)
        return i;
      const a = s;
      if (!tu(a))
        return Y1(e[a]());
    }
    ownKeys() {
      return Object.keys(e).filter((r) => !tu(r));
    }
    has(r, s) {
      return !tu(s) && s in e;
    }
  }
  return new Proxy({}, new t());
}, q1 = (e) => e[Js], Fd = () => () => {
}, Am = (e) => {
  const t = (() => {
    throw new Error(e);
  });
  return t.source = null, t.query = null, t;
};
class K1 extends qc {
  get(t, n) {
    if (n === "subscribe" || n === "on")
      return Fd;
    if (n === Js)
      return Q1;
    const r = ao(n, "DefaultAssistantClient");
    return r !== !1 ? r : Am("You are using a component or hook that requires an AuiProvider. Wrap your component in an <AuiProvider> component.");
  }
  ownKeys() {
    return ["subscribe", "on", Js];
  }
  has(t, n) {
    return n === "subscribe" || n === "on" || n === Js;
  }
}
const uo = new Proxy({}, new K1()), Q1 = Tm(uo), X1 = () => new Proxy({}, {
  get(e, t) {
    const n = ao(t, "AssistantClient");
    return n !== !1 ? n : Am(`The current scope does not have a "${String(t)}" property.`);
  }
}), ym = Tt(uo), J1 = () => mt(ym), Lr = ({ value: e, children: t }) => d.jsx(ym.Provider, { value: e, children: t }), On = Fe((e) => null), rc = /* @__PURE__ */ Symbol("assistant-ui.transform-scopes");
function xm(e, t) {
  const n = e;
  if (n[rc])
    throw new Error("transformScopes is already attached to this resource");
  n[rc] = t;
}
function Z1(e) {
  return e[rc];
}
function eA(e, t) {
  const n = { ...e }, r = /* @__PURE__ */ new Set();
  let s = !0;
  for (; s; ) {
    s = !1;
    for (const o of Object.values(n)) {
      if (o.type === On || r.has(o.type))
        continue;
      r.add(o.type);
      const u = Z1(o.type);
      if (u) {
        u(n, t), s = !0;
        break;
      }
    }
  }
  const i = {}, a = {};
  for (const [o, u] of Object.entries(n))
    u.type === On ? a[o] = u : i[o] = u;
  return { rootClients: i, derivedClients: a };
}
const jd = (e) => Me(() => e, [...Object.entries(e).flat()]), tA = (e, t) => {
  const { rootClients: n, derivedClients: r } = eA(e, t);
  return {
    rootClients: jd(n),
    derivedClients: jd(r)
  };
}, Cm = (e) => typeof e == "string" ? { scope: e.split(".")[0], event: e } : { scope: e.scope, event: e.event }, nA = Fe(() => Cr(() => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set();
  return {
    on(r, s) {
      const i = s;
      if (r === "*")
        return t.add(i), () => t.delete(i);
      let a = e.get(r);
      return a || (a = /* @__PURE__ */ new Set(), e.set(r, a)), a.add(i), () => {
        a.delete(i), a.size === 0 && e.delete(r);
      };
    },
    emit(r, s, i) {
      const a = e.get(r);
      !a && t.size === 0 || queueMicrotask(() => {
        const o = [];
        if (a)
          for (const u of a)
            try {
              u(s, i);
            } catch (c) {
              o.push(c);
            }
        if (t.size > 0) {
          const u = { event: r, payload: s };
          for (const c of t)
            try {
              c(u, i);
            } catch (l) {
              o.push(l);
            }
        }
        if (o.length > 0) {
          if (o.length === 1)
            throw o[0];
          for (const u of o)
            console.error(u);
          throw new AggregateError(o, "Errors occurred during event emission");
        }
      });
    },
    subscribe(r) {
      return n.add(r), () => n.delete(r);
    },
    notifySubscribers() {
      for (const r of n)
        try {
          r();
        } catch (s) {
          console.error("NotificationManager: subscriber callback error", s);
        }
    }
  };
})), Sm = pm(null), rA = (e, t) => mm(Sm, e, t), wm = () => {
  const e = gm(Sm);
  if (!e)
    throw new Error("AssistantTapContext is not available");
  return e;
}, Im = () => wm().clientRef, Kc = () => {
  const { emit: e } = wm(), t = Wc();
  return Yc((n, r) => {
    e(n, r, t);
  });
}, vm = (e) => Me(() => e, e), sA = Fe(({ element: e, emit: t, clientRef: n }) => {
  const { methods: r, state: s } = rA({ clientRef: n, emit: t }, () => oo(e));
  return Me(() => ({ state: s, methods: r }), [r, s]);
}), iA = Fe(({ element: e, notifications: t, clientRef: n, name: r }) => {
  const s = j1(sA({ element: e, emit: t.emit, clientRef: n }));
  return ft(() => s.subscribe(t.notifySubscribers), [s, t]), Me(() => {
    const i = () => s.getValue().methods;
    return Object.defineProperties(i, {
      source: {
        value: "root",
        writable: !1
      },
      query: {
        value: {},
        writable: !1
      },
      name: {
        value: r,
        configurable: !0
      }
    }), i;
  }, [s, r]);
}), aA = Fe(() => Me(() => ({
  clients: [],
  subscribe: void 0,
  on: void 0
}), [])), oA = Fe(({ clients: e, clientRef: t }) => {
  const n = Ft(nA());
  ft(() => t.parent.subscribe(n.notifySubscribers), [t, n]);
  const r = vm(Gc(() => Object.keys(e).map((s) => Ln(s, iA({
    element: e[s],
    notifications: n,
    clientRef: t,
    name: s
  }))), [e, n, t]));
  return Me(() => ({
    clients: r,
    subscribe: n.subscribe,
    on: function(s, i) {
      if (!this)
        throw new Error("const { on } = useAui() is not supported. Use aui.on() instead.");
      const { scope: a, event: o } = Cm(s);
      if (a !== "*" && this[a].source === null)
        throw new Error(`Scope "${a}" is not available. Use { scope: "*", event: "${o}" } to listen globally.`);
      const u = n.on(o, (l, h) => {
        if (a === "*") {
          i(l);
          return;
        }
        const m = this[a](), p = $1(m);
        m === h[p] && i(l);
      });
      if (a !== "*" && t.parent[a].source === null)
        return u;
      const c = t.parent.on(s, i);
      return () => {
        u(), c();
      };
    }
  }), [r, n, t]);
}), $d = (e, t, n) => {
  if ("source" in e && "query" in e)
    return e;
  if (n.dep === e)
    return n.meta;
  const r = e.getMeta(t.current);
  return n.meta = r, n.dep = e, r;
}, uA = Fe(({ element: e, clientRef: t, name: n }) => {
  const r = Yc(() => e.props);
  return Me(() => {
    const s = () => r().get(t.current), i = {};
    return Object.defineProperties(s, {
      source: {
        get: () => $d(r(), t, i).source
      },
      query: {
        get: () => $d(r(), t, i).query
      },
      name: {
        value: n,
        configurable: !0
      }
    }), s;
  }, [t, n]);
}), cA = Fe(({ clients: e, clientRef: t }) => vm(Gc(() => Object.keys(e).map((n) => Ln(n, uA({
  element: e[n],
  clientRef: t,
  name: n
}))), [e, t]))), lA = Fe(({ parent: e, clients: t }) => {
  const { rootClients: n, derivedClients: r } = tA(t, e), s = Xn({
    parent: e,
    current: null
  }).current;
  ft(() => {
    s.current = o;
  });
  const i = Ft(Object.keys(n).length > 0 ? oA({ clients: n, clientRef: s }) : aA()), a = Ft(cA({ clients: r, clientRef: s })), o = Me(() => {
    const u = e === uo ? X1() : e, c = Object.create(u);
    Object.assign(c, {
      subscribe: i.subscribe ?? e.subscribe,
      on: i.on ?? e.on,
      [Js]: Tm(c)
    });
    for (const l of i.clients)
      c[l.name] = l;
    for (const l of a)
      c[l.name] = l;
    return c;
  }, [e, i, a]);
  return s.current === null && (s.current = o), o;
});
function Re(e, { parent: t } = {
  parent: J1()
}) {
  if (e)
    return I1(lA({
      parent: t ?? uo,
      clients: e
    }));
  if (t === null)
    throw new Error("received null parent, this usage is not allowed");
  return t;
}
const J = (e) => {
  const t = Re(), n = q1(t), r = t1(t.subscribe, () => e(n), () => e(n));
  if (r === n)
    throw new Error("You tried to return the entire AssistantState. This is not supported due to technical limitations.");
  return n1(r), r;
}, dA = Ze.createContext(!0);
function zd() {
  throw new Error("A function wrapped in useEffectEvent can't be called during rendering.");
}
const hA = "use" in Ze ? () => {
  try {
    return Ze.use(dA);
  } catch {
    return !1;
  }
} : () => !1;
function fA(e) {
  const t = Ze.useRef(zd);
  return Ze.useInsertionEffect(() => {
    t.current = e;
  }, [e]), (...n) => {
    hA() && zd();
    const r = t.current;
    return r(...n);
  };
}
const nu = (e, t) => {
  const n = Re(), r = fA(t), { scope: s, event: i } = Cm(e);
  _e(() => n.on({ scope: s, event: i }, r), [n, s, i, r]);
}, pA = (e) => {
  const t = Re(), n = Ke(void 0);
  return J(() => (n.current === void 0 && (n.current = e(t)), n.current)), () => (n.current = void 0, e(t));
}, mA = Object.freeze({});
function Qc({ getItemState: e, children: t }) {
  const n = pA(e);
  return gA(t(n));
}
const gA = (e) => {
  const t = typeof e == "object" && e != null && "type" in e ? e : null, n = t?.type, r = t?.key, s = typeof t?.props == "object" && t.props != null && Object.entries(t.props).length === 0 ? mA : t?.props;
  return (
    // biome-ignore lint/correctness/useExhaustiveDependencies: optimization
    se(() => t, [n, r, s]) ?? e
  );
}, EA = bm((e) => {
  if (e.key === void 0)
    throw new Error("tapClientResource: Element has no key");
  return Ft(_m(e));
});
function cs(e, t) {
  const n = Gc(
    () => e().map((a) => EA(a)),
    // biome-ignore lint/correctness/useExhaustiveDependencies: getElementsDeps is passed through from caller
    t
  ), r = Me(() => Object.keys(n), [n]), s = Me(() => n.reduce((a, o, u) => (a[o.key] = u, a), {}), [n]);
  return {
    state: Me(() => n.map((a) => a.state), [n]),
    get: (a) => {
      if ("index" in a) {
        if (a.index < 0 || a.index >= r.length)
          throw new Error(`tapClientLookup: Index ${a.index} out of bounds (length: ${r.length})`);
        return n[a.index].methods;
      }
      const o = s[a.key];
      if (o === void 0)
        throw new Error(`tapClientLookup: Key "${a.key}" not found`);
      return n[o].methods;
    }
  };
}
const Vd = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (c, l) => {
    const h = typeof c == "function" ? c(t) : c;
    if (!Object.is(h, t)) {
      const m = t;
      t = l ?? (typeof h != "object" || h === null) ? h : Object.assign({}, t, h), n.forEach((p) => p(t, m));
    }
  }, s = () => t, o = { setState: r, getState: s, getInitialState: () => u, subscribe: (c) => (n.add(c), () => n.delete(c)) }, u = t = e(r, s, o);
  return o;
}, bA = ((e) => e ? Vd(e) : Vd), _A = (e) => e;
function TA(e, t = _A) {
  const n = Ze.useSyncExternalStore(
    e.subscribe,
    Ze.useCallback(() => t(e.getState()), [e, t]),
    Ze.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return Ze.useDebugValue(n), n;
}
const Yd = (e) => {
  const t = bA(e), n = (r) => TA(t, r);
  return Object.assign(n, t), n;
}, ls = ((e) => e ? Yd(e) : Yd), AA = Fe((e) => ({
  getState: () => e
})), yA = Fe((e) => {
  const [t] = Tn(() => ({
    suggestions: (e ?? []).map((s) => typeof s == "string" ? {
      title: s,
      label: "",
      prompt: s
    } : {
      title: s.title,
      label: s.label,
      prompt: s.prompt
    })
  })), n = cs(() => t.suggestions.map((r, s) => Ln(s, AA(r))), [t.suggestions]);
  return {
    getState: () => t,
    suggestion: ({ index: r }) => n.get({ index: r })
  };
}), xA = yA, CA = Object.freeze({
  type: "complete"
}), SA = Fe(({ parts: e, getMessagePart: t }) => {
  const [n, r] = Tn(!0), s = Me(() => e[e.length - 1]?.status ?? CA, [e]), i = Me(() => ({ parts: e, collapsed: n, status: s }), [e, n, s]);
  return {
    getState: () => i,
    setCollapsed: r,
    part: t
  };
}), wA = (e) => Array.from(e).map((n) => n.getModelContext()).sort((n, r) => (r.priority ?? 0) - (n.priority ?? 0)).reduce((n, r) => {
  if (r.system && (n.system ? n.system += `

${r.system}` : n.system = r.system), r.tools)
    for (const [s, i] of Object.entries(r.tools)) {
      const a = n.tools?.[s];
      if (a && a !== i)
        throw new Error(`You tried to define a tool with the name ${s}, but it already exists.`);
      n.tools || (n.tools = {}), n.tools[s] = i;
    }
  return r.config && (n.config = {
    ...n.config,
    ...r.config
  }), r.callSettings && (n.callSettings = {
    ...n.callSettings,
    ...r.callSettings
  }), n;
}, {});
class Xc {
  constructor() {
    k(this, "_providers", /* @__PURE__ */ new Set());
    k(this, "_subscribers", /* @__PURE__ */ new Set());
  }
  getModelContext() {
    return wA(this._providers);
  }
  registerModelContextProvider(t) {
    this._providers.add(t);
    const n = t.subscribe?.(() => {
      this.notifySubscribers();
    });
    return this.notifySubscribers(), () => {
      this._providers.delete(t), n?.(), this.notifySubscribers();
    };
  }
  notifySubscribers() {
    for (const t of this._subscribers)
      t();
  }
  subscribe(t) {
    return this._subscribers.add(t), () => this._subscribers.delete(t);
  }
}
const IA = 1, Nm = Fe(() => {
  const [e] = Tn(() => ({ version: IA + 1 })), t = Me(() => new Xc(), []);
  return {
    getState: () => e,
    getModelContext: () => t.getModelContext(),
    subscribe: (n) => t.subscribe(n),
    register: (n) => t.registerModelContextProvider(n)
  };
}), km = Fe(({ toolkit: e }) => {
  const [t, n] = Tn(() => ({
    tools: {}
  })), r = Im(), s = io((i, a) => (n((o) => ({
    ...o,
    tools: {
      ...o.tools,
      [i]: [...o.tools[i] ?? [], a]
    }
  })), () => {
    n((o) => ({
      ...o,
      tools: {
        ...o.tools,
        [i]: o.tools[i]?.filter((u) => u !== a) ?? []
      }
    }));
  }), []);
  return ft(() => {
    if (!e)
      return;
    const i = [];
    for (const [u, c] of Object.entries(e))
      c.render && i.push(s(u, c.render));
    const a = Object.entries(e).reduce((u, [c, l]) => {
      const { render: h, ...m } = l;
      return u[c] = m, u;
    }, {}), o = {
      getModelContext: () => ({
        tools: a
      })
    };
    return i.push(r.current.modelContext().register(o)), () => {
      i.forEach((u) => u());
    };
  }, [e, s, r]), {
    getState: () => t,
    setToolUI: s
  };
});
xm(km, (e, t) => {
  !e.modelContext && t.modelContext.source === null && (e.modelContext = Nm());
});
const vA = Fe(() => {
  const [e, t] = Tn(() => ({
    renderers: {}
  })), n = io((r, s) => (t((i) => ({
    ...i,
    renderers: {
      ...i.renderers,
      [r]: [...i.renderers[r] ?? [], s]
    }
  })), () => {
    t((i) => ({
      ...i,
      renderers: {
        ...i.renderers,
        [r]: i.renderers[r]?.filter((a) => a !== s) ?? []
      }
    }));
  }), []);
  return {
    getState: () => e,
    setDataUI: n
  };
}), sc = {
  toResponse(e, t) {
    return new Response(sc.toByteStream(e, t), {
      headers: t.headers ?? {}
    });
  },
  fromResponse(e, t) {
    return sc.fromByteStream(e.body, t);
  },
  toByteStream(e, t) {
    return e.pipeThrough(t);
  },
  fromByteStream(e, t) {
    return e.pipeThrough(t);
  }
}, Rm = function() {
  let e, t;
  const n = new Promise((r, s) => {
    e = r, t = s;
  });
  if (!e || !t)
    throw new Error("Failed to create promise");
  return { promise: n, resolve: e, reject: t };
}, NA = () => {
  const e = [];
  let t = !1, n, r;
  const s = (a) => {
    a.promise || (a.promise = a.reader.read().then(({ done: o, value: u }) => {
      a.promise = void 0, o ? (e.splice(e.indexOf(a), 1), t && e.length === 0 && n.close()) : n.enqueue(u), r?.resolve(), r = void 0;
    }).catch((o) => {
      console.error(o), e.forEach((u) => {
        u.reader.cancel();
      }), e.length = 0, n.error(o), r?.reject(o), r = void 0;
    }));
  };
  return {
    readable: new ReadableStream({
      start(a) {
        n = a;
      },
      pull() {
        return r = Rm(), e.forEach((a) => {
          s(a);
        }), r.promise;
      },
      cancel() {
        e.forEach((a) => {
          a.reader.cancel();
        }), e.length = 0;
      }
    }),
    isSealed() {
      return t;
    },
    seal() {
      t = !0, e.length === 0 && n.close();
    },
    addStream(a) {
      if (t)
        throw new Error("Cannot add streams after the run callback has settled.");
      const o = { reader: a.getReader() };
      e.push(o), s(o);
    },
    enqueue(a) {
      this.addStream(new ReadableStream({
        start(o) {
          o.enqueue(a), o.close();
        }
      }));
    }
  };
};
class Gd {
  constructor(t) {
    k(this, "_controller");
    k(this, "_isClosed", !1);
    this._controller = t;
  }
  append(t) {
    return this._controller.enqueue({
      type: "text-delta",
      path: [],
      textDelta: t
    }), this;
  }
  close() {
    this._isClosed || (this._isClosed = !0, this._controller.enqueue({
      type: "part-finish",
      path: []
    }), this._controller.close());
  }
}
const Pm = (e) => new ReadableStream({
  start(t) {
    return e.start?.(new Gd(t));
  },
  pull(t) {
    return e.pull?.(new Gd(t));
  },
  cancel(t) {
    return e.cancel?.(t);
  }
}), Wd = () => {
  let e;
  return [Pm({
    start(n) {
      e = n;
    }
  }), e];
};
class qd {
  constructor(t) {
    k(this, "_controller");
    k(this, "_isClosed", !1);
    k(this, "_mergeTask");
    k(this, "_argsTextController");
    this._controller = t;
    const n = Pm({
      start: (s) => {
        this._argsTextController = s;
      }
    });
    let r = !1;
    this._mergeTask = n.pipeTo(new WritableStream({
      write: (s) => {
        switch (s.type) {
          case "text-delta":
            r = !0, this._controller.enqueue(s);
            break;
          case "part-finish":
            r || this._controller.enqueue({
              type: "text-delta",
              textDelta: "{}",
              path: []
            }), this._controller.enqueue({
              type: "tool-call-args-text-finish",
              path: []
            });
            break;
          default:
            throw new Error(`Unexpected chunk type: ${s.type}`);
        }
      }
    }));
  }
  get argsText() {
    return this._argsTextController;
  }
  async setResponse(t) {
    this._argsTextController.close(), await Promise.resolve(), this._controller.enqueue({
      type: "result",
      path: [],
      ...t.artifact !== void 0 ? { artifact: t.artifact } : {},
      result: t.result,
      isError: t.isError ?? !1,
      ...t.messages !== void 0 ? { messages: t.messages } : {}
    });
  }
  async close() {
    this._isClosed || (this._isClosed = !0, this._argsTextController.close(), await this._mergeTask, this._controller.enqueue({
      type: "part-finish",
      path: []
    }), this._controller.close());
  }
}
const kA = (e) => new ReadableStream({
  start(t) {
    return e.start?.(new qd(t));
  },
  pull(t) {
    return e.pull?.(new qd(t));
  },
  cancel(t) {
    return e.cancel?.(t);
  }
}), RA = () => {
  let e;
  return [kA({
    start(n) {
      e = n;
    }
  }), e];
};
class Om {
  constructor() {
    k(this, "value", -1);
  }
  up() {
    return ++this.value;
  }
}
class PA extends TransformStream {
  constructor(t) {
    super({
      transform(n, r) {
        r.enqueue({
          ...n,
          path: [t, ...n.path]
        });
      }
    });
  }
}
class G9 extends TransformStream {
  constructor(t) {
    super({
      transform(n, r) {
        const { path: [s, ...i] } = n;
        if (t !== s)
          throw new Error(`Path mismatch: expected ${t}, got ${s}`);
        r.enqueue({
          ...n,
          path: i
        });
      }
    });
  }
}
class OA extends TransformStream {
  constructor(t) {
    const n = new Om(), r = /* @__PURE__ */ new Map();
    super({
      transform(s, i) {
        s.type === "part-start" && s.path.length === 0 && r.set(n.up(), t.up());
        const [a, ...o] = s.path;
        if (a === void 0) {
          i.enqueue(s);
          return;
        }
        const u = r.get(a);
        if (u === void 0)
          throw new Error("Path not found");
        i.enqueue({
          ...s,
          path: [u, ...o]
        });
      }
    });
  }
}
class DA extends TransformStream {
  constructor(t, n, r) {
    const [s, i] = HA();
    let a;
    super({
      start(o) {
        return a = s.pipeTo(new WritableStream({
          write(u) {
            o.enqueue(u);
          },
          abort(u) {
            o.error(u);
          },
          close() {
            o.terminate();
          }
        })).catch((u) => {
          o.error(u);
        }), t.start?.(i);
      },
      transform(o) {
        return t.transform?.(o, i);
      },
      async flush() {
        await t.flush?.(i), i.close(), await a;
      }
    }, n, r);
  }
}
class LA extends TransformStream {
  constructor(t) {
    super();
    const n = t(super.readable);
    Object.defineProperty(this, "readable", {
      value: n,
      writable: !1
    });
  }
}
let Dm = (e, t = 21) => (n = t) => {
  let r = "", s = n | 0;
  for (; s-- > 0; )
    r += e[Math.random() * e.length | 0];
  return r;
};
const Lm = Dm("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7);
class Jc {
  constructor(t) {
    k(this, "_state");
    k(this, "_parentId");
    this._state = t || {
      merger: NA(),
      contentCounter: new Om()
    };
  }
  get __internal_isClosed() {
    return this._state.merger.isSealed();
  }
  __internal_getReadable() {
    return this._state.merger.readable;
  }
  __internal_subscribeToClose(t) {
    this._state.closeSubscriber = t;
  }
  _addPart(t, n) {
    this._state.append && (this._state.append.controller.close(), this._state.append = void 0), this.enqueue({
      type: "part-start",
      part: t,
      path: []
    }), this._state.merger.addStream(n.pipeThrough(new PA(this._state.contentCounter.value)));
  }
  merge(t) {
    this._state.merger.addStream(t.pipeThrough(new OA(this._state.contentCounter)));
  }
  appendText(t) {
    this._state.append?.kind !== "text" && (this._state.append = {
      kind: "text",
      controller: this.addTextPart()
    }), this._state.append.controller.append(t);
  }
  appendReasoning(t) {
    this._state.append?.kind !== "reasoning" && (this._state.append = {
      kind: "reasoning",
      controller: this.addReasoningPart()
    }), this._state.append.controller.append(t);
  }
  addTextPart() {
    const [t, n] = Wd();
    return this._addPart({ type: "text" }, t), n;
  }
  addReasoningPart() {
    const [t, n] = Wd();
    return this._addPart({ type: "reasoning" }, t), n;
  }
  addToolCallPart(t) {
    const n = typeof t == "string" ? { toolName: t } : t, r = n.toolName, s = n.toolCallId ?? Lm(), [i, a] = RA();
    return this._addPart({
      type: "tool-call",
      toolName: r,
      toolCallId: s,
      ...this._parentId && { parentId: this._parentId }
    }, i), n.argsText !== void 0 && (a.argsText.append(n.argsText), a.argsText.close()), n.args !== void 0 && (a.argsText.append(JSON.stringify(n.args)), a.argsText.close()), n.response !== void 0 && a.setResponse(n.response), a;
  }
  appendSource(t) {
    this._addPart({ ...t, ...this._parentId && { parentId: this._parentId } }, new ReadableStream({
      start(n) {
        n.enqueue({
          type: "part-finish",
          path: []
        }), n.close();
      }
    }));
  }
  appendFile(t) {
    this._addPart(t, new ReadableStream({
      start(n) {
        n.enqueue({
          type: "part-finish",
          path: []
        }), n.close();
      }
    }));
  }
  enqueue(t) {
    this._state.merger.enqueue(t), t.type === "part-start" && t.path.length === 0 && this._state.contentCounter.up();
  }
  withParentId(t) {
    const n = new Jc(this._state);
    return n._parentId = t, n;
  }
  close() {
    this._state.append?.controller?.close(), this._state.merger.seal(), this._state.closeSubscriber?.();
  }
}
function MA(e) {
  const t = new Jc();
  return (async () => {
    try {
      await e(t);
    } catch (r) {
      throw t.__internal_isClosed || t.enqueue({
        type: "error",
        path: [],
        error: String(r)
      }), r;
    } finally {
      t.__internal_isClosed || t.close();
    }
  })(), t.__internal_getReadable();
}
function HA() {
  const { resolve: e, promise: t } = Rm();
  let n;
  return [MA((s) => (n = s, n.__internal_subscribeToClose(e), t)), n];
}
var Er = { exports: {} }, Kd;
function BA() {
  if (Kd) return Er.exports;
  Kd = 1;
  const e = typeof Buffer < "u", t = /"(?:_|\\u005[Ff])(?:_|\\u005[Ff])(?:p|\\u0070)(?:r|\\u0072)(?:o|\\u006[Ff])(?:t|\\u0074)(?:o|\\u006[Ff])(?:_|\\u005[Ff])(?:_|\\u005[Ff])"\s*:/, n = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
  function r(o, u, c) {
    c == null && u !== null && typeof u == "object" && (c = u, u = void 0), e && Buffer.isBuffer(o) && (o = o.toString()), o && o.charCodeAt(0) === 65279 && (o = o.slice(1));
    const l = JSON.parse(o, u);
    if (l === null || typeof l != "object")
      return l;
    const h = c && c.protoAction || "error", m = c && c.constructorAction || "error";
    if (h === "ignore" && m === "ignore")
      return l;
    if (h !== "ignore" && m !== "ignore") {
      if (t.test(o) === !1 && n.test(o) === !1)
        return l;
    } else if (h !== "ignore" && m === "ignore") {
      if (t.test(o) === !1)
        return l;
    } else if (n.test(o) === !1)
      return l;
    return s(l, { protoAction: h, constructorAction: m, safe: c && c.safe });
  }
  function s(o, { protoAction: u = "error", constructorAction: c = "error", safe: l } = {}) {
    let h = [o];
    for (; h.length; ) {
      const m = h;
      h = [];
      for (const p of m) {
        if (u !== "ignore" && Object.prototype.hasOwnProperty.call(p, "__proto__")) {
          if (l === !0)
            return null;
          if (u === "error")
            throw new SyntaxError("Object contains forbidden prototype property");
          delete p.__proto__;
        }
        if (c !== "ignore" && Object.prototype.hasOwnProperty.call(p, "constructor") && p.constructor !== null && typeof p.constructor == "object" && Object.prototype.hasOwnProperty.call(p.constructor, "prototype")) {
          if (l === !0)
            return null;
          if (c === "error")
            throw new SyntaxError("Object contains forbidden prototype property");
          delete p.constructor;
        }
        for (const E in p) {
          const g = p[E];
          g && typeof g == "object" && h.push(g);
        }
      }
    }
    return o;
  }
  function i(o, u, c) {
    const { stackTraceLimit: l } = Error;
    Error.stackTraceLimit = 0;
    try {
      return r(o, u, c);
    } finally {
      Error.stackTraceLimit = l;
    }
  }
  function a(o, u) {
    const { stackTraceLimit: c } = Error;
    Error.stackTraceLimit = 0;
    try {
      return r(o, u, { safe: !0 });
    } catch {
      return;
    } finally {
      Error.stackTraceLimit = c;
    }
  }
  return Er.exports = i, Er.exports.default = i, Er.exports.parse = i, Er.exports.safeParse = a, Er.exports.scan = s, Er.exports;
}
var UA = BA();
const Qd = /* @__PURE__ */ Dr(UA);
function FA(e) {
  const t = ["ROOT"];
  let n = -1, r = null;
  const s = [];
  let i;
  function a() {
    i !== void 0 && (s.push(JSON.parse(`"${i}"`)), i = void 0);
  }
  function o(h, m, p) {
    switch (h) {
      case '"': {
        n = m, t.pop(), t.push(p), t.push("INSIDE_STRING"), a();
        break;
      }
      case "f":
      case "t":
      case "n": {
        n = m, r = m, t.pop(), t.push(p), t.push("INSIDE_LITERAL");
        break;
      }
      case "-": {
        t.pop(), t.push(p), t.push("INSIDE_NUMBER"), a();
        break;
      }
      case "0":
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9": {
        n = m, t.pop(), t.push(p), t.push("INSIDE_NUMBER"), a();
        break;
      }
      case "{": {
        n = m, t.pop(), t.push(p), t.push("INSIDE_OBJECT_START"), a();
        break;
      }
      case "[": {
        n = m, t.pop(), t.push(p), t.push("INSIDE_ARRAY_START"), a();
        break;
      }
    }
  }
  function u(h, m) {
    switch (h) {
      case ",": {
        t.pop(), t.push("INSIDE_OBJECT_AFTER_COMMA");
        break;
      }
      case "}": {
        n = m, t.pop(), i = s.pop();
        break;
      }
    }
  }
  function c(h, m) {
    switch (h) {
      case ",": {
        t.pop(), t.push("INSIDE_ARRAY_AFTER_COMMA"), i = (Number(i) + 1).toString();
        break;
      }
      case "]": {
        n = m, t.pop(), i = s.pop();
        break;
      }
    }
  }
  for (let h = 0; h < e.length; h++) {
    const m = e[h];
    switch (t[t.length - 1]) {
      case "ROOT":
        o(m, h, "FINISH");
        break;
      case "INSIDE_OBJECT_START": {
        switch (m) {
          case '"': {
            t.pop(), t.push("INSIDE_OBJECT_KEY"), i = "";
            break;
          }
          case "}": {
            n = h, t.pop(), i = s.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_COMMA": {
        m === '"' && (t.pop(), t.push("INSIDE_OBJECT_KEY"), i = "");
        break;
      }
      case "INSIDE_OBJECT_KEY": {
        switch (m) {
          case '"': {
            t.pop(), t.push("INSIDE_OBJECT_AFTER_KEY");
            break;
          }
          case "\\": {
            t.push("INSIDE_STRING_ESCAPE"), i += m;
            break;
          }
          default: {
            i += m;
            break;
          }
        }
        break;
      }
      case "INSIDE_OBJECT_AFTER_KEY": {
        m === ":" && (t.pop(), t.push("INSIDE_OBJECT_BEFORE_VALUE"));
        break;
      }
      case "INSIDE_OBJECT_BEFORE_VALUE": {
        o(m, h, "INSIDE_OBJECT_AFTER_VALUE");
        break;
      }
      case "INSIDE_OBJECT_AFTER_VALUE": {
        u(m, h);
        break;
      }
      case "INSIDE_STRING": {
        switch (m) {
          case '"': {
            t.pop(), n = h, i = s.pop();
            break;
          }
          case "\\": {
            t.push("INSIDE_STRING_ESCAPE");
            break;
          }
          default:
            n = h;
        }
        break;
      }
      case "INSIDE_ARRAY_START": {
        m === "]" ? (n = h, t.pop(), i = s.pop()) : (n = h, i = "0", o(m, h, "INSIDE_ARRAY_AFTER_VALUE"));
        break;
      }
      case "INSIDE_ARRAY_AFTER_VALUE": {
        switch (m) {
          case ",": {
            t.pop(), t.push("INSIDE_ARRAY_AFTER_COMMA"), i = (Number(i) + 1).toString();
            break;
          }
          case "]": {
            n = h, t.pop(), i = s.pop();
            break;
          }
          default: {
            n = h;
            break;
          }
        }
        break;
      }
      case "INSIDE_ARRAY_AFTER_COMMA": {
        o(m, h, "INSIDE_ARRAY_AFTER_VALUE");
        break;
      }
      case "INSIDE_STRING_ESCAPE": {
        t.pop(), t[t.length - 1] === "INSIDE_STRING" ? n = h : t[t.length - 1] === "INSIDE_OBJECT_KEY" && (i += m);
        break;
      }
      case "INSIDE_NUMBER": {
        switch (m) {
          case "0":
          case "1":
          case "2":
          case "3":
          case "4":
          case "5":
          case "6":
          case "7":
          case "8":
          case "9": {
            n = h;
            break;
          }
          case "e":
          case "E":
          case "-":
          case ".":
            break;
          case ",": {
            t.pop(), i = s.pop(), t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(m, h), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" && u(m, h);
            break;
          }
          case "}": {
            t.pop(), i = s.pop(), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" && u(m, h);
            break;
          }
          case "]": {
            t.pop(), i = s.pop(), t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(m, h);
            break;
          }
          default: {
            t.pop(), i = s.pop();
            break;
          }
        }
        break;
      }
      case "INSIDE_LITERAL": {
        const E = e.substring(r, h + 1);
        !"false".startsWith(E) && !"true".startsWith(E) && !"null".startsWith(E) ? (t.pop(), t[t.length - 1] === "INSIDE_OBJECT_AFTER_VALUE" ? u(m, h) : t[t.length - 1] === "INSIDE_ARRAY_AFTER_VALUE" && c(m, h)) : n = h;
        break;
      }
    }
  }
  let l = e.slice(0, n + 1);
  for (let h = t.length - 1; h >= 0; h--)
    switch (t[h]) {
      case "INSIDE_STRING": {
        l += '"';
        break;
      }
      case "INSIDE_OBJECT_KEY":
      case "INSIDE_OBJECT_AFTER_KEY":
      case "INSIDE_OBJECT_AFTER_COMMA":
      case "INSIDE_OBJECT_START":
      case "INSIDE_OBJECT_BEFORE_VALUE":
      case "INSIDE_OBJECT_AFTER_VALUE": {
        l += "}";
        break;
      }
      case "INSIDE_ARRAY_START":
      case "INSIDE_ARRAY_AFTER_COMMA":
      case "INSIDE_ARRAY_AFTER_VALUE": {
        l += "]";
        break;
      }
      case "INSIDE_LITERAL": {
        const p = e.substring(r, e.length);
        "true".startsWith(p) ? l += "true".slice(p.length) : "false".startsWith(p) ? l += "false".slice(p.length) : "null".startsWith(p) && (l += "null".slice(p.length));
      }
    }
  return [l, s];
}
const ru = /* @__PURE__ */ Symbol("aui.parse-partial-json-object.meta"), co = (e) => {
  if (e.length === 0)
    return {
      [ru]: { state: "partial", partialPath: [] }
    };
  try {
    const t = Qd.parse(e);
    if (typeof t != "object" || t === null)
      throw new Error("argsText is expected to be an object");
    return t[ru] = {
      state: "complete",
      partialPath: []
    }, t;
  } catch {
    try {
      const [t, n] = FA(e), r = Qd.parse(t);
      if (typeof r != "object" || r === null)
        throw new Error("argsText is expected to be an object");
      return r[ru] = {
        state: "partial",
        partialPath: n
      }, r;
    } catch {
      return;
    }
  }
};
class Zs {
  constructor(t = null) {
    k(this, "_state");
    this._state = t;
  }
  get state() {
    return this._state;
  }
  append(t) {
    this._state = t.reduce((n, r) => Zs.apply(n, r), this._state);
  }
  static apply(t, n) {
    const r = n.type;
    switch (r) {
      case "set":
        return Zs.updatePath(t, n.path, () => n.value);
      case "append-text":
        return Zs.updatePath(t, n.path, (s) => {
          if (typeof s != "string")
            throw new Error(`Expected string at path [${n.path.join(", ")}]`);
          return s + n.value;
        });
      default: {
        const s = r;
        throw new Error(`Invalid operation type: ${s}`);
      }
    }
  }
  static updatePath(t, n, r) {
    if (n.length === 0)
      return r(t);
    if (t ?? (t = {}), typeof t != "object")
      throw new Error(`Invalid path: [${n.join(", ")}]`);
    const [s, ...i] = n;
    if (Array.isArray(t)) {
      const o = Number(s);
      if (Number.isNaN(o))
        throw new Error(`Expected array index at [${n.join(", ")}]`);
      if (o > t.length || o < 0)
        throw new Error("Insert array index out of bounds");
      const u = [...t];
      return u[o] = this.updatePath(u[o], i, r), u;
    }
    const a = { ...t };
    return a[s] = this.updatePath(a[s], i, r), a;
  }
}
class jA {
  constructor() {
    k(this, "_streamStartTime");
    k(this, "_firstTokenTime");
    k(this, "_totalChunks", 0);
    k(this, "_toolCallIds", /* @__PURE__ */ new Set());
    this._streamStartTime = Date.now();
  }
  recordChunk() {
    this._totalChunks++;
  }
  recordFirstToken() {
    this._firstTokenTime === void 0 && (this._firstTokenTime = Date.now());
  }
  recordToolCallStart(t) {
    this._toolCallIds.add(t);
  }
  getTiming(t, n) {
    const s = Date.now() - this._streamStartTime, i = t && t > 0 ? t : n ? Math.ceil(n.length / 4) : void 0, a = i && s > 0 ? i / s * 1e3 : void 0;
    return {
      streamStartTime: this._streamStartTime,
      ...this._firstTokenTime !== void 0 ? { firstTokenTime: this._firstTokenTime - this._streamStartTime } : void 0,
      totalStreamTime: s,
      ...i !== void 0 ? { tokenCount: i } : void 0,
      ...a !== void 0 ? { tokensPerSecond: a } : void 0,
      totalChunks: this._totalChunks,
      toolCallCount: this._toolCallIds.size
    };
  }
}
const $A = ({ unstable_state: e = null } = {}) => ({
  role: "assistant",
  status: { type: "running" },
  parts: [],
  get content() {
    return this.parts;
  },
  metadata: {
    unstable_state: e,
    unstable_data: [],
    unstable_annotations: [],
    steps: [],
    custom: {}
  }
}), lo = (e, t, n) => {
  if (e.parts.length === 0)
    throw new Error("No parts available to update.");
  if (t.path.length !== 1)
    throw new Error("Nested paths are not supported yet.");
  const r = t.path[0], s = n(e.parts[r]);
  return {
    ...e,
    parts: [
      ...e.parts.slice(0, r),
      s,
      ...e.parts.slice(r + 1)
    ],
    get content() {
      return this.parts;
    }
  };
}, zA = (e, t) => {
  const n = t.part;
  if (n.type === "text" || n.type === "reasoning") {
    const r = {
      type: n.type,
      text: "",
      status: { type: "running" },
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "tool-call") {
    const r = {
      type: "tool-call",
      state: "partial-call",
      status: { type: "running", isArgsComplete: !1 },
      toolCallId: n.toolCallId,
      toolName: n.toolName,
      argsText: "",
      args: {},
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "source") {
    const r = {
      type: "source",
      sourceType: n.sourceType,
      id: n.id,
      url: n.url,
      ...n.title ? { title: n.title } : void 0,
      ...n.parentId && { parentId: n.parentId }
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else if (n.type === "file") {
    const r = {
      type: "file",
      mimeType: n.mimeType,
      data: n.data
    };
    return {
      ...e,
      parts: [...e.parts, r],
      get content() {
        return this.parts;
      }
    };
  } else
    throw new Error(`Unsupported part type: ${n.type}`);
}, VA = (e, t) => lo(e, t, (n) => {
  if (n.type !== "tool-call")
    throw new Error("Last is not a tool call");
  return n.state !== "partial-call" ? n : {
    ...n,
    state: "call"
  };
}), YA = (e, t) => lo(e, t, (n) => ({
  ...n,
  status: { type: "complete", reason: "unknown" }
})), GA = (e, t) => lo(e, t, (n) => {
  if (n.type === "text" || n.type === "reasoning")
    return { ...n, text: n.text + t.textDelta };
  if (n.type === "tool-call") {
    const r = n.argsText + t.textDelta, s = co(r) ?? n.args;
    return { ...n, argsText: r, args: s };
  } else
    throw new Error("text-delta received but part is neither text nor tool-call");
}), WA = (e, t) => lo(e, t, (n) => {
  if (n.type === "tool-call")
    return {
      ...n,
      state: "result",
      ...t.artifact !== void 0 ? { artifact: t.artifact } : {},
      result: t.result,
      isError: t.isError ?? !1,
      ...t.messages !== void 0 ? { messages: t.messages } : {},
      status: { type: "complete", reason: "stop" }
    };
  throw new Error("Result chunk received but part is not a tool-call");
}), Xd = (e, t) => {
  if (e.status?.type === "incomplete" && e.status?.reason === "error")
    return e;
  const n = qA(t);
  return { ...e, status: n };
}, qA = (e) => e.finishReason === "tool-calls" ? {
  type: "requires-action",
  reason: "tool-calls"
} : e.finishReason === "stop" || e.finishReason === "unknown" ? {
  type: "complete",
  reason: e.finishReason
} : {
  type: "incomplete",
  reason: e.finishReason
}, KA = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    unstable_annotations: [
      ...e.metadata.unstable_annotations,
      ...t.annotations
    ]
  }
}), QA = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    unstable_data: [...e.metadata.unstable_data, ...t.data]
  }
}), XA = (e, t) => ({
  ...e,
  metadata: {
    ...e.metadata,
    steps: [
      ...e.metadata.steps,
      { state: "started", messageId: t.messageId }
    ]
  }
}), JA = (e, t) => {
  const n = e.metadata.steps.slice(), r = n.length - 1;
  return n.length > 0 && n[r]?.state === "started" ? n[r] = {
    ...n[r],
    state: "finished",
    finishReason: t.finishReason,
    usage: t.usage,
    isContinued: t.isContinued
  } : n.push({
    state: "finished",
    messageId: Lm(),
    finishReason: t.finishReason,
    usage: t.usage,
    isContinued: t.isContinued
  }), {
    ...e,
    metadata: {
      ...e.metadata,
      steps: n
    }
  };
}, ZA = (e, t) => ({
  ...e,
  status: { type: "incomplete", reason: "error", error: t.error }
}), ey = (e, t) => {
  const n = new Zs(e.metadata.unstable_state);
  return n.append(t.operations), {
    ...e,
    metadata: {
      ...e.metadata,
      unstable_state: n.state
    }
  };
}, Jd = (e, t) => {
  let n = 0;
  for (const s of t.metadata.steps)
    s.state === "finished" && s.usage && (n += s.usage.outputTokens);
  let r = "";
  for (const s of t.parts)
    (s.type === "text" || s.type === "reasoning") && (r += s.text);
  return e.getTiming(n > 0 ? n : void 0, r || void 0);
}, ty = (e) => {
  let t = !1;
  return () => {
    t || (t = !0, queueMicrotask(() => {
      t = !1, e();
    }));
  };
};
class ny extends TransformStream {
  constructor({ initialMessage: t, throttle: n, onError: r } = {}) {
    let s = t ?? $A();
    const i = new jA();
    let a;
    const o = n ? ty(() => {
      a?.enqueue(s);
    }) : () => {
      a?.enqueue(s);
    };
    super({
      start(u) {
        a = u;
      },
      transform(u) {
        i.recordChunk();
        const c = u.type;
        switch (c) {
          case "part-start":
            s = zA(s, u), u.part.type === "tool-call" && i.recordToolCallStart(u.part.toolCallId);
            break;
          case "tool-call-args-text-finish":
            s = VA(s, u);
            break;
          case "part-finish":
            s = YA(s, u);
            break;
          case "text-delta":
            s = GA(s, u), i.recordFirstToken();
            break;
          case "result":
            s = WA(s, u);
            break;
          case "message-finish":
            s = Xd(s, u);
            break;
          case "annotations":
            s = KA(s, u);
            break;
          case "data":
            s = QA(s, u);
            break;
          case "step-start":
            s = XA(s, u);
            break;
          case "step-finish":
            s = JA(s, u);
            break;
          case "error":
            s = ZA(s, u), r?.(u.error);
            break;
          case "update-state":
            s = ey(s, u);
            break;
          default: {
            const l = c;
            throw new Error(`Unsupported chunk type: ${l}`);
          }
        }
        s.status.type !== "running" && (s = {
          ...s,
          metadata: {
            ...s.metadata,
            timing: Jd(i, s)
          }
        }), o();
      },
      flush(u) {
        if (s.status?.type === "running") {
          const c = s.parts?.some((l) => l.type === "tool-call" && (l.state === "call" || l.state === "partial-call") && l.result === void 0) ?? !1;
          s = Xd(s, {
            finishReason: c ? "tool-calls" : "unknown"
          }), s = {
            ...s,
            metadata: {
              ...s.metadata,
              timing: Jd(i, s)
            }
          }, u.enqueue(s);
        }
      }
    });
  }
}
class ry extends LA {
  constructor() {
    super((t) => {
      const n = new DA({
        transform(r, s) {
          s.appendText(r);
        }
      });
      return t.pipeThrough(new TextDecoderStream()).pipeThrough(n);
    });
  }
}
class ei {
  constructor(t) {
    k(this, "readable");
    this.readable = t, this.readable = t;
  }
  static fromAssistantStream(t) {
    return new ei(t.pipeThrough(new ny()));
  }
  async unstable_result() {
    let t;
    for await (const n of this)
      t = n;
    return t || {
      role: "assistant",
      status: { type: "complete", reason: "unknown" },
      parts: [],
      content: [],
      metadata: {
        unstable_state: null,
        unstable_data: [],
        unstable_annotations: [],
        steps: [],
        custom: {}
      }
    };
  }
  [Symbol.asyncIterator]() {
    const t = this.readable.getReader();
    return {
      async next() {
        const { done: n, value: r } = await t.read();
        return n ? { done: !0, value: void 0 } : { done: !1, value: r };
      }
    };
  }
  tee() {
    const [t, n] = this.readable.tee();
    return [
      new ei(t),
      new ei(n)
    ];
  }
}
const Zd = /* @__PURE__ */ Symbol.for("aui.tool-response");
class Da {
  constructor(t) {
    k(this, "artifact");
    k(this, "result");
    k(this, "isError");
    k(this, "messages");
    t.artifact !== void 0 && (this.artifact = t.artifact), this.result = t.result, this.isError = t.isError ?? !1, t.messages !== void 0 && (this.messages = t.messages);
  }
  get [Zd]() {
    return !0;
  }
  static [Symbol.hasInstance](t) {
    return typeof t == "object" && t !== null && Zd in t;
  }
  static toResponse(t) {
    return t instanceof Da ? t : new Da({
      result: t === void 0 ? "<no result>" : t
    });
  }
}
const Mr = (e) => {
  const [, t] = Tn(e.getState);
  return ft(() => (t(e.getState()), e.subscribe(() => {
    t(e.getState());
  })), [e]), e.getState();
}, Mm = Fe(({ runtime: e }) => {
  const t = Mr(e);
  return {
    getState: () => t,
    remove: e.remove,
    __internal_getRuntime: () => e
  };
}), sy = Fe(({ runtime: e }) => {
  const t = Mr(e);
  return {
    getState: () => t,
    addToolResult: (n) => e.addToolResult(n),
    resumeToolCall: (n) => e.resumeToolCall(n),
    __internal_getRuntime: () => e
  };
}), iy = Fe(({ runtime: e, index: t }) => {
  const n = Me(() => e.getAttachmentByIndex(t), [e, t]);
  return Ft(Mm({
    runtime: n
  }));
}), Hm = Fe(({ threadIdRef: e, messageIdRef: t, runtime: n }) => {
  const r = Mr(n), s = Kc();
  ft(() => {
    const o = [];
    for (const u of ["send", "attachmentAdd"]) {
      const c = n.unstable_on(u, () => {
        s(`composer.${u}`, {
          threadId: e.current,
          ...t && { messageId: t.current }
        });
      });
      o.push(c);
    }
    return o.push(n.unstable_on("attachmentAddError", () => {
      const u = n.getState().attachments.findLast((c) => c.status.type === "incomplete" && c.status.reason === "error");
      s("composer.attachmentAddError", {
        threadId: e.current,
        ...t && { messageId: t.current },
        ...u && { attachmentId: u.id }
      });
    })), () => {
      for (const u of o)
        u();
    };
  }, [n, s, e, t]);
  const i = cs(() => r.attachments.map((o, u) => Ln(o.id, iy({
    runtime: n,
    index: u
  }))), [r.attachments, n]), a = Me(() => ({
    text: r.text,
    role: r.role,
    attachments: i.state,
    runConfig: r.runConfig,
    isEditing: r.isEditing,
    canCancel: r.canCancel,
    attachmentAccept: r.attachmentAccept,
    isEmpty: r.isEmpty,
    type: r.type ?? "thread",
    dictation: r.dictation,
    quote: r.quote,
    queue: []
  }), [r, i.state]);
  return {
    getState: () => a,
    setText: n.setText,
    setRole: n.setRole,
    setRunConfig: n.setRunConfig,
    addAttachment: n.addAttachment,
    reset: n.reset,
    clearAttachments: n.clearAttachments,
    send: n.send,
    cancel: n.cancel,
    beginEdit: n.beginEdit ?? (() => {
      throw new Error("beginEdit is not supported in this runtime");
    }),
    startDictation: n.startDictation,
    stopDictation: n.stopDictation,
    setQuote: n.setQuote,
    attachment: (o) => "id" in o ? i.get({ key: o.id }) : i.get(o),
    queueItem: () => {
      throw new Error("Queue is not supported in this runtime");
    },
    __internal_getRuntime: () => n
  };
}), ay = Fe(({ runtime: e, index: t }) => {
  const n = Me(() => e.getAttachmentByIndex(t), [e, t]);
  return Ft(Mm({ runtime: n }));
}), oy = Fe(({ runtime: e, index: t }) => {
  const n = Me(() => e.getMessagePartByIndex(t), [e, t]);
  return Ft(sy({ runtime: n }));
}), uy = Fe(({ runtime: e, threadIdRef: t }) => {
  const n = Mr(e), [r, s] = Tn(!1), [i, a] = Tn(!1), o = Me(() => ({
    get current() {
      return e.getState().id;
    }
  }), [e]), u = oo(Hm({
    runtime: e.composer,
    threadIdRef: t,
    messageIdRef: o
  })), c = cs(() => n.content.map((m, p) => Ln("toolCallId" in m && m.toolCallId != null ? `toolCallId-${m.toolCallId}` : `index-${p}`, oy({ runtime: e, index: p }))), [n.content, e]), l = cs(() => (n.attachments ?? []).map((m, p) => Ln(m.id, ay({ runtime: e, index: p }))), [n.attachments, e]), h = Me(() => ({
    ...n,
    parts: c.state,
    composer: u.state,
    isCopied: r,
    isHovering: i
  }), [
    n,
    c.state,
    u.state,
    r,
    i
  ]);
  return {
    getState: () => h,
    composer: () => u.methods,
    reload: (m) => e.reload(m),
    speak: () => e.speak(),
    stopSpeaking: () => e.stopSpeaking(),
    submitFeedback: (m) => e.submitFeedback(m),
    switchToBranch: (m) => e.switchToBranch(m),
    getCopyText: () => e.unstable_getCopyText(),
    part: (m) => "index" in m ? c.get({ index: m.index }) : c.get({ key: `toolCallId-${m.toolCallId}` }),
    attachment: (m) => "id" in m ? l.get({ key: m.id }) : l.get(m),
    setIsCopied: s,
    setIsHovering: a,
    __internal_getRuntime: () => e
  };
}), cy = Fe(({ runtime: e, id: t, threadIdRef: n }) => {
  const r = Me(() => e.getMessageById(t), [e, t]);
  return Ft(uy({ runtime: r, threadIdRef: n }));
}), ly = Fe(({ runtime: e }) => {
  const t = Mr(e), n = Kc();
  ft(() => {
    const o = [], u = [
      "runStart",
      "runEnd",
      "initialize",
      "modelContextUpdate"
    ];
    for (const c of u) {
      const l = e.unstable_on(c, () => {
        const h = e.getState()?.threadId || "unknown";
        n(`thread.${c}`, {
          threadId: h
        });
      });
      o.push(l);
    }
    return () => {
      for (const c of o)
        c();
    };
  }, [e, n]);
  const r = Me(() => ({
    get current() {
      return e.getState().threadId;
    }
  }), [e]), s = oo(Hm({
    runtime: e.composer,
    threadIdRef: r
  })), i = cs(() => t.messages.map((o) => Ln(o.id, cy({ runtime: e, id: o.id, threadIdRef: r }))), [t.messages, e, r]), a = Me(() => ({
    isEmpty: i.state.length === 0 && !t.isLoading,
    isDisabled: t.isDisabled,
    isLoading: t.isLoading,
    isRunning: t.isRunning,
    capabilities: t.capabilities,
    state: t.state,
    suggestions: t.suggestions,
    extras: t.extras,
    speech: t.speech,
    composer: s.state,
    messages: i.state
  }), [t, i, s.state]);
  return {
    getState: () => a,
    composer: () => s.methods,
    append: e.append,
    startRun: e.startRun,
    resumeRun: e.resumeRun,
    unstable_resumeRun: e.resumeRun,
    cancelRun: e.cancelRun,
    getModelContext: e.getModelContext,
    export: e.export,
    import: e.import,
    reset: e.reset,
    stopSpeaking: e.stopSpeaking,
    startVoice: async () => {
      throw new Error("startVoice is not supported in this runtime");
    },
    stopVoice: async () => {
      throw new Error("stopVoice is not supported in this runtime");
    },
    message: (o) => "id" in o ? i.get({ key: o.id }) : i.get(o),
    __internal_getRuntime: () => e
  };
}), Bm = Fe(({ runtime: e }) => {
  const t = Mr(e), n = Kc();
  return ft(() => {
    const r = [], s = [
      "switchedTo",
      "switchedAway"
    ];
    for (const i of s) {
      const a = e.unstable_on(i, () => {
        n(`threadListItem.${i}`, {
          threadId: e.getState().id
        });
      });
      r.push(a);
    }
    return () => {
      for (const i of r)
        i();
    };
  }, [e, n]), {
    getState: () => t,
    switchTo: e.switchTo,
    rename: e.rename,
    archive: e.archive,
    unarchive: e.unarchive,
    delete: e.delete,
    generateTitle: e.generateTitle,
    initialize: e.initialize,
    detach: e.detach,
    __internal_getRuntime: () => e
  };
}), dy = Fe(({ runtime: e, id: t }) => {
  const n = Me(() => e.getItemById(t), [e, t]);
  return Ft(Bm({
    runtime: n
  }));
}), hy = Fe(({ runtime: e, __internal_assistantRuntime: t }) => {
  const n = Mr(e), r = oo(ly({
    runtime: e.main
  })), s = cs(() => Object.keys(n.threadItems).map((a) => Ln(a, dy({ runtime: e, id: a }))), [n.threadItems, e]), i = Me(() => ({
    mainThreadId: n.mainThreadId,
    newThreadId: n.newThreadId ?? null,
    isLoading: n.isLoading,
    threadIds: n.threadIds,
    archivedThreadIds: n.archivedThreadIds,
    threadItems: s.state,
    main: r.state
  }), [n, s.state, r.state]);
  return {
    getState: () => i,
    thread: () => r.methods,
    item: (a) => {
      if (a === "main")
        return s.get({ key: i.mainThreadId });
      if ("id" in a)
        return s.get({ key: a.id });
      const { index: o, archived: u = !1 } = a, c = u ? i.archivedThreadIds[o] : i.threadIds[o];
      return s.get({ key: c });
    },
    switchToThread: async (a) => {
      await e.switchToThread(a);
    },
    switchToNewThread: async () => {
      await e.switchToNewThread();
    },
    __internal_getAssistantRuntime: () => t
  };
}), fy = Fe((e) => {
  const t = Im();
  return ft(() => e.registerModelContextProvider(t.current.modelContext()), [e, t]), Ft(hy({
    runtime: e.threads,
    __internal_assistantRuntime: e
  }));
}), py = (e, t) => {
  e.thread ?? (e.thread = On({
    source: "threads",
    query: { type: "main" },
    get: (n) => n.threads().thread("main")
  })), e.threadListItem ?? (e.threadListItem = On({
    source: "threads",
    query: { type: "main" },
    get: (n) => n.threads().item("main")
  })), e.composer ?? (e.composer = On({
    source: "thread",
    query: {},
    get: (n) => n.threads().thread("main").composer()
  })), !e.modelContext && t.modelContext.source === null && (e.modelContext = Nm()), !e.suggestions && t.suggestions.source === null && (e.suggestions = xA());
}, my = ({ runtime: e, children: t }) => {
  const n = Re({
    threadListItem: Bm({ runtime: e })
  });
  return d.jsx(Lr, { value: n, children: t });
}, Um = ({ index: e, children: t }) => {
  const n = Re({
    message: On({
      source: "thread",
      query: { type: "index", index: e },
      get: (r) => r.thread().message({ index: e })
    }),
    composer: On({
      source: "message",
      query: {},
      get: (r) => r.thread().message({ index: e }).composer()
    })
  });
  return d.jsx(Lr, { value: n, children: t });
}, Fm = ({ index: e, children: t }) => {
  const n = Re({
    part: On({
      source: "message",
      query: { type: "index", index: e },
      get: (r) => r.message().part({ index: e })
    })
  });
  return d.jsx(Lr, { value: n, children: t });
}, gy = Fe(({ text: e, isRunning: t }) => {
  const n = Me(() => ({
    type: "text",
    text: e,
    status: t ? { type: "running" } : { type: "complete" }
  }), [e, t]);
  return {
    getState: () => n,
    addToolResult: () => {
      throw new Error("Not supported");
    },
    resumeToolCall: () => {
      throw new Error("Not supported");
    }
  };
}), Ey = ({ text: e, isRunning: t = !1, children: n }) => {
  const r = Re({
    part: gy({ text: e, isRunning: t })
  });
  return d.jsx(Lr, { value: r, children: n });
}, by = ({ startIndex: e, endIndex: t, children: n }) => {
  const r = J((a) => a.message.parts).slice(e, t + 1), s = Re(), i = Re({
    chainOfThought: SA({
      parts: r,
      getMessagePart: ({ index: a }) => {
        if (a < 0 || a >= r.length)
          throw new Error(`ChainOfThought part index ${a} is out of bounds (0..${r.length - 1})`);
        return s.message().part({ index: e + a });
      }
    })
  });
  return d.jsx(Lr, { value: i, children: n });
}, jm = ({ index: e, archived: t, children: n }) => {
  const r = Re({
    threadListItem: On({
      source: "threads",
      query: { type: "index", index: e, archived: t },
      get: (s) => s.threads().item({ index: e, archived: t })
    })
  });
  return d.jsx(Lr, { value: r, children: n });
}, on = /* @__PURE__ */ Symbol("skip-update");
function _y(e, t) {
  if (e === void 0 && t === void 0)
    return !0;
  if (e === void 0 || t === void 0)
    return !1;
  for (const n of Object.keys(e)) {
    const r = e[n], s = t[n];
    if (!Object.is(r, s))
      return !1;
  }
  return !0;
}
class Si {
  constructor() {
    k(this, "_subscribers", /* @__PURE__ */ new Set());
  }
  subscribe(t) {
    return this._subscribers.add(t), () => this._subscribers.delete(t);
  }
  waitForUpdate() {
    return new Promise((t) => {
      const n = this.subscribe(() => {
        n(), t();
      });
    });
  }
  _notifySubscribers() {
    const t = [];
    for (const n of this._subscribers)
      try {
        n();
      } catch (r) {
        t.push(r);
      }
    if (t.length > 0) {
      if (t.length === 1)
        throw t[0];
      for (const n of t)
        console.error(n);
      throw new AggregateError(t);
    }
  }
}
class ho {
  constructor() {
    k(this, "_subscriptions", /* @__PURE__ */ new Set());
    k(this, "_connection");
  }
  get isConnected() {
    return !!this._connection;
  }
  notifySubscribers() {
    for (const t of this._subscriptions)
      t();
  }
  _updateConnection() {
    if (this._subscriptions.size > 0) {
      if (this._connection)
        return;
      this._connection = this._connect();
    } else
      this._connection?.(), this._connection = void 0;
  }
  subscribe(t) {
    return this._subscriptions.add(t), this._updateConnection(), () => {
      this._subscriptions.delete(t), this._updateConnection();
    };
  }
}
class sn extends ho {
  constructor(n) {
    super();
    k(this, "binding");
    k(this, "_previousState");
    k(this, "getState", () => (this.isConnected || this._syncState(), this._previousState));
    this.binding = n;
    const r = n.getState();
    if (r === on)
      throw new Error("Entry not available in the store");
    this._previousState = r;
  }
  get path() {
    return this.binding.path;
  }
  _syncState() {
    const n = this.binding.getState();
    return n === on || _y(n, this._previousState) ? !1 : (this._previousState = n, !0);
  }
  _connect() {
    const n = () => {
      this._syncState() && this.notifySubscribers();
    };
    return this.binding.subscribe(n);
  }
}
class Zc extends ho {
  constructor(n) {
    super();
    k(this, "binding");
    k(this, "_previousStateDirty", !0);
    k(this, "_previousState");
    k(this, "getState", () => {
      if (!this.isConnected || this._previousStateDirty) {
        const n = this.binding.getState();
        n !== on && (this._previousState = n), this._previousStateDirty = !1;
      }
      if (this._previousState === void 0)
        throw new Error("Entry not available in the store");
      return this._previousState;
    });
    this.binding = n;
  }
  get path() {
    return this.binding.path;
  }
  _connect() {
    const n = () => {
      this._previousStateDirty = !0, this.notifySubscribers();
    };
    return this.binding.subscribe(n);
  }
}
class La extends ho {
  constructor(n) {
    super();
    k(this, "binding");
    this.binding = n;
  }
  get path() {
    return this.binding.path;
  }
  getState() {
    return this.binding.getState();
  }
  outerSubscribe(n) {
    return this.binding.subscribe(n);
  }
  _connect() {
    const n = () => {
      this.notifySubscribers();
    };
    let r = this.binding.getState(), s = r?.subscribe(n);
    const i = () => {
      const o = this.binding.getState();
      o !== r && (r = o, s?.(), s = o?.subscribe(n), n());
    }, a = this.outerSubscribe(i);
    return () => {
      a?.(), s?.();
    };
  }
}
class $m extends ho {
  constructor(n) {
    super();
    k(this, "config");
    this.config = n;
  }
  getState() {
    return this.config.binding.getState();
  }
  outerSubscribe(n) {
    return this.config.binding.subscribe(n);
  }
  _connect() {
    const n = () => {
      this.notifySubscribers();
    };
    let r = this.config.binding.getState(), s = r?.unstable_on(this.config.event, n);
    const i = () => {
      const o = this.config.binding.getState();
      o !== r && (r = o, s?.(), s = o?.unstable_on(this.config.event, n));
    }, a = this.outerSubscribe(i);
    return () => {
      a?.(), s?.();
    };
  }
}
class el {
  constructor() {
    k(this, "_contextProvider", new Xc());
  }
  registerModelContextProvider(t) {
    return this._contextProvider.registerModelContextProvider(t);
  }
  getModelContextProvider() {
    return this._contextProvider;
  }
}
const Ma = (e) => e.content.filter((n) => n.type === "text").map((n) => n.text).join(`

`), tr = Dm("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 7), Ty = "__optimistic__", Ay = () => `${Ty}${tr()}`, fo = /* @__PURE__ */ Symbol("autoStatus"), yy = Object.freeze(Object.assign({ type: "running" }, { [fo]: !0 })), xy = Object.freeze(Object.assign({
  type: "complete",
  reason: "unknown"
}, { [fo]: !0 })), Cy = Object.freeze(Object.assign({
  type: "requires-action",
  reason: "tool-calls"
}, { [fo]: !0 })), Sy = Object.freeze(Object.assign({
  type: "requires-action",
  reason: "interrupt"
}, { [fo]: !0 })), zm = (e, t, n, r, s) => e && t ? yy : n ? Sy : r ? Cy : xy, su = (e, t) => {
  if (e.startsWith("data-"))
    return { type: "data", name: e.substring(5), data: t };
}, wi = (e, t, n) => {
  const { role: r, id: s, createdAt: i, attachments: a, status: o, metadata: u } = e, c = {
    id: s ?? t,
    createdAt: i ?? /* @__PURE__ */ new Date()
  }, l = typeof e.content == "string" ? [{ type: "text", text: e.content }] : e.content, h = ({ image: m, ...p }) => m.match(/^data:image\/(png|jpeg|jpg|gif|webp);base64,(.*)$/) ? { ...p, image: m } : (console.warn("Invalid image data format detected"), null);
  if (r !== "user" && a?.length)
    throw new Error("attachments are only supported for user messages");
  if (r !== "assistant" && o)
    throw new Error("status is only supported for assistant messages");
  if (r !== "assistant" && u?.steps)
    throw new Error("metadata.steps is only supported for assistant messages");
  switch (r) {
    case "assistant":
      return {
        ...c,
        role: r,
        content: l.map((m) => {
          const p = m.type;
          switch (p) {
            case "text":
            case "reasoning":
              return m.text.trim().length === 0 ? null : m;
            case "file":
            case "source":
              return m;
            case "image":
              return h(m);
            case "data":
              return m;
            case "tool-call": {
              const { parentId: E, messages: g, ..._ } = m, b = {
                ..._,
                toolCallId: m.toolCallId ?? `tool-${tr()}`,
                ...E !== void 0 && { parentId: E },
                ...g !== void 0 && { messages: g }
              };
              return m.args ? {
                ...b,
                args: m.args,
                argsText: m.argsText ?? JSON.stringify(m.args)
              } : {
                ...b,
                args: co(m.argsText ?? "") ?? {},
                argsText: m.argsText ?? ""
              };
            }
            default: {
              const E = su(p, m.data);
              if (E)
                return E;
              throw new Error(`Unsupported assistant message part type: ${p}`);
            }
          }
        }).filter((m) => !!m),
        status: o ?? n,
        metadata: {
          unstable_state: u?.unstable_state ?? null,
          unstable_annotations: u?.unstable_annotations ?? [],
          unstable_data: u?.unstable_data ?? [],
          custom: u?.custom ?? {},
          steps: u?.steps ?? [],
          ...u?.timing && { timing: u.timing },
          ...u?.submittedFeedback && {
            submittedFeedback: u.submittedFeedback
          }
        }
      };
    case "user":
      return {
        ...c,
        role: r,
        content: l.map((m) => {
          const p = m.type;
          switch (p) {
            case "text":
            case "image":
            case "audio":
            case "file":
            case "data":
              return m;
            default: {
              const E = su(p, m.data);
              if (E)
                return E;
              throw new Error(`Unsupported user message part type: ${p}`);
            }
          }
        }),
        attachments: (a ?? []).map((m) => ({
          ...m,
          content: m.content.map((p) => su(p.type, p.data) ?? p)
        })),
        metadata: {
          custom: u?.custom ?? {}
        }
      };
    case "system":
      if (l.length !== 1 || l[0].type !== "text")
        throw new Error("System messages must have exactly one text message part.");
      return {
        ...c,
        role: r,
        content: l,
        metadata: {
          custom: u?.custom ?? {}
        }
      };
    default: {
      const m = r;
      throw new Error(`Unknown message role: ${m}`);
    }
  }
}, tl = {
  fromArray: (e) => {
    const t = e.map((n) => wi(n, tr(), zm(!1, !1, !1, !1)));
    return {
      messages: t.map((n, r) => ({
        parentId: r > 0 ? t[r - 1].id : null,
        message: n
      }))
    };
  }
}, ba = (e) => e.next ? ba(e.next) : "current" in e ? e : null;
class wy {
  constructor(t) {
    k(this, "func");
    k(this, "_value", null);
    this.func = t;
  }
  get value() {
    return this._value === null && (this._value = this.func()), this._value;
  }
  dirty() {
    this._value = null;
  }
}
class Vm {
  constructor() {
    k(this, "messages", /* @__PURE__ */ new Map());
    k(this, "head", null);
    k(this, "root", {
      children: [],
      next: null
    });
    k(this, "_messages", new wy(() => {
      const t = new Array((this.head?.level ?? -1) + 1);
      for (let n = this.head; n; n = n.prev)
        t[n.level] = n.current;
      return t;
    }));
  }
  updateLevels(t, n) {
    t.level = n;
    for (const r of t.children) {
      const s = this.messages.get(r);
      s && this.updateLevels(s, n + 1);
    }
  }
  performOp(t, n, r) {
    const s = n.prev ?? this.root, i = t ?? this.root;
    if (!(r === "relink" && s === i)) {
      if (r !== "link" && (s.children = s.children.filter((a) => a !== n.current.id), s.next === n)) {
        const a = s.children.at(-1), o = a ? this.messages.get(a) : null;
        if (o === void 0)
          throw new Error("MessageRepository(performOp/cut): Fallback sibling message not found. This is likely an internal bug in assistant-ui.");
        s.next = o;
      }
      if (r !== "cut") {
        for (let o = t; o; o = o.prev)
          if (o.current.id === n.current.id)
            throw new Error("MessageRepository(performOp/link): A message with the same id already exists in the parent tree. This error occurs if the same message id is found multiple times. This is likely an internal bug in assistant-ui.");
        i.children = [
          ...i.children,
          n.current.id
        ], (ba(n) === this.head || i.next === null) && (i.next = n), n.prev = t;
        const a = t ? t.level + 1 : 0;
        this.updateLevels(n, a);
      }
    }
  }
  get headId() {
    return this.head?.current.id ?? null;
  }
  getMessages(t) {
    if (t === void 0 || t === this.head?.current.id)
      return this._messages.value;
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(getMessages): Head message not found. This is likely an internal bug in assistant-ui.");
    const r = new Array(n.level + 1);
    for (let s = n; s; s = s.prev)
      r[s.level] = s.current;
    return r;
  }
  addOrUpdateMessage(t, n) {
    const r = this.messages.get(n.id), s = t ? this.messages.get(t) : null;
    if (s === void 0)
      throw new Error("MessageRepository(addOrUpdateMessage): Parent message not found. This is likely an internal bug in assistant-ui.");
    if (r) {
      r.current = n, this.performOp(s, r, "relink"), this._messages.dirty();
      return;
    }
    const i = {
      prev: s,
      current: n,
      next: null,
      children: [],
      level: s ? s.level + 1 : 0
    };
    this.messages.set(n.id, i), this.performOp(s, i, "link"), this.head === s && (this.head = i), this._messages.dirty();
  }
  getMessage(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(updateMessage): Message not found. This is likely an internal bug in assistant-ui.");
    return {
      parentId: n.prev?.current.id ?? null,
      message: n.current,
      index: n.level
    };
  }
  appendOptimisticMessage(t, n) {
    let r;
    do
      r = Ay();
    while (this.messages.has(r));
    return this.addOrUpdateMessage(t, wi(n, r, { type: "running" })), r;
  }
  deleteMessage(t, n) {
    const r = this.messages.get(t);
    if (!r)
      throw new Error("MessageRepository(deleteMessage): Message not found. This is likely an internal bug in assistant-ui.");
    const s = n === void 0 ? r.prev : n === null ? null : this.messages.get(n);
    if (s === void 0)
      throw new Error("MessageRepository(deleteMessage): Replacement not found. This is likely an internal bug in assistant-ui.");
    for (const i of r.children) {
      const a = this.messages.get(i);
      if (!a)
        throw new Error("MessageRepository(deleteMessage): Child message not found. This is likely an internal bug in assistant-ui.");
      this.performOp(s, a, "relink");
    }
    this.performOp(null, r, "cut"), this.messages.delete(t), this.head === r && (this.head = ba(s ?? this.root)), this._messages.dirty();
  }
  getBranches(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(getBranches): Message not found. This is likely an internal bug in assistant-ui.");
    const { children: r } = n.prev ?? this.root;
    return r;
  }
  switchToBranch(t) {
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(switchToBranch): Branch not found. This is likely an internal bug in assistant-ui.");
    const r = n.prev ?? this.root;
    r.next = n, this.head = ba(n), this._messages.dirty();
  }
  resetHead(t) {
    if (t === null) {
      this.clear();
      return;
    }
    const n = this.messages.get(t);
    if (!n)
      throw new Error("MessageRepository(resetHead): Branch not found. This is likely an internal bug in assistant-ui.");
    if (n.children.length > 0) {
      const r = (s) => {
        for (const i of s.children) {
          const a = this.messages.get(i);
          a && (r(a), this.messages.delete(i));
        }
      };
      r(n), n.children = [], n.next = null;
    }
    this.head = n;
    for (let r = n; r; r = r.prev)
      r.prev ? r.prev.next = r : this.root.next = r;
    this._messages.dirty();
  }
  clear() {
    this.messages.clear(), this.head = null, this.root = {
      children: [],
      next: null
    }, this._messages.dirty();
  }
  export() {
    const t = [];
    for (const [, n] of this.messages)
      t.push({
        message: n.current,
        parentId: n.prev?.current.id ?? null
      });
    return {
      headId: this.head?.current.id ?? null,
      messages: t
    };
  }
  import({ headId: t, messages: n }) {
    for (const { message: r, parentId: s } of n)
      this.addOrUpdateMessage(s, r);
    this.resetHead(t ?? n.at(-1)?.message.id ?? null);
  }
}
function Iy(e, t) {
  if (t === "*")
    return !0;
  const n = t.split(",").map((i) => i.trim().toLowerCase()), r = `.${e.name.split(".").pop().toLowerCase()}`, s = e.type.toLowerCase();
  for (const i of n) {
    if (i.startsWith(".") && i === r || i.includes("/") && i === s)
      return !0;
    if (i.endsWith("/*")) {
      const a = i.split("/")[0];
      if (s.startsWith(`${a}/`))
        return !0;
    }
  }
  return !1;
}
const iu = (e) => e.status.type === "complete";
class Ym extends Si {
  constructor() {
    super(...arguments);
    k(this, "isEditing", !0);
    k(this, "_attachments", []);
    k(this, "_text", "");
    k(this, "_role", "user");
    k(this, "_runConfig", {});
    k(this, "_quote");
    k(this, "_dictation");
    k(this, "_dictationSession");
    k(this, "_dictationUnsubscribes", []);
    k(this, "_dictationBaseText", "");
    k(this, "_currentInterimText", "");
    k(this, "_dictationSessionIdCounter", 0);
    k(this, "_activeDictationSessionId");
    k(this, "_isCleaningDictation", !1);
    k(this, "_eventSubscribers", /* @__PURE__ */ new Map());
  }
  get attachmentAccept() {
    return this.getAttachmentAdapter()?.accept ?? "*";
  }
  get attachments() {
    return this._attachments;
  }
  setAttachments(n) {
    this._attachments = n, this._notifySubscribers();
  }
  get isEmpty() {
    return !this.text.trim() && !this.attachments.length;
  }
  get text() {
    return this._text;
  }
  get role() {
    return this._role;
  }
  get runConfig() {
    return this._runConfig;
  }
  get quote() {
    return this._quote;
  }
  setQuote(n) {
    this._quote !== n && (this._quote = n, this._notifySubscribers());
  }
  setText(n) {
    if (this._text !== n) {
      if (this._text = n, this._dictation) {
        this._dictationBaseText = n, this._currentInterimText = "";
        const { status: r, inputDisabled: s } = this._dictation;
        this._dictation = s ? { status: r, inputDisabled: s } : { status: r };
      }
      this._notifySubscribers();
    }
  }
  setRole(n) {
    this._role !== n && (this._role = n, this._notifySubscribers());
  }
  setRunConfig(n) {
    this._runConfig !== n && (this._runConfig = n, this._notifySubscribers());
  }
  _emptyTextAndAttachments() {
    this._attachments = [], this._text = "", this._notifySubscribers();
  }
  async _onClearAttachments() {
    const n = this.getAttachmentAdapter();
    if (n) {
      const r = this._attachments.filter((s) => !iu(s));
      await Promise.all(r.map((s) => n.remove(s)));
    }
  }
  async reset() {
    if (this._attachments.length === 0 && this._text === "" && this._role === "user" && Object.keys(this._runConfig).length === 0 && this._quote === void 0)
      return;
    this._role = "user", this._runConfig = {}, this._quote = void 0;
    const n = this._onClearAttachments();
    this._emptyTextAndAttachments(), await n;
  }
  async clearAttachments() {
    const n = this._onClearAttachments();
    this.setAttachments([]), await n;
  }
  async send() {
    if (this.isEmpty)
      return;
    this._dictationSession && (this._dictationSession.cancel(), this._cleanupDictation());
    const n = this.getAttachmentAdapter(), r = this.attachments.length > 0 ? Promise.all(this.attachments.map(async (o) => {
      if (iu(o))
        return o;
      if (!n)
        throw new Error("Attachments are not supported");
      return await n.send(o);
    })) : [], s = this.text, i = this._quote;
    this._quote = void 0, this._emptyTextAndAttachments();
    const a = {
      createdAt: /* @__PURE__ */ new Date(),
      role: this.role,
      content: s ? [{ type: "text", text: s }] : [],
      attachments: await r,
      runConfig: this.runConfig,
      metadata: { custom: { ...i ? { quote: i } : {} } }
    };
    this.handleSend(a), this._notifyEventSubscribers("send");
  }
  cancel() {
    this.handleCancel();
  }
  async addAttachment(n) {
    if (!(n instanceof File)) {
      const o = {
        id: n.id ?? tr(),
        type: n.type ?? "document",
        name: n.name,
        contentType: n.contentType,
        content: n.content,
        status: { type: "complete" }
      };
      this._attachments = [...this._attachments, o], this._notifyEventSubscribers("attachmentAdd"), this._notifySubscribers();
      return;
    }
    const r = this.getAttachmentAdapter();
    if (!r)
      throw new Error("Attachments are not supported");
    if (!Iy({ name: n.name, type: n.type }, r.accept))
      throw new Error(`File type ${n.type || "unknown"} is not accepted. Accepted types: ${r.accept}`);
    const s = (o) => {
      const u = this._attachments.findIndex((c) => c.id === o.id);
      u !== -1 ? this._attachments = [
        ...this._attachments.slice(0, u),
        o,
        ...this._attachments.slice(u + 1)
      ] : this._attachments = [...this._attachments, o], this._notifySubscribers();
    };
    let i;
    try {
      const o = r.add({ file: n });
      if (Symbol.asyncIterator in o)
        for await (const u of o)
          i = u, s(u);
      else
        i = await o, s(i);
    } catch (o) {
      i && s({
        ...i,
        status: { type: "incomplete", reason: "error" }
      });
      try {
        this._notifyEventSubscribers("attachmentAddError");
      } catch {
      }
      throw o;
    }
    const a = i?.status.type === "incomplete" && i.status.reason === "error";
    this._notifyEventSubscribers(a ? "attachmentAddError" : "attachmentAdd");
  }
  async removeAttachment(n) {
    const r = this._attachments.findIndex((i) => i.id === n);
    if (r === -1)
      throw new Error("Attachment not found");
    const s = this._attachments[r];
    if (!iu(s)) {
      const i = this.getAttachmentAdapter();
      if (!i)
        throw new Error("Attachments are not supported");
      await i.remove(s);
    }
    this._attachments = this._attachments.filter((i) => i.id !== n), this._notifySubscribers();
  }
  get dictation() {
    return this._dictation;
  }
  _isActiveSession(n, r) {
    return this._activeDictationSessionId === n && this._dictationSession === r;
  }
  startDictation() {
    const n = this.getDictationAdapter();
    if (!n)
      throw new Error("Dictation adapter not configured");
    if (this._dictationSession) {
      for (const h of this._dictationUnsubscribes)
        h();
      this._dictationUnsubscribes = [], this._dictationSession.stop().catch(() => {
      }), this._dictationSession = void 0;
    }
    const r = n.disableInputDuringDictation ?? !1;
    this._dictationBaseText = this._text, this._currentInterimText = "";
    const s = n.listen();
    this._dictationSession = s;
    const i = ++this._dictationSessionIdCounter;
    this._activeDictationSessionId = i, this._dictation = { status: s.status, inputDisabled: r }, this._notifySubscribers();
    const a = s.onSpeech((l) => {
      if (!this._isActiveSession(i, s))
        return;
      const h = l.isFinal !== !1, p = this._dictationBaseText && !this._dictationBaseText.endsWith(" ") && l.transcript ? " " : "";
      if (h) {
        if (this._dictationBaseText = this._dictationBaseText + p + l.transcript, this._currentInterimText = "", this._text = this._dictationBaseText, this._dictation) {
          const { transcript: E, ...g } = this._dictation;
          this._dictation = g;
        }
        this._notifySubscribers();
      } else
        this._currentInterimText = p + l.transcript, this._text = this._dictationBaseText + this._currentInterimText, this._dictation && (this._dictation = {
          ...this._dictation,
          transcript: l.transcript
        }), this._notifySubscribers();
    });
    this._dictationUnsubscribes.push(a);
    const o = s.onSpeechStart(() => {
      this._isActiveSession(i, s) && (this._dictation = {
        status: { type: "running" },
        inputDisabled: r,
        ...this._dictation?.transcript && {
          transcript: this._dictation.transcript
        }
      }, this._notifySubscribers());
    });
    this._dictationUnsubscribes.push(o);
    const u = s.onSpeechEnd(() => {
      this._cleanupDictation({ sessionId: i });
    });
    this._dictationUnsubscribes.push(u);
    const c = setInterval(() => {
      this._isActiveSession(i, s) && s.status.type === "ended" && this._cleanupDictation({ sessionId: i });
    }, 100);
    this._dictationUnsubscribes.push(() => clearInterval(c));
  }
  stopDictation() {
    if (!this._dictationSession)
      return;
    const n = this._dictationSession, r = this._activeDictationSessionId;
    n.stop().finally(() => {
      this._cleanupDictation({ sessionId: r });
    });
  }
  _cleanupDictation(n) {
    if (!(n?.sessionId !== void 0 && n.sessionId !== this._activeDictationSessionId || this._isCleaningDictation)) {
      this._isCleaningDictation = !0;
      try {
        for (const s of this._dictationUnsubscribes)
          s();
        this._dictationUnsubscribes = [], this._dictationSession = void 0, this._activeDictationSessionId = void 0, this._dictation = void 0, this._dictationBaseText = "", this._currentInterimText = "", this._notifySubscribers();
      } finally {
        this._isCleaningDictation = !1;
      }
    }
  }
  _notifyEventSubscribers(n) {
    const r = this._eventSubscribers.get(n);
    if (r)
      for (const s of r)
        s();
  }
  unstable_on(n, r) {
    const s = this._eventSubscribers.get(n);
    return s ? s.add(r) : this._eventSubscribers.set(n, /* @__PURE__ */ new Set([r])), () => {
      const i = this._eventSubscribers.get(n);
      i && i.delete(r);
    };
  }
}
class Gm extends Ym {
  constructor(n) {
    super();
    k(this, "runtime");
    k(this, "_canCancel", !1);
    this.runtime = n, this.connect();
  }
  get canCancel() {
    return this._canCancel;
  }
  getAttachmentAdapter() {
    return this.runtime.adapters?.attachments;
  }
  getDictationAdapter() {
    return this.runtime.adapters?.dictation;
  }
  connect() {
    return this.runtime.subscribe(() => {
      this.canCancel !== this.runtime.capabilities.cancel && (this._canCancel = this.runtime.capabilities.cancel, this._notifySubscribers());
    });
  }
  async handleSend(n) {
    this.runtime.append({
      ...n,
      parentId: this.runtime.messages.at(-1)?.id ?? null,
      sourceId: null
    });
  }
  async handleCancel() {
    this.runtime.cancelRun();
  }
}
class vy extends Ym {
  constructor(n, r, { parentId: s, message: i }) {
    super();
    k(this, "runtime");
    k(this, "endEditCallback");
    k(this, "_nonTextParts");
    k(this, "_previousText");
    k(this, "_parentId");
    k(this, "_sourceId");
    this.runtime = n, this.endEditCallback = r, this._parentId = s, this._sourceId = i.id, this._previousText = Ma(i), this.setText(this._previousText), this.setRole(i.role), this.setAttachments(i.attachments ?? []), this._nonTextParts = i.content.filter((a) => a.type !== "text"), this.setRunConfig({ ...n.composer.runConfig });
  }
  get canCancel() {
    return !0;
  }
  getAttachmentAdapter() {
    return this.runtime.adapters?.attachments;
  }
  getDictationAdapter() {
    return this.runtime.adapters?.dictation;
  }
  async handleSend(n) {
    Ma(n) !== this._previousText && this.runtime.append({
      ...n,
      content: [...n.content, ...this._nonTextParts],
      parentId: this._parentId,
      sourceId: this._sourceId
    }), this.handleCancel();
  }
  handleCancel() {
    this.endEditCallback(), this._notifySubscribers();
  }
}
class Ny {
  constructor(t) {
    k(this, "_contextProvider");
    k(this, "_subscriptions", /* @__PURE__ */ new Set());
    k(this, "_isInitialized", !1);
    k(this, "repository", new Vm());
    k(this, "composer", new Gm(this));
    k(this, "_editComposers", /* @__PURE__ */ new Map());
    k(this, "_stopSpeaking");
    k(this, "speech");
    k(this, "_eventSubscribers", /* @__PURE__ */ new Map());
    this._contextProvider = t;
  }
  get messages() {
    return this.repository.getMessages();
  }
  get state() {
    let t;
    for (const n of this.messages)
      n.role === "assistant" && (t = n);
    return t?.metadata.unstable_state ?? null;
  }
  getModelContext() {
    return this._contextProvider.getModelContext();
  }
  getEditComposer(t) {
    return this._editComposers.get(t);
  }
  beginEdit(t) {
    if (this._editComposers.has(t))
      throw new Error("Edit already in progress");
    this._editComposers.set(t, new vy(this, () => this._editComposers.delete(t), this.repository.getMessage(t))), this._notifySubscribers();
  }
  getMessageById(t) {
    try {
      return this.repository.getMessage(t);
    } catch {
      return;
    }
  }
  getBranches(t) {
    return this.repository.getBranches(t);
  }
  switchToBranch(t) {
    this.repository.switchToBranch(t), this._notifySubscribers();
  }
  _notifySubscribers() {
    for (const t of this._subscriptions)
      t();
  }
  _notifyEventSubscribers(t) {
    const n = this._eventSubscribers.get(t);
    if (n)
      for (const r of n)
        r();
  }
  subscribe(t) {
    return this._subscriptions.add(t), () => this._subscriptions.delete(t);
  }
  submitFeedback({ messageId: t, type: n }) {
    const r = this.adapters?.feedback;
    if (!r)
      throw new Error("Feedback adapter not configured");
    const { message: s, parentId: i } = this.repository.getMessage(t);
    if (r.submit({ message: s, type: n }), s.role === "assistant") {
      const a = {
        ...s,
        metadata: {
          ...s.metadata,
          submittedFeedback: { type: n }
        }
      };
      this.repository.addOrUpdateMessage(i, a);
    }
    this._notifySubscribers();
  }
  speak(t) {
    const n = this.adapters?.speech;
    if (!n)
      throw new Error("Speech adapter not configured");
    const { message: r } = this.repository.getMessage(t);
    this._stopSpeaking?.();
    const s = n.speak(Ma(r)), i = s.subscribe(() => {
      s.status.type === "ended" ? (this._stopSpeaking = void 0, this.speech = void 0) : this.speech = { messageId: t, status: s.status }, this._notifySubscribers();
    });
    this.speech = { messageId: t, status: s.status }, this._notifySubscribers(), this._stopSpeaking = () => {
      s.cancel(), i(), this.speech = void 0, this._stopSpeaking = void 0;
    };
  }
  stopSpeaking() {
    if (!this._stopSpeaking)
      throw new Error("No message is being spoken");
    this._stopSpeaking(), this._notifySubscribers();
  }
  ensureInitialized() {
    this._isInitialized || (this._isInitialized = !0, this._notifyEventSubscribers("initialize"));
  }
  export() {
    return this.repository.export();
  }
  import(t) {
    this.ensureInitialized(), this.repository.clear(), this.repository.import(t), this._notifySubscribers();
  }
  reset(t) {
    this.import(tl.fromArray(t ?? []));
  }
  unstable_on(t, n) {
    if (t === "modelContextUpdate")
      return this._contextProvider.subscribe?.(n) ?? (() => {
      });
    const r = this._eventSubscribers.get(t);
    return r ? r.add(n) : this._eventSubscribers.set(t, /* @__PURE__ */ new Set([n])), () => {
      this._eventSubscribers.get(t).delete(n);
    };
  }
}
class Yi {
  constructor(t, n) {
    k(this, "_core");
    k(this, "_threadListBinding");
    this._core = t, this._threadListBinding = n, this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.switchTo = this.switchTo.bind(this), this.rename = this.rename.bind(this), this.archive = this.archive.bind(this), this.unarchive = this.unarchive.bind(this), this.delete = this.delete.bind(this), this.initialize = this.initialize.bind(this), this.generateTitle = this.generateTitle.bind(this), this.subscribe = this.subscribe.bind(this), this.unstable_on = this.unstable_on.bind(this), this.getState = this.getState.bind(this), this.detach = this.detach.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  switchTo() {
    const t = this._core.getState();
    return this._threadListBinding.switchToThread(t.id);
  }
  rename(t) {
    const n = this._core.getState();
    return this._threadListBinding.rename(n.id, t);
  }
  archive() {
    const t = this._core.getState();
    return this._threadListBinding.archive(t.id);
  }
  unarchive() {
    const t = this._core.getState();
    return this._threadListBinding.unarchive(t.id);
  }
  delete() {
    const t = this._core.getState();
    return this._threadListBinding.delete(t.id);
  }
  initialize() {
    const t = this._core.getState();
    return this._threadListBinding.initialize(t.id);
  }
  generateTitle() {
    const t = this._core.getState();
    return this._threadListBinding.generateTitle(t.id);
  }
  unstable_on(t, n) {
    let r = this._core.getState().isMain, s = this._core.getState().id;
    return this.subscribe(() => {
      const i = this._core.getState(), a = i.isMain, o = i.id;
      r === a && s === o || (r = a, s = o, !(t === "switchedTo" && !a) && (t === "switchedAway" && a || n()));
    });
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  detach() {
    const t = this._core.getState();
    this._threadListBinding.detach(t.id);
  }
  __internal_getRuntime() {
    return this;
  }
}
const Ha = /* @__PURE__ */ Symbol("innerMessage");
class Wm {
  constructor(t) {
    k(this, "_core");
    this._core = t, this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.getState = this.getState.bind(this), this.remove = this.remove.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
}
class qm extends Wm {
  constructor(n, r) {
    super(n);
    k(this, "_composerApi");
    this._composerApi = r;
  }
  remove() {
    const n = this._composerApi.getState();
    if (!n)
      throw new Error("Composer is not available");
    return n.removeAttachment(this.getState().id);
  }
}
class ky extends qm {
  get source() {
    return "thread-composer";
  }
}
class Ry extends qm {
  get source() {
    return "edit-composer";
  }
}
class Py extends Wm {
  get source() {
    return "message";
  }
  constructor(t) {
    super(t);
  }
  remove() {
    throw new Error("Message attachments cannot be removed");
  }
}
const Km = Object.freeze([]), Qm = Object.freeze({}), Oy = (e) => Object.freeze({
  type: "thread",
  isEditing: e?.isEditing ?? !1,
  canCancel: e?.canCancel ?? !1,
  isEmpty: e?.isEmpty ?? !0,
  attachments: e?.attachments ?? Km,
  text: e?.text ?? "",
  role: e?.role ?? "user",
  runConfig: e?.runConfig ?? Qm,
  attachmentAccept: e?.attachmentAccept ?? "",
  dictation: e?.dictation,
  quote: e?.quote,
  value: e?.text ?? ""
}), Dy = (e) => Object.freeze({
  type: "edit",
  isEditing: e?.isEditing ?? !1,
  canCancel: e?.canCancel ?? !1,
  isEmpty: e?.isEmpty ?? !0,
  text: e?.text ?? "",
  role: e?.role ?? "user",
  attachments: e?.attachments ?? Km,
  runConfig: e?.runConfig ?? Qm,
  attachmentAccept: e?.attachmentAccept ?? "",
  dictation: e?.dictation,
  quote: e?.quote,
  value: e?.text ?? ""
});
class Xm {
  constructor(t) {
    k(this, "_core");
    k(this, "_eventSubscriptionSubjects", /* @__PURE__ */ new Map());
    this._core = t;
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.setText = this.setText.bind(this), this.setRunConfig = this.setRunConfig.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.addAttachment = this.addAttachment.bind(this), this.reset = this.reset.bind(this), this.clearAttachments = this.clearAttachments.bind(this), this.send = this.send.bind(this), this.cancel = this.cancel.bind(this), this.setRole = this.setRole.bind(this), this.getAttachmentByIndex = this.getAttachmentByIndex.bind(this), this.startDictation = this.startDictation.bind(this), this.stopDictation = this.stopDictation.bind(this), this.setQuote = this.setQuote.bind(this), this.unstable_on = this.unstable_on.bind(this);
  }
  setText(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setText(t);
  }
  setRunConfig(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setRunConfig(t);
  }
  addAttachment(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    return n.addAttachment(t);
  }
  reset() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    return t.reset();
  }
  clearAttachments() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    return t.clearAttachments();
  }
  send() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.send();
  }
  cancel() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.cancel();
  }
  setRole(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setRole(t);
  }
  startDictation() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.startDictation();
  }
  stopDictation() {
    const t = this._core.getState();
    if (!t)
      throw new Error("Composer is not available");
    t.stopDictation();
  }
  setQuote(t) {
    const n = this._core.getState();
    if (!n)
      throw new Error("Composer is not available");
    n.setQuote(t);
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  unstable_on(t, n) {
    let r = this._eventSubscriptionSubjects.get(t);
    return r || (r = new $m({
      event: t,
      binding: this._core
    }), this._eventSubscriptionSubjects.set(t, r)), r.subscribe(n);
  }
}
class Ly extends Xm {
  constructor(n) {
    const r = new Zc({
      path: n.path,
      getState: () => Oy(n.getState()),
      subscribe: (s) => n.subscribe(s)
    });
    super({
      path: n.path,
      getState: () => n.getState(),
      subscribe: (s) => r.subscribe(s)
    });
    k(this, "_getState");
    this._getState = r.getState.bind(r), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  get type() {
    return "thread";
  }
  getState() {
    return this._getState();
  }
  getAttachmentByIndex(n) {
    return new ky(new sn({
      path: {
        ...this.path,
        attachmentSource: "thread-composer",
        attachmentSelector: { type: "index", index: n },
        ref: `${this.path.ref}.attachments[${n}]`
      },
      getState: () => {
        const s = this.getState().attachments[n];
        return s ? {
          ...s,
          source: "thread-composer"
        } : on;
      },
      subscribe: (r) => this._core.subscribe(r)
    }), this._core);
  }
}
class My extends Xm {
  constructor(n, r) {
    const s = new Zc({
      path: n.path,
      getState: () => Dy(n.getState()),
      subscribe: (i) => n.subscribe(i)
    });
    super({
      path: n.path,
      getState: () => n.getState(),
      subscribe: (i) => s.subscribe(i)
    });
    k(this, "_beginEdit");
    k(this, "_getState");
    this._beginEdit = r, this._getState = s.getState.bind(s), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  get type() {
    return "edit";
  }
  __internal_bindMethods() {
    super.__internal_bindMethods(), this.beginEdit = this.beginEdit.bind(this);
  }
  getState() {
    return this._getState();
  }
  beginEdit() {
    this._beginEdit();
  }
  getAttachmentByIndex(n) {
    return new Ry(new sn({
      path: {
        ...this.path,
        attachmentSource: "edit-composer",
        attachmentSelector: { type: "index", index: n },
        ref: `${this.path.ref}.attachments[${n}]`
      },
      getState: () => {
        const s = this.getState().attachments[n];
        return s ? {
          ...s,
          source: "edit-composer"
        } : on;
      },
      subscribe: (r) => this._core.subscribe(r)
    }), this._core);
  }
}
class eh {
  constructor(t, n, r) {
    k(this, "contentBinding");
    k(this, "messageApi");
    k(this, "threadApi");
    this.contentBinding = t, this.messageApi = n, this.threadApi = r, this.__internal_bindMethods();
  }
  get path() {
    return this.contentBinding.path;
  }
  __internal_bindMethods() {
    this.addToolResult = this.addToolResult.bind(this), this.resumeToolCall = this.resumeToolCall.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  getState() {
    return this.contentBinding.getState();
  }
  addToolResult(t) {
    const n = this.contentBinding.getState();
    if (!n)
      throw new Error("Message part is not available");
    if (n.type !== "tool-call")
      throw new Error("Tried to add tool result to non-tool message part");
    if (!this.messageApi)
      throw new Error("Message API is not available. This is likely a bug in assistant-ui.");
    if (!this.threadApi)
      throw new Error("Thread API is not available");
    const r = this.messageApi.getState();
    if (!r)
      throw new Error("Message is not available");
    const s = n.toolName, i = n.toolCallId, a = Da.toResponse(t);
    this.threadApi.getState().addToolResult({
      messageId: r.id,
      toolName: s,
      toolCallId: i,
      result: a.result,
      artifact: a.artifact,
      isError: a.isError
    });
  }
  resumeToolCall(t) {
    const n = this.contentBinding.getState();
    if (!n)
      throw new Error("Message part is not available");
    if (n.type !== "tool-call")
      throw new Error("Tried to resume tool call on non-tool message part");
    if (!this.threadApi)
      throw new Error("Thread API is not available");
    const r = n.toolCallId;
    this.threadApi.getState().resumeToolCall({
      toolCallId: r,
      payload: t
    });
  }
  subscribe(t) {
    return this.contentBinding.subscribe(t);
  }
}
const Gi = Object.freeze({
  type: "complete"
}), Hy = (e, t, n) => {
  if (e.role !== "assistant")
    return Gi;
  if (n.type === "tool-call")
    return n.result ? Gi : e.status;
  const r = t === Math.max(0, e.content.length - 1);
  return e.status.type === "requires-action" ? Gi : r ? e.status : Gi;
}, th = (e, t) => {
  const n = e.content[t];
  if (!n)
    return on;
  const r = Hy(e, t, n);
  return Object.freeze({
    ...n,
    [Ha]: n[Ha],
    status: r
  });
};
class By {
  constructor(t, n) {
    k(this, "_core");
    k(this, "_threadBinding");
    k(this, "composer");
    k(this, "_getEditComposerRuntimeCore", () => this._threadBinding.getState().getEditComposer(this._core.getState().id));
    this._core = t, this._threadBinding = n, this.composer = new My(new La({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.composer`,
        composerSource: "edit"
      },
      getState: this._getEditComposerRuntimeCore,
      subscribe: (r) => this._threadBinding.subscribe(r)
    }), () => this._threadBinding.getState().beginEdit(this._core.getState().id)), this.__internal_bindMethods();
  }
  get path() {
    return this._core.path;
  }
  __internal_bindMethods() {
    this.reload = this.reload.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.getMessagePartByIndex = this.getMessagePartByIndex.bind(this), this.getMessagePartByToolCallId = this.getMessagePartByToolCallId.bind(this), this.getAttachmentByIndex = this.getAttachmentByIndex.bind(this), this.unstable_getCopyText = this.unstable_getCopyText.bind(this), this.speak = this.speak.bind(this), this.stopSpeaking = this.stopSpeaking.bind(this), this.submitFeedback = this.submitFeedback.bind(this), this.switchToBranch = this.switchToBranch.bind(this);
  }
  getState() {
    return this._core.getState();
  }
  reload(t = {}) {
    const n = this._getEditComposerRuntimeCore(), r = n ?? this._threadBinding.getState().composer, s = n ?? r, { runConfig: i = s.runConfig } = t, a = this._core.getState();
    if (a.role !== "assistant")
      throw new Error("Can only reload assistant messages");
    this._threadBinding.getState().startRun({
      parentId: a.parentId,
      sourceId: a.id,
      runConfig: i
    });
  }
  speak() {
    const t = this._core.getState();
    return this._threadBinding.getState().speak(t.id);
  }
  stopSpeaking() {
    const t = this._core.getState();
    if (this._threadBinding.getState().speech?.messageId === t.id)
      this._threadBinding.getState().stopSpeaking();
    else
      throw new Error("Message is not being spoken");
  }
  submitFeedback({ type: t }) {
    const n = this._core.getState();
    this._threadBinding.getState().submitFeedback({
      messageId: n.id,
      type: t
    });
  }
  switchToBranch({ position: t, branchId: n }) {
    const r = this._core.getState();
    if (n && t)
      throw new Error("May not specify both branchId and position");
    if (!n && !t)
      throw new Error("Must specify either branchId or position");
    const i = this._threadBinding.getState().getBranches(r.id);
    let a = n;
    if (t === "previous" ? a = i[r.branchNumber - 2] : t === "next" && (a = i[r.branchNumber]), !a)
      throw new Error("Branch not found");
    this._threadBinding.getState().switchToBranch(a);
  }
  unstable_getCopyText() {
    return Ma(this.getState());
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  getMessagePartByIndex(t) {
    if (t < 0)
      throw new Error("Message part index must be >= 0");
    return new eh(new sn({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.content[${t}]`,
        messagePartSelector: { type: "index", index: t }
      },
      getState: () => th(this.getState(), t),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core, this._threadBinding);
  }
  getMessagePartByToolCallId(t) {
    return new eh(new sn({
      path: {
        ...this.path,
        ref: this.path.ref + `${this.path.ref}.content[toolCallId=${JSON.stringify(t)}]`,
        messagePartSelector: { type: "toolCallId", toolCallId: t }
      },
      getState: () => {
        const n = this._core.getState(), r = n.content.findIndex((s) => s.type === "tool-call" && s.toolCallId === t);
        return r === -1 ? on : th(n, r);
      },
      subscribe: (n) => this._core.subscribe(n)
    }), this._core, this._threadBinding);
  }
  getAttachmentByIndex(t) {
    return new Py(new sn({
      path: {
        ...this.path,
        ref: `${this.path.ref}${this.path.ref}.attachments[${t}]`,
        attachmentSource: "message",
        attachmentSelector: { type: "index", index: t }
      },
      getState: () => {
        const r = this.getState().attachments?.[t];
        return r ? {
          ...r,
          source: "message"
        } : on;
      },
      subscribe: (n) => this._core.subscribe(n)
    }));
  }
}
const Uy = (e) => ({
  parentId: e.parentId ?? null,
  sourceId: e.sourceId ?? null,
  runConfig: e.runConfig ?? {},
  ...e.stream ? { stream: e.stream } : {}
}), Fy = (e) => ({
  parentId: e.parentId ?? null,
  sourceId: e.sourceId ?? null,
  runConfig: e.runConfig ?? {}
}), jy = (e, t) => typeof t == "string" ? {
  createdAt: /* @__PURE__ */ new Date(),
  parentId: e.at(-1)?.id ?? null,
  sourceId: null,
  runConfig: {},
  role: "user",
  content: [{ type: "text", text: t }],
  attachments: [],
  metadata: { custom: {} }
} : {
  createdAt: t.createdAt ?? /* @__PURE__ */ new Date(),
  parentId: t.parentId ?? e.at(-1)?.id ?? null,
  sourceId: t.sourceId ?? null,
  role: t.role ?? "user",
  content: t.content,
  attachments: t.attachments ?? [],
  metadata: t.metadata ?? { custom: {} },
  runConfig: t.runConfig ?? {},
  startRun: t.startRun
}, $y = (e, t) => {
  const n = e.messages.at(-1);
  return Object.freeze({
    threadId: t.id,
    metadata: t,
    capabilities: e.capabilities,
    isDisabled: e.isDisabled,
    isLoading: e.isLoading,
    isRunning: n?.role !== "assistant" ? !1 : n.status.type === "running",
    messages: e.messages,
    state: e.state,
    suggestions: e.suggestions,
    extras: e.extras,
    speech: e.speech
  });
};
class Jm {
  constructor(t, n) {
    k(this, "_threadBinding");
    k(this, "composer");
    k(this, "_eventSubscriptionSubjects", /* @__PURE__ */ new Map());
    const r = new sn({
      path: t.path,
      getState: () => $y(t.getState(), n.getState()),
      subscribe: (s) => {
        const i = t.subscribe(s), a = n.subscribe(s);
        return () => {
          i(), a();
        };
      }
    });
    this._threadBinding = {
      path: t.path,
      getState: () => t.getState(),
      getStateState: () => r.getState(),
      outerSubscribe: (s) => t.outerSubscribe(s),
      subscribe: (s) => t.subscribe(s)
    }, this.composer = new Ly(new La({
      path: {
        ...this.path,
        ref: `${this.path.ref}.composer`,
        composerSource: "thread"
      },
      getState: () => this._threadBinding.getState().composer,
      subscribe: (s) => this._threadBinding.subscribe(s)
    })), this.__internal_bindMethods();
  }
  get path() {
    return this._threadBinding.path;
  }
  get __internal_threadBinding() {
    return this._threadBinding;
  }
  __internal_bindMethods() {
    this.append = this.append.bind(this), this.resumeRun = this.resumeRun.bind(this), this.unstable_resumeRun = this.unstable_resumeRun.bind(this), this.unstable_loadExternalState = this.unstable_loadExternalState.bind(this), this.importExternalState = this.importExternalState.bind(this), this.exportExternalState = this.exportExternalState.bind(this), this.startRun = this.startRun.bind(this), this.cancelRun = this.cancelRun.bind(this), this.stopSpeaking = this.stopSpeaking.bind(this), this.export = this.export.bind(this), this.import = this.import.bind(this), this.reset = this.reset.bind(this), this.getMessageByIndex = this.getMessageByIndex.bind(this), this.getMessageById = this.getMessageById.bind(this), this.subscribe = this.subscribe.bind(this), this.unstable_on = this.unstable_on.bind(this), this.getModelContext = this.getModelContext.bind(this), this.getModelConfig = this.getModelConfig.bind(this), this.getState = this.getState.bind(this);
  }
  getState() {
    return this._threadBinding.getStateState();
  }
  append(t) {
    this._threadBinding.getState().append(jy(this._threadBinding.getState().messages, t));
  }
  subscribe(t) {
    return this._threadBinding.subscribe(t);
  }
  getModelContext() {
    return this._threadBinding.getState().getModelContext();
  }
  getModelConfig() {
    return this.getModelContext();
  }
  startRun(t) {
    const n = t === null || typeof t == "string" ? { parentId: t } : t;
    return this._threadBinding.getState().startRun(Fy(n));
  }
  resumeRun(t) {
    return this._threadBinding.getState().resumeRun(Uy(t));
  }
  /** @deprecated Use `resumeRun` instead. */
  unstable_resumeRun(t) {
    return this.resumeRun(t);
  }
  exportExternalState() {
    return this._threadBinding.getState().exportExternalState();
  }
  importExternalState(t) {
    this._threadBinding.getState().importExternalState(t);
  }
  unstable_loadExternalState(t) {
    this._threadBinding.getState().unstable_loadExternalState(t);
  }
  cancelRun() {
    this._threadBinding.getState().cancelRun();
  }
  stopSpeaking() {
    return this._threadBinding.getState().stopSpeaking();
  }
  export() {
    return this._threadBinding.getState().export();
  }
  import(t) {
    this._threadBinding.getState().import(t);
  }
  reset(t) {
    this._threadBinding.getState().reset(t);
  }
  getMessageByIndex(t) {
    if (t < 0)
      throw new Error("Message index must be >= 0");
    return this._getMessageRuntime({
      ...this.path,
      ref: `${this.path.ref}.messages[${t}]`,
      messageSelector: { type: "index", index: t }
    }, () => {
      const n = this._threadBinding.getState().messages, r = n[t];
      if (r)
        return {
          message: r,
          parentId: n[t - 1]?.id ?? null,
          index: t
        };
    });
  }
  getMessageById(t) {
    return this._getMessageRuntime({
      ...this.path,
      ref: `${this.path.ref}.messages[messageId=${JSON.stringify(t)}]`,
      messageSelector: { type: "messageId", messageId: t }
    }, () => this._threadBinding.getState().getMessageById(t));
  }
  _getMessageRuntime(t, n) {
    return new By(new sn({
      path: t,
      getState: () => {
        const { message: r, parentId: s, index: i } = n() ?? {}, { messages: a, speech: o } = this._threadBinding.getState();
        if (!r || s === void 0 || i === void 0)
          return on;
        const c = this._threadBinding.getState().getBranches(r.id), l = r.metadata.submittedFeedback;
        return {
          ...r,
          [Ha]: r[Ha],
          index: i,
          isLast: a.at(-1)?.id === r.id,
          parentId: s,
          branchNumber: c.indexOf(r.id) + 1,
          branchCount: c.length,
          speech: o?.messageId === r.id ? o : void 0,
          submittedFeedback: l
        };
      },
      subscribe: (r) => this._threadBinding.subscribe(r)
    }), this._threadBinding);
  }
  unstable_on(t, n) {
    let r = this._eventSubscriptionSubjects.get(t);
    return r || (r = new $m({
      event: t,
      binding: this._threadBinding
    }), this._eventSubscriptionSubjects.set(t, r)), r.subscribe(n);
  }
}
const zy = (e) => ({
  mainThreadId: e.mainThreadId,
  newThreadId: e.newThreadId,
  threadIds: e.threadIds,
  archivedThreadIds: e.archivedThreadIds,
  isLoading: e.isLoading,
  threadItems: e.threadItems
}), Wi = (e, t) => {
  if (t === void 0)
    return on;
  const n = e.getItemById(t);
  return n ? {
    id: n.id,
    remoteId: n.remoteId,
    externalId: n.externalId,
    title: n.title,
    status: n.status,
    isMain: n.id === e.mainThreadId
  } : on;
};
class Zm {
  constructor(t, n = Jm) {
    k(this, "_core");
    k(this, "_runtimeFactory");
    k(this, "_getState");
    k(this, "_mainThreadListItemRuntime");
    k(this, "main");
    this._core = t, this._runtimeFactory = n;
    const r = new Zc({
      path: {},
      getState: () => zy(t),
      subscribe: (s) => t.subscribe(s)
    });
    this._getState = r.getState.bind(r), this._mainThreadListItemRuntime = new Yi(new sn({
      path: {
        ref: "threadItems[main]",
        threadSelector: { type: "main" }
      },
      getState: () => Wi(this._core, this._core.mainThreadId),
      subscribe: (s) => this._core.subscribe(s)
    }), this._core), this.main = new n(new La({
      path: {
        ref: "threads.main",
        threadSelector: { type: "main" }
      },
      getState: () => t.getMainThreadRuntimeCore(),
      subscribe: (s) => t.subscribe(s)
    }), this._mainThreadListItemRuntime), this.__internal_bindMethods();
  }
  __internal_bindMethods() {
    this.switchToThread = this.switchToThread.bind(this), this.switchToNewThread = this.switchToNewThread.bind(this), this.getState = this.getState.bind(this), this.subscribe = this.subscribe.bind(this), this.getById = this.getById.bind(this), this.getItemById = this.getItemById.bind(this), this.getItemByIndex = this.getItemByIndex.bind(this), this.getArchivedItemByIndex = this.getArchivedItemByIndex.bind(this);
  }
  switchToThread(t) {
    return this._core.switchToThread(t);
  }
  switchToNewThread() {
    return this._core.switchToNewThread();
  }
  getState() {
    return this._getState();
  }
  subscribe(t) {
    return this._core.subscribe(t);
  }
  get mainItem() {
    return this._mainThreadListItemRuntime;
  }
  getById(t) {
    return new this._runtimeFactory(new La({
      path: {
        ref: `threads[threadId=${JSON.stringify(t)}]`,
        threadSelector: { type: "threadId", threadId: t }
      },
      getState: () => this._core.getThreadRuntimeCore(t),
      subscribe: (n) => this._core.subscribe(n)
    }), this.mainItem);
  }
  getItemByIndex(t) {
    return new Yi(new sn({
      path: {
        ref: `threadItems[${t}]`,
        threadSelector: { type: "index", index: t }
      },
      getState: () => Wi(this._core, this._core.threadIds[t]),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
  getArchivedItemByIndex(t) {
    return new Yi(new sn({
      path: {
        ref: `archivedThreadItems[${t}]`,
        threadSelector: { type: "archiveIndex", index: t }
      },
      getState: () => Wi(this._core, this._core.archivedThreadIds[t]),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
  getItemById(t) {
    return new Yi(new sn({
      path: {
        ref: `threadItems[threadId=${t}]`,
        threadSelector: { type: "threadId", threadId: t }
      },
      getState: () => Wi(this._core, t),
      subscribe: (n) => this._core.subscribe(n)
    }), this._core);
  }
}
class nl {
  constructor(t) {
    k(this, "_core");
    k(this, "threads");
    k(this, "_thread");
    this._core = t, this.threads = new Zm(t.threads), this._thread = this.threads.main, this.__internal_bindMethods();
  }
  get threadList() {
    return this.threads;
  }
  __internal_bindMethods() {
    this.switchToNewThread = this.switchToNewThread.bind(this), this.switchToThread = this.switchToThread.bind(this), this.registerModelContextProvider = this.registerModelContextProvider.bind(this), this.registerModelConfigProvider = this.registerModelConfigProvider.bind(this), this.reset = this.reset.bind(this);
  }
  get thread() {
    return this._thread;
  }
  switchToNewThread() {
    return this._core.threads.switchToNewThread();
  }
  switchToThread(t) {
    return this._core.threads.switchToThread(t);
  }
  registerModelContextProvider(t) {
    return this._core.registerModelContextProvider(t);
  }
  registerModelConfigProvider(t) {
    return this.registerModelContextProvider(t);
  }
  reset({ initialMessages: t } = {}) {
    return this._core.threads.getMainThreadRuntimeCore().import(tl.fromArray(t ?? []));
  }
}
const eg = Fe((e) => Ft(fy(e)));
xm(eg, (e, t) => {
  py(e, t), !e.tools && t.tools.source === null && (e.tools = km({})), !e.dataRenderers && t.dataRenderers.source === null && (e.dataRenderers = vA());
});
const ic = Tt(null), rl = ({ adapters: e, children: t }) => {
  const n = mt(ic);
  return d.jsx(ic.Provider, { value: {
    ...n,
    ...e
  }, children: t });
}, Vy = () => mt(ic);
function Yy(e) {
  return e != null && typeof e == "object" && !Array.isArray(e);
}
function ac(e, t = 0) {
  return t > 100 ? !1 : e === null || typeof e == "string" || typeof e == "boolean" ? !0 : typeof e == "number" ? !Number.isNaN(e) && Number.isFinite(e) : Array.isArray(e) ? e.every((n) => ac(n, t + 1)) : Yy(e) ? Object.entries(e).every(([n, r]) => typeof n == "string" && ac(r, t + 1)) : !1;
}
const nh = (e, t) => t === void 0 ? e.status?.type === "requires-action" && e.status.reason === "tool-calls" && e.content.every((n) => n.type !== "tool-call" || !!n.result) : e.status?.type === "requires-action" && e.status.reason === "tool-calls" && e.content.every((n) => n.type !== "tool-call" || !!n.result || !t.includes(n.toolName));
class au extends Error {
  constructor(n, r) {
    super(r);
    k(this, "name", "AbortError");
    k(this, "detach");
    this.detach = n;
  }
}
class Gy extends Ny {
  constructor(n, r) {
    super(n);
    k(this, "capabilities", {
      switchToBranch: !0,
      switchBranchDuringRun: !0,
      edit: !0,
      reload: !0,
      cancel: !0,
      unstable_copy: !0,
      speech: !1,
      dictation: !1,
      attachments: !1,
      feedback: !1,
      queue: !1
    });
    k(this, "abortController", null);
    k(this, "isDisabled", !1);
    k(this, "_isLoading", !1);
    k(this, "_suggestions", []);
    k(this, "_suggestionsController", null);
    k(this, "_options");
    k(this, "_lastRunConfig", {});
    k(this, "_getThreadId");
    k(this, "_getInitializePromise");
    k(this, "_loadPromise");
    this.__internal_setOptions(r);
  }
  get isLoading() {
    return this._isLoading;
  }
  get suggestions() {
    return this._suggestions;
  }
  get adapters() {
    return this._options.adapters;
  }
  __internal_setGetThreadId(n) {
    this._getThreadId = n;
  }
  __internal_setGetInitializePromise(n) {
    this._getInitializePromise = n;
  }
  get extras() {
  }
  __internal_setOptions(n) {
    if (this._options === n)
      return;
    this._options = n;
    let r = !1;
    const s = n.adapters?.speech !== void 0;
    this.capabilities.speech !== s && (this.capabilities.speech = s, r = !0);
    const i = n.adapters?.dictation !== void 0;
    this.capabilities.dictation !== i && (this.capabilities.dictation = i, r = !0);
    const a = n.adapters?.attachments !== void 0;
    this.capabilities.attachments !== a && (this.capabilities.attachments = a, r = !0);
    const o = n.adapters?.feedback !== void 0;
    this.capabilities.feedback !== o && (this.capabilities.feedback = o, r = !0), r && this._notifySubscribers();
  }
  __internal_load() {
    if (this._loadPromise)
      return this._loadPromise;
    const n = this.adapters.history?.load() ?? Promise.resolve(null);
    return this._isLoading = !0, this._notifySubscribers(), this._loadPromise = n.then((r) => {
      if (!r)
        return;
      this.repository.import(r), r.messages.length > 0 && this.ensureInitialized(), this._notifySubscribers();
      const s = this.adapters.history?.resume?.bind(this.adapters.history);
      r.unstable_resume && s && this.startRun({
        parentId: this.repository.headId,
        sourceId: this.repository.headId,
        runConfig: this._lastRunConfig
      }, s).catch(() => {
      });
    }).finally(() => {
      this._isLoading = !1, this._notifySubscribers();
    }), this._loadPromise;
  }
  async append(n) {
    this.ensureInitialized();
    const r = this._getInitializePromise?.();
    r && await r;
    const s = wi(n, tr(), {
      type: "complete",
      reason: "unknown"
    });
    this.repository.addOrUpdateMessage(n.parentId, s), this._options.adapters.history?.append({
      parentId: n.parentId,
      message: s,
      ...n.runConfig !== void 0 && { runConfig: n.runConfig }
    }), n.startRun ?? n.role === "user" ? await this.startRun({
      parentId: s.id,
      sourceId: n.sourceId,
      runConfig: n.runConfig ?? {}
    }) : (this.repository.resetHead(s.id), this._notifySubscribers());
  }
  resumeRun({ stream: n, ...r }) {
    if (!n)
      throw new Error("You must pass a stream parameter to resume runs.");
    return this.startRun(r, n);
  }
  exportExternalState() {
    throw new Error("Runtime does not support exporting external states.");
  }
  importExternalState() {
    throw new Error("Runtime does not support importing external states.");
  }
  unstable_loadExternalState() {
    throw new Error("Runtime does not support importing external states.");
  }
  async startRun({ parentId: n, runConfig: r }, s) {
    this.ensureInitialized();
    let a = {
      id: tr(),
      role: "assistant",
      status: { type: "running" },
      content: [],
      metadata: {
        unstable_state: this.state,
        unstable_annotations: [],
        unstable_data: [],
        steps: [],
        custom: {}
      },
      createdAt: /* @__PURE__ */ new Date()
    };
    this._notifyEventSubscribers("runStart");
    try {
      this._suggestions = [], this._suggestionsController?.abort(), this._suggestionsController = null, this._notifySubscribers();
      do
        a = await this.performRoundtrip(n, a, r, s), s = void 0;
      while (nh(a, this._options.unstable_humanToolNames));
    } finally {
      this._notifyEventSubscribers("runEnd");
    }
    this._suggestionsController = new AbortController();
    const o = this._suggestionsController.signal;
    if (this.adapters.suggestion && a.status?.type !== "requires-action") {
      const u = this.adapters.suggestion?.generate({
        messages: this.messages
      });
      if (Symbol.asyncIterator in u)
        for await (const c of u) {
          if (o.aborted)
            break;
          this._suggestions = c, this._notifySubscribers();
        }
      else {
        const c = await u;
        if (o.aborted)
          return;
        this._suggestions = c, this._notifySubscribers();
      }
    }
  }
  async performRoundtrip(n, r, s, i) {
    const a = n ? this.repository.getMessages(n) : [];
    this.abortController?.abort(), this.abortController = new AbortController();
    const o = r.content, u = r.metadata?.unstable_annotations, c = r.metadata?.unstable_data, l = r.metadata?.steps, h = r.metadata?.custom, m = (g) => {
      const _ = g.metadata?.steps, b = _ ? [...l ?? [], ..._] : void 0, T = g.metadata?.unstable_annotations, C = g.metadata?.unstable_data, R = T ? [...u ?? [], ...T] : void 0, D = C ? [...c ?? [], ...C] : void 0;
      r = {
        ...r,
        ...g.content ? { content: [...o, ...g.content ?? []] } : void 0,
        status: g.status ?? r.status,
        ...g.metadata ? {
          metadata: {
            ...r.metadata,
            ...g.metadata.unstable_state ? { unstable_state: g.metadata.unstable_state } : void 0,
            ...R ? { unstable_annotations: R } : void 0,
            ...D ? { unstable_data: D } : void 0,
            ...b ? { steps: b } : void 0,
            ...g.metadata?.timing ? { timing: g.metadata.timing } : void 0,
            ...g.metadata?.custom ? {
              custom: {
                ...h ?? {},
                ...g.metadata.custom
              }
            } : void 0
          }
        } : void 0
      }, this.repository.addOrUpdateMessage(n, r), this._notifySubscribers();
    }, p = this._options.maxSteps ?? 2;
    if ((r.metadata?.steps?.length ?? 0) >= p)
      return m({
        status: {
          type: "incomplete",
          reason: "tool-calls"
        }
      }), r;
    m({
      status: {
        type: "running"
      }
    }), this.repository.resetHead(r.id), this._notifySubscribers();
    try {
      this._lastRunConfig = s ?? {};
      const g = this.getModelContext();
      i = i ?? this.adapters.chatModel.run.bind(this.adapters.chatModel);
      const _ = this.abortController.signal, b = this._getThreadId?.(), T = i({
        messages: a,
        runConfig: this._lastRunConfig,
        abortSignal: _,
        context: g,
        config: g,
        unstable_assistantMessageId: r.id,
        unstable_threadId: b,
        unstable_parentId: n,
        unstable_getMessage() {
          return r;
        }
      });
      if (Symbol.asyncIterator in T)
        for await (const C of T) {
          if (_.aborted) {
            m({
              status: { type: "incomplete", reason: "cancelled" }
            });
            break;
          }
          m(C);
        }
      else
        m(await T);
      r.status.type === "running" && m({
        status: { type: "complete", reason: "unknown" }
      });
    } catch (g) {
      if (g instanceof au)
        m({
          status: { type: "incomplete", reason: "cancelled" }
        });
      else if (g instanceof Error && g.name === "AbortError")
        m({
          status: { type: "incomplete", reason: "cancelled" }
        });
      else
        throw m({
          status: {
            type: "incomplete",
            reason: "error",
            error: g instanceof Error ? g.message : `[${typeof g}] ${new String(g).toString()}`
          }
        }), g;
    } finally {
      this.abortController = null, (r.status.type === "complete" || r.status.type === "incomplete") && await this._options.adapters.history?.append({
        parentId: n,
        message: r,
        runConfig: this._lastRunConfig
      });
    }
    return r;
  }
  detach() {
    const n = new au(!0);
    this.abortController?.abort(n), this.abortController = null;
  }
  cancelRun() {
    const n = new au(!1);
    this.abortController?.abort(n), this.abortController = null;
  }
  addToolResult({ messageId: n, toolCallId: r, result: s, isError: i, artifact: a }) {
    const o = this.repository.getMessage(n), { parentId: u } = o;
    let { message: c } = o;
    if (c.role !== "assistant")
      throw new Error("Tried to add tool result to non-assistant message");
    let l = !1, h = !1;
    const m = c.content.map((p) => p.type !== "tool-call" || p.toolCallId !== r ? p : (h = !0, p.result || (l = !0), {
      ...p,
      result: s,
      artifact: a,
      isError: i
    }));
    if (!h)
      throw new Error("Tried to add tool result to non-existing tool call");
    c = {
      ...c,
      content: m
    }, this.repository.addOrUpdateMessage(u, c), l && nh(c, this._options.unstable_humanToolNames) && this.performRoundtrip(u, c, this._lastRunConfig).catch(() => {
    });
  }
  resumeToolCall(n) {
    throw new Error("Local runtime does not support resuming tool calls.");
  }
}
const rh = Object.freeze([]), oc = "__DEFAULT_ID__", Wy = Object.freeze({
  [oc]: {
    id: oc,
    remoteId: void 0,
    externalId: void 0,
    status: "regular",
    title: void 0
  }
});
class qy extends Si {
  constructor(n) {
    super();
    k(this, "_mainThread");
    this._mainThread = n();
  }
  get isLoading() {
    return !1;
  }
  getMainThreadRuntimeCore() {
    return this._mainThread;
  }
  get newThreadId() {
  }
  get threadIds() {
    return rh;
  }
  get archivedThreadIds() {
    return rh;
  }
  get mainThreadId() {
    return oc;
  }
  get threadItems() {
    return Wy;
  }
  getThreadRuntimeCore() {
    throw new Error("Method not implemented.");
  }
  getLoadThreadsPromise() {
    return Promise.resolve();
  }
  getItemById(n) {
    if (n === this.mainThreadId)
      return {
        status: "regular",
        id: this.mainThreadId,
        remoteId: this.mainThreadId,
        externalId: void 0,
        title: void 0,
        isMain: !0
      };
    throw new Error("Method not implemented");
  }
  async switchToThread() {
    throw new Error("Method not implemented.");
  }
  switchToNewThread() {
    throw new Error("Method not implemented.");
  }
  rename() {
    throw new Error("Method not implemented.");
  }
  archive() {
    throw new Error("Method not implemented.");
  }
  detach() {
    throw new Error("Method not implemented.");
  }
  unarchive() {
    throw new Error("Method not implemented.");
  }
  delete() {
    throw new Error("Method not implemented.");
  }
  initialize(n) {
    return Promise.resolve({ remoteId: n, externalId: void 0 });
  }
  generateTitle() {
    throw new Error("Method not implemented.");
  }
}
class Ky extends el {
  constructor(n, r) {
    super();
    k(this, "threads");
    k(this, "Provider");
    k(this, "_options");
    this._options = n, this.threads = new qy(() => new Gy(this._contextProvider, this._options)), r && this.threads.getMainThreadRuntimeCore().import(tl.fromArray(r));
  }
}
const sh = (e, t, n) => n.reduce((r, s) => s?.(r, t) ?? r, e);
class Qy extends Si {
  constructor(n) {
    super();
    k(this, "_pendingTransforms", []);
    /**
     * `optimistic` callbacks from transforms that have already resolved.
     * Re-applied after every `then` callback so that a wholesale state
     * replacement (e.g. list()) cannot erase earlier completed effects
     * (e.g. delete). Cleared when no pending transforms remain.
     *
     * Correctness requirement: `optimistic` callbacks must be idempotent.
     */
    k(this, "_completedOptimistics", []);
    k(this, "_baseValue");
    k(this, "_cachedValue");
    this._baseValue = n, this._cachedValue = n;
  }
  _updateState() {
    this._cachedValue = this._pendingTransforms.reduce((n, r) => sh(n, r.task, [
      r.loading,
      r.optimistic
    ]), this._baseValue), this._notifySubscribers();
  }
  get baseValue() {
    return this._baseValue;
  }
  get value() {
    return this._cachedValue;
  }
  update(n) {
    this._baseValue = n, this._updateState();
  }
  async optimisticUpdate(n) {
    const r = n.execute(), s = { ...n, task: r };
    try {
      this._pendingTransforms.push(s), this._updateState();
      const i = await r;
      this._baseValue = sh(this._baseValue, i, [
        n.optimistic,
        n.then
      ]);
      for (const a of this._completedOptimistics)
        this._baseValue = a(this._baseValue);
      return n.optimistic && this._completedOptimistics.push(n.optimistic), i;
    } finally {
      const i = this._pendingTransforms.indexOf(s);
      i > -1 && this._pendingTransforms.splice(i, 1), this._pendingTransforms.length === 0 && (this._completedOptimistics.length = 0), this._updateState();
    }
  }
}
const Qe = new Error("This is the empty thread, a placeholder for the main thread. You cannot perform any actions on this thread instance. This error is probably because you tried to call a thread method in your render function. Call the method inside a `useEffect` hook instead."), Xy = {
  getMessageById() {
  },
  getBranches() {
    return [];
  },
  switchToBranch() {
    throw Qe;
  },
  append() {
    throw Qe;
  },
  startRun() {
    throw Qe;
  },
  resumeRun() {
    throw Qe;
  },
  cancelRun() {
    throw Qe;
  },
  addToolResult() {
    throw Qe;
  },
  resumeToolCall() {
    throw Qe;
  },
  speak() {
    throw Qe;
  },
  stopSpeaking() {
    throw Qe;
  },
  submitFeedback() {
    throw Qe;
  },
  getModelContext() {
    return {};
  },
  exportExternalState() {
    throw Qe;
  },
  importExternalState() {
    throw Qe;
  },
  unstable_loadExternalState() {
    throw Qe;
  },
  composer: {
    attachments: [],
    attachmentAccept: "*",
    async addAttachment(e) {
      throw Qe;
    },
    async removeAttachment() {
      throw Qe;
    },
    isEditing: !0,
    canCancel: !1,
    isEmpty: !0,
    text: "",
    setText() {
      throw Qe;
    },
    role: "user",
    setRole() {
      throw Qe;
    },
    runConfig: {},
    setRunConfig() {
      throw Qe;
    },
    async reset() {
    },
    async clearAttachments() {
    },
    send() {
      throw Qe;
    },
    cancel() {
    },
    dictation: void 0,
    startDictation() {
      throw Qe;
    },
    stopDictation() {
    },
    quote: void 0,
    setQuote() {
      throw Qe;
    },
    subscribe() {
      return () => {
      };
    },
    unstable_on() {
      return () => {
      };
    }
  },
  getEditComposer() {
  },
  beginEdit() {
    throw Qe;
  },
  speech: void 0,
  capabilities: {
    switchToBranch: !1,
    switchBranchDuringRun: !1,
    edit: !1,
    reload: !1,
    cancel: !1,
    unstable_copy: !1,
    speech: !1,
    dictation: !1,
    attachments: !1,
    feedback: !1,
    queue: !1
  },
  isDisabled: !1,
  isLoading: !1,
  messages: [],
  state: null,
  suggestions: [],
  extras: void 0,
  subscribe() {
    return () => {
    };
  },
  import() {
    throw Qe;
  },
  export() {
    return { messages: [] };
  },
  reset() {
    throw Qe;
  },
  unstable_on() {
    return () => {
    };
  }
};
const Ws = (e, t) => {
  const n = e.threadIdMap[t];
  if (n !== void 0)
    return e.threadData[n];
}, qi = (e, t, n) => {
  const r = Ws(e, t);
  if (!r)
    return e;
  const { id: s, remoteId: i, status: a } = r;
  if (a === n)
    return e;
  const o = { ...e };
  switch (a) {
    case "new":
      o.newThreadId = void 0;
      break;
    case "regular":
      o.threadIds = o.threadIds.filter((u) => u !== s);
      break;
    case "archived":
      o.archivedThreadIds = o.archivedThreadIds.filter((u) => u !== s);
      break;
    default: {
      const u = a;
      throw new Error(`Unsupported state: ${u}`);
    }
  }
  switch (n) {
    case "regular":
      o.threadIds = [s, ...o.threadIds];
      break;
    case "archived":
      o.archivedThreadIds = [s, ...o.archivedThreadIds];
      break;
    case "deleted":
      o.threadData = Object.fromEntries(Object.entries(o.threadData).filter(([u]) => u !== s)), o.threadIdMap = Object.fromEntries(Object.entries(o.threadIdMap).filter(([u]) => u !== s && u !== i));
      break;
    default: {
      const u = n;
      throw new Error(`Unsupported state: ${u}`);
    }
  }
  return n !== "deleted" && (o.threadData = {
    ...o.threadData,
    [s]: {
      ...r,
      status: n
    }
  }), o;
};
class Jy extends Si {
  constructor(n, r) {
    super();
    k(this, "useRuntimeHook");
    k(this, "instances", /* @__PURE__ */ new Map());
    k(this, "useAliveThreadsKeysChanged", ls(() => ({})));
    k(this, "parent");
    k(this, "_InnerActiveThreadProvider", ({ threadId: n }) => {
      const { useRuntime: r } = this.useRuntimeHook(), s = r(), i = s.thread.__internal_threadBinding, a = ne(() => {
        const l = this.instances.get(n);
        if (!l)
          throw new Error("Thread not found. This is a bug in assistant-ui.");
        l.runtime = i.getState(), this._notifySubscribers();
      }, [n, i]), o = Ke(!1);
      o.current || a(), _e(() => (o.current = !0, a(), i.outerSubscribe(a)), [i, a]);
      const u = Re(), c = Ke(void 0);
      return _e(() => {
        const l = i.getState(), h = l.__internal_setGetInitializePromise;
        typeof h == "function" && h.call(l, () => c.current);
      }, [i]), _e(() => s.threads.main.unstable_on("initialize", () => {
        if (u.threadListItem().getState().status === "new") {
          c.current = u.threadListItem().initialize();
          const h = s.thread.unstable_on("runEnd", () => {
            h(), u.threadListItem().generateTitle();
          });
        }
      }), [s, u]), null;
    });
    k(this, "_OuterActiveThreadProvider", de(({ threadId: n, provider: r }) => {
      const s = se(() => new Zm(this.parent).getItemById(n), [n]);
      return d.jsx(my, { runtime: s, children: d.jsx(r, { children: d.jsx(this._InnerActiveThreadProvider, { threadId: n }) }) });
    }));
    k(this, "__internal_RenderThreadRuntimes", ({ provider: n }) => (this.useAliveThreadsKeysChanged(), Array.from(this.instances.keys()).map((r) => d.jsx(this._OuterActiveThreadProvider, { threadId: r, provider: n }, r))));
    this.parent = r, this.useRuntimeHook = ls(() => ({ useRuntime: n }));
  }
  startThreadRuntime(n) {
    return this.instances.has(n) || (this.instances.set(n, {}), this.useAliveThreadsKeysChanged.setState({}, !0)), new Promise((r, s) => {
      const i = () => {
        const o = this.instances.get(n);
        if (!o)
          a(), s(new Error("Thread was deleted before runtime was started"));
        else if (o.runtime)
          a(), r(o.runtime);
        else
          return;
      }, a = this.subscribe(i);
      i();
    });
  }
  getThreadRuntimeCore(n) {
    const r = this.instances.get(n);
    if (r)
      return r.runtime;
  }
  stopThreadRuntime(n) {
    this.instances.delete(n), this.useAliveThreadsKeysChanged.setState({}, !0);
  }
  setRuntimeHook(n) {
    this.useRuntimeHook.getState().useRuntime !== n && this.useRuntimeHook.setState({ useRuntime: n }, !0);
  }
}
class Zy extends Si {
  constructor(n, r) {
    super();
    k(this, "_options");
    k(this, "_hookManager");
    k(this, "_loadThreadsPromise");
    k(this, "_mainThreadId");
    k(this, "_state", new Qy({
      isLoading: !1,
      newThreadId: void 0,
      threadIds: [],
      archivedThreadIds: [],
      threadIdMap: {},
      threadData: {}
    }));
    k(this, "contextProvider");
    k(this, "useProvider");
    k(this, "initialize", async (n) => {
      if (this._state.value.newThreadId !== n) {
        const r = this.getItemById(n);
        if (!r)
          throw new Error("Thread not found");
        if (r.status === "new")
          throw new Error("Unexpected new state");
        return r.initializeTask;
      }
      return this._state.optimisticUpdate({
        execute: () => this._options.adapter.initialize(n),
        optimistic: (r) => qi(r, n, "regular"),
        loading: (r, s) => {
          const i = n;
          return {
            ...r,
            threadData: {
              ...r.threadData,
              [i]: {
                ...r.threadData[i],
                initializeTask: s
              }
            }
          };
        },
        then: (r, { remoteId: s, externalId: i }) => {
          const a = Ws(r, n);
          if (!a)
            return r;
          const o = n;
          return {
            ...r,
            threadIdMap: {
              ...r.threadIdMap,
              [s]: o
            },
            threadData: {
              ...r.threadData,
              [o]: {
                ...a,
                initializeTask: Promise.resolve({ remoteId: s, externalId: i }),
                remoteId: s,
                externalId: i
              }
            }
          };
        }
      });
    });
    k(this, "generateTitle", async (n) => {
      const r = this.getItemById(n);
      if (!r)
        throw new Error("Thread not found");
      if (r.status === "new")
        throw new Error("Thread is not yet initialized");
      const { remoteId: s } = await r.initializeTask, i = this._hookManager.getThreadRuntimeCore(r.id);
      if (!i)
        return;
      const a = i.messages, o = await this._options.adapter.generateTitle(s, a), u = ei.fromAssistantStream(o);
      for await (const c of u) {
        const l = c.parts.filter((p) => p.type === "text")[0]?.text, h = this._state.baseValue, m = Ws(h, r.id);
        m && this._state.update({
          ...h,
          threadData: {
            ...h.threadData,
            [m.id]: {
              ...m,
              title: l
            }
          }
        });
      }
    });
    k(this, "useBoundIds", ls(() => []));
    k(this, "__internal_RenderComponent", () => {
      const n = r1();
      _e(() => (this.useBoundIds.setState((a) => [...a, n], !0), () => {
        this.useBoundIds.setState((a) => a.filter((o) => o !== n), !0);
      }), [n]);
      const r = this.useBoundIds(), { Provider: s } = this.useProvider(), i = {
        modelContext: this.contextProvider
      };
      return (r.length === 0 || r[0] === n) && // only render if the component is the first one mounted
      d.jsx(rl, { adapters: i, children: d.jsx(this._hookManager.__internal_RenderThreadRuntimes, { provider: s }) });
    });
    this.contextProvider = r, this._state.subscribe(() => this._notifySubscribers()), this._hookManager = new Jy(n.runtimeHook, this), this.useProvider = ls(() => ({
      Provider: n.adapter.unstable_Provider ?? Pd
    })), this.__internal_setOptions(n), this.switchToNewThread();
  }
  get threadItems() {
    return this._state.value.threadData;
  }
  getLoadThreadsPromise() {
    return this._loadThreadsPromise || (this._loadThreadsPromise = this._state.optimisticUpdate({
      execute: () => this._options.adapter.list(),
      loading: (n) => ({
        ...n,
        isLoading: !0
      }),
      then: (n, r) => {
        const s = [], i = [], a = {}, o = {};
        for (const u of r.threads) {
          switch (u.status) {
            case "regular":
              s.push(u.remoteId);
              break;
            case "archived":
              i.push(u.remoteId);
              break;
            default: {
              const l = u.status;
              throw new Error(`Unsupported state: ${l}`);
            }
          }
          const c = u.remoteId;
          a[u.remoteId] = c, o[c] = {
            id: u.remoteId,
            remoteId: u.remoteId,
            externalId: u.externalId,
            status: u.status,
            title: u.title,
            initializeTask: Promise.resolve({
              remoteId: u.remoteId,
              externalId: u.externalId
            })
          };
        }
        return {
          ...n,
          threadIds: s,
          archivedThreadIds: i,
          threadIdMap: {
            ...n.threadIdMap,
            ...a
          },
          threadData: {
            ...n.threadData,
            ...o
          }
        };
      }
    }).then(() => {
    })), this._loadThreadsPromise;
  }
  __internal_setOptions(n) {
    if (this._options === n)
      return;
    this._options = n;
    const r = n.adapter.unstable_Provider ?? Pd;
    r !== this.useProvider.getState().Provider && this.useProvider.setState({ Provider: r }, !0), this._hookManager.setRuntimeHook(n.runtimeHook);
  }
  __internal_load() {
    this.getLoadThreadsPromise();
  }
  get isLoading() {
    return this._state.value.isLoading;
  }
  get threadIds() {
    return this._state.value.threadIds;
  }
  get archivedThreadIds() {
    return this._state.value.archivedThreadIds;
  }
  get newThreadId() {
    return this._state.value.newThreadId;
  }
  get mainThreadId() {
    return this._mainThreadId;
  }
  getMainThreadRuntimeCore() {
    const n = this._hookManager.getThreadRuntimeCore(this._mainThreadId);
    return n || Xy;
  }
  getThreadRuntimeCore(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    const s = this._hookManager.getThreadRuntimeCore(r.id);
    if (!s)
      throw new Error("Thread not found");
    return s;
  }
  getItemById(n) {
    return Ws(this._state.value, n);
  }
  async switchToThread(n) {
    let r = this.getItemById(n);
    if (!r) {
      const i = await this._options.adapter.fetch(n), a = this._state.value, o = i.remoteId, u = {
        ...a.threadData,
        [o]: {
          id: o,
          initializeTask: Promise.resolve({
            remoteId: i.remoteId,
            externalId: i.externalId
          }),
          remoteId: i.remoteId,
          externalId: i.externalId,
          status: i.status,
          title: i.title
        }
      }, c = {
        ...a.threadIdMap,
        [i.remoteId]: o
      }, l = i.status === "regular" ? [...a.threadIds, i.remoteId] : a.threadIds, h = i.status === "archived" ? [...a.archivedThreadIds, i.remoteId] : a.archivedThreadIds;
      this._state.update({
        ...a,
        threadIds: l,
        archivedThreadIds: h,
        threadIdMap: c,
        threadData: u
      }), r = this.getItemById(n);
    }
    if (!r)
      throw new Error("Thread not found");
    if (this._mainThreadId === r.id)
      return;
    const s = this._hookManager.startThreadRuntime(r.id);
    this.mainThreadId !== void 0 ? await s : s.then(() => this._notifySubscribers()), r.status === "archived" && await this.unarchive(r.id), this._mainThreadId = r.id, this._notifySubscribers();
  }
  async switchToNewThread() {
    for (; this._state.baseValue.newThreadId !== void 0 && this._state.value.newThreadId === void 0; )
      await this._state.waitForUpdate();
    const n = this._state.value;
    let r = this._state.value.newThreadId;
    if (r === void 0) {
      do
        r = `__LOCALID_${tr()}`;
      while (n.threadIdMap[r]);
      const s = r;
      this._state.update({
        ...n,
        newThreadId: r,
        threadIdMap: {
          ...n.threadIdMap,
          [r]: s
        },
        threadData: {
          ...n.threadData,
          [s]: {
            status: "new",
            id: r,
            remoteId: void 0,
            externalId: void 0,
            title: void 0
          }
        }
      });
    }
    return this.switchToThread(r);
  }
  rename(n, r) {
    const s = this.getItemById(n);
    if (!s)
      throw new Error("Thread not found");
    if (s.status === "new")
      throw new Error("Thread is not yet initialized");
    return this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: i } = await s.initializeTask;
        return this._options.adapter.rename(i, r);
      },
      optimistic: (i) => {
        const a = Ws(i, n);
        return a ? {
          ...i,
          threadData: {
            ...i.threadData,
            [a.id]: {
              ...a,
              title: r
            }
          }
        } : i;
      }
    });
  }
  async _ensureThreadIsNotMain(n) {
    if (n === this.newThreadId)
      throw new Error("Cannot ensure new thread is not main");
    n === this._mainThreadId && await this.switchToNewThread();
  }
  async archive(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular")
      throw new Error("Thread is not yet initialized or already archived");
    return await this._ensureThreadIsNotMain(r.id), this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: s } = await r.initializeTask;
        return this._options.adapter.archive(s);
      },
      optimistic: (s) => qi(s, r.id, "archived")
    });
  }
  unarchive(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "archived")
      throw new Error("Thread is not archived");
    return this._state.optimisticUpdate({
      execute: async () => {
        try {
          const { remoteId: s } = await r.initializeTask;
          return await this._options.adapter.unarchive(s);
        } catch (s) {
          throw await this._ensureThreadIsNotMain(r.id), s;
        }
      },
      optimistic: (s) => qi(s, r.id, "regular")
    });
  }
  async delete(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular" && r.status !== "archived")
      throw new Error("Thread is not yet initialized");
    return await this._ensureThreadIsNotMain(r.id), this._hookManager.stopThreadRuntime(r.id), this._state.optimisticUpdate({
      execute: async () => {
        const { remoteId: s } = await r.initializeTask;
        return await this._options.adapter.delete(s);
      },
      optimistic: (s) => qi(s, r.id, "deleted")
    });
  }
  async detach(n) {
    const r = this.getItemById(n);
    if (!r)
      throw new Error("Thread not found");
    if (r.status !== "regular" && r.status !== "archived")
      throw new Error("Thread is not yet initialized");
    await this._ensureThreadIsNotMain(r.id), this._hookManager.stopThreadRuntime(r.id);
  }
}
class ex extends el {
  constructor(n) {
    super();
    k(this, "threads");
    this.threads = new Zy(n, this._contextProvider);
  }
  get RenderComponent() {
    return this.threads.__internal_RenderComponent;
  }
}
const tx = (e) => {
  const [t] = ce(() => new ex(e));
  return _e(() => {
    t.threads.__internal_setOptions(e), t.threads.__internal_load();
  }, [t, e]), se(() => new nl(t), [t]);
}, tg = (e) => {
  const t = Ke(e.runtimeHook);
  t.current = e.runtimeHook;
  const n = ne(() => t.current(), []), r = se(() => ({
    adapter: e.adapter,
    allowNesting: e.allowNesting,
    runtimeHook: n
  }), [e.adapter, e.allowNesting, n]);
  if (Re().threadListItem.source !== null) {
    if (!r.allowNesting)
      throw new Error("useRemoteThreadListRuntime cannot be nested inside another RemoteThreadListRuntime. Set allowNesting: true to allow nesting (the inner runtime will become a no-op).");
    return n();
  }
  return tx(r);
}, ih = (e) => {
  try {
    const n = e.split(".")[1];
    if (!n)
      throw new Error("Invalid JWT format");
    let r = n.replace(/-/g, "+").replace(/_/g, "/");
    for (; r.length % 4 !== 0; )
      r += "=";
    const s = atob(r), a = JSON.parse(s).exp;
    if (!a || typeof a != "number")
      throw new Error('JWT does not contain a valid "exp" field');
    return a * 1e3;
  } catch (t) {
    throw new Error(`Unable to determine the token expiry: ${t}`);
  }
};
var Ai;
class ng {
  constructor(t) {
    k(this, "strategy", "jwt");
    k(this, "cachedToken", null);
    k(this, "tokenExpiry", null);
    Ps(this, Ai);
    Os(this, Ai, t);
  }
  async getAuthHeaders() {
    const t = Date.now();
    if (this.cachedToken && this.tokenExpiry && this.tokenExpiry - t > 30 * 1e3)
      return { Authorization: `Bearer ${this.cachedToken}` };
    const n = await Rs(this, Ai).call(this);
    return n ? (this.cachedToken = n, this.tokenExpiry = ih(n), { Authorization: `Bearer ${n}` }) : !1;
  }
  readAuthHeaders(t) {
    const n = t.get("Authorization");
    if (!n)
      return;
    const [r, s] = n.split(" ");
    if (r !== "Bearer" || !s)
      throw new Error("Invalid auth header received");
    this.cachedToken = s, this.tokenExpiry = ih(s);
  }
}
Ai = new WeakMap();
var yi, xi, Ci;
class nx {
  constructor(t, n, r) {
    k(this, "strategy", "api-key");
    Ps(this, yi);
    Ps(this, xi);
    Ps(this, Ci);
    Os(this, yi, t), Os(this, xi, n), Os(this, Ci, r);
  }
  async getAuthHeaders() {
    return {
      Authorization: `Bearer ${Rs(this, yi)}`,
      "Aui-User-Id": Rs(this, xi),
      "Aui-Workspace-Id": Rs(this, Ci)
    };
  }
  readAuthHeaders() {
  }
}
yi = new WeakMap(), xi = new WeakMap(), Ci = new WeakMap();
const Ki = "aui:refresh_token";
class rx {
  constructor(t) {
    k(this, "strategy", "anon");
    k(this, "baseUrl");
    k(this, "jwtStrategy");
    this.baseUrl = t, this.jwtStrategy = new ng(async () => {
      const n = Date.now(), r = localStorage.getItem(Ki), s = r ? JSON.parse(r) : void 0;
      if (s)
        if (new Date(s.expires_at).getTime() - n > 30 * 1e3) {
          const l = await fetch(`${this.baseUrl}/v1/auth/tokens/refresh`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ refresh_token: s.token })
          });
          if (l.ok) {
            const h = await l.json(), { access_token: m, refresh_token: p } = h;
            return p && localStorage.setItem(Ki, JSON.stringify(p)), m;
          }
        } else
          localStorage.removeItem(Ki);
      const i = await fetch(`${this.baseUrl}/v1/auth/tokens/anonymous`, {
        method: "POST"
      });
      if (!i.ok)
        return null;
      const a = await i.json(), { access_token: o, refresh_token: u } = a;
      return !o || !u ? null : (localStorage.setItem(Ki, JSON.stringify(u)), o);
    });
  }
  async getAuthHeaders() {
    return this.jwtStrategy.getAuthHeaders();
  }
  readAuthHeaders(t) {
    this.jwtStrategy.readAuthHeaders(t);
  }
}
class ah extends Error {
  constructor(t) {
    super(t), this.name = "APIError";
  }
}
class sx {
  constructor(t) {
    k(this, "_auth");
    k(this, "_baseUrl");
    if ("authToken" in t)
      this._baseUrl = t.baseUrl, this._auth = new ng(t.authToken);
    else if ("apiKey" in t)
      this._baseUrl = "https://backend.assistant-api.com", this._auth = new nx(t.apiKey, t.userId, t.workspaceId);
    else if ("anonymous" in t)
      this._baseUrl = t.baseUrl, this._auth = new rx(t.baseUrl);
    else
      throw new Error("Invalid configuration: Must provide authToken, apiKey, or anonymous configuration");
  }
  async initializeAuth() {
    return !!this._auth.getAuthHeaders();
  }
  async makeRawRequest(t, n = {}) {
    const r = await this._auth.getAuthHeaders();
    if (!r)
      throw new Error("Authorization failed");
    const s = {
      ...r,
      ...n.headers,
      "Content-Type": "application/json"
    }, i = new URLSearchParams();
    if (n.query)
      for (const [u, c] of Object.entries(n.query))
        c !== !1 && (c === !0 ? i.set(u, "true") : i.set(u, c.toString()));
    const a = new URL(`${this._baseUrl}/v1${t}`);
    a.search = i.toString();
    const o = await fetch(a, {
      method: n.method ?? "GET",
      headers: s,
      body: n.body ? JSON.stringify(n.body) : null
    });
    if (this._auth.readAuthHeaders(o.headers), !o.ok) {
      const u = await o.text();
      try {
        const c = JSON.parse(u);
        throw new ah(c.message);
      } catch (c) {
        throw c instanceof ah ? c : new Error(`Request failed with status ${o.status}, ${u}`);
      }
    }
    return o;
  }
  async makeRequest(t, n = {}) {
    return (await this.makeRawRequest(t, n)).json();
  }
}
class ix {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  async create() {
    return this.cloud.makeRequest("/auth/tokens", { method: "POST" });
  }
}
class ax {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  __internal_getAssistantOptions(t) {
    return {
      api: `${this.cloud._baseUrl}/v1/runs/stream`,
      headers: async () => {
        const n = await this.cloud._auth.getAuthHeaders();
        if (!n)
          throw new Error("Authorization failed");
        return {
          ...n,
          Accept: "text/plain"
        };
      },
      body: {
        assistant_id: t,
        response_format: "vercel-ai-data-stream/v1",
        thread_id: "unstable_todo"
      }
    };
  }
  async stream(t) {
    const n = await this.cloud.makeRawRequest("/runs/stream", {
      method: "POST",
      headers: {
        Accept: "text/plain"
      },
      body: t
    });
    return sc.fromResponse(n, new ry());
  }
  async report(t) {
    return this.cloud.makeRequest("/runs", { method: "POST", body: t });
  }
}
class ox {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  async list(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages`, { query: n });
  }
  async create(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages`, { method: "POST", body: n });
  }
  async update(t, n, r) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}/messages/${encodeURIComponent(n)}`, { method: "PUT", body: r });
  }
}
class ux {
  constructor(t) {
    k(this, "cloud");
    k(this, "messages");
    this.cloud = t, this.messages = new ox(t);
  }
  async list(t) {
    return this.cloud.makeRequest("/threads", { query: t });
  }
  async get(t) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`);
  }
  async create(t) {
    return this.cloud.makeRequest("/threads", { method: "POST", body: t });
  }
  async update(t, n) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`, {
      method: "PUT",
      body: n
    });
  }
  async delete(t) {
    return this.cloud.makeRequest(`/threads/${encodeURIComponent(t)}`, {
      method: "DELETE"
    });
  }
}
class cx {
  constructor(t) {
    k(this, "cloud");
    this.cloud = t;
  }
  async pdfToImages(t) {
    return this.cloud.makeRequest("/files/pdf-to-images", {
      method: "POST",
      body: t
    });
  }
  async generatePresignedUploadUrl(t) {
    return this.cloud.makeRequest("/files/attachments/generate-presigned-upload-url", {
      method: "POST",
      body: t
    });
  }
}
class lx {
  constructor(t) {
    k(this, "threads");
    k(this, "auth");
    k(this, "runs");
    k(this, "files");
    k(this, "telemetry");
    const n = new sx(t);
    this.threads = new ux(n), this.auth = {
      tokens: new ix(n)
    }, this.runs = new ax(n), this.files = new cx(n);
    const r = t.telemetry;
    this.telemetry = r === !1 ? { enabled: !1 } : r === !0 || r === void 0 ? { enabled: !0 } : { enabled: r.enabled !== !1, ...r };
  }
}
class dx {
  constructor(t) {
    k(this, "cloud");
    k(this, "idMapping", {});
    this.cloud = t;
  }
  /**
   * Persist a message to the cloud.
   *
   * @param threadId - Remote thread ID
   * @param messageId - Local message ID (used for tracking)
   * @param parentId - Local parent message ID (or null for first message)
   * @param format - Message format (e.g., "aui/v0", "ai-sdk/v6")
   * @param content - Message content (format-specific)
   */
  async append(t, n, r, s, i) {
    const a = r ? await this.idMapping[r] ?? r : null, o = this.cloud.threads.messages.create(t, {
      parent_id: a,
      format: s,
      content: i
    }).then(({ message_id: u }) => (this.idMapping[n] = u, u)).catch((u) => {
      throw this.idMapping[n] === o && delete this.idMapping[n], u;
    });
    return this.idMapping[n] = o, o.then(() => {
    });
  }
  /**
   * Update an already-persisted message in the cloud.
   */
  async update(t, n, r, s) {
    const i = await this.getRemoteId(n);
    i && await this.cloud.threads.messages.update(t, i, { content: s });
  }
  /**
   * Check if a message has been persisted (or is currently being persisted).
   */
  isPersisted(t) {
    return t in this.idMapping;
  }
  /**
   * Get the remote ID for a local message ID (resolved).
   * Returns undefined if not persisted.
   */
  async getRemoteId(t) {
    const n = this.idMapping[t];
    if (n)
      return n;
  }
  /**
   * Load messages from the cloud and populate the ID mapping.
   *
   * The ID mapping is populated so that `isPersisted()` returns true for
   * loaded messages, preventing re-persistence of already-stored messages.
   *
   * @param threadId - Remote thread ID
   * @param format - Optional format filter
   * @returns Array of cloud messages
   */
  async load(t, n) {
    const { messages: r } = await this.cloud.threads.messages.list(t, n ? { format: n } : void 0);
    for (const s of r)
      this.idMapping[s.id] = s.id;
    return r;
  }
  /**
   * Reset the ID mapping (call when switching threads).
   */
  reset() {
    this.idMapping = {};
  }
}
const hx = (e, t) => ({
  append: async (n, r) => {
    const s = t.getId(r.message), i = t.encode(r);
    return e.append(n, s, r.parentId, t.format, i);
  },
  update: e.update ? async (n, r, s) => {
    const i = t.encode(r);
    return e.update(n, s, t.format, i);
  } : void 0,
  load: async (n) => ({
    messages: (await e.load(n, t.format)).filter((s) => s.format === t.format).map((s) => t.decode({
      id: s.id,
      parent_id: s.parent_id,
      format: s.format,
      content: s.content
    })).reverse()
  }),
  isPersisted: (n) => e.isPersisted(n)
});
class fx {
  list() {
    return Promise.resolve({
      threads: []
    });
  }
  rename() {
    return Promise.resolve();
  }
  archive() {
    return Promise.resolve();
  }
  unarchive() {
    return Promise.resolve();
  }
  delete() {
    return Promise.resolve();
  }
  initialize(t) {
    return Promise.resolve({ remoteId: t, externalId: void 0 });
  }
  generateTitle() {
    return Promise.resolve(new ReadableStream());
  }
  fetch(t) {
    return Promise.reject(new Error("Thread not found"));
  }
}
function px(e) {
  const t = e.status?.type === "running" ? { type: "incomplete", reason: "cancelled" } : e.status;
  return {
    role: e.role,
    content: e.content.map((n) => {
      const r = n.type;
      switch (r) {
        case "text":
          return { type: "text", text: n.text };
        case "reasoning":
          return { type: "reasoning", text: n.text };
        case "source":
          return {
            type: "source",
            sourceType: n.sourceType,
            id: n.id,
            url: n.url,
            ...n.title ? { title: n.title } : void 0
          };
        case "tool-call":
          return ac(n.result) || console.warn(`tool-call result is not JSON! ${JSON.stringify(n)}`), {
            type: "tool-call",
            toolCallId: n.toolCallId,
            toolName: n.toolName,
            ...JSON.stringify(n.args) === n.argsText ? { args: n.args } : { argsText: n.argsText },
            ...n.result ? { result: n.result } : void 0,
            ...n.isError ? { isError: !0 } : void 0
          };
        case "image":
          return { type: "image", image: n.image };
        case "file":
          return {
            type: "file",
            data: n.data,
            mimeType: n.mimeType,
            ...n.filename ? { filename: n.filename } : void 0
          };
        default: {
          const s = r;
          throw new Error(`Message part type not supported by aui/v0: ${s}`);
        }
      }
    }),
    metadata: e.metadata,
    ...t ? { status: t } : void 0
  };
}
function mx(e) {
  const t = e.content, n = wi({
    id: e.id,
    createdAt: e.created_at,
    ...t
  }, e.id, { type: "complete", reason: "unknown" });
  return {
    parentId: e.parent_id,
    message: n
  };
}
const ou = /* @__PURE__ */ new WeakMap();
class gx {
  constructor(t, n) {
    k(this, "cloudRef");
    k(this, "aui");
    this.cloudRef = t, this.aui = n;
  }
  get _persistence() {
    const t = this.aui.threadListItem();
    return ou.has(t) || ou.set(t, new dx(this.cloudRef.current)), ou.get(t);
  }
  withFormat(t) {
    const n = this, r = hx(this._persistence, t);
    return {
      // Note: callers must also call reportTelemetry() for run tracking
      async append(s) {
        const { remoteId: i } = await n.aui.threadListItem().initialize();
        await r.append(i, s);
      },
      async update(s, i) {
        const a = n.aui.threadListItem().getState().remoteId;
        a && await r.update?.(a, s, i);
      },
      reportTelemetry(s, i) {
        const a = s.map((o) => t.encode(o));
        n._reportRunTelemetry(t.format, a, i);
      },
      async load() {
        const s = n.aui.threadListItem().getState().remoteId;
        return s ? r.load(s) : { messages: [] };
      }
    };
  }
  async append({ parentId: t, message: n }) {
    const { remoteId: r } = await this.aui.threadListItem().initialize(), s = px(n);
    await this._persistence.append(r, n.id, t, "aui/v0", s), this.cloudRef.current.telemetry.enabled && this._maybeReportRun(r, "aui/v0", s);
  }
  async load() {
    const t = this.aui.threadListItem().getState().remoteId;
    return t ? {
      messages: (await this._persistence.load(t, "aui/v0")).filter((r) => r.format === "aui/v0").map(mx).reverse()
    } : { messages: [] };
  }
  _reportRunTelemetry(t, n, r) {
    if (!this.cloudRef.current.telemetry.enabled)
      return;
    const s = this.aui.threadListItem().getState().remoteId;
    if (!s)
      return;
    const i = Tx(t, n);
    i && this._sendReport(s, i, r?.durationMs, r?.stepTimestamps);
  }
  _maybeReportRun(t, n, r) {
    const s = sg(n, r);
    s && this._sendReport(t, s);
  }
  _sendReport(t, n, r, s) {
    const i = _x(n.steps, s), a = {
      thread_id: t,
      status: n.status,
      ...n.totalSteps != null ? { total_steps: n.totalSteps } : void 0,
      ...n.toolCalls ? { tool_calls: n.toolCalls } : void 0,
      ...i ? { steps: i } : void 0,
      ...n.inputTokens != null ? { input_tokens: n.inputTokens } : void 0,
      ...n.outputTokens != null ? { output_tokens: n.outputTokens } : void 0,
      ...n.reasoningTokens != null ? { reasoning_tokens: n.reasoningTokens } : void 0,
      ...n.cachedInputTokens != null ? { cached_input_tokens: n.cachedInputTokens } : void 0,
      ...r != null ? { duration_ms: r } : void 0,
      ...n.outputText != null ? { output_text: n.outputText } : void 0,
      ...n.metadata ? { metadata: n.metadata } : void 0,
      ...n.modelId ? { model_id: n.modelId } : void 0
    }, { beforeReport: o } = this.cloudRef.current.telemetry, u = o ? o(a) : a;
    u && this.cloudRef.current.runs.report(u).catch(() => {
    });
  }
}
const oh = 5e4;
function po(e) {
  return e.length <= oh ? e : e.slice(0, oh);
}
function uc(e) {
  if (e != null)
    try {
      return po(JSON.stringify(e));
    } catch {
      return;
    }
}
const Ex = /^[A-Za-z0-9+/]{100,}={0,2}$/;
function bx(e) {
  if (e != null) {
    try {
      const t = typeof e == "string" ? JSON.parse(e) : e;
      if (Array.isArray(t)) {
        const n = t.map((r) => {
          if (r && typeof r == "object" && r.type && (r.type === "image" || r.type === "audio") && typeof r.data == "string" && Ex.test(r.data.slice(0, 200))) {
            const s = (r.data.length * 3 / 4 / 1024).toFixed(1);
            return { ...r, data: `[${r.type}: ${s}KB]` };
          }
          return r;
        });
        return po(JSON.stringify(n));
      }
    } catch {
    }
    return uc(e);
  }
}
function rg(e, t, n, r, s, i) {
  const a = {
    tool_name: e,
    tool_call_id: t
  }, o = s ?? uc(n);
  o !== void 0 && (a.tool_args = o);
  const u = i === "mcp" ? bx(r) : uc(r);
  return u !== void 0 && (a.tool_result = u), i && (a.tool_source = i), a;
}
function _x(e, t) {
  if (!t)
    return e;
  if (!e)
    return t.map((r) => ({ ...r }));
  const n = Math.min(e.length, t.length);
  return e.map((r, s) => ({
    ...r,
    ...s < n ? t[s] : void 0
  }));
}
function sg(e, t) {
  switch (e) {
    case "aui/v0":
      return yx(t);
    case "ai-sdk/v6":
      return Ix(t);
    default:
      return null;
  }
}
function Tx(e, t) {
  if (e === "ai-sdk/v6")
    return vx(t);
  for (let n = t.length - 1; n >= 0; n--) {
    const r = sg(e, t[n]);
    if (r)
      return r;
  }
  return null;
}
const Ax = {
  error: "error",
  incomplete: "incomplete"
};
function yx(e) {
  const t = e;
  if (t.role !== "assistant")
    return null;
  const n = t.content?.filter((g) => g.type === "tool-call" && g.toolName && g.toolCallId).map((g) => rg(g.toolName, g.toolCallId, g.args, g.result, g.argsText)), r = t.content?.filter((g) => g.type === "text" && g.text), s = r && r.length > 0 ? po(r.map((g) => g.text).join("")) : void 0, i = t.metadata?.steps;
  let a, o, u, c;
  if (i && i.length > 0) {
    let g = 0, _ = 0, b = 0, T = 0, C = !1, R = !1, D = !1, w = !1;
    for (const O of i)
      O.usage?.inputTokens != null && (g += O.usage.inputTokens, C = !0), O.usage?.outputTokens != null && (_ += O.usage.outputTokens, R = !0), O.usage?.reasoningTokens != null && (b += O.usage.reasoningTokens, D = !0), O.usage?.cachedInputTokens != null && (T += O.usage.cachedInputTokens, w = !0);
    a = C ? g : void 0, o = R ? _ : void 0, u = D ? b : void 0, c = w ? T : void 0;
  }
  const l = t.status?.type, h = l && Ax[l] || "completed", m = t.metadata?.custom, p = t.metadata?.modelId ?? (typeof t.metadata?.custom?.modelId == "string" ? t.metadata.custom.modelId : void 0), E = i && i.length > 1 ? i.map((g) => ({
    ...g.usage?.inputTokens != null ? { input_tokens: g.usage.inputTokens } : void 0,
    ...g.usage?.outputTokens != null ? { output_tokens: g.usage.outputTokens } : void 0,
    ...g.usage?.reasoningTokens != null ? { reasoning_tokens: g.usage.reasoningTokens } : void 0,
    ...g.usage?.cachedInputTokens != null ? { cached_input_tokens: g.usage.cachedInputTokens } : void 0
  })) : void 0;
  return {
    status: h,
    ...n && n.length > 0 ? { toolCalls: n } : void 0,
    ...i?.length ? { totalSteps: i.length } : void 0,
    ...a != null ? { inputTokens: a } : void 0,
    ...o != null ? { outputTokens: o } : void 0,
    ...u != null ? { reasoningTokens: u } : void 0,
    ...c != null ? { cachedInputTokens: c } : void 0,
    ...s != null ? { outputText: s } : void 0,
    ...m ? { metadata: m } : void 0,
    ...E ? { steps: E } : void 0,
    ...p ? { modelId: p } : void 0
  };
}
function xx(e) {
  return e.toolCallId ? e.type === "tool-call" || e.type === "dynamic-tool" ? !!e.toolName : e.type.startsWith("tool-") || e.type.startsWith("dynamic-tool-") : !1;
}
function Cx(e) {
  return e.type === "dynamic-tool" || e.type.startsWith("dynamic-tool-");
}
function Sx(e) {
  const t = Cx(e) ? "mcp" : void 0;
  return rg(e.toolName ?? e.type.slice(5), e.toolCallId, e.args ?? e.input, e.result ?? e.output, void 0, t);
}
function ig(e) {
  const t = [], n = [], r = [];
  let s = null;
  for (const i of e)
    if (i.type === "step-start")
      s !== null && r.push({ tool_calls: s }), s = [];
    else if (i.type === "text" && i.text)
      t.push(i.text);
    else if (xx(i)) {
      const a = Sx(i);
      n.push(a), s !== null && s.push(a);
    }
  return s !== null && r.push({ tool_calls: s }), { textParts: t, toolCalls: n, stepsData: r };
}
function wx(e) {
  if (!e)
    return;
  if (typeof e.modelId == "string")
    return e.modelId;
  const t = e.custom;
  if (typeof t?.modelId == "string")
    return t.modelId;
}
function ag(e, t, n, r, s, i) {
  const a = e.length > 0, o = a ? po(e.join("")) : void 0, u = wx(r), c = s && s.length > 1 ? s.map((l) => ({
    ...l.tool_calls.length > 0 ? { tool_calls: l.tool_calls } : void 0
  })) : void 0;
  return {
    status: a ? "completed" : "incomplete",
    ...t.length > 0 ? { toolCalls: t } : void 0,
    ...n > 0 ? { totalSteps: n } : void 0,
    ...i?.inputTokens != null ? { inputTokens: i.inputTokens } : void 0,
    ...i?.outputTokens != null ? { outputTokens: i.outputTokens } : void 0,
    ...i?.reasoningTokens != null ? { reasoningTokens: i.reasoningTokens } : void 0,
    ...i?.cachedInputTokens != null ? { cachedInputTokens: i.cachedInputTokens } : void 0,
    ...o != null ? { outputText: o } : void 0,
    ...r ? { metadata: r } : void 0,
    ...c ? { steps: c } : void 0,
    ...u ? { modelId: u } : void 0
  };
}
function uh(e) {
  const t = e.inputTokens ?? e.promptTokens, n = e.outputTokens ?? e.completionTokens;
  if (!(t == null && n == null && e.reasoningTokens == null && e.cachedInputTokens == null))
    return {
      ...t != null ? { inputTokens: t } : void 0,
      ...n != null ? { outputTokens: n } : void 0,
      ...e.reasoningTokens != null ? { reasoningTokens: e.reasoningTokens } : void 0,
      ...e.cachedInputTokens != null ? { cachedInputTokens: e.cachedInputTokens } : void 0
    };
}
function og(e) {
  const t = e?.usage;
  if (t) {
    const r = uh(t);
    if (r)
      return r;
  }
  const n = e?.steps;
  if (n && n.length > 0) {
    let r = 0, s = 0, i = 0, a = 0, o = !1, u = !1, c = !1, l = !1, h = !1;
    for (const m of n) {
      if (!m.usage)
        continue;
      const p = uh(m.usage);
      p && (p.inputTokens != null && (r += p.inputTokens, o = !0), p.outputTokens != null && (s += p.outputTokens, u = !0), p.reasoningTokens != null && (i += p.reasoningTokens, c = !0), p.cachedInputTokens != null && (a += p.cachedInputTokens, l = !0), h = !0);
    }
    if (h)
      return {
        ...o ? { inputTokens: r } : void 0,
        ...u ? { outputTokens: s } : void 0,
        ...c ? { reasoningTokens: i } : void 0,
        ...l ? { cachedInputTokens: a } : void 0
      };
  }
}
function Ix(e) {
  const t = e;
  if (t.role !== "assistant")
    return null;
  const { textParts: n, toolCalls: r, stepsData: s } = ig(t.parts ?? []);
  return ag(n, r, s.length, t.metadata, s, og(t.metadata));
}
function vx(e) {
  const t = [], n = [], r = [];
  let s = !1, i, a = 0, o = 0, u = 0, c = 0, l = !1, h = !1, m = !1, p = !1;
  for (const E of e) {
    const g = E;
    if (g.role !== "assistant")
      continue;
    s = !0;
    const { textParts: _, toolCalls: b, stepsData: T } = ig(g.parts ?? []);
    t.push(..._), n.push(...b), r.push(...T), g.metadata && (i = g.metadata);
    const C = og(g.metadata);
    C && (C.inputTokens != null && (a += C.inputTokens, l = !0), C.outputTokens != null && (o += C.outputTokens, h = !0), C.reasoningTokens != null && (u += C.reasoningTokens, m = !0), C.cachedInputTokens != null && (c += C.cachedInputTokens, p = !0));
  }
  return s ? ag(t, n, r.length, i, r, {
    ...l ? { inputTokens: a } : void 0,
    ...h ? { outputTokens: o } : void 0,
    ...m ? { reasoningTokens: u } : void 0,
    ...p ? { cachedInputTokens: c } : void 0
  }) : null;
}
function Nx(e) {
  const t = Re(), [n] = ce(() => new gx(e, t));
  return n;
}
const kx = (e) => e.startsWith("image/") ? "image" : e.startsWith("text/") ? "document" : "file";
class Rx {
  constructor(t) {
    k(this, "cloud");
    k(this, "accept", "*");
    k(this, "uploadedUrls", /* @__PURE__ */ new Map());
    this.cloud = t;
  }
  async *add({ file: t }) {
    const n = crypto.randomUUID(), r = kx(t.type);
    let s = {
      id: n,
      type: r,
      name: t.name,
      contentType: t.type,
      file: t,
      status: { type: "running", reason: "uploading", progress: 0 }
    };
    yield s;
    try {
      const { signedUrl: i, publicUrl: a } = await this.cloud.files.generatePresignedUploadUrl({
        filename: t.name
      });
      await fetch(i, {
        method: "PUT",
        body: t,
        headers: {
          "Content-Type": t.type
        },
        mode: "cors"
      }), this.uploadedUrls.set(n, a), s = {
        ...s,
        status: { type: "requires-action", reason: "composer-send" }
      }, yield s;
    } catch {
      s = {
        ...s,
        status: { type: "incomplete", reason: "error" }
      }, yield s;
    }
  }
  async remove(t) {
    this.uploadedUrls.delete(t.id);
  }
  async send(t) {
    const n = this.uploadedUrls.get(t.id);
    if (!n)
      throw new Error("Attachment not uploaded");
    this.uploadedUrls.delete(t.id);
    let r;
    return t.type === "image" ? r = [{ type: "image", image: n, filename: t.name }] : r = [
      {
        type: "file",
        data: n,
        mimeType: t.contentType ?? "",
        filename: t.name
      }
    ], {
      ...t,
      status: { type: "complete" },
      content: r
    };
  }
}
const ch = typeof process < "u" && process?.env?.NEXT_PUBLIC_ASSISTANT_BASE_URL, uu = ch ? new lx({ baseUrl: ch, anonymous: !0 }) : void 0, Px = (e) => {
  const t = Ke(e);
  _e(() => {
    t.current = e;
  }, [e]);
  const n = ne(function({ children: i }) {
    const a = Nx({
      get current() {
        return t.current.cloud ?? uu;
      }
    }), o = t.current.cloud ?? uu, u = se(() => new Rx(o), [o]), c = se(() => ({
      history: a,
      attachments: u
    }), [a, u]);
    return d.jsx(rl, { adapters: c, children: i });
  }, []), r = e.cloud ?? uu;
  if (!r) {
    const s = t, i = new fx();
    return i.initialize = async (a) => {
      const o = await s.current.create?.();
      return { remoteId: a, externalId: o?.externalId };
    }, i;
  }
  return {
    list: async () => {
      const { threads: s } = await r.threads.list();
      return {
        threads: s.map((i) => ({
          status: i.is_archived ? "archived" : "regular",
          remoteId: i.id,
          title: i.title,
          externalId: i.external_id ?? void 0
        }))
      };
    },
    initialize: async () => {
      const i = await (e.create?.() ?? Promise.resolve()), a = i ? i.externalId : void 0, { thread_id: o } = await r.threads.create({
        last_message_at: /* @__PURE__ */ new Date(),
        external_id: a
      });
      return { externalId: a, remoteId: o };
    },
    rename: async (s, i) => r.threads.update(s, { title: i }),
    archive: async (s) => r.threads.update(s, { is_archived: !0 }),
    unarchive: async (s) => r.threads.update(s, { is_archived: !1 }),
    delete: async (s) => (await e.delete?.(s), r.threads.delete(s)),
    generateTitle: async (s, i) => {
      const a = i.map((o) => ({
        ...o,
        content: o.content.filter((u) => u.type === "text" || u.type === "tool-call")
      }));
      return r.runs.stream({
        thread_id: s,
        assistant_id: "system/thread_title",
        messages: a
      });
    },
    fetch: async (s) => {
      const i = await r.threads.get(s);
      return {
        status: i.is_archived ? "archived" : "regular",
        remoteId: i.id,
        title: i.title,
        externalId: i.external_id ?? void 0
      };
    },
    unstable_Provider: n
  };
}, Ox = (e) => e._core?.RenderComponent, Dx = de(({ runtime: e, aui: t = null, children: n }) => {
  const r = Re({ threads: eg(e) }, { parent: t }), s = Ox(e);
  return d.jsxs(Lr, { value: r, children: [s && d.jsx(s, {}), n] });
}), ug = (e, t) => e.Message === t.Message && e.EditComposer === t.EditComposer && e.UserEditComposer === t.UserEditComposer && e.AssistantEditComposer === t.AssistantEditComposer && e.SystemEditComposer === t.SystemEditComposer && e.UserMessage === t.UserMessage && e.AssistantMessage === t.AssistantMessage && e.SystemMessage === t.SystemMessage, Lx = () => null, Mx = (e, t, n) => {
  switch (t) {
    case "user":
      return n ? e.UserEditComposer ?? e.EditComposer ?? e.UserMessage ?? e.Message : e.UserMessage ?? e.Message;
    case "assistant":
      return n ? e.AssistantEditComposer ?? e.EditComposer ?? e.AssistantMessage ?? e.Message : e.AssistantMessage ?? e.Message;
    case "system":
      return n ? e.SystemEditComposer ?? e.EditComposer ?? e.SystemMessage ?? e.Message : e.SystemMessage ?? e.Message ?? Lx;
    default:
      const r = t;
      throw new Error(`Unknown message role: ${r}`);
  }
}, cg = ({ components: e }) => {
  const t = J((s) => s.message.role), n = J((s) => s.message.composer.isEditing), r = Mx(e, t, n);
  return d.jsx(r, {});
}, sl = de(({ index: e, components: t }) => d.jsx(Um, { index: e, children: d.jsx(cg, { components: t }) }), (e, t) => e.index === t.index && ug(e.components, t.components));
sl.displayName = "ThreadPrimitive.MessageByIndex";
const lh = ({ children: e }) => {
  const t = J((n) => n.thread.messages.length);
  return se(() => t === 0 ? null : Array.from({ length: t }, (n, r) => d.jsx(Um, { index: r, children: d.jsx(Qc, { getItemState: (s) => s.thread().message({ index: r }).getState(), children: (s) => e({
    get message() {
      return s();
    }
  }) }) }, r)), [t, e]);
}, lg = ({ components: e, children: t }) => e ? d.jsx(lh, { children: () => d.jsx(cg, { components: e }) }) : d.jsx(lh, { children: t });
lg.displayName = "ThreadPrimitive.Messages";
de(lg, (e, t) => e.children || t.children ? e.children === t.children : ug(e.components, t.components));
const Hx = (e) => {
  const t = e.message.metadata;
  if (!(!t || typeof t != "object"))
    return t.custom?.quote;
}, dh = (e) => Symbol.iterator in e, hh = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), fh = (e, t) => {
  const n = e instanceof Map ? e : new Map(e.entries()), r = t instanceof Map ? t : new Map(t.entries());
  if (n.size !== r.size)
    return !1;
  for (const [s, i] of n)
    if (!r.has(s) || !Object.is(i, r.get(s)))
      return !1;
  return !0;
}, Bx = (e, t) => {
  const n = e[Symbol.iterator](), r = t[Symbol.iterator]();
  let s = n.next(), i = r.next();
  for (; !s.done && !i.done; ) {
    if (!Object.is(s.value, i.value))
      return !1;
    s = n.next(), i = r.next();
  }
  return !!s.done && !!i.done;
};
function Ux(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : dh(e) && dh(t) ? hh(e) && hh(t) ? fh(e, t) : Bx(e, t) : fh(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function Fx(e) {
  const t = Ze.useRef(void 0);
  return (n) => {
    const r = e(n);
    return Ux(t.current, r) ? t.current : t.current = r;
  };
}
const cu = (e) => {
  let t = -1;
  return {
    startGroup: (n) => {
      t === -1 && (t = n);
    },
    endGroup: (n, r) => {
      t !== -1 && (r.push({
        type: e,
        startIndex: t,
        endIndex: n
      }), t = -1);
    },
    finalize: (n, r) => {
      t !== -1 && r.push({
        type: e,
        startIndex: t,
        endIndex: n
      });
    }
  };
}, jx = (e, t) => {
  const n = [];
  if (t) {
    const r = cu("chainOfThoughtGroup");
    for (let s = 0; s < e.length; s++) {
      const i = e[s];
      i === "tool-call" || i === "reasoning" ? r.startGroup(s) : (r.endGroup(s - 1, n), n.push({ type: "single", index: s }));
    }
    r.finalize(e.length - 1, n);
  } else {
    const r = cu("toolGroup"), s = cu("reasoningGroup");
    for (let i = 0; i < e.length; i++) {
      const a = e[i];
      a === "tool-call" ? (s.endGroup(i - 1, n), r.startGroup(i)) : a === "reasoning" ? (r.endGroup(i - 1, n), s.startGroup(i)) : (r.endGroup(i - 1, n), s.endGroup(i - 1, n), n.push({ type: "single", index: i }));
    }
    r.finalize(e.length - 1, n), s.finalize(e.length - 1, n);
  }
  return n;
}, $x = (e) => {
  const t = J(Fx((n) => n.message.parts.map((r) => r.type)));
  return se(() => t.length === 0 ? [] : jx(t, e), [t, e]);
}, zx = ({ Fallback: e, ...t }) => {
  const n = J((r) => {
    const s = r.tools.tools[t.toolName] ?? e;
    return Array.isArray(s) ? s[0] ?? e : s;
  });
  return n ? d.jsx(n, { ...t }) : null;
}, Vx = ({ Fallback: e, ...t }) => {
  const n = J((r) => {
    const s = r.dataRenderers.renderers[t.name] ?? e;
    return Array.isArray(s) ? s[0] ?? e : s;
  });
  return n ? d.jsx(n, { ...t }) : null;
}, Et = {
  Text: () => null,
  Reasoning: () => null,
  Source: () => null,
  Image: () => null,
  File: () => null,
  Unstable_Audio: () => null,
  ToolGroup: ({ children: e }) => e,
  ReasoningGroup: ({ children: e }) => e
}, Yx = ({ components: { Text: e = Et.Text, Reasoning: t = Et.Reasoning, Image: n = Et.Image, Source: r = Et.Source, File: s = Et.File, Unstable_Audio: i = Et.Unstable_Audio, tools: a = {}, data: o } = {} }) => {
  const u = Re(), c = J((h) => h.part), l = c.type;
  if (l === "tool-call") {
    const h = u.part().addToolResult, m = u.part().resumeToolCall;
    if ("Override" in a)
      return d.jsx(a.Override, { ...c, addResult: h, resume: m });
    const p = a.by_name?.[c.toolName] ?? a.Fallback;
    return d.jsx(zx, { ...c, Fallback: p, addResult: h, resume: m });
  }
  if (c.status?.type === "requires-action")
    throw new Error("Encountered unexpected requires-action status");
  switch (l) {
    case "text":
      return d.jsx(e, { ...c });
    case "reasoning":
      return d.jsx(t, { ...c });
    case "source":
      return d.jsx(r, { ...c });
    case "image":
      return d.jsx(n, { ...c });
    case "file":
      return d.jsx(s, { ...c });
    case "audio":
      return d.jsx(i, { ...c });
    case "data": {
      const h = o?.by_name?.[c.name] ?? o?.Fallback;
      return d.jsx(Vx, { ...c, Fallback: h });
    }
    default:
      return console.warn(`Unknown message part type: ${l}`), null;
  }
}, _a = de(({ index: e, components: t }) => d.jsx(Fm, { index: e, children: d.jsx(Yx, { components: t }) }), (e, t) => e.index === t.index && e.components?.Text === t.components?.Text && e.components?.Reasoning === t.components?.Reasoning && e.components?.Source === t.components?.Source && e.components?.Image === t.components?.Image && e.components?.File === t.components?.File && e.components?.Unstable_Audio === t.components?.Unstable_Audio && e.components?.tools === t.components?.tools && e.components?.data === t.components?.data && e.components?.ToolGroup === t.components?.ToolGroup && e.components?.ReasoningGroup === t.components?.ReasoningGroup);
_a.displayName = "MessagePrimitive.PartByIndex";
const Gx = ({ status: e, component: t }) => d.jsx(Ey, { text: "", isRunning: e.type === "running", children: d.jsx(t, { type: "text", text: "", status: e }) }), Wx = Object.freeze({
  type: "complete"
}), qx = ({ components: e }) => {
  const t = J((n) => n.message.status ?? Wx);
  return e?.Empty ? d.jsx(e.Empty, { status: t }) : t.type !== "running" ? null : d.jsx(Gx, { status: t, component: e?.Text ?? Et.Text });
}, dg = de(qx, (e, t) => e.components?.Empty === t.components?.Empty && e.components?.Text === t.components?.Text), Kx = ({ components: e, enabled: t }) => J((r) => {
  if (!t || r.message.parts.length === 0)
    return !1;
  const s = r.message.parts[r.message.parts.length - 1];
  return s?.type !== "text" && s?.type !== "reasoning";
}) ? d.jsx(dg, { components: e }) : null, Qx = de(Kx, (e, t) => e.enabled === t.enabled && e.components?.Empty === t.components?.Empty && e.components?.Text === t.components?.Text), Xx = ({ Quote: e }) => {
  const t = J(Hx);
  return t ? d.jsx(e, { text: t.text, messageId: t.messageId }) : null;
}, Jx = de(Xx), hg = () => {
  const e = Re(), t = J((r) => r.part), n = J((r) => {
    if (r.part.type !== "tool-call")
      return null;
    const s = r.tools.tools[r.part.toolName];
    return Array.isArray(s) ? s[0] ?? null : s ?? null;
  });
  return !n || t.type !== "tool-call" ? null : d.jsx(n, { ...t, addResult: e.part().addToolResult, resume: e.part().resumeToolCall });
}, fg = () => {
  const e = J((n) => n.part), t = J((n) => {
    if (n.part.type !== "data")
      return null;
    const r = n.dataRenderers.renderers[n.part.name];
    return Array.isArray(r) ? r[0] ?? null : r ?? null;
  });
  return !t || e.type !== "data" ? null : d.jsx(t, { ...e });
}, Zx = () => {
  const e = J((t) => t.part.type);
  return e === "tool-call" ? d.jsx(hg, {}) : e === "data" ? d.jsx(fg, {}) : null;
}, eC = ({ children: e }) => {
  const t = Re(), n = J((r) => r.message.parts.length);
  return se(() => Array.from({ length: n }, (r, s) => d.jsx(Fm, { index: s, children: d.jsx(Qc, { getItemState: (i) => i.message().part({ index: s }).getState(), children: (i) => {
    const a = e({
      get part() {
        const o = i();
        if (o.type === "tool-call") {
          const u = t.tools().getState().tools[o.toolName], c = Array.isArray(u) ? !!u[0] : !!u, l = t.message().part({ index: s });
          return {
            ...o,
            toolUI: c ? d.jsx(hg, {}) : null,
            addResult: l.addToolResult,
            resume: l.resumeToolCall
          };
        }
        if (o.type === "data") {
          const u = t.dataRenderers().getState().renderers[o.name], c = Array.isArray(u) ? !!u[0] : !!u;
          return {
            ...o,
            dataRendererUI: c ? d.jsx(fg, {}) : null
          };
        }
        return o;
      }
    });
    return a !== null ? a : d.jsx(Zx, {});
  } }) }, s)), [n, e]);
}, cc = ({ components: e, unstable_showEmptyOnNonTextEnd: t = !0, children: n }) => n ? d.jsx(eC, { children: n }) : d.jsx(tC, { components: e, unstable_showEmptyOnNonTextEnd: t });
cc.displayName = "MessagePrimitive.Parts";
const tC = ({ components: e, unstable_showEmptyOnNonTextEnd: t }) => {
  const n = J((a) => a.message.parts.length), r = !!e?.ChainOfThought, s = $x(r), i = se(() => n === 0 ? d.jsx(dg, { components: e }) : s.map((a) => {
    if (a.type === "single")
      return d.jsx(_a, { index: a.index, components: e }, a.index);
    if (a.type === "chainOfThoughtGroup") {
      const o = e?.ChainOfThought;
      return o ? d.jsx(by, { startIndex: a.startIndex, endIndex: a.endIndex, children: d.jsx(o, {}) }, `chainOfThought-${a.startIndex}`) : null;
    } else if (a.type === "toolGroup") {
      const o = e?.ToolGroup ?? Et.ToolGroup;
      return d.jsx(o, { startIndex: a.startIndex, endIndex: a.endIndex, children: Array.from({ length: a.endIndex - a.startIndex + 1 }, (u, c) => d.jsx(_a, { index: a.startIndex + c, components: e }, c)) }, `tool-${a.startIndex}`);
    } else {
      const o = e?.ReasoningGroup ?? Et.ReasoningGroup;
      return d.jsx(o, { startIndex: a.startIndex, endIndex: a.endIndex, children: Array.from({ length: a.endIndex - a.startIndex + 1 }, (u, c) => d.jsx(_a, { index: a.startIndex + c, components: e }, c)) }, `reasoning-${a.startIndex}`);
    }
  }), [s, e, n]);
  return d.jsxs(d.Fragment, { children: [e?.Quote && d.jsx(Jx, { Quote: e.Quote }), i, d.jsx(Qx, { components: e, enabled: t })] });
}, nC = de(({ index: e, archived: t = !1, components: n }) => {
  const r = n.ThreadListItem;
  return d.jsx(jm, { index: e, archived: t, children: d.jsx(r, {}) });
}, (e, t) => e.index === t.index && e.archived === t.archived && e.components.ThreadListItem === t.components.ThreadListItem);
nC.displayName = "ThreadListPrimitive.ItemByIndex";
const ph = ({ archived: e, children: t }) => {
  const n = J((r) => e ? r.threads.archivedThreadIds.length : r.threads.threadIds.length);
  return se(() => Array.from({ length: n }, (r, s) => d.jsx(jm, { index: s, archived: e, children: d.jsx(Qc, { getItemState: (i) => i.threads().item({ index: s, archived: e }).getState(), children: (i) => t({
    get threadListItem() {
      return i();
    }
  }) }) }, s)), [n, e, t]);
}, pg = ({ archived: e = !1, components: t, children: n }) => {
  if (t) {
    const r = t.ThreadListItem;
    return d.jsx(ph, { archived: e, children: () => d.jsx(r, {}) });
  }
  return d.jsx(ph, { archived: e, children: n });
};
pg.displayName = "ThreadListPrimitive.Items";
const mg = ({ fallback: e }) => {
  const t = J((n) => n.threadListItem.title);
  return d.jsx(d.Fragment, { children: t || e });
};
mg.displayName = "ThreadListItemPrimitive.Title";
const rC = () => {
  const e = Re(), t = J((r) => r.thread.isRunning && !r.thread.capabilities.queue || !r.composer.isEditing || r.composer.isEmpty);
  return { send: ne((r) => {
    e.composer().send(r);
  }, [e]), disabled: t };
}, sC = () => {
  const e = Re(), t = J((r) => !r.composer.canCancel);
  return { cancel: ne(() => {
    e.composer().cancel();
  }, [e]), disabled: t };
}, iC = () => {
  const e = Re(), t = J((r) => r.composer.isEditing);
  return { edit: ne(() => {
    e.composer().beginEdit();
  }, [e]), disabled: t };
}, aC = () => {
  const e = Re(), t = J((r) => r.thread.isRunning || r.thread.isDisabled || r.message.role !== "assistant");
  return { reload: ne(() => {
    e.message().reload();
  }, [e]), disabled: t };
}, oC = () => {
  const e = Re(), t = J((r) => r.message.metadata.submittedFeedback?.type === "positive");
  return { submit: ne(() => {
    e.message().submitFeedback({ type: "positive" });
  }, [e]), isSubmitted: t };
}, uC = () => {
  const e = Re(), t = J((r) => r.message.metadata.submittedFeedback?.type === "negative");
  return { submit: ne(() => {
    e.message().submitFeedback({ type: "negative" });
  }, [e]), isSubmitted: t };
}, cC = () => {
  const e = Re(), t = J((r) => !!(r.message.branchNumber >= r.message.branchCount || r.thread.isRunning && !r.thread.capabilities.switchBranchDuringRun));
  return { next: ne(() => {
    e.message().switchToBranch({ position: "next" });
  }, [e]), disabled: t };
}, lC = () => {
  const e = Re(), t = J((r) => !!(r.message.branchNumber <= 1 || r.thread.isRunning && !r.thread.capabilities.switchBranchDuringRun));
  return { previous: ne(() => {
    e.message().switchToBranch({ position: "previous" });
  }, [e]), disabled: t };
}, dC = ({ prompt: e, send: t, clearComposer: n = !0 }) => {
  const r = Re(), s = J((o) => o.thread.isDisabled), i = t ?? !1;
  return { trigger: ne(() => {
    const o = r.thread().getState().isRunning;
    if (i && !o)
      r.thread().append({
        content: [{ type: "text", text: e }],
        runConfig: r.composer().getState().runConfig
      }), n && r.composer().setText("");
    else if (n)
      r.composer().setText(e);
    else {
      const u = r.composer().getState().text;
      r.composer().setText(u.trim() ? `${u} ${e}` : e);
    }
  }, [r, i, n, e]), disabled: s };
}, hC = () => {
  const e = Re();
  return { switchTo: ne(() => {
    e.threadListItem().switchTo();
  }, [e]) };
}, fC = () => {
  const e = Re();
  return { switchToNewThread: ne(() => {
    e.threads().switchToNewThread();
  }, [e]) };
}, pC = () => J((e) => e.message.status?.type === "incomplete" && e.message.status.reason === "error" ? e.message.status.error ?? "An error occurred" : void 0), mC = (e, { initialMessages: t, ...n }) => {
  const { modelContext: r, ...s } = Vy() ?? {}, i = {
    ...n,
    adapters: {
      ...s,
      ...n.adapters,
      chatModel: e
    }
  }, [a] = ce(() => new Ky(i, t)), o = Ke(void 0);
  return o.current = J((u) => u.threadListItem.remoteId), _e(() => {
    a.threads.getMainThreadRuntimeCore().__internal_setGetThreadId(() => o.current);
  }, [a]), _e(() => () => {
    a.threads.getMainThreadRuntimeCore().detach();
  }, [a]), _e(() => {
    a.threads.getMainThreadRuntimeCore().__internal_setOptions(i), a.threads.getMainThreadRuntimeCore().__internal_load();
  }), _e(() => {
    if (r)
      return a.registerModelContextProvider(r);
  }, [r, a]), se(() => new nl(a), [a]);
}, gC = (e, { cloud: t, ...n } = {}) => {
  const r = Px({ cloud: t });
  return tg({
    runtimeHook: function() {
      return mC(e, n);
    },
    adapter: r,
    allowNesting: !0
  });
}, lu = (e) => {
  const t = /* @__PURE__ */ new Map(), n = () => {
    let r = 0;
    for (const s of t.values())
      r += s;
    e(r);
  };
  return {
    register: () => {
      const r = /* @__PURE__ */ Symbol();
      return t.set(r, 0), {
        setHeight: (s) => {
          t.get(r) !== s && (t.set(r, s), n());
        },
        unregister: () => {
          t.delete(r), n();
        }
      };
    }
  };
}, EC = (e = {}) => {
  const t = /* @__PURE__ */ new Set(), n = lu((a) => {
    i.setState({
      height: {
        ...i.getState().height,
        viewport: a
      }
    });
  }), r = lu((a) => {
    i.setState({
      height: {
        ...i.getState().height,
        inset: a
      }
    });
  }), s = lu((a) => {
    i.setState({
      height: {
        ...i.getState().height,
        userMessage: a
      }
    });
  }), i = ls(() => ({
    isAtBottom: !0,
    scrollToBottom: ({ behavior: a = "auto" } = {}) => {
      for (const o of t)
        o({ behavior: a });
    },
    onScrollToBottom: (a) => (t.add(a), () => {
      t.delete(a);
    }),
    turnAnchor: e.turnAnchor ?? "bottom",
    height: {
      viewport: 0,
      inset: 0,
      userMessage: 0
    },
    registerViewport: n.register,
    registerContentInset: r.register,
    registerUserMessageHeight: s.register
  }));
  return i;
};
function bC(e, t) {
  function n(r) {
    const s = mt(e);
    if (!r?.optional && !s)
      throw new Error(`This component must be used within ${t}.`);
    return s;
  }
  return n;
}
function gg(e, t) {
  function n(s) {
    const i = e(s);
    return i ? i[t] : null;
  }
  function r(s) {
    let i = !1, a;
    typeof s == "function" ? a = s : s && typeof s == "object" && (i = !!s.optional, a = s.selector);
    const o = n({
      optional: i
    });
    return o ? a ? o(a) : o() : null;
  }
  return {
    [t]: r,
    [`${t}Store`]: n
  };
}
const Eg = Tt(null), _C = bC(Eg, "ThreadPrimitive.Viewport"), { useThreadViewport: di, useThreadViewportStore: mo } = gg(_C, "useThreadViewport"), hi = (e) => e, TC = (e) => {
  const t = mo({ optional: !0 }), [n] = ce(() => EC(e));
  return _e(() => t?.getState().onScrollToBottom(() => {
    n.getState().scrollToBottom();
  }), [t, n]), _e(() => {
    if (t)
      return n.subscribe((r) => {
        t.getState().isAtBottom !== r.isAtBottom && hi(t).setState({ isAtBottom: r.isAtBottom });
      });
  }, [n, t]), _e(() => {
    const r = {
      turnAnchor: e.turnAnchor ?? "bottom"
    };
    n.getState().turnAnchor !== r.turnAnchor && hi(n).setState(r);
  }, [n, e.turnAnchor]), n;
}, bg = ({ children: e, options: t = {} }) => {
  const n = TC(t), [r] = ce(() => ({
    useThreadViewport: n
  }));
  return d.jsx(Eg.Provider, { value: r, children: e });
};
let Gr;
const du = () => {
  if (Gr)
    return Gr;
  const e = () => ({
    apis: /* @__PURE__ */ new Map(),
    nextId: 0,
    listeners: /* @__PURE__ */ new Set()
  });
  if (typeof window > "u")
    return Gr = e(), Gr;
  const t = window.__ASSISTANT_UI_DEVTOOLS_HOOK__;
  if (t)
    return Gr = t, t;
  const n = e();
  return window.__ASSISTANT_UI_DEVTOOLS_HOOK__ = n, Gr = n, n;
}, qn = class qn {
  static register(t) {
    const n = du();
    for (const o of n.apis.values())
      if (o.api === t)
        return () => {
        };
    const r = n.nextId++, s = {
      api: t,
      logs: []
    }, i = t.on?.("*", (o) => {
      const u = n.apis.get(r);
      u && (u.logs.push({
        time: /* @__PURE__ */ new Date(),
        event: o.event,
        data: o.payload
      }), u.logs.length > qn.MAX_EVENT_LOGS_PER_API && (u.logs = u.logs.slice(-200)), qn.notifyListeners(r));
    }), a = t.subscribe?.(() => {
      qn.notifyListeners(r);
    });
    return n.apis.set(r, s), qn.notifyListeners(r), () => {
      const o = du();
      o.apis.get(r) && (i?.(), a?.(), o.apis.delete(r), qn.notifyListeners(r));
    };
  }
  static notifyListeners(t) {
    du().listeners.forEach((r) => r(t));
  }
};
k(qn, "MAX_EVENT_LOGS_PER_API", 200);
let lc = qn;
const AC = () => {
  const e = Re();
  return _e(() => {
    if (!(typeof process > "u" || process.env.NODE_ENV === "production"))
      return lc.register(e);
  }, [e]), null;
}, yC = ({ children: e, aui: t, runtime: n }) => d.jsxs(Dx, { runtime: n, aui: t ?? null, children: [d.jsx(AC, {}), d.jsx(bg, { children: e })] }), xC = de(yC);
function mh(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function il(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((s) => {
      const i = mh(s, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let s = 0; s < r.length; s++) {
          const i = r[s];
          typeof i == "function" ? i() : mh(e[s], null);
        }
      };
  };
}
function ze(...e) {
  return A.useCallback(il(...e), e);
}
var CC = /* @__PURE__ */ Symbol.for("react.lazy"), Ba = A[" use ".trim().toString()];
function SC(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function _g(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === CC && "_payload" in e && SC(e._payload);
}
// @__NO_SIDE_EFFECTS__
function Tg(e) {
  const t = /* @__PURE__ */ IC(e), n = A.forwardRef((r, s) => {
    let { children: i, ...a } = r;
    _g(i) && typeof Ba == "function" && (i = Ba(i._payload));
    const o = A.Children.toArray(i), u = o.find(NC);
    if (u) {
      const c = u.props.children, l = o.map((h) => h === u ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : h);
      return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: A.isValidElement(c) ? A.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var wC = /* @__PURE__ */ Tg("Slot");
// @__NO_SIDE_EFFECTS__
function IC(e) {
  const t = A.forwardRef((n, r) => {
    let { children: s, ...i } = n;
    if (_g(s) && typeof Ba == "function" && (s = Ba(s._payload)), A.isValidElement(s)) {
      const a = RC(s), o = kC(i, s.props);
      return s.type !== A.Fragment && (o.ref = r ? il(r, a) : a), A.cloneElement(s, o);
    }
    return A.Children.count(s) > 1 ? A.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var vC = /* @__PURE__ */ Symbol("radix.slottable");
function NC(e) {
  return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === vC;
}
function kC(e, t) {
  const n = { ...t };
  for (const r in t) {
    const s = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? s && i ? n[r] = (...o) => {
      const u = i(...o);
      return s(...o), u;
    } : s && (n[r] = s) : r === "style" ? n[r] = { ...s, ...i } : r === "className" && (n[r] = [s, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function RC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var PC = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Rt = PC.reduce((e, t) => {
  const n = /* @__PURE__ */ Tg(`Primitive.${t}`), r = A.forwardRef((s, i) => {
    const { asChild: a, ...o } = s, u = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d.jsx(u, { ...o, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), kn;
(function(e) {
  e.Hidden = "hidden", e.Floating = "floating", e.Normal = "normal";
})(kn || (kn = {}));
const OC = ({ hideWhenRunning: e, autohide: t, autohideFloat: n, forceVisible: r }) => J((s) => {
  if (e && s.thread.isRunning)
    return kn.Hidden;
  const i = t === "always" || t === "not-last" && !s.message.isLast, a = r || s.message.isHovering;
  return i ? a ? n === "always" || n === "single-branch" && s.message.branchCount <= 1 ? kn.Floating : kn.Normal : kn.Hidden : kn.Normal;
}), DC = Tt(null), go = Je(({ hideWhenRunning: e, autohide: t, autohideFloat: n, ...r }, s) => {
  const [i, a] = ce(0), o = ne(() => {
    let l = !1;
    return a((h) => h + 1), () => {
      l || (l = !0, a((h) => Math.max(0, h - 1)));
    };
  }, []), u = se(() => ({ acquireInteractionLock: o }), [o]), c = OC({
    hideWhenRunning: e,
    autohide: t,
    autohideFloat: n,
    forceVisible: i > 0
  });
  return c === kn.Hidden ? null : d.jsx(DC.Provider, { value: u, children: d.jsx(Rt.div, { ...c === kn.Floating ? { "data-floating": "true" } : null, ...r, ref: s }) });
});
go.displayName = "ActionBarPrimitive.Root";
function be(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(s) {
    if (e?.(s), n === !1 || !s.defaultPrevented)
      return t?.(s);
  };
}
const Un = (e, t, n = []) => {
  const r = Je((s, i) => {
    const a = {}, o = {};
    Object.keys(s).forEach((c) => {
      n.includes(c) ? a[c] = s[c] : o[c] = s[c];
    });
    const u = t(a) ?? void 0;
    return d.jsx(Rt.button, { ...o, type: "button", ref: i, disabled: o.disabled || !u, onClick: be(o.onClick, u) });
  });
  return r.displayName = e, r;
}, LC = () => {
  const { disabled: e, reload: t } = aC();
  return e ? null : t;
}, Ag = Un("ActionBarPrimitive.Reload", LC), MC = () => {
  const { disabled: e, edit: t } = iC();
  return e ? null : t;
}, HC = Un("ActionBarPrimitive.Edit", MC);
function jt(e) {
  const t = A.useRef(e);
  return A.useEffect(() => {
    t.current = e;
  }), A.useMemo(() => (...n) => t.current?.(...n), []);
}
function yg(e, t = globalThis?.document) {
  const n = jt(e);
  A.useEffect(() => {
    const r = (s) => {
      s.key === "Escape" && n(s);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
const BC = () => {
  const { submit: e } = oC();
  return e;
}, xg = Je(({ onClick: e, disabled: t, ...n }, r) => {
  const s = J((a) => a.message.metadata.submittedFeedback?.type === "positive"), i = BC();
  return d.jsx(Rt.button, { type: "button", ...s ? { "data-submitted": "true" } : {}, ...n, ref: r, disabled: t || !i, onClick: be(e, () => {
    i?.();
  }) });
});
xg.displayName = "ActionBarPrimitive.FeedbackPositive";
const UC = () => {
  const { submit: e } = uC();
  return e;
}, Cg = Je(({ onClick: e, disabled: t, ...n }, r) => {
  const s = J((a) => a.message.metadata.submittedFeedback?.type === "negative"), i = UC();
  return d.jsx(Rt.button, { type: "button", ...s ? { "data-submitted": "true" } : {}, ...n, ref: r, disabled: t || !i, onClick: be(e, () => {
    i?.();
  }) });
});
Cg.displayName = "ActionBarPrimitive.FeedbackNegative";
// @__NO_SIDE_EFFECTS__
function vr(e) {
  const t = /* @__PURE__ */ FC(e), n = A.forwardRef((r, s) => {
    const { children: i, ...a } = r, o = A.Children.toArray(i), u = o.find($C);
    if (u) {
      const c = u.props.children, l = o.map((h) => h === u ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : h);
      return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: A.isValidElement(c) ? A.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ d.jsx(t, { ...a, ref: s, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Sg = /* @__PURE__ */ vr("Slot");
// @__NO_SIDE_EFFECTS__
function FC(e) {
  const t = A.forwardRef((n, r) => {
    const { children: s, ...i } = n;
    if (A.isValidElement(s)) {
      const a = VC(s), o = zC(i, s.props);
      return s.type !== A.Fragment && (o.ref = r ? il(r, a) : a), A.cloneElement(s, o);
    }
    return A.Children.count(s) > 1 ? A.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var wg = /* @__PURE__ */ Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function jC(e) {
  const t = ({ children: n }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = wg, t;
}
function $C(e) {
  return A.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === wg;
}
function zC(e, t) {
  const n = { ...t };
  for (const r in t) {
    const s = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? s && i ? n[r] = (...o) => {
      const u = i(...o);
      return s(...o), u;
    } : s && (n[r] = s) : r === "style" ? n[r] = { ...s, ...i } : r === "className" && (n[r] = [s, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function VC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var YC = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ve = YC.reduce((e, t) => {
  const n = /* @__PURE__ */ vr(`Primitive.${t}`), r = A.forwardRef((s, i) => {
    const { asChild: a, ...o } = s, u = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d.jsx(u, { ...o, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function GC(e, t) {
  e && so.flushSync(() => e.dispatchEvent(t));
}
var Ig = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), WC = "VisuallyHidden", vg = A.forwardRef(
  (e, t) => /* @__PURE__ */ d.jsx(
    Ve.span,
    {
      ...e,
      ref: t,
      style: { ...Ig, ...e.style }
    }
  )
);
vg.displayName = WC;
var qC = vg;
function KC(e, t) {
  const n = A.createContext(t), r = (i) => {
    const { children: a, ...o } = i, u = A.useMemo(() => o, Object.values(o));
    return /* @__PURE__ */ d.jsx(n.Provider, { value: u, children: a });
  };
  r.displayName = e + "Provider";
  function s(i) {
    const a = A.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, s];
}
function bs(e, t = []) {
  let n = [];
  function r(i, a) {
    const o = A.createContext(a), u = n.length;
    n = [...n, a];
    const c = (h) => {
      const { scope: m, children: p, ...E } = h, g = m?.[e]?.[u] || o, _ = A.useMemo(() => E, Object.values(E));
      return /* @__PURE__ */ d.jsx(g.Provider, { value: _, children: p });
    };
    c.displayName = i + "Provider";
    function l(h, m) {
      const p = m?.[e]?.[u] || o, E = A.useContext(p);
      if (E) return E;
      if (a !== void 0) return a;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return [c, l];
  }
  const s = () => {
    const i = n.map((a) => A.createContext(a));
    return function(o) {
      const u = o?.[e] || i;
      return A.useMemo(
        () => ({ [`__scope${e}`]: { ...o, [e]: u } }),
        [o, u]
      );
    };
  };
  return s.scopeName = e, [r, QC(s, ...t)];
}
function QC(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(i) {
      const a = r.reduce((o, { useScope: u, scopeName: c }) => {
        const h = u(i)[`__scope${c}`];
        return { ...o, ...h };
      }, {});
      return A.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function XC(e) {
  const t = e + "CollectionProvider", [n, r] = bs(t), [s, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (g) => {
    const { scope: _, children: b } = g, T = Ze.useRef(null), C = Ze.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d.jsx(s, { scope: _, itemMap: C, collectionRef: T, children: b });
  };
  a.displayName = t;
  const o = e + "CollectionSlot", u = /* @__PURE__ */ vr(o), c = Ze.forwardRef(
    (g, _) => {
      const { scope: b, children: T } = g, C = i(o, b), R = ze(_, C.collectionRef);
      return /* @__PURE__ */ d.jsx(u, { ref: R, children: T });
    }
  );
  c.displayName = o;
  const l = e + "CollectionItemSlot", h = "data-radix-collection-item", m = /* @__PURE__ */ vr(l), p = Ze.forwardRef(
    (g, _) => {
      const { scope: b, children: T, ...C } = g, R = Ze.useRef(null), D = ze(_, R), w = i(l, b);
      return Ze.useEffect(() => (w.itemMap.set(R, { ref: R, ...C }), () => {
        w.itemMap.delete(R);
      })), /* @__PURE__ */ d.jsx(m, { [h]: "", ref: D, children: T });
    }
  );
  p.displayName = l;
  function E(g) {
    const _ = i(e + "CollectionConsumer", g);
    return Ze.useCallback(() => {
      const T = _.collectionRef.current;
      if (!T) return [];
      const C = Array.from(T.querySelectorAll(`[${h}]`));
      return Array.from(_.itemMap.values()).sort(
        (w, O) => C.indexOf(w.ref.current) - C.indexOf(O.ref.current)
      );
    }, [_.collectionRef, _.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: p },
    E,
    r
  ];
}
var _t = globalThis?.document ? A.useLayoutEffect : () => {
}, JC = A[" useInsertionEffect ".trim().toString()] || _t;
function fi({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [s, i, a] = ZC({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, u = o ? e : s;
  {
    const l = A.useRef(e !== void 0);
    A.useEffect(() => {
      const h = l.current;
      h !== o && console.warn(
        `${r} is changing from ${h ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), l.current = o;
    }, [o, r]);
  }
  const c = A.useCallback(
    (l) => {
      if (o) {
        const h = eS(l) ? l(e) : l;
        h !== e && a.current?.(h);
      } else
        i(l);
    },
    [o, e, i, a]
  );
  return [u, c];
}
function ZC({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = A.useState(e), s = A.useRef(n), i = A.useRef(t);
  return JC(() => {
    i.current = t;
  }, [t]), A.useEffect(() => {
    s.current !== n && (i.current?.(n), s.current = n);
  }, [n, s]), [n, r, i];
}
function eS(e) {
  return typeof e == "function";
}
function tS(e, t) {
  return A.useReducer((n, r) => t[n][r] ?? n, e);
}
var ir = (e) => {
  const { present: t, children: n } = e, r = nS(t), s = typeof n == "function" ? n({ present: r.isPresent }) : A.Children.only(n), i = ze(r.ref, rS(s));
  return typeof n == "function" || r.isPresent ? A.cloneElement(s, { ref: i }) : null;
};
ir.displayName = "Presence";
function nS(e) {
  const [t, n] = A.useState(), r = A.useRef(null), s = A.useRef(e), i = A.useRef("none"), a = e ? "mounted" : "unmounted", [o, u] = tS(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return A.useEffect(() => {
    const c = Qi(r.current);
    i.current = o === "mounted" ? c : "none";
  }, [o]), _t(() => {
    const c = r.current, l = s.current;
    if (l !== e) {
      const m = i.current, p = Qi(c);
      e ? u("MOUNT") : p === "none" || c?.display === "none" ? u("UNMOUNT") : u(l && m !== p ? "ANIMATION_OUT" : "UNMOUNT"), s.current = e;
    }
  }, [e, u]), _t(() => {
    if (t) {
      let c;
      const l = t.ownerDocument.defaultView ?? window, h = (p) => {
        const g = Qi(r.current).includes(CSS.escape(p.animationName));
        if (p.target === t && g && (u("ANIMATION_END"), !s.current)) {
          const _ = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = l.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = _);
          });
        }
      }, m = (p) => {
        p.target === t && (i.current = Qi(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", h), t.addEventListener("animationend", h), () => {
        l.clearTimeout(c), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", h), t.removeEventListener("animationend", h);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(o),
    ref: A.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Qi(e) {
  return e?.animationName || "none";
}
function rS(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var sS = A[" useId ".trim().toString()] || (() => {
}), iS = 0;
function Jn(e) {
  const [t, n] = A.useState(sS());
  return _t(() => {
    n((r) => r ?? String(iS++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var aS = A.createContext(void 0);
function oS(e) {
  const t = A.useContext(aS);
  return e || t || "ltr";
}
var uS = "DismissableLayer", dc = "dismissableLayer.update", cS = "dismissableLayer.pointerDownOutside", lS = "dismissableLayer.focusOutside", gh, Ng = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ii = A.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: s,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: o,
      ...u
    } = e, c = A.useContext(Ng), [l, h] = A.useState(null), m = l?.ownerDocument ?? globalThis?.document, [, p] = A.useState({}), E = ze(t, (O) => h(O)), g = Array.from(c.layers), [_] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = g.indexOf(_), T = l ? g.indexOf(l) : -1, C = c.layersWithOutsidePointerEventsDisabled.size > 0, R = T >= b, D = fS((O) => {
      const U = O.target, q = [...c.branches].some((P) => P.contains(U));
      !R || q || (s?.(O), a?.(O), O.defaultPrevented || o?.());
    }, m), w = pS((O) => {
      const U = O.target;
      [...c.branches].some((P) => P.contains(U)) || (i?.(O), a?.(O), O.defaultPrevented || o?.());
    }, m);
    return yg((O) => {
      T === c.layers.size - 1 && (r?.(O), !O.defaultPrevented && o && (O.preventDefault(), o()));
    }, m), A.useEffect(() => {
      if (l)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (gh = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(l)), c.layers.add(l), Eh(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = gh);
        };
    }, [l, m, n, c]), A.useEffect(() => () => {
      l && (c.layers.delete(l), c.layersWithOutsidePointerEventsDisabled.delete(l), Eh());
    }, [l, c]), A.useEffect(() => {
      const O = () => p({});
      return document.addEventListener(dc, O), () => document.removeEventListener(dc, O);
    }, []), /* @__PURE__ */ d.jsx(
      Ve.div,
      {
        ...u,
        ref: E,
        style: {
          pointerEvents: C ? R ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: be(e.onFocusCapture, w.onFocusCapture),
        onBlurCapture: be(e.onBlurCapture, w.onBlurCapture),
        onPointerDownCapture: be(
          e.onPointerDownCapture,
          D.onPointerDownCapture
        )
      }
    );
  }
);
Ii.displayName = uS;
var dS = "DismissableLayerBranch", hS = A.forwardRef((e, t) => {
  const n = A.useContext(Ng), r = A.useRef(null), s = ze(t, r);
  return A.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ d.jsx(Ve.div, { ...e, ref: s });
});
hS.displayName = dS;
function fS(e, t = globalThis?.document) {
  const n = jt(e), r = A.useRef(!1), s = A.useRef(() => {
  });
  return A.useEffect(() => {
    const i = (o) => {
      if (o.target && !r.current) {
        let u = function() {
          kg(
            cS,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: o };
        o.pointerType === "touch" ? (t.removeEventListener("click", s.current), s.current = u, t.addEventListener("click", s.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", s.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", s.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function pS(e, t = globalThis?.document) {
  const n = jt(e), r = A.useRef(!1);
  return A.useEffect(() => {
    const s = (i) => {
      i.target && !r.current && kg(lS, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", s), () => t.removeEventListener("focusin", s);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Eh() {
  const e = new CustomEvent(dc);
  document.dispatchEvent(e);
}
function kg(e, t, n, { discrete: r }) {
  const s = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && s.addEventListener(e, t, { once: !0 }), r ? GC(s, i) : s.dispatchEvent(i);
}
var hu = "focusScope.autoFocusOnMount", fu = "focusScope.autoFocusOnUnmount", bh = { bubbles: !1, cancelable: !0 }, mS = "FocusScope", Eo = A.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: s,
    onUnmountAutoFocus: i,
    ...a
  } = e, [o, u] = A.useState(null), c = jt(s), l = jt(i), h = A.useRef(null), m = ze(t, (g) => u(g)), p = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (r) {
      let g = function(C) {
        if (p.paused || !o) return;
        const R = C.target;
        o.contains(R) ? h.current = R : Yn(h.current, { select: !0 });
      }, _ = function(C) {
        if (p.paused || !o) return;
        const R = C.relatedTarget;
        R !== null && (o.contains(R) || Yn(h.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const D of C)
            D.removedNodes.length > 0 && Yn(o);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", _);
      const T = new MutationObserver(b);
      return o && T.observe(o, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", _), T.disconnect();
      };
    }
  }, [r, o, p.paused]), A.useEffect(() => {
    if (o) {
      Th.add(p);
      const g = document.activeElement;
      if (!o.contains(g)) {
        const b = new CustomEvent(hu, bh);
        o.addEventListener(hu, c), o.dispatchEvent(b), b.defaultPrevented || (gS(AS(Rg(o)), { select: !0 }), document.activeElement === g && Yn(o));
      }
      return () => {
        o.removeEventListener(hu, c), setTimeout(() => {
          const b = new CustomEvent(fu, bh);
          o.addEventListener(fu, l), o.dispatchEvent(b), b.defaultPrevented || Yn(g ?? document.body, { select: !0 }), o.removeEventListener(fu, l), Th.remove(p);
        }, 0);
      };
    }
  }, [o, c, l, p]);
  const E = A.useCallback(
    (g) => {
      if (!n && !r || p.paused) return;
      const _ = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
      if (_ && b) {
        const T = g.currentTarget, [C, R] = ES(T);
        C && R ? !g.shiftKey && b === R ? (g.preventDefault(), n && Yn(C, { select: !0 })) : g.shiftKey && b === C && (g.preventDefault(), n && Yn(R, { select: !0 })) : b === T && g.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ d.jsx(Ve.div, { tabIndex: -1, ...a, ref: m, onKeyDown: E });
});
Eo.displayName = mS;
function gS(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Yn(r, { select: t }), document.activeElement !== n) return;
}
function ES(e) {
  const t = Rg(e), n = _h(t, e), r = _h(t.reverse(), e);
  return [n, r];
}
function Rg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const s = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || s ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function _h(e, t) {
  for (const n of e)
    if (!bS(n, { upTo: t })) return n;
}
function bS(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function _S(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Yn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && _S(e) && t && e.select();
  }
}
var Th = TS();
function TS() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = Ah(e, t), e.unshift(t);
    },
    remove(t) {
      e = Ah(e, t), e[0]?.resume();
    }
  };
}
function Ah(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function AS(e) {
  return e.filter((t) => t.tagName !== "A");
}
var yS = "Portal", vi = A.forwardRef((e, t) => {
  const { container: n, ...r } = e, [s, i] = A.useState(!1);
  _t(() => i(!0), []);
  const a = n || s && globalThis?.document?.body;
  return a ? c1.createPortal(/* @__PURE__ */ d.jsx(Ve.div, { ...r, ref: t }), a) : null;
});
vi.displayName = yS;
var pu = 0;
function al() {
  A.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? yh()), document.body.insertAdjacentElement("beforeend", e[1] ?? yh()), pu++, () => {
      pu === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), pu--;
    };
  }, []);
}
function yh() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var gn = function() {
  return gn = Object.assign || function(t) {
    for (var n, r = 1, s = arguments.length; r < s; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, gn.apply(this, arguments);
};
function Pg(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, r = Object.getOwnPropertySymbols(e); s < r.length; s++)
      t.indexOf(r[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[s]) && (n[r[s]] = e[r[s]]);
  return n;
}
function xS(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, s = t.length, i; r < s; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Ta = "right-scroll-bar-position", Aa = "width-before-scroll-bar", CS = "with-scroll-bars-hidden", SS = "--removed-body-scroll-bar-size";
function mu(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function wS(e, t) {
  var n = ce(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var s = n.value;
          s !== r && (n.value = r, n.callback(r, s));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var IS = typeof window < "u" ? A.useLayoutEffect : A.useEffect, xh = /* @__PURE__ */ new WeakMap();
function vS(e, t) {
  var n = wS(null, function(r) {
    return e.forEach(function(s) {
      return mu(s, r);
    });
  });
  return IS(function() {
    var r = xh.get(n);
    if (r) {
      var s = new Set(r), i = new Set(e), a = n.current;
      s.forEach(function(o) {
        i.has(o) || mu(o, null);
      }), i.forEach(function(o) {
        s.has(o) || mu(o, a);
      });
    }
    xh.set(n, e);
  }, [e]), n;
}
function NS(e) {
  return e;
}
function kS(e, t) {
  t === void 0 && (t = NS);
  var n = [], r = !1, s = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(o) {
          return o !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(o) {
          return i(o);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var o = n;
        n = [], o.forEach(i), a = n;
      }
      var u = function() {
        var l = a;
        a = [], l.forEach(i);
      }, c = function() {
        return Promise.resolve().then(u);
      };
      c(), n = {
        push: function(l) {
          a.push(l), c();
        },
        filter: function(l) {
          return a = a.filter(l), n;
        }
      };
    }
  };
  return s;
}
function RS(e) {
  e === void 0 && (e = {});
  var t = kS(null);
  return t.options = gn({ async: !0, ssr: !1 }, e), t;
}
var Og = function(e) {
  var t = e.sideCar, n = Pg(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return A.createElement(r, gn({}, n));
};
Og.isSideCarExport = !0;
function PS(e, t) {
  return e.useMedium(t), Og;
}
var Dg = RS(), gu = function() {
}, bo = A.forwardRef(function(e, t) {
  var n = A.useRef(null), r = A.useState({
    onScrollCapture: gu,
    onWheelCapture: gu,
    onTouchMoveCapture: gu
  }), s = r[0], i = r[1], a = e.forwardProps, o = e.children, u = e.className, c = e.removeScrollBar, l = e.enabled, h = e.shards, m = e.sideCar, p = e.noRelative, E = e.noIsolation, g = e.inert, _ = e.allowPinchZoom, b = e.as, T = b === void 0 ? "div" : b, C = e.gapMode, R = Pg(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), D = m, w = vS([n, t]), O = gn(gn({}, R), s);
  return A.createElement(
    A.Fragment,
    null,
    l && A.createElement(D, { sideCar: Dg, removeScrollBar: c, shards: h, noRelative: p, noIsolation: E, inert: g, setCallbacks: i, allowPinchZoom: !!_, lockRef: n, gapMode: C }),
    a ? A.cloneElement(A.Children.only(o), gn(gn({}, O), { ref: w })) : A.createElement(T, gn({}, O, { className: u, ref: w }), o)
  );
});
bo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
bo.classNames = {
  fullWidth: Aa,
  zeroRight: Ta
};
var OS = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function DS() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = OS();
  return t && e.setAttribute("nonce", t), e;
}
function LS(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function MS(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var HS = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = DS()) && (LS(t, n), MS(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, BS = function() {
  var e = HS();
  return function(t, n) {
    A.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, Lg = function() {
  var e = BS(), t = function(n) {
    var r = n.styles, s = n.dynamic;
    return e(r, s), null;
  };
  return t;
}, US = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Eu = function(e) {
  return parseInt(e || "", 10) || 0;
}, FS = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], s = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Eu(n), Eu(r), Eu(s)];
}, jS = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return US;
  var t = FS(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, $S = Lg(), rs = "data-scroll-locked", zS = function(e, t, n, r) {
  var s = e.left, i = e.top, a = e.right, o = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(CS, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(o, "px ").concat(r, `;
  }
  body[`).concat(rs, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(s, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(o, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(o, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ta, ` {
    right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(Aa, ` {
    margin-right: `).concat(o, "px ").concat(r, `;
  }
  
  .`).concat(Ta, " .").concat(Ta, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Aa, " .").concat(Aa, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(rs, `] {
    `).concat(SS, ": ").concat(o, `px;
  }
`);
}, Ch = function() {
  var e = parseInt(document.body.getAttribute(rs) || "0", 10);
  return isFinite(e) ? e : 0;
}, VS = function() {
  A.useEffect(function() {
    return document.body.setAttribute(rs, (Ch() + 1).toString()), function() {
      var e = Ch() - 1;
      e <= 0 ? document.body.removeAttribute(rs) : document.body.setAttribute(rs, e.toString());
    };
  }, []);
}, YS = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, s = r === void 0 ? "margin" : r;
  VS();
  var i = A.useMemo(function() {
    return jS(s);
  }, [s]);
  return A.createElement($S, { styles: zS(i, !t, s, n ? "" : "!important") });
}, hc = !1;
if (typeof window < "u")
  try {
    var Xi = Object.defineProperty({}, "passive", {
      get: function() {
        return hc = !0, !0;
      }
    });
    window.addEventListener("test", Xi, Xi), window.removeEventListener("test", Xi, Xi);
  } catch {
    hc = !1;
  }
var Wr = hc ? { passive: !1 } : !1, GS = function(e) {
  return e.tagName === "TEXTAREA";
}, Mg = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !GS(e) && n[t] === "visible")
  );
}, WS = function(e) {
  return Mg(e, "overflowY");
}, qS = function(e) {
  return Mg(e, "overflowX");
}, Sh = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var s = Hg(e, r);
    if (s) {
      var i = Bg(e, r), a = i[1], o = i[2];
      if (a > o)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, KS = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, QS = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Hg = function(e, t) {
  return e === "v" ? WS(t) : qS(t);
}, Bg = function(e, t) {
  return e === "v" ? KS(t) : QS(t);
}, XS = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, JS = function(e, t, n, r, s) {
  var i = XS(e, window.getComputedStyle(t).direction), a = i * r, o = n.target, u = t.contains(o), c = !1, l = a > 0, h = 0, m = 0;
  do {
    if (!o)
      break;
    var p = Bg(e, o), E = p[0], g = p[1], _ = p[2], b = g - _ - i * E;
    (E || b) && Hg(e, o) && (h += b, m += E);
    var T = o.parentNode;
    o = T && T.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? T.host : T;
  } while (
    // portaled content
    !u && o !== document.body || // self content
    u && (t.contains(o) || t === o)
  );
  return (l && Math.abs(h) < 1 || !l && Math.abs(m) < 1) && (c = !0), c;
}, Ji = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, wh = function(e) {
  return [e.deltaX, e.deltaY];
}, Ih = function(e) {
  return e && "current" in e ? e.current : e;
}, ZS = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, ew = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, tw = 0, qr = [];
function nw(e) {
  var t = A.useRef([]), n = A.useRef([0, 0]), r = A.useRef(), s = A.useState(tw++)[0], i = A.useState(Lg)[0], a = A.useRef(e);
  A.useEffect(function() {
    a.current = e;
  }, [e]), A.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(s));
      var g = xS([e.lockRef.current], (e.shards || []).map(Ih), !0).filter(Boolean);
      return g.forEach(function(_) {
        return _.classList.add("allow-interactivity-".concat(s));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(s)), g.forEach(function(_) {
          return _.classList.remove("allow-interactivity-".concat(s));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var o = A.useCallback(function(g, _) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = Ji(g), T = n.current, C = "deltaX" in g ? g.deltaX : T[0] - b[0], R = "deltaY" in g ? g.deltaY : T[1] - b[1], D, w = g.target, O = Math.abs(C) > Math.abs(R) ? "h" : "v";
    if ("touches" in g && O === "h" && w.type === "range")
      return !1;
    var U = window.getSelection(), q = U && U.anchorNode, P = q ? q === w || q.contains(w) : !1;
    if (P)
      return !1;
    var z = Sh(O, w);
    if (!z)
      return !0;
    if (z ? D = O : (D = O === "v" ? "h" : "v", z = Sh(O, w)), !z)
      return !1;
    if (!r.current && "changedTouches" in g && (C || R) && (r.current = D), !D)
      return !0;
    var G = r.current || D;
    return JS(G, _, g, G === "h" ? C : R);
  }, []), u = A.useCallback(function(g) {
    var _ = g;
    if (!(!qr.length || qr[qr.length - 1] !== i)) {
      var b = "deltaY" in _ ? wh(_) : Ji(_), T = t.current.filter(function(D) {
        return D.name === _.type && (D.target === _.target || _.target === D.shadowParent) && ZS(D.delta, b);
      })[0];
      if (T && T.should) {
        _.cancelable && _.preventDefault();
        return;
      }
      if (!T) {
        var C = (a.current.shards || []).map(Ih).filter(Boolean).filter(function(D) {
          return D.contains(_.target);
        }), R = C.length > 0 ? o(_, C[0]) : !a.current.noIsolation;
        R && _.cancelable && _.preventDefault();
      }
    }
  }, []), c = A.useCallback(function(g, _, b, T) {
    var C = { name: g, delta: _, target: b, should: T, shadowParent: rw(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(R) {
        return R !== C;
      });
    }, 1);
  }, []), l = A.useCallback(function(g) {
    n.current = Ji(g), r.current = void 0;
  }, []), h = A.useCallback(function(g) {
    c(g.type, wh(g), g.target, o(g, e.lockRef.current));
  }, []), m = A.useCallback(function(g) {
    c(g.type, Ji(g), g.target, o(g, e.lockRef.current));
  }, []);
  A.useEffect(function() {
    return qr.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", u, Wr), document.addEventListener("touchmove", u, Wr), document.addEventListener("touchstart", l, Wr), function() {
      qr = qr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", u, Wr), document.removeEventListener("touchmove", u, Wr), document.removeEventListener("touchstart", l, Wr);
    };
  }, []);
  var p = e.removeScrollBar, E = e.inert;
  return A.createElement(
    A.Fragment,
    null,
    E ? A.createElement(i, { styles: ew(s) }) : null,
    p ? A.createElement(YS, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function rw(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const sw = PS(Dg, nw);
var _o = A.forwardRef(function(e, t) {
  return A.createElement(bo, gn({}, e, { ref: t, sideCar: sw }));
});
_o.classNames = bo.classNames;
var iw = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Kr = /* @__PURE__ */ new WeakMap(), Zi = /* @__PURE__ */ new WeakMap(), ea = {}, bu = 0, Ug = function(e) {
  return e && (e.host || Ug(e.parentNode));
}, aw = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Ug(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, ow = function(e, t, n, r) {
  var s = aw(t, Array.isArray(e) ? e : [e]);
  ea[n] || (ea[n] = /* @__PURE__ */ new WeakMap());
  var i = ea[n], a = [], o = /* @__PURE__ */ new Set(), u = new Set(s), c = function(h) {
    !h || o.has(h) || (o.add(h), c(h.parentNode));
  };
  s.forEach(c);
  var l = function(h) {
    !h || u.has(h) || Array.prototype.forEach.call(h.children, function(m) {
      if (o.has(m))
        l(m);
      else
        try {
          var p = m.getAttribute(r), E = p !== null && p !== "false", g = (Kr.get(m) || 0) + 1, _ = (i.get(m) || 0) + 1;
          Kr.set(m, g), i.set(m, _), a.push(m), g === 1 && E && Zi.set(m, !0), _ === 1 && m.setAttribute(n, "true"), E || m.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", m, b);
        }
    });
  };
  return l(t), o.clear(), bu++, function() {
    a.forEach(function(h) {
      var m = Kr.get(h) - 1, p = i.get(h) - 1;
      Kr.set(h, m), i.set(h, p), m || (Zi.has(h) || h.removeAttribute(r), Zi.delete(h)), p || h.removeAttribute(n);
    }), bu--, bu || (Kr = /* @__PURE__ */ new WeakMap(), Kr = /* @__PURE__ */ new WeakMap(), Zi = /* @__PURE__ */ new WeakMap(), ea = {});
  };
}, ol = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), s = iw(e);
  return s ? (r.push.apply(r, Array.from(s.querySelectorAll("[aria-live], script"))), ow(r, s, n, "aria-hidden")) : function() {
    return null;
  };
}, To = "Dialog", [Fg] = bs(To), [uw, dn] = Fg(To), jg = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    modal: a = !0
  } = e, o = A.useRef(null), u = A.useRef(null), [c, l] = fi({
    prop: r,
    defaultProp: s ?? !1,
    onChange: i,
    caller: To
  });
  return /* @__PURE__ */ d.jsx(
    uw,
    {
      scope: t,
      triggerRef: o,
      contentRef: u,
      contentId: Jn(),
      titleId: Jn(),
      descriptionId: Jn(),
      open: c,
      onOpenChange: l,
      onOpenToggle: A.useCallback(() => l((h) => !h), [l]),
      modal: a,
      children: n
    }
  );
};
jg.displayName = To;
var $g = "DialogTrigger", cw = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = dn($g, n), i = ze(t, s.triggerRef);
    return /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.contentId,
        "data-state": ll(s.open),
        ...r,
        ref: i,
        onClick: be(e.onClick, s.onOpenToggle)
      }
    );
  }
);
cw.displayName = $g;
var ul = "DialogPortal", [lw, zg] = Fg(ul, {
  forceMount: void 0
}), Vg = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: s } = e, i = dn(ul, t);
  return /* @__PURE__ */ d.jsx(lw, { scope: t, forceMount: n, children: A.Children.map(r, (a) => /* @__PURE__ */ d.jsx(ir, { present: n || i.open, children: /* @__PURE__ */ d.jsx(vi, { asChild: !0, container: s, children: a }) })) });
};
Vg.displayName = ul;
var Ua = "DialogOverlay", Yg = A.forwardRef(
  (e, t) => {
    const n = zg(Ua, e.__scopeDialog), { forceMount: r = n.forceMount, ...s } = e, i = dn(Ua, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ d.jsx(ir, { present: r || i.open, children: /* @__PURE__ */ d.jsx(hw, { ...s, ref: t }) }) : null;
  }
);
Yg.displayName = Ua;
var dw = /* @__PURE__ */ vr("DialogOverlay.RemoveScroll"), hw = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = dn(Ua, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ d.jsx(_o, { as: dw, allowPinchZoom: !0, shards: [s.contentRef], children: /* @__PURE__ */ d.jsx(
        Ve.div,
        {
          "data-state": ll(s.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Nr = "DialogContent", Gg = A.forwardRef(
  (e, t) => {
    const n = zg(Nr, e.__scopeDialog), { forceMount: r = n.forceMount, ...s } = e, i = dn(Nr, e.__scopeDialog);
    return /* @__PURE__ */ d.jsx(ir, { present: r || i.open, children: i.modal ? /* @__PURE__ */ d.jsx(fw, { ...s, ref: t }) : /* @__PURE__ */ d.jsx(pw, { ...s, ref: t }) });
  }
);
Gg.displayName = Nr;
var fw = A.forwardRef(
  (e, t) => {
    const n = dn(Nr, e.__scopeDialog), r = A.useRef(null), s = ze(t, n.contentRef, r);
    return A.useEffect(() => {
      const i = r.current;
      if (i) return ol(i);
    }, []), /* @__PURE__ */ d.jsx(
      Wg,
      {
        ...e,
        ref: s,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: be(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, o = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || o) && i.preventDefault();
        }),
        onFocusOutside: be(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), pw = A.forwardRef(
  (e, t) => {
    const n = dn(Nr, e.__scopeDialog), r = A.useRef(!1), s = A.useRef(!1);
    return /* @__PURE__ */ d.jsx(
      Wg,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, s.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (s.current = !0));
          const a = i.target;
          n.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && s.current && i.preventDefault();
        }
      }
    );
  }
), Wg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: s, onCloseAutoFocus: i, ...a } = e, o = dn(Nr, n), u = A.useRef(null), c = ze(t, u);
    return al(), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(
        Eo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: s,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ d.jsx(
            Ii,
            {
              role: "dialog",
              id: o.contentId,
              "aria-describedby": o.descriptionId,
              "aria-labelledby": o.titleId,
              "data-state": ll(o.open),
              ...a,
              ref: c,
              onDismiss: () => o.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
        /* @__PURE__ */ d.jsx(mw, { titleId: o.titleId }),
        /* @__PURE__ */ d.jsx(Ew, { contentRef: u, descriptionId: o.descriptionId })
      ] })
    ] });
  }
), cl = "DialogTitle", qg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = dn(cl, n);
    return /* @__PURE__ */ d.jsx(Ve.h2, { id: s.titleId, ...r, ref: t });
  }
);
qg.displayName = cl;
var Kg = "DialogDescription", Qg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = dn(Kg, n);
    return /* @__PURE__ */ d.jsx(Ve.p, { id: s.descriptionId, ...r, ref: t });
  }
);
Qg.displayName = Kg;
var Xg = "DialogClose", Jg = A.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, s = dn(Xg, n);
    return /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, () => s.onOpenChange(!1))
      }
    );
  }
);
Jg.displayName = Xg;
function ll(e) {
  return e ? "open" : "closed";
}
var Zg = "DialogTitleWarning", [W9, e0] = KC(Zg, {
  contentName: Nr,
  titleName: cl,
  docsSlug: "dialog"
}), mw = ({ titleId: e }) => {
  const t = e0(Zg), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return A.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, gw = "DialogDescriptionWarning", Ew = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${e0(gw).contentName}}.`;
  return A.useEffect(() => {
    const s = e.current?.getAttribute("aria-describedby");
    t && s && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, bw = jg, _w = Vg, Tw = Yg, Aw = Gg, yw = qg, xw = Qg, Cw = Jg;
function Sw(e) {
  const t = A.useRef({ value: e, previous: e });
  return A.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function ww(e) {
  const [t, n] = A.useState(void 0);
  return _t(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((s) => {
        if (!Array.isArray(s) || !s.length)
          return;
        const i = s[0];
        let a, o;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, c = Array.isArray(u) ? u[0] : u;
          a = c.inlineSize, o = c.blockSize;
        } else
          a = e.offsetWidth, o = e.offsetHeight;
        n({ width: a, height: o });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
const Iw = ["top", "right", "bottom", "left"], nr = Math.min, Ht = Math.max, Fa = Math.round, ta = Math.floor, _n = (e) => ({
  x: e,
  y: e
}), vw = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Nw = {
  start: "end",
  end: "start"
};
function fc(e, t, n) {
  return Ht(e, nr(t, n));
}
function Mn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Hn(e) {
  return e.split("-")[0];
}
function _s(e) {
  return e.split("-")[1];
}
function dl(e) {
  return e === "x" ? "y" : "x";
}
function hl(e) {
  return e === "y" ? "height" : "width";
}
const kw = /* @__PURE__ */ new Set(["top", "bottom"]);
function bn(e) {
  return kw.has(Hn(e)) ? "y" : "x";
}
function fl(e) {
  return dl(bn(e));
}
function Rw(e, t, n) {
  n === void 0 && (n = !1);
  const r = _s(e), s = fl(e), i = hl(s);
  let a = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = ja(a)), [a, ja(a)];
}
function Pw(e) {
  const t = ja(e);
  return [pc(e), t, pc(t)];
}
function pc(e) {
  return e.replace(/start|end/g, (t) => Nw[t]);
}
const vh = ["left", "right"], Nh = ["right", "left"], Ow = ["top", "bottom"], Dw = ["bottom", "top"];
function Lw(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Nh : vh : t ? vh : Nh;
    case "left":
    case "right":
      return t ? Ow : Dw;
    default:
      return [];
  }
}
function Mw(e, t, n, r) {
  const s = _s(e);
  let i = Lw(Hn(e), n === "start", r);
  return s && (i = i.map((a) => a + "-" + s), t && (i = i.concat(i.map(pc)))), i;
}
function ja(e) {
  return e.replace(/left|right|bottom|top/g, (t) => vw[t]);
}
function Hw(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function t0(e) {
  return typeof e != "number" ? Hw(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function $a(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function kh(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = bn(t), a = fl(t), o = hl(a), u = Hn(t), c = i === "y", l = r.x + r.width / 2 - s.width / 2, h = r.y + r.height / 2 - s.height / 2, m = r[o] / 2 - s[o] / 2;
  let p;
  switch (u) {
    case "top":
      p = {
        x: l,
        y: r.y - s.height
      };
      break;
    case "bottom":
      p = {
        x: l,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      p = {
        x: r.x - s.width,
        y: h
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (_s(t)) {
    case "start":
      p[a] -= m * (n && c ? -1 : 1);
      break;
    case "end":
      p[a] += m * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function Bw(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: a,
    elements: o,
    strategy: u
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: h = "floating",
    altBoundary: m = !1,
    padding: p = 0
  } = Mn(t, e), E = t0(p), _ = o[m ? h === "floating" ? "reference" : "floating" : h], b = $a(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(_))) == null || n ? _ : _.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: l,
    strategy: u
  })), T = h === "floating" ? {
    x: r,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), R = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = $a(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: T,
    offsetParent: C,
    strategy: u
  }) : T);
  return {
    top: (b.top - D.top + E.top) / R.y,
    bottom: (D.bottom - b.bottom + E.bottom) / R.y,
    left: (b.left - D.left + E.left) / R.x,
    right: (D.right - b.right + E.right) / R.x
  };
}
const Uw = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: a
  } = n, o = i.filter(Boolean), u = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: l,
    y: h
  } = kh(c, r, u), m = r, p = {}, E = 0;
  for (let _ = 0; _ < o.length; _++) {
    var g;
    const {
      name: b,
      fn: T
    } = o[_], {
      x: C,
      y: R,
      data: D,
      reset: w
    } = await T({
      x: l,
      y: h,
      initialPlacement: r,
      placement: m,
      strategy: s,
      middlewareData: p,
      rects: c,
      platform: {
        ...a,
        detectOverflow: (g = a.detectOverflow) != null ? g : Bw
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    l = C ?? l, h = R ?? h, p = {
      ...p,
      [b]: {
        ...p[b],
        ...D
      }
    }, w && E <= 50 && (E++, typeof w == "object" && (w.placement && (m = w.placement), w.rects && (c = w.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : w.rects), {
      x: l,
      y: h
    } = kh(c, m, u)), _ = -1);
  }
  return {
    x: l,
    y: h,
    placement: m,
    strategy: s,
    middlewareData: p
  };
}, Fw = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: s,
      rects: i,
      platform: a,
      elements: o,
      middlewareData: u
    } = t, {
      element: c,
      padding: l = 0
    } = Mn(e, t) || {};
    if (c == null)
      return {};
    const h = t0(l), m = {
      x: n,
      y: r
    }, p = fl(s), E = hl(p), g = await a.getDimensions(c), _ = p === "y", b = _ ? "top" : "left", T = _ ? "bottom" : "right", C = _ ? "clientHeight" : "clientWidth", R = i.reference[E] + i.reference[p] - m[p] - i.floating[E], D = m[p] - i.reference[p], w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let O = w ? w[C] : 0;
    (!O || !await (a.isElement == null ? void 0 : a.isElement(w))) && (O = o.floating[C] || i.floating[E]);
    const U = R / 2 - D / 2, q = O / 2 - g[E] / 2 - 1, P = nr(h[b], q), z = nr(h[T], q), G = P, F = O - g[E] - z, M = O / 2 - g[E] / 2 + U, H = fc(G, M, F), B = !u.arrow && _s(s) != null && M !== H && i.reference[E] / 2 - (M < G ? P : z) - g[E] / 2 < 0, Y = B ? M < G ? M - G : M - F : 0;
    return {
      [p]: m[p] + Y,
      data: {
        [p]: H,
        centerOffset: M - H - Y,
        ...B && {
          alignmentOffset: Y
        }
      },
      reset: B
    };
  }
}), jw = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: u,
        elements: c
      } = t, {
        mainAxis: l = !0,
        crossAxis: h = !0,
        fallbackPlacements: m,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: E = "none",
        flipAlignment: g = !0,
        ..._
      } = Mn(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const b = Hn(s), T = bn(o), C = Hn(o) === o, R = await (u.isRTL == null ? void 0 : u.isRTL(c.floating)), D = m || (C || !g ? [ja(o)] : Pw(o)), w = E !== "none";
      !m && w && D.push(...Mw(o, g, E, R));
      const O = [o, ...D], U = await u.detectOverflow(t, _), q = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (l && q.push(U[b]), h) {
        const M = Rw(s, a, R);
        q.push(U[M[0]], U[M[1]]);
      }
      if (P = [...P, {
        placement: s,
        overflows: q
      }], !q.every((M) => M <= 0)) {
        var z, G;
        const M = (((z = i.flip) == null ? void 0 : z.index) || 0) + 1, H = O[M];
        if (H && (!(h === "alignment" ? T !== bn(H) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every(($) => bn($.placement) === T ? $.overflows[0] > 0 : !0)))
          return {
            data: {
              index: M,
              overflows: P
            },
            reset: {
              placement: H
            }
          };
        let B = (G = P.filter((Y) => Y.overflows[0] <= 0).sort((Y, $) => Y.overflows[1] - $.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!B)
          switch (p) {
            case "bestFit": {
              var F;
              const Y = (F = P.filter(($) => {
                if (w) {
                  const Z = bn($.placement);
                  return Z === T || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map(($) => [$.placement, $.overflows.filter((Z) => Z > 0).reduce((Z, y) => Z + y, 0)]).sort(($, Z) => $[1] - Z[1])[0]) == null ? void 0 : F[0];
              Y && (B = Y);
              break;
            }
            case "initialPlacement":
              B = o;
              break;
          }
        if (s !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
};
function Rh(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ph(e) {
  return Iw.some((t) => e[t] >= 0);
}
const $w = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: s = "referenceHidden",
        ...i
      } = Mn(e, t);
      switch (s) {
        case "referenceHidden": {
          const a = await r.detectOverflow(t, {
            ...i,
            elementContext: "reference"
          }), o = Rh(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: Ph(o)
            }
          };
        }
        case "escaped": {
          const a = await r.detectOverflow(t, {
            ...i,
            altBoundary: !0
          }), o = Rh(a, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: Ph(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, n0 = /* @__PURE__ */ new Set(["left", "top"]);
async function zw(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), a = Hn(n), o = _s(n), u = bn(n) === "y", c = n0.has(a) ? -1 : 1, l = i && u ? -1 : 1, h = Mn(t, e);
  let {
    mainAxis: m,
    crossAxis: p,
    alignmentAxis: E
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: h.mainAxis || 0,
    crossAxis: h.crossAxis || 0,
    alignmentAxis: h.alignmentAxis
  };
  return o && typeof E == "number" && (p = o === "end" ? E * -1 : E), u ? {
    x: p * l,
    y: m * c
  } : {
    x: m * c,
    y: p * l
  };
}
const Vw = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: i,
        placement: a,
        middlewareData: o
      } = t, u = await zw(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: s + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: a
        }
      };
    }
  };
}, Yw = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: s,
        platform: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: u = {
          fn: (b) => {
            let {
              x: T,
              y: C
            } = b;
            return {
              x: T,
              y: C
            };
          }
        },
        ...c
      } = Mn(e, t), l = {
        x: n,
        y: r
      }, h = await i.detectOverflow(t, c), m = bn(Hn(s)), p = dl(m);
      let E = l[p], g = l[m];
      if (a) {
        const b = p === "y" ? "top" : "left", T = p === "y" ? "bottom" : "right", C = E + h[b], R = E - h[T];
        E = fc(C, E, R);
      }
      if (o) {
        const b = m === "y" ? "top" : "left", T = m === "y" ? "bottom" : "right", C = g + h[b], R = g - h[T];
        g = fc(C, g, R);
      }
      const _ = u.fn({
        ...t,
        [p]: E,
        [m]: g
      });
      return {
        ..._,
        data: {
          x: _.x - n,
          y: _.y - r,
          enabled: {
            [p]: a,
            [m]: o
          }
        }
      };
    }
  };
}, Gw = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: s,
        rects: i,
        middlewareData: a
      } = t, {
        offset: o = 0,
        mainAxis: u = !0,
        crossAxis: c = !0
      } = Mn(e, t), l = {
        x: n,
        y: r
      }, h = bn(s), m = dl(h);
      let p = l[m], E = l[h];
      const g = Mn(o, t), _ = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (u) {
        const C = m === "y" ? "height" : "width", R = i.reference[m] - i.floating[C] + _.mainAxis, D = i.reference[m] + i.reference[C] - _.mainAxis;
        p < R ? p = R : p > D && (p = D);
      }
      if (c) {
        var b, T;
        const C = m === "y" ? "width" : "height", R = n0.has(Hn(s)), D = i.reference[h] - i.floating[C] + (R && ((b = a.offset) == null ? void 0 : b[h]) || 0) + (R ? 0 : _.crossAxis), w = i.reference[h] + i.reference[C] + (R ? 0 : ((T = a.offset) == null ? void 0 : T[h]) || 0) - (R ? _.crossAxis : 0);
        E < D ? E = D : E > w && (E = w);
      }
      return {
        [m]: p,
        [h]: E
      };
    }
  };
}, Ww = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        rects: i,
        platform: a,
        elements: o
      } = t, {
        apply: u = () => {
        },
        ...c
      } = Mn(e, t), l = await a.detectOverflow(t, c), h = Hn(s), m = _s(s), p = bn(s) === "y", {
        width: E,
        height: g
      } = i.floating;
      let _, b;
      h === "top" || h === "bottom" ? (_ = h, b = m === (await (a.isRTL == null ? void 0 : a.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (b = h, _ = m === "end" ? "top" : "bottom");
      const T = g - l.top - l.bottom, C = E - l.left - l.right, R = nr(g - l[_], T), D = nr(E - l[b], C), w = !t.middlewareData.shift;
      let O = R, U = D;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (U = C), (r = t.middlewareData.shift) != null && r.enabled.y && (O = T), w && !m) {
        const P = Ht(l.left, 0), z = Ht(l.right, 0), G = Ht(l.top, 0), F = Ht(l.bottom, 0);
        p ? U = E - 2 * (P !== 0 || z !== 0 ? P + z : Ht(l.left, l.right)) : O = g - 2 * (G !== 0 || F !== 0 ? G + F : Ht(l.top, l.bottom));
      }
      await u({
        ...t,
        availableWidth: U,
        availableHeight: O
      });
      const q = await a.getDimensions(o.floating);
      return E !== q.width || g !== q.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ao() {
  return typeof window < "u";
}
function Ts(e) {
  return r0(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Bt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function yn(e) {
  var t;
  return (t = (r0(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function r0(e) {
  return Ao() ? e instanceof Node || e instanceof Bt(e).Node : !1;
}
function un(e) {
  return Ao() ? e instanceof Element || e instanceof Bt(e).Element : !1;
}
function An(e) {
  return Ao() ? e instanceof HTMLElement || e instanceof Bt(e).HTMLElement : !1;
}
function Oh(e) {
  return !Ao() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Bt(e).ShadowRoot;
}
const qw = /* @__PURE__ */ new Set(["inline", "contents"]);
function Ni(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = cn(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !qw.has(s);
}
const Kw = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Qw(e) {
  return Kw.has(Ts(e));
}
const Xw = [":popover-open", ":modal"];
function yo(e) {
  return Xw.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Jw = ["transform", "translate", "scale", "rotate", "perspective"], Zw = ["transform", "translate", "scale", "rotate", "perspective", "filter"], eI = ["paint", "layout", "strict", "content"];
function pl(e) {
  const t = ml(), n = un(e) ? cn(e) : e;
  return Jw.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Zw.some((r) => (n.willChange || "").includes(r)) || eI.some((r) => (n.contain || "").includes(r));
}
function tI(e) {
  let t = rr(e);
  for (; An(t) && !ds(t); ) {
    if (pl(t))
      return t;
    if (yo(t))
      return null;
    t = rr(t);
  }
  return null;
}
function ml() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const nI = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function ds(e) {
  return nI.has(Ts(e));
}
function cn(e) {
  return Bt(e).getComputedStyle(e);
}
function xo(e) {
  return un(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function rr(e) {
  if (Ts(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Oh(e) && e.host || // Fallback.
    yn(e)
  );
  return Oh(t) ? t.host : t;
}
function s0(e) {
  const t = rr(e);
  return ds(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : An(t) && Ni(t) ? t : s0(t);
}
function pi(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = s0(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Bt(s);
  if (i) {
    const o = mc(a);
    return t.concat(a, a.visualViewport || [], Ni(s) ? s : [], o && n ? pi(o) : []);
  }
  return t.concat(s, pi(s, [], n));
}
function mc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function i0(e) {
  const t = cn(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = An(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : r, o = Fa(n) !== i || Fa(r) !== a;
  return o && (n = i, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function gl(e) {
  return un(e) ? e : e.contextElement;
}
function ss(e) {
  const t = gl(e);
  if (!An(t))
    return _n(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = i0(t);
  let a = (i ? Fa(n.width) : n.width) / r, o = (i ? Fa(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const rI = /* @__PURE__ */ _n(0);
function a0(e) {
  const t = Bt(e);
  return !ml() || !t.visualViewport ? rI : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function sI(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Bt(e) ? !1 : t;
}
function kr(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = gl(e);
  let a = _n(1);
  t && (r ? un(r) && (a = ss(r)) : a = ss(e));
  const o = sI(i, n, r) ? a0(i) : _n(0);
  let u = (s.left + o.x) / a.x, c = (s.top + o.y) / a.y, l = s.width / a.x, h = s.height / a.y;
  if (i) {
    const m = Bt(i), p = r && un(r) ? Bt(r) : r;
    let E = m, g = mc(E);
    for (; g && r && p !== E; ) {
      const _ = ss(g), b = g.getBoundingClientRect(), T = cn(g), C = b.left + (g.clientLeft + parseFloat(T.paddingLeft)) * _.x, R = b.top + (g.clientTop + parseFloat(T.paddingTop)) * _.y;
      u *= _.x, c *= _.y, l *= _.x, h *= _.y, u += C, c += R, E = Bt(g), g = mc(E);
    }
  }
  return $a({
    width: l,
    height: h,
    x: u,
    y: c
  });
}
function Co(e, t) {
  const n = xo(e).scrollLeft;
  return t ? t.left + n : kr(yn(e)).left + n;
}
function o0(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Co(e, n), s = n.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function iI(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", a = yn(r), o = t ? yo(t.floating) : !1;
  if (r === a || o && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = _n(1);
  const l = _n(0), h = An(r);
  if ((h || !h && !i) && ((Ts(r) !== "body" || Ni(a)) && (u = xo(r)), An(r))) {
    const p = kr(r);
    c = ss(r), l.x = p.x + r.clientLeft, l.y = p.y + r.clientTop;
  }
  const m = a && !h && !i ? o0(a, u) : _n(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - u.scrollLeft * c.x + l.x + m.x,
    y: n.y * c.y - u.scrollTop * c.y + l.y + m.y
  };
}
function aI(e) {
  return Array.from(e.getClientRects());
}
function oI(e) {
  const t = yn(e), n = xo(e), r = e.ownerDocument.body, s = Ht(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Ht(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Co(e);
  const o = -n.scrollTop;
  return cn(r).direction === "rtl" && (a += Ht(t.clientWidth, r.clientWidth) - s), {
    width: s,
    height: i,
    x: a,
    y: o
  };
}
const Dh = 25;
function uI(e, t) {
  const n = Bt(e), r = yn(e), s = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, o = 0, u = 0;
  if (s) {
    i = s.width, a = s.height;
    const l = ml();
    (!l || l && t === "fixed") && (o = s.offsetLeft, u = s.offsetTop);
  }
  const c = Co(r);
  if (c <= 0) {
    const l = r.ownerDocument, h = l.body, m = getComputedStyle(h), p = l.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, E = Math.abs(r.clientWidth - h.clientWidth - p);
    E <= Dh && (i -= E);
  } else c <= Dh && (i += c);
  return {
    width: i,
    height: a,
    x: o,
    y: u
  };
}
const cI = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function lI(e, t) {
  const n = kr(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, i = An(e) ? ss(e) : _n(1), a = e.clientWidth * i.x, o = e.clientHeight * i.y, u = s * i.x, c = r * i.y;
  return {
    width: a,
    height: o,
    x: u,
    y: c
  };
}
function Lh(e, t, n) {
  let r;
  if (t === "viewport")
    r = uI(e, n);
  else if (t === "document")
    r = oI(yn(e));
  else if (un(t))
    r = lI(t, n);
  else {
    const s = a0(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return $a(r);
}
function u0(e, t) {
  const n = rr(e);
  return n === t || !un(n) || ds(n) ? !1 : cn(n).position === "fixed" || u0(n, t);
}
function dI(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = pi(e, [], !1).filter((o) => un(o) && Ts(o) !== "body"), s = null;
  const i = cn(e).position === "fixed";
  let a = i ? rr(e) : e;
  for (; un(a) && !ds(a); ) {
    const o = cn(a), u = pl(a);
    !u && o.position === "fixed" && (s = null), (i ? !u && !s : !u && o.position === "static" && !!s && cI.has(s.position) || Ni(a) && !u && u0(e, a)) ? r = r.filter((l) => l !== a) : s = o, a = rr(a);
  }
  return t.set(e, r), r;
}
function hI(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const a = [...n === "clippingAncestors" ? yo(t) ? [] : dI(t, this._c) : [].concat(n), r], o = a[0], u = a.reduce((c, l) => {
    const h = Lh(t, l, s);
    return c.top = Ht(h.top, c.top), c.right = nr(h.right, c.right), c.bottom = nr(h.bottom, c.bottom), c.left = Ht(h.left, c.left), c;
  }, Lh(t, o, s));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function fI(e) {
  const {
    width: t,
    height: n
  } = i0(e);
  return {
    width: t,
    height: n
  };
}
function pI(e, t, n) {
  const r = An(t), s = yn(t), i = n === "fixed", a = kr(e, !0, i, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = _n(0);
  function c() {
    u.x = Co(s);
  }
  if (r || !r && !i)
    if ((Ts(t) !== "body" || Ni(s)) && (o = xo(t)), r) {
      const p = kr(t, !0, i, t);
      u.x = p.x + t.clientLeft, u.y = p.y + t.clientTop;
    } else s && c();
  i && !r && s && c();
  const l = s && !r && !i ? o0(s, o) : _n(0), h = a.left + o.scrollLeft - u.x - l.x, m = a.top + o.scrollTop - u.y - l.y;
  return {
    x: h,
    y: m,
    width: a.width,
    height: a.height
  };
}
function _u(e) {
  return cn(e).position === "static";
}
function Mh(e, t) {
  if (!An(e) || cn(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return yn(e) === n && (n = n.ownerDocument.body), n;
}
function c0(e, t) {
  const n = Bt(e);
  if (yo(e))
    return n;
  if (!An(e)) {
    let s = rr(e);
    for (; s && !ds(s); ) {
      if (un(s) && !_u(s))
        return s;
      s = rr(s);
    }
    return n;
  }
  let r = Mh(e, t);
  for (; r && Qw(r) && _u(r); )
    r = Mh(r, t);
  return r && ds(r) && _u(r) && !pl(r) ? n : r || tI(e) || n;
}
const mI = async function(e) {
  const t = this.getOffsetParent || c0, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: pI(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function gI(e) {
  return cn(e).direction === "rtl";
}
const EI = {
  convertOffsetParentRelativeRectToViewportRelativeRect: iI,
  getDocumentElement: yn,
  getClippingRect: hI,
  getOffsetParent: c0,
  getElementRects: mI,
  getClientRects: aI,
  getDimensions: fI,
  getScale: ss,
  isElement: un,
  isRTL: gI
};
function l0(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function bI(e, t) {
  let n = null, r;
  const s = yn(e);
  function i() {
    var o;
    clearTimeout(r), (o = n) == null || o.disconnect(), n = null;
  }
  function a(o, u) {
    o === void 0 && (o = !1), u === void 0 && (u = 1), i();
    const c = e.getBoundingClientRect(), {
      left: l,
      top: h,
      width: m,
      height: p
    } = c;
    if (o || t(), !m || !p)
      return;
    const E = ta(h), g = ta(s.clientWidth - (l + m)), _ = ta(s.clientHeight - (h + p)), b = ta(l), C = {
      rootMargin: -E + "px " + -g + "px " + -_ + "px " + -b + "px",
      threshold: Ht(0, nr(1, u)) || 1
    };
    let R = !0;
    function D(w) {
      const O = w[0].intersectionRatio;
      if (O !== u) {
        if (!R)
          return a();
        O ? a(!1, O) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      O === 1 && !l0(c, e.getBoundingClientRect()) && a(), R = !1;
    }
    try {
      n = new IntersectionObserver(D, {
        ...C,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(D, C);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function _I(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, c = gl(e), l = s || i ? [...c ? pi(c) : [], ...pi(t)] : [];
  l.forEach((b) => {
    s && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const h = c && o ? bI(c, n) : null;
  let m = -1, p = null;
  a && (p = new ResizeObserver((b) => {
    let [T] = b;
    T && T.target === c && p && (p.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(t);
    })), n();
  }), c && !u && p.observe(c), p.observe(t));
  let E, g = u ? kr(e) : null;
  u && _();
  function _() {
    const b = kr(e);
    g && !l0(g, b) && n(), g = b, E = requestAnimationFrame(_);
  }
  return n(), () => {
    var b;
    l.forEach((T) => {
      s && T.removeEventListener("scroll", n), i && T.removeEventListener("resize", n);
    }), h?.(), (b = p) == null || b.disconnect(), p = null, u && cancelAnimationFrame(E);
  };
}
const TI = Vw, AI = Yw, yI = jw, xI = Ww, CI = $w, Hh = Fw, SI = Gw, wI = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = {
    platform: EI,
    ...n
  }, i = {
    ...s.platform,
    _c: r
  };
  return Uw(e, t, {
    ...s,
    platform: i
  });
};
var II = typeof document < "u", vI = function() {
}, ya = II ? os : vI;
function za(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, s;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!za(e[r], t[r]))
          return !1;
      return !0;
    }
    if (s = Object.keys(e), n = s.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, s[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = s[r];
      if (!(i === "_owner" && e.$$typeof) && !za(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function d0(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bh(e, t) {
  const n = d0(e);
  return Math.round(t * n) / n;
}
function Tu(e) {
  const t = A.useRef(e);
  return ya(() => {
    t.current = e;
  }), t;
}
function NI(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: s,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: o = !0,
    whileElementsMounted: u,
    open: c
  } = e, [l, h] = A.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, p] = A.useState(r);
  za(m, r) || p(r);
  const [E, g] = A.useState(null), [_, b] = A.useState(null), T = A.useCallback(($) => {
    $ !== w.current && (w.current = $, g($));
  }, []), C = A.useCallback(($) => {
    $ !== O.current && (O.current = $, b($));
  }, []), R = i || E, D = a || _, w = A.useRef(null), O = A.useRef(null), U = A.useRef(l), q = u != null, P = Tu(u), z = Tu(s), G = Tu(c), F = A.useCallback(() => {
    if (!w.current || !O.current)
      return;
    const $ = {
      placement: t,
      strategy: n,
      middleware: m
    };
    z.current && ($.platform = z.current), wI(w.current, O.current, $).then((Z) => {
      const y = {
        ...Z,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: G.current !== !1
      };
      M.current && !za(U.current, y) && (U.current = y, so.flushSync(() => {
        h(y);
      }));
    });
  }, [m, t, n, z, G]);
  ya(() => {
    c === !1 && U.current.isPositioned && (U.current.isPositioned = !1, h(($) => ({
      ...$,
      isPositioned: !1
    })));
  }, [c]);
  const M = A.useRef(!1);
  ya(() => (M.current = !0, () => {
    M.current = !1;
  }), []), ya(() => {
    if (R && (w.current = R), D && (O.current = D), R && D) {
      if (P.current)
        return P.current(R, D, F);
      F();
    }
  }, [R, D, F, P, q]);
  const H = A.useMemo(() => ({
    reference: w,
    floating: O,
    setReference: T,
    setFloating: C
  }), [T, C]), B = A.useMemo(() => ({
    reference: R,
    floating: D
  }), [R, D]), Y = A.useMemo(() => {
    const $ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!B.floating)
      return $;
    const Z = Bh(B.floating, l.x), y = Bh(B.floating, l.y);
    return o ? {
      ...$,
      transform: "translate(" + Z + "px, " + y + "px)",
      ...d0(B.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Z,
      top: y
    };
  }, [n, o, B.floating, l.x, l.y]);
  return A.useMemo(() => ({
    ...l,
    update: F,
    refs: H,
    elements: B,
    floatingStyles: Y
  }), [l, F, H, B, Y]);
}
const kI = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: s
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Hh({
        element: r.current,
        padding: s
      }).fn(n) : {} : r ? Hh({
        element: r,
        padding: s
      }).fn(n) : {};
    }
  };
}, RI = (e, t) => ({
  ...TI(e),
  options: [e, t]
}), PI = (e, t) => ({
  ...AI(e),
  options: [e, t]
}), OI = (e, t) => ({
  ...SI(e),
  options: [e, t]
}), DI = (e, t) => ({
  ...yI(e),
  options: [e, t]
}), LI = (e, t) => ({
  ...xI(e),
  options: [e, t]
}), MI = (e, t) => ({
  ...CI(e),
  options: [e, t]
}), HI = (e, t) => ({
  ...kI(e),
  options: [e, t]
});
var BI = "Arrow", h0 = A.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: s = 5, ...i } = e;
  return /* @__PURE__ */ d.jsx(
    Ve.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: s,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
h0.displayName = BI;
var UI = h0, El = "Popper", [f0, As] = bs(El), [FI, p0] = f0(El), m0 = (e) => {
  const { __scopePopper: t, children: n } = e, [r, s] = A.useState(null);
  return /* @__PURE__ */ d.jsx(FI, { scope: t, anchor: r, onAnchorChange: s, children: n });
};
m0.displayName = El;
var g0 = "PopperAnchor", E0 = A.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...s } = e, i = p0(g0, n), a = A.useRef(null), o = ze(t, a), u = A.useRef(null);
    return A.useEffect(() => {
      const c = u.current;
      u.current = r?.current || a.current, c !== u.current && i.onAnchorChange(u.current);
    }), r ? null : /* @__PURE__ */ d.jsx(Ve.div, { ...s, ref: o });
  }
);
E0.displayName = g0;
var bl = "PopperContent", [jI, $I] = f0(bl), b0 = A.forwardRef(
  (e, t) => {
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: s = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: o = 0,
      avoidCollisions: u = !0,
      collisionBoundary: c = [],
      collisionPadding: l = 0,
      sticky: h = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: E,
      ...g
    } = e, _ = p0(bl, n), [b, T] = A.useState(null), C = ze(t, (re) => T(re)), [R, D] = A.useState(null), w = ww(R), O = w?.width ?? 0, U = w?.height ?? 0, q = r + (i !== "center" ? "-" + i : ""), P = typeof l == "number" ? l : { top: 0, right: 0, bottom: 0, left: 0, ...l }, z = Array.isArray(c) ? c : [c], G = z.length > 0, F = {
      padding: P,
      boundary: z.filter(VI),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: G
    }, { refs: M, floatingStyles: H, placement: B, isPositioned: Y, middlewareData: $ } = NI({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: q,
      whileElementsMounted: (...re) => _I(...re, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: _.anchor
      },
      middleware: [
        RI({ mainAxis: s + U, alignmentAxis: a }),
        u && PI({
          mainAxis: !0,
          crossAxis: !1,
          limiter: h === "partial" ? OI() : void 0,
          ...F
        }),
        u && DI({ ...F }),
        LI({
          ...F,
          apply: ({ elements: re, rects: Ae, availableWidth: he, availableHeight: le }) => {
            const { width: ye, height: Pe } = Ae.reference, qe = re.floating.style;
            qe.setProperty("--radix-popper-available-width", `${he}px`), qe.setProperty("--radix-popper-available-height", `${le}px`), qe.setProperty("--radix-popper-anchor-width", `${ye}px`), qe.setProperty("--radix-popper-anchor-height", `${Pe}px`);
          }
        }),
        R && HI({ element: R, padding: o }),
        YI({ arrowWidth: O, arrowHeight: U }),
        m && MI({ strategy: "referenceHidden", ...F })
      ]
    }), [Z, y] = A0(B), fe = jt(E);
    _t(() => {
      Y && fe?.();
    }, [Y, fe]);
    const Ce = $.arrow?.x, v = $.arrow?.y, Se = $.arrow?.centerOffset !== 0, [Te, pe] = A.useState();
    return _t(() => {
      b && pe(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ d.jsx(
      "div",
      {
        ref: M.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...H,
          transform: Y ? H.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Te,
          "--radix-popper-transform-origin": [
            $.transformOrigin?.x,
            $.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...$.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d.jsx(
          jI,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: D,
            arrowX: Ce,
            arrowY: v,
            shouldHideArrow: Se,
            children: /* @__PURE__ */ d.jsx(
              Ve.div,
              {
                "data-side": Z,
                "data-align": y,
                ...g,
                ref: C,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Y ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
b0.displayName = bl;
var _0 = "PopperArrow", zI = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, T0 = A.forwardRef(function(t, n) {
  const { __scopePopper: r, ...s } = t, i = $I(_0, r), a = zI[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d.jsx(
          UI,
          {
            ...s,
            ref: n,
            style: {
              ...s.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
T0.displayName = _0;
function VI(e) {
  return e !== null;
}
var YI = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: r, middlewareData: s } = t, a = s.arrow?.centerOffset !== 0, o = a ? 0 : e.arrowWidth, u = a ? 0 : e.arrowHeight, [c, l] = A0(n), h = { start: "0%", center: "50%", end: "100%" }[l], m = (s.arrow?.x ?? 0) + o / 2, p = (s.arrow?.y ?? 0) + u / 2;
    let E = "", g = "";
    return c === "bottom" ? (E = a ? h : `${m}px`, g = `${-u}px`) : c === "top" ? (E = a ? h : `${m}px`, g = `${r.floating.height + u}px`) : c === "right" ? (E = `${-u}px`, g = a ? h : `${p}px`) : c === "left" && (E = `${r.floating.width + u}px`, g = a ? h : `${p}px`), { data: { x: E, y: g } };
  }
});
function A0(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var _l = m0, So = E0, Tl = b0, Al = T0;
function Uh(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var wo = "Popover", [y0] = bs(wo, [
  As
]), ki = As(), [GI, ar] = y0(wo), x0 = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    modal: a = !1
  } = e, o = ki(t), u = A.useRef(null), [c, l] = A.useState(!1), [h, m] = fi({
    prop: r,
    defaultProp: s ?? !1,
    onChange: i,
    caller: wo
  });
  return /* @__PURE__ */ d.jsx(_l, { ...o, children: /* @__PURE__ */ d.jsx(
    GI,
    {
      scope: t,
      contentId: Jn(),
      triggerRef: u,
      open: h,
      onOpenChange: m,
      onOpenToggle: A.useCallback(() => m((p) => !p), [m]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: A.useCallback(() => l(!0), []),
      onCustomAnchorRemove: A.useCallback(() => l(!1), []),
      modal: a,
      children: n
    }
  ) });
};
x0.displayName = wo;
var C0 = "PopoverAnchor", WI = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = ar(C0, n), i = ki(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: o } = s;
    return A.useEffect(() => (a(), () => o()), [a, o]), /* @__PURE__ */ d.jsx(So, { ...i, ...r, ref: t });
  }
);
WI.displayName = C0;
var S0 = "PopoverTrigger", w0 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = ar(S0, n), i = ki(n), a = ze(t, s.triggerRef), o = /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": s.open,
        "aria-controls": s.contentId,
        "data-state": R0(s.open),
        ...r,
        ref: a,
        onClick: be(e.onClick, s.onOpenToggle)
      }
    );
    return s.hasCustomAnchor ? o : /* @__PURE__ */ d.jsx(So, { asChild: !0, ...i, children: o });
  }
);
w0.displayName = S0;
var yl = "PopoverPortal", [qI, KI] = y0(yl, {
  forceMount: void 0
}), I0 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: s } = e, i = ar(yl, t);
  return /* @__PURE__ */ d.jsx(qI, { scope: t, forceMount: n, children: /* @__PURE__ */ d.jsx(ir, { present: n || i.open, children: /* @__PURE__ */ d.jsx(vi, { asChild: !0, container: s, children: r }) }) });
};
I0.displayName = yl;
var hs = "PopoverContent", v0 = A.forwardRef(
  (e, t) => {
    const n = KI(hs, e.__scopePopover), { forceMount: r = n.forceMount, ...s } = e, i = ar(hs, e.__scopePopover);
    return /* @__PURE__ */ d.jsx(ir, { present: r || i.open, children: i.modal ? /* @__PURE__ */ d.jsx(XI, { ...s, ref: t }) : /* @__PURE__ */ d.jsx(JI, { ...s, ref: t }) });
  }
);
v0.displayName = hs;
var QI = /* @__PURE__ */ vr("PopoverContent.RemoveScroll"), XI = A.forwardRef(
  (e, t) => {
    const n = ar(hs, e.__scopePopover), r = A.useRef(null), s = ze(t, r), i = A.useRef(!1);
    return A.useEffect(() => {
      const a = r.current;
      if (a) return ol(a);
    }, []), /* @__PURE__ */ d.jsx(_o, { as: QI, allowPinchZoom: !0, children: /* @__PURE__ */ d.jsx(
      N0,
      {
        ...e,
        ref: s,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), i.current || n.triggerRef.current?.focus();
        }),
        onPointerDownOutside: be(
          e.onPointerDownOutside,
          (a) => {
            const o = a.detail.originalEvent, u = o.button === 0 && o.ctrlKey === !0, c = o.button === 2 || u;
            i.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: be(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), JI = A.forwardRef(
  (e, t) => {
    const n = ar(hs, e.__scopePopover), r = A.useRef(!1), s = A.useRef(!1);
    return /* @__PURE__ */ d.jsx(
      N0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (r.current || n.triggerRef.current?.focus(), i.preventDefault()), r.current = !1, s.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (s.current = !0));
          const a = i.target;
          n.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && s.current && i.preventDefault();
        }
      }
    );
  }
), N0 = A.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: s,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: o,
      onPointerDownOutside: u,
      onFocusOutside: c,
      onInteractOutside: l,
      ...h
    } = e, m = ar(hs, n), p = ki(n);
    return al(), /* @__PURE__ */ d.jsx(
      Eo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: s,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ d.jsx(
          Ii,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: l,
            onEscapeKeyDown: o,
            onPointerDownOutside: u,
            onFocusOutside: c,
            onDismiss: () => m.onOpenChange(!1),
            children: /* @__PURE__ */ d.jsx(
              Tl,
              {
                "data-state": R0(m.open),
                role: "dialog",
                id: m.contentId,
                ...p,
                ...h,
                ref: t,
                style: {
                  ...h.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), k0 = "PopoverClose", ZI = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = ar(k0, n);
    return /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: be(e.onClick, () => s.onOpenChange(!1))
      }
    );
  }
);
ZI.displayName = k0;
var e2 = "PopoverArrow", t2 = A.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, s = ki(n);
    return /* @__PURE__ */ d.jsx(Al, { ...s, ...r, ref: t });
  }
);
t2.displayName = e2;
function R0(e) {
  return e ? "open" : "closed";
}
var n2 = x0, r2 = w0, s2 = I0, i2 = v0, a2 = [" ", "Enter", "ArrowUp", "ArrowDown"], o2 = [" ", "Enter"], Rr = "Select", [Io, vo, u2] = XC(Rr), [ys] = bs(Rr, [
  u2,
  As
]), No = As(), [c2, or] = ys(Rr), [l2, d2] = ys(Rr), P0 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    value: a,
    defaultValue: o,
    onValueChange: u,
    dir: c,
    name: l,
    autoComplete: h,
    disabled: m,
    required: p,
    form: E
  } = e, g = No(t), [_, b] = A.useState(null), [T, C] = A.useState(null), [R, D] = A.useState(!1), w = oS(c), [O, U] = fi({
    prop: r,
    defaultProp: s ?? !1,
    onChange: i,
    caller: Rr
  }), [q, P] = fi({
    prop: a,
    defaultProp: o,
    onChange: u,
    caller: Rr
  }), z = A.useRef(null), G = _ ? E || !!_.closest("form") : !0, [F, M] = A.useState(/* @__PURE__ */ new Set()), H = Array.from(F).map((B) => B.props.value).join(";");
  return /* @__PURE__ */ d.jsx(_l, { ...g, children: /* @__PURE__ */ d.jsxs(
    c2,
    {
      required: p,
      scope: t,
      trigger: _,
      onTriggerChange: b,
      valueNode: T,
      onValueNodeChange: C,
      valueNodeHasChildren: R,
      onValueNodeHasChildrenChange: D,
      contentId: Jn(),
      value: q,
      onValueChange: P,
      open: O,
      onOpenChange: U,
      dir: w,
      triggerPointerDownPosRef: z,
      disabled: m,
      children: [
        /* @__PURE__ */ d.jsx(Io.Provider, { scope: t, children: /* @__PURE__ */ d.jsx(
          l2,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: A.useCallback((B) => {
              M((Y) => new Set(Y).add(B));
            }, []),
            onNativeOptionRemove: A.useCallback((B) => {
              M((Y) => {
                const $ = new Set(Y);
                return $.delete(B), $;
              });
            }, []),
            children: n
          }
        ) }),
        G ? /* @__PURE__ */ d.jsxs(
          eE,
          {
            "aria-hidden": !0,
            required: p,
            tabIndex: -1,
            name: l,
            autoComplete: h,
            value: q,
            onChange: (B) => P(B.target.value),
            disabled: m,
            form: E,
            children: [
              q === void 0 ? /* @__PURE__ */ d.jsx("option", { value: "" }) : null,
              Array.from(F)
            ]
          },
          H
        ) : null
      ]
    }
  ) });
};
P0.displayName = Rr;
var O0 = "SelectTrigger", D0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...s } = e, i = No(n), a = or(O0, n), o = a.disabled || r, u = ze(t, a.onTriggerChange), c = vo(n), l = A.useRef("touch"), [h, m, p] = nE((g) => {
      const _ = c().filter((C) => !C.disabled), b = _.find((C) => C.value === a.value), T = rE(_, g, b);
      T !== void 0 && a.onValueChange(T.value);
    }), E = (g) => {
      o || (a.onOpenChange(!0), p()), g && (a.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ d.jsx(So, { asChild: !0, ...i, children: /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-placeholder": tE(a.value) ? "" : void 0,
        ...s,
        ref: u,
        onClick: be(s.onClick, (g) => {
          g.currentTarget.focus(), l.current !== "mouse" && E(g);
        }),
        onPointerDown: be(s.onPointerDown, (g) => {
          l.current = g.pointerType;
          const _ = g.target;
          _.hasPointerCapture(g.pointerId) && _.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (E(g), g.preventDefault());
        }),
        onKeyDown: be(s.onKeyDown, (g) => {
          const _ = h.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && m(g.key), !(_ && g.key === " ") && a2.includes(g.key) && (E(), g.preventDefault());
        })
      }
    ) });
  }
);
D0.displayName = O0;
var L0 = "SelectValue", M0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: s, children: i, placeholder: a = "", ...o } = e, u = or(L0, n), { onValueNodeHasChildrenChange: c } = u, l = i !== void 0, h = ze(t, u.onValueNodeChange);
    return _t(() => {
      c(l);
    }, [c, l]), /* @__PURE__ */ d.jsx(
      Ve.span,
      {
        ...o,
        ref: h,
        style: { pointerEvents: "none" },
        children: tE(u.value) ? /* @__PURE__ */ d.jsx(d.Fragment, { children: a }) : i
      }
    );
  }
);
M0.displayName = L0;
var h2 = "SelectIcon", H0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...s } = e;
    return /* @__PURE__ */ d.jsx(Ve.span, { "aria-hidden": !0, ...s, ref: t, children: r || "▼" });
  }
);
H0.displayName = h2;
var f2 = "SelectPortal", B0 = (e) => /* @__PURE__ */ d.jsx(vi, { asChild: !0, ...e });
B0.displayName = f2;
var Pr = "SelectContent", U0 = A.forwardRef(
  (e, t) => {
    const n = or(Pr, e.__scopeSelect), [r, s] = A.useState();
    if (_t(() => {
      s(new DocumentFragment());
    }, []), !n.open) {
      const i = r;
      return i ? so.createPortal(
        /* @__PURE__ */ d.jsx(F0, { scope: e.__scopeSelect, children: /* @__PURE__ */ d.jsx(Io.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ d.jsx("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ d.jsx(j0, { ...e, ref: t });
  }
);
U0.displayName = Pr;
var tn = 10, [F0, ur] = ys(Pr), p2 = "SelectContentImpl", m2 = /* @__PURE__ */ vr("SelectContent.RemoveScroll"), j0 = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: o,
      sideOffset: u,
      align: c,
      alignOffset: l,
      arrowPadding: h,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: E,
      hideWhenDetached: g,
      avoidCollisions: _,
      //
      ...b
    } = e, T = or(Pr, n), [C, R] = A.useState(null), [D, w] = A.useState(null), O = ze(t, (re) => R(re)), [U, q] = A.useState(null), [P, z] = A.useState(
      null
    ), G = vo(n), [F, M] = A.useState(!1), H = A.useRef(!1);
    A.useEffect(() => {
      if (C) return ol(C);
    }, [C]), al();
    const B = A.useCallback(
      (re) => {
        const [Ae, ...he] = G().map((Pe) => Pe.ref.current), [le] = he.slice(-1), ye = document.activeElement;
        for (const Pe of re)
          if (Pe === ye || (Pe?.scrollIntoView({ block: "nearest" }), Pe === Ae && D && (D.scrollTop = 0), Pe === le && D && (D.scrollTop = D.scrollHeight), Pe?.focus(), document.activeElement !== ye)) return;
      },
      [G, D]
    ), Y = A.useCallback(
      () => B([U, C]),
      [B, U, C]
    );
    A.useEffect(() => {
      F && Y();
    }, [F, Y]);
    const { onOpenChange: $, triggerPointerDownPosRef: Z } = T;
    A.useEffect(() => {
      if (C) {
        let re = { x: 0, y: 0 };
        const Ae = (le) => {
          re = {
            x: Math.abs(Math.round(le.pageX) - (Z.current?.x ?? 0)),
            y: Math.abs(Math.round(le.pageY) - (Z.current?.y ?? 0))
          };
        }, he = (le) => {
          re.x <= 10 && re.y <= 10 ? le.preventDefault() : C.contains(le.target) || $(!1), document.removeEventListener("pointermove", Ae), Z.current = null;
        };
        return Z.current !== null && (document.addEventListener("pointermove", Ae), document.addEventListener("pointerup", he, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Ae), document.removeEventListener("pointerup", he, { capture: !0 });
        };
      }
    }, [C, $, Z]), A.useEffect(() => {
      const re = () => $(!1);
      return window.addEventListener("blur", re), window.addEventListener("resize", re), () => {
        window.removeEventListener("blur", re), window.removeEventListener("resize", re);
      };
    }, [$]);
    const [y, fe] = nE((re) => {
      const Ae = G().filter((ye) => !ye.disabled), he = Ae.find((ye) => ye.ref.current === document.activeElement), le = rE(Ae, re, he);
      le && setTimeout(() => le.ref.current.focus());
    }), Ce = A.useCallback(
      (re, Ae, he) => {
        const le = !H.current && !he;
        (T.value !== void 0 && T.value === Ae || le) && (q(re), le && (H.current = !0));
      },
      [T.value]
    ), v = A.useCallback(() => C?.focus(), [C]), Se = A.useCallback(
      (re, Ae, he) => {
        const le = !H.current && !he;
        (T.value !== void 0 && T.value === Ae || le) && z(re);
      },
      [T.value]
    ), Te = r === "popper" ? gc : $0, pe = Te === gc ? {
      side: o,
      sideOffset: u,
      align: c,
      alignOffset: l,
      arrowPadding: h,
      collisionBoundary: m,
      collisionPadding: p,
      sticky: E,
      hideWhenDetached: g,
      avoidCollisions: _
    } : {};
    return /* @__PURE__ */ d.jsx(
      F0,
      {
        scope: n,
        content: C,
        viewport: D,
        onViewportChange: w,
        itemRefCallback: Ce,
        selectedItem: U,
        onItemLeave: v,
        itemTextRefCallback: Se,
        focusSelectedItem: Y,
        selectedItemText: P,
        position: r,
        isPositioned: F,
        searchRef: y,
        children: /* @__PURE__ */ d.jsx(_o, { as: m2, allowPinchZoom: !0, children: /* @__PURE__ */ d.jsx(
          Eo,
          {
            asChild: !0,
            trapped: T.open,
            onMountAutoFocus: (re) => {
              re.preventDefault();
            },
            onUnmountAutoFocus: be(s, (re) => {
              T.trigger?.focus({ preventScroll: !0 }), re.preventDefault();
            }),
            children: /* @__PURE__ */ d.jsx(
              Ii,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (re) => re.preventDefault(),
                onDismiss: () => T.onOpenChange(!1),
                children: /* @__PURE__ */ d.jsx(
                  Te,
                  {
                    role: "listbox",
                    id: T.contentId,
                    "data-state": T.open ? "open" : "closed",
                    dir: T.dir,
                    onContextMenu: (re) => re.preventDefault(),
                    ...b,
                    ...pe,
                    onPlaced: () => M(!0),
                    ref: O,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: be(b.onKeyDown, (re) => {
                      const Ae = re.ctrlKey || re.altKey || re.metaKey;
                      if (re.key === "Tab" && re.preventDefault(), !Ae && re.key.length === 1 && fe(re.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(re.key)) {
                        let le = G().filter((ye) => !ye.disabled).map((ye) => ye.ref.current);
                        if (["ArrowUp", "End"].includes(re.key) && (le = le.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(re.key)) {
                          const ye = re.target, Pe = le.indexOf(ye);
                          le = le.slice(Pe + 1);
                        }
                        setTimeout(() => B(le)), re.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
j0.displayName = p2;
var g2 = "SelectItemAlignedPosition", $0 = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...s } = e, i = or(Pr, n), a = ur(Pr, n), [o, u] = A.useState(null), [c, l] = A.useState(null), h = ze(t, (O) => l(O)), m = vo(n), p = A.useRef(!1), E = A.useRef(!0), { viewport: g, selectedItem: _, selectedItemText: b, focusSelectedItem: T } = a, C = A.useCallback(() => {
    if (i.trigger && i.valueNode && o && c && g && _ && b) {
      const O = i.trigger.getBoundingClientRect(), U = c.getBoundingClientRect(), q = i.valueNode.getBoundingClientRect(), P = b.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const ye = P.left - U.left, Pe = q.left - ye, qe = O.left - Pe, gt = O.width + qe, Xt = Math.max(gt, U.width), zt = window.innerWidth - tn, Sn = Uh(Pe, [
          tn,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(tn, zt - Xt)
        ]);
        o.style.minWidth = gt + "px", o.style.left = Sn + "px";
      } else {
        const ye = U.right - P.right, Pe = window.innerWidth - q.right - ye, qe = window.innerWidth - O.right - Pe, gt = O.width + qe, Xt = Math.max(gt, U.width), zt = window.innerWidth - tn, Sn = Uh(Pe, [
          tn,
          Math.max(tn, zt - Xt)
        ]);
        o.style.minWidth = gt + "px", o.style.right = Sn + "px";
      }
      const z = m(), G = window.innerHeight - tn * 2, F = g.scrollHeight, M = window.getComputedStyle(c), H = parseInt(M.borderTopWidth, 10), B = parseInt(M.paddingTop, 10), Y = parseInt(M.borderBottomWidth, 10), $ = parseInt(M.paddingBottom, 10), Z = H + B + F + $ + Y, y = Math.min(_.offsetHeight * 5, Z), fe = window.getComputedStyle(g), Ce = parseInt(fe.paddingTop, 10), v = parseInt(fe.paddingBottom, 10), Se = O.top + O.height / 2 - tn, Te = G - Se, pe = _.offsetHeight / 2, re = _.offsetTop + pe, Ae = H + B + re, he = Z - Ae;
      if (Ae <= Se) {
        const ye = z.length > 0 && _ === z[z.length - 1].ref.current;
        o.style.bottom = "0px";
        const Pe = c.clientHeight - g.offsetTop - g.offsetHeight, qe = Math.max(
          Te,
          pe + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (ye ? v : 0) + Pe + Y
        ), gt = Ae + qe;
        o.style.height = gt + "px";
      } else {
        const ye = z.length > 0 && _ === z[0].ref.current;
        o.style.top = "0px";
        const qe = Math.max(
          Se,
          H + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (ye ? Ce : 0) + pe
        ) + he;
        o.style.height = qe + "px", g.scrollTop = Ae - Se + g.offsetTop;
      }
      o.style.margin = `${tn}px 0`, o.style.minHeight = y + "px", o.style.maxHeight = G + "px", r?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    o,
    c,
    g,
    _,
    b,
    i.dir,
    r
  ]);
  _t(() => C(), [C]);
  const [R, D] = A.useState();
  _t(() => {
    c && D(window.getComputedStyle(c).zIndex);
  }, [c]);
  const w = A.useCallback(
    (O) => {
      O && E.current === !0 && (C(), T?.(), E.current = !1);
    },
    [C, T]
  );
  return /* @__PURE__ */ d.jsx(
    b2,
    {
      scope: n,
      contentWrapper: o,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: w,
      children: /* @__PURE__ */ d.jsx(
        "div",
        {
          ref: u,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: R
          },
          children: /* @__PURE__ */ d.jsx(
            Ve.div,
            {
              ...s,
              ref: h,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...s.style
              }
            }
          )
        }
      )
    }
  );
});
$0.displayName = g2;
var E2 = "SelectPopperPosition", gc = A.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: s = tn,
    ...i
  } = e, a = No(n);
  return /* @__PURE__ */ d.jsx(
    Tl,
    {
      ...a,
      ...i,
      ref: t,
      align: r,
      collisionPadding: s,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
gc.displayName = E2;
var [b2, xl] = ys(Pr, {}), Ec = "SelectViewport", z0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...s } = e, i = ur(Ec, n), a = xl(Ec, n), o = ze(t, i.onViewportChange), u = A.useRef(0);
    return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ d.jsx(Io.Slot, { scope: n, children: /* @__PURE__ */ d.jsx(
        Ve.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...s,
          ref: o,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...s.style
          },
          onScroll: be(s.onScroll, (c) => {
            const l = c.currentTarget, { contentWrapper: h, shouldExpandOnScrollRef: m } = a;
            if (m?.current && h) {
              const p = Math.abs(u.current - l.scrollTop);
              if (p > 0) {
                const E = window.innerHeight - tn * 2, g = parseFloat(h.style.minHeight), _ = parseFloat(h.style.height), b = Math.max(g, _);
                if (b < E) {
                  const T = b + p, C = Math.min(E, T), R = T - C;
                  h.style.height = C + "px", h.style.bottom === "0px" && (l.scrollTop = R > 0 ? R : 0, h.style.justifyContent = "flex-end");
                }
              }
            }
            u.current = l.scrollTop;
          })
        }
      ) })
    ] });
  }
);
z0.displayName = Ec;
var V0 = "SelectGroup", [_2, T2] = ys(V0), A2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, s = Jn();
    return /* @__PURE__ */ d.jsx(_2, { scope: n, id: s, children: /* @__PURE__ */ d.jsx(Ve.div, { role: "group", "aria-labelledby": s, ...r, ref: t }) });
  }
);
A2.displayName = V0;
var Y0 = "SelectLabel", y2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, s = T2(Y0, n);
    return /* @__PURE__ */ d.jsx(Ve.div, { id: s.id, ...r, ref: t });
  }
);
y2.displayName = Y0;
var Va = "SelectItem", [x2, G0] = ys(Va), W0 = A.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: s = !1,
      textValue: i,
      ...a
    } = e, o = or(Va, n), u = ur(Va, n), c = o.value === r, [l, h] = A.useState(i ?? ""), [m, p] = A.useState(!1), E = ze(
      t,
      (T) => u.itemRefCallback?.(T, r, s)
    ), g = Jn(), _ = A.useRef("touch"), b = () => {
      s || (o.onValueChange(r), o.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d.jsx(
      x2,
      {
        scope: n,
        value: r,
        disabled: s,
        textId: g,
        isSelected: c,
        onItemTextChange: A.useCallback((T) => {
          h((C) => C || (T?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d.jsx(
          Io.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: s,
            textValue: l,
            children: /* @__PURE__ */ d.jsx(
              Ve.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": s || void 0,
                "data-disabled": s ? "" : void 0,
                tabIndex: s ? void 0 : -1,
                ...a,
                ref: E,
                onFocus: be(a.onFocus, () => p(!0)),
                onBlur: be(a.onBlur, () => p(!1)),
                onClick: be(a.onClick, () => {
                  _.current !== "mouse" && b();
                }),
                onPointerUp: be(a.onPointerUp, () => {
                  _.current === "mouse" && b();
                }),
                onPointerDown: be(a.onPointerDown, (T) => {
                  _.current = T.pointerType;
                }),
                onPointerMove: be(a.onPointerMove, (T) => {
                  _.current = T.pointerType, s ? u.onItemLeave?.() : _.current === "mouse" && T.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: be(a.onPointerLeave, (T) => {
                  T.currentTarget === document.activeElement && u.onItemLeave?.();
                }),
                onKeyDown: be(a.onKeyDown, (T) => {
                  u.searchRef?.current !== "" && T.key === " " || (o2.includes(T.key) && b(), T.key === " " && T.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
W0.displayName = Va;
var qs = "SelectItemText", q0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: s, ...i } = e, a = or(qs, n), o = ur(qs, n), u = G0(qs, n), c = d2(qs, n), [l, h] = A.useState(null), m = ze(
      t,
      (b) => h(b),
      u.onItemTextChange,
      (b) => o.itemTextRefCallback?.(b, u.value, u.disabled)
    ), p = l?.textContent, E = A.useMemo(
      () => /* @__PURE__ */ d.jsx("option", { value: u.value, disabled: u.disabled, children: p }, u.value),
      [u.disabled, u.value, p]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: _ } = c;
    return _t(() => (g(E), () => _(E)), [g, _, E]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      /* @__PURE__ */ d.jsx(Ve.span, { id: u.textId, ...i, ref: m }),
      u.isSelected && a.valueNode && !a.valueNodeHasChildren ? so.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
q0.displayName = qs;
var K0 = "SelectItemIndicator", Q0 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return G0(K0, n).isSelected ? /* @__PURE__ */ d.jsx(Ve.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
Q0.displayName = K0;
var bc = "SelectScrollUpButton", X0 = A.forwardRef((e, t) => {
  const n = ur(bc, e.__scopeSelect), r = xl(bc, e.__scopeSelect), [s, i] = A.useState(!1), a = ze(t, r.onScrollButtonChange);
  return _t(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const c = u.scrollTop > 0;
        i(c);
      };
      const u = n.viewport;
      return o(), u.addEventListener("scroll", o), () => u.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), s ? /* @__PURE__ */ d.jsx(
    Z0,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: u } = n;
        o && u && (o.scrollTop = o.scrollTop - u.offsetHeight);
      }
    }
  ) : null;
});
X0.displayName = bc;
var _c = "SelectScrollDownButton", J0 = A.forwardRef((e, t) => {
  const n = ur(_c, e.__scopeSelect), r = xl(_c, e.__scopeSelect), [s, i] = A.useState(!1), a = ze(t, r.onScrollButtonChange);
  return _t(() => {
    if (n.viewport && n.isPositioned) {
      let o = function() {
        const c = u.scrollHeight - u.clientHeight, l = Math.ceil(u.scrollTop) < c;
        i(l);
      };
      const u = n.viewport;
      return o(), u.addEventListener("scroll", o), () => u.removeEventListener("scroll", o);
    }
  }, [n.viewport, n.isPositioned]), s ? /* @__PURE__ */ d.jsx(
    Z0,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: o, selectedItem: u } = n;
        o && u && (o.scrollTop = o.scrollTop + u.offsetHeight);
      }
    }
  ) : null;
});
J0.displayName = _c;
var Z0 = A.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...s } = e, i = ur("SelectScrollButton", n), a = A.useRef(null), o = vo(n), u = A.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return A.useEffect(() => () => u(), [u]), _t(() => {
    o().find((l) => l.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [o]), /* @__PURE__ */ d.jsx(
    Ve.div,
    {
      "aria-hidden": !0,
      ...s,
      ref: t,
      style: { flexShrink: 0, ...s.style },
      onPointerDown: be(s.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: be(s.onPointerMove, () => {
        i.onItemLeave?.(), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: be(s.onPointerLeave, () => {
        u();
      })
    }
  );
}), C2 = "SelectSeparator", S2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ d.jsx(Ve.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
S2.displayName = C2;
var Tc = "SelectArrow", w2 = A.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, s = No(n), i = or(Tc, n), a = ur(Tc, n);
    return i.open && a.position === "popper" ? /* @__PURE__ */ d.jsx(Al, { ...s, ...r, ref: t }) : null;
  }
);
w2.displayName = Tc;
var I2 = "SelectBubbleInput", eE = A.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const s = A.useRef(null), i = ze(r, s), a = Sw(t);
    return A.useEffect(() => {
      const o = s.current;
      if (!o) return;
      const u = window.HTMLSelectElement.prototype, l = Object.getOwnPropertyDescriptor(
        u,
        "value"
      ).set;
      if (a !== t && l) {
        const h = new Event("change", { bubbles: !0 });
        l.call(o, t), o.dispatchEvent(h);
      }
    }, [a, t]), /* @__PURE__ */ d.jsx(
      Ve.select,
      {
        ...n,
        style: { ...Ig, ...n.style },
        ref: i,
        defaultValue: t
      }
    );
  }
);
eE.displayName = I2;
function tE(e) {
  return e === "" || e === void 0;
}
function nE(e) {
  const t = jt(e), n = A.useRef(""), r = A.useRef(0), s = A.useCallback(
    (a) => {
      const o = n.current + a;
      t(o), (function u(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => u(""), 1e3));
      })(o);
    },
    [t]
  ), i = A.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return A.useEffect(() => () => window.clearTimeout(r.current), []), [n, s, i];
}
function rE(e, t, n) {
  const s = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let a = v2(e, Math.max(i, 0));
  s.length === 1 && (a = a.filter((c) => c !== n));
  const u = a.find(
    (c) => c.textValue.toLowerCase().startsWith(s.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function v2(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var N2 = P0, k2 = D0, R2 = M0, P2 = H0, O2 = B0, D2 = U0, L2 = z0, M2 = W0, H2 = q0, B2 = Q0, U2 = X0, F2 = J0, [ko] = bs("Tooltip", [
  As
]), Ro = As(), sE = "TooltipProvider", j2 = 700, Ac = "tooltip.open", [$2, Cl] = ko(sE), iE = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = j2,
    skipDelayDuration: r = 300,
    disableHoverableContent: s = !1,
    children: i
  } = e, a = A.useRef(!0), o = A.useRef(!1), u = A.useRef(0);
  return A.useEffect(() => {
    const c = u.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ d.jsx(
    $2,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: A.useCallback(() => {
        window.clearTimeout(u.current), a.current = !1;
      }, []),
      onClose: A.useCallback(() => {
        window.clearTimeout(u.current), u.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: o,
      onPointerInTransitChange: A.useCallback((c) => {
        o.current = c;
      }, []),
      disableHoverableContent: s,
      children: i
    }
  );
};
iE.displayName = sE;
var mi = "Tooltip", [z2, Ri] = ko(mi), aE = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: s,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: o
  } = e, u = Cl(mi, e.__scopeTooltip), c = Ro(t), [l, h] = A.useState(null), m = Jn(), p = A.useRef(0), E = a ?? u.disableHoverableContent, g = o ?? u.delayDuration, _ = A.useRef(!1), [b, T] = fi({
    prop: r,
    defaultProp: s ?? !1,
    onChange: (O) => {
      O ? (u.onOpen(), document.dispatchEvent(new CustomEvent(Ac))) : u.onClose(), i?.(O);
    },
    caller: mi
  }), C = A.useMemo(() => b ? _.current ? "delayed-open" : "instant-open" : "closed", [b]), R = A.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, _.current = !1, T(!0);
  }, [T]), D = A.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, T(!1);
  }, [T]), w = A.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      _.current = !0, T(!0), p.current = 0;
    }, g);
  }, [g, T]);
  return A.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ d.jsx(_l, { ...c, children: /* @__PURE__ */ d.jsx(
    z2,
    {
      scope: t,
      contentId: m,
      open: b,
      stateAttribute: C,
      trigger: l,
      onTriggerChange: h,
      onTriggerEnter: A.useCallback(() => {
        u.isOpenDelayedRef.current ? w() : R();
      }, [u.isOpenDelayedRef, w, R]),
      onTriggerLeave: A.useCallback(() => {
        E ? D() : (window.clearTimeout(p.current), p.current = 0);
      }, [D, E]),
      onOpen: R,
      onClose: D,
      disableHoverableContent: E,
      children: n
    }
  ) });
};
aE.displayName = mi;
var yc = "TooltipTrigger", oE = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, s = Ri(yc, n), i = Cl(yc, n), a = Ro(n), o = A.useRef(null), u = ze(t, o, s.onTriggerChange), c = A.useRef(!1), l = A.useRef(!1), h = A.useCallback(() => c.current = !1, []);
    return A.useEffect(() => () => document.removeEventListener("pointerup", h), [h]), /* @__PURE__ */ d.jsx(So, { asChild: !0, ...a, children: /* @__PURE__ */ d.jsx(
      Ve.button,
      {
        "aria-describedby": s.open ? s.contentId : void 0,
        "data-state": s.stateAttribute,
        ...r,
        ref: u,
        onPointerMove: be(e.onPointerMove, (m) => {
          m.pointerType !== "touch" && !l.current && !i.isPointerInTransitRef.current && (s.onTriggerEnter(), l.current = !0);
        }),
        onPointerLeave: be(e.onPointerLeave, () => {
          s.onTriggerLeave(), l.current = !1;
        }),
        onPointerDown: be(e.onPointerDown, () => {
          s.open && s.onClose(), c.current = !0, document.addEventListener("pointerup", h, { once: !0 });
        }),
        onFocus: be(e.onFocus, () => {
          c.current || s.onOpen();
        }),
        onBlur: be(e.onBlur, s.onClose),
        onClick: be(e.onClick, s.onClose)
      }
    ) });
  }
);
oE.displayName = yc;
var Sl = "TooltipPortal", [V2, Y2] = ko(Sl, {
  forceMount: void 0
}), uE = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: s } = e, i = Ri(Sl, t);
  return /* @__PURE__ */ d.jsx(V2, { scope: t, forceMount: n, children: /* @__PURE__ */ d.jsx(ir, { present: n || i.open, children: /* @__PURE__ */ d.jsx(vi, { asChild: !0, container: s, children: r }) }) });
};
uE.displayName = Sl;
var fs = "TooltipContent", cE = A.forwardRef(
  (e, t) => {
    const n = Y2(fs, e.__scopeTooltip), { forceMount: r = n.forceMount, side: s = "top", ...i } = e, a = Ri(fs, e.__scopeTooltip);
    return /* @__PURE__ */ d.jsx(ir, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ d.jsx(lE, { side: s, ...i, ref: t }) : /* @__PURE__ */ d.jsx(G2, { side: s, ...i, ref: t }) });
  }
), G2 = A.forwardRef((e, t) => {
  const n = Ri(fs, e.__scopeTooltip), r = Cl(fs, e.__scopeTooltip), s = A.useRef(null), i = ze(t, s), [a, o] = A.useState(null), { trigger: u, onClose: c } = n, l = s.current, { onPointerInTransitChange: h } = r, m = A.useCallback(() => {
    o(null), h(!1);
  }, [h]), p = A.useCallback(
    (E, g) => {
      const _ = E.currentTarget, b = { x: E.clientX, y: E.clientY }, T = Q2(b, _.getBoundingClientRect()), C = X2(b, T), R = J2(g.getBoundingClientRect()), D = ev([...C, ...R]);
      o(D), h(!0);
    },
    [h]
  );
  return A.useEffect(() => () => m(), [m]), A.useEffect(() => {
    if (u && l) {
      const E = (_) => p(_, l), g = (_) => p(_, u);
      return u.addEventListener("pointerleave", E), l.addEventListener("pointerleave", g), () => {
        u.removeEventListener("pointerleave", E), l.removeEventListener("pointerleave", g);
      };
    }
  }, [u, l, p, m]), A.useEffect(() => {
    if (a) {
      const E = (g) => {
        const _ = g.target, b = { x: g.clientX, y: g.clientY }, T = u?.contains(_) || l?.contains(_), C = !Z2(b, a);
        T ? m() : C && (m(), c());
      };
      return document.addEventListener("pointermove", E), () => document.removeEventListener("pointermove", E);
    }
  }, [u, l, a, c, m]), /* @__PURE__ */ d.jsx(lE, { ...e, ref: i });
}), [W2, q2] = ko(mi, { isInside: !1 }), K2 = /* @__PURE__ */ jC("TooltipContent"), lE = A.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": s,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...o
    } = e, u = Ri(fs, n), c = Ro(n), { onClose: l } = u;
    return A.useEffect(() => (document.addEventListener(Ac, l), () => document.removeEventListener(Ac, l)), [l]), A.useEffect(() => {
      if (u.trigger) {
        const h = (m) => {
          m.target?.contains(u.trigger) && l();
        };
        return window.addEventListener("scroll", h, { capture: !0 }), () => window.removeEventListener("scroll", h, { capture: !0 });
      }
    }, [u.trigger, l]), /* @__PURE__ */ d.jsx(
      Ii,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (h) => h.preventDefault(),
        onDismiss: l,
        children: /* @__PURE__ */ d.jsxs(
          Tl,
          {
            "data-state": u.stateAttribute,
            ...c,
            ...o,
            ref: t,
            style: {
              ...o.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ d.jsx(K2, { children: r }),
              /* @__PURE__ */ d.jsx(W2, { scope: n, isInside: !0, children: /* @__PURE__ */ d.jsx(qC, { id: u.contentId, role: "tooltip", children: s || r }) })
            ]
          }
        )
      }
    );
  }
);
cE.displayName = fs;
var dE = "TooltipArrow", hE = A.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, s = Ro(n);
    return q2(
      dE,
      n
    ).isInside ? null : /* @__PURE__ */ d.jsx(Al, { ...s, ...r, ref: t });
  }
);
hE.displayName = dE;
function Q2(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), s = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(n, r, s, i)) {
    case i:
      return "left";
    case s:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function X2(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function J2(e) {
  const { top: t, right: n, bottom: r, left: s } = e;
  return [
    { x: s, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: s, y: r }
  ];
}
function Z2(e, t) {
  const { x: n, y: r } = e;
  let s = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const o = t[i], u = t[a], c = o.x, l = o.y, h = u.x, m = u.y;
    l > r != m > r && n < (h - c) * (r - l) / (m - l) + c && (s = !s);
  }
  return s;
}
function ev(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), tv(t);
}
function tv(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const s = e[r];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (s.y - a.y) >= (i.y - a.y) * (s.x - a.x)) t.pop();
      else break;
    }
    t.push(s);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const s = e[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], a = n[n.length - 2];
      if ((i.x - a.x) * (s.y - a.y) >= (i.y - a.y) * (s.x - a.x)) n.pop();
      else break;
    }
    n.push(s);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var nv = iE, rv = aE, sv = oE, iv = uE, av = cE, ov = hE;
const uv = () => {
  const { disabled: e, next: t } = cC();
  return e ? null : t;
}, cv = Un("BranchPickerPrimitive.Next", uv), lv = () => {
  const { disabled: e, previous: t } = lC();
  return e ? null : t;
}, dv = Un("BranchPickerPrimitive.Previous", lv), hv = () => J((t) => t.message.branchCount), fE = () => {
  const e = hv();
  return d.jsx(d.Fragment, { children: e });
};
fE.displayName = "BranchPickerPrimitive.Count";
const fv = () => J((t) => t.message.branchNumber), pE = () => {
  const e = fv();
  return d.jsx(d.Fragment, { children: e });
};
pE.displayName = "BranchPickerPrimitive.Number";
const pv = (e) => J((t) => {
  const { role: n, attachments: r, parts: s, branchCount: i, isLast: a, speech: o, isCopied: u, isHovering: c } = t.message;
  return !(e.hasBranches === !0 && i < 2 || e.user && n !== "user" || e.assistant && n !== "assistant" || e.system && n !== "system" || e.lastOrHover === !0 && !c && !a || e.last !== void 0 && e.last !== a || e.copied === !0 && !u || e.copied === !1 && u || e.speaking === !0 && o == null || e.speaking === !1 && o != null || e.hasAttachments === !0 && (n !== "user" || !r?.length) || e.hasAttachments === !1 && n === "user" && r?.length || e.hasContent === !0 && s.length === 0 || e.hasContent === !1 && s.length > 0 || e.submittedFeedback !== void 0 && (t.message.metadata.submittedFeedback?.type ?? null) !== e.submittedFeedback);
}), nn = ({ children: e, ...t }) => pv(t) ? e : null;
nn.displayName = "MessagePrimitive.If";
const mE = Je(({ hideWhenSingleBranch: e, ...t }, n) => d.jsx(nn, { hasBranches: e ? !0 : void 0, children: d.jsx(Rt.div, { ...t, ref: n }) }));
mE.displayName = "BranchPickerPrimitive.Root";
const gE = () => {
  const { disabled: e, send: t } = rC(), n = ne(() => t(), [t]);
  return e ? null : n;
}, EE = Un("ComposerPrimitive.Send", gE), wl = Je(({ onSubmit: e, ...t }, n) => {
  const r = gE(), s = (i) => {
    i.preventDefault(), r && r();
  };
  return d.jsx(Rt.form, { ...t, ref: n, onSubmit: be(e, s) });
});
wl.displayName = "ComposerPrimitive.Root";
function xc() {
  return xc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xc.apply(null, arguments);
}
function mv(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var gv = os, Ev = function(t) {
  var n = Ze.useRef(t);
  return gv(function() {
    n.current = t;
  }), n;
}, Fh = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, bv = function(t, n) {
  var r = Ze.useRef();
  return Ze.useCallback(function(s) {
    t.current = s, r.current && Fh(r.current, null), r.current = n, n && Fh(n, s);
  }, [n]);
}, jh = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, _v = function(t) {
  Object.keys(jh).forEach(function(n) {
    t.style.setProperty(n, jh[n], "important");
  });
}, $h = _v, St = null, zh = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function Tv(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), St || (St = document.createElement("textarea"), St.setAttribute("tabindex", "-1"), St.setAttribute("aria-hidden", "true"), $h(St)), St.parentNode === null && document.body.appendChild(St);
  var s = e.paddingSize, i = e.borderSize, a = e.sizingStyle, o = a.boxSizing;
  Object.keys(a).forEach(function(m) {
    var p = m;
    St.style[p] = a[p];
  }), $h(St), St.value = t;
  var u = zh(St, e);
  St.value = t, u = zh(St, e), St.value = "x";
  var c = St.scrollHeight - s, l = c * n;
  o === "border-box" && (l = l + s + i), u = Math.max(l, u);
  var h = c * r;
  return o === "border-box" && (h = h + s + i), u = Math.min(h, u), [u, c];
}
var Vh = function() {
}, Av = function(t, n) {
  return t.reduce(function(r, s) {
    return r[s] = n[s], r;
  }, {});
}, yv = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak",
  "wordSpacing",
  "scrollbarGutter"
], xv = !!document.documentElement.currentStyle, Cv = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = Av(yv, n), s = r.boxSizing;
  if (s === "")
    return null;
  xv && s === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var i = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), a = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: i,
    borderSize: a
  };
}, Sv = Cv;
function Il(e, t, n) {
  var r = Ev(n);
  A.useLayoutEffect(function() {
    var s = function(a) {
      return r.current(a);
    };
    if (e)
      return e.addEventListener(t, s), function() {
        return e.removeEventListener(t, s);
      };
  }, []);
}
var wv = function(t, n) {
  Il(document.body, "reset", function(r) {
    t.current.form === r.target && n(r);
  });
}, Iv = function(t) {
  Il(window, "resize", t);
}, vv = function(t) {
  Il(document.fonts, "loadingdone", t);
}, Nv = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], kv = function(t, n) {
  var r = t.cacheMeasurements, s = t.maxRows, i = t.minRows, a = t.onChange, o = a === void 0 ? Vh : a, u = t.onHeightChange, c = u === void 0 ? Vh : u, l = mv(t, Nv), h = l.value !== void 0, m = A.useRef(null), p = bv(m, n), E = A.useRef(0), g = A.useRef(), _ = function() {
    var C = m.current, R = r && g.current ? g.current : Sv(C);
    if (R) {
      g.current = R;
      var D = Tv(R, C.value || C.placeholder || "x", i, s), w = D[0], O = D[1];
      E.current !== w && (E.current = w, C.style.setProperty("height", w + "px", "important"), c(w, {
        rowHeight: O
      }));
    }
  }, b = function(C) {
    h || _(), o(C);
  };
  return A.useLayoutEffect(_), wv(m, function() {
    if (!h) {
      var T = m.current.value;
      requestAnimationFrame(function() {
        var C = m.current;
        C && T !== C.value && _();
      });
    }
  }), Iv(_), vv(_), /* @__PURE__ */ A.createElement("textarea", xc({}, l, {
    onChange: b,
    ref: p
  }));
}, Rv = /* @__PURE__ */ A.forwardRef(kv);
const bE = (e) => {
  const t = jt(e), n = di((r) => r.onScrollToBottom);
  _e(() => n(t), [n, t]);
}, Pv = Tt(null), Ov = () => mt(Pv), Dv = Tt(null), Lv = () => mt(Dv), vl = Je(({ autoFocus: e = !1, asChild: t, disabled: n, onChange: r, onKeyDown: s, onPaste: i, onSelect: a, submitOnEnter: o, submitMode: u, cancelOnEscape: c = !0, unstable_focusOnRunStart: l = !0, unstable_focusOnScrollToBottom: h = !0, unstable_focusOnThreadSwitched: m = !0, addAttachmentOnPaste: p = !0, ...E }, g) => {
  const _ = Re(), b = Ov(), T = Lv(), C = u ?? (o === !1 ? "none" : "enter"), R = J((F) => F.composer.isEditing ? F.composer.text : ""), D = t ? Sg : Rv, w = J((F) => F.thread.isDisabled || F.composer.dictation?.inputDisabled) || n, O = Ke(null), U = ze(g, O);
  yg((F) => {
    if (!O.current?.contains(F.target))
      return;
    if (b?.open) {
      b.handleKeyDown(F);
      return;
    }
    if (!c)
      return;
    const M = _.composer();
    M.getState().canCancel && (M.cancel(), F.preventDefault());
  });
  const q = (F) => {
    if (!w && !F.nativeEvent.isComposing && !b?.handleKeyDown(F) && F.key === "Enter") {
      const M = _.thread().getState(), H = M.capabilities.queue;
      if (F.shiftKey && (F.ctrlKey || F.metaKey) && H && C !== "none" && !_.composer().getState().isEmpty) {
        F.preventDefault(), _.composer().send({ steer: !0 });
        return;
      }
      if (F.shiftKey || M.isRunning && !H)
        return;
      let B = !1;
      C === "ctrlEnter" ? B = F.ctrlKey || F.metaKey : C === "enter" && (B = !0), B && (F.preventDefault(), O.current?.closest("form")?.requestSubmit());
    }
  }, P = async (F) => {
    if (!p)
      return;
    const M = _.thread().getState().capabilities, H = Array.from(F.clipboardData?.files || []);
    if (M.attachments && H.length > 0)
      try {
        F.preventDefault(), await Promise.all(H.map((B) => _.composer().addAttachment(B)));
      } catch (B) {
        console.error("Error adding attachment:", B);
      }
  }, z = e && !w, G = ne(() => {
    const F = O.current;
    !F || !z || (F.focus({ preventScroll: !0 }), F.setSelectionRange(F.value.length, F.value.length));
  }, [z]);
  return _e(() => G(), [G]), bE(() => {
    _.composer().getState().type === "thread" && h && G();
  }), _e(() => {
    if (!(_.composer().getState().type !== "thread" || !l))
      return _.on("thread.runStart", G);
  }, [l, G, _]), _e(() => {
    if (!(_.composer().getState().type !== "thread" || !m))
      return _.on("threadListItem.switchedTo", G);
  }, [m, G, _]), d.jsx(D, { name: "input", value: R, ...E, ref: U, disabled: w, onChange: be(r, (F) => {
    _.composer().getState().isEditing && (F1(() => {
      _.composer().setText(F.target.value);
    }), T?.setCursorPosition(F.target.selectionStart ?? F.target.value.length));
  }), onKeyDown: be(s, q), onSelect: be(a, (F) => {
    const M = F.target;
    T?.setCursorPosition(M.selectionStart ?? M.value.length);
  }), onPaste: be(i, P) });
});
vl.displayName = "ComposerPrimitive.Input";
const Mv = () => {
  const { disabled: e, cancel: t } = sC();
  return e ? null : t;
}, _E = Un("ComposerPrimitive.Cancel", Mv), TE = () => J((t) => {
  if (t.part.type !== "text" && t.part.type !== "reasoning")
    throw new Error("MessagePartText can only be used inside text or reasoning message parts.");
  return t.part;
}), AE = Tt(null), Hv = (e) => ({ useSmoothStatus: ls(() => e) }), Bv = ({ children: e }) => {
  const t = yE({ optional: !0 }), n = Re(), [r] = ce(() => Hv(n.part().getState().status));
  return t ? e : d.jsx(AE.Provider, { value: r, children: e });
}, Uv = (e) => {
  const t = Je((n, r) => d.jsx(Bv, { children: d.jsx(e, { ...n, ref: r }) }));
  return t.displayName = e.displayName, t;
};
function yE(e) {
  const t = mt(AE);
  if (!e?.optional && !t)
    throw new Error("This component must be used within a SmoothContextProvider.");
  return t;
}
const { useSmoothStatus: Fv, useSmoothStatusStore: jv } = gg(yE, "useSmoothStatus");
class $v {
  constructor(t, n) {
    k(this, "currentText");
    k(this, "setText");
    k(this, "animationFrameId", null);
    k(this, "lastUpdateTime", Date.now());
    k(this, "targetText", "");
    k(this, "animate", () => {
      const t = Date.now();
      let r = t - this.lastUpdateTime;
      const s = this.targetText.length - this.currentText.length, i = Math.min(5, 250 / s);
      let a = 0;
      for (; r >= i && a < s; )
        a++, r -= i;
      a !== s ? this.animationFrameId = requestAnimationFrame(this.animate) : this.animationFrameId = null, a !== 0 && (this.currentText = this.targetText.slice(0, this.currentText.length + a), this.lastUpdateTime = t - r, this.setText(this.currentText));
    });
    this.currentText = t, this.setText = n;
  }
  start() {
    this.animationFrameId === null && (this.lastUpdateTime = Date.now(), this.animate());
  }
  stop() {
    this.animationFrameId !== null && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null);
  }
}
const Au = Object.freeze({
  type: "running"
}), xE = (e, t = !1) => {
  const { text: n } = e, r = J((l) => l.message.id), s = Ke(r), [i, a] = ce(e.status.type === "running" ? "" : n), o = jv({ optional: !0 }), u = jt((l) => {
    if (a(l), o) {
      const h = i !== l || e.status.type === "running" ? Au : e.status;
      hi(o).setState(h, !0);
    }
  });
  _e(() => {
    if (o) {
      const l = t && (i !== n || e.status.type === "running") ? Au : e.status;
      hi(o).setState(l, !0);
    }
  }, [o, t, n, i, e.status]);
  const [c] = ce(new $v(i, u));
  return _e(() => {
    if (!t) {
      c.stop();
      return;
    }
    if (s.current !== r || !n.startsWith(c.targetText)) {
      s.current = r, e.status.type === "running" ? (u(""), c.currentText = "", c.targetText = n, c.start()) : (u(n), c.currentText = n, c.targetText = n, c.stop());
      return;
    }
    c.targetText = n, c.start();
  }, [u, c, r, t, n, e.status.type]), _e(() => () => {
    c.stop();
  }, [c]), se(() => t ? {
    type: "text",
    text: i,
    status: n === i ? e.status : Au
  } : e, [t, i, e, n]);
}, CE = Je(({ smooth: e = !0, component: t = "span", ...n }, r) => {
  const { text: s, status: i } = xE(TE(), e);
  return d.jsx(t, { "data-status": i.type, ...n, ref: r, children: s });
});
CE.displayName = "MessagePartPrimitive.Text";
const zv = () => J((t) => {
  if (t.part.type !== "image")
    throw new Error("MessagePartImage can only be used inside image message parts.");
  return t.part;
}), SE = Je((e, t) => {
  const { image: n } = zv();
  return d.jsx(Rt.img, { src: n, ...e, ref: t });
});
SE.displayName = "MessagePartPrimitive.Image";
const wE = ({ children: e }) => J((n) => n.part.status.type === "running") ? e : null;
wE.displayName = "MessagePartPrimitive.InProgress";
const Pi = (e) => {
  const t = Ke(void 0);
  return ne((r) => {
    t.current && t.current(), r && (t.current = e(r));
  }, [e]);
}, IE = (e, t) => {
  const n = ne((r) => {
    if (!e)
      return;
    const s = e(), i = () => {
      const o = t ? t(r) : r.offsetHeight;
      s.setHeight(o);
    }, a = new ResizeObserver(i);
    return a.observe(r), i(), () => {
      a.disconnect(), s.unregister();
    };
  }, [e, t]);
  return Pi(n);
}, Yh = Tt(!1), Gh = (e, t) => {
  const n = e.match(/^([\d.]+)(em|px|rem)$/);
  if (!n)
    return 0;
  const r = parseFloat(n[1]), s = n[2];
  if (s === "px")
    return r;
  if (s === "em") {
    const i = parseFloat(getComputedStyle(t).fontSize) || 16;
    return r * i;
  }
  if (s === "rem") {
    const i = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return r * i;
  }
  return 0;
}, vE = ({ children: e, fillClampThreshold: t = "10em", fillClampOffset: n = "6em" }) => {
  const r = J(
    // only add slack to the last assistant message following a user message (valid turn)
    (u) => u.message.isLast && u.message.role === "assistant" && u.message.index >= 1 && u.thread.messages.at(u.message.index - 1)?.role === "user"
  ), s = mo({ optional: !0 }), i = mt(Yh), a = ne((u) => {
    if (!s || i)
      return;
    const c = () => {
      const l = s.getState();
      if (l.turnAnchor === "top" && r) {
        const { viewport: h, inset: m, userMessage: p } = l.height, E = Gh(t, u), g = Gh(n, u), _ = p <= E ? p : g, b = Math.max(0, h - m - _);
        u.style.minHeight = `${b}px`, u.style.flexShrink = "0", u.style.transition = "min-height 0s";
      } else
        u.style.minHeight = "", u.style.flexShrink = "", u.style.transition = "";
    };
    return c(), s.subscribe(c);
  }, [
    s,
    r,
    i,
    t,
    n
  ]), o = Pi(a);
  return d.jsx(Yh.Provider, { value: !0, children: d.jsx(Sg, { ref: o, children: e }) });
};
vE.displayName = "ThreadPrimitive.ViewportSlack";
const Vv = () => {
  const e = Re(), t = J(() => e.message()), n = ne((r) => {
    const s = () => {
      t.setIsHovering(!0);
    }, i = () => {
      t.setIsHovering(!1);
    };
    return r.addEventListener("mouseenter", s), r.addEventListener("mouseleave", i), r.matches(":hover") && queueMicrotask(() => t.setIsHovering(!0)), () => {
      r.removeEventListener("mouseenter", s), r.removeEventListener("mouseleave", i), t.setIsHovering(!1);
    };
  }, [t]);
  return Pi(n);
}, Yv = () => {
  const e = di((s) => s.turnAnchor), t = di((s) => s.registerUserMessageHeight), n = J((s) => e === "top" && s.message.role === "user" && s.message.index === s.thread.messages.length - 2 && s.thread.messages.at(-1)?.role === "assistant"), r = ne((s) => s.offsetHeight, []);
  return IE(n ? t : null, r);
}, Po = Je((e, t) => {
  const n = Vv(), r = Yv(), s = ze(t, n, r), i = J((a) => a.message.id);
  return d.jsx(vE, { children: d.jsx(Rt.div, { ...e, ref: s, "data-message-id": i }) });
});
Po.displayName = "MessagePrimitive.Root";
const yu = {
  ...Et,
  Text: () => d.jsxs("p", { style: { whiteSpace: "pre-line" }, children: [d.jsx(CE, {}), d.jsx(wE, { children: d.jsx("span", { style: { fontFamily: "revert" }, children: " ●" }) })] }),
  Image: () => d.jsx(SE, {})
}, Oo = (e) => {
  if ("children" in e)
    return d.jsx(cc, { children: e.children });
  const { components: t, ...n } = e, r = t ? {
    Text: t.Text ?? yu.Text,
    Image: t.Image ?? yu.Image,
    Reasoning: t.Reasoning ?? Et.Reasoning,
    Source: t.Source ?? Et.Source,
    File: t.File ?? Et.File,
    Unstable_Audio: t.Unstable_Audio ?? Et.Unstable_Audio,
    ..."ChainOfThought" in t ? { ChainOfThought: t.ChainOfThought } : {
      tools: t.tools,
      data: t.data,
      ToolGroup: t.ToolGroup ?? Et.ToolGroup,
      ReasoningGroup: t.ReasoningGroup ?? Et.ReasoningGroup
    },
    Empty: t.Empty,
    Quote: t.Quote
  } : yu;
  return d.jsx(cc, { components: r, ...n });
};
Oo.displayName = "MessagePrimitive.Parts";
const Nl = ({ children: e }) => pC() !== void 0 ? e : null;
Nl.displayName = "MessagePrimitive.Error";
const kl = Je((e, t) => d.jsx(Rt.div, { ...e, ref: t }));
kl.displayName = "ThreadPrimitive.Root";
const NE = ({ children: e }) => J((n) => n.thread.isEmpty) ? e : null;
NE.displayName = "ThreadPrimitive.Empty";
const Gv = (e) => J((t) => !(e.empty === !0 && !t.thread.isEmpty || e.empty === !1 && t.thread.isEmpty || e.running === !0 && !t.thread.isRunning || e.running === !1 && t.thread.isRunning || e.disabled === !0 && !t.thread.isDisabled || e.disabled === !1 && t.thread.isDisabled)), gi = ({ children: e, ...t }) => Gv(t) ? e : null;
gi.displayName = "ThreadPrimitive.If";
const Wv = (e) => {
  const t = jt(e), n = ne((r) => {
    const s = new ResizeObserver(() => {
      t();
    }), i = new MutationObserver((a) => {
      a.some((u) => u.type !== "attributes" || u.attributeName !== "style") && t();
    });
    return s.observe(r), i.observe(r, {
      childList: !0,
      subtree: !0,
      attributes: !0,
      characterData: !0
    }), () => {
      s.disconnect(), i.disconnect();
    };
  }, [t]);
  return Pi(n);
}, qv = ({ autoScroll: e, scrollToBottomOnRunStart: t = !0, scrollToBottomOnInitialize: n = !0, scrollToBottomOnThreadSwitch: r = !0 }) => {
  const s = Ke(null), i = mo();
  e === void 0 && (e = i.getState().turnAnchor !== "top");
  const a = Ke(0), o = Ke(null), u = ne((p) => {
    const E = s.current;
    E && (o.current = p, E.scrollTo({ top: E.scrollHeight, behavior: p }));
  }, []), c = () => {
    const p = s.current;
    if (!p)
      return;
    const E = i.getState().isAtBottom, g = Math.abs(p.scrollHeight - p.scrollTop - p.clientHeight) < 1 || p.scrollHeight <= p.clientHeight;
    !g && a.current < p.scrollTop || (g && (o.current = null), (g || o.current === null) && g !== E && hi(i).setState({
      isAtBottom: g
    })), a.current = p.scrollTop;
  }, l = Wv(() => {
    const p = o.current;
    p ? u(p) : e && i.getState().isAtBottom && u("instant"), c();
  }), h = Pi((p) => (p.addEventListener("scroll", c), () => {
    p.removeEventListener("scroll", c);
  }));
  return bE(({ behavior: p }) => {
    u(p);
  }), nu("thread.runStart", () => {
    t && (o.current = "auto", requestAnimationFrame(() => {
      u("auto");
    }));
  }), nu("thread.initialize", () => {
    n && (o.current = "instant", requestAnimationFrame(() => {
      u("instant");
    }));
  }), nu("threadListItem.switchedTo", () => {
    r && (o.current = "instant", requestAnimationFrame(() => {
      u("instant");
    }));
  }), ze(l, h, s);
}, Kv = () => {
  const e = di((n) => n.registerViewport), t = ne((n) => n.clientHeight, []);
  return IE(e, t);
}, kE = Je(({ autoScroll: e, scrollToBottomOnRunStart: t, scrollToBottomOnInitialize: n, scrollToBottomOnThreadSwitch: r, children: s, ...i }, a) => {
  const o = qv({
    autoScroll: e,
    scrollToBottomOnRunStart: t,
    scrollToBottomOnInitialize: n,
    scrollToBottomOnThreadSwitch: r
  }), u = Kv(), c = ze(a, o, u);
  return d.jsx(Rt.div, { ...i, ref: c, children: s });
});
kE.displayName = "ThreadPrimitive.ViewportScrollable";
const Rl = Je(({ turnAnchor: e, ...t }, n) => d.jsx(bg, { options: { turnAnchor: e }, children: d.jsx(kE, { ...t, ref: n }) }));
Rl.displayName = "ThreadPrimitive.Viewport";
const Qv = ({ behavior: e } = {}) => {
  const t = di((s) => s.isAtBottom), n = mo(), r = ne(() => {
    n.getState().scrollToBottom({ behavior: e });
  }, [n, e]);
  return t ? null : r;
}, RE = Un("ThreadPrimitive.ScrollToBottom", Qv, ["behavior"]), Xv = ({ prompt: e, send: t, clearComposer: n, autoSend: r, method: s }) => {
  const i = t ?? r ?? !1, { disabled: a, trigger: o } = dC({
    prompt: e,
    send: i,
    clearComposer: n
  });
  return a ? null : o;
}, Jv = Un("ThreadPrimitive.Suggestion", Xv, ["prompt", "send", "clearComposer", "autoSend", "method"]), PE = Je(({ onClick: e, disabled: t, ...n }, r) => {
  const s = J((a) => a.threads.newThreadId === a.threads.mainThreadId), { switchToNewThread: i } = fC();
  return d.jsx(Rt.button, { type: "button", ...s ? { "data-active": "true", "aria-current": "true" } : null, ...n, ref: r, disabled: t, onClick: be(e, i) });
});
PE.displayName = "ThreadListPrimitive.New";
const OE = Je((e, t) => d.jsx(Rt.div, { ...e, ref: t }));
OE.displayName = "ThreadListPrimitive.Root";
const DE = Je((e, t) => {
  const n = J((r) => r.threads.mainThreadId === r.threadListItem.id);
  return d.jsx(Rt.div, { ...n ? { "data-active": "true", "aria-current": "true" } : null, ...e, ref: t });
});
DE.displayName = "ThreadListItemPrimitive.Root";
const Zv = () => {
  const { switchTo: e } = hC();
  return e;
}, eN = Un("ThreadListItemPrimitive.Trigger", Zv), tN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AssistantRuntimeImpl: nl,
  BaseAssistantRuntimeCore: el,
  CompositeContextProvider: Xc,
  DefaultThreadComposerRuntimeCore: Gm,
  MessageRepository: Vm,
  ThreadRuntimeImpl: Jm,
  fromThreadMessageLike: wi,
  generateId: tr,
  getAutoStatus: zm,
  useSmooth: xE,
  useSmoothStatus: Fv,
  withSmoothContextProvider: Uv
}, Symbol.toStringTag, { value: "Module" })), dt = [];
for (let e = 0; e < 256; ++e)
  dt.push((e + 256).toString(16).slice(1));
function nN(e, t = 0) {
  return (dt[e[t + 0]] + dt[e[t + 1]] + dt[e[t + 2]] + dt[e[t + 3]] + "-" + dt[e[t + 4]] + dt[e[t + 5]] + "-" + dt[e[t + 6]] + dt[e[t + 7]] + "-" + dt[e[t + 8]] + dt[e[t + 9]] + "-" + dt[e[t + 10]] + dt[e[t + 11]] + dt[e[t + 12]] + dt[e[t + 13]] + dt[e[t + 14]] + dt[e[t + 15]]).toLowerCase();
}
let xu;
const rN = new Uint8Array(16);
function sN() {
  if (!xu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    xu = crypto.getRandomValues.bind(crypto);
  }
  return xu(rN);
}
const iN = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Wh = { randomUUID: iN };
function aN(e, t, n) {
  if (Wh.randomUUID && !e)
    return Wh.randomUUID();
  e = e || {};
  const r = e.random ?? e.rng?.() ?? sN();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, nN(r);
}
const LE = {
  // Brand Resources
  get_my_brand: "winnin://brands/me",
  get_my_competitors: "winnin://brands/competitors",
  share_of_engagement_content_and_views: "winnin://brands/share_of_engagement_content_and_views/:provider/:territoryType/:timeRangeInDays",
  get_key_findings: "winnin://brands/me/key_findings/:language",
  get_brand_engagement_histogram: "winnin://brands/engagement/histogram/:provider/:territoryType/:timeRangeInDays",
  get_brand_views_histogram: "winnin://brands/views/histogram/:provider/:territoryType/:timeRangeInDays",
  get_brand_posts_histogram: "winnin://brands/posts/histogram/:provider/:territoryType/:timeRangeInDays",
  // Brand V2 Resources
  get_my_brand_v2: "winnin://brands-v2/me",
  get_my_competitors_v2: "winnin://brands-v2/competitors",
  share_of_engagement_content_and_views_v2: "winnin://brands-v2/share_of_engagement_content_and_views/:provider/:timeRangeInDays",
  get_brand_engagement_histogram_v2: "winnin://brands-v2/engagement/histogram/:provider/:timeRangeInDays",
  get_brand_posts_histogram_v2: "winnin://brands-v2/posts/histogram/:provider/:timeRangeInDays",
  get_brand_views_histogram_v2: "winnin://brands-v2/views/histogram/:provider/:timeRangeInDays",
  // Category Resources
  share_of_attention: "winnin://category/share_of_attention/:year/:period",
  share_of_attention_v2: "winnin://category/share_of_attention/v2/:year/:period",
  get_trending_territories: "winnin://category/trending_territories",
  get_category: "winnin://category",
  // Category V2 Resources
  share_of_attention_v3: "winnin://category-v2/share_of_attention/v3/:industryId/:year/:period",
  get_share_of_attention_industries: "winnin://category-v2/share_of_attention/v3/industries",
  get_share_of_attention_reasoning: "winnin://category-v2/share_of_attention/v3/reasoning/:industryId/:year/:period",
  // Territory Resources
  get_territory_resource: "winnin://territory/:territoryId",
  get_territory_tags_resource: "winnin://territory/:territoryId/:timeRange/tags",
  get_territory_niches_resource: "winnin://territory/:territoryId/:timeRange/niches/:context",
  get_territory_formats_resource: "winnin://territory/:territoryId/:timeRange/formats",
  get_territory_creators_resource: "winnin://territory/:territoryId/:timeRange/creators",
  get_territory_videos_resource: "winnin://territory/:territoryId/:timeRange/videos/:sortBy",
  get_territory_performance_resource: "winnin://territory/:territoryId/:timeRange/metrics",
  get_territory_affinities_resource: "winnin://territory/:territoryId/:timeRange/affinity",
  get_territory_audience_resource: "winnin://territory/:territoryId/:timeRange/audience",
  deep_territory_analysis: "winnin://territory/:territoryId/:timeRange/deep_analysis",
  get_territory_relevance_resource: "winnin://territory/:territoryId/:timeRange/relevance",
  // Winnin Documentation Resources
  about_winnin: "winnin://winnin/about",
  about_relevance_index: "winnin://metrics/relevance_index",
  about_avg_engagement: "winnin://metrics/avg_engagement",
  about_avg_views: "winnin://metrics/avg_views",
  about_total_videos: "winnin://metrics/total_videos",
  metrics_vs_retention: "winnin://metrics/retention",
  about_affinity: "winnin://metrics/affinity_calculation",
  about_relationship_metric: "winnin://metrics/relationship_calculation",
  about_audience: "winnin://audience/data_collection",
  what_are_trending_topics_in_territories: "winnin://trending/topics_in_territories",
  what_are_trending_tags_in_sidebar: "winnin://trending/tags_sidebar",
  what_does_trending_creator_or_subtopic_mean: "winnin://trending/creator_subtopic_meaning",
  why_do_some_creators_appear_without_subscriber_count: "winnin://creators/missing_subscriber_count"
}, qt = (e, t = 1) => {
  const n = Math.abs(e), r = e < 0 ? "-" : "";
  let s;
  if (n >= 1e12)
    s = (n / 1e12).toFixed(t) + "T";
  else if (n >= 1e9)
    s = (n / 1e9).toFixed(t) + "B";
  else if (n >= 1e6)
    s = (n / 1e6).toFixed(t) + "M";
  else if (n >= 1e3)
    s = (n / 1e3).toFixed(t) + "K";
  else
    return Number.isInteger(n) ? n : n.toFixed(t);
  return r + s;
};
function ME(e) {
  return e.match(/:(\w+)/g)?.map((t) => t.substring(1)) || [];
}
function Kt(e, t) {
  return Object.entries(t).reduce((n, [r, s]) => n?.replace(new RegExp(`:${r}\\b`, "g"), String(s)), e);
}
const sr = {
  earned: "earned",
  paid: "paid",
  selfContent: "proprietary-channels",
  owned: "proprietary-channels",
  // 'owned' is the same as 'selfContent'
  grouped: "overview",
  overview: "overview"
  // 'overview' is the same as 'grouped'
}, qh = {
  earned: {
    skipEarned: !1,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !0
  },
  paid: {
    skipEarned: !0,
    skipPaid: !1,
    skipGrouped: !0,
    skipSelfContent: !0
  },
  grouped: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !1,
    skipSelfContent: !0
  },
  selfContent: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !1
  },
  // 'overview' is the same as 'grouped'
  overview: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !1,
    skipSelfContent: !0
  },
  // 'owned' is the same as 'selfContent'
  owned: {
    skipEarned: !0,
    skipPaid: !0,
    skipGrouped: !0,
    skipSelfContent: !1
  }
}, oN = "#755CFF", Ue = {
  // Charts
  graph_item_1: "#F7CA00",
  graph_item_2: "#F76D3E",
  graph_item_3: "#3BBA18",
  graph_item_4: "#005DFF",
  graph_item_5: "#EF377A",
  graph_item_6: "#C519F0",
  graph_item_7: "#0EC9F2",
  graph_item_8: "#FD3636",
  graph_item_9: "#A9DC1A",
  graph_item_10: "#FF9B21",
  graph_item_11: "#FA6FA2",
  graph_item_12: "#238508",
  graph_item_13: "#DC5BFC",
  graph_item_14: "#0443B1",
  graph_item_15: "#B5350A",
  graph_item_16: "#00A3FF",
  graph_item_17: "#1ECF8F",
  graph_item_18: "#C4A000",
  graph_item_19: "#D94411",
  graph_item_20: "#780404",
  graph_item_21: "#A2BBCD",
  graph_item_22: "#795E00",
  graph_item_23: "#9570FF",
  graph_item_24: "#0086A4",
  graph_item_25: "#510090",
  graph_item_26: "#9F007C",
  graph_item_27: "#1B654A",
  graph_item_28: "#474747",
  graph_item_29: "#909C00",
  graph_item_30: "#24FF00",
  winnin: oN
}, Kh = [
  Ue.graph_item_1,
  Ue.graph_item_2,
  Ue.graph_item_3,
  Ue.graph_item_4,
  Ue.graph_item_5,
  Ue.graph_item_6,
  Ue.graph_item_7,
  Ue.graph_item_8,
  Ue.graph_item_9,
  Ue.graph_item_10,
  Ue.graph_item_11,
  Ue.graph_item_12,
  Ue.graph_item_13,
  Ue.graph_item_14,
  Ue.graph_item_15,
  Ue.graph_item_16,
  Ue.graph_item_17,
  Ue.graph_item_18,
  Ue.graph_item_19,
  Ue.graph_item_20,
  Ue.graph_item_21,
  Ue.graph_item_22,
  Ue.graph_item_23,
  Ue.graph_item_24,
  Ue.graph_item_25,
  Ue.graph_item_26,
  Ue.graph_item_27,
  Ue.graph_item_28,
  Ue.graph_item_29,
  Ue.graph_item_30
];
class uN {
  constructor() {
    this.baseUrl = "";
  }
}
const is = new uN(), fn = (e) => e.replace(/\//g, "\\/").replace(/:\w+/g, `[^\\/\\s)"'\\],.;:><!?|#]+(?:\\.[^\\/\\s)"'\\],.;:><!?|#]+)*`) + `(?=[\\s)"'\\],;:><!?|#]|\\.(?:[^\\w]|$)|$)`, ge = "winnin://", te = {
  // Brand Resources
  GET_KEY_FINDINGS: `${ge}brands/me/key_findings/:language`,
  GET_MY_BRAND: `${ge}brands/me`,
  GET_MY_COMPETITORS: `${ge}brands/competitors`,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS: `${ge}brands/share_of_engagement_content_and_views/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE: `${ge}brands/engagement/histogram/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_VIEWS_HISTOGRAM: `${ge}brands/views/histogram/:provider/:territoryType/:timeRangeInDays`,
  GET_BRAND_POSTS_HISTOGRAM: `${ge}brands/posts/histogram/:provider/:territoryType/:timeRangeInDays`,
  // Brand V2 Resources
  GET_MY_BRAND_V2: `${ge}brands-v2/me`,
  GET_MY_COMPETITORS_V2: `${ge}brands-v2/competitors`,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2: `${ge}brands-v2/share_of_engagement_content_and_views/:provider/:timeRangeInDays`,
  GET_BRAND_ENGAGEMENT_HISTOGRAM_V2: `${ge}brands-v2/engagement/histogram/:provider/:timeRangeInDays`,
  GET_BRAND_POSTS_HISTOGRAM_V2: `${ge}brands-v2/posts/histogram/:provider/:timeRangeInDays`,
  GET_BRAND_VIEWS_HISTOGRAM_V2: `${ge}brands-v2/views/histogram/:provider/:timeRangeInDays`,
  // Category Resources
  SHARE_OF_ATTENTION_V2: `${ge}category/share_of_attention/v2/:year/:period`,
  SHARE_OF_ATTENTION: `${ge}category/share_of_attention/:year/:period`,
  GET_TRENDING_TERRITORIES: `${ge}category/trending_territories`,
  GET_CATEGORY: `${ge}category`,
  // Category V2 Resources
  GET_SHARE_OF_ATTENTION_REASONING: `${ge}category-v2/share_of_attention/v3/reasoning/:industryId/:year/:period`,
  SHARE_OF_ATTENTION_V3: `${ge}category-v2/share_of_attention/v3/:industryId/:year/:period`,
  GET_SHARE_OF_ATTENTION_INDUSTRIES: `${ge}category-v2/share_of_attention/v3/industries`,
  // Territory Resources
  GET_TERRITORY_NICHES_RESOURCE: `${ge}territory/:territoryId/:timeRange/niches/:context`,
  GET_TERRITORY_VIDEOS_RESOURCE: `${ge}territory/:territoryId/:timeRange/videos/:sortBy`,
  GET_TERRITORY_TAGS_RESOURCE: `${ge}territory/:territoryId/:timeRange/tags`,
  GET_TERRITORY_FORMATS_RESOURCE: `${ge}territory/:territoryId/:timeRange/formats`,
  GET_TERRITORY_CREATORS_RESOURCE: `${ge}territory/:territoryId/:timeRange/creators`,
  GET_TERRITORY_PERFORMANCE_RESOURCE: `${ge}territory/:territoryId/:timeRange/metrics`,
  GET_TERRITORY_AFFINITIES_RESOURCE: `${ge}territory/:territoryId/:timeRange/affinity`,
  GET_TERRITORY_AUDIENCE_RESOURCE: `${ge}territory/:territoryId/:timeRange/audience`,
  DEEP_ANALYSIS_RESOURCE: `${ge}territory/:territoryId/:timeRange/deep_analysis`,
  GET_TERRITORY_RELEVANCE_RESOURCE: `${ge}territory/:territoryId/:timeRange/relevance`,
  GET_TERRITORY_RESOURCE: `${ge}territory/:territoryId`,
  // Other
  POST: `${ge}post/:provider/:id`,
  CREATOR: `${ge}creator/:provider/:id`,
  // Winnin Documentation Resources
  ABOUT_WINNIN: `${ge}winnin/about`,
  ABOUT_RELEVANCE_INDEX: `${ge}metrics/relevance_index`,
  ABOUT_AVG_ENGAGEMENT: `${ge}metrics/avg_engagement`,
  ABOUT_AVG_VIEWS: `${ge}metrics/avg_views`,
  ABOUT_TOTAL_VIDEOS: `${ge}metrics/total_videos`,
  METRICS_VS_RETENTION: `${ge}metrics/retention`,
  ABOUT_AFFINITY: `${ge}metrics/affinity_calculation`,
  ABOUT_RELATIONSHIP_METRIC: `${ge}metrics/relationship_calculation`,
  ABOUT_AUDIENCE: `${ge}audience/data_collection`,
  WHAT_ARE_TRENDING_TOPICS_IN_TERRITORIES: `${ge}trending/topics_in_territories`,
  WHAT_ARE_TRENDING_TAGS_IN_SIDEBAR: `${ge}trending/tags_sidebar`,
  WHAT_DOES_TRENDING_CREATOR_OR_SUBTOPIC_MEAN: `${ge}trending/creator_subtopic_meaning`,
  WHY_DO_SOME_CREATORS_APPEAR_WITHOUT_SUBSCRIBER_COUNT: `${ge}creators/missing_subscriber_count`
}, na = {
  SHARE_OF_ATTENTION: [te.SHARE_OF_ATTENTION, te.GET_TRENDING_TERRITORIES],
  BRAND: [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]
}, Be = is.baseUrl, Bn = {
  [te.GET_MY_BRAND]: `${Be}/workspace/:panelId/brands/overview`,
  [te.GET_MY_COMPETITORS]: `${Be}/workspace/:panelId/brands/overview`,
  [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2]: `${Be}/workspace/:panelId/brands/overview`,
  [te.GET_KEY_FINDINGS]: `${Be}/workspace/:panelId/brands/overview`,
  [te.SHARE_OF_ATTENTION]: `${Be}/workspace/:panelId/share-of-attention`,
  [te.SHARE_OF_ATTENTION_V2]: `${Be}/workspace/:panelId/share-of-attention`,
  [te.SHARE_OF_ATTENTION_V3]: `${Be}/workspace/:panelId/share-of-attention`,
  [te.GET_TRENDING_TERRITORIES]: `${Be}/workspace/:panelId`,
  [te.GET_TERRITORY_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/overview`,
  [te.GET_TERRITORY_TAGS_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/hashtags`,
  [te.GET_TERRITORY_NICHES_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/niches`,
  [te.GET_TERRITORY_FORMATS_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/formats`,
  [te.GET_TERRITORY_CREATORS_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/creators`,
  [te.GET_TERRITORY_VIDEOS_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/videos`,
  [te.GET_TERRITORY_PERFORMANCE_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/performance`,
  [te.GET_TERRITORY_AFFINITIES_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/people-also-watch`,
  [te.GET_TERRITORY_AUDIENCE_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/audience`,
  [te.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_VIEWS_HISTOGRAM]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_POSTS_HISTOGRAM]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.GET_MY_BRAND_V2]: `${Be}/workspace/:panelId/brands/overview`,
  [te.GET_MY_COMPETITORS_V2]: `${Be}/workspace/:panelId/brands/overview`,
  [te.GET_BRAND_ENGAGEMENT_HISTOGRAM_V2]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_POSTS_HISTOGRAM_V2]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.GET_BRAND_VIEWS_HISTOGRAM_V2]: `${Be}/workspace/:panelId/brands/:tab`,
  [te.GET_CATEGORY]: `${Be}/workspace/:panelId/share-of-attention`,
  [te.GET_SHARE_OF_ATTENTION_INDUSTRIES]: `${Be}/workspace/:panelId/share-of-attention`,
  [te.GET_SHARE_OF_ATTENTION_REASONING]: `${Be}/workspace/:panelId/share-of-attention`,
  [te.GET_TERRITORY_RELEVANCE_RESOURCE]: `${Be}/workspace/:panelId/:territoryType/:entityId/performance`,
  [te.POST]: `${Be}/workspace/:panelId/post/:provider/:id`,
  [te.CREATOR]: `${Be}/creator/:id/:provider`
}, ut = {
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS: te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS,
  SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2: te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2,
  SHARE_OF_ATTENTION: te.SHARE_OF_ATTENTION,
  SHARE_OF_ATTENTION_V2: te.SHARE_OF_ATTENTION_V2,
  SHARE_OF_ATTENTION_V3: te.SHARE_OF_ATTENTION_V3,
  GET_TERRITORY_PERFORMANCE_RESOURCE: te.GET_TERRITORY_PERFORMANCE_RESOURCE,
  GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE: te.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE,
  POST: te.POST,
  CREATOR: te.CREATOR
}, cN = [
  {
    pattern: new RegExp(
      fn(ut.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS),
      "g"
    ),
    replacement: (e) => `<embed data-type="shares" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(
      fn(ut.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2),
      "g"
    ),
    replacement: (e) => `<embed data-type="shares" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(fn(ut.SHARE_OF_ATTENTION_V3), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(fn(ut.SHARE_OF_ATTENTION_V2), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(fn(ut.SHARE_OF_ATTENTION), "g"),
    replacement: (e) => `<embed data-type="share-of-attention" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(fn(ut.GET_TERRITORY_PERFORMANCE_RESOURCE), "g"),
    replacement: (e) => `<embed data-type="territory-performance" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(
      fn(ut.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE),
      "g"
    ),
    replacement: (e) => `<embed data-type="brand-engagement-over-time" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(fn(ut.POST), "g"),
    replacement: (e) => `<embed data-type="post" data-uri="${e}"></embed>`
  },
  {
    pattern: new RegExp(fn(ut.CREATOR), "g"),
    replacement: (e) => `<embed data-type="creator" data-uri="${e}"></embed>`
  }
], Pl = {
  yt: "YouTube",
  fb: "Facebook",
  in: "Instagram",
  tt: "TikTok",
  tw: "Twitter",
  all: "All Providers"
}, ra = { fb: !0, tt: !0, yt: !0, in: !0, tw: !0 }, xs = {
  topic: "topic",
  subtopic: "subtopic",
  global_topic: "global-topic",
  niche: "niche",
  saved_search: "saved-search",
  brand_territory: "brand",
  trending_subject: "trending-tag",
  trending: "trending",
  brand_group: "brand-group",
  tag: "tag",
  industry_topic: "industry-category",
  theme: "theme",
  segment: "segment",
  subject: "subject",
  entity_query: "entity-query",
  entity: "entity"
}, lN = ["pt-BR", "en", "es"];
class dN {
  /**
   * @param customSettings string in the format: `{ color: string }` or just the color string
   */
  parseColorFromSettings(t, n) {
    const r = t?.trim();
    try {
      const i = JSON.parse(r ?? "");
      if (i?.color)
        return i.color;
    } catch {
      if (r?.startsWith("#") || r?.startsWith("rgba") || r?.startsWith("rgb"))
        return r;
    }
    return Kh[n % Kh.length];
  }
  /**
   * Get color from brand, checking brand.color, brand.brandColor, then customSettings, then default
   */
  getBrandColor(t, n) {
    return t.color ? t.color : t.brandColor ? t.brandColor : this.parseColorFromSettings(t.customSettings, n);
  }
  getMetricKeyByTerritoryType(t) {
    const n = {
      earned: "earnedTerritory",
      paid: "paidTerritory",
      selfContent: "selfContentTerritory",
      owned: "selfContentTerritory",
      // 'owned' is the same as 'selfContent'
      grouped: "groupedTerritory",
      overview: "groupedTerritory"
      // 'overview' is the same as 'grouped'
    };
    return n[t] || n.grouped;
  }
}
const Qr = new dN(), Qh = (e) => {
  const n = [3, 6, 12, 24, 36, 61], r = Math.floor(e / 30);
  return n.includes(r) ? {
    timeUnit: "month",
    timeValue: r
  } : {
    timeUnit: "day",
    timeValue: e
  };
}, hN = (e) => {
  const t = e.split(":");
  if (t.length === 2) {
    const n = new Date(t[0]), r = new Date(t[1]);
    if (!isNaN(n.getTime()) && !isNaN(r.getTime()))
      return {
        gte: Math.floor(n.getTime()),
        lte: Math.floor(r.getTime())
      };
  }
}, Cu = (e) => typeof e == "string" && e.includes(":") ? { publishedAt: hN(e), timeRange: null } : typeof e == "number" ? { timeRange: Qh(e), publishedAt: null } : typeof e == "string" && !isNaN(Number(e)) ? { timeRange: Qh(Number(e)), publishedAt: null } : {}, HE = function() {
  if (window.location.hostname === "localhost")
    return "local";
  const t = window.location.href, n = /^([^.]+\/)(\b((?!insights\b)[\s\S])+)/;
  if (n.test(t)) {
    const s = n.exec(t);
    if (!s)
      return "production";
    switch (s[2]) {
      // temporary production environment for testing
      case "production.":
        return "production";
      case "staging.":
        return "staging";
      case "local.":
        return "local";
      case "dev.":
        return "development";
      default:
        return s[2].includes("testprod") ? "staging" : "development";
    }
  }
  return "production";
}, fN = Object.values(ut), pN = Object.values(te).filter((e) => !fN.includes(e)).map(fn), mN = (e) => pN.reduce((t, n) => {
  const r = new RegExp(
    // Negative lookbehind to avoid matching URIs preceded by quotes
    `(?<!")(?<!')(${n})(?!")(?!')`,
    "g"
  );
  return t.replace(r, "");
}, e), gN = [
  "ai.dev.winnin.com",
  "ai.stg.winnin.com",
  "ai.winnin.com",
  "production.ai.winnin.com",
  "localhost:3040"
], EN = [
  "artifacts.dev.insights.winnin.com",
  "artifacts-stg.insights.winnin.com",
  "artifacts.insights.winnin.com"
], BE = (e) => e.map((t) => t.replace(/[.]/g, "\\.")).join("|"), UE = BE(gN), bN = BE(EN), _N = new RegExp(`https?://(?:${UE})/w/([^/]+)/workflows/deliverables/([^/?#)\\s]+)`, "g"), TN = new RegExp(`https?://(?:${UE})/deliverables/c/a/([^/?#)\\s]+)`, "g"), AN = new RegExp(`https?://(?:${bN})/w/([^/]+)/a/([^/?#)\\s]+)`, "g"), FE = (e) => e.replace(_N, `${is.baseUrl}/workspace/$1/artifact/$2`).replace(TN, `${is.baseUrl}/public/artifact/$1`).replace(AN, `${is.baseUrl}/workspace/$1/artifact/$2`), Xh = (e, t) => {
  const n = "yt|fb|in|tt|tw", r = new RegExp(
    `(?<!\\]\\([^\\)]*?)(?:winnin://)?(${t}):(${n}):([a-zA-Z0-9_-]+)(?=\\s|$|\\.|,|\\))`,
    "g"
  ), s = new RegExp(
    `\\[([^\\]]+)\\]\\((?:winnin://)?(${t}):(${n}):([a-zA-Z0-9_-]+)\\)`,
    "g"
  );
  let i = e;
  return i = i.replace(
    s,
    (a, o, u, c, l) => `winnin://${u}/${c}/${l}`
  ), i = i.replace(
    r,
    (a, o, u, c) => `winnin://${o}/${u}/${c}`
  ), i;
}, Ol = (e, t, n = "overview") => {
  const [r, s] = t.split("."), i = xs[r];
  return i ? `${is.baseUrl}/workspace/${e}/${i}/${s}/${n}` : "";
}, yN = (e, t) => {
  const n = Object.keys(xs).join("|"), r = new RegExp(
    // 1) In markdown link format with and without "winnin://" [text](winnin://brand_territory.abc-123) or [text](brand_territory.abc-123)
    `\\[(?<text>[^\\]]+)\\]\\((?:winnin://)?(?<fullMatch>(${n})\\.([a-zA-Z0-9_-]+))\\)|\\[(?<onlyBrackets>(${n})\\.([a-zA-Z0-9_-]+))\\]|(?<!\\]\\([^\\)]*?)(?<!/)(?<!winnin://)(?<![a-zA-Z0-9_])(?<loose>(${n})\\.([a-zA-Z0-9_-]+))(?!/|\\?)(?=\\s|$|\\.|,|\\)|\\])`,
    "g"
  );
  return t.replace(r, (i, ...a) => {
    const o = a.at(-1), u = o.fullMatch || o.onlyBrackets || o.loose;
    if (!u) return i;
    const c = Ol(e, u);
    return `[${o.text || u}](${c})`;
  });
}, xN = (e) => cN.reduce((t, { pattern: n, replacement: r }) => t.replace(n, r), e);
function it(e, t = {}) {
  const n = typeof t == "string" ? { path: t, exact: !1, strict: !1, sensitive: !1 } : {
    path: t.path,
    exact: t.exact ?? !1,
    strict: t.strict ?? !1,
    sensitive: t.sensitive ?? !1
  }, { path: r, exact: s, strict: i, sensitive: a } = n;
  if (!r) return null;
  const o = [], u = r.replace(/\/$/, i ? "/" : "/?").replace(/:(\w+)/g, (g, _) => (o.push({ name: _ }), "([^\\/]+)")).replace(/\*/g, "(.*)"), c = a ? "" : "i", h = new RegExp("^" + u + (s ? "$" : ""), c).exec(e);
  if (!h) return null;
  const m = h[0], p = e === m;
  if (s && !p) return null;
  const E = o.reduce(
    (g, _, b) => (g[_.name] = h[b + 1] || "", g),
    {}
  );
  return { path: r, url: m, isExact: p, params: E };
}
const CN = (e, t) => t.replace(
  /<embed data-type="(shares|share-of-attention)" data-uri="([^"]+)"><\/embed>/g,
  (n, r, s) => {
    if (!Object.values(te).find(
      (o) => it(s, { path: o, exact: !0 })
    )) return n;
    const a = Kt(Bn[te.SHARE_OF_ATTENTION_V2], {
      panelId: e
    });
    return `[${a}](${a})`;
  }
);
class Dl {
  constructor(t, n) {
    this.workspaceId = t, this.text = n;
  }
  replaceText(t) {
    return this.text = t, this;
  }
  /**
   * Replaces territory IDs in the text with markdown links.
   */
  replaceTerritoryIds() {
    const t = yN(this.workspaceId, this.text);
    return this.replaceText(t);
  }
  /**
   * Rewrites winnin-intelligence artifact links to the old platform's (insights) artifact routes,
   * so links clicked in this chat stay in the platform the user is actually in.
   */
  replaceArtifactLinks() {
    const t = FE(this.text);
    return this.replaceText(t);
  }
  /**
   * Replaces post IDs in the text with markdown links.
   */
  replacePostIds() {
    const t = Xh(this.text, "post");
    return this.replaceText(t);
  }
  /**
   * Replaces creator IDs in the text with markdown links.
   */
  replaceCreatorIds() {
    const t = Xh(this.text, "creator");
    return this.replaceText(t);
  }
  /**
   * Replaces specific URI patterns in the text with corresponding widget embed tags.
   */
  replaceWidgets() {
    const t = xN(this.text);
    return this.replaceText(t);
  }
  cleanUnusedURIs() {
    const t = mN(this.text);
    return this.replaceText(t);
  }
  /**
   * Replaces widget embed tags with macroarea links.
   */
  replaceWidgetTagWithLink() {
    const t = CN(this.workspaceId, this.text);
    return this.replaceText(t);
  }
  /**
   * @returns The final text with all replacements made.
   */
  build() {
    return this.text;
  }
}
const SN = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, wN = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, IN = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function vN(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    NN(e);
    return;
  }
  return t;
}
function NN(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function jE(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const n = e.trim();
  if (n.length <= 9)
    switch (n.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!IN.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (SN.test(e) || wN.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, vN);
    }
    return JSON.parse(e);
  } catch (r) {
    if (t.strict)
      throw r;
    return e;
  }
}
function Jh(e) {
  if (!e)
    return {
      id: null,
      metadata: null,
      data: null,
      mimetype: null,
      encoding: null,
      path: null
    };
  if (typeof e.data == "string")
    try {
      e.data = jE(e.data);
    } catch (t) {
      console.error("Failed to parse tool result data:", t), e.data = null;
    }
  return e;
}
function $E(e) {
  if (!e) return [];
  if (typeof e == "string")
    try {
      return e = jE(e), Array.isArray(e) ? e.map(Jh) : [Jh(e)];
    } catch (t) {
      return console.error("Failed to parse tool result:", t), [];
    }
  return e;
}
const Ya = {
  local: "http://localhost:3000",
  development: "https://zai-chat.dev.insights.winnin.com",
  staging: "https://zai-chat-staging.insights.winnin.com",
  production: "https://chat.insights.winnin.com"
};
class kN {
  constructor(t) {
    this.workspaceId = t.workspaceId, this.getValidToken = t.getValidToken, this.userId = t.userId, this.userEmail = t.userEmail, this.abortSignal = t.abortSignal, this.baseUrl = this.getBaseURLByEnvironment();
  }
  getBaseURLByEnvironment() {
    const t = HE();
    return Ya[t] || Ya.development;
  }
  async getHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${await this.getValidToken()}`
    };
  }
  async getPrePrompts(t) {
    const n = new URLSearchParams({ language: t }), r = `${this.baseUrl}/api/workspace/${this.workspaceId}/prompt?${n.toString()}`;
    try {
      const s = await this.getHeaders(), i = await fetch(r, {
        method: "GET",
        headers: s
      });
      if (!i.ok)
        throw new Error(`Failed to fetch prompts: ${i.statusText}`);
      return await i.json() ?? [];
    } catch (s) {
      throw console.error({
        log: "Zai Chat - Error to fetch pre prompts from backend",
        query: { name: r },
        error: s
      }), s;
    }
  }
  async getThreads() {
    const t = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads`;
    try {
      const n = await this.getHeaders(), r = await fetch(t, {
        method: "GET",
        headers: n
      });
      if (!r.ok)
        throw new Error(`Failed to fetch threads: ${r.statusText}`);
      return await r.json();
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch threads from backend",
        query: { name: t },
        error: n
      }), n;
    }
  }
  async getMessagesByThreadId(t) {
    const n = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads/${t}`;
    try {
      const r = await this.getHeaders(), s = await fetch(n, {
        method: "GET",
        headers: r
      });
      if (!s.ok)
        throw new Error(`Failed to fetch thread: ${s.statusText}`);
      return await s.json();
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch messages by thread ID from backend",
        query: { name: n },
        error: r
      }), r;
    }
  }
  async deleteThread(t) {
    const n = `${this.baseUrl}/api/workspace/${this.workspaceId}/threads/${t}`;
    try {
      const r = await this.getHeaders(), s = await fetch(n, {
        method: "DELETE",
        headers: r
      });
      if (!s.ok)
        throw new Error(`Failed to delete thread: ${s.statusText}`);
      return await s.json();
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error deleting thread in backend",
        query: { name: n, variables: { threadId: t, workspaceId: this.workspaceId } },
        error: r
      }), r;
    }
  }
  async postMessageToThread(t, n, r = {}) {
    const s = `${this.baseUrl}/api/workspace/${this.workspaceId}/chat`, i = JSON.stringify({
      thread: t,
      ...n
    });
    try {
      const a = await this.getHeaders(), o = await fetch(s, {
        method: "POST",
        headers: a,
        body: i,
        signal: r?.abortSignal || this.abortSignal
      });
      if (!o.ok)
        throw new Error(`Failed to post message: ${o.statusText}`);
      return o.body?.getReader();
    } catch (a) {
      throw console.error({
        log: "Zai Chat - Error to post message to thread in backend",
        query: { name: s, variables: { body: i } },
        error: a
      }), a;
    }
  }
  // This method is not currently being used, but it will be useful in the future when we migrate message processing to the frontend.
  static processThreadMessages(t, n) {
    const r = t.filter((a) => a.role === "tool").reduce((a, o) => {
      const u = o;
      return a[u.content.kwargs.tool_call_id] = {
        content: u.content.kwargs.content,
        status: u.content.kwargs.status
      }, a;
    }, {});
    return t.filter((a) => a.role !== "tool").map((a) => {
      switch (a.role) {
        case "user":
          return {
            id: crypto.randomUUID(),
            metadata: {},
            role: "user",
            attachments: [],
            content: [{ type: "text", text: a.content }],
            createdAt: new Date(a.created_at),
            status: { type: "complete", reason: "stop" }
          };
        case "assistant": {
          if (typeof a.content == "string") {
            const m = new Dl(n, a.content).replaceTerritoryIds().replacePostIds().replaceCreatorIds().replaceWidgets().replaceArtifactLinks().cleanUnusedURIs().build();
            return {
              id: crypto.randomUUID(),
              metadata: {},
              role: "assistant",
              content: [{ type: "text", text: m }],
              createdAt: new Date(a.created_at),
              status: { type: "complete", reason: "stop" }
            };
          }
          const o = a.content;
          let u;
          try {
            u = JSON.parse(o.arguments);
          } catch {
            console.log("Failed to parse arguments:", o.arguments);
          }
          const c = u?.resource_uri;
          let l = LE[o.name];
          l && (l = Kt(l, u));
          const h = r[o.id];
          return {
            id: crypto.randomUUID(),
            metadata: {},
            createdAt: new Date(a.created_at),
            role: "assistant",
            content: [
              {
                type: "tool-call",
                toolCallId: o.id,
                toolName: o.name,
                args: u,
                argsText: c || l,
                result: $E(h?.content) || null
              }
            ],
            status: h ? { type: "complete", reason: "stop" } : { type: "requires-action", reason: "tool-calls" }
          };
        }
        default:
          return {};
      }
    }).reduce(
      (a, o) => {
        const u = a.messages[a.messages.length - 1] || null;
        if (u?.message.role === o.role && u.message.id === a.lastId) {
          const c = a.messages[a.messages.length - 1].message.content;
          a.messages[a.messages.length - 1].message.content = [...c, ...o.content], a.messages[a.messages.length - 1].message.status = o.status;
        } else {
          const c = o.id;
          a.messages.push({ message: o, parentId: a.lastId }), a.lastId = c;
        }
        return a;
      },
      { messages: [], lastId: null }
    ).messages;
  }
}
const Ll = (e) => {
  const { workspaceId: t, userId: n, userEmail: r, getValidToken: s } = at();
  return se(
    () => new kN({
      workspaceId: t,
      getValidToken: s,
      userId: n,
      userEmail: r,
      abortSignal: e?.abortSignal
    }),
    [t, n, r, s, e?.abortSignal]
  );
}, zE = de(
  ({ children: e, currentThread: t }) => {
    const n = Ll(), r = J((u) => u?.threadListItem?.remoteId), s = J((u) => u?.threadListItem?.id), i = J((u) => u?.threads?.mainThreadId);
    s === i && (t.current = r ?? null);
    const a = se(
      () => ({
        async load() {
          return r ? { messages: (await n.getMessagesByThreadId(r)).map(
            (l) => l.message.role === "assistant" ? {
              ...l,
              message: {
                ...l.message,
                content: l.message.content.map(
                  (h) => h.type === "text" ? { ...h, text: FE(h.text) } : h
                )
              }
            } : l
          ) } : { messages: [] };
        },
        async append() {
        }
      }),
      [r, n]
    ), o = se(() => ({ history: a }), [a]);
    return /* @__PURE__ */ d.jsx(rl, { adapters: o, children: e });
  }
);
zE.displayName = "ThreadAdapterProvider";
const RN = ({ currentThread: e }) => (t) => /* @__PURE__ */ d.jsx(zE, { currentThread: e, ...t }), He = a1, Oi = o1;
new TextEncoder();
const PN = 4096;
function VE(e, t, n) {
  let r = t;
  const s = r + n, i = [];
  let a = "";
  for (; r < s; ) {
    const o = e[r++];
    if ((o & 128) === 0)
      i.push(o);
    else if ((o & 224) === 192) {
      const u = e[r++] & 63;
      i.push((o & 31) << 6 | u);
    } else if ((o & 240) === 224) {
      const u = e[r++] & 63, c = e[r++] & 63;
      i.push((o & 31) << 12 | u << 6 | c);
    } else if ((o & 248) === 240) {
      const u = e[r++] & 63, c = e[r++] & 63, l = e[r++] & 63;
      let h = (o & 7) << 18 | u << 12 | c << 6 | l;
      h > 65535 && (h -= 65536, i.push(h >>> 10 & 1023 | 55296), h = 56320 | h & 1023), i.push(h);
    } else
      i.push(o);
    i.length >= PN && (a += String.fromCharCode(...i), i.length = 0);
  }
  return i.length > 0 && (a += String.fromCharCode(...i)), a;
}
const ON = new TextDecoder(), DN = 200;
function LN(e, t, n) {
  const r = e.subarray(t, t + n);
  return ON.decode(r);
}
function MN(e, t, n) {
  return n > DN ? LN(e, t, n) : VE(e, t, n);
}
class sa {
  constructor(t, n) {
    k(this, "type");
    k(this, "data");
    this.type = t, this.data = n;
  }
}
class Mt extends Error {
  constructor(t) {
    super(t);
    const n = Object.create(Mt.prototype);
    Object.setPrototypeOf(this, n), Object.defineProperty(this, "name", {
      configurable: !0,
      enumerable: !1,
      value: Mt.name
    });
  }
}
const Hs = 4294967295;
function HN(e, t, n) {
  const r = Math.floor(n / 4294967296), s = n;
  e.setUint32(t, r), e.setUint32(t + 4, s);
}
function YE(e, t) {
  const n = e.getInt32(t), r = e.getUint32(t + 4);
  return n * 4294967296 + r;
}
function BN(e, t) {
  const n = e.getUint32(t), r = e.getUint32(t + 4);
  return n * 4294967296 + r;
}
const UN = -1, FN = 4294967296 - 1, jN = 17179869184 - 1;
function $N({ sec: e, nsec: t }) {
  if (e >= 0 && t >= 0 && e <= jN)
    if (t === 0 && e <= FN) {
      const n = new Uint8Array(4);
      return new DataView(n.buffer).setUint32(0, e), n;
    } else {
      const n = e / 4294967296, r = e & 4294967295, s = new Uint8Array(8), i = new DataView(s.buffer);
      return i.setUint32(0, t << 2 | n & 3), i.setUint32(4, r), s;
    }
  else {
    const n = new Uint8Array(12), r = new DataView(n.buffer);
    return r.setUint32(0, t), HN(r, 4, e), n;
  }
}
function zN(e) {
  const t = e.getTime(), n = Math.floor(t / 1e3), r = (t - n * 1e3) * 1e6, s = Math.floor(r / 1e9);
  return {
    sec: n + s,
    nsec: r - s * 1e9
  };
}
function VN(e) {
  if (e instanceof Date) {
    const t = zN(e);
    return $N(t);
  } else
    return null;
}
function YN(e) {
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength);
  switch (e.byteLength) {
    case 4:
      return { sec: t.getUint32(0), nsec: 0 };
    case 8: {
      const n = t.getUint32(0), r = t.getUint32(4), s = (n & 3) * 4294967296 + r, i = n >>> 2;
      return { sec: s, nsec: i };
    }
    case 12: {
      const n = YE(t, 4), r = t.getUint32(0);
      return { sec: n, nsec: r };
    }
    default:
      throw new Mt(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${e.length}`);
  }
}
function GN(e) {
  const t = YN(e);
  return new Date(t.sec * 1e3 + t.nsec / 1e6);
}
const WN = {
  type: UN,
  encode: VN,
  decode: GN
}, no = class no {
  constructor() {
    // ensures ExtensionCodecType<X> matches ExtensionCodec<X>
    // this will make type errors a lot more clear
    // eslint-disable-next-line @typescript-eslint/naming-convention
    k(this, "__brand");
    // built-in extensions
    k(this, "builtInEncoders", []);
    k(this, "builtInDecoders", []);
    // custom extensions
    k(this, "encoders", []);
    k(this, "decoders", []);
    this.register(WN);
  }
  register({ type: t, encode: n, decode: r }) {
    if (t >= 0)
      this.encoders[t] = n, this.decoders[t] = r;
    else {
      const s = -1 - t;
      this.builtInEncoders[s] = n, this.builtInDecoders[s] = r;
    }
  }
  tryToEncode(t, n) {
    for (let r = 0; r < this.builtInEncoders.length; r++) {
      const s = this.builtInEncoders[r];
      if (s != null) {
        const i = s(t, n);
        if (i != null) {
          const a = -1 - r;
          return new sa(a, i);
        }
      }
    }
    for (let r = 0; r < this.encoders.length; r++) {
      const s = this.encoders[r];
      if (s != null) {
        const i = s(t, n);
        if (i != null) {
          const a = r;
          return new sa(a, i);
        }
      }
    }
    return t instanceof sa ? t : null;
  }
  decode(t, n, r) {
    const s = n < 0 ? this.builtInDecoders[-1 - n] : this.decoders[n];
    return s ? s(t, n, r) : new sa(n, t);
  }
};
k(no, "defaultCodec", new no());
let Cc = no;
function qN(e) {
  return e instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer;
}
function Zh(e) {
  return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : qN(e) ? new Uint8Array(e) : Uint8Array.from(e);
}
function Su(e) {
  return `${e < 0 ? "-" : ""}0x${Math.abs(e).toString(16).padStart(2, "0")}`;
}
const KN = 16, QN = 16;
class XN {
  constructor(t = KN, n = QN) {
    k(this, "hit", 0);
    k(this, "miss", 0);
    k(this, "caches");
    k(this, "maxKeyLength");
    k(this, "maxLengthPerKey");
    this.maxKeyLength = t, this.maxLengthPerKey = n, this.caches = [];
    for (let r = 0; r < this.maxKeyLength; r++)
      this.caches.push([]);
  }
  canBeCached(t) {
    return t > 0 && t <= this.maxKeyLength;
  }
  find(t, n, r) {
    const s = this.caches[r - 1];
    e: for (const i of s) {
      const a = i.bytes;
      for (let o = 0; o < r; o++)
        if (a[o] !== t[n + o])
          continue e;
      return i.str;
    }
    return null;
  }
  store(t, n) {
    const r = this.caches[t.length - 1], s = { bytes: t, str: n };
    r.length >= this.maxLengthPerKey ? r[Math.random() * r.length | 0] = s : r.push(s);
  }
  decode(t, n, r) {
    const s = this.find(t, n, r);
    if (s != null)
      return this.hit++, s;
    this.miss++;
    const i = VE(t, n, r), a = Uint8Array.prototype.slice.call(t, n, n + r);
    return this.store(a, i), i;
  }
}
const Sc = "array", ti = "map_key", GE = "map_value", JN = (e) => {
  if (typeof e == "string" || typeof e == "number")
    return e;
  throw new Mt("The type of key must be string or number but " + typeof e);
};
class ZN {
  constructor() {
    k(this, "stack", []);
    k(this, "stackHeadPosition", -1);
  }
  get length() {
    return this.stackHeadPosition + 1;
  }
  top() {
    return this.stack[this.stackHeadPosition];
  }
  pushArrayState(t) {
    const n = this.getUninitializedStateFromPool();
    n.type = Sc, n.position = 0, n.size = t, n.array = new Array(t);
  }
  pushMapState(t) {
    const n = this.getUninitializedStateFromPool();
    n.type = ti, n.readCount = 0, n.size = t, n.map = {};
  }
  getUninitializedStateFromPool() {
    if (this.stackHeadPosition++, this.stackHeadPosition === this.stack.length) {
      const t = {
        type: void 0,
        size: 0,
        array: void 0,
        position: 0,
        readCount: 0,
        map: void 0,
        key: null
      };
      this.stack.push(t);
    }
    return this.stack[this.stackHeadPosition];
  }
  release(t) {
    if (this.stack[this.stackHeadPosition] !== t)
      throw new Error("Invalid stack state. Released state is not on top of the stack.");
    if (t.type === Sc) {
      const r = t;
      r.size = 0, r.array = void 0, r.position = 0, r.type = void 0;
    }
    if (t.type === ti || t.type === GE) {
      const r = t;
      r.size = 0, r.map = void 0, r.readCount = 0, r.type = void 0;
    }
    this.stackHeadPosition--;
  }
  reset() {
    this.stack.length = 0, this.stackHeadPosition = -1;
  }
}
const Bs = -1, Ml = new DataView(new ArrayBuffer(0)), ek = new Uint8Array(Ml.buffer);
try {
  Ml.getInt8(0);
} catch (e) {
  if (!(e instanceof RangeError))
    throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
const ef = new RangeError("Insufficient data"), tk = new XN();
class Hl {
  constructor(t) {
    k(this, "extensionCodec");
    k(this, "context");
    k(this, "useBigInt64");
    k(this, "rawStrings");
    k(this, "maxStrLength");
    k(this, "maxBinLength");
    k(this, "maxArrayLength");
    k(this, "maxMapLength");
    k(this, "maxExtLength");
    k(this, "keyDecoder");
    k(this, "mapKeyConverter");
    k(this, "totalPos", 0);
    k(this, "pos", 0);
    k(this, "view", Ml);
    k(this, "bytes", ek);
    k(this, "headByte", Bs);
    k(this, "stack", new ZN());
    k(this, "entered", !1);
    this.extensionCodec = t?.extensionCodec ?? Cc.defaultCodec, this.context = t?.context, this.useBigInt64 = t?.useBigInt64 ?? !1, this.rawStrings = t?.rawStrings ?? !1, this.maxStrLength = t?.maxStrLength ?? Hs, this.maxBinLength = t?.maxBinLength ?? Hs, this.maxArrayLength = t?.maxArrayLength ?? Hs, this.maxMapLength = t?.maxMapLength ?? Hs, this.maxExtLength = t?.maxExtLength ?? Hs, this.keyDecoder = t?.keyDecoder !== void 0 ? t.keyDecoder : tk, this.mapKeyConverter = t?.mapKeyConverter ?? JN;
  }
  clone() {
    return new Hl({
      extensionCodec: this.extensionCodec,
      context: this.context,
      useBigInt64: this.useBigInt64,
      rawStrings: this.rawStrings,
      maxStrLength: this.maxStrLength,
      maxBinLength: this.maxBinLength,
      maxArrayLength: this.maxArrayLength,
      maxMapLength: this.maxMapLength,
      maxExtLength: this.maxExtLength,
      keyDecoder: this.keyDecoder
    });
  }
  reinitializeState() {
    this.totalPos = 0, this.headByte = Bs, this.stack.reset();
  }
  setBuffer(t) {
    const n = Zh(t);
    this.bytes = n, this.view = new DataView(n.buffer, n.byteOffset, n.byteLength), this.pos = 0;
  }
  appendBuffer(t) {
    if (this.headByte === Bs && !this.hasRemaining(1))
      this.setBuffer(t);
    else {
      const n = this.bytes.subarray(this.pos), r = Zh(t), s = new Uint8Array(n.length + r.length);
      s.set(n), s.set(r, n.length), this.setBuffer(s);
    }
  }
  hasRemaining(t) {
    return this.view.byteLength - this.pos >= t;
  }
  createExtraByteError(t) {
    const { view: n, pos: r } = this;
    return new RangeError(`Extra ${n.byteLength - r} of ${n.byteLength} byte(s) found at buffer[${t}]`);
  }
  /**
   * @throws {@link DecodeError}
   * @throws {@link RangeError}
   */
  decode(t) {
    if (this.entered)
      return this.clone().decode(t);
    try {
      this.entered = !0, this.reinitializeState(), this.setBuffer(t);
      const n = this.doDecodeSync();
      if (this.hasRemaining(1))
        throw this.createExtraByteError(this.pos);
      return n;
    } finally {
      this.entered = !1;
    }
  }
  *decodeMulti(t) {
    if (this.entered) {
      yield* this.clone().decodeMulti(t);
      return;
    }
    try {
      for (this.entered = !0, this.reinitializeState(), this.setBuffer(t); this.hasRemaining(1); )
        yield this.doDecodeSync();
    } finally {
      this.entered = !1;
    }
  }
  async decodeAsync(t) {
    if (this.entered)
      return this.clone().decodeAsync(t);
    try {
      this.entered = !0;
      let n = !1, r;
      for await (const o of t) {
        if (n)
          throw this.entered = !1, this.createExtraByteError(this.totalPos);
        this.appendBuffer(o);
        try {
          r = this.doDecodeSync(), n = !0;
        } catch (u) {
          if (!(u instanceof RangeError))
            throw u;
        }
        this.totalPos += this.pos;
      }
      if (n) {
        if (this.hasRemaining(1))
          throw this.createExtraByteError(this.totalPos);
        return r;
      }
      const { headByte: s, pos: i, totalPos: a } = this;
      throw new RangeError(`Insufficient data in parsing ${Su(s)} at ${a} (${i} in the current buffer)`);
    } finally {
      this.entered = !1;
    }
  }
  decodeArrayStream(t) {
    return this.decodeMultiAsync(t, !0);
  }
  decodeStream(t) {
    return this.decodeMultiAsync(t, !1);
  }
  async *decodeMultiAsync(t, n) {
    if (this.entered) {
      yield* this.clone().decodeMultiAsync(t, n);
      return;
    }
    try {
      this.entered = !0;
      let r = n, s = -1;
      for await (const i of t) {
        if (n && s === 0)
          throw this.createExtraByteError(this.totalPos);
        this.appendBuffer(i), r && (s = this.readArraySize(), r = !1, this.complete());
        try {
          for (; yield this.doDecodeSync(), --s !== 0; )
            ;
        } catch (a) {
          if (!(a instanceof RangeError))
            throw a;
        }
        this.totalPos += this.pos;
      }
    } finally {
      this.entered = !1;
    }
  }
  doDecodeSync() {
    e: for (; ; ) {
      const t = this.readHeadByte();
      let n;
      if (t >= 224)
        n = t - 256;
      else if (t < 192)
        if (t < 128)
          n = t;
        else if (t < 144) {
          const s = t - 128;
          if (s !== 0) {
            this.pushMapState(s), this.complete();
            continue e;
          } else
            n = {};
        } else if (t < 160) {
          const s = t - 144;
          if (s !== 0) {
            this.pushArrayState(s), this.complete();
            continue e;
          } else
            n = [];
        } else {
          const s = t - 160;
          n = this.decodeString(s, 0);
        }
      else if (t === 192)
        n = null;
      else if (t === 194)
        n = !1;
      else if (t === 195)
        n = !0;
      else if (t === 202)
        n = this.readF32();
      else if (t === 203)
        n = this.readF64();
      else if (t === 204)
        n = this.readU8();
      else if (t === 205)
        n = this.readU16();
      else if (t === 206)
        n = this.readU32();
      else if (t === 207)
        this.useBigInt64 ? n = this.readU64AsBigInt() : n = this.readU64();
      else if (t === 208)
        n = this.readI8();
      else if (t === 209)
        n = this.readI16();
      else if (t === 210)
        n = this.readI32();
      else if (t === 211)
        this.useBigInt64 ? n = this.readI64AsBigInt() : n = this.readI64();
      else if (t === 217) {
        const s = this.lookU8();
        n = this.decodeString(s, 1);
      } else if (t === 218) {
        const s = this.lookU16();
        n = this.decodeString(s, 2);
      } else if (t === 219) {
        const s = this.lookU32();
        n = this.decodeString(s, 4);
      } else if (t === 220) {
        const s = this.readU16();
        if (s !== 0) {
          this.pushArrayState(s), this.complete();
          continue e;
        } else
          n = [];
      } else if (t === 221) {
        const s = this.readU32();
        if (s !== 0) {
          this.pushArrayState(s), this.complete();
          continue e;
        } else
          n = [];
      } else if (t === 222) {
        const s = this.readU16();
        if (s !== 0) {
          this.pushMapState(s), this.complete();
          continue e;
        } else
          n = {};
      } else if (t === 223) {
        const s = this.readU32();
        if (s !== 0) {
          this.pushMapState(s), this.complete();
          continue e;
        } else
          n = {};
      } else if (t === 196) {
        const s = this.lookU8();
        n = this.decodeBinary(s, 1);
      } else if (t === 197) {
        const s = this.lookU16();
        n = this.decodeBinary(s, 2);
      } else if (t === 198) {
        const s = this.lookU32();
        n = this.decodeBinary(s, 4);
      } else if (t === 212)
        n = this.decodeExtension(1, 0);
      else if (t === 213)
        n = this.decodeExtension(2, 0);
      else if (t === 214)
        n = this.decodeExtension(4, 0);
      else if (t === 215)
        n = this.decodeExtension(8, 0);
      else if (t === 216)
        n = this.decodeExtension(16, 0);
      else if (t === 199) {
        const s = this.lookU8();
        n = this.decodeExtension(s, 1);
      } else if (t === 200) {
        const s = this.lookU16();
        n = this.decodeExtension(s, 2);
      } else if (t === 201) {
        const s = this.lookU32();
        n = this.decodeExtension(s, 4);
      } else
        throw new Mt(`Unrecognized type byte: ${Su(t)}`);
      this.complete();
      const r = this.stack;
      for (; r.length > 0; ) {
        const s = r.top();
        if (s.type === Sc)
          if (s.array[s.position] = n, s.position++, s.position === s.size)
            n = s.array, r.release(s);
          else
            continue e;
        else if (s.type === ti) {
          if (n === "__proto__")
            throw new Mt("The key __proto__ is not allowed");
          s.key = this.mapKeyConverter(n), s.type = GE;
          continue e;
        } else if (s.map[s.key] = n, s.readCount++, s.readCount === s.size)
          n = s.map, r.release(s);
        else {
          s.key = null, s.type = ti;
          continue e;
        }
      }
      return n;
    }
  }
  readHeadByte() {
    return this.headByte === Bs && (this.headByte = this.readU8()), this.headByte;
  }
  complete() {
    this.headByte = Bs;
  }
  readArraySize() {
    const t = this.readHeadByte();
    switch (t) {
      case 220:
        return this.readU16();
      case 221:
        return this.readU32();
      default: {
        if (t < 160)
          return t - 144;
        throw new Mt(`Unrecognized array type byte: ${Su(t)}`);
      }
    }
  }
  pushMapState(t) {
    if (t > this.maxMapLength)
      throw new Mt(`Max length exceeded: map length (${t}) > maxMapLengthLength (${this.maxMapLength})`);
    this.stack.pushMapState(t);
  }
  pushArrayState(t) {
    if (t > this.maxArrayLength)
      throw new Mt(`Max length exceeded: array length (${t}) > maxArrayLength (${this.maxArrayLength})`);
    this.stack.pushArrayState(t);
  }
  decodeString(t, n) {
    return !this.rawStrings || this.stateIsMapKey() ? this.decodeUtf8String(t, n) : this.decodeBinary(t, n);
  }
  /**
   * @throws {@link RangeError}
   */
  decodeUtf8String(t, n) {
    if (t > this.maxStrLength)
      throw new Mt(`Max length exceeded: UTF-8 byte length (${t}) > maxStrLength (${this.maxStrLength})`);
    if (this.bytes.byteLength < this.pos + n + t)
      throw ef;
    const r = this.pos + n;
    let s;
    return this.stateIsMapKey() && this.keyDecoder?.canBeCached(t) ? s = this.keyDecoder.decode(this.bytes, r, t) : s = MN(this.bytes, r, t), this.pos += n + t, s;
  }
  stateIsMapKey() {
    return this.stack.length > 0 ? this.stack.top().type === ti : !1;
  }
  /**
   * @throws {@link RangeError}
   */
  decodeBinary(t, n) {
    if (t > this.maxBinLength)
      throw new Mt(`Max length exceeded: bin length (${t}) > maxBinLength (${this.maxBinLength})`);
    if (!this.hasRemaining(t + n))
      throw ef;
    const r = this.pos + n, s = this.bytes.subarray(r, r + t);
    return this.pos += n + t, s;
  }
  decodeExtension(t, n) {
    if (t > this.maxExtLength)
      throw new Mt(`Max length exceeded: ext length (${t}) > maxExtLength (${this.maxExtLength})`);
    const r = this.view.getInt8(this.pos + n), s = this.decodeBinary(
      t,
      n + 1
      /* extType */
    );
    return this.extensionCodec.decode(s, r, this.context);
  }
  lookU8() {
    return this.view.getUint8(this.pos);
  }
  lookU16() {
    return this.view.getUint16(this.pos);
  }
  lookU32() {
    return this.view.getUint32(this.pos);
  }
  readU8() {
    const t = this.view.getUint8(this.pos);
    return this.pos++, t;
  }
  readI8() {
    const t = this.view.getInt8(this.pos);
    return this.pos++, t;
  }
  readU16() {
    const t = this.view.getUint16(this.pos);
    return this.pos += 2, t;
  }
  readI16() {
    const t = this.view.getInt16(this.pos);
    return this.pos += 2, t;
  }
  readU32() {
    const t = this.view.getUint32(this.pos);
    return this.pos += 4, t;
  }
  readI32() {
    const t = this.view.getInt32(this.pos);
    return this.pos += 4, t;
  }
  readU64() {
    const t = BN(this.view, this.pos);
    return this.pos += 8, t;
  }
  readI64() {
    const t = YE(this.view, this.pos);
    return this.pos += 8, t;
  }
  readU64AsBigInt() {
    const t = this.view.getBigUint64(this.pos);
    return this.pos += 8, t;
  }
  readI64AsBigInt() {
    const t = this.view.getBigInt64(this.pos);
    return this.pos += 8, t;
  }
  readF32() {
    const t = this.view.getFloat32(this.pos);
    return this.pos += 4, t;
  }
  readF64() {
    const t = this.view.getFloat64(this.pos);
    return this.pos += 8, t;
  }
}
function nk(e, t) {
  return new Hl(t).decode(e);
}
const Zt = "ZAI", en = {
  click: "Click",
  select: "Select",
  view: "View",
  start: "Start"
}, rn = {
  prePrompts: `${Zt}_${en.click} Quick prompts`,
  sendMessage: `${Zt}_${en.click} Send message`,
  sendMessageError: `${Zt}_${en.view} Error`,
  feedback: `${Zt}_${en.select} Feedback`,
  sideChatOpen: `${Zt}_${en.click} Side chat`,
  sideChatClose: `${Zt}_${en.click} Side chat close`,
  demandIntelligenceSendMessage: "CAT_Click DI ZAI Send Message",
  startProactiveMessage: `${Zt}_${en.start} Proactive message`,
  htmlGenerated: `${Zt}_${en.view} HTML generated`,
  htmlOpen: `${Zt}_${en.click} HTML open`,
  htmlDownload: `${Zt}_${en.click} HTML download`,
  htmlFileOpened: `${Zt}_${en.view} Downloaded HTML`
};
class rk {
  constructor() {
  }
  track(t, n) {
    const s = {
      "Macro Area": "ZAI",
      ...n
    };
    zi.track(t, s);
  }
  /**
   * What a saved HTML file needs to report its own openings as `htmlFileOpened`, attributed to the
   * user saving it — or null when tracking is off (e.g. impersonation), so the file goes out clean.
   */
  getHtmlOpenTracking(t) {
    const n = zi.getTrackingSnapshot();
    return n ? {
      token: n.token,
      endpoint: n.endpoint,
      eventName: rn.htmlFileOpened,
      properties: {
        ...n.context,
        "Macro Area": "ZAI",
        ...t,
        distinct_id: n.distinctId
      }
    } : null;
  }
  /** The workspace and company the chat is running for — available even when tracking is off. */
  getGlobalContext() {
    return zi.getGlobalContext();
  }
  identify(t) {
    t && zi.identify(t);
  }
}
const Wt = new rk(), sk = (e, t) => Object.prototype.hasOwnProperty.call(e, t), Ga = (e, t, n) => {
  if (Array.isArray(e))
    return e.map((r, s) => Ga(r, `${t}[${s}]`, n));
  if (e && typeof e == "object") {
    const r = e, s = Object.keys(r), i = n.get(t) ?? [], a = new Set(i), o = [
      ...i.filter((u) => sk(r, u)),
      ...s.filter((u) => !a.has(u))
    ];
    return n.set(t, o), Object.fromEntries(o.map((u) => [
      u,
      Ga(r[u], `${t}.${u}`, n)
    ]));
  }
  return e;
}, WE = (e, t) => {
  const n = e?.get(t) ?? /* @__PURE__ */ new Map();
  return e?.set(t, n), n;
}, ik = (e, t, n) => {
  const r = WE(e, t);
  Ga(n, "$", r);
}, qE = (e, t, n) => {
  const r = WE(e, t), s = Ga(n, "$", r);
  return JSON.stringify(s);
}, KE = (e, t, n) => `${e ?? "unknown"}:${t}:${n}`, ak = ({ chunk: e, matchingToolCallChunk: t, messageId: n, toolArgsKeyOrderCache: r }) => {
  const s = KE(n, "tool", e.id), i = e.partial_json ?? t?.args ?? t?.args_json, a = i ?? qE(r, s, e.args), o = a ? co(a) : null, u = a ? o ?? {} : e.args;
  return ik(r, s, o ?? e.args), i == null && r?.delete(s), { args: u, argsText: a };
}, wu = (e) => e?.metadata ?? {}, tf = /* @__PURE__ */ new Set(), ok = (e) => {
  typeof process > "u" || process?.env?.NODE_ENV !== "development" || tf.has(e) || (tf.add(e), console.warn(`Unknown message part type: ${e}`));
}, nf = /* @__PURE__ */ new Set(), uk = (e) => {
  if (typeof process > "u" || process?.env?.NODE_ENV !== "development")
    return;
  const t = Object.keys(e).sort().join(",");
  nf.has(t) || (nf.add(t), console.warn(`Unsupported file content block shape: ${t}`));
}, ck = (e) => "file" in e ? {
  type: "file",
  filename: e.file.filename,
  data: e.file.file_data,
  mimeType: e.file.mime_type
} : "data" in e && typeof e.data == "string" ? {
  type: "file",
  filename: e.metadata?.filename ?? "file",
  data: e.data,
  mimeType: e.mime_type
} : "base64" in e && typeof e.base64 == "string" ? {
  type: "file",
  filename: e.filename ?? "file",
  data: e.base64,
  mimeType: e.mime_type
} : (uk(e), null), rf = (e, t, n) => typeof e == "string" ? [{ type: "text", text: e }] : e.map((r) => {
  const s = r.type;
  switch (s) {
    case "text":
      return { type: "text", text: r.text };
    case "text_delta":
      return { type: "text", text: r.text };
    case "image_url":
      return typeof r.image_url == "string" ? { type: "image", image: r.image_url } : {
        type: "image",
        image: r.image_url.url
      };
    case "file":
      return ck(r);
    case "thinking":
      return { type: "reasoning", text: r.thinking };
    case "reasoning":
      return {
        type: "reasoning",
        text: r.summary.map((o) => o.text).join(`


`)
      };
    case "tool_use":
      return null;
    case "input_json_delta":
      return null;
    case "computer_call":
      const i = r.action;
      return {
        type: "tool-call",
        toolCallId: r.call_id,
        toolName: "computer_call",
        args: i,
        argsText: qE(t.toolArgsKeyOrderCache, KE(n, "computer", r.call_id), i)
      };
    default:
      return ok(s), null;
  }
}).filter((r) => r !== null), lk = (e, t = {}) => {
  switch (e.type) {
    case "system":
      return {
        role: "system",
        id: e.id,
        content: [{ type: "text", text: e.content }],
        metadata: { custom: wu(e.additional_kwargs) }
      };
    case "human":
      return {
        role: "user",
        id: e.id,
        content: rf(e.content, t, e.id),
        metadata: { custom: wu(e.additional_kwargs) }
      };
    case "ai":
      const n = e.tool_calls?.map((i) => {
        const a = e.tool_call_chunks?.find((c) => c.id === i.id), { args: o, argsText: u } = ak({
          chunk: i,
          matchingToolCallChunk: a,
          messageId: e.id,
          toolArgsKeyOrderCache: t.toolArgsKeyOrderCache
        });
        return {
          type: "tool-call",
          toolCallId: i.id,
          toolName: i.name,
          args: o,
          argsText: u
        };
      }) ?? [], r = typeof e.content == "string" ? [{ type: "text", text: e.content }] : e.content, s = [
        e.additional_kwargs?.reasoning,
        ...r,
        ...e.additional_kwargs?.tool_outputs ?? []
      ].filter((i) => i !== void 0);
      return {
        role: "assistant",
        id: e.id,
        content: [
          ...rf(s, t, e.id),
          ...n
        ],
        metadata: { custom: wu(e.additional_kwargs) },
        ...e.status && { status: e.status }
      };
    case "tool":
      return {
        role: "tool",
        toolName: e.name,
        toolCallId: e.tool_call_id,
        result: e.content,
        artifact: e.artifact,
        isError: e.status === "error"
      };
  }
}, ht = [];
for (let e = 0; e < 256; ++e)
  ht.push((e + 256).toString(16).slice(1));
function dk(e, t = 0) {
  return (ht[e[t + 0]] + ht[e[t + 1]] + ht[e[t + 2]] + ht[e[t + 3]] + "-" + ht[e[t + 4]] + ht[e[t + 5]] + "-" + ht[e[t + 6]] + ht[e[t + 7]] + "-" + ht[e[t + 8]] + ht[e[t + 9]] + "-" + ht[e[t + 10]] + ht[e[t + 11]] + ht[e[t + 12]] + ht[e[t + 13]] + ht[e[t + 14]] + ht[e[t + 15]]).toLowerCase();
}
let Iu;
const hk = new Uint8Array(16);
function fk() {
  if (!Iu) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Iu = crypto.getRandomValues.bind(crypto);
  }
  return Iu(hk);
}
const pk = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), sf = { randomUUID: pk };
function mk(e, t, n) {
  e = e || {};
  const r = e.random ?? e.rng?.() ?? fk();
  if (r.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, dk(r);
}
function gk(e, t, n) {
  return sf.randomUUID && !e ? sf.randomUUID() : mk(e);
}
class Ek {
  constructor({ initialMessages: t = [], appendMessage: n = ((r, s) => s) } = {}) {
    k(this, "messagesMap", /* @__PURE__ */ new Map());
    k(this, "metadataMap", /* @__PURE__ */ new Map());
    k(this, "appendMessage");
    this.appendMessage = n, this.addMessages(t);
  }
  ensureMessageId(t) {
    return t.id ? t : { ...t, id: gk() };
  }
  addMessages(t) {
    if (t.length === 0)
      return this.getMessages();
    for (const n of t.map(this.ensureMessageId)) {
      const r = n.id, s = this.messagesMap.get(r);
      this.messagesMap.set(r, this.appendMessage(s, n));
    }
    return this.getMessages();
  }
  addMessageWithMetadata(t, n) {
    const r = this.ensureMessageId(t), s = r.id, i = this.messagesMap.get(s);
    this.messagesMap.set(s, this.appendMessage(i, r));
    const a = this.metadataMap.get(s);
    return this.metadataMap.set(s, { ...a, ...n }), this.getMessages();
  }
  getMessages() {
    return [...this.messagesMap.values()];
  }
  getMetadataMap() {
    return this.metadataMap;
  }
  replaceMessages(t) {
    this.messagesMap.clear(), this.metadataMap.clear();
    for (const n of t.map(this.ensureMessageId))
      this.messagesMap.set(n.id, n);
    return this.getMessages();
  }
  clear() {
    this.messagesMap.clear(), this.metadataMap.clear();
  }
}
const bk = (e, t) => {
  if (t.type !== "AIMessageChunk")
    return t;
  if (e?.type !== "ai")
    return {
      ...t,
      type: t.type.replace("MessageChunk", "").toLowerCase()
    };
  const n = typeof e.content == "string" ? [{ type: "text", text: e.content }] : [...e.content];
  if (typeof t?.content == "string") {
    const s = n.length - 1;
    n[s]?.type === "text" ? n[s].text = n[s].text + t.content : n.push({ type: "text", text: t.content });
  } else if (Array.isArray(t.content)) {
    const s = n.length - 1;
    for (const i of t.content)
      "type" in i && (i.type === "text" ? n[s]?.type === "text" ? n[s].text = n[s].text + i.text : n.push({ type: "text", text: i.text }) : i.type === "image_url" && n.push(i));
  }
  const r = [...e.tool_calls ?? []];
  for (const s of t.tool_call_chunks ?? []) {
    const i = r[s.index] ?? { argsText: "" }, a = (i.argsText || "") + s.args;
    r[s.index] = {
      ...s,
      ...i,
      argsText: a,
      args: co(a) ?? ("args" in i ? i.args : {})
    };
  }
  return {
    ...e,
    content: n,
    tool_calls: r
  };
}, _k = /* @__PURE__ */ new Set([
  "analyze",
  "plan",
  "execute_step",
  "validate_step",
  "synthesize",
  "clarify"
]), Tk = /* @__PURE__ */ new Set(["execute_step", "validate_step"]);
class Ak {
  constructor() {
    this.accumulator = new Ek({
      initialMessages: [],
      appendMessage: bk
    });
  }
  addChunk(t) {
    this.accumulator.addMessages([t]);
  }
  addProgress(t) {
    if (!_k.has(t.node) || t.node === "clarify")
      return;
    const n = this.progress?.entries ?? [], r = this.getEntryKey(t, n), s = t.message ?? t.step_description ?? "", a = n.some((o) => o.key === r) ? n.map((o) => o.key === r ? { ...o, node: t.node, text: s } : o) : [...n, { key: r, node: t.node, text: s }];
    this.progress = { entries: a, activeKey: r, activeNode: t.node };
  }
  getEntryKey(t, n) {
    if (!Tk.has(t.node))
      return t.node;
    if (t.step_id) return `${t.node}#id:${t.step_id}`;
    if (typeof t.current_step == "number") return `${t.node}#step:${t.current_step}`;
    const r = n.filter((s) => s.node === t.node).length;
    return `${t.node}#idx:${r}`;
  }
  getCompletedResponse(t) {
    const n = this.accumulator.getMessages().flatMap((i) => lk(i, {})), r = n.filter((i) => i?.role === "tool").reduce((i, a) => (i[a.toolCallId] = {
      result: a.result,
      toolName: a.toolName,
      isError: a.isError
    }, i), {});
    return {
      content: n.filter((i) => i && i.role === "assistant").map((i) => i.content.map((a) => {
        if (a.toolCallId) {
          const o = a.args?.resource_uri;
          let u = LE[a.toolName];
          u && (u = Kt(u, a.args));
          const c = r[a.toolCallId];
          if (a.argsText = o || u, c)
            return {
              ...a,
              type: "tool-call",
              toolName: c.toolName,
              result: $E(c.result),
              isError: c.isError
            };
        } else if (a.type === "text")
          return {
            type: "text",
            text: new Dl(t, a.text).replaceTerritoryIds().replacePostIds().replaceCreatorIds().replaceWidgets().replaceArtifactLinks().cleanUnusedURIs().build()
          };
        return a;
      })).flat(),
      ...this.progress ? { metadata: { custom: { zaiProgress: this.progress } } } : {}
    };
  }
}
const yk = {
  "pt-BR": "por",
  en: "eng",
  es: "spa"
}, xk = (e) => yk[e], Ck = (e) => {
  const t = new TextEncoder().encode(e);
  let n = "";
  for (const r of t)
    n += String.fromCharCode(r);
  return btoa(n);
}, Sk = ({ token: e, endpoint: t, eventName: n, properties: r }) => {
  const s = Ck(JSON.stringify({ event: n, properties: { ...r, token: e } }));
  return `<img src="${`${t.replace(/\/+$/, "")}/track?data=${encodeURIComponent(s)}&img=1&ip=0`}" width="1" height="1" alt="" style="display:none" />`;
}, wk = (e, t) => t ? e + Sk(t) : e, Ik = (e) => e.match(/```html\b/gi)?.length ?? 0, vk = 255, QE = (e) => {
  const t = new DOMParser().parseFromString(e, "text/html");
  return [t.title, t.querySelector("h1")?.textContent ?? ""].map((r) => r.replace(/\s+/g, " ").trim()).find(Boolean)?.slice(0, vk);
}, Nk = (e) => [...e.matchAll(/```html\b([\s\S]*?)(?:```|$)/gi)].map(([, t]) => QE(t)).filter((t) => !!t);
function kk(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), n;
}
const Rk = (e) => (e.content ?? []).map((t) => t.type === "text" ? t.text : "").join(`
`), Pk = ({
  workspaceId: e,
  thread: t,
  langRef: n,
  getOrigin: r,
  getPromptPage: s,
  checkIsPrePrompt: i,
  resetIsPrePrompt: a,
  checkIsProactiveMessage: o,
  getQuickPromptId: u,
  service: c
}) => ({
  async *run({ messages: h, abortSignal: m, context: p, runConfig: E }) {
    const g = h?.length ? h[h.length - 1]?.content[0]?.text : null, _ = i(), b = o(), T = r(), C = s(), R = _ ? u() : null, D = _ || !!E?.custom?.skipResponseInteraction, w = {
      workspaceId: e,
      thread: t.current
    };
    if (g && (w.message = g), T && (w.origin = T), _ && C && (w.page = C), b)
      Wt.track(rn.startProactiveMessage, w);
    else {
      const P = rn[_ ? "prePrompts" : "sendMessage"];
      Wt.track(P, w), !_ && T === "Demand Intelligence" && w.message && Wt.track(rn.demandIntelligenceSendMessage, { "Message Text": w.message });
    }
    a();
    const O = await c.postMessageToThread(
      t.current || "",
      {
        messages: h,
        context: p,
        language: xk(n.current || "en"),
        ...R ? { quick_prompt_id: R } : {},
        skip_response_interaction: D
      },
      {
        abortSignal: m
      }
    );
    if (!O)
      return;
    const U = new Ak();
    let q = new Uint8Array(0);
    for (; ; ) {
      const { done: P, value: z } = await O.read();
      if (P) {
        const G = Rk(U.getCompletedResponse(e)), F = Ik(G);
        F > 0 && Wt.track(rn.htmlGenerated, {
          ...w,
          "HTML Count": F,
          "HTML Titles": Nk(G)
        });
        break;
      }
      for (q = kk(q, z); !(q.length < 4); ) {
        const F = new DataView(q.buffer, q.byteOffset, 4).getUint32(0, !1);
        if (q.length < 4 + F) break;
        const M = q.subarray(4, 4 + F);
        q = q.subarray(4 + F);
        try {
          const H = nk(M);
          if (H.type === "ping")
            continue;
          if (H.type === "progress") {
            U.addProgress(H), yield U.getCompletedResponse(e);
            continue;
          }
          U.addChunk(H), yield U.getCompletedResponse(e);
        } catch (H) {
          Wt.track(rn.sendMessageError, w), console.error("Failed to decode msgpack chunk:", H);
        }
      }
    }
  }
});
function af(e) {
  return lN.includes(e);
}
const Ok = (e) => () => {
  const t = Pk(e), n = gC(t, {}), r = J((l) => l?.threadListItem?.remoteId), s = J((l) => l?.threadListItem?.id), i = J((l) => l?.threads?.mainThreadId), a = J((l) => l?.threadListItem?.title), { setThreadRunning: o, notifyIfBackground: u } = im(), c = Ke({
    remoteId: r,
    threadListItemId: s,
    mainThreadId: i,
    title: a,
    setThreadRunning: o,
    notifyIfBackground: u
  });
  return c.current = { remoteId: r, threadListItemId: s, mainThreadId: i, title: a, setThreadRunning: o, notifyIfBackground: u }, _e(() => {
    const l = n.thread.unstable_on("runStart", () => {
      const { threadListItemId: m, setThreadRunning: p } = c.current;
      m && p({ threadId: m, isRunning: !0 });
    }), h = n.thread.unstable_on("runEnd", () => {
      const { threadListItemId: m, setThreadRunning: p } = c.current;
      m && p({ threadId: m, isRunning: !1 }), setTimeout(() => {
        const { remoteId: E, threadListItemId: g, mainThreadId: _, title: b, notifyIfBackground: T } = c.current;
        !E || !b || T({ threadId: E, isActiveThread: g === _, title: b });
      }, 100);
    });
    return () => {
      l(), h();
    };
  }, [n]), n;
}, Dk = ({ workspaceId: e }) => {
  const t = Ll(), { getOrigin: n, getPage: r, checkIsPrePrompt: s, resetIsPrePrompt: i, checkIsProactiveMessage: a } = Es(), { getQuickPromptId: o, resetPrePromptParams: u } = Vc(), c = ne(() => {
    i(), u();
  }, [i, u]), { language: l } = Oi(), h = af(l) ? l : "pt-BR", m = Ke(h), p = Ke(null), E = se(
    () => Ok({
      workspaceId: e,
      thread: p,
      langRef: m,
      getOrigin: n,
      getPromptPage: r,
      checkIsPrePrompt: s,
      resetIsPrePrompt: c,
      checkIsProactiveMessage: a,
      getQuickPromptId: o,
      service: t
    }),
    [
      e,
      n,
      r,
      s,
      c,
      a,
      o,
      t
    ]
  ), g = se(() => RN({ currentThread: p }), []), _ = tg({
    runtimeHook: E,
    adapter: {
      unstable_Provider: g,
      async list() {
        return {
          threads: await t.getThreads()
        };
      },
      async fetch(b) {
        return (await t.getThreads()).find((C) => C.remoteId === b) ?? { status: "regular", remoteId: b };
      },
      async initialize() {
        const b = aN();
        return p.current = b, { remoteId: b, externalId: b };
      },
      async rename() {
      },
      async delete(b) {
        await t.deleteThread(b);
      },
      async archive() {
      },
      async generateTitle(b, T) {
        let C = "New Thread";
        return T?.[0]?.content[0]?.type === "text" && (C = T[0].content[0]?.text), new ReadableStream({
          start(D) {
            D.enqueue({
              type: "part-start",
              part: { type: "text" },
              path: [0]
            }), D.enqueue({
              type: "text-delta",
              textDelta: C,
              path: [0]
            }), D.enqueue({
              type: "part-finish",
              path: [0]
            }), D.close();
          }
        });
      },
      async unarchive() {
      }
    }
  });
  return _e(() => {
    af(l) && (m.current = l);
  }, [l]), {
    threadRuntime: _
  };
}, Lk = ({
  children: e,
  workspaceId: t,
  setAssistantUiIsReady: n,
  setAssistantUiControl: r
}) => {
  const { threadRuntime: s } = Dk({ workspaceId: t });
  return _e(() => n(!!s), [n, s]), _e(() => {
    s && r?.((i) => s.threads.switchToThread(i));
  }, [s, r]), /* @__PURE__ */ d.jsx(xC, { runtime: s, children: e });
}, Mk = de(Lk), q9 = ({
  workspaceId: e,
  userId: t,
  userEmail: n,
  getValidToken: r,
  children: s,
  onBackgroundThreadComplete: i,
  setAssistantUiControl: a,
  isChatVisible: o,
  isConnectionsEnabled: u
}) => {
  const [c, l] = ce(!1);
  return /* @__PURE__ */ d.jsx(
    tm.Provider,
    {
      value: { workspaceId: e, userId: t, userEmail: n, getValidToken: r, assistantUiIsReady: c, isConnectionsEnabled: u },
      children: /* @__PURE__ */ d.jsx(_1, { children: /* @__PURE__ */ d.jsx(T1, { children: /* @__PURE__ */ d.jsx(A1, { children: e ? /* @__PURE__ */ d.jsx(
        y1,
        {
          onBackgroundThreadComplete: i,
          isChatVisible: o,
          children: /* @__PURE__ */ d.jsx(
            Mk,
            {
              workspaceId: e,
              setAssistantUiIsReady: l,
              setAssistantUiControl: a,
              children: s
            }
          )
        }
      ) : s }) }) })
    }
  );
};
class Hk {
  constructor(t) {
    this.workspaceId = t.workspaceId, this.getValidToken = t.getValidToken, this.baseUrl = Ya[HE()] || Ya.development;
  }
  /**
   * The BFF origin the OAuth popup's callback page posts from — the caller checks event.origin
   * against this before trusting a postMessage from the popup.
   */
  get callbackOrigin() {
    return new URL(this.baseUrl).origin;
  }
  url(t) {
    return `${this.baseUrl}/api/workspace/${this.workspaceId}/mcp/${t}`;
  }
  async headers() {
    return { "Content-Type": "application/json", Authorization: `Bearer ${await this.getValidToken()}` };
  }
  async getConnections() {
    const t = await fetch(this.url("connections"), { headers: await this.headers() });
    if (!t.ok) throw new Error(`mcp/connections: ${t.status}`);
    return (await t.json()).connections ?? [];
  }
  /**
   * For a no-auth server returns `{ connected: true }`; for an OAuth server returns
   * `{ oauth_required: true, authorize_url }` — the caller opens authorize_url in a popup.
   */
  async connect(t) {
    const n = await fetch(this.url("connect"), {
      method: "POST",
      headers: await this.headers(),
      body: JSON.stringify({ server: t })
    });
    if (!n.ok) throw new Error(`mcp/connect: ${n.status}`);
    return n.json();
  }
  async disconnect(t) {
    const n = await fetch(this.url("disconnect"), {
      method: "POST",
      headers: await this.headers(),
      body: JSON.stringify({ server: t })
    });
    if (!n.ok) throw new Error(`mcp/disconnect: ${n.status}`);
  }
  /**
   * ScaleKit (b2b) completion — the popup hands back an auth_request_id that db_api verifies
   * against the authenticated caller (workspace membership gated server-side).
   */
  async oauthVerify(t) {
    const n = await fetch(this.url("oauth/verify"), {
      method: "POST",
      headers: await this.headers(),
      body: JSON.stringify({ auth_request_id: t })
    });
    if (!n.ok) throw new Error(`mcp/oauth/verify: ${n.status}`);
  }
}
function Bk() {
  const { workspaceId: e, getValidToken: t } = at();
  return se(
    () => new Hk({ workspaceId: e, getValidToken: t }),
    [e, t]
  );
}
function Uk(e, t, n, r) {
  return new Promise((s, i) => {
    let a = !1, o;
    const u = () => {
      a = !0, window.removeEventListener("message", c), o !== void 0 && window.clearInterval(o);
    }, c = async (l) => {
      if (l.origin !== n || l.source !== e) return;
      const h = l.data;
      if (h?.type === "zai-mcp-oauth") {
        u();
        try {
          h.auth_request_id ? (await r(h.auth_request_id), s()) : i(new Error(h.error || "oauth_failed"));
        } catch (m) {
          i(m);
        }
      }
    };
    window.addEventListener("message", c), e.location.href = t, o = window.setInterval(() => {
      e.closed && !a && (u(), i(new Error("cancelled")));
    }, 500);
  });
}
function Fk() {
  const e = Bk(), [t, n] = ce([]), [r, s] = ce(!0), [i, a] = ce(null), [o, u] = ce(!1), c = ne(async () => {
    try {
      n(await e.getConnections()), u(!1);
    } catch {
      u(!0);
    }
  }, [e]);
  _e(() => {
    let m = !0;
    return (async () => {
      s(!0);
      try {
        const p = await e.getConnections();
        m && (n(p), u(!1));
      } catch {
        m && u(!0);
      } finally {
        m && s(!1);
      }
    })(), () => {
      m = !1;
    };
  }, [e]);
  const l = ne(
    async (m) => {
      const p = window.open("", "zai-mcp-oauth", "width=520,height=680");
      a(m);
      try {
        const E = await e.connect(m);
        if (E.oauth_required) {
          if (!p || !E.authorize_url) throw new Error("oauth_unavailable");
          await Uk(
            p,
            E.authorize_url,
            e.callbackOrigin,
            (g) => e.oauthVerify(g)
          );
        } else
          p?.close();
        await c();
      } catch {
        p?.close(), u(!0);
      } finally {
        a(null);
      }
    },
    [e, c]
  ), h = ne(
    async (m) => {
      a(m);
      try {
        await e.disconnect(m), await c();
      } catch {
        u(!0);
      } finally {
        a(null);
      }
    },
    [e, c]
  );
  return { connections: t, loading: r, busyId: i, error: o, onConnect: l, onDisconnect: h, onRetry: c };
}
function XE(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (n = XE(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function JE() {
  for (var e, t, n = 0, r = "", s = arguments.length; n < s; n++) (e = arguments[n]) && (t = XE(e)) && (r && (r += " "), r += t);
  return r;
}
const of = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, uf = JE, jk = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return uf(e, n?.class, n?.className);
  const { variants: s, defaultVariants: i } = t, a = Object.keys(s).map((c) => {
    const l = n?.[c], h = i?.[c];
    if (l === null) return null;
    const m = of(l) || of(h);
    return s[c][m];
  }), o = n && Object.entries(n).reduce((c, l) => {
    let [h, m] = l;
    return m === void 0 || (c[h] = m), c;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, l) => {
    let { class: h, className: m, ...p } = l;
    return Object.entries(p).every((E) => {
      let [g, _] = E;
      return Array.isArray(_) ? _.includes({
        ...i,
        ...o
      }[g]) : {
        ...i,
        ...o
      }[g] === _;
    }) ? [
      ...c,
      h,
      m
    ] : c;
  }, []);
  return uf(e, a, u, n?.class, n?.className);
}, $k = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, zk = (e, t) => ({
  classGroupId: e,
  validator: t
}), ZE = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), Wa = "-", cf = [], Vk = "arbitrary..", Yk = (e) => {
  const t = Wk(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return Gk(a);
      const o = a.split(Wa), u = o[0] === "" && o.length > 1 ? 1 : 0;
      return eb(o, u, t);
    },
    getConflictingClassGroupIds: (a, o) => {
      if (o) {
        const u = r[a], c = n[a];
        return u ? c ? $k(c, u) : u : c || cf;
      }
      return n[a] || cf;
    }
  };
}, eb = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const s = e[t], i = n.nextPart.get(s);
  if (i) {
    const c = eb(e, t + 1, i);
    if (c) return c;
  }
  const a = n.validators;
  if (a === null)
    return;
  const o = t === 0 ? e.join(Wa) : e.slice(t).join(Wa), u = a.length;
  for (let c = 0; c < u; c++) {
    const l = a[c];
    if (l.validator(o))
      return l.classGroupId;
  }
}, Gk = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? Vk + r : void 0;
})(), Wk = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return qk(n, t);
}, qk = (e, t) => {
  const n = ZE();
  for (const r in e) {
    const s = e[r];
    Bl(s, n, r, t);
  }
  return n;
}, Bl = (e, t, n, r) => {
  const s = e.length;
  for (let i = 0; i < s; i++) {
    const a = e[i];
    Kk(a, t, n, r);
  }
}, Kk = (e, t, n, r) => {
  if (typeof e == "string") {
    Qk(e, t, n);
    return;
  }
  if (typeof e == "function") {
    Xk(e, t, n, r);
    return;
  }
  Jk(e, t, n, r);
}, Qk = (e, t, n) => {
  const r = e === "" ? t : tb(t, e);
  r.classGroupId = n;
}, Xk = (e, t, n, r) => {
  if (Zk(e)) {
    Bl(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(zk(n, e));
}, Jk = (e, t, n, r) => {
  const s = Object.entries(e), i = s.length;
  for (let a = 0; a < i; a++) {
    const [o, u] = s[a];
    Bl(u, tb(t, o), n, r);
  }
}, tb = (e, t) => {
  let n = e;
  const r = t.split(Wa), s = r.length;
  for (let i = 0; i < s; i++) {
    const a = r[i];
    let o = n.nextPart.get(a);
    o || (o = ZE(), n.nextPart.set(a, o)), n = o;
  }
  return n;
}, Zk = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, eR = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const s = (i, a) => {
    n[i] = a, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(i) {
      let a = n[i];
      if (a !== void 0)
        return a;
      if ((a = r[i]) !== void 0)
        return s(i, a), a;
    },
    set(i, a) {
      i in n ? n[i] = a : s(i, a);
    }
  };
}, wc = "!", lf = ":", tR = [], df = (e, t, n, r, s) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: s
}), nR = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (s) => {
    const i = [];
    let a = 0, o = 0, u = 0, c;
    const l = s.length;
    for (let g = 0; g < l; g++) {
      const _ = s[g];
      if (a === 0 && o === 0) {
        if (_ === lf) {
          i.push(s.slice(u, g)), u = g + 1;
          continue;
        }
        if (_ === "/") {
          c = g;
          continue;
        }
      }
      _ === "[" ? a++ : _ === "]" ? a-- : _ === "(" ? o++ : _ === ")" && o--;
    }
    const h = i.length === 0 ? s : s.slice(u);
    let m = h, p = !1;
    h.endsWith(wc) ? (m = h.slice(0, -1), p = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      h.startsWith(wc) && (m = h.slice(1), p = !0)
    );
    const E = c && c > u ? c - u : void 0;
    return df(i, p, m, E);
  };
  if (t) {
    const s = t + lf, i = r;
    r = (a) => a.startsWith(s) ? i(a.slice(s.length)) : df(tR, !1, a, void 0, !0);
  }
  if (n) {
    const s = r;
    r = (i) => n({
      className: i,
      parseClassName: s
    });
  }
  return r;
}, rR = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let s = [];
    for (let i = 0; i < n.length; i++) {
      const a = n[i], o = a[0] === "[", u = t.has(a);
      o || u ? (s.length > 0 && (s.sort(), r.push(...s), s = []), r.push(a)) : s.push(a);
    }
    return s.length > 0 && (s.sort(), r.push(...s)), r;
  };
}, sR = (e) => ({
  cache: eR(e.cacheSize),
  parseClassName: nR(e),
  sortModifiers: rR(e),
  ...Yk(e)
}), iR = /\s+/, aR = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: s,
    sortModifiers: i
  } = t, a = [], o = e.trim().split(iR);
  let u = "";
  for (let c = o.length - 1; c >= 0; c -= 1) {
    const l = o[c], {
      isExternal: h,
      modifiers: m,
      hasImportantModifier: p,
      baseClassName: E,
      maybePostfixModifierPosition: g
    } = n(l);
    if (h) {
      u = l + (u.length > 0 ? " " + u : u);
      continue;
    }
    let _ = !!g, b = r(_ ? E.substring(0, g) : E);
    if (!b) {
      if (!_) {
        u = l + (u.length > 0 ? " " + u : u);
        continue;
      }
      if (b = r(E), !b) {
        u = l + (u.length > 0 ? " " + u : u);
        continue;
      }
      _ = !1;
    }
    const T = m.length === 0 ? "" : m.length === 1 ? m[0] : i(m).join(":"), C = p ? T + wc : T, R = C + b;
    if (a.indexOf(R) > -1)
      continue;
    a.push(R);
    const D = s(b, _);
    for (let w = 0; w < D.length; ++w) {
      const O = D[w];
      a.push(C + O);
    }
    u = l + (u.length > 0 ? " " + u : u);
  }
  return u;
}, oR = (...e) => {
  let t = 0, n, r, s = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = nb(n)) && (s && (s += " "), s += r);
  return s;
}, nb = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = nb(e[r])) && (n && (n += " "), n += t);
  return n;
}, uR = (e, ...t) => {
  let n, r, s, i;
  const a = (u) => {
    const c = t.reduce((l, h) => h(l), e());
    return n = sR(c), r = n.cache.get, s = n.cache.set, i = o, o(u);
  }, o = (u) => {
    const c = r(u);
    if (c)
      return c;
    const l = aR(u, n);
    return s(u, l), l;
  };
  return i = a, (...u) => i(oR(...u));
}, cR = [], ot = (e) => {
  const t = (n) => n[e] || cR;
  return t.isThemeGetter = !0, t;
}, rb = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, sb = /^\((?:(\w[\w-]*):)?(.+)\)$/i, lR = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, dR = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, hR = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, fR = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, pR = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, mR = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, $n = (e) => lR.test(e), Ie = (e) => !!e && !Number.isNaN(Number(e)), zn = (e) => !!e && Number.isInteger(Number(e)), vu = (e) => e.endsWith("%") && Ie(e.slice(0, -1)), In = (e) => dR.test(e), ib = () => !0, gR = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  hR.test(e) && !fR.test(e)
), Ul = () => !1, ER = (e) => pR.test(e), bR = (e) => mR.test(e), _R = (e) => !ae(e) && !oe(e), TR = (e) => cr(e, ub, Ul), ae = (e) => rb.test(e), br = (e) => cr(e, cb, gR), hf = (e) => cr(e, vR, Ie), AR = (e) => cr(e, db, ib), yR = (e) => cr(e, lb, Ul), ff = (e) => cr(e, ab, Ul), xR = (e) => cr(e, ob, bR), ia = (e) => cr(e, hb, ER), oe = (e) => sb.test(e), Us = (e) => Hr(e, cb), CR = (e) => Hr(e, lb), pf = (e) => Hr(e, ab), SR = (e) => Hr(e, ub), wR = (e) => Hr(e, ob), aa = (e) => Hr(e, hb, !0), IR = (e) => Hr(e, db, !0), cr = (e, t, n) => {
  const r = rb.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Hr = (e, t, n = !1) => {
  const r = sb.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, ab = (e) => e === "position" || e === "percentage", ob = (e) => e === "image" || e === "url", ub = (e) => e === "length" || e === "size" || e === "bg-size", cb = (e) => e === "length", vR = (e) => e === "number", lb = (e) => e === "family-name", db = (e) => e === "number" || e === "weight", hb = (e) => e === "shadow", NR = () => {
  const e = ot("color"), t = ot("font"), n = ot("text"), r = ot("font-weight"), s = ot("tracking"), i = ot("leading"), a = ot("breakpoint"), o = ot("container"), u = ot("spacing"), c = ot("radius"), l = ot("shadow"), h = ot("inset-shadow"), m = ot("text-shadow"), p = ot("drop-shadow"), E = ot("blur"), g = ot("perspective"), _ = ot("aspect"), b = ot("ease"), T = ot("animate"), C = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], D = () => [...R(), oe, ae], w = () => ["auto", "hidden", "clip", "visible", "scroll"], O = () => ["auto", "contain", "none"], U = () => [oe, ae, u], q = () => [$n, "full", "auto", ...U()], P = () => [zn, "none", "subgrid", oe, ae], z = () => ["auto", {
    span: ["full", zn, oe, ae]
  }, zn, oe, ae], G = () => [zn, "auto", oe, ae], F = () => ["auto", "min", "max", "fr", oe, ae], M = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], H = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], B = () => ["auto", ...U()], Y = () => [$n, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...U()], $ = () => [$n, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...U()], Z = () => [$n, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...U()], y = () => [e, oe, ae], fe = () => [...R(), pf, ff, {
    position: [oe, ae]
  }], Ce = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], v = () => ["auto", "cover", "contain", SR, TR, {
    size: [oe, ae]
  }], Se = () => [vu, Us, br], Te = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    oe,
    ae
  ], pe = () => ["", Ie, Us, br], re = () => ["solid", "dashed", "dotted", "double"], Ae = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], he = () => [Ie, vu, pf, ff], le = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    E,
    oe,
    ae
  ], ye = () => ["none", Ie, oe, ae], Pe = () => ["none", Ie, oe, ae], qe = () => [Ie, oe, ae], gt = () => [$n, "full", ...U()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [In],
      breakpoint: [In],
      color: [ib],
      container: [In],
      "drop-shadow": [In],
      ease: ["in", "out", "in-out"],
      font: [_R],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [In],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [In],
      shadow: [In],
      spacing: ["px", Ie],
      text: [In],
      "text-shadow": [In],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", $n, ae, oe, _]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Ie, ae, oe, o]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": C()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": C()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: D()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: w()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": w()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": w()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: q()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": q()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": q()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": q(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: q()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": q(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: q()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": q()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": q()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: q()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: q()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: q()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: q()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [zn, "auto", oe, ae]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [$n, "full", "auto", o, ...U()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Ie, $n, "auto", "initial", "none", ae]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Ie, oe, ae]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Ie, oe, ae]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [zn, "first", "last", "none", oe, ae]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": P()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: z()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": G()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": G()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": P()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: z()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": G()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": G()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": F()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": F()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: U()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": U()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": U()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...M(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...H(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...H()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...M()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...H(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...H(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": M()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...H(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...H()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: U()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: U()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: U()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: U()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: U()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: U()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: U()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: U()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: U()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: U()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: U()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: B()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: B()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: B()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: B()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: B()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: B()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: B()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: B()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: B()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: B()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: B()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": U()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": U()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: Y()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...$()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...$()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...$()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...Z()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...Z()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...Z()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [o, "screen", ...Y()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          o,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...Y()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          o,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...Y()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...Y()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...Y()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...Y()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Us, br]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, IR, AR]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", vu, ae]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [CR, yR, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [ae]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [s, oe, ae]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Ie, "none", oe, hf]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          i,
          ...U()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", oe, ae]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", oe, ae]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: y()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: y()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...re(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Ie, "from-font", "auto", oe, br]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: y()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Ie, "auto", oe, ae]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: U()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", oe, ae]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", oe, ae]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: fe()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: Ce()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: v()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, zn, oe, ae],
          radial: ["", oe, ae],
          conic: [zn, oe, ae]
        }, wR, xR]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: y()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Se()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Se()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Se()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: y()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: y()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: y()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: Te()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": Te()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": Te()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": Te()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": Te()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": Te()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": Te()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": Te()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": Te()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": Te()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": Te()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": Te()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": Te()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": Te()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": Te()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: pe()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": pe()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": pe()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": pe()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": pe()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": pe()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": pe()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": pe()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": pe()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": pe()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": pe()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": pe()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": pe()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...re(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...re(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: y()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": y()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": y()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": y()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": y()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": y()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": y()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": y()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": y()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": y()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": y()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: y()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...re(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ie, oe, ae]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Ie, Us, br]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: y()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          l,
          aa,
          ia
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: y()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", h, aa, ia]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": y()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: pe()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: y()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Ie, br]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": y()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": pe()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": y()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, aa, ia]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": y()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Ie, oe, ae]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...Ae(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": Ae()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [Ie]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": he()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": he()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": y()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": y()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": he()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": he()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": y()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": y()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": he()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": he()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": y()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": y()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": he()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": he()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": y()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": y()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": he()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": he()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": y()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": y()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": he()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": he()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": y()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": y()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": he()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": he()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": y()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": y()
      }],
      "mask-image-radial": [{
        "mask-radial": [oe, ae]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": he()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": he()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": y()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": y()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": R()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [Ie]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": he()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": he()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": y()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": y()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: fe()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: Ce()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: v()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", oe, ae]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          ae
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: le()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Ie, oe, ae]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Ie, oe, ae]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          aa,
          ia
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": y()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Ie, oe, ae]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Ie, oe, ae]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Ie, oe, ae]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Ie, oe, ae]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Ie, oe, ae]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          oe,
          ae
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": le()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Ie, oe, ae]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Ie, oe, ae]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Ie, oe, ae]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Ie, oe, ae]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Ie, oe, ae]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Ie, oe, ae]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Ie, oe, ae]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Ie, oe, ae]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": U()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": U()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": U()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", oe, ae]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Ie, "initial", oe, ae]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", b, oe, ae]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Ie, oe, ae]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", T, oe, ae]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, oe, ae]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": D()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ye()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ye()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ye()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ye()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Pe()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Pe()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Pe()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Pe()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: qe()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": qe()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": qe()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [oe, ae, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: D()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: gt()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": gt()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": gt()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": gt()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: y()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: y()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", oe, ae]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": U()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": U()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": U()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": U()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": U()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": U()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": U()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": U()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": U()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": U()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": U()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": U()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": U()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": U()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": U()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": U()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": U()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": U()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": U()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": U()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": U()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": U()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", oe, ae]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...y()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Ie, Us, br, hf]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...y()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, kR = /* @__PURE__ */ uR(NR);
function ue(...e) {
  return kR(JE(e));
}
const RR = jk(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer",
  {
    variants: {
      variant: {
        "purple-gradient": `
          text-white
          overflow-hidden
          border
          border-white/20
          bg-gradient-to-r
          from-[rgba(98,36,198,0.8)]
          from-10.17%
          to-[rgba(66,24,133,0.8)]
          to-86.14%
          backdrop-blur-xl
          shadow-[inset_-2px_-2px_20px_0px_#f6f0ff33]
          before:content-['']
          before:absolute
          before:inset-0
          before:-z-10
          before:bg-gradient-to-r
          before:from-[#6224c6]
          before:from-10.17%
          before:to-[#421885]
          before:to-86.14%
          before:opacity-0
          before:transition-opacity
          before:duration-300
          before:ease-in-out
          disabled:bg-neutral-200
          disabled:text-neutral-500
          disabled:shadow-none
          disabled:cursor-not-allowed
          disabled:[&_svg]:fill-neutral-500
          hover:enabled:border-[#6b27d8]
          hover:enabled:shadow-[0px_2px_4px_0px_#6224c680]
          hover:enabled:before:opacity-100
        `,
        "highlight-border": `
          bg-secondary
          text-secondary-foreground
          shadow-sm
          border
          border-violet-300
          w-fit
          hover:bg-secondary/80
        `,
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        purple: `
          shadow-xs
          border
          border-[#5F3D85]
          bg-[#4A276F]
          data-[active]:bg-[#5F3D85]
          hover:bg-[#5F3D85]
        `
      },
      size: {
        default: "h-9 px-4 py-3 has-[>svg]:pl-2 has-[>svg]:pr-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), pt = A.forwardRef(
  ({
    className: e,
    variant: t,
    size: n,
    asChild: r = !1,
    ...s
  }, i) => {
    const a = r ? wC : "button";
    return /* @__PURE__ */ d.jsx(a, { "data-slot": "button", className: ue(RR({ variant: t, size: n, className: e })), ...s, ref: i });
  }
), _r = u1({
  title: { key: "zai.connections.title", defaultValue: "Conexões" },
  connect: { key: "zai.connections.connect", defaultValue: "Conectar" },
  disconnect: { key: "zai.connections.disconnect", defaultValue: "Desconectar" },
  reconnect: { key: "zai.connections.reconnect", defaultValue: "Reconectar" },
  connected: { key: "zai.connections.connected", defaultValue: "Conectado" },
  expired: { key: "zai.connections.expired", defaultValue: "Expirado" },
  error: { key: "zai.connections.error", defaultValue: "Algo deu errado nas conexões. Tente novamente." }
}), PR = de(function({
  connections: t,
  loading: n,
  busyId: r,
  error: s,
  onConnect: i,
  onDisconnect: a,
  onRetry: o
}) {
  const { t: u } = He(), [c, l] = ce(!1);
  if (n && t.length === 0 || !s && t.length === 0) return null;
  const h = t.filter((E) => E.connected && !E.expired).length, m = r !== null, p = () => {
    const E = !c;
    E && s && o(), l(E);
  };
  return /* @__PURE__ */ d.jsxs("section", { className: "mt-2 flex shrink-0 flex-col border-t border-neutral-700/50 pt-3", children: [
    /* @__PURE__ */ d.jsxs(
      "button",
      {
        type: "button",
        onClick: p,
        "aria-expanded": c,
        "data-testid": "mcp-connections-toggle",
        "data-dd-action-name": "mcp-connections-toggle",
        className: "flex items-center justify-between gap-2 rounded-lg px-2 py-1 hover:bg-neutral-700/40",
        children: [
          /* @__PURE__ */ d.jsxs("span", { className: "text-xs font-medium uppercase tracking-wide text-neutral-400", children: [
            u(_r.title),
            h > 0 && /* @__PURE__ */ d.jsxs("span", { className: "ml-1 text-emerald-400", children: [
              "(",
              h,
              ")"
            ] })
          ] }),
          /* @__PURE__ */ d.jsx(
            "svg",
            {
              viewBox: "0 0 20 20",
              fill: "currentColor",
              "aria-hidden": !0,
              className: ue("h-4 w-4 shrink-0 text-neutral-400 transition-transform", c && "rotate-180"),
              children: /* @__PURE__ */ d.jsx(
                "path",
                {
                  fillRule: "evenodd",
                  d: "M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z",
                  clipRule: "evenodd"
                }
              )
            }
          )
        ]
      }
    ),
    c && s && /* @__PURE__ */ d.jsx("p", { className: "px-2 pt-1 text-xs text-neutral-500", children: u(_r.error) }),
    /* @__PURE__ */ d.jsx("ul", { className: ue("mt-1 flex-col gap-0.5 overflow-y-auto", c ? "flex max-h-72" : "hidden"), children: t.map((E) => {
      const g = E.connected && !E.expired;
      return /* @__PURE__ */ d.jsxs(
        "li",
        {
          className: "flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 hover:bg-neutral-700/40",
          children: [
            /* @__PURE__ */ d.jsxs("div", { className: "min-w-0", children: [
              /* @__PURE__ */ d.jsx("p", { className: "truncate text-sm text-neutral-100", children: E.name }),
              E.connected && /* @__PURE__ */ d.jsx("p", { className: ue("text-xs", E.expired ? "text-amber-400" : "text-emerald-400"), children: E.expired ? u(_r.expired) : u(_r.connected) })
            ] }),
            g ? /* @__PURE__ */ d.jsx(
              pt,
              {
                variant: "outline",
                size: "sm",
                disabled: m,
                onClick: () => a(E.id),
                "data-testid": `mcp-disconnect-${E.id}`,
                "data-dd-action-name": "mcp-disconnect",
                children: u(_r.disconnect)
              }
            ) : /* @__PURE__ */ d.jsx(
              pt,
              {
                variant: "secondary",
                size: "sm",
                disabled: m,
                onClick: () => i(E.id),
                "data-testid": `mcp-connect-${E.id}`,
                "data-dd-action-name": "mcp-connect",
                children: E.expired ? u(_r.reconnect) : u(_r.connect)
              }
            )
          ]
        },
        E.id
      );
    }) })
  ] });
});
function OR() {
  const e = Fk();
  return /* @__PURE__ */ d.jsx(PR, { ...e });
}
const DR = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), LR = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), mf = (e) => {
  const t = LR(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, fb = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), MR = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
var HR = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const BR = Je(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: s = "",
    children: i,
    iconNode: a,
    ...o
  }, u) => ec(
    "svg",
    {
      ref: u,
      ...HR,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: fb("lucide", s),
      ...!i && !MR(o) && { "aria-hidden": "true" },
      ...o
    },
    [
      ...a.map(([c, l]) => ec(c, l)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
const et = (e, t) => {
  const n = Je(
    ({ className: r, ...s }, i) => ec(BR, {
      ref: i,
      iconNode: t,
      className: fb(
        `lucide-${DR(mf(e))}`,
        `lucide-${e}`,
        r
      ),
      ...s
    })
  );
  return n.displayName = mf(e), n;
};
const UR = [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
], FR = et("align-justify", UR);
const jR = [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
], pb = et("arrow-down", jR);
const $R = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Do = et("check", $R);
const zR = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], mb = et("chevron-down", zR);
const VR = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], gb = et("chevron-left", VR);
const YR = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], GR = et("chevron-right", YR);
const WR = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], qR = et("chevron-up", WR);
const KR = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], gf = et("circle-check", KR);
const QR = [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
], XR = et("code-xml", QR);
const JR = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Fl = et("copy", JR);
const ZR = [
  ["path", { d: "M12 15V3", key: "m9g1x1" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["path", { d: "m7 10 5 5 5-5", key: "brsn70" }]
], eP = et("download", ZR);
const tP = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], nP = et("ellipsis-vertical", tP);
const rP = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
], Eb = et("external-link", rP);
const sP = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], iP = et("globe", sP);
const aP = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], oP = et("link-2", aP);
const uP = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], cP = et("maximize-2", uP);
const lP = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], dP = et("plus", lP);
const hP = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], bb = et("refresh-cw", hP);
const fP = [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
], pP = et("send", fP);
const mP = [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
], gP = et("thumbs-down", mP);
const EP = [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
], bP = et("thumbs-up", EP);
const _P = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], _b = et("x", _P), TP = ({
  isOpen: e,
  isDeleting: t,
  onCancel: n,
  onConfirm: r
}) => {
  const s = ne(
    (o) => {
      o.stopPropagation(), n();
    },
    [n]
  ), i = ne(
    (o) => {
      o.stopPropagation(), r();
    },
    [r]
  ), a = ne((o) => {
    o.stopPropagation();
  }, []);
  return {
    isOpen: e,
    isDeleting: t,
    onOverlayClick: t ? void 0 : s,
    onContentClick: a,
    onCancelClick: s,
    onConfirmClick: i
  };
}, oa = {
  title: {
    key: "zai.delete-thread-modal.title",
    defaultValue: "Excluir chat"
  },
  description: {
    key: "zai.delete-thread-modal.description",
    defaultValue: "Tem certeza de que deseja excluir este chat?"
  },
  cancel: {
    key: "zai.delete-thread-modal.cancel",
    defaultValue: "Cancelar"
  },
  confirm: {
    key: "zai.delete-thread-modal.confirm",
    defaultValue: "Excluir"
  }
}, AP = ({
  isOpen: e,
  isDeleting: t,
  onOverlayClick: n,
  onContentClick: r,
  onCancelClick: s,
  onConfirmClick: i
}) => {
  const { t: a } = He();
  return /* @__PURE__ */ d.jsx("div", { onClick: r, children: /* @__PURE__ */ d.jsxs(Ds, { show: e, animate: !1, classes: ["w-[90%]!", "max-w-[500px]!"], children: [
    /* @__PURE__ */ d.jsx(Ds.Overlay, { onClick: n }),
    /* @__PURE__ */ d.jsx(Ds.Header, { children: /* @__PURE__ */ d.jsx("h2", { className: "text-2xl font-semibold text-[#2b2b2b]", children: a(oa.title) }) }),
    /* @__PURE__ */ d.jsx(Ds.Body, { classes: ["py-4"], children: /* @__PURE__ */ d.jsx("p", { className: "text-sm font-normal text-[#4c5567]", children: a(oa.description) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "h-px bg-black/10" }),
    /* @__PURE__ */ d.jsxs(Ds.Footer, { classes: ["gap-4", "pt-4"], children: [
      /* @__PURE__ */ d.jsx(
        pt,
        {
          variant: "ghost",
          onClick: s,
          disabled: t,
          className: "h-9 rounded-[4px] px-4 font-normal text-[#4c5567] hover:bg-transparent hover:text-[#4c5567] dark:hover:bg-transparent",
          children: a(oa.cancel)
        }
      ),
      /* @__PURE__ */ d.jsxs(
        pt,
        {
          variant: "default",
          onClick: i,
          disabled: t,
          className: "relative h-9 rounded-[4px] bg-[#6224c6] px-4 font-normal text-white hover:bg-[#6224c6]",
          children: [
            /* @__PURE__ */ d.jsx("span", { className: t ? "invisible" : void 0, children: a(oa.confirm) }),
            t && /* @__PURE__ */ d.jsx("span", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ d.jsx("span", { className: "size-4 animate-spin rounded-full border-2 border-white border-t-transparent" }) })
          ]
        }
      )
    ] })
  ] }) });
}, yP = de(AP), xP = (e) => {
  const t = TP(e);
  return /* @__PURE__ */ d.jsx(yP, { ...t });
}, CP = ({ onDeleteClick: e }) => {
  const [t, n] = ce(!1), r = ne((i) => {
    i.stopPropagation();
  }, []), s = ne(
    (i) => {
      i.stopPropagation(), n(!1), e();
    },
    [e]
  );
  return {
    isOpen: t,
    onOpenChange: n,
    onTriggerClick: r,
    onDeleteClick: s
  };
}, Tb = Tt({
  container: null
});
function Lo() {
  return mt(Tb).container;
}
const Xr = {
  dark: null,
  light: null
}, Nu = {
  dark: 0,
  light: 0
};
function jl({
  children: e,
  theme: t = "dark"
}) {
  const [n, r] = ce(null);
  return _e(() => {
    if (Nu[t]++, !Xr[t]) {
      const s = document.createElement("div");
      s.id = `zai-chat-portal-container-${t}`, s.className = `zai-chat-package ${t}`, s.style.cssText = "position:fixed;z-index:99999999991;", document.body.appendChild(s), Xr[t] = s;
    }
    return r(Xr[t]), () => {
      Nu[t]--, Nu[t] === 0 && Xr[t] && (document.body.removeChild(Xr[t]), Xr[t] = null);
    };
  }, [t]), /* @__PURE__ */ d.jsx(Tb.Provider, { value: { container: n }, children: e });
}
function $l({ ...e }) {
  return /* @__PURE__ */ d.jsx(n2, { "data-slot": "popover", ...e });
}
function zl({ ...e }) {
  return /* @__PURE__ */ d.jsx(r2, { "data-slot": "popover-trigger", ...e });
}
function Vl({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...r
}) {
  const s = Lo();
  return /* @__PURE__ */ d.jsx(s2, { container: s ?? void 0, children: /* @__PURE__ */ d.jsx(
    i2,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: ue(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        e
      ),
      ...r
    }
  ) });
}
const Ef = {
  delete: {
    key: "zai.thread-list-item-menu.delete",
    defaultValue: "Excluir"
  },
  actionsLabel: {
    key: "zai.thread-list-item-menu.actions-label",
    defaultValue: "Ações da conversa"
  }
}, SP = ({ isOpen: e, onOpenChange: t, onTriggerClick: n, onDeleteClick: r }) => {
  const { t: s } = He();
  return /* @__PURE__ */ d.jsxs($l, { open: e, onOpenChange: t, children: [
    /* @__PURE__ */ d.jsx(
      zl,
      {
        onClick: n,
        "aria-label": s(Ef.actionsLabel),
        className: `
          flex
          items-center
          justify-center
          size-5
          rounded-full
          bg-[#6f6f6f]
          shrink-0
          opacity-0
          group-hover:opacity-100
          focus-visible:opacity-100
          data-[state=open]:opacity-100
          outline-none
        `,
        children: /* @__PURE__ */ d.jsx(nP, { className: "size-3 text-[#f7f9fc]" })
      }
    ),
    /* @__PURE__ */ d.jsx(
      Vl,
      {
        align: "end",
        onClick: n,
        className: "w-[180px] p-0 rounded shadow-[0px_2px_10px_1px_rgba(0,0,0,0.08)] bg-white border-none",
        children: /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "button",
            onClick: r,
            className: "w-full h-9 pl-6 pr-2 py-2 rounded text-start text-sm text-[#4c5567] hover:bg-neutral-100",
            children: s(Ef.delete)
          }
        )
      }
    )
  ] });
}, wP = de(SP), IP = (e) => {
  const t = CP(e);
  return /* @__PURE__ */ d.jsx(wP, { ...t });
};
class Mo extends s1 {
  constructor() {
    super(...arguments), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t) {
    (t?.message?.includes("tapClientLookup") || t?.message?.includes("out of bounds")) && setTimeout(() => this.setState({ hasError: !1 }), 0);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
const $t = {
  loading: {
    key: "zai.loading",
    defaultValue: "Carregando..."
  },
  loadingThreads: {
    key: "zai.loading-threads",
    defaultValue: "Carregando conversas"
  },
  copy: {
    key: "zai.copy",
    defaultValue: "Copiar"
  },
  newThread: {
    key: "zai.new-thread",
    defaultValue: "Nova conversa"
  },
  scrollToBottom: {
    key: "zai.thread.scroll-to-bottom",
    defaultValue: "Role para baixo"
  },
  welcomeMessage: {
    key: "zai.thread.welcome-message",
    defaultValue: "Como posso ajudar você hoje?"
  },
  placeholder: {
    key: "zai.thread.placeholder",
    defaultValue: "Escreva sua mensagem para ZAI"
  },
  somethingWentWrong: {
    key: "zai.thread.something-went-wrong",
    defaultValue: "Parece que algo deu errado. Tente novamente."
  }
}, Ab = ({ handleItemClick: e }) => {
  const t = J((r) => r?.threads?.isLoading), { t: n } = He();
  return /* @__PURE__ */ d.jsxs(OE, { className: "flex flex-col items-stretch gap-1.5", children: [
    /* @__PURE__ */ d.jsx(vP, { handleItemClick: e }),
    t ? /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-center p-4 gap-2.5", children: [
      /* @__PURE__ */ d.jsx("span", { className: "animate-spin size-5 border-2 border-purple-300 rounded-full border-t-transparent" }),
      /* @__PURE__ */ d.jsx("p", { className: "text-white font-medium", children: n($t.loadingThreads) })
    ] }) : /* @__PURE__ */ d.jsx(NP, { handleItemClick: e })
  ] });
}, vP = ({ handleItemClick: e }) => {
  const { t } = He();
  return /* @__PURE__ */ d.jsx(PE, { asChild: !0, children: /* @__PURE__ */ d.jsxs(
    pt,
    {
      onClick: e,
      variant: "purple",
      size: "default",
      className: `
          justify-start
          rounded-lg
          h-11
        `,
      children: [
        /* @__PURE__ */ d.jsx(dP, {}),
        t($t.newThread)
      ]
    }
  ) });
}, NP = ({ handleItemClick: e }) => /* @__PURE__ */ d.jsx(Mo, { children: /* @__PURE__ */ d.jsx(
  pg,
  {
    components: { ThreadListItem: () => /* @__PURE__ */ d.jsx(kP, { handleItemClick: e }) }
  }
) }), kP = ({ handleItemClick: e }) => {
  const [t, n] = ce(!1), [r, s] = ce(!1), a = Re().threadListItem(), o = async () => {
    s(!0);
    try {
      await a.delete(), n(!1);
    } finally {
      s(!1);
    }
  };
  return /* @__PURE__ */ d.jsxs(
    DE,
    {
      onClick: e,
      className: "group data-[active]:bg-neutral-700 hover:bg-neutral-700 focus-visible:bg-neutral-700 focus-visible:ring-ring flex items-center gap-2 rounded-lg transition-all focus-visible:outline-none focus-visible:ring-2",
      children: [
        /* @__PURE__ */ d.jsx(eN, { className: "flex-grow px-3 py-2 text-start w-full min-w-0", children: /* @__PURE__ */ d.jsx(RP, {}) }),
        /* @__PURE__ */ d.jsx(IP, { onDeleteClick: () => n(!0) }),
        /* @__PURE__ */ d.jsx(
          xP,
          {
            isOpen: t,
            isDeleting: r,
            onCancel: () => n(!1),
            onConfirm: o
          }
        )
      ]
    }
  );
}, RP = () => {
  const e = J((r) => r?.threadListItem?.id), { isThreadRunning: t } = im(), { t: n } = He();
  return /* @__PURE__ */ d.jsxs("p", { className: "text-sm font-medium flex items-center gap-1.5 min-w-0", children: [
    t(e) && /* @__PURE__ */ d.jsx("span", { "data-status": "running", role: "status", "aria-label": n($t.loading), className: "aui-md shrink-0" }),
    /* @__PURE__ */ d.jsx("span", { className: "truncate", children: /* @__PURE__ */ d.jsx(mg, { fallback: "New Chat" }) })
  ] });
};
function PP({ ...e }) {
  return /* @__PURE__ */ d.jsx(bw, { "data-slot": "sheet", ...e });
}
function OP({ ...e }) {
  const t = Lo();
  return /* @__PURE__ */ d.jsx(_w, { "data-slot": "sheet-portal", container: t ?? void 0, ...e });
}
function DP({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    Tw,
    {
      "data-slot": "sheet-overlay",
      className: ue(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
        e
      ),
      ...t
    }
  );
}
function LP({
  className: e,
  children: t,
  side: n = "right",
  ...r
}) {
  return /* @__PURE__ */ d.jsxs(OP, { children: [
    /* @__PURE__ */ d.jsx(DP, {}),
    /* @__PURE__ */ d.jsxs(
      Aw,
      {
        "data-slot": "sheet-content",
        className: ue(
          "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
          n === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-0 right-0 h-full w-3/4 border-l sm:max-w-sm",
          n === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm",
          n === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-0 top-0 h-auto border-b",
          n === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-0 bottom-0 h-auto border-t",
          e
        ),
        ...r,
        children: [
          t,
          /* @__PURE__ */ d.jsxs(Cw, { className: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none", children: [
            /* @__PURE__ */ d.jsx(_b, { className: "size-4" }),
            /* @__PURE__ */ d.jsx("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function MP({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx("div", { "data-slot": "sheet-header", className: ue("flex flex-col gap-1.5 p-4", e), ...t });
}
function HP({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    yw,
    {
      "data-slot": "sheet-title",
      className: ue("text-foreground font-semibold", e),
      ...t
    }
  );
}
function BP({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    xw,
    {
      "data-slot": "sheet-description",
      className: ue("text-muted-foreground text-sm", e),
      ...t
    }
  );
}
function kt({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx("div", { "data-slot": "skeleton", className: ue("bg-accent animate-pulse rounded-md", e), ...t });
}
function yb({ delayDuration: e = 0, ...t }) {
  return /* @__PURE__ */ d.jsx(nv, { "data-slot": "tooltip-provider", delayDuration: e, ...t });
}
function UP({ ...e }) {
  return /* @__PURE__ */ d.jsx(yb, { children: /* @__PURE__ */ d.jsx(rv, { "data-slot": "tooltip", ...e }) });
}
function FP({ ...e }) {
  return /* @__PURE__ */ d.jsx(sv, { "data-slot": "tooltip-trigger", ...e });
}
function jP({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...r
}) {
  const s = Lo();
  return /* @__PURE__ */ d.jsx(iv, { container: s ?? void 0, children: /* @__PURE__ */ d.jsxs(
    av,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: ue(
        "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ d.jsx(ov, { className: "bg-primary fill-primary z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" })
      ]
    }
  ) });
}
const ku = 768;
function $P() {
  const [e, t] = A.useState(void 0);
  return A.useEffect(() => {
    const n = window.matchMedia(`(max-width: ${ku - 1}px)`), r = () => {
      t(window.innerWidth < ku);
    };
    return n.addEventListener("change", r), t(window.innerWidth < ku), () => n.removeEventListener("change", r);
  }, []), !!e;
}
const zP = "sidebar_state", VP = 3600 * 24 * 7, YP = "16rem", GP = "18rem", WP = "3rem", qP = "b", xb = A.createContext(null);
function KP() {
  const e = A.useContext(xb);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function QP({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: n,
  className: r,
  style: s,
  children: i,
  ...a
}) {
  const o = $P(), [u, c] = A.useState(!1), [l, h] = A.useState(e), m = t ?? l, p = A.useCallback(
    (b) => {
      const T = typeof b == "function" ? b(m) : b;
      n ? n(T) : h(T), document.cookie = `${zP}=${T}; path=/; max-age=${VP}`;
    },
    [n, m]
  ), E = A.useCallback(() => o ? c((b) => !b) : p((b) => !b), [o, p, c]);
  A.useEffect(() => {
    const b = (T) => {
      T.key === qP && (T.metaKey || T.ctrlKey) && (T.preventDefault(), E());
    };
    return window.addEventListener("keydown", b), () => window.removeEventListener("keydown", b);
  }, [E]);
  const g = m ? "expanded" : "collapsed", _ = A.useMemo(
    () => ({
      state: g,
      open: m,
      setOpen: p,
      isMobile: o,
      openMobile: u,
      setOpenMobile: c,
      toggleSidebar: E
    }),
    [g, m, p, o, u, c, E]
  );
  return /* @__PURE__ */ d.jsx(xb.Provider, { value: _, children: /* @__PURE__ */ d.jsx(yb, { delayDuration: 0, children: /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-wrapper",
      style: {
        "--sidebar-width": YP,
        "--sidebar-width-icon": WP,
        ...s
      },
      className: ue("group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full", r),
      ...a,
      children: i
    }
  ) }) });
}
function XP({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: n = "offcanvas",
  className: r,
  children: s,
  ...i
}) {
  const { isMobile: a, state: o, openMobile: u, setOpenMobile: c } = KP();
  return n === "none" ? /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar",
      className: ue("bg-sidebar text-sidebar-foreground flex h-full w-(--sidebar-width) flex-col", r),
      ...i,
      children: s
    }
  ) : a ? /* @__PURE__ */ d.jsx(PP, { open: u, onOpenChange: c, ...i, children: /* @__PURE__ */ d.jsxs(
    LP,
    {
      "data-sidebar": "sidebar",
      "data-slot": "sidebar",
      "data-mobile": "true",
      className: "bg-sidebar text-sidebar-foreground w-(--sidebar-width) p-0 [&>button]:hidden",
      style: {
        "--sidebar-width": GP
      },
      side: e,
      children: [
        /* @__PURE__ */ d.jsxs(MP, { className: "sr-only", children: [
          /* @__PURE__ */ d.jsx(HP, { children: "Sidebar" }),
          /* @__PURE__ */ d.jsx(BP, { children: "Displays the mobile sidebar." })
        ] }),
        /* @__PURE__ */ d.jsx("div", { className: "flex h-full w-full flex-col", children: s })
      ]
    }
  ) }) : /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: "group peer text-sidebar-foreground hidden md:block",
      "data-state": o,
      "data-collapsible": o === "collapsed" ? n : "",
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ d.jsx(
          "div",
          {
            "data-slot": "sidebar-gap",
            className: ue(
              "relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              t === "floating" || t === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
            )
          }
        ),
        /* @__PURE__ */ d.jsx(
          "div",
          {
            "data-slot": "sidebar-container",
            className: ue(
              "fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              r
            ),
            ...i,
            children: /* @__PURE__ */ d.jsx(
              "div",
              {
                "data-sidebar": "sidebar",
                "data-slot": "sidebar-inner",
                className: "bg-sidebar group-data-[variant=floating]:border-sidebar-border flex h-full w-full flex-col group-data-[variant=floating]:rounded-xl group-data-[variant=floating]:border group-data-[variant=floating]:shadow-sm",
                children: s
              }
            )
          }
        )
      ]
    }
  );
}
function JP({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: ue(
        "bg-background relative flex w-full flex-1 flex-col",
        "md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2",
        e
      ),
      ...t
    }
  );
}
function ZP({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: ue("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function e3({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: ue(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    }
  );
}
function t3({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: ue("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    }
  );
}
function n3({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: ue("flex w-full min-w-0 flex-col gap-1", e),
      ...t
    }
  );
}
function r3({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: ue("group/menu-item relative", e),
      ...t
    }
  );
}
const s3 = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M7.433.91a3.25 3.25 0 0 1 3.317 3.257v10.834a4.086 4.086 0 0 1-4.348 4.07 4.084 4.084 0 0 1-3.817-4.113A4.08 4.08 0 0 1 .93 12.01 4.08 4.08 0 0 1 1.998 8.9a4.08 4.08 0 0 1 1.189-4.511 4.1 4.1 0 0 1 1.093-.665A3.25 3.25 0 0 1 7.432.91m.03 1.5a1.75 1.75 0 0 0-1.711 1.827.75.75 0 0 1-.563.76A2.586 2.586 0 0 0 3.25 7.604c.016.391.12.775.307 1.12a.75.75 0 0 1-.188.937 2.585 2.585 0 0 0 .36 4.255.75.75 0 0 1 .374.75 2.59 2.59 0 0 0 1.385 2.63A2.583 2.583 0 0 0 9.25 15V4.164A1.75 1.75 0 0 0 7.464 2.41",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M12.567.91a3.25 3.25 0 0 1 3.152 2.814 4.085 4.085 0 0 1 2.528 3.941 4.1 4.1 0 0 1-.246 1.234 4.082 4.082 0 0 1-.586 6.06 4.08 4.08 0 0 1-.929 2.633 4.085 4.085 0 0 1-7.236-2.59V4.166A3.25 3.25 0 0 1 12.567.91m-.03 1.5a1.75 1.75 0 0 0-1.787 1.754V15a2.585 2.585 0 0 0 2.751 2.575 2.583 2.583 0 0 0 2.395-2.909.75.75 0 0 1 .374-.749 2.583 2.583 0 0 0 .36-4.255.75.75 0 0 1-.188-.937 2.59 2.59 0 0 0-.6-3.193 2.6 2.6 0 0 0-1.032-.534.75.75 0 0 1-.562-.76 1.75 1.75 0 0 0-1.712-1.828",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M10 6.75a.75.75 0 0 1 .749.709 3 3 0 0 0 2 2.667.75.75 0 0 1-.498 1.415 4.5 4.5 0 0 1-2.106-1.545q-.076-.103-.145-.209-.07.106-.145.21A4.5 4.5 0 0 1 7.75 11.54a.75.75 0 0 1-.498-1.415 3 3 0 0 0 2-2.667l.022-.145A.75.75 0 0 1 10 6.75m5.03-3.228a.75.75 0 0 1 .718.78 3.25 3.25 0 0 1-.433 1.49.75.75 0 1 1-1.299-.75c.141-.245.221-.52.233-.802a.75.75 0 0 1 .78-.718m-10.057 0a.75.75 0 0 1 .78.719c.011.282.091.557.232.801a.75.75 0 0 1-1.3.75 3.25 3.25 0 0 1-.43-1.49.75.75 0 0 1 .718-.78M2.98 8.021a.833.833 0 1 1 .81 1.458q-.195.107-.366.248A.834.834 0 0 1 2.37 8.434q.286-.233.61-.413m12.907.325a.833.833 0 0 1 1.132-.325q.324.18.61.413a.834.834 0 0 1-1.053 1.293 2.5 2.5 0 0 0-.365-.248.833.833 0 0 1-.324-1.133M2.708 14.202a.75.75 0 0 1 1.021-.285c.388.218.825.333 1.27.333A.75.75 0 0 1 5 15.75a4.1 4.1 0 0 1-2.007-.527.75.75 0 0 1-.285-1.021m13.562-.285a.75.75 0 0 1 .738 1.306A4.1 4.1 0 0 1 15 15.75a.75.75 0 0 1 0-1.5 2.6 2.6 0 0 0 1.27-.333",
      fill: "currentColor"
    }
  )
] }), i3 = ({ index: e, ...t }) => /* @__PURE__ */ d.jsxs("svg", { width: "192", height: "192", viewBox: "0 0 192 192", className: "w-48 h-48", ...t, children: [
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: `donut-clip-${e}`, children: /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M 96 96 m -96 0 a 96 96 0 1 0 192 0 a 96 96 0 1 0 -192 0 Z M 96 96 m -72 0 a 72 72 0 0 1 144 0 a 72 72 0 0 1 -144 0 Z",
      fillRule: "evenodd"
    }
  ) }) }),
  /* @__PURE__ */ d.jsx(
    "rect",
    {
      width: "192",
      height: "192",
      fill: "rgb(75, 85, 99)",
      clipPath: `url(#donut-clip-${e})`,
      className: "animate-pulse"
    }
  )
] }), a3 = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#a)", fill: "currentColor", children: [
    /* @__PURE__ */ d.jsx("path", { d: "M10.637 2.387a.888.888 0 0 0-1.774 0v.141A2.1 2.1 0 0 1 7.637 4.43a1 1 0 0 1-.238.069 2.1 2.1 0 0 1-2.182-.472l-.056-.055a.89.89 0 0 0-1.254 0 .886.886 0 0 0 0 1.255l.055.055a2.1 2.1 0 0 1 .436 2.272 2.1 2.1 0 0 1-1.92 1.375h-.091a.888.888 0 0 0 0 1.773h.141a2.1 2.1 0 0 1 1.918 1.265 2.1 2.1 0 0 1-.419 2.316l-.055.056a.89.89 0 0 0 0 1.254.886.886 0 0 0 1.255 0l.055-.055a2.1 2.1 0 0 1 2.272-.437l.045.017h-.001a2.1 2.1 0 0 1 1.33 1.905v.09a.887.887 0 0 0 1.774 0v-.141a2.1 2.1 0 0 1 1.265-1.92 2.1 2.1 0 0 1 2.316.42l.056.056.064.059a.89.89 0 0 0 1.383-.347.89.89 0 0 0-.192-.967l-.056-.055a2.1 2.1 0 0 1-.42-2.317 2.1 2.1 0 0 1 1.92-1.264h.075a.887.887 0 0 0 0-1.774h-.141a2.1 2.1 0 0 1-1.902-1.226 1 1 0 0 1-.07-.238 2.1 2.1 0 0 1 .473-2.182l.055-.056.059-.064a.89.89 0 0 0-.059-1.19.886.886 0 0 0-1.255 0l-.055.055a2.1 2.1 0 0 1-2.317.42V4.38a2.1 2.1 0 0 1-1.264-1.918zm1.5.07.006.087a.6.6 0 0 0 .28.422l.077.04.008.003a.6.6 0 0 0 .66-.12l.044-.043a2.388 2.388 0 0 1 3.377 3.376l-.044.044-.058.068a.6.6 0 0 0-.067.58q.03.076.049.163a.6.6 0 0 0 .508.286h.136a2.387 2.387 0 0 1 0 4.774h-.07l-.087.006a.6.6 0 0 0-.462.357l-.003.008a.6.6 0 0 0 .116.658l.047.046a2.39 2.39 0 0 1 .518 2.603 2.388 2.388 0 0 1-3.894.774l-.044-.044a.6.6 0 0 0-.66-.12l-.009.004a.6.6 0 0 0-.363.549v.135a2.387 2.387 0 0 1-4.773 0v-.066a.6.6 0 0 0-.393-.538l-.044-.019a.6.6 0 0 0-.66.12l-.044.044a2.39 2.39 0 0 1-2.602.518 2.385 2.385 0 0 1-.773-3.895l.042-.043a.6.6 0 0 0 .12-.66l-.004-.009a.6.6 0 0 0-.462-.356l-.087-.007h-.135a2.387 2.387 0 0 1 0-4.773h.065a.6.6 0 0 0 .54-.393q.008-.023.018-.044a.6.6 0 0 0-.12-.66h-.001l-.043-.044A2.387 2.387 0 1 1 6.222 2.91l.044.044.068.058a.6.6 0 0 0 .58.067l.08-.028.083-.022a.6.6 0 0 0 .286-.505v-.138a2.387 2.387 0 0 1 4.774 0z" }),
    /* @__PURE__ */ d.jsx("path", { d: "M11 9.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0" })
  ] }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "a", children: /* @__PURE__ */ d.jsx("path", { d: "M0 0h20v20H0z" }) }) })
] }), o3 = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M6.75 15.833a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M16.75 12.917a2.167 2.167 0 0 0-2.167-2.167H5.417a3.667 3.667 0 1 1 0-7.333H12.5a.75.75 0 0 1 0 1.5H5.417a2.167 2.167 0 0 0 0 4.333h9.166a3.668 3.668 0 0 1 0 7.334H7.5a.75.75 0 0 1 0-1.5h7.083a2.17 2.17 0 0 0 2.167-2.167",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M16.75 4.167a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0m1.5 0a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0",
      fill: "currentColor"
    }
  )
] }), u3 = (e) => /* @__PURE__ */ d.jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsxs("g", { clipPath: "url(#clip0_318_263)", children: [
    /* @__PURE__ */ d.jsx(
      "path",
      {
        d: "M11.1694 6.01412C11.2759 5.6973 11.7241 5.6973 11.8306 6.01412L11.8596 6.1003C12.4887 7.97035 13.9013 9.4735 15.7288 10.2173C16.0103 10.3319 16.0103 10.7306 15.7288 10.8452C13.9013 11.589 12.4887 13.0921 11.8596 14.9622L11.8306 15.0484C11.7241 15.3652 11.2759 15.3652 11.1694 15.0484L11.1404 14.9622C10.5113 13.0921 9.09865 11.589 7.27121 10.8452C6.98968 10.7306 6.98968 10.3319 7.27121 10.2173C9.09865 9.4735 10.5113 7.97035 11.1404 6.1003L11.1694 6.01412Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ d.jsx(
      "path",
      {
        opacity: "0.4",
        d: "M4.25463 2.66311C4.33892 2.43533 4.66109 2.43533 4.74537 2.66311C5.27536 4.09538 6.40462 5.22464 7.83689 5.75463C8.06467 5.83892 8.06467 6.16109 7.83689 6.24537C6.40462 6.77536 5.27536 7.90462 4.74537 9.33689C4.66109 9.56467 4.33892 9.56467 4.25463 9.33689C3.72464 7.90462 2.59538 6.77536 1.16311 6.24537C0.935326 6.16109 0.935326 5.83892 1.16311 5.75463C2.59538 5.22464 3.72464 4.09538 4.25463 2.66311Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ d.jsx(
      "path",
      {
        opacity: "0.4",
        d: "M9.37731 0.300304C9.41946 0.186413 9.58054 0.186413 9.62269 0.300304C9.88768 1.01644 10.4523 1.58107 11.1684 1.84606C11.2823 1.88821 11.2823 2.04929 11.1684 2.09144C10.4523 2.35643 9.88768 2.92106 9.62269 3.6372C9.58054 3.75109 9.41946 3.75109 9.37731 3.6372C9.11232 2.92106 8.54769 2.35643 7.83155 2.09144C7.71766 2.04929 7.71766 1.88821 7.83155 1.84606C8.54769 1.58107 9.11232 1.01644 9.37731 0.300304Z",
        fill: "currentColor"
      }
    )
  ] }),
  /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsx("clipPath", { id: "clip0_318_263", children: /* @__PURE__ */ d.jsx("rect", { width: "16", height: "16", fill: "currentColor", transform: "translate(0.5)" }) }) })
] }), bf = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M10 .916a1.17 1.17 0 0 1 1.095.762l.029.091.004.015 1.317 5.112a.92.92 0 0 0 .66.658h-.002l5.114 1.319.012.002c.215.06.409.18.557.344l.06.074.055.079a1.167 1.167 0 0 1-.672 1.752l-.012.004-5.113 1.317a.92.92 0 0 0-.62.543l-.039.116-1.318 5.112-.004.015a1.168 1.168 0 0 1-2.251-.015l-1.317-5.112a.92.92 0 0 0-.659-.658l-5.113-1.319-.017-.005a1.17 1.17 0 0 1-.844-1.027L.918 10l.004-.095a1.17 1.17 0 0 1 .844-1.028l.017-.004 5.112-1.319h.001a.92.92 0 0 0 .659-.658l1.318-5.112.004-.015A1.17 1.17 0 0 1 10 .916m-.993 6.355A2.42 2.42 0 0 1 7.27 9.006L3.42 10l3.85.994a2.42 2.42 0 0 1 1.737 1.736l.992 3.854.994-3.854a2.42 2.42 0 0 1 1.736-1.736L16.581 10l-3.851-.992a2.42 2.42 0 0 1-1.737-1.736L10 3.417zm6.91-1.438V2.5a.75.75 0 1 1 1.5 0v3.333a.75.75 0 0 1-1.5 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M18.333 3.417a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1 0-1.5zM2.583 15.834v-1.667a.75.75 0 1 1 1.5 0v1.667a.75.75 0 0 1-1.5 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx("path", { d: "M4.167 14.25a.75.75 0 0 1 0 1.5H2.5a.75.75 0 0 1 0-1.5z", fill: "currentColor" })
] }), c3 = (e) => /* @__PURE__ */ d.jsxs("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M17.584 10a7.584 7.584 0 1 0-15.168 0 7.584 7.584 0 0 0 15.168 0m1.5 0A9.084 9.084 0 1 1 .915 9.999a9.084 9.084 0 0 1 18.169 0",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M11.97 7.803a.75.75 0 1 1 1.06 1.06l-3.333 3.334a.75.75 0 0 1-1.06 0L6.97 10.53a.75.75 0 0 1 1.06-1.06l1.136 1.135z",
      fill: "currentColor"
    }
  )
] }), Cb = (e) => /* @__PURE__ */ d.jsxs("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ d.jsx(
    "path",
    {
      d: "M19.5606 13.3584C19.7026 12.9378 20.2975 12.9378 20.4395 13.3584L20.4767 13.4685C21.3173 15.9574 23.2009 17.9566 25.6355 18.9438C26.011 19.096 26.011 19.6277 25.6355 19.78C23.2009 20.7672 21.3173 22.7662 20.4767 25.2553L20.4395 25.3654C20.2975 25.786 19.7026 25.786 19.5606 25.3654L19.5234 25.2553C18.6829 22.7662 16.7993 20.7672 14.3646 19.78C13.9891 19.6277 13.9891 19.096 14.3646 18.9438C16.7993 17.9566 18.6829 15.9574 19.5234 13.4685L19.5606 13.3584Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      opacity: "0.4",
      d: "M10.3406 8.90916C10.4529 8.60678 10.8806 8.60678 10.9929 8.90916C11.7002 10.8131 13.2067 12.3141 15.1125 13.0165C15.4164 13.1285 15.4164 13.5588 15.1125 13.6708C13.2067 14.3734 11.7002 15.8743 10.9929 17.7782C10.8806 18.0806 10.4529 18.0806 10.3406 17.7782C9.63331 15.8743 8.12679 14.3734 6.22105 13.6708C5.9172 13.5588 5.9172 13.1285 6.22105 13.0165C8.12679 12.3141 9.63331 10.8131 10.3406 8.90916Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d.jsx(
    "path",
    {
      opacity: "0.4",
      d: "M17.1703 5.77233C17.2264 5.62114 17.4403 5.62114 17.4964 5.77233C17.85 6.7243 18.6034 7.47478 19.5562 7.82601C19.7082 7.88201 19.7082 8.09718 19.5562 8.15318C18.6034 8.50439 17.85 9.25487 17.4964 10.2069C17.4403 10.358 17.2264 10.358 17.1703 10.2069C16.8167 9.25487 16.0634 8.50439 15.1106 8.15318C14.9586 8.09718 14.9586 7.88201 15.1106 7.82601C16.0634 7.47478 16.8167 6.7243 17.1703 5.77233Z",
      fill: "currentColor"
    }
  )
] }), Sb = () => /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-2 zai-brand", children: [
  /* @__PURE__ */ d.jsx(Cb, { width: 32, height: 32, color: "#FFFFFF" }),
  /* @__PURE__ */ d.jsx("span", { className: "text-2xl font-medium", children: "ZAI" })
] });
function l3(e) {
  const { isConnectionsEnabled: t } = at();
  return /* @__PURE__ */ d.jsx(XP, { ...e, variant: "floating", collapsible: "none", className: "p-4 bg-transparent h-[calc(100%_-_98px)]", children: /* @__PURE__ */ d.jsxs(t3, { className: "p-0 bg-sidebar h-full rounded-xl", children: [
    /* @__PURE__ */ d.jsx(ZP, { className: "p-6", children: /* @__PURE__ */ d.jsx(n3, { children: /* @__PURE__ */ d.jsx(r3, { children: /* @__PURE__ */ d.jsx(Sb, {}) }) }) }),
    /* @__PURE__ */ d.jsxs(e3, { className: "p-6 pt-0", children: [
      /* @__PURE__ */ d.jsx("div", { className: "min-h-0 flex-1 overflow-y-auto", children: /* @__PURE__ */ d.jsx(Ab, {}) }),
      t && /* @__PURE__ */ d.jsx(OR, {})
    ] })
  ] }) });
}
const d3 = {
  7: "0",
  30: "1",
  90: "3",
  180: "6",
  365: "12",
  730: "24",
  1095: "36"
}, _f = {
  0: "day",
  1: "week",
  3: "week",
  6: "month",
  12: "month",
  24: "quarter",
  36: "quarter",
  61: "quarter"
}, Yl = (e) => d3[String(e)], Ic = (e) => {
  const t = Yl(e);
  return t && _f[t] || _f[1];
}, wb = (e) => {
  const t = new URLSearchParams();
  if (e.timeRangeInDays !== void 0) {
    const n = Yl(e.timeRangeInDays);
    n && t.set("uploadDate", n);
  }
  return e.provider && e.provider !== "all" && t.set("providers", e.provider), t;
};
function h3(e, t, n) {
  const r = e.getUTCDate().toString().padStart(2, "0"), s = (e.getUTCMonth() + 1).toString().padStart(2, "0"), i = e.getUTCFullYear().toString();
  if (n) {
    if (t === "DD/MM/YYYY")
      return `${r}/${s}/${i}`;
    const o = new Intl.DateTimeFormat(n, {
      timeZone: "UTC",
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).formatToParts(e), u = o.find((h) => h.type === "day")?.value || r, c = o.find((h) => h.type === "month")?.value || s, l = o.find((h) => h.type === "year")?.value || i;
    return `${u}/${c}/${l}`;
  }
  return t.replace("DD", r).replace("MM", s).replace("YYYY", i);
}
function Tf(e, t, n) {
  const r = new Date(e);
  switch (n) {
    case "day":
      r.setUTCDate(r.getUTCDate() + t);
      break;
    case "week":
      r.setUTCDate(r.getUTCDate() + t * 7);
      break;
    case "month":
      r.setUTCMonth(r.getUTCMonth() + t);
      break;
    case "quarter":
      r.setUTCMonth(r.getUTCMonth() + t * 3);
      break;
    case "year":
      r.setUTCFullYear(r.getUTCFullYear() + t);
      break;
    default:
      throw new Error(`Unsupported unit: ${n}`);
  }
  return r;
}
function f3(e, t, n) {
  switch (n) {
    case "day":
      return Math.floor((t.getTime() - e.getTime()) / (1e3 * 60 * 60 * 24));
    case "week":
      return Math.floor((t.getTime() - e.getTime()) / (1e3 * 60 * 60 * 24 * 7));
    case "month":
      return (t.getUTCFullYear() - e.getUTCFullYear()) * 12 + (t.getUTCMonth() - e.getUTCMonth());
    case "quarter": {
      const r = (t.getUTCFullYear() - e.getUTCFullYear()) * 12 + (t.getUTCMonth() - e.getUTCMonth());
      return Math.floor(r / 3);
    }
    case "year":
      return t.getUTCFullYear() - e.getUTCFullYear();
    default:
      throw new Error(`Unsupported unit: ${n}`);
  }
}
function p3(e, t, n = "DD/MM/YYYY", r = "day", s = null) {
  const i = (E) => {
    if (E instanceof Date)
      return new Date(Date.UTC(E.getUTCFullYear(), E.getUTCMonth(), E.getUTCDate()));
    const g = /* @__PURE__ */ new Date(E + "T00:00:00.000");
    if (isNaN(g.getTime())) {
      const _ = new Date(E);
      return isNaN(_.getTime()) ? /* @__PURE__ */ new Date(NaN) : new Date(Date.UTC(_.getUTCFullYear(), _.getUTCMonth(), _.getUTCDate()));
    }
    return new Date(Date.UTC(g.getFullYear(), g.getMonth(), g.getDate()));
  }, a = i(e), o = i(t);
  if (isNaN(a.getTime()) || isNaN(o.getTime()))
    return [];
  const u = f3(a, o, r), c = Math.abs(u) + 1, h = c > 0 ? c : 0, m = u < 0;
  return Array.from(Array(h)).map((E, g) => {
    const _ = m ? Tf(a, -g, r) : Tf(a, g, r);
    return h3(_, n, s || void 0);
  });
}
const m3 = `
  query Creator($creatorId: ID!, $filter: AnalyticsFilterInput!) {
    creator(_id: $creatorId) {
      ... on Creator {
        id: creatorId
        subscribers
        title
        provider
        country
        thumbnail
        isTrending
        performance {
          analytics(filter: $filter) {
            avgEngagement
            avgEngagementVariation
          }
        }
      }
      ... on CreatorIncompleteIN {
        title
      }
      ... on CreatorIncompleteTT {
        title
      }
      ... on CreatorIncompleteYT {
        title
      }
      ... on CreatorIncompleteFB {
        title
      }
      ... on CreatorIncompleteTW {
        title
      }
      ... on CreatorPublic {
        id: creatorId
        subscribers
        title
        provider
        country
        thumbnail
        isTrending
      }
    }
  }
`, g3 = `
  query Post($postId: ID!) {
    post(_id: $postId) {
      id: postId
      thumbnail
      publishedAt
      provider
      views
      likes
      title
      creator {
        ... on Creator {
          id: creatorId
          title
          thumbnail
          provider
        }
        ... on CreatorIncompleteTW {
          title
        }
        ... on CreatorIncompleteFB {
          title
        }
        ... on CreatorIncompleteYT {
          title
        }
        ... on CreatorIncompleteTT {
          title
        }
        ... on CreatorIncompleteIN {
          title
        }
        ... on CreatorPublic {
          title
          thumbnail
        }
      }
    }
  }
`, E3 = `
  query getDocumentsList($take: Int!, $cursor: String, $status: [FileStorageStatus!]) {
    getWorkspace {
      fileStorage {
        filesPaginated(take: $take, cursor: $cursor, status: $status) {
          cursor
          totalCount
          data {
            fileName
            id
            size
          }
        }
      }
    }
  }
`, b3 = `
  fragment TerritoryEngagementOverTime on TerritoryInterface {
    territoryId
    territoryPerformance {
      metricsPerMonth(
        timeRange: $timeRange
        publishedAt: $publishedAt
        providers: $providers
        interval: $interval
      ) {
        date
        totalEngagement
      }
    }
  }

  fragment EngagementOverTimeBrandItem on WorkspaceBrand {
    id
    name
    customSettings
    workspaceBrandTerritories {
      selfContentTerritory @skip(if: $skipSelfContent) {
        ...TerritoryEngagementOverTime
      }
      earnedTerritory @skip(if: $skipEarned) {
        ...TerritoryEngagementOverTime
      }
      paidTerritory @skip(if: $skipPaid) {
        ...TerritoryEngagementOverTime
      }
      groupedTerritory @skip(if: $skipGrouped) {
        ...TerritoryEngagementOverTime
      }
    }
  }

  query getBrandEngagementOverTime(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $interval: SparklineIntervalInput
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand {
        ...EngagementOverTimeBrandItem
      }
      workspaceBrandCompetitorsPaginated {
        data {
          ...EngagementOverTimeBrandItem
        }
      }
    }
  }
`, _3 = `
  fragment TerritoryEngagementOverTime on TerritoryInterface {
    territoryId
    territoryPerformance {
      metricsPerMonth(
        timeRange: $timeRange
        publishedAt: $publishedAt
        providers: $providers
        interval: $interval
      ) {
        date
        totalEngagement
      }
    }
  }

  fragment EngagementOverTimeBrandItem on WorkspaceBrandV2 {
    id
    name
    customSettings # <- "{ color: string }"
    workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
      selfContentTerritory @skip(if: $skipSelfContent) {
        ...TerritoryEngagementOverTime
      }
      earnedTerritory @skip(if: $skipEarned) {
        ...TerritoryEngagementOverTime
      }
      paidTerritory @skip(if: $skipPaid) {
        ...TerritoryEngagementOverTime
      }
      groupedTerritory @skip(if: $skipGrouped) {
        ...TerritoryEngagementOverTime
      }
    }
  }

  query getBrandEngagementOverTime(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $interval: SparklineIntervalInput
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        ...EngagementOverTimeBrandItem
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          ...EngagementOverTimeBrandItem
        }
      }
    }
  }
`, T3 = `
  fragment TerritoryPerformanceFields on TerritoryPerformance {
    metrics(
      timeRange: $timeRange
      publishedAt: $publishedAt
      providers: $providers
    ) {
      totalEngagement
      totalViews
    }
    totalPosts(
      timeRange: $timeRange
      providers: $providers
      publishedAt: $publishedAt
    )
  }

  query BrandCharts_AttentionMetrics(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand {
        id
        name
        customSettings
        workspaceBrandTerritories {
          selfContentTerritory @skip(if: $skipSelfContent) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          earnedTerritory @skip(if: $skipEarned) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          paidTerritory @skip(if: $skipPaid) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          groupedTerritory @skip(if: $skipGrouped) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated {
        data {
          id
          name
          customSettings
          workspaceBrandTerritories {
            selfContentTerritory @skip(if: $skipSelfContent) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            earnedTerritory @skip(if: $skipEarned) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            paidTerritory @skip(if: $skipPaid) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            groupedTerritory @skip(if: $skipGrouped) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
          }
        }
      }
    }
  }
`, A3 = `
  fragment TerritoryPerformanceFields on TerritoryPerformance {
    metrics(
      timeRange: $timeRange
      publishedAt: $publishedAt
      providers: $providers
    ) {
      totalEngagement
      totalViews
    }
    totalPosts(
      timeRange: $timeRange
      providers: $providers
      publishedAt: $publishedAt
    )
  }

  query BrandCharts_AttentionMetrics(
    $timeRange: TimeRange
    $publishedAt: RangeQuery
    $providers: [Providers!]
    $skipPaid: Boolean! = true
    $skipEarned: Boolean! = true
    $skipGrouped: Boolean! = true
    $skipSelfContent: Boolean! = true
  ) {
    getWorkspace {
      id
      workspaceBrand: workspaceBrandV2 {
        id
        name
        customSettings # <- "{ color: string }"
        workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
          selfContentTerritory @skip(if: $skipSelfContent) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          earnedTerritory @skip(if: $skipEarned) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          paidTerritory @skip(if: $skipPaid) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
          groupedTerritory @skip(if: $skipGrouped) {
            name
            territoryPerformance {
              ...TerritoryPerformanceFields
            }
          }
        }
      }
      workspaceBrandCompetitorsPaginated: workspaceBrandCompetitorsPaginatedV2 {
        data {
          id
          name
          customSettings # <- "{ color: string }"
          workspaceBrandTerritories: workspaceBrandTerritoriesV2 {
            selfContentTerritory @skip(if: $skipSelfContent) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            earnedTerritory @skip(if: $skipEarned) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            paidTerritory @skip(if: $skipPaid) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
            groupedTerritory @skip(if: $skipGrouped) {
              name
              territoryPerformance {
                ...TerritoryPerformanceFields
              }
            }
          }
        }
      }
    }
  }
`, y3 = `
  query getShareOfAttentionV2($input: ShareOfAttentionV2Input!) {
    getWorkspace {
      listShareOfAttentionV2(input: $input) {
        data {
          current {
            donut {
              brand {
                id
                name
                brandColor
              }
              rankPosition
              rankVariation
              value
              valueVariation
            }
            histogram {
              brand {
                id
                name
                brandColor
              }
              date
              rankPosition
              rankVariation
              value
              valueVariation
            }
          }
        }
      }
      selfBrandSOA {
        brand {
          id
          name
        }
        category {
          id
          name
          country
        }
      }
    }
  }
`, x3 = `
  query SHARE_OF_ATTENTION_V3($input: ShareOfAttentionV3MetricsInput!) {
    shareOfAttentionV3 {
      metrics(input: $input) {

        histogram {
          brand {
            id
            color
            name
            thumbnailUrl
          }

          date
          value
          valueVariation
          rankPosition
          rankVariation
          isPartial
        }

      }

      myBrand {
        id
        name
        color
        thumbnailUrl
        isVerified
        country
      }

      listMySoas {
        id
        name
      }
    }
  }
`, C3 = `
  query getTerritoryRelevance(
    $territoryId: ID!
    $interval: SparklineIntervalInput
    $publishedAt: RangeQuery
    $timeRange: TimeRange
  ) {
    getTerritory(territoryId: $territoryId) {
      territoryId
      territoryPerformance {
        totalPosts(timeRange: $timeRange, publishedAt: $publishedAt)
        relevancev2(
          filters: { timeRange: $timeRange, interval: $interval, publishedAt: $publishedAt }
        ) {
          sparkline
          endDate
          startDate
        }
      }
    }
  }
`;
class es {
  constructor({ workspaceId: t, getValidToken: n, userId: r, userEmail: s = "" }) {
    this.workspaceId = t, this.getValidToken = n, this.userId = r, this.userEmail = s;
  }
  async getInsightsHeaders() {
    return {
      "Content-Type": "application/json",
      Authorization: await this.getValidToken(),
      "x-insights-workspace": this.workspaceId
    };
  }
  async fetchInsightsGraphQL(t, n) {
    const r = await this.getInsightsHeaders(), s = await fetch(`${is.baseUrl}/graphql`, {
      method: "POST",
      headers: r,
      body: JSON.stringify({ query: t, variables: n })
    });
    if (!s.ok) {
      const i = await s.text();
      throw new Error(`Insights GraphQL error: ${s.status} ${i}`);
    }
    return s.json();
  }
  static formatBrandEngagementData(t, n) {
    const r = Qr.getMetricKeyByTerritoryType(n), s = t?.workspaceBrand, i = t?.workspaceBrandCompetitorsPaginated?.data || [];
    return [s, ...i].map((o, u) => {
      const c = o.workspaceBrandTerritories?.[r]?.territoryPerformance?.metricsPerMonth || [];
      return {
        id: o.id,
        name: o.name,
        color: Qr.parseColorFromSettings(o.customSettings, u),
        metrics: c.map((l) => ({ date: l.date, totalEngagement: l.totalEngagement }))
      };
    });
  }
  static formatSharesData(t, n) {
    const r = Qr.getMetricKeyByTerritoryType(n), s = t?.workspaceBrand, i = t?.workspaceBrandCompetitorsPaginated?.data || [];
    return [s, ...i].map((o, u) => {
      const c = o.workspaceBrandTerritories?.[r]?.territoryPerformance;
      return {
        id: o.id,
        name: o.name,
        color: Qr.parseColorFromSettings(o.customSettings, u),
        totalEngagement: c?.metrics?.totalEngagement || 0,
        totalViews: c?.metrics?.totalViews || 0,
        totalPosts: c?.totalPosts || 0
      };
    });
  }
  static formatSoAData(t) {
    const n = {
      category: t.selfBrandSOA?.brand?.category || null,
      brands: []
    }, r = {}, s = t.selfBrandSOA?.brand?.id;
    return t.listShareOfAttentionV2.data.current.histogram.forEach((i, a) => {
      const o = i.brand.id;
      r[o] || (r[o] = {
        id: o,
        name: i.brand.name,
        color: Qr.getBrandColor(i.brand, a),
        isSelf: o === s,
        dateMap: /* @__PURE__ */ new Map()
      }), r[o].dateMap.set(i.date, parseFloat(Number(i.value * 100).toFixed(2)));
    }), n.brands = Object.values(r).map((i) => ({
      id: i.id,
      name: i.name,
      color: i.color,
      isSelf: i.isSelf,
      scores: Array.from(i.dateMap.entries()).sort(([a], [o]) => a.localeCompare(o)).map(([a, o]) => ({ date: a, value: o }))
    })), n;
  }
  static formatSoAV3Data({ histogram: t, industry: n, myBrand: r }) {
    const i = {
      category: n ? { id: n.id, name: n.name, country: r.country ?? "" } : null,
      brands: []
    }, a = {};
    return t.forEach((o, u) => {
      const c = o.brand.id;
      a[c] || (a[c] = {
        id: c,
        name: o.brand.name,
        color: Qr.getBrandColor(o.brand, u),
        isSelf: c === r.id,
        dateMap: /* @__PURE__ */ new Map()
      }), a[c].dateMap.set(o.date, parseFloat(Number(o.value * 100).toFixed(2)));
    }), i.brands = Object.values(a).map((o) => ({
      id: o.id,
      name: o.name,
      color: o.color,
      isSelf: o.isSelf,
      scores: Array.from(o.dateMap.entries()).sort(([u], [c]) => u.localeCompare(c)).map(([u, c]) => ({ date: u, value: c }))
    })), i;
  }
  async getBrandEngagementOverTimeData(t, n = {}) {
    try {
      const r = t.territoryType || "grouped", s = t.provider || "all", i = s in ra ? [s] : Object.keys(ra), a = Number.parseInt(t.timeRangeInDays || "30", 10), { publishedAt: o, timeRange: u } = Cu(a), c = qh[r], l = { type: "calendar", timeUnit: Ic(a) }, h = n?.isNewPageBrandOverviewEnabled ? _3 : b3, m = await this.fetchInsightsGraphQL(h, {
        ...c,
        providers: i,
        publishedAt: o,
        timeRange: u,
        interval: l
      });
      return es.formatBrandEngagementData(m.data.getWorkspace, r);
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch brand engagement over time from backend",
        error: r
      }), r;
    }
  }
  async getShareOfAttentionData(t, n = {}) {
    try {
      const r = t.period || "monthly", s = Number.parseInt(t.year || String((/* @__PURE__ */ new Date()).getFullYear()), 10);
      if (n?.isSOAV3WithZaiEnabled) {
        const a = await this.fetchInsightsGraphQL(x3, { input: { aggregate: r, year: s } }), o = a.data.shareOfAttentionV3?.metrics?.histogram, u = a.data.shareOfAttentionV3?.listMySoas, c = a.data.shareOfAttentionV3?.myBrand;
        return es.formatSoAV3Data({
          histogram: o,
          industry: u,
          myBrand: c
        });
      }
      const i = await this.fetchInsightsGraphQL(y3, { input: { aggregate: r, year: s } });
      return es.formatSoAData(i.data.getWorkspace);
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch share of attention data from backend",
        error: r
      }), r;
    }
  }
  async getSharesData(t, n = {}) {
    const r = t.territoryType || "grouped", s = t.provider || "all", i = s in ra ? [s] : Object.keys(ra), a = Number.parseInt(t.timeRangeInDays || "30", 10), { publishedAt: o, timeRange: u } = Cu(a), c = n?.isNewPageBrandOverviewEnabled ? A3 : T3;
    try {
      const l = await this.fetchInsightsGraphQL(c, {
        ...qh[r],
        providers: i,
        publishedAt: o,
        timeRange: u
      });
      return es.formatSharesData(l.data.getWorkspace, r);
    } catch (l) {
      throw console.error({
        log: "Zai Chat - Error to fetch shares data from backend",
        error: l
      }), l;
    }
  }
  async getTerritoryRelevanceData(t) {
    const n = t.territoryId, r = t.timeRange || "30", s = Cu(r), i = { type: "calendar", timeUnit: Ic(r) };
    try {
      const a = await this.fetchInsightsGraphQL(C3, {
        territoryId: n,
        interval: i,
        publishedAt: s.publishedAt,
        timeRange: s.timeRange
      }), o = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.sparkline || [], u = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.startDate, c = a?.data?.getTerritory?.territoryPerformance?.relevancev2?.endDate, l = p3(u, c, "YYYY-MM-DD", i.timeUnit);
      return { sparkline: Array.from({ length: Math.min(o.length, l.length) }, (m, p) => ({
        date: l[p],
        value: o[p]
      })), startDate: u, endDate: c };
    } catch (a) {
      throw console.error({
        log: "Zai Chat - Error to fetch territory relevance data from backend",
        error: a
      }), a;
    }
  }
  async getFiles(t) {
    try {
      return (await this.fetchInsightsGraphQL(E3, {
        take: t.limit,
        cursor: t.cursor,
        status: ["REQUESTED", "PROCESSING", "PROCESSED"]
      })).data.getWorkspace.fileStorage.filesPaginated;
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch files from backend",
        error: n
      }), n;
    }
  }
  async getCreatorData(t, n) {
    try {
      return (await this.fetchInsightsGraphQL(m3, {
        creatorId: t,
        filter: { periodInMonths: n.performanceInMonths }
      })).data.creator;
    } catch (r) {
      throw console.error({
        log: "Zai Chat - Error to fetch creator data from backend",
        query: { variables: { creatorId: t } },
        error: r
      }), r;
    }
  }
  async getPostData(t) {
    try {
      return (await this.fetchInsightsGraphQL(g3, { postId: t })).data.post;
    } catch (n) {
      throw console.error({
        log: "Zai Chat - Error to fetch post data from backend",
        query: { variables: { postId: t } },
        error: n
      }), n;
    }
  }
}
const Br = () => {
  const { workspaceId: e, userId: t, userEmail: n, getValidToken: r } = at();
  return se(
    () => new es({ workspaceId: e, getValidToken: r, userId: t, userEmail: n }),
    [e, t, n, r]
  );
}, S3 = ({ limit: e = 100 }) => {
  const { workspaceId: t } = at(), n = Br(), [r, s] = ce(!1), [i, a] = ce(!1), [o, u] = ce(!1), [c, l] = ce(null), h = ne(async () => {
    if (t)
      try {
        s(!0), u(!1);
        const p = await n.getFiles({ limit: e });
        l(p);
      } catch {
        u(!0);
      } finally {
        s(!1);
      }
  }, [t, e, n]), m = ne(async () => {
    if (!(!t || !c?.cursor))
      try {
        a(!0), u(!1);
        const p = await n.getFiles({ limit: e, cursor: c.cursor });
        l((E) => ({
          cursor: p.cursor,
          data: [...E?.data || [], ...p.data],
          totalCount: p.totalCount
        }));
      } catch {
        u(!0);
      } finally {
        a(!1);
      }
  }, [t, c?.cursor, e, n]);
  return _e(() => {
    h();
  }, []), {
    isLoading: r,
    isLoadingMore: i,
    isError: o,
    data: c,
    refetch: h,
    fetchMore: m
  };
}, w3 = 1, Ib = "h-[82px]", I3 = ({
  data: e,
  isLoading: t,
  isError: n,
  refetch: r,
  onButtonClick: s = () => {
  },
  onInfoClick: i = () => {
  }
}) => {
  const a = se(() => e?.totalCount || 0, [e?.totalCount]), o = se(() => a === 0, [a]), u = ne(() => {
    s();
  }, [s]), c = ne(
    (l) => {
      l.stopPropagation(), i();
    },
    [i]
  );
  return {
    isEmpty: o,
    totalCount: a,
    showLoading: t,
    showError: n,
    handleButtonClick: u,
    handleInfoClick: c,
    refetch: r
  };
}, Af = {
  0: "gap-0",
  26: "gap-[26px]"
}, v3 = (e) => {
  const t = !e.description && !e.hasTrendTag ? Af[26] : Af[0];
  return /* @__PURE__ */ d.jsx("a", { href: e.creatorUrl, target: "_blank", rel: "noopener noreferrer", className: "flex w-full h-full no-underline", children: /* @__PURE__ */ d.jsx(Vr, { theme: e.theme || "dark", children: /* @__PURE__ */ d.jsxs("div", { className: "flex gap-3", children: [
    e.thumbnail && /* @__PURE__ */ d.jsx("div", { className: "w-[100px] shrink-0", children: /* @__PURE__ */ d.jsx(Vr.Thumbnail, { ...e.thumbnail }) }),
    /* @__PURE__ */ d.jsxs("div", { className: `flex flex-col ${t}`, children: [
      e.title && /* @__PURE__ */ d.jsx(Vr.Title, { children: e.title }),
      (e.description || e.hasTrendTag) && /* @__PURE__ */ d.jsxs("div", { className: "flex gap-[10px] pb-[10px]", children: [
        e.description && /* @__PURE__ */ d.jsx(Vr.Description, { children: e.description }),
        e.hasTrendTag && /* @__PURE__ */ d.jsx(Vr.TrendTag, {})
      ] }),
      e.metrics && /* @__PURE__ */ d.jsx(Vr.Metrics, { ...e.metrics })
    ] })
  ] }) }) });
}, N3 = de(v3), vb = {
  fb: "facebook",
  in: "instagram",
  tt: "tiktok",
  tw: "twitch",
  yt: "youtube"
}, k3 = (e) => /* @__PURE__ */ d.jsxs(Yr, { theme: e.theme || "dark", classes: ["ds-video-card-default"], children: [
  /* @__PURE__ */ d.jsx("a", { href: e.videoUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ d.jsx(Yr.Thumbnail, { ...e.thumbnail }) }),
  /* @__PURE__ */ d.jsx(Yr.Description, { classes: ["px-2"], children: e.description }),
  /* @__PURE__ */ d.jsxs("div", { className: "flex px-2 justify-between items-center", children: [
    e.creatorUrl ? /* @__PURE__ */ d.jsx("a", { href: e.creatorUrl, target: "_blank", rel: "noopener noreferrer", children: /* @__PURE__ */ d.jsx(Yr.Creator, { ...e.creator }) }) : /* @__PURE__ */ d.jsx(Yr.Creator, { ...e.creator }),
    /* @__PURE__ */ d.jsx(Yr.Metrics, { ...e.metrics })
  ] })
] }), R3 = de(k3), ln = {
  VideoCardDefault: R3,
  // IIconProps is not exported from @winnin/ds-icon, so we widen the name type via cast
  Icon: l1,
  CreatorCardDefault: N3,
  LineChart: h1,
  SyncMultipleDonut: f1,
  ColumnsChart: d1
}, P3 = de(({ children: e, ...t }) => /* @__PURE__ */ d.jsxs(
  "button",
  {
    ...t,
    type: "button",
    className: "flex justify-between items-center w-full gap-5 p-5 bg-black rounded-xl cursor-pointer h-[82px]",
    children: [
      /* @__PURE__ */ d.jsx("div", { className: "text-sm text-white text-left leading-[21px]", children: e }),
      /* @__PURE__ */ d.jsx(ln.Icon, { name: "upload", width: 24, height: 24, className: "shrink-0 text-purple-300" })
    ]
  }
)), Ur = ({
  isLoading: e,
  isError: t,
  isEmpty: n,
  emptyComponent: r,
  errorComponent: s,
  loadingComponent: i,
  children: a
}) => e ? /* @__PURE__ */ d.jsx(d.Fragment, { children: i }) : t ? /* @__PURE__ */ d.jsx(d.Fragment, { children: s }) : n && r ? /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: a }), qa = {
  error: {
    key: "file-upload.error.title",
    defaultValue: "Falha ao carregar arquivos"
  },
  tryAgain: {
    key: "file-upload.try-again",
    defaultValue: "Tentar novamente"
  },
  emptyMessage: {
    key: "file-upload.empty-message",
    defaultValue: "Expanda o conhecimento da Zai com documentos da sua marca"
  },
  filesCount: (e) => ({
    key: "file-upload.files-count",
    defaultValue: "{count, plural, one {# arquivo adicionado} other {# arquivos adicionados}}",
    parameters: { count: e }
  })
}, O3 = ({ refetch: e, t }) => /* @__PURE__ */ d.jsxs(
  "div",
  {
    className: `w-full p-4 bg-black rounded-xl flex flex-col items-center justify-center gap-1 ${Ib}`,
    children: [
      /* @__PURE__ */ d.jsx("strong", { className: "text-white text-sm", children: t(qa.error) }),
      /* @__PURE__ */ d.jsx(pt, { variant: "highlight-border", onClick: e, children: t(qa.tryAgain) })
    ]
  }
), D3 = de(O3), L3 = () => /* @__PURE__ */ d.jsx("div", { className: "w-full", children: /* @__PURE__ */ d.jsx(kt, { className: `bg-gray-600 rounded-xl w-full ${Ib}` }) }), M3 = de(L3), H3 = ({
  isEmpty: e,
  totalCount: t,
  showLoading: n,
  showError: r,
  handleButtonClick: s,
  handleInfoClick: i,
  refetch: a,
  t: o
}) => /* @__PURE__ */ d.jsx("div", { className: "w-full", children: /* @__PURE__ */ d.jsx(
  Ur,
  {
    isLoading: n,
    isError: r,
    loadingComponent: /* @__PURE__ */ d.jsx(M3, {}),
    errorComponent: /* @__PURE__ */ d.jsx(D3, { refetch: a, t: o }),
    children: /* @__PURE__ */ d.jsxs(P3, { onClick: s, children: [
      o(e ? qa.emptyMessage : qa.filesCount(t)),
      e && /* @__PURE__ */ d.jsx(
        "span",
        {
          role: "button",
          tabIndex: 0,
          className: "inline-block align-middle pl-2 cursor-pointer",
          onClick: i,
          children: /* @__PURE__ */ d.jsx(ln.Icon, { name: "info", width: 16, height: 16, className: "text-white" })
        }
      )
    ] })
  }
) }), B3 = de(H3), Nb = Je(({ onButtonClick: e, onInfoClick: t }, n) => {
  const { t: r } = He(), { data: s, isLoading: i, isError: a, refetch: o } = S3({
    limit: w3
  });
  i1(
    n,
    () => ({
      refetch: o
    }),
    [o]
  );
  const u = I3({
    data: s,
    isLoading: i,
    isError: a,
    refetch: o,
    onButtonClick: e,
    onInfoClick: t
  });
  return /* @__PURE__ */ d.jsx(B3, { ...u, t: r });
});
Nb.displayName = "FileUpload";
const U3 = ({ copiedDuration: e = 3e3 } = {}) => {
  const { workspaceId: t } = at(), n = Re(), r = n.message(), s = n.composer(), i = Re(), a = J((u) => {
    const c = u?.message;
    return c ? (c.role !== "assistant" || c.status.type !== "running") && c.content.some((l) => l.type === "text" && l.text?.length > 0) : !1;
  }), o = ne(() => {
    const { isEditing: u, text: c } = s.getState(), l = u ? c : r.getCopyText(), h = new Dl(t, l).replaceWidgetTagWithLink().build();
    navigator.clipboard.writeText(h).then(() => {
      i.message().setIsCopied(!0), setTimeout(() => i.message().setIsCopied(!1), e);
    });
  }, [s, r, t, i, e]);
  return a ? o : null;
}, Gl = Je(({ copiedDuration: e, onClick: t, disabled: n, ...r }, s) => {
  const i = J((o) => o.message.isCopied), a = U3({ copiedDuration: e });
  return /* @__PURE__ */ d.jsx(
    Rt.button,
    {
      type: "button",
      ...i ? { "data-copied": "true" } : {},
      ...r,
      ref: s,
      disabled: n || !a,
      onClick: be(t, () => {
        a?.();
      })
    }
  );
});
Gl.displayName = "ActionBarPrimitive.Copy";
function yf(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), s = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const a = n.slice(s, r).trim();
    (a || !i) && t.push(a), s = r + 1, r = n.indexOf(",", s);
  }
  return t;
}
function kb(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const F3 = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, j3 = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, $3 = {};
function xf(e, t) {
  return ($3.jsx ? j3 : F3).test(e);
}
const z3 = /[ \t\n\f\r]/g;
function V3(e) {
  return typeof e == "object" ? e.type === "text" ? Cf(e.value) : !1 : Cf(e);
}
function Cf(e) {
  return e.replace(z3, "") === "";
}
class Di {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(t, n, r) {
    this.normal = n, this.property = t, r && (this.space = r);
  }
}
Di.prototype.normal = {};
Di.prototype.property = {};
Di.prototype.space = void 0;
function Rb(e, t) {
  const n = {}, r = {};
  for (const s of e)
    Object.assign(n, s.property), Object.assign(r, s.normal);
  return new Di(n, r, t);
}
function Ei(e) {
  return e.toLowerCase();
}
class Pt {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(t, n) {
    this.attribute = n, this.property = t;
  }
}
Pt.prototype.attribute = "";
Pt.prototype.booleanish = !1;
Pt.prototype.boolean = !1;
Pt.prototype.commaOrSpaceSeparated = !1;
Pt.prototype.commaSeparated = !1;
Pt.prototype.defined = !1;
Pt.prototype.mustUseProperty = !1;
Pt.prototype.number = !1;
Pt.prototype.overloadedBoolean = !1;
Pt.prototype.property = "";
Pt.prototype.spaceSeparated = !1;
Pt.prototype.space = void 0;
let Y3 = 0;
const we = Fr(), st = Fr(), vc = Fr(), X = Fr(), We = Fr(), as = Fr(), Lt = Fr();
function Fr() {
  return 2 ** ++Y3;
}
const Nc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: we,
  booleanish: st,
  commaOrSpaceSeparated: Lt,
  commaSeparated: as,
  number: X,
  overloadedBoolean: vc,
  spaceSeparated: We
}, Symbol.toStringTag, { value: "Module" })), Ru = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(Nc)
);
class Wl extends Pt {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(t, n, r, s) {
    let i = -1;
    if (super(t, n), Sf(this, "space", s), typeof r == "number")
      for (; ++i < Ru.length; ) {
        const a = Ru[i];
        Sf(this, Ru[i], (r & Nc[a]) === Nc[a]);
      }
  }
}
Wl.prototype.defined = !0;
function Sf(e, t, n) {
  n && (e[t] = n);
}
function Cs(e) {
  const t = {}, n = {};
  for (const [r, s] of Object.entries(e.properties)) {
    const i = new Wl(
      r,
      e.transform(e.attributes || {}, r),
      s,
      e.space
    );
    e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[Ei(r)] = r, n[Ei(i.attribute)] = r;
  }
  return new Di(t, n, e.space);
}
const Pb = Cs({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: st,
    ariaAutoComplete: null,
    ariaBusy: st,
    ariaChecked: st,
    ariaColCount: X,
    ariaColIndex: X,
    ariaColSpan: X,
    ariaControls: We,
    ariaCurrent: null,
    ariaDescribedBy: We,
    ariaDetails: null,
    ariaDisabled: st,
    ariaDropEffect: We,
    ariaErrorMessage: null,
    ariaExpanded: st,
    ariaFlowTo: We,
    ariaGrabbed: st,
    ariaHasPopup: null,
    ariaHidden: st,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: We,
    ariaLevel: X,
    ariaLive: null,
    ariaModal: st,
    ariaMultiLine: st,
    ariaMultiSelectable: st,
    ariaOrientation: null,
    ariaOwns: We,
    ariaPlaceholder: null,
    ariaPosInSet: X,
    ariaPressed: st,
    ariaReadOnly: st,
    ariaRelevant: null,
    ariaRequired: st,
    ariaRoleDescription: We,
    ariaRowCount: X,
    ariaRowIndex: X,
    ariaRowSpan: X,
    ariaSelected: st,
    ariaSetSize: X,
    ariaSort: null,
    ariaValueMax: X,
    ariaValueMin: X,
    ariaValueNow: X,
    ariaValueText: null,
    role: null
  },
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
});
function Ob(e, t) {
  return t in e ? e[t] : t;
}
function Db(e, t) {
  return Ob(e, t.toLowerCase());
}
const G3 = Cs({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: as,
    acceptCharset: We,
    accessKey: We,
    action: null,
    allow: null,
    allowFullScreen: we,
    allowPaymentRequest: we,
    allowUserMedia: we,
    alt: null,
    as: null,
    async: we,
    autoCapitalize: null,
    autoComplete: We,
    autoFocus: we,
    autoPlay: we,
    blocking: We,
    capture: null,
    charSet: null,
    checked: we,
    cite: null,
    className: We,
    cols: X,
    colSpan: null,
    content: null,
    contentEditable: st,
    controls: we,
    controlsList: We,
    coords: X | as,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: we,
    defer: we,
    dir: null,
    dirName: null,
    disabled: we,
    download: vc,
    draggable: st,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: we,
    formTarget: null,
    headers: We,
    height: X,
    hidden: vc,
    high: X,
    href: null,
    hrefLang: null,
    htmlFor: We,
    httpEquiv: We,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: we,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: we,
    itemId: null,
    itemProp: We,
    itemRef: We,
    itemScope: we,
    itemType: We,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: we,
    low: X,
    manifest: null,
    max: null,
    maxLength: X,
    media: null,
    method: null,
    min: null,
    minLength: X,
    multiple: we,
    muted: we,
    name: null,
    nonce: null,
    noModule: we,
    noValidate: we,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: we,
    optimum: X,
    pattern: null,
    ping: We,
    placeholder: null,
    playsInline: we,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: we,
    referrerPolicy: null,
    rel: We,
    required: we,
    reversed: we,
    rows: X,
    rowSpan: X,
    sandbox: We,
    scope: null,
    scoped: we,
    seamless: we,
    selected: we,
    shadowRootClonable: we,
    shadowRootDelegatesFocus: we,
    shadowRootMode: null,
    shape: null,
    size: X,
    sizes: null,
    slot: null,
    span: X,
    spellCheck: st,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: X,
    step: null,
    style: null,
    tabIndex: X,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: we,
    useMap: null,
    value: st,
    width: X,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: We,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: X,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: X,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: we,
    // Lists. Use CSS to reduce space between items instead
    declare: we,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: X,
    // `<img>` and `<object>`
    leftMargin: X,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: X,
    // `<body>`
    marginWidth: X,
    // `<body>`
    noResize: we,
    // `<frame>`
    noHref: we,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: we,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: we,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: X,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: st,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: X,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: X,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: we,
    disableRemotePlayback: we,
    prefix: null,
    property: null,
    results: X,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: Db
}), W3 = Cs({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: Lt,
    accentHeight: X,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: X,
    amplitude: X,
    arabicForm: null,
    ascent: X,
    attributeName: null,
    attributeType: null,
    azimuth: X,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: X,
    by: null,
    calcMode: null,
    capHeight: X,
    className: We,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: X,
    diffuseConstant: X,
    direction: null,
    display: null,
    dur: null,
    divisor: X,
    dominantBaseline: null,
    download: we,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: X,
    enableBackground: null,
    end: null,
    event: null,
    exponent: X,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: X,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: as,
    g2: as,
    glyphName: as,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: X,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: X,
    horizOriginX: X,
    horizOriginY: X,
    id: null,
    ideographic: X,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: X,
    k: X,
    k1: X,
    k2: X,
    k3: X,
    k4: X,
    kernelMatrix: Lt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: X,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: X,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: X,
    overlineThickness: X,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: X,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: We,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: X,
    pointsAtY: X,
    pointsAtZ: X,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Lt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Lt,
    rev: Lt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Lt,
    requiredFeatures: Lt,
    requiredFonts: Lt,
    requiredFormats: Lt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: X,
    specularExponent: X,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: X,
    strikethroughThickness: X,
    string: null,
    stroke: null,
    strokeDashArray: Lt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: X,
    strokeOpacity: X,
    strokeWidth: null,
    style: null,
    surfaceScale: X,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Lt,
    tabIndex: X,
    tableValues: null,
    target: null,
    targetX: X,
    targetY: X,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Lt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: X,
    underlineThickness: X,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: X,
    values: null,
    vAlphabetic: X,
    vMathematical: X,
    vectorEffect: null,
    vHanging: X,
    vIdeographic: X,
    version: null,
    vertAdvY: X,
    vertOriginX: X,
    vertOriginY: X,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: X,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: Ob
}), Lb = Cs({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
}), Mb = Cs({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: Db
}), Hb = Cs({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
}), q3 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, K3 = /[A-Z]/g, wf = /-[a-z]/g, Q3 = /^data[-\w.:]+$/i;
function Ho(e, t) {
  const n = Ei(t);
  let r = t, s = Pt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Q3.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(wf, J3);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!wf.test(i)) {
        let a = i.replace(K3, X3);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    s = Wl;
  }
  return new s(r, t);
}
function X3(e) {
  return "-" + e.toLowerCase();
}
function J3(e) {
  return e.charAt(1).toUpperCase();
}
const Li = Rb([Pb, G3, Lb, Mb, Hb], "html"), lr = Rb([Pb, W3, Lb, Mb, Hb], "svg");
function If(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function Bb(e) {
  return e.join(" ").trim();
}
var Fs = {}, ua = { exports: {} }, Pu, vf;
function Z3() {
  if (vf) return Pu;
  vf = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, s = /^:\s*/, i = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, a = /^[;\s]*/, o = /^\s+|\s+$/g, u = `
`, c = "/", l = "*", h = "", m = "comment", p = "declaration";
  Pu = function(g, _) {
    if (typeof g != "string")
      throw new TypeError("First argument must be a string");
    if (!g) return [];
    _ = _ || {};
    var b = 1, T = 1;
    function C(F) {
      var M = F.match(t);
      M && (b += M.length);
      var H = F.lastIndexOf(u);
      T = ~H ? F.length - H : T + F.length;
    }
    function R() {
      var F = { line: b, column: T };
      return function(M) {
        return M.position = new D(F), U(), M;
      };
    }
    function D(F) {
      this.start = F, this.end = { line: b, column: T }, this.source = _.source;
    }
    D.prototype.content = g;
    function w(F) {
      var M = new Error(
        _.source + ":" + b + ":" + T + ": " + F
      );
      if (M.reason = F, M.filename = _.source, M.line = b, M.column = T, M.source = g, !_.silent) throw M;
    }
    function O(F) {
      var M = F.exec(g);
      if (M) {
        var H = M[0];
        return C(H), g = g.slice(H.length), M;
      }
    }
    function U() {
      O(n);
    }
    function q(F) {
      var M;
      for (F = F || []; M = P(); )
        M !== !1 && F.push(M);
      return F;
    }
    function P() {
      var F = R();
      if (!(c != g.charAt(0) || l != g.charAt(1))) {
        for (var M = 2; h != g.charAt(M) && (l != g.charAt(M) || c != g.charAt(M + 1)); )
          ++M;
        if (M += 2, h === g.charAt(M - 1))
          return w("End of comment missing");
        var H = g.slice(2, M - 2);
        return T += 2, C(H), g = g.slice(M), T += 2, F({
          type: m,
          comment: H
        });
      }
    }
    function z() {
      var F = R(), M = O(r);
      if (M) {
        if (P(), !O(s)) return w("property missing ':'");
        var H = O(i), B = F({
          type: p,
          property: E(M[0].replace(e, h)),
          value: H ? E(H[0].replace(e, h)) : h
        });
        return O(a), B;
      }
    }
    function G() {
      var F = [];
      q(F);
      for (var M; M = z(); )
        M !== !1 && (F.push(M), q(F));
      return F;
    }
    return U(), G();
  };
  function E(g) {
    return g ? g.replace(o, h) : h;
  }
  return Pu;
}
var Nf;
function eO() {
  if (Nf) return ua.exports;
  Nf = 1;
  var e = Z3();
  function t(n, r) {
    var s = null;
    if (!n || typeof n != "string")
      return s;
    for (var i, a = e(n), o = typeof r == "function", u, c, l = 0, h = a.length; l < h; l++)
      i = a[l], u = i.property, c = i.value, o ? r(u, c, i) : c && (s || (s = {}), s[u] = c);
    return s;
  }
  return ua.exports = t, ua.exports.default = t, ua.exports;
}
var js = {}, kf;
function tO() {
  if (kf) return js;
  kf = 1, js.__esModule = !0, js.camelCase = void 0;
  var e = /^--[a-zA-Z0-9-]+$/, t = /-([a-z])/g, n = /^[^-]+$/, r = /^-(webkit|moz|ms|o|khtml)-/, s = /^-(ms)-/, i = function(c) {
    return !c || n.test(c) || e.test(c);
  }, a = function(c, l) {
    return l.toUpperCase();
  }, o = function(c, l) {
    return "".concat(l, "-");
  }, u = function(c, l) {
    return l === void 0 && (l = {}), i(c) ? c : (c = c.toLowerCase(), l.reactCompat ? c = c.replace(s, o) : c = c.replace(r, o), c.replace(t, a));
  };
  return js.camelCase = u, js;
}
var Rf;
function nO() {
  return Rf || (Rf = 1, (function(e) {
    var t = Fs && Fs.__importDefault || function(i) {
      return i && i.__esModule ? i : { default: i };
    };
    e.__esModule = !0;
    var n = t(eO()), r = tO();
    function s(i, a) {
      var o = {};
      return !i || typeof i != "string" || (0, n.default)(i, function(u, c) {
        u && c && (o[(0, r.camelCase)(u, a)] = c);
      }), o;
    }
    e.default = s;
  })(Fs)), Fs;
}
var rO = nO();
const sO = /* @__PURE__ */ Dr(rO), Bo = Ub("end"), xn = Ub("start");
function Ub(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function iO(e) {
  const t = xn(e), n = Bo(e);
  if (t && n)
    return { start: t, end: n };
}
function ni(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Pf(e.position) : "start" in e || "end" in e ? Pf(e) : "line" in e || "column" in e ? kc(e) : "";
}
function kc(e) {
  return Of(e && e.line) + ":" + Of(e && e.column);
}
function Pf(e) {
  return kc(e && e.start) + "-" + kc(e && e.end);
}
function Of(e) {
  return e && typeof e == "number" ? e : 1;
}
class At extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let s = "", i = {}, a = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? s = t : !i.cause && t && (a = !0, s = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? i.ruleId = r : (i.source = r.slice(0, u), i.ruleId = r.slice(u + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const u = i.ancestors[i.ancestors.length - 1];
      u && (i.place = u.position);
    }
    const o = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file = "", this.message = s, this.line = o ? o.line : void 0, this.name = ni(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = a && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual = void 0, this.expected = void 0, this.note = void 0, this.url = void 0;
  }
}
At.prototype.file = "";
At.prototype.name = "";
At.prototype.reason = "";
At.prototype.message = "";
At.prototype.stack = "";
At.prototype.column = void 0;
At.prototype.line = void 0;
At.prototype.ancestors = void 0;
At.prototype.cause = void 0;
At.prototype.fatal = void 0;
At.prototype.place = void 0;
At.prototype.ruleId = void 0;
At.prototype.source = void 0;
const ql = {}.hasOwnProperty, aO = /* @__PURE__ */ new Map(), oO = /[A-Z]/g, uO = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), cO = /* @__PURE__ */ new Set(["td", "th"]), Fb = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function lO(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = bO(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = EO(n, t.jsx, t.jsxs);
  }
  const s = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? lr : Li,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, i = jb(s, e, void 0);
  return i && typeof i != "string" ? i : s.create(
    e,
    s.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function jb(e, t, n) {
  if (t.type === "element")
    return dO(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return hO(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return pO(e, t, n);
  if (t.type === "mdxjsEsm")
    return fO(e, t);
  if (t.type === "root")
    return mO(e, t, n);
  if (t.type === "text")
    return gO(e, t);
}
function dO(e, t, n) {
  const r = e.schema;
  let s = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (s = lr, e.schema = s), e.ancestors.push(t);
  const i = zb(e, t.tagName, !1), a = _O(e, t);
  let o = Ql(e, t);
  return uO.has(t.tagName) && (o = o.filter(function(u) {
    return typeof u == "string" ? !V3(u) : !0;
  })), $b(e, a, i, t), Kl(a, o), e.ancestors.pop(), e.schema = r, e.create(t, i, a, n);
}
function hO(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  bi(e, t.position);
}
function fO(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  bi(e, t.position);
}
function pO(e, t, n) {
  const r = e.schema;
  let s = r;
  t.name === "svg" && r.space === "html" && (s = lr, e.schema = s), e.ancestors.push(t);
  const i = t.name === null ? e.Fragment : zb(e, t.name, !0), a = TO(e, t), o = Ql(e, t);
  return $b(e, a, i, t), Kl(a, o), e.ancestors.pop(), e.schema = r, e.create(t, i, a, n);
}
function mO(e, t, n) {
  const r = {};
  return Kl(r, Ql(e, t)), e.create(t, e.Fragment, r, n);
}
function gO(e, t) {
  return t.value;
}
function $b(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function Kl(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function EO(e, t, n) {
  return r;
  function r(s, i, a, o) {
    const c = Array.isArray(a.children) ? n : t;
    return o ? c(i, a, o) : c(i, a);
  }
}
function bO(e, t) {
  return n;
  function n(r, s, i, a) {
    const o = Array.isArray(i.children), u = xn(r);
    return t(
      s,
      i,
      a,
      o,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function _O(e, t) {
  const n = {};
  let r, s;
  for (s in t.properties)
    if (s !== "children" && ql.call(t.properties, s)) {
      const i = AO(e, s, t.properties[s]);
      if (i) {
        const [a, o] = i;
        e.tableCellAlignToStyle && a === "align" && typeof o == "string" && cO.has(t.tagName) ? r = o : n[a] = o;
      }
    }
  if (r) {
    const i = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    i[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function TO(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const i = r.data.estree.body[0];
        i.type;
        const a = i.expression;
        a.type;
        const o = a.properties[0];
        o.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(o.argument)
        );
      } else
        bi(e, t.position);
    else {
      const s = r.name;
      let i;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const o = r.value.data.estree.body[0];
          o.type, i = e.evaluater.evaluateExpression(o.expression);
        } else
          bi(e, t.position);
      else
        i = r.value === null ? !0 : r.value;
      n[s] = /** @type {Props[keyof Props]} */
      i;
    }
  return n;
}
function Ql(e, t) {
  const n = [];
  let r = -1;
  const s = e.passKeys ? /* @__PURE__ */ new Map() : aO;
  for (; ++r < t.children.length; ) {
    const i = t.children[r];
    let a;
    if (e.passKeys) {
      const u = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (u) {
        const c = s.get(u) || 0;
        a = u + "-" + c, s.set(u, c + 1);
      }
    }
    const o = jb(e, i, a);
    o !== void 0 && n.push(o);
  }
  return n;
}
function AO(e, t, n) {
  const r = Ho(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? kb(n) : Bb(n)), r.property === "style") {
      let s = typeof n == "object" ? n : yO(e, String(n));
      return e.stylePropertyNameCase === "css" && (s = xO(s)), ["style", s];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? q3[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function yO(e, t) {
  try {
    return sO(t, { reactCompat: !0 });
  } catch (n) {
    if (e.ignoreInvalidStyle)
      return {};
    const r = (
      /** @type {Error} */
      n
    ), s = new At("Cannot parse `style` attribute", {
      ancestors: e.ancestors,
      cause: r,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    throw s.file = e.filePath || void 0, s.url = Fb + "#cannot-parse-style-attribute", s;
  }
}
function zb(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const s = t.split(".");
    let i = -1, a;
    for (; ++i < s.length; ) {
      const o = xf(s[i]) ? { type: "Identifier", name: s[i] } : { type: "Literal", value: s[i] };
      a = a ? {
        type: "MemberExpression",
        object: a,
        property: o,
        computed: !!(i && o.type === "Literal"),
        optional: !1
      } : o;
    }
    r = a;
  } else
    r = xf(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const s = (
      /** @type {string | number} */
      r.value
    );
    return ql.call(e.components, s) ? e.components[s] : s;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  bi(e);
}
function bi(e, t) {
  const n = new At(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = Fb + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function xO(e) {
  const t = {};
  let n;
  for (n in e)
    ql.call(e, n) && (t[CO(n)] = e[n]);
  return t;
}
function CO(e) {
  let t = e.replace(oO, SO);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function SO(e) {
  return "-" + e.toLowerCase();
}
const Ou = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, wO = {};
function Xl(e, t) {
  const n = wO, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, s = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Vb(e, r, s);
}
function Vb(e, t, n) {
  if (IO(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Df(e.children, t, n);
  }
  return Array.isArray(e) ? Df(e, t, n) : "";
}
function Df(e, t, n) {
  const r = [];
  let s = -1;
  for (; ++s < e.length; )
    r[s] = Vb(e[s], t, n);
  return r.join("");
}
function IO(e) {
  return !!(e && typeof e == "object");
}
const Lf = document.createElement("i");
function Jl(e) {
  const t = "&" + e + ";";
  Lf.innerHTML = t;
  const n = Lf.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Ut(e, t, n, r) {
  const s = e.length;
  let i = 0, a;
  if (t < 0 ? t = -t > s ? 0 : s + t : t = t > s ? s : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); i < r.length; )
      a = r.slice(i, i + 1e4), a.unshift(t, 0), e.splice(...a), i += 1e4, t += 1e4;
}
function Yt(e, t) {
  return e.length > 0 ? (Ut(e, e.length, 0, t), e) : t;
}
const Mf = {}.hasOwnProperty;
function Yb(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    vO(t, e[n]);
  return t;
}
function vO(e, t) {
  let n;
  for (n in t) {
    const s = (Mf.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let a;
    if (i)
      for (a in i) {
        Mf.call(s, a) || (s[a] = []);
        const o = i[a];
        NO(
          // @ts-expect-error Looks like a list.
          s[a],
          Array.isArray(o) ? o : o ? [o] : []
        );
      }
  }
}
function NO(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Ut(e, 0, 0, r);
}
function Gb(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function an(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const wt = dr(/[A-Za-z]/), bt = dr(/[\dA-Za-z]/), kO = dr(/[#-'*+\--9=?A-Z^-~]/);
function Ka(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Rc = dr(/\d/), RO = dr(/[\dA-Fa-f]/), PO = dr(/[!-/:-@[-`{-~]/);
function me(e) {
  return e !== null && e < -2;
}
function Ge(e) {
  return e !== null && (e < 0 || e === 32);
}
function ke(e) {
  return e === -2 || e === -1 || e === 32;
}
const Uo = dr(/\p{P}|\p{S}/u), Or = dr(/\s/);
function dr(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Ss(e) {
  const t = [];
  let n = -1, r = 0, s = 0;
  for (; ++n < e.length; ) {
    const i = e.charCodeAt(n);
    let a = "";
    if (i === 37 && bt(e.charCodeAt(n + 1)) && bt(e.charCodeAt(n + 2)))
      s = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (a = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const o = e.charCodeAt(n + 1);
      i < 56320 && o > 56319 && o < 57344 ? (a = String.fromCharCode(i, o), s = 1) : a = "�";
    } else
      a = String.fromCharCode(i);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + s + 1, a = ""), s && (n += s, s = 0);
  }
  return t.join("") + e.slice(r);
}
function Le(e, t, n, r) {
  const s = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return a;
  function a(u) {
    return ke(u) ? (e.enter(n), o(u)) : t(u);
  }
  function o(u) {
    return ke(u) && i++ < s ? (e.consume(u), o) : (e.exit(n), t(u));
  }
}
const OO = {
  tokenize: DO
};
function DO(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, s);
  let n;
  return t;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), Le(e, t, "linePrefix");
  }
  function s(o) {
    return e.enter("paragraph"), i(o);
  }
  function i(o) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, a(o);
  }
  function a(o) {
    if (o === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(o);
      return;
    }
    return me(o) ? (e.consume(o), e.exit("chunkText"), i) : (e.consume(o), a);
  }
}
const LO = {
  tokenize: MO
}, Hf = {
  tokenize: HO
};
function MO(e) {
  const t = this, n = [];
  let r = 0, s, i, a;
  return o;
  function o(C) {
    if (r < n.length) {
      const R = n[r];
      return t.containerState = R[1], e.attempt(R[0].continuation, u, c)(C);
    }
    return c(C);
  }
  function u(C) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, s && T();
      const R = t.events.length;
      let D = R, w;
      for (; D--; )
        if (t.events[D][0] === "exit" && t.events[D][1].type === "chunkFlow") {
          w = t.events[D][1].end;
          break;
        }
      b(r);
      let O = R;
      for (; O < t.events.length; )
        t.events[O][1].end = {
          ...w
        }, O++;
      return Ut(t.events, D + 1, 0, t.events.slice(R)), t.events.length = O, c(C);
    }
    return o(C);
  }
  function c(C) {
    if (r === n.length) {
      if (!s)
        return m(C);
      if (s.currentConstruct && s.currentConstruct.concrete)
        return E(C);
      t.interrupt = !!(s.currentConstruct && !s._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(Hf, l, h)(C);
  }
  function l(C) {
    return s && T(), b(r), m(C);
  }
  function h(C) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, E(C);
  }
  function m(C) {
    return t.containerState = {}, e.attempt(Hf, p, E)(C);
  }
  function p(C) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(C);
  }
  function E(C) {
    if (C === null) {
      s && T(), b(0), e.consume(C);
      return;
    }
    return s = s || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: s,
      contentType: "flow",
      previous: i
    }), g(C);
  }
  function g(C) {
    if (C === null) {
      _(e.exit("chunkFlow"), !0), b(0), e.consume(C);
      return;
    }
    return me(C) ? (e.consume(C), _(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, o) : (e.consume(C), g);
  }
  function _(C, R) {
    const D = t.sliceStream(C);
    if (R && D.push(null), C.previous = i, i && (i.next = C), i = C, s.defineSkip(C.start), s.write(D), t.parser.lazy[C.start.line]) {
      let w = s.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          s.events[w][1].start.offset < a && // …and either is not ended yet…
          (!s.events[w][1].end || // …or ends after it.
          s.events[w][1].end.offset > a)
        )
          return;
      const O = t.events.length;
      let U = O, q, P;
      for (; U--; )
        if (t.events[U][0] === "exit" && t.events[U][1].type === "chunkFlow") {
          if (q) {
            P = t.events[U][1].end;
            break;
          }
          q = !0;
        }
      for (b(r), w = O; w < t.events.length; )
        t.events[w][1].end = {
          ...P
        }, w++;
      Ut(t.events, U + 1, 0, t.events.slice(O)), t.events.length = w;
    }
  }
  function b(C) {
    let R = n.length;
    for (; R-- > C; ) {
      const D = n[R];
      t.containerState = D[1], D[0].exit.call(t, e);
    }
    n.length = C;
  }
  function T() {
    s.write([null]), i = void 0, s = void 0, t.containerState._closeFlow = void 0;
  }
}
function HO(e, t, n) {
  return Le(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function ps(e) {
  if (e === null || Ge(e) || Or(e))
    return 1;
  if (Uo(e))
    return 2;
}
function Fo(e, t, n) {
  const r = [];
  let s = -1;
  for (; ++s < e.length; ) {
    const i = e[s].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const Pc = {
  name: "attention",
  resolveAll: BO,
  tokenize: UO
};
function BO(e, t) {
  let n = -1, r, s, i, a, o, u, c, l;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const h = {
            ...e[r][1].end
          }, m = {
            ...e[n][1].start
          };
          Bf(h, -u), Bf(m, u), a = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: h,
            end: {
              ...e[r][1].end
            }
          }, o = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, i = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, s = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...a.start
            },
            end: {
              ...o.end
            }
          }, e[r][1].end = {
            ...a.start
          }, e[n][1].start = {
            ...o.end
          }, c = [], e[r][1].end.offset - e[r][1].start.offset && (c = Yt(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = Yt(c, [["enter", s, t], ["enter", a, t], ["exit", a, t], ["enter", i, t]]), c = Yt(c, Fo(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = Yt(c, [["exit", i, t], ["enter", o, t], ["exit", o, t], ["exit", s, t]]), e[n][1].end.offset - e[n][1].start.offset ? (l = 2, c = Yt(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : l = 0, Ut(e, r - 1, n - r + 3, c), n = r + c.length - l - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function UO(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, s = ps(r);
  let i;
  return a;
  function a(u) {
    return i = u, e.enter("attentionSequence"), o(u);
  }
  function o(u) {
    if (u === i)
      return e.consume(u), o;
    const c = e.exit("attentionSequence"), l = ps(u), h = !l || l === 2 && s || n.includes(u), m = !s || s === 2 && l || n.includes(r);
    return c._open = !!(i === 42 ? h : h && (s || !m)), c._close = !!(i === 42 ? m : m && (l || !h)), t(u);
  }
}
function Bf(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const FO = {
  name: "autolink",
  tokenize: jO
};
function jO(e, t, n) {
  let r = 0;
  return s;
  function s(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(p) {
    return wt(p) ? (e.consume(p), a) : p === 64 ? n(p) : c(p);
  }
  function a(p) {
    return p === 43 || p === 45 || p === 46 || bt(p) ? (r = 1, o(p)) : c(p);
  }
  function o(p) {
    return p === 58 ? (e.consume(p), r = 0, u) : (p === 43 || p === 45 || p === 46 || bt(p)) && r++ < 32 ? (e.consume(p), o) : (r = 0, c(p));
  }
  function u(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || Ka(p) ? n(p) : (e.consume(p), u);
  }
  function c(p) {
    return p === 64 ? (e.consume(p), l) : kO(p) ? (e.consume(p), c) : n(p);
  }
  function l(p) {
    return bt(p) ? h(p) : n(p);
  }
  function h(p) {
    return p === 46 ? (e.consume(p), r = 0, l) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(p);
  }
  function m(p) {
    if ((p === 45 || bt(p)) && r++ < 63) {
      const E = p === 45 ? m : h;
      return e.consume(p), E;
    }
    return n(p);
  }
}
const Mi = {
  partial: !0,
  tokenize: $O
};
function $O(e, t, n) {
  return r;
  function r(i) {
    return ke(i) ? Le(e, s, "linePrefix")(i) : s(i);
  }
  function s(i) {
    return i === null || me(i) ? t(i) : n(i);
  }
}
const Wb = {
  continuation: {
    tokenize: VO
  },
  exit: YO,
  name: "blockQuote",
  tokenize: zO
};
function zO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    if (a === 62) {
      const o = r.containerState;
      return o.open || (e.enter("blockQuote", {
        _container: !0
      }), o.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), i;
    }
    return n(a);
  }
  function i(a) {
    return ke(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function VO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return ke(a) ? Le(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a) : i(a);
  }
  function i(a) {
    return e.attempt(Wb, t, n)(a);
  }
}
function YO(e) {
  e.exit("blockQuote");
}
const qb = {
  name: "characterEscape",
  tokenize: GO
};
function GO(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), s;
  }
  function s(i) {
    return PO(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const Kb = {
  name: "characterReference",
  tokenize: WO
};
function WO(e, t, n) {
  const r = this;
  let s = 0, i, a;
  return o;
  function o(h) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), u;
  }
  function u(h) {
    return h === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(h), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), i = 31, a = bt, l(h));
  }
  function c(h) {
    return h === 88 || h === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(h), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, a = RO, l) : (e.enter("characterReferenceValue"), i = 7, a = Rc, l(h));
  }
  function l(h) {
    if (h === 59 && s) {
      const m = e.exit("characterReferenceValue");
      return a === bt && !Jl(r.sliceSerialize(m)) ? n(h) : (e.enter("characterReferenceMarker"), e.consume(h), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(h) && s++ < i ? (e.consume(h), l) : n(h);
  }
}
const Uf = {
  partial: !0,
  tokenize: KO
}, Ff = {
  concrete: !0,
  name: "codeFenced",
  tokenize: qO
};
function qO(e, t, n) {
  const r = this, s = {
    partial: !0,
    tokenize: D
  };
  let i = 0, a = 0, o;
  return u;
  function u(w) {
    return c(w);
  }
  function c(w) {
    const O = r.events[r.events.length - 1];
    return i = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, o = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), l(w);
  }
  function l(w) {
    return w === o ? (a++, e.consume(w), l) : a < 3 ? n(w) : (e.exit("codeFencedFenceSequence"), ke(w) ? Le(e, h, "whitespace")(w) : h(w));
  }
  function h(w) {
    return w === null || me(w) ? (e.exit("codeFencedFence"), r.interrupt ? t(w) : e.check(Uf, g, R)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(w));
  }
  function m(w) {
    return w === null || me(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), h(w)) : ke(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Le(e, p, "whitespace")(w)) : w === 96 && w === o ? n(w) : (e.consume(w), m);
  }
  function p(w) {
    return w === null || me(w) ? h(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), E(w));
  }
  function E(w) {
    return w === null || me(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), h(w)) : w === 96 && w === o ? n(w) : (e.consume(w), E);
  }
  function g(w) {
    return e.attempt(s, R, _)(w);
  }
  function _(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), b;
  }
  function b(w) {
    return i > 0 && ke(w) ? Le(e, T, "linePrefix", i + 1)(w) : T(w);
  }
  function T(w) {
    return w === null || me(w) ? e.check(Uf, g, R)(w) : (e.enter("codeFlowValue"), C(w));
  }
  function C(w) {
    return w === null || me(w) ? (e.exit("codeFlowValue"), T(w)) : (e.consume(w), C);
  }
  function R(w) {
    return e.exit("codeFenced"), t(w);
  }
  function D(w, O, U) {
    let q = 0;
    return P;
    function P(H) {
      return w.enter("lineEnding"), w.consume(H), w.exit("lineEnding"), z;
    }
    function z(H) {
      return w.enter("codeFencedFence"), ke(H) ? Le(w, G, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : G(H);
    }
    function G(H) {
      return H === o ? (w.enter("codeFencedFenceSequence"), F(H)) : U(H);
    }
    function F(H) {
      return H === o ? (q++, w.consume(H), F) : q >= a ? (w.exit("codeFencedFenceSequence"), ke(H) ? Le(w, M, "whitespace")(H) : M(H)) : U(H);
    }
    function M(H) {
      return H === null || me(H) ? (w.exit("codeFencedFence"), O(H)) : U(H);
    }
  }
}
function KO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const Du = {
  name: "codeIndented",
  tokenize: XO
}, QO = {
  partial: !0,
  tokenize: JO
};
function XO(e, t, n) {
  const r = this;
  return s;
  function s(c) {
    return e.enter("codeIndented"), Le(e, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? a(c) : n(c);
  }
  function a(c) {
    return c === null ? u(c) : me(c) ? e.attempt(QO, a, u)(c) : (e.enter("codeFlowValue"), o(c));
  }
  function o(c) {
    return c === null || me(c) ? (e.exit("codeFlowValue"), a(c)) : (e.consume(c), o);
  }
  function u(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function JO(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return r.parser.lazy[r.now().line] ? n(a) : me(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), s) : Le(e, i, "linePrefix", 5)(a);
  }
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(a) : me(a) ? s(a) : n(a);
  }
}
const ZO = {
  name: "codeText",
  previous: tD,
  resolve: eD,
  tokenize: nD
};
function eD(e) {
  let t = e.length - 4, n = 3, r, s;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    s === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (s = r) : (r === t || e[r][1].type === "lineEnding") && (e[s][1].type = "codeTextData", r !== s + 2 && (e[s][1].end = e[r - 1][1].end, e.splice(s + 2, r - s - 2), t -= r - s - 2, r = s + 2), s = void 0);
  return e;
}
function tD(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function nD(e, t, n) {
  let r = 0, s, i;
  return a;
  function a(h) {
    return e.enter("codeText"), e.enter("codeTextSequence"), o(h);
  }
  function o(h) {
    return h === 96 ? (e.consume(h), r++, o) : (e.exit("codeTextSequence"), u(h));
  }
  function u(h) {
    return h === null ? n(h) : h === 32 ? (e.enter("space"), e.consume(h), e.exit("space"), u) : h === 96 ? (i = e.enter("codeTextSequence"), s = 0, l(h)) : me(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), u) : (e.enter("codeTextData"), c(h));
  }
  function c(h) {
    return h === null || h === 32 || h === 96 || me(h) ? (e.exit("codeTextData"), u(h)) : (e.consume(h), c);
  }
  function l(h) {
    return h === 96 ? (e.consume(h), s++, l) : s === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(h)) : (i.type = "codeTextData", c(h));
  }
}
class rD {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const s = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - s, Number.POSITIVE_INFINITY);
    return r && $s(this.left, r), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), $s(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), $s(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        $s(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        $s(this.left, n.reverse());
      }
  }
}
function $s(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Qb(e) {
  const t = {};
  let n = -1, r, s, i, a, o, u, c;
  const l = new rD(e);
  for (; ++n < l.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = l.get(n), n && r[1].type === "chunkFlow" && l.get(n - 1)[1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, i = 0, i < u.length && u[i][1].type === "lineEndingBlank" && (i += 2), i < u.length && u[i][1].type === "content"))
      for (; ++i < u.length && u[i][1].type !== "content"; )
        u[i][1].type === "chunkText" && (u[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, sD(l, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (i = n, s = void 0; i--; )
        if (a = l.get(i), a[1].type === "lineEnding" || a[1].type === "lineEndingBlank")
          a[0] === "enter" && (s && (l.get(s)[1].type = "lineEndingBlank"), a[1].type = "lineEnding", s = i);
        else if (!(a[1].type === "linePrefix" || a[1].type === "listItemIndent")) break;
      s && (r[1].end = {
        ...l.get(s)[1].start
      }, o = l.slice(s, n), o.unshift(r), l.splice(s, n - s + 1, o));
    }
  }
  return Ut(e, 0, Number.POSITIVE_INFINITY, l.slice(0)), !c;
}
function sD(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let s = t - 1;
  const i = [];
  let a = n._tokenizer;
  a || (a = r.parser[n.contentType](n.start), n._contentTypeTextTrailing && (a._contentTypeTextTrailing = !0));
  const o = a.events, u = [], c = {};
  let l, h, m = -1, p = n, E = 0, g = 0;
  const _ = [g];
  for (; p; ) {
    for (; e.get(++s)[1] !== p; )
      ;
    i.push(s), p._tokenizer || (l = r.sliceStream(p), p.next || l.push(null), h && a.defineSkip(p.start), p._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(l), p._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), h = p, p = p.next;
  }
  for (p = n; ++m < o.length; )
    // Find a void token that includes a break.
    o[m][0] === "exit" && o[m - 1][0] === "enter" && o[m][1].type === o[m - 1][1].type && o[m][1].start.line !== o[m][1].end.line && (g = m + 1, _.push(g), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (a.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : _.pop(), m = _.length; m--; ) {
    const b = o.slice(_[m], _[m + 1]), T = i.pop();
    u.push([T, T + b.length - 1]), e.splice(T, 2, b);
  }
  for (u.reverse(), m = -1; ++m < u.length; )
    c[E + u[m][0]] = E + u[m][1], E += u[m][1] - u[m][0] - 1;
  return c;
}
const iD = {
  resolve: oD,
  tokenize: uD
}, aD = {
  partial: !0,
  tokenize: cD
};
function oD(e) {
  return Qb(e), e;
}
function uD(e, t) {
  let n;
  return r;
  function r(o) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), s(o);
  }
  function s(o) {
    return o === null ? i(o) : me(o) ? e.check(aD, a, i)(o) : (e.consume(o), s);
  }
  function i(o) {
    return e.exit("chunkContent"), e.exit("content"), t(o);
  }
  function a(o) {
    return e.consume(o), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, s;
  }
}
function cD(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Le(e, i, "linePrefix");
  }
  function i(a) {
    if (a === null || me(a))
      return n(a);
    const o = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && o && o[1].type === "linePrefix" && o[2].sliceSerialize(o[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function Xb(e, t, n, r, s, i, a, o, u) {
  const c = u || Number.POSITIVE_INFINITY;
  let l = 0;
  return h;
  function h(b) {
    return b === 60 ? (e.enter(r), e.enter(s), e.enter(i), e.consume(b), e.exit(i), m) : b === null || b === 32 || b === 41 || Ka(b) ? n(b) : (e.enter(r), e.enter(a), e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), g(b));
  }
  function m(b) {
    return b === 62 ? (e.enter(i), e.consume(b), e.exit(i), e.exit(s), e.exit(r), t) : (e.enter(o), e.enter("chunkString", {
      contentType: "string"
    }), p(b));
  }
  function p(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(o), m(b)) : b === null || b === 60 || me(b) ? n(b) : (e.consume(b), b === 92 ? E : p);
  }
  function E(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), p) : p(b);
  }
  function g(b) {
    return !l && (b === null || b === 41 || Ge(b)) ? (e.exit("chunkString"), e.exit(o), e.exit(a), e.exit(r), t(b)) : l < c && b === 40 ? (e.consume(b), l++, g) : b === 41 ? (e.consume(b), l--, g) : b === null || b === 32 || b === 40 || Ka(b) ? n(b) : (e.consume(b), b === 92 ? _ : g);
  }
  function _(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), g) : g(b);
  }
}
function Jb(e, t, n, r, s, i) {
  const a = this;
  let o = 0, u;
  return c;
  function c(p) {
    return e.enter(r), e.enter(s), e.consume(p), e.exit(s), e.enter(i), l;
  }
  function l(p) {
    return o > 999 || p === null || p === 91 || p === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !o && "_hiddenFootnoteSupport" in a.parser.constructs ? n(p) : p === 93 ? (e.exit(i), e.enter(s), e.consume(p), e.exit(s), e.exit(r), t) : me(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), l) : (e.enter("chunkString", {
      contentType: "string"
    }), h(p));
  }
  function h(p) {
    return p === null || p === 91 || p === 93 || me(p) || o++ > 999 ? (e.exit("chunkString"), l(p)) : (e.consume(p), u || (u = !ke(p)), p === 92 ? m : h);
  }
  function m(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), o++, h) : h(p);
  }
}
function Zb(e, t, n, r, s, i) {
  let a;
  return o;
  function o(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(s), e.consume(m), e.exit(s), a = m === 40 ? 41 : m, u) : n(m);
  }
  function u(m) {
    return m === a ? (e.enter(s), e.consume(m), e.exit(s), e.exit(r), t) : (e.enter(i), c(m));
  }
  function c(m) {
    return m === a ? (e.exit(i), u(a)) : m === null ? n(m) : me(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), Le(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), l(m));
  }
  function l(m) {
    return m === a || m === null || me(m) ? (e.exit("chunkString"), c(m)) : (e.consume(m), m === 92 ? h : l);
  }
  function h(m) {
    return m === a || m === 92 ? (e.consume(m), l) : l(m);
  }
}
function ri(e, t) {
  let n;
  return r;
  function r(s) {
    return me(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), n = !0, r) : ke(s) ? Le(e, r, n ? "linePrefix" : "lineSuffix")(s) : t(s);
  }
}
const lD = {
  name: "definition",
  tokenize: hD
}, dD = {
  partial: !0,
  tokenize: fD
};
function hD(e, t, n) {
  const r = this;
  let s;
  return i;
  function i(p) {
    return e.enter("definition"), a(p);
  }
  function a(p) {
    return Jb.call(
      r,
      e,
      o,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function o(p) {
    return s = an(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), u) : n(p);
  }
  function u(p) {
    return Ge(p) ? ri(e, c)(p) : c(p);
  }
  function c(p) {
    return Xb(
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function l(p) {
    return e.attempt(dD, h, h)(p);
  }
  function h(p) {
    return ke(p) ? Le(e, m, "whitespace")(p) : m(p);
  }
  function m(p) {
    return p === null || me(p) ? (e.exit("definition"), r.parser.defined.push(s), t(p)) : n(p);
  }
}
function fD(e, t, n) {
  return r;
  function r(o) {
    return Ge(o) ? ri(e, s)(o) : n(o);
  }
  function s(o) {
    return Zb(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(o);
  }
  function i(o) {
    return ke(o) ? Le(e, a, "whitespace")(o) : a(o);
  }
  function a(o) {
    return o === null || me(o) ? t(o) : n(o);
  }
}
const pD = {
  name: "hardBreakEscape",
  tokenize: mD
};
function mD(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), s;
  }
  function s(i) {
    return me(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const gD = {
  name: "headingAtx",
  resolve: ED,
  tokenize: bD
};
function ED(e, t) {
  let n = e.length - 2, r = 3, s, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (s = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Ut(e, r, n - r + 1, [["enter", s, t], ["enter", i, t], ["exit", i, t], ["exit", s, t]])), e;
}
function bD(e, t, n) {
  let r = 0;
  return s;
  function s(l) {
    return e.enter("atxHeading"), i(l);
  }
  function i(l) {
    return e.enter("atxHeadingSequence"), a(l);
  }
  function a(l) {
    return l === 35 && r++ < 6 ? (e.consume(l), a) : l === null || Ge(l) ? (e.exit("atxHeadingSequence"), o(l)) : n(l);
  }
  function o(l) {
    return l === 35 ? (e.enter("atxHeadingSequence"), u(l)) : l === null || me(l) ? (e.exit("atxHeading"), t(l)) : ke(l) ? Le(e, o, "whitespace")(l) : (e.enter("atxHeadingText"), c(l));
  }
  function u(l) {
    return l === 35 ? (e.consume(l), u) : (e.exit("atxHeadingSequence"), o(l));
  }
  function c(l) {
    return l === null || l === 35 || Ge(l) ? (e.exit("atxHeadingText"), o(l)) : (e.consume(l), c);
  }
}
const _D = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], jf = ["pre", "script", "style", "textarea"], TD = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: xD,
  tokenize: CD
}, AD = {
  partial: !0,
  tokenize: wD
}, yD = {
  partial: !0,
  tokenize: SD
};
function xD(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function CD(e, t, n) {
  const r = this;
  let s, i, a, o, u;
  return c;
  function c(v) {
    return l(v);
  }
  function l(v) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(v), h;
  }
  function h(v) {
    return v === 33 ? (e.consume(v), m) : v === 47 ? (e.consume(v), i = !0, g) : v === 63 ? (e.consume(v), s = 3, r.interrupt ? t : y) : wt(v) ? (e.consume(v), a = String.fromCharCode(v), _) : n(v);
  }
  function m(v) {
    return v === 45 ? (e.consume(v), s = 2, p) : v === 91 ? (e.consume(v), s = 5, o = 0, E) : wt(v) ? (e.consume(v), s = 4, r.interrupt ? t : y) : n(v);
  }
  function p(v) {
    return v === 45 ? (e.consume(v), r.interrupt ? t : y) : n(v);
  }
  function E(v) {
    const Se = "CDATA[";
    return v === Se.charCodeAt(o++) ? (e.consume(v), o === Se.length ? r.interrupt ? t : G : E) : n(v);
  }
  function g(v) {
    return wt(v) ? (e.consume(v), a = String.fromCharCode(v), _) : n(v);
  }
  function _(v) {
    if (v === null || v === 47 || v === 62 || Ge(v)) {
      const Se = v === 47, Te = a.toLowerCase();
      return !Se && !i && jf.includes(Te) ? (s = 1, r.interrupt ? t(v) : G(v)) : _D.includes(a.toLowerCase()) ? (s = 6, Se ? (e.consume(v), b) : r.interrupt ? t(v) : G(v)) : (s = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(v) : i ? T(v) : C(v));
    }
    return v === 45 || bt(v) ? (e.consume(v), a += String.fromCharCode(v), _) : n(v);
  }
  function b(v) {
    return v === 62 ? (e.consume(v), r.interrupt ? t : G) : n(v);
  }
  function T(v) {
    return ke(v) ? (e.consume(v), T) : P(v);
  }
  function C(v) {
    return v === 47 ? (e.consume(v), P) : v === 58 || v === 95 || wt(v) ? (e.consume(v), R) : ke(v) ? (e.consume(v), C) : P(v);
  }
  function R(v) {
    return v === 45 || v === 46 || v === 58 || v === 95 || bt(v) ? (e.consume(v), R) : D(v);
  }
  function D(v) {
    return v === 61 ? (e.consume(v), w) : ke(v) ? (e.consume(v), D) : C(v);
  }
  function w(v) {
    return v === null || v === 60 || v === 61 || v === 62 || v === 96 ? n(v) : v === 34 || v === 39 ? (e.consume(v), u = v, O) : ke(v) ? (e.consume(v), w) : U(v);
  }
  function O(v) {
    return v === u ? (e.consume(v), u = null, q) : v === null || me(v) ? n(v) : (e.consume(v), O);
  }
  function U(v) {
    return v === null || v === 34 || v === 39 || v === 47 || v === 60 || v === 61 || v === 62 || v === 96 || Ge(v) ? D(v) : (e.consume(v), U);
  }
  function q(v) {
    return v === 47 || v === 62 || ke(v) ? C(v) : n(v);
  }
  function P(v) {
    return v === 62 ? (e.consume(v), z) : n(v);
  }
  function z(v) {
    return v === null || me(v) ? G(v) : ke(v) ? (e.consume(v), z) : n(v);
  }
  function G(v) {
    return v === 45 && s === 2 ? (e.consume(v), B) : v === 60 && s === 1 ? (e.consume(v), Y) : v === 62 && s === 4 ? (e.consume(v), fe) : v === 63 && s === 3 ? (e.consume(v), y) : v === 93 && s === 5 ? (e.consume(v), Z) : me(v) && (s === 6 || s === 7) ? (e.exit("htmlFlowData"), e.check(AD, Ce, F)(v)) : v === null || me(v) ? (e.exit("htmlFlowData"), F(v)) : (e.consume(v), G);
  }
  function F(v) {
    return e.check(yD, M, Ce)(v);
  }
  function M(v) {
    return e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), H;
  }
  function H(v) {
    return v === null || me(v) ? F(v) : (e.enter("htmlFlowData"), G(v));
  }
  function B(v) {
    return v === 45 ? (e.consume(v), y) : G(v);
  }
  function Y(v) {
    return v === 47 ? (e.consume(v), a = "", $) : G(v);
  }
  function $(v) {
    if (v === 62) {
      const Se = a.toLowerCase();
      return jf.includes(Se) ? (e.consume(v), fe) : G(v);
    }
    return wt(v) && a.length < 8 ? (e.consume(v), a += String.fromCharCode(v), $) : G(v);
  }
  function Z(v) {
    return v === 93 ? (e.consume(v), y) : G(v);
  }
  function y(v) {
    return v === 62 ? (e.consume(v), fe) : v === 45 && s === 2 ? (e.consume(v), y) : G(v);
  }
  function fe(v) {
    return v === null || me(v) ? (e.exit("htmlFlowData"), Ce(v)) : (e.consume(v), fe);
  }
  function Ce(v) {
    return e.exit("htmlFlow"), t(v);
  }
}
function SD(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return me(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : n(a);
  }
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function wD(e, t, n) {
  return r;
  function r(s) {
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), e.attempt(Mi, t, n);
  }
}
const ID = {
  name: "htmlText",
  tokenize: vD
};
function vD(e, t, n) {
  const r = this;
  let s, i, a;
  return o;
  function o(y) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(y), u;
  }
  function u(y) {
    return y === 33 ? (e.consume(y), c) : y === 47 ? (e.consume(y), D) : y === 63 ? (e.consume(y), C) : wt(y) ? (e.consume(y), U) : n(y);
  }
  function c(y) {
    return y === 45 ? (e.consume(y), l) : y === 91 ? (e.consume(y), i = 0, E) : wt(y) ? (e.consume(y), T) : n(y);
  }
  function l(y) {
    return y === 45 ? (e.consume(y), p) : n(y);
  }
  function h(y) {
    return y === null ? n(y) : y === 45 ? (e.consume(y), m) : me(y) ? (a = h, Y(y)) : (e.consume(y), h);
  }
  function m(y) {
    return y === 45 ? (e.consume(y), p) : h(y);
  }
  function p(y) {
    return y === 62 ? B(y) : y === 45 ? m(y) : h(y);
  }
  function E(y) {
    const fe = "CDATA[";
    return y === fe.charCodeAt(i++) ? (e.consume(y), i === fe.length ? g : E) : n(y);
  }
  function g(y) {
    return y === null ? n(y) : y === 93 ? (e.consume(y), _) : me(y) ? (a = g, Y(y)) : (e.consume(y), g);
  }
  function _(y) {
    return y === 93 ? (e.consume(y), b) : g(y);
  }
  function b(y) {
    return y === 62 ? B(y) : y === 93 ? (e.consume(y), b) : g(y);
  }
  function T(y) {
    return y === null || y === 62 ? B(y) : me(y) ? (a = T, Y(y)) : (e.consume(y), T);
  }
  function C(y) {
    return y === null ? n(y) : y === 63 ? (e.consume(y), R) : me(y) ? (a = C, Y(y)) : (e.consume(y), C);
  }
  function R(y) {
    return y === 62 ? B(y) : C(y);
  }
  function D(y) {
    return wt(y) ? (e.consume(y), w) : n(y);
  }
  function w(y) {
    return y === 45 || bt(y) ? (e.consume(y), w) : O(y);
  }
  function O(y) {
    return me(y) ? (a = O, Y(y)) : ke(y) ? (e.consume(y), O) : B(y);
  }
  function U(y) {
    return y === 45 || bt(y) ? (e.consume(y), U) : y === 47 || y === 62 || Ge(y) ? q(y) : n(y);
  }
  function q(y) {
    return y === 47 ? (e.consume(y), B) : y === 58 || y === 95 || wt(y) ? (e.consume(y), P) : me(y) ? (a = q, Y(y)) : ke(y) ? (e.consume(y), q) : B(y);
  }
  function P(y) {
    return y === 45 || y === 46 || y === 58 || y === 95 || bt(y) ? (e.consume(y), P) : z(y);
  }
  function z(y) {
    return y === 61 ? (e.consume(y), G) : me(y) ? (a = z, Y(y)) : ke(y) ? (e.consume(y), z) : q(y);
  }
  function G(y) {
    return y === null || y === 60 || y === 61 || y === 62 || y === 96 ? n(y) : y === 34 || y === 39 ? (e.consume(y), s = y, F) : me(y) ? (a = G, Y(y)) : ke(y) ? (e.consume(y), G) : (e.consume(y), M);
  }
  function F(y) {
    return y === s ? (e.consume(y), s = void 0, H) : y === null ? n(y) : me(y) ? (a = F, Y(y)) : (e.consume(y), F);
  }
  function M(y) {
    return y === null || y === 34 || y === 39 || y === 60 || y === 61 || y === 96 ? n(y) : y === 47 || y === 62 || Ge(y) ? q(y) : (e.consume(y), M);
  }
  function H(y) {
    return y === 47 || y === 62 || Ge(y) ? q(y) : n(y);
  }
  function B(y) {
    return y === 62 ? (e.consume(y), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(y);
  }
  function Y(y) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(y), e.exit("lineEnding"), $;
  }
  function $(y) {
    return ke(y) ? Le(e, Z, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(y) : Z(y);
  }
  function Z(y) {
    return e.enter("htmlTextData"), a(y);
  }
}
const Zl = {
  name: "labelEnd",
  resolveAll: PD,
  resolveTo: OD,
  tokenize: DD
}, ND = {
  tokenize: LD
}, kD = {
  tokenize: MD
}, RD = {
  tokenize: HD
};
function PD(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const s = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += s;
    }
  }
  return e.length !== n.length && Ut(e, 0, e.length, n), e;
}
function OD(e, t) {
  let n = e.length, r = 0, s, i, a, o;
  for (; n--; )
    if (s = e[n][1], i) {
      if (s.type === "link" || s.type === "labelLink" && s._inactive)
        break;
      e[n][0] === "enter" && s.type === "labelLink" && (s._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (s.type === "labelImage" || s.type === "labelLink") && !s._balanced && (i = n, s.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else s.type === "labelEnd" && (a = n);
  const u = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[a][1].end
    }
  }, l = {
    type: "labelText",
    start: {
      ...e[i + r + 2][1].end
    },
    end: {
      ...e[a - 2][1].start
    }
  };
  return o = [["enter", u, t], ["enter", c, t]], o = Yt(o, e.slice(i + 1, i + r + 3)), o = Yt(o, [["enter", l, t]]), o = Yt(o, Fo(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, a - 3), t)), o = Yt(o, [["exit", l, t], e[a - 2], e[a - 1], ["exit", c, t]]), o = Yt(o, e.slice(a + 1)), o = Yt(o, [["exit", u, t]]), Ut(e, i, e.length, o), e;
}
function DD(e, t, n) {
  const r = this;
  let s = r.events.length, i, a;
  for (; s--; )
    if ((r.events[s][1].type === "labelImage" || r.events[s][1].type === "labelLink") && !r.events[s][1]._balanced) {
      i = r.events[s][1];
      break;
    }
  return o;
  function o(m) {
    return i ? i._inactive ? h(m) : (a = r.parser.defined.includes(an(r.sliceSerialize({
      start: i.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(m);
  }
  function u(m) {
    return m === 40 ? e.attempt(ND, l, a ? l : h)(m) : m === 91 ? e.attempt(kD, l, a ? c : h)(m) : a ? l(m) : h(m);
  }
  function c(m) {
    return e.attempt(RD, l, h)(m);
  }
  function l(m) {
    return t(m);
  }
  function h(m) {
    return i._balanced = !0, n(m);
  }
}
function LD(e, t, n) {
  return r;
  function r(h) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), s;
  }
  function s(h) {
    return Ge(h) ? ri(e, i)(h) : i(h);
  }
  function i(h) {
    return h === 41 ? l(h) : Xb(e, a, o, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(h);
  }
  function a(h) {
    return Ge(h) ? ri(e, u)(h) : l(h);
  }
  function o(h) {
    return n(h);
  }
  function u(h) {
    return h === 34 || h === 39 || h === 40 ? Zb(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(h) : l(h);
  }
  function c(h) {
    return Ge(h) ? ri(e, l)(h) : l(h);
  }
  function l(h) {
    return h === 41 ? (e.enter("resourceMarker"), e.consume(h), e.exit("resourceMarker"), e.exit("resource"), t) : n(h);
  }
}
function MD(e, t, n) {
  const r = this;
  return s;
  function s(o) {
    return Jb.call(r, e, i, a, "reference", "referenceMarker", "referenceString")(o);
  }
  function i(o) {
    return r.parser.defined.includes(an(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(o) : n(o);
  }
  function a(o) {
    return n(o);
  }
}
function HD(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), s;
  }
  function s(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const BD = {
  name: "labelStartImage",
  resolveAll: Zl.resolveAll,
  tokenize: UD
};
function UD(e, t, n) {
  const r = this;
  return s;
  function s(o) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(o), e.exit("labelImageMarker"), i;
  }
  function i(o) {
    return o === 91 ? (e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelImage"), a) : n(o);
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const FD = {
  name: "labelStartLink",
  resolveAll: Zl.resolveAll,
  tokenize: jD
};
function jD(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const Lu = {
  name: "lineEnding",
  tokenize: $D
};
function $D(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Le(e, t, "linePrefix");
  }
}
const xa = {
  name: "thematicBreak",
  tokenize: zD
};
function zD(e, t, n) {
  let r = 0, s;
  return i;
  function i(c) {
    return e.enter("thematicBreak"), a(c);
  }
  function a(c) {
    return s = c, o(c);
  }
  function o(c) {
    return c === s ? (e.enter("thematicBreakSequence"), u(c)) : r >= 3 && (c === null || me(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function u(c) {
    return c === s ? (e.consume(c), r++, u) : (e.exit("thematicBreakSequence"), ke(c) ? Le(e, o, "whitespace")(c) : o(c));
  }
}
const Nt = {
  continuation: {
    tokenize: WD
  },
  exit: KD,
  name: "list",
  tokenize: GD
}, VD = {
  partial: !0,
  tokenize: QD
}, YD = {
  partial: !0,
  tokenize: qD
};
function GD(e, t, n) {
  const r = this, s = r.events[r.events.length - 1];
  let i = s && s[1].type === "linePrefix" ? s[2].sliceSerialize(s[1], !0).length : 0, a = 0;
  return o;
  function o(p) {
    const E = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (E === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : Rc(p)) {
      if (r.containerState.type || (r.containerState.type = E, e.enter(E, {
        _container: !0
      })), E === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(xa, n, c)(p) : c(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(p);
    }
    return n(p);
  }
  function u(p) {
    return Rc(p) && ++a < 10 ? (e.consume(p), u) : (!r.interrupt || a < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), c(p)) : n(p);
  }
  function c(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      Mi,
      // Can’t be empty when interrupting.
      r.interrupt ? n : l,
      e.attempt(VD, m, h)
    );
  }
  function l(p) {
    return r.containerState.initialBlankLine = !0, i++, m(p);
  }
  function h(p) {
    return ke(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), m) : n(p);
  }
  function m(p) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function WD(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Mi, s, i);
  function s(o) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Le(e, t, "listItemIndent", r.containerState.size + 1)(o);
  }
  function i(o) {
    return r.containerState.furtherBlankLines || !ke(o) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(o)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(YD, t, a)(o));
  }
  function a(o) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Le(e, e.attempt(Nt, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o);
  }
}
function qD(e, t, n) {
  const r = this;
  return Le(e, s, "listItemIndent", r.containerState.size + 1);
  function s(i) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function KD(e) {
  e.exit(this.containerState.type);
}
function QD(e, t, n) {
  const r = this;
  return Le(e, s, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function s(i) {
    const a = r.events[r.events.length - 1];
    return !ke(i) && a && a[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const $f = {
  name: "setextUnderline",
  resolveTo: XD,
  tokenize: JD
};
function XD(e, t) {
  let n = e.length, r, s, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (s = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const a = {
    type: "setextHeading",
    start: {
      ...e[r][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[s][1].type = "setextHeadingText", i ? (e.splice(s, 0, ["enter", a, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[i][1].end
  }) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function JD(e, t, n) {
  const r = this;
  let s;
  return i;
  function i(c) {
    let l = r.events.length, h;
    for (; l--; )
      if (r.events[l][1].type !== "lineEnding" && r.events[l][1].type !== "linePrefix" && r.events[l][1].type !== "content") {
        h = r.events[l][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || h) ? (e.enter("setextHeadingLine"), s = c, a(c)) : n(c);
  }
  function a(c) {
    return e.enter("setextHeadingLineSequence"), o(c);
  }
  function o(c) {
    return c === s ? (e.consume(c), o) : (e.exit("setextHeadingLineSequence"), ke(c) ? Le(e, u, "lineSuffix")(c) : u(c));
  }
  function u(c) {
    return c === null || me(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const ZD = {
  tokenize: eL
};
function eL(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Mi,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, s, Le(e, e.attempt(this.parser.constructs.flow, s, e.attempt(iD, s)), "linePrefix"))
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function s(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const tL = {
  resolveAll: t_()
}, nL = e_("string"), rL = e_("text");
function e_(e) {
  return {
    resolveAll: t_(e === "text" ? sL : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, s = this.parser.constructs[e], i = n.attempt(s, a, o);
    return a;
    function a(l) {
      return c(l) ? i(l) : o(l);
    }
    function o(l) {
      if (l === null) {
        n.consume(l);
        return;
      }
      return n.enter("data"), n.consume(l), u;
    }
    function u(l) {
      return c(l) ? (n.exit("data"), i(l)) : (n.consume(l), u);
    }
    function c(l) {
      if (l === null)
        return !0;
      const h = s[l];
      let m = -1;
      if (h)
        for (; ++m < h.length; ) {
          const p = h[m];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function t_(e) {
  return t;
  function t(n, r) {
    let s = -1, i;
    for (; ++s <= n.length; )
      i === void 0 ? n[s] && n[s][1].type === "data" && (i = s, s++) : (!n[s] || n[s][1].type !== "data") && (s !== i + 2 && (n[i][1].end = n[s - 1][1].end, n.splice(i + 2, s - i - 2), s = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function sL(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], s = t.sliceStream(r);
      let i = s.length, a = -1, o = 0, u;
      for (; i--; ) {
        const c = s[i];
        if (typeof c == "string") {
          for (a = c.length; c.charCodeAt(a - 1) === 32; )
            o++, a--;
          if (a) break;
          a = -1;
        } else if (c === -2)
          u = !0, o++;
        else if (c !== -1) {
          i++;
          break;
        }
      }
      if (t._contentTypeTextTrailing && n === e.length && (o = 0), o) {
        const c = {
          type: n === e.length || u || o < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: i ? a : r.start._bufferIndex + a,
            _index: r.start._index + i,
            line: r.end.line,
            column: r.end.column - o,
            offset: r.end.offset - o
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...c.start
        }, r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(n, 0, ["enter", c, t], ["exit", c, t]), n += 2);
      }
      n++;
    }
  return e;
}
const iL = {
  42: Nt,
  43: Nt,
  45: Nt,
  48: Nt,
  49: Nt,
  50: Nt,
  51: Nt,
  52: Nt,
  53: Nt,
  54: Nt,
  55: Nt,
  56: Nt,
  57: Nt,
  62: Wb
}, aL = {
  91: lD
}, oL = {
  [-2]: Du,
  [-1]: Du,
  32: Du
}, uL = {
  35: gD,
  42: xa,
  45: [$f, xa],
  60: TD,
  61: $f,
  95: xa,
  96: Ff,
  126: Ff
}, cL = {
  38: Kb,
  92: qb
}, lL = {
  [-5]: Lu,
  [-4]: Lu,
  [-3]: Lu,
  33: BD,
  38: Kb,
  42: Pc,
  60: [FO, ID],
  91: FD,
  92: [pD, qb],
  93: Zl,
  95: Pc,
  96: ZO
}, dL = {
  null: [Pc, tL]
}, hL = {
  null: [42, 95]
}, fL = {
  null: []
}, pL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: hL,
  contentInitial: aL,
  disable: fL,
  document: iL,
  flow: uL,
  flowInitial: oL,
  insideSpan: dL,
  string: cL,
  text: lL
}, Symbol.toStringTag, { value: "Module" }));
function mL(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const s = {}, i = [];
  let a = [], o = [];
  const u = {
    attempt: O(D),
    check: O(w),
    consume: T,
    enter: C,
    exit: R,
    interrupt: O(w, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: g,
    events: [],
    now: E,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: p,
    write: h
  };
  let l = t.tokenize.call(c, u);
  return t.resolveAll && i.push(t), c;
  function h(z) {
    return a = Yt(a, z), _(), a[a.length - 1] !== null ? [] : (U(t, 0), c.events = Fo(i, c.events, c), c.events);
  }
  function m(z, G) {
    return EL(p(z), G);
  }
  function p(z) {
    return gL(a, z);
  }
  function E() {
    const {
      _bufferIndex: z,
      _index: G,
      line: F,
      column: M,
      offset: H
    } = r;
    return {
      _bufferIndex: z,
      _index: G,
      line: F,
      column: M,
      offset: H
    };
  }
  function g(z) {
    s[z.line] = z.column, P();
  }
  function _() {
    let z;
    for (; r._index < a.length; ) {
      const G = a[r._index];
      if (typeof G == "string")
        for (z = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === z && r._bufferIndex < G.length; )
          b(G.charCodeAt(r._bufferIndex));
      else
        b(G);
    }
  }
  function b(z) {
    l = l(z);
  }
  function T(z) {
    me(z) ? (r.line++, r.column = 1, r.offset += z === -3 ? 2 : 1, P()) : z !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    a[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = z;
  }
  function C(z, G) {
    const F = G || {};
    return F.type = z, F.start = E(), c.events.push(["enter", F, c]), o.push(F), F;
  }
  function R(z) {
    const G = o.pop();
    return G.end = E(), c.events.push(["exit", G, c]), G;
  }
  function D(z, G) {
    U(z, G.from);
  }
  function w(z, G) {
    G.restore();
  }
  function O(z, G) {
    return F;
    function F(M, H, B) {
      let Y, $, Z, y;
      return Array.isArray(M) ? (
        /* c8 ignore next 1 */
        Ce(M)
      ) : "tokenize" in M ? (
        // Looks like a construct.
        Ce([
          /** @type {Construct} */
          M
        ])
      ) : fe(M);
      function fe(pe) {
        return re;
        function re(Ae) {
          const he = Ae !== null && pe[Ae], le = Ae !== null && pe.null, ye = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(he) ? he : he ? [he] : [],
            ...Array.isArray(le) ? le : le ? [le] : []
          ];
          return Ce(ye)(Ae);
        }
      }
      function Ce(pe) {
        return Y = pe, $ = 0, pe.length === 0 ? B : v(pe[$]);
      }
      function v(pe) {
        return re;
        function re(Ae) {
          return y = q(), Z = pe, pe.partial || (c.currentConstruct = pe), pe.name && c.parser.constructs.disable.null.includes(pe.name) ? Te() : pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            G ? Object.assign(Object.create(c), G) : c,
            u,
            Se,
            Te
          )(Ae);
        }
      }
      function Se(pe) {
        return z(Z, y), H;
      }
      function Te(pe) {
        return y.restore(), ++$ < Y.length ? v(Y[$]) : B;
      }
    }
  }
  function U(z, G) {
    z.resolveAll && !i.includes(z) && i.push(z), z.resolve && Ut(c.events, G, c.events.length - G, z.resolve(c.events.slice(G), c)), z.resolveTo && (c.events = z.resolveTo(c.events, c));
  }
  function q() {
    const z = E(), G = c.previous, F = c.currentConstruct, M = c.events.length, H = Array.from(o);
    return {
      from: M,
      restore: B
    };
    function B() {
      r = z, c.previous = G, c.currentConstruct = F, c.events.length = M, o = H, P();
    }
  }
  function P() {
    r.line in s && r.column < 2 && (r.column = s[r.line], r.offset += s[r.line] - 1);
  }
}
function gL(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, s = t.end._index, i = t.end._bufferIndex;
  let a;
  if (n === s)
    a = [e[n].slice(r, i)];
  else {
    if (a = e.slice(n, s), r > -1) {
      const o = a[0];
      typeof o == "string" ? a[0] = o.slice(r) : a.shift();
    }
    i > 0 && a.push(e[s].slice(0, i));
  }
  return a;
}
function EL(e, t) {
  let n = -1;
  const r = [];
  let s;
  for (; ++n < e.length; ) {
    const i = e[n];
    let a;
    if (typeof i == "string")
      a = i;
    else switch (i) {
      case -5: {
        a = "\r";
        break;
      }
      case -4: {
        a = `
`;
        break;
      }
      case -3: {
        a = `\r
`;
        break;
      }
      case -2: {
        a = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && s) continue;
        a = " ";
        break;
      }
      default:
        a = String.fromCharCode(i);
    }
    s = i === -2, r.push(a);
  }
  return r.join("");
}
function bL(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Yb([pL, ...(e || {}).extensions || []])
    ),
    content: s(OO),
    defined: [],
    document: s(LO),
    flow: s(ZD),
    lazy: {},
    string: s(nL),
    text: s(rL)
  };
  return r;
  function s(i) {
    return a;
    function a(o) {
      return mL(r, i, o);
    }
  }
}
function _L(e) {
  for (; !Qb(e); )
    ;
  return e;
}
const zf = /[\0\t\n\r]/g;
function TL() {
  let e = 1, t = "", n = !0, r;
  return s;
  function s(i, a, o) {
    const u = [];
    let c, l, h, m, p;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(a || void 0).decode(i)), h = 0, t = "", n && (i.charCodeAt(0) === 65279 && h++, n = void 0); h < i.length; ) {
      if (zf.lastIndex = h, c = zf.exec(i), m = c && c.index !== void 0 ? c.index : i.length, p = i.charCodeAt(m), !c) {
        t = i.slice(h);
        break;
      }
      if (p === 10 && h === m && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), h < m && (u.push(i.slice(h, m)), e += m - h), p) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (l = Math.ceil(e / 4) * 4, u.push(-2); e++ < l; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      h = m + 1;
    }
    return o && (r && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const AL = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function yL(e) {
  return e.replace(AL, xL);
}
function xL(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const s = n.charCodeAt(1), i = s === 120 || s === 88;
    return Gb(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return Jl(n) || e;
}
const n_ = {}.hasOwnProperty;
function CL(e, t, n) {
  return t && typeof t == "object" && (n = t, t = void 0), SL(n)(_L(bL(n).document().write(TL()(e, t, !0))));
}
function SL(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(fr),
      autolinkProtocol: q,
      autolinkEmail: q,
      atxHeading: i(Xt),
      blockQuote: i(le),
      characterEscape: q,
      characterReference: q,
      codeFenced: i(ye),
      codeFencedFenceInfo: a,
      codeFencedFenceMeta: a,
      codeIndented: i(ye, a),
      codeText: i(Pe, a),
      codeTextData: q,
      data: q,
      codeFlowValue: q,
      definition: i(qe),
      definitionDestinationString: a,
      definitionLabelString: a,
      definitionTitleString: a,
      emphasis: i(gt),
      hardBreakEscape: i(zt),
      hardBreakTrailing: i(zt),
      htmlFlow: i(Sn, a),
      htmlFlowData: q,
      htmlText: i(Sn, a),
      htmlTextData: q,
      image: i(Fi),
      label: a,
      link: i(fr),
      listItem: i(Ko),
      listItemValue: m,
      listOrdered: i(ji, h),
      listUnordered: i(ji),
      paragraph: i(ks),
      reference: v,
      referenceString: a,
      resourceDestinationString: a,
      resourceTitleString: a,
      setextHeading: i(Xt),
      strong: i(Qo),
      thematicBreak: i($i)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: D,
      autolink: u(),
      autolinkEmail: he,
      autolinkProtocol: Ae,
      blockQuote: u(),
      characterEscapeValue: P,
      characterReferenceMarkerHexadecimal: Te,
      characterReferenceMarkerNumeric: Te,
      characterReferenceValue: pe,
      characterReference: re,
      codeFenced: u(_),
      codeFencedFence: g,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: E,
      codeFlowValue: P,
      codeIndented: u(b),
      codeText: u(H),
      codeTextData: P,
      data: P,
      definition: u(),
      definitionDestinationString: R,
      definitionLabelString: T,
      definitionTitleString: C,
      emphasis: u(),
      hardBreakEscape: u(G),
      hardBreakTrailing: u(G),
      htmlFlow: u(F),
      htmlFlowData: P,
      htmlText: u(M),
      htmlTextData: P,
      image: u(Y),
      label: Z,
      labelText: $,
      lineEnding: z,
      link: u(B),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Se,
      resourceDestinationString: y,
      resourceTitleString: fe,
      resource: Ce,
      setextHeading: u(U),
      setextHeadingLineSequence: O,
      setextHeadingText: w,
      strong: u(),
      thematicBreak: u()
    }
  };
  r_(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(V) {
    let ee = {
      type: "root",
      children: []
    };
    const xe = {
      stack: [ee],
      tokenStack: [],
      config: t,
      enter: o,
      exit: c,
      buffer: a,
      resume: l,
      data: n
    }, ve = [];
    let je = -1;
    for (; ++je < V.length; )
      if (V[je][1].type === "listOrdered" || V[je][1].type === "listUnordered")
        if (V[je][0] === "enter")
          ve.push(je);
        else {
          const Ot = ve.pop();
          je = s(V, Ot, je);
        }
    for (je = -1; ++je < V.length; ) {
      const Ot = t[V[je][0]];
      n_.call(Ot, V[je][1].type) && Ot[V[je][1].type].call(Object.assign({
        sliceSerialize: V[je][2].sliceSerialize
      }, xe), V[je][1]);
    }
    if (xe.tokenStack.length > 0) {
      const Ot = xe.tokenStack[xe.tokenStack.length - 1];
      (Ot[1] || Vf).call(xe, void 0, Ot[0]);
    }
    for (ee.position = {
      start: Vn(V.length > 0 ? V[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Vn(V.length > 0 ? V[V.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, je = -1; ++je < t.transforms.length; )
      ee = t.transforms[je](ee) || ee;
    return ee;
  }
  function s(V, ee, xe) {
    let ve = ee - 1, je = -1, Ot = !1, wn, Jt, pr, mr;
    for (; ++ve <= xe; ) {
      const xt = V[ve];
      switch (xt[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          xt[0] === "enter" ? je++ : je--, mr = void 0;
          break;
        }
        case "lineEndingBlank": {
          xt[0] === "enter" && (wn && !mr && !je && !pr && (pr = ve), mr = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          mr = void 0;
      }
      if (!je && xt[0] === "enter" && xt[1].type === "listItemPrefix" || je === -1 && xt[0] === "exit" && (xt[1].type === "listUnordered" || xt[1].type === "listOrdered")) {
        if (wn) {
          let jn = ve;
          for (Jt = void 0; jn--; ) {
            const Dt = V[jn];
            if (Dt[1].type === "lineEnding" || Dt[1].type === "lineEndingBlank") {
              if (Dt[0] === "exit") continue;
              Jt && (V[Jt][1].type = "lineEndingBlank", Ot = !0), Dt[1].type = "lineEnding", Jt = jn;
            } else if (!(Dt[1].type === "linePrefix" || Dt[1].type === "blockQuotePrefix" || Dt[1].type === "blockQuotePrefixWhitespace" || Dt[1].type === "blockQuoteMarker" || Dt[1].type === "listItemIndent")) break;
          }
          pr && (!Jt || pr < Jt) && (wn._spread = !0), wn.end = Object.assign({}, Jt ? V[Jt][1].start : xt[1].end), V.splice(Jt || ve, 0, ["exit", wn, xt[2]]), ve++, xe++;
        }
        if (xt[1].type === "listItemPrefix") {
          const jn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, xt[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          wn = jn, V.splice(ve, 0, ["enter", jn, xt[2]]), ve++, xe++, pr = void 0, mr = !0;
        }
      }
    }
    return V[ee][1]._spread = Ot, xe;
  }
  function i(V, ee) {
    return xe;
    function xe(ve) {
      o.call(this, V(ve), ve), ee && ee.call(this, ve);
    }
  }
  function a() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function o(V, ee, xe) {
    this.stack[this.stack.length - 1].children.push(V), this.stack.push(V), this.tokenStack.push([ee, xe || void 0]), V.position = {
      start: Vn(ee.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(V) {
    return ee;
    function ee(xe) {
      V && V.call(this, xe), c.call(this, xe);
    }
  }
  function c(V, ee) {
    const xe = this.stack.pop(), ve = this.tokenStack.pop();
    if (ve)
      ve[0].type !== V.type && (ee ? ee.call(this, V, ve[0]) : (ve[1] || Vf).call(this, V, ve[0]));
    else throw new Error("Cannot close `" + V.type + "` (" + ni({
      start: V.start,
      end: V.end
    }) + "): it’s not open");
    xe.position.end = Vn(V.end);
  }
  function l() {
    return Xl(this.stack.pop());
  }
  function h() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(V) {
    if (this.data.expectingFirstListItemValue) {
      const ee = this.stack[this.stack.length - 2];
      ee.start = Number.parseInt(this.sliceSerialize(V), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.lang = V;
  }
  function E() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.meta = V;
  }
  function g() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function _() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V.replace(/(\r?\n|\r)$/g, "");
  }
  function T(V) {
    const ee = this.resume(), xe = this.stack[this.stack.length - 1];
    xe.label = ee, xe.identifier = an(this.sliceSerialize(V)).toLowerCase();
  }
  function C() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.title = V;
  }
  function R() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.url = V;
  }
  function D(V) {
    const ee = this.stack[this.stack.length - 1];
    if (!ee.depth) {
      const xe = this.sliceSerialize(V).length;
      ee.depth = xe;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(V) {
    const ee = this.stack[this.stack.length - 1];
    ee.depth = this.sliceSerialize(V).codePointAt(0) === 61 ? 1 : 2;
  }
  function U() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function q(V) {
    const xe = this.stack[this.stack.length - 1].children;
    let ve = xe[xe.length - 1];
    (!ve || ve.type !== "text") && (ve = Xo(), ve.position = {
      start: Vn(V.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, xe.push(ve)), this.stack.push(ve);
  }
  function P(V) {
    const ee = this.stack.pop();
    ee.value += this.sliceSerialize(V), ee.position.end = Vn(V.end);
  }
  function z(V) {
    const ee = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const xe = ee.children[ee.children.length - 1];
      xe.position.end = Vn(V.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(ee.type) && (q.call(this, V), P.call(this, V));
  }
  function G() {
    this.data.atHardBreak = !0;
  }
  function F() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V;
  }
  function M() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V;
  }
  function H() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.value = V;
  }
  function B() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ee = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = ee, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function Y() {
    const V = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const ee = this.data.referenceType || "shortcut";
      V.type += "Reference", V.referenceType = ee, delete V.url, delete V.title;
    } else
      delete V.identifier, delete V.label;
    this.data.referenceType = void 0;
  }
  function $(V) {
    const ee = this.sliceSerialize(V), xe = this.stack[this.stack.length - 2];
    xe.label = yL(ee), xe.identifier = an(ee).toLowerCase();
  }
  function Z() {
    const V = this.stack[this.stack.length - 1], ee = this.resume(), xe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, xe.type === "link") {
      const ve = V.children;
      xe.children = ve;
    } else
      xe.alt = ee;
  }
  function y() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.url = V;
  }
  function fe() {
    const V = this.resume(), ee = this.stack[this.stack.length - 1];
    ee.title = V;
  }
  function Ce() {
    this.data.inReference = void 0;
  }
  function v() {
    this.data.referenceType = "collapsed";
  }
  function Se(V) {
    const ee = this.resume(), xe = this.stack[this.stack.length - 1];
    xe.label = ee, xe.identifier = an(this.sliceSerialize(V)).toLowerCase(), this.data.referenceType = "full";
  }
  function Te(V) {
    this.data.characterReferenceType = V.type;
  }
  function pe(V) {
    const ee = this.sliceSerialize(V), xe = this.data.characterReferenceType;
    let ve;
    xe ? (ve = Gb(ee, xe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ve = Jl(ee);
    const je = this.stack[this.stack.length - 1];
    je.value += ve;
  }
  function re(V) {
    const ee = this.stack.pop();
    ee.position.end = Vn(V.end);
  }
  function Ae(V) {
    P.call(this, V);
    const ee = this.stack[this.stack.length - 1];
    ee.url = this.sliceSerialize(V);
  }
  function he(V) {
    P.call(this, V);
    const ee = this.stack[this.stack.length - 1];
    ee.url = "mailto:" + this.sliceSerialize(V);
  }
  function le() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function ye() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Pe() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function qe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function gt() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Xt() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function zt() {
    return {
      type: "break"
    };
  }
  function Sn() {
    return {
      type: "html",
      value: ""
    };
  }
  function Fi() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function fr() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ji(V) {
    return {
      type: "list",
      ordered: V.type === "listOrdered",
      start: null,
      spread: V._spread,
      children: []
    };
  }
  function Ko(V) {
    return {
      type: "listItem",
      spread: V._spread,
      checked: null,
      children: []
    };
  }
  function ks() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Qo() {
    return {
      type: "strong",
      children: []
    };
  }
  function Xo() {
    return {
      type: "text",
      value: ""
    };
  }
  function $i() {
    return {
      type: "thematicBreak"
    };
  }
}
function Vn(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function r_(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? r_(e, r) : wL(e, r);
  }
}
function wL(e, t) {
  let n;
  for (n in t)
    if (n_.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Vf(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + ni({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + ni({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + ni({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function IL(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return CL(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function vL(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function NL(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function kL(e, t) {
  const n = t.value ? t.value + `
` : "", r = {}, s = t.lang ? t.lang.split(/\s+/) : [];
  s.length > 0 && (r.className = ["language-" + s[0]]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function RL(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function PL(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function OL(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), s = Ss(r.toLowerCase()), i = e.footnoteOrder.indexOf(r);
  let a, o = e.footnoteCounts.get(r);
  o === void 0 ? (o = 0, e.footnoteOrder.push(r), a = e.footnoteOrder.length) : a = i + 1, o += 1, e.footnoteCounts.set(r, o);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + s,
      id: n + "fnref-" + s + (o > 1 ? "-" + o : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(a) }]
  };
  e.patch(t, u);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function DL(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function LL(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function s_(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const s = e.all(t), i = s[0];
  i && i.type === "text" ? i.value = "[" + i.value : s.unshift({ type: "text", value: "[" });
  const a = s[s.length - 1];
  return a && a.type === "text" ? a.value += r : s.push({ type: "text", value: r }), s;
}
function ML(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return s_(e, t);
  const s = { src: Ss(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (s.title = r.title);
  const i = { type: "element", tagName: "img", properties: s, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function HL(e, t) {
  const n = { src: Ss(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function BL(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function UL(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return s_(e, t);
  const s = { href: Ss(r.url || "") };
  r.title !== null && r.title !== void 0 && (s.title = r.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: s,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function FL(e, t) {
  const n = { href: Ss(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function jL(e, t, n) {
  const r = e.all(t), s = n ? $L(n) : i_(t), i = {}, a = [];
  if (typeof t.checked == "boolean") {
    const l = r[0];
    let h;
    l && l.type === "element" && l.tagName === "p" ? h = l : (h = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(h)), h.children.length > 0 && h.children.unshift({ type: "text", value: " " }), h.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let o = -1;
  for (; ++o < r.length; ) {
    const l = r[o];
    (s || o !== 0 || l.type !== "element" || l.tagName !== "p") && a.push({ type: "text", value: `
` }), l.type === "element" && l.tagName === "p" && !s ? a.push(...l.children) : a.push(l);
  }
  const u = r[r.length - 1];
  u && (s || u.type !== "element" || u.tagName !== "p") && a.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: i, children: a };
  return e.patch(t, c), e.applyData(t, c);
}
function $L(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = i_(n[r]);
  }
  return t;
}
function i_(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function zL(e, t) {
  const n = {}, r = e.all(t);
  let s = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++s < r.length; ) {
    const a = r[s];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function VL(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function YL(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function GL(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function WL(e, t) {
  const n = e.all(t), r = n.shift(), s = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), s.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, o = xn(t.children[1]), u = Bo(t.children[t.children.length - 1]);
    o && u && (a.position = { start: o, end: u }), s.push(a);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(s, !0)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function qL(e, t, n) {
  const r = n ? n.children : void 0, i = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, o = a ? a.length : t.children.length;
  let u = -1;
  const c = [];
  for (; ++u < o; ) {
    const h = t.children[u], m = {}, p = a ? a[u] : void 0;
    p && (m.align = p);
    let E = { type: "element", tagName: i, properties: m, children: [] };
    h && (E.children = e.all(h), e.patch(h, E), E = e.applyData(h, E)), c.push(E);
  }
  const l = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, l), e.applyData(t, l);
}
function KL(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Yf = 9, Gf = 32;
function QL(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), s = 0;
  const i = [];
  for (; r; )
    i.push(
      Wf(t.slice(s, r.index), s > 0, !0),
      r[0]
    ), s = r.index + r[0].length, r = n.exec(t);
  return i.push(Wf(t.slice(s), s > 0, !1)), i.join("");
}
function Wf(e, t, n) {
  let r = 0, s = e.length;
  if (t) {
    let i = e.codePointAt(r);
    for (; i === Yf || i === Gf; )
      r++, i = e.codePointAt(r);
  }
  if (n) {
    let i = e.codePointAt(s - 1);
    for (; i === Yf || i === Gf; )
      s--, i = e.codePointAt(s - 1);
  }
  return s > r ? e.slice(r, s) : "";
}
function XL(e, t) {
  const n = { type: "text", value: QL(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function JL(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const ZL = {
  blockquote: vL,
  break: NL,
  code: kL,
  delete: RL,
  emphasis: PL,
  footnoteReference: OL,
  heading: DL,
  html: LL,
  imageReference: ML,
  image: HL,
  inlineCode: BL,
  linkReference: UL,
  link: FL,
  listItem: jL,
  list: zL,
  paragraph: VL,
  // @ts-expect-error: root is different, but hard to type.
  root: YL,
  strong: GL,
  table: WL,
  tableCell: KL,
  tableRow: qL,
  text: XL,
  thematicBreak: JL,
  toml: ca,
  yaml: ca,
  definition: ca,
  footnoteDefinition: ca
};
function ca() {
}
const a_ = -1, jo = 0, si = 1, Qa = 2, ed = 3, td = 4, nd = 5, rd = 6, o_ = 7, u_ = 8, qf = typeof self == "object" ? self : globalThis, eM = (e, t) => {
  const n = (s, i) => (e.set(i, s), s), r = (s) => {
    if (e.has(s))
      return e.get(s);
    const [i, a] = t[s];
    switch (i) {
      case jo:
      case a_:
        return n(a, s);
      case si: {
        const o = n([], s);
        for (const u of a)
          o.push(r(u));
        return o;
      }
      case Qa: {
        const o = n({}, s);
        for (const [u, c] of a)
          o[r(u)] = r(c);
        return o;
      }
      case ed:
        return n(new Date(a), s);
      case td: {
        const { source: o, flags: u } = a;
        return n(new RegExp(o, u), s);
      }
      case nd: {
        const o = n(/* @__PURE__ */ new Map(), s);
        for (const [u, c] of a)
          o.set(r(u), r(c));
        return o;
      }
      case rd: {
        const o = n(/* @__PURE__ */ new Set(), s);
        for (const u of a)
          o.add(r(u));
        return o;
      }
      case o_: {
        const { name: o, message: u } = a;
        return n(new qf[o](u), s);
      }
      case u_:
        return n(BigInt(a), s);
      case "BigInt":
        return n(Object(BigInt(a)), s);
      case "ArrayBuffer":
        return n(new Uint8Array(a).buffer, a);
      case "DataView": {
        const { buffer: o } = new Uint8Array(a);
        return n(new DataView(o), a);
      }
    }
    return n(new qf[i](a), s);
  };
  return r;
}, Kf = (e) => eM(/* @__PURE__ */ new Map(), e)(0), Jr = "", { toString: tM } = {}, { keys: nM } = Object, zs = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [jo, t];
  const n = tM.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [si, Jr];
    case "Object":
      return [Qa, Jr];
    case "Date":
      return [ed, Jr];
    case "RegExp":
      return [td, Jr];
    case "Map":
      return [nd, Jr];
    case "Set":
      return [rd, Jr];
    case "DataView":
      return [si, n];
  }
  return n.includes("Array") ? [si, n] : n.includes("Error") ? [o_, n] : [Qa, n];
}, la = ([e, t]) => e === jo && (t === "function" || t === "symbol"), rM = (e, t, n, r) => {
  const s = (a, o) => {
    const u = r.push(a) - 1;
    return n.set(o, u), u;
  }, i = (a) => {
    if (n.has(a))
      return n.get(a);
    let [o, u] = zs(a);
    switch (o) {
      case jo: {
        let l = a;
        switch (u) {
          case "bigint":
            o = u_, l = a.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            l = null;
            break;
          case "undefined":
            return s([a_], a);
        }
        return s([o, l], a);
      }
      case si: {
        if (u) {
          let m = a;
          return u === "DataView" ? m = new Uint8Array(a.buffer) : u === "ArrayBuffer" && (m = new Uint8Array(a)), s([u, [...m]], a);
        }
        const l = [], h = s([o, l], a);
        for (const m of a)
          l.push(i(m));
        return h;
      }
      case Qa: {
        if (u)
          switch (u) {
            case "BigInt":
              return s([u, a.toString()], a);
            case "Boolean":
            case "Number":
            case "String":
              return s([u, a.valueOf()], a);
          }
        if (t && "toJSON" in a)
          return i(a.toJSON());
        const l = [], h = s([o, l], a);
        for (const m of nM(a))
          (e || !la(zs(a[m]))) && l.push([i(m), i(a[m])]);
        return h;
      }
      case ed:
        return s([o, a.toISOString()], a);
      case td: {
        const { source: l, flags: h } = a;
        return s([o, { source: l, flags: h }], a);
      }
      case nd: {
        const l = [], h = s([o, l], a);
        for (const [m, p] of a)
          (e || !(la(zs(m)) || la(zs(p)))) && l.push([i(m), i(p)]);
        return h;
      }
      case rd: {
        const l = [], h = s([o, l], a);
        for (const m of a)
          (e || !la(zs(m))) && l.push(i(m));
        return h;
      }
    }
    const { message: c } = a;
    return s([o, { name: u, message: c }], a);
  };
  return i;
}, Qf = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return rM(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, ms = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Kf(Qf(e, t)) : structuredClone(e)
) : (e, t) => Kf(Qf(e, t));
function sM(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function iM(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function aM(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || sM, r = e.options.footnoteBackLabel || iM, s = e.options.footnoteLabel || "Footnotes", i = e.options.footnoteLabelTagName || "h2", a = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, o = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!c)
      continue;
    const l = e.all(c), h = String(c.identifier).toUpperCase(), m = Ss(h.toLowerCase());
    let p = 0;
    const E = [], g = e.footnoteCounts.get(h);
    for (; g !== void 0 && ++p <= g; ) {
      E.length > 0 && E.push({ type: "text", value: " " });
      let T = typeof n == "string" ? n : n(u, p);
      typeof T == "string" && (T = { type: "text", value: T }), E.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + m + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(T) ? T : [T]
      });
    }
    const _ = l[l.length - 1];
    if (_ && _.type === "element" && _.tagName === "p") {
      const T = _.children[_.children.length - 1];
      T && T.type === "text" ? T.value += " " : _.children.push({ type: "text", value: " " }), _.children.push(...E);
    } else
      l.push(...E);
    const b = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + m },
      children: e.wrap(l, !0)
    };
    e.patch(c, b), o.push(b);
  }
  if (o.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...ms(a),
            id: "footnote-label"
          },
          children: [{ type: "text", value: s }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(o, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const $o = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return lM;
    if (typeof e == "function")
      return zo(e);
    if (typeof e == "object")
      return Array.isArray(e) ? oM(e) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        uM(
          /** @type {Props} */
          e
        )
      );
    if (typeof e == "string")
      return cM(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function oM(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = $o(e[n]);
  return zo(r);
  function r(...s) {
    let i = -1;
    for (; ++i < t.length; )
      if (t[i].apply(this, s)) return !0;
    return !1;
  }
}
function uM(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return zo(n);
  function n(r) {
    const s = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let i;
    for (i in e)
      if (s[i] !== t[i]) return !1;
    return !0;
  }
}
function cM(e) {
  return zo(t);
  function t(n) {
    return n && n.type === e;
  }
}
function zo(e) {
  return t;
  function t(n, r, s) {
    return !!(dM(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      s || void 0
    ));
  }
}
function lM() {
  return !0;
}
function dM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const c_ = [], hM = !0, Oc = !1, fM = "skip";
function l_(e, t, n, r) {
  let s;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : s = t;
  const i = $o(s), a = r ? -1 : 1;
  o(e, void 0, [])();
  function o(u, c, l) {
    const h = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof h.type == "string") {
      const p = (
        // `hast`
        typeof h.tagName == "string" ? h.tagName : (
          // `xast`
          typeof h.name == "string" ? h.name : void 0
        )
      );
      Object.defineProperty(m, "name", {
        value: "node (" + (u.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return m;
    function m() {
      let p = c_, E, g, _;
      if ((!t || i(u, c, l[l.length - 1] || void 0)) && (p = pM(n(u, l)), p[0] === Oc))
        return p;
      if ("children" in u && u.children) {
        const b = (
          /** @type {UnistParent} */
          u
        );
        if (b.children && p[0] !== fM)
          for (g = (r ? b.children.length : -1) + a, _ = l.concat(b); g > -1 && g < b.children.length; ) {
            const T = b.children[g];
            if (E = o(T, g, _)(), E[0] === Oc)
              return E;
            g = typeof E[1] == "number" ? E[1] : g + a;
          }
      }
      return p;
    }
  }
}
function pM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [hM, e] : e == null ? c_ : [e];
}
function Vo(e, t, n, r) {
  let s, i, a;
  typeof t == "function" && typeof n != "function" ? (i = void 0, a = t, s = n) : (i = t, a = n, s = r), l_(e, i, o, s);
  function o(u, c) {
    const l = c[c.length - 1], h = l ? l.children.indexOf(u) : void 0;
    return a(u, h, l);
  }
}
const Dc = {}.hasOwnProperty, mM = {};
function gM(e, t) {
  const n = t || mM, r = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = { ...ZL, ...n.handlers }, o = {
    all: c,
    applyData: bM,
    definitionById: r,
    footnoteById: s,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: a,
    one: u,
    options: n,
    patch: EM,
    wrap: TM
  };
  return Vo(e, function(l) {
    if (l.type === "definition" || l.type === "footnoteDefinition") {
      const h = l.type === "definition" ? r : s, m = String(l.identifier).toUpperCase();
      h.has(m) || h.set(m, l);
    }
  }), o;
  function u(l, h) {
    const m = l.type, p = o.handlers[m];
    if (Dc.call(o.handlers, m) && p)
      return p(o, l, h);
    if (o.options.passThrough && o.options.passThrough.includes(m)) {
      if ("children" in l) {
        const { children: g, ..._ } = l, b = ms(_);
        return b.children = o.all(l), b;
      }
      return ms(l);
    }
    return (o.options.unknownHandler || _M)(o, l, h);
  }
  function c(l) {
    const h = [];
    if ("children" in l) {
      const m = l.children;
      let p = -1;
      for (; ++p < m.length; ) {
        const E = o.one(m[p], l);
        if (E) {
          if (p && m[p - 1].type === "break" && (!Array.isArray(E) && E.type === "text" && (E.value = Xf(E.value)), !Array.isArray(E) && E.type === "element")) {
            const g = E.children[0];
            g && g.type === "text" && (g.value = Xf(g.value));
          }
          Array.isArray(E) ? h.push(...E) : h.push(E);
        }
      }
    }
    return h;
  }
}
function EM(e, t) {
  e.position && (t.position = iO(e));
}
function bM(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, s = e.data.hChildren, i = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const a = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: a };
      }
    n.type === "element" && i && Object.assign(n.properties, ms(i)), "children" in n && n.children && s !== null && s !== void 0 && (n.children = s);
  }
  return n;
}
function _M(e, t) {
  const n = t.data || {}, r = "value" in t && !(Dc.call(n, "hProperties") || Dc.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function TM(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Xf(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Jf(e, t) {
  const n = gM(e, t), r = n.one(e, void 0), s = aM(n), i = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return s && i.children.push({ type: "text", value: `
` }, s), i;
}
function AM(e, t) {
  return e && "run" in e ? async function(n, r) {
    const s = (
      /** @type {HastRoot} */
      Jf(n, { file: r, ...t })
    );
    await e.run(s, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Jf(n, { file: r, ...e || t })
    );
  };
}
function Zf(e) {
  if (e)
    throw e;
}
var Mu, ep;
function yM() {
  if (ep) return Mu;
  ep = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, s = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : t.call(c) === "[object Array]";
  }, i = function(c) {
    if (!c || t.call(c) !== "[object Object]")
      return !1;
    var l = e.call(c, "constructor"), h = c.constructor && c.constructor.prototype && e.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !l && !h)
      return !1;
    var m;
    for (m in c)
      ;
    return typeof m > "u" || e.call(c, m);
  }, a = function(c, l) {
    n && l.name === "__proto__" ? n(c, l.name, {
      enumerable: !0,
      configurable: !0,
      value: l.newValue,
      writable: !0
    }) : c[l.name] = l.newValue;
  }, o = function(c, l) {
    if (l === "__proto__")
      if (e.call(c, l)) {
        if (r)
          return r(c, l).value;
      } else return;
    return c[l];
  };
  return Mu = function u() {
    var c, l, h, m, p, E, g = arguments[0], _ = 1, b = arguments.length, T = !1;
    for (typeof g == "boolean" && (T = g, g = arguments[1] || {}, _ = 2), (g == null || typeof g != "object" && typeof g != "function") && (g = {}); _ < b; ++_)
      if (c = arguments[_], c != null)
        for (l in c)
          h = o(g, l), m = o(c, l), g !== m && (T && m && (i(m) || (p = s(m))) ? (p ? (p = !1, E = h && s(h) ? h : []) : E = h && i(h) ? h : {}, a(g, { name: l, newValue: u(T, E, m) })) : typeof m < "u" && a(g, { name: l, newValue: m }));
    return g;
  }, Mu;
}
var xM = yM();
const Hu = /* @__PURE__ */ Dr(xM);
function Lc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function CM() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...s) {
    let i = -1;
    const a = s.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    o(null, ...s);
    function o(u, ...c) {
      const l = e[++i];
      let h = -1;
      if (u) {
        a(u);
        return;
      }
      for (; ++h < s.length; )
        (c[h] === null || c[h] === void 0) && (c[h] = s[h]);
      s = c, l ? SM(l, o)(...c) : a(null, ...c);
    }
  }
  function r(s) {
    if (typeof s != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + s
      );
    return e.push(s), t;
  }
}
function SM(e, t) {
  let n;
  return r;
  function r(...a) {
    const o = e.length > a.length;
    let u;
    o && a.push(s);
    try {
      u = e.apply(this, a);
    } catch (c) {
      const l = (
        /** @type {Error} */
        c
      );
      if (o && n)
        throw l;
      return s(l);
    }
    o || (u && u.then && typeof u.then == "function" ? u.then(i, s) : u instanceof Error ? s(u) : i(u));
  }
  function s(a, ...o) {
    n || (n = !0, t(a, ...o));
  }
  function i(a) {
    s(null, a);
  }
}
const pn = { basename: wM, dirname: IM, extname: vM, join: NM, sep: "/" };
function wM(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Hi(e);
  let n = 0, r = -1, s = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; s--; )
      if (e.codePointAt(s) === 47) {
        if (i) {
          n = s + 1;
          break;
        }
      } else r < 0 && (i = !0, r = s + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, o = t.length - 1;
  for (; s--; )
    if (e.codePointAt(s) === 47) {
      if (i) {
        n = s + 1;
        break;
      }
    } else
      a < 0 && (i = !0, a = s + 1), o > -1 && (e.codePointAt(s) === t.codePointAt(o--) ? o < 0 && (r = s) : (o = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function IM(e) {
  if (Hi(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function vM(e) {
  Hi(e);
  let t = e.length, n = -1, r = 0, s = -1, i = 0, a;
  for (; t--; ) {
    const o = e.codePointAt(t);
    if (o === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), o === 46 ? s < 0 ? s = t : i !== 1 && (i = 1) : s > -1 && (i = -1);
  }
  return s < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && s === n - 1 && s === r + 1 ? "" : e.slice(s, n);
}
function NM(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Hi(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : kM(n);
}
function kM(e) {
  Hi(e);
  const t = e.codePointAt(0) === 47;
  let n = RM(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function RM(e, t) {
  let n = "", r = 0, s = -1, i = 0, a = -1, o, u;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      o = e.codePointAt(a);
    else {
      if (o === 47)
        break;
      o = 47;
    }
    if (o === 47) {
      if (!(s === a - 1 || i === 1)) if (s !== a - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), s = a, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, s = a, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(s + 1, a) : n = e.slice(s + 1, a), r = a - s - 1;
      s = a, i = 0;
    } else o === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function Hi(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const PM = { cwd: OM };
function OM() {
  return "/";
}
function Mc(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function DM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Mc(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return LM(e);
}
function LM(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const s = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw s.code = "ERR_INVALID_FILE_URL_PATH", s;
      }
    }
  return decodeURIComponent(t);
}
const Bu = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class d_ {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Mc(t) ? n = { path: t } : typeof t == "string" || MM(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : PM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < Bu.length; ) {
      const i = Bu[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let s;
    for (s in n)
      Bu.includes(s) || (this[s] = n[s]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? pn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Fu(t, "basename"), Uu(t, "basename"), this.path = pn.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? pn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    tp(this.basename, "dirname"), this.path = pn.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? pn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (Uu(t, "extname"), tp(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = pn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Mc(t) && (t = DM(t)), Fu(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? pn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Fu(t, "stem"), Uu(t, "stem"), this.path = pn.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const s = this.message(t, n, r);
    throw s.fatal = !0, s;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const s = this.message(t, n, r);
    return s.fatal = void 0, s;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const s = new At(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (s.name = this.path + ":" + s.name, s.file = this.path), s.fatal = !1, this.messages.push(s), s;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function Uu(e, t) {
  if (e && e.includes(pn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + pn.sep + "`"
    );
}
function Fu(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function tp(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function MM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const HM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), s = r[e], i = function() {
      return s.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, r), i;
  })
), BM = {}.hasOwnProperty;
class sd extends HM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = CM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new sd()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Hu(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (zu("data", this.frozen), this.namespace[t] = n, this) : BM.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (zu("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const s = n.call(t, ...r);
      typeof s == "function" && this.transformers.use(s);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = da(t), r = this.parser || this.Parser;
    return ju("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), ju("process", this.parser || this.Parser), $u("process", this.compiler || this.Compiler), n ? s(void 0, n) : new Promise(s);
    function s(i, a) {
      const o = da(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(o)
      );
      r.run(u, o, function(l, h, m) {
        if (l || !h || !m)
          return c(l);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          h
        ), E = r.stringify(p, m);
        jM(E) ? m.value = E : m.result = E, c(
          l,
          /** @type {VFileWithOutput<CompileResult>} */
          m
        );
      });
      function c(l, h) {
        l || !h ? a(l) : i ? i(h) : n(void 0, h);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), ju("processSync", this.parser || this.Parser), $u("processSync", this.compiler || this.Compiler), this.process(t, s), rp("processSync", "process", n), r;
    function s(i, a) {
      n = !0, Zf(i), r = a;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    np(t), this.freeze();
    const s = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? i(void 0, r) : new Promise(i);
    function i(a, o) {
      const u = da(n);
      s.run(t, u, c);
      function c(l, h, m) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          h || t
        );
        l ? o(l) : a ? a(p) : r(void 0, p, m);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, s;
    return this.run(t, n, i), rp("runSync", "run", r), s;
    function i(a, o) {
      Zf(a), s = o, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = da(n), s = this.compiler || this.Compiler;
    return $u("stringify", s), np(t), s(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, s = this.namespace;
    if (zu("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? o(t) : a(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function i(c) {
      if (typeof c == "function")
        u(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [l, ...h] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          u(l, h);
        } else
          a(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function a(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      o(c.plugins), c.settings && (s.settings = Hu(!0, s.settings, c.settings));
    }
    function o(c) {
      let l = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++l < c.length; ) {
          const h = c[l];
          i(h);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function u(c, l) {
      let h = -1, m = -1;
      for (; ++h < r.length; )
        if (r[h][0] === c) {
          m = h;
          break;
        }
      if (m === -1)
        r.push([c, ...l]);
      else if (l.length > 0) {
        let [p, ...E] = l;
        const g = r[m][1];
        Lc(g) && Lc(p) && (p = Hu(!0, g, p)), r[m] = [c, p, ...E];
      }
    }
  }
}
const UM = new sd().freeze();
function ju(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function $u(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function zu(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function np(e) {
  if (!Lc(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function rp(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function da(e) {
  return FM(e) ? e : new d_(e);
}
function FM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function jM(e) {
  return typeof e == "string" || $M(e);
}
function $M(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const zM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", sp = [], ip = { allowDangerousHtml: !0 }, VM = /^(https?|ircs?|mailto|xmpp)$/i, YM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function h_(e) {
  const t = GM(e), n = WM(e);
  return qM(t.runSync(t.parse(n), n), e);
}
function GM(e) {
  const t = e.rehypePlugins || sp, n = e.remarkPlugins || sp, r = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...ip } : ip;
  return UM().use(IL).use(n).use(AM, r).use(t);
}
function WM(e) {
  const t = e.children || "", n = new d_();
  return typeof t == "string" && (n.value = t), n;
}
function qM(e, t) {
  const n = t.allowedElements, r = t.allowElement, s = t.components, i = t.disallowedElements, a = t.skipHtml, o = t.unwrapDisallowed, u = t.urlTransform || KM;
  for (const l of YM)
    Object.hasOwn(t, l.from) && ("" + l.from + (l.to ? "use `" + l.to + "` instead" : "remove it") + zM + l.id, void 0);
  return Vo(e, c), lO(e, {
    Fragment: d.Fragment,
    components: s,
    ignoreInvalidStyle: !0,
    jsx: d.jsx,
    jsxs: d.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function c(l, h, m) {
    if (l.type === "raw" && m && typeof h == "number")
      return a ? m.children.splice(h, 1) : m.children[h] = { type: "text", value: l.value }, h;
    if (l.type === "element") {
      let p;
      for (p in Ou)
        if (Object.hasOwn(Ou, p) && Object.hasOwn(l.properties, p)) {
          const E = l.properties[p], g = Ou[p];
          (g === null || g.includes(l.tagName)) && (l.properties[p] = u(String(E || ""), p, l));
        }
    }
    if (l.type === "element") {
      let p = n ? !n.includes(l.tagName) : i ? i.includes(l.tagName) : !1;
      if (!p && r && typeof h == "number" && (p = !r(l, h, m)), p && m && typeof h == "number")
        return o && l.children ? m.children.splice(h, 1, ...l.children) : m.children.splice(h, 1), h;
    }
  }
}
function KM(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), s = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    s !== -1 && t > s || n !== -1 && t > n || r !== -1 && t > r || // It is a protocol, it should be allowed.
    VM.test(e.slice(0, t)) ? e : ""
  );
}
const QM = (e, t) => typeof e == "string" ? e === t : JSON.stringify(e) === JSON.stringify(t), XM = (e, t) => {
  if (!e || !t)
    return !1;
  const n = (r) => {
    const { position: s, data: i, ...a } = r || {};
    return a;
  };
  return JSON.stringify(n(e.properties)) === JSON.stringify(n(t.properties)) && QM(e.children, t.children);
}, id = (e, t) => XM(e.node, t.node), JM = (e = {}) => Object.fromEntries(Object.entries(e ?? {}).map(([t, n]) => {
  if (!n)
    return [t, n];
  const r = n;
  return [t, de(({ node: i, ...a }) => d.jsx(r, { ...a }), id)];
})), ad = Tt(null), f_ = () => mt(ad) !== null, ZM = ({ children: e, ...t }) => d.jsx(ad.Provider, { value: t, children: e }), e6 = de(ZM, id), t6 = ({ node: e, ...t }) => d.jsx("pre", { ...t }), n6 = ({ node: e, ...t }) => d.jsx("code", { ...t }), od = ({ node: e, components: { Pre: t, Code: n }, code: r }) => d.jsx(t, { children: d.jsx(n, { node: e, children: r }) }), r6 = () => null, s6 = ({ node: e, components: { Pre: t, Code: n, SyntaxHighlighter: r, CodeHeader: s }, language: i, code: a }) => {
  const o = se(() => ({ Pre: t, Code: n }), [t, n]), u = i ? r : od;
  return d.jsxs(d.Fragment, { children: [d.jsx(s, { node: e, language: i, code: a }), d.jsx(u, { node: e, components: o, language: i ?? "unknown", code: a })] });
};
var Vu = { exports: {} };
var ap;
function i6() {
  return ap || (ap = 1, (function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", a = 0; a < arguments.length; a++) {
          var o = arguments[a];
          o && (i = s(i, r(o)));
        }
        return i;
      }
      function r(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var a = "";
        for (var o in i)
          t.call(i, o) && i[o] && (a = s(a, o));
        return a;
      }
      function s(i, a) {
        return a ? i ? i + " " + a : i + a : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  })(Vu)), Vu.exports;
}
var a6 = i6();
const p_ = /* @__PURE__ */ Dr(a6), op = ({ className: e, ...t }) => ({ className: n, ...r }) => ({
  className: p_(e, n),
  ...t,
  ...r
}), o6 = ({ node: e, components: { Pre: t, Code: n, SyntaxHighlighter: r, CodeHeader: s }, componentsByLanguage: i = {}, children: a, ...o }) => {
  const u = mt(ad), c = op(u), l = jt((_) => d.jsx(t, { ...c(_) })), h = op(o), m = jt((_) => d.jsx(n, { ...h(_) })), p = /language-(\w+)/.exec(o.className || "")?.[1] ?? "";
  if (typeof a != "string")
    return d.jsx(od, { node: e, components: { Pre: l, Code: m }, code: a });
  const E = i[p]?.SyntaxHighlighter ?? r, g = i[p]?.CodeHeader ?? s;
  return d.jsx(s6, { node: e, components: {
    Pre: l,
    Code: m,
    SyntaxHighlighter: E,
    CodeHeader: g
  }, language: p || "unknown", code: a });
}, u6 = ({ node: e, components: t, componentsByLanguage: n, ...r }) => f_() ? d.jsx(o6, { node: e, components: t, componentsByLanguage: n, ...r }) : d.jsx(t.Code, { ...r }), c6 = de(u6, (e, t) => e.components === t.components && e.componentsByLanguage === t.componentsByLanguage && id(e, t)), { useSmooth: l6, useSmoothStatus: d6, withSmoothContextProvider: h6 } = tN, f6 = ({ components: e, componentsByLanguage: t, smooth: n = !0, preprocess: r, ...s }) => {
  const i = TE(), a = se(() => r ? {
    ...i,
    text: r(i.text)
  } : i, [i, r]), { text: o } = l6(a, n), { pre: u = t6, code: c = n6, SyntaxHighlighter: l = od, CodeHeader: h = r6 } = e ?? {}, m = se(() => ({
    Pre: u,
    Code: c,
    SyntaxHighlighter: l,
    CodeHeader: h
  }), [u, c, l, h]), p = jt((g) => d.jsx(c6, { components: m, componentsByLanguage: t, ...g })), E = se(() => {
    const { pre: g, code: _, SyntaxHighlighter: b, CodeHeader: T, ...C } = e ?? {};
    return {
      ...C,
      pre: e6,
      code: p
    };
  }, [p, e]);
  return d.jsx(h_, { components: E, ...s, children: o });
}, m_ = Je(({ className: e, containerProps: t, containerComponent: n = "div", ...r }, s) => {
  const i = d6();
  return d.jsx(n, { "data-status": i.type, ...t, className: p_(e, t?.className), ref: s, children: d.jsx(f6, { ...r }) });
});
m_.displayName = "MarkdownTextPrimitive";
const p6 = h6(m_), up = /[#.]/g;
function m6(e, t) {
  const n = e || "", r = {};
  let s = 0, i, a;
  for (; s < n.length; ) {
    up.lastIndex = s;
    const o = up.exec(n), u = n.slice(s, o ? o.index : n.length);
    u && (i ? i === "#" ? r.id = u : Array.isArray(r.className) ? r.className.push(u) : r.className = [u] : a = u, s += u.length), o && (i = o[0], s++);
  }
  return {
    type: "element",
    // @ts-expect-error: tag name is parsed.
    tagName: a || t || "div",
    properties: r,
    children: []
  };
}
function g_(e, t, n) {
  const r = n ? _6(n) : void 0;
  function s(i, a, ...o) {
    let u;
    if (i == null) {
      u = { type: "root", children: [] };
      const c = (
        /** @type {Child} */
        a
      );
      o.unshift(c);
    } else {
      u = m6(i, t);
      const c = u.tagName.toLowerCase(), l = r ? r.get(c) : void 0;
      if (u.tagName = l || c, g6(a))
        o.unshift(a);
      else
        for (const [h, m] of Object.entries(a))
          E6(e, u.properties, h, m);
    }
    for (const c of o)
      Hc(u.children, c);
    return u.type === "element" && u.tagName === "template" && (u.content = { type: "root", children: u.children }, u.children = []), u;
  }
  return s;
}
function g6(e) {
  if (e === null || typeof e != "object" || Array.isArray(e))
    return !0;
  if (typeof e.type != "string") return !1;
  const t = (
    /** @type {Record<string, unknown>} */
    e
  ), n = Object.keys(e);
  for (const r of n) {
    const s = t[r];
    if (s && typeof s == "object") {
      if (!Array.isArray(s)) return !0;
      const i = (
        /** @type {ReadonlyArray<unknown>} */
        s
      );
      for (const a of i)
        if (typeof a != "number" && typeof a != "string")
          return !0;
    }
  }
  return !!("children" in e && Array.isArray(e.children));
}
function E6(e, t, n, r) {
  const s = Ho(e, n);
  let i;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) return;
      i = r;
    } else typeof r == "boolean" ? i = r : typeof r == "string" ? s.spaceSeparated ? i = If(r) : s.commaSeparated ? i = yf(r) : s.commaOrSpaceSeparated ? i = If(yf(r).join(" ")) : i = cp(s, s.property, r) : Array.isArray(r) ? i = [...r] : i = s.property === "style" ? b6(r) : String(r);
    if (Array.isArray(i)) {
      const a = [];
      for (const o of i)
        a.push(
          /** @type {number | string} */
          cp(s, s.property, o)
        );
      i = a;
    }
    s.property === "className" && Array.isArray(t.className) && (i = t.className.concat(
      /** @type {Array<number | string> | number | string} */
      i
    )), t[s.property] = i;
  }
}
function Hc(e, t) {
  if (t != null) if (typeof t == "number" || typeof t == "string")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (const n of t)
      Hc(e, n);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? Hc(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function cp(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || Ei(n) === Ei(t)))
      return !0;
  }
  return n;
}
function b6(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    t.push([n, r].join(": "));
  return t.join("; ");
}
function _6(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e)
    t.set(n.toLowerCase(), n);
  return t;
}
const T6 = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], A6 = g_(Li, "div"), y6 = g_(lr, "g", T6);
function x6(e) {
  const t = String(e), n = [];
  return { toOffset: s, toPoint: r };
  function r(i) {
    if (typeof i == "number" && i > -1 && i <= t.length) {
      let a = 0;
      for (; ; ) {
        let o = n[a];
        if (o === void 0) {
          const u = lp(t, n[a - 1]);
          o = u === -1 ? t.length + 1 : u + 1, n[a] = o;
        }
        if (o > i)
          return {
            line: a + 1,
            column: i - (a > 0 ? n[a - 1] : 0) + 1,
            offset: i
          };
        a++;
      }
    }
  }
  function s(i) {
    if (i && typeof i.line == "number" && typeof i.column == "number" && !Number.isNaN(i.line) && !Number.isNaN(i.column)) {
      for (; n.length < i.line; ) {
        const o = n[n.length - 1], u = lp(t, o), c = u === -1 ? t.length + 1 : u + 1;
        if (o === c) break;
        n.push(c);
      }
      const a = (i.line > 1 ? n[i.line - 2] : 0) + i.column - 1;
      if (a < n[i.line - 1]) return a;
    }
  }
}
function lp(e, t) {
  const n = e.indexOf("\r", t), r = e.indexOf(`
`, t);
  return r === -1 ? n : n === -1 || n + 1 === r ? r : n < r ? n : r;
}
const yr = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg",
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
}, E_ = {}.hasOwnProperty, C6 = Object.prototype;
function S6(e, t) {
  const n = t || {};
  return ud(
    {
      file: n.file || void 0,
      location: !1,
      schema: n.space === "svg" ? lr : Li,
      verbose: n.verbose || !1
    },
    e
  );
}
function ud(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['commentNode']} */
        t
      );
      return n = { type: "comment", value: r.data }, Ca(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {DefaultTreeAdapterMap['document'] | DefaultTreeAdapterMap['documentFragment']} */
        t
      ), s = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: b_(e, t.childNodes),
        data: { quirksMode: s }
      }, e.file && e.location) {
        const i = String(e.file), a = x6(i), o = a.toPoint(0), u = a.toPoint(i.length);
        n.position = { start: o, end: u };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {DefaultTreeAdapterMap['documentType']} */
        t
      );
      return n = { type: "doctype" }, Ca(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {DefaultTreeAdapterMap['textNode']} */
        t
      );
      return n = { type: "text", value: r.value }, Ca(e, r, n), n;
    }
    // Element.
    default:
      return n = w6(
        e,
        /** @type {DefaultTreeAdapterMap['element']} */
        t
      ), n;
  }
}
function b_(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; ) {
    const s = (
      /** @type {RootContent} */
      ud(e, t[n])
    );
    r.push(s);
  }
  return r;
}
function w6(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === yr.svg ? lr : Li;
  let r = -1;
  const s = {};
  for (; ++r < t.attrs.length; ) {
    const o = t.attrs[r], u = (o.prefix ? o.prefix + ":" : "") + o.name;
    E_.call(C6, u) || (s[u] = o.value);
  }
  const a = (e.schema.space === "svg" ? y6 : A6)(t.tagName, s, b_(e, t.childNodes));
  if (Ca(e, t, a), a.tagName === "template") {
    const o = (
      /** @type {DefaultTreeAdapterMap['template']} */
      t
    ), u = o.sourceCodeLocation, c = u && u.startTag && ts(u.startTag), l = u && u.endTag && ts(u.endTag), h = (
      /** @type {Root} */
      ud(e, o.content)
    );
    c && l && e.file && (h.position = { start: c.end, end: l.start }), a.content = h;
  }
  return e.schema = n, a;
}
function Ca(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = I6(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function I6(e, t, n) {
  const r = ts(n);
  if (t.type === "element") {
    const s = t.children[t.children.length - 1];
    if (r && !n.endTag && s && s.position && s.position.end && (r.end = Object.assign({}, s.position.end)), e.verbose) {
      const i = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          E_.call(n.attrs, a) && (i[Ho(e.schema, a).property] = ts(
            n.attrs[a]
          ));
      n.startTag;
      const o = ts(n.startTag), u = n.endTag ? ts(n.endTag) : void 0, c = { opening: o };
      u && (c.closing = u), c.properties = i, t.data = { position: c };
    }
  }
  return r;
}
function ts(e) {
  const t = dp({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = dp({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function dp(e) {
  return e.line && e.column ? e : void 0;
}
const hp = {}.hasOwnProperty;
function __(e, t) {
  const n = t || {};
  function r(s, ...i) {
    let a = r.invalid;
    const o = r.handlers;
    if (s && hp.call(s, e)) {
      const u = String(s[e]);
      a = hp.call(o, u) ? o[u] : r.unknown;
    }
    if (a)
      return a.call(this, s, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const v6 = {}, N6 = {}.hasOwnProperty, T_ = __("type", { handlers: { root: R6, element: M6, text: D6, comment: L6, doctype: O6 } });
function k6(e, t) {
  const r = (t || v6).space;
  return T_(e, r === "svg" ? lr : Li);
}
function R6(e, t) {
  const n = {
    nodeName: "#document",
    // @ts-expect-error: `parse5` uses enums, which are actually strings.
    mode: (e.data || {}).quirksMode ? "quirks" : "no-quirks",
    childNodes: []
  };
  return n.childNodes = cd(e.children, n, t), ws(e, n), n;
}
function P6(e, t) {
  const n = { nodeName: "#document-fragment", childNodes: [] };
  return n.childNodes = cd(e.children, n, t), ws(e, n), n;
}
function O6(e) {
  const t = {
    nodeName: "#documentType",
    name: "html",
    publicId: "",
    systemId: "",
    parentNode: null
  };
  return ws(e, t), t;
}
function D6(e) {
  const t = {
    nodeName: "#text",
    value: e.value,
    parentNode: null
  };
  return ws(e, t), t;
}
function L6(e) {
  const t = {
    nodeName: "#comment",
    data: e.value,
    parentNode: null
  };
  return ws(e, t), t;
}
function M6(e, t) {
  const n = t;
  let r = n;
  e.type === "element" && e.tagName.toLowerCase() === "svg" && n.space === "html" && (r = lr);
  const s = [];
  let i;
  if (e.properties) {
    for (i in e.properties)
      if (i !== "children" && N6.call(e.properties, i)) {
        const u = H6(
          r,
          i,
          e.properties[i]
        );
        u && s.push(u);
      }
  }
  const a = r.space, o = {
    nodeName: e.tagName,
    tagName: e.tagName,
    attrs: s,
    // @ts-expect-error: `parse5` types are wrong.
    namespaceURI: yr[a],
    childNodes: [],
    parentNode: null
  };
  return o.childNodes = cd(e.children, o, r), ws(e, o), e.tagName === "template" && e.content && (o.content = P6(e.content, r)), o;
}
function H6(e, t, n) {
  const r = Ho(e, t);
  if (n === !1 || n === null || n === void 0 || typeof n == "number" && Number.isNaN(n) || !n && r.boolean)
    return;
  Array.isArray(n) && (n = r.commaSeparated ? kb(n) : Bb(n));
  const s = {
    name: r.attribute,
    value: n === !0 ? "" : String(n)
  };
  if (r.space && r.space !== "html" && r.space !== "svg") {
    const i = s.name.indexOf(":");
    i < 0 ? s.prefix = "" : (s.name = s.name.slice(i + 1), s.prefix = r.attribute.slice(0, i)), s.namespace = yr[r.space];
  }
  return s;
}
function cd(e, t, n) {
  let r = -1;
  const s = [];
  if (e)
    for (; ++r < e.length; ) {
      const i = T_(e[r], n);
      i.parentNode = t, s.push(i);
    }
  return s;
}
function ws(e, t) {
  const n = e.position;
  n && n.start && n.end && (n.start.offset, n.end.offset, t.sourceCodeLocation = {
    startLine: n.start.line,
    startCol: n.start.column,
    startOffset: n.start.offset,
    endLine: n.end.line,
    endCol: n.end.column,
    endOffset: n.end.offset
  });
}
const B6 = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
], U6 = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), Xe = "�";
var x;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z";
})(x || (x = {}));
const vt = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function A_(e) {
  return e >= 55296 && e <= 57343;
}
function F6(e) {
  return e >= 56320 && e <= 57343;
}
function j6(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function y_(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function x_(e) {
  return e >= 64976 && e <= 65007 || U6.has(e);
}
var j;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(j || (j = {}));
const $6 = 65536;
class z6 {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = $6, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t, n) {
    const { line: r, col: s, offset: i } = this, a = s + n, o = i + n;
    return {
      code: t,
      startLine: r,
      endLine: r,
      startCol: a,
      endCol: a,
      startOffset: o,
      endOffset: o
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t, 0)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const n = this.html.charCodeAt(this.pos + 1);
      if (F6(n))
        return this.pos++, this._addGap(), j6(t, n);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, x.EOF;
    return this._err(j.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, n) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = n;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, n) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (n)
      return this.html.startsWith(t, this.pos);
    for (let r = 0; r < t.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== t.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(t) {
    const n = this.pos + t;
    if (n >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, x.EOF;
    const r = this.html.charCodeAt(n);
    return r === x.CARRIAGE_RETURN ? x.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, x.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === x.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, x.LINE_FEED) : t === x.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, A_(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === x.LINE_FEED || t === x.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    y_(t) ? this._err(j.controlCharacterInInputStream) : x_(t) && this._err(j.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Ne;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(Ne || (Ne = {}));
function C_(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
}
const V6 = /* @__PURE__ */ new Uint16Array(
  // prettier-ignore
  /* @__PURE__ */ 'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), Y6 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
function G6(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = Y6.get(e)) !== null && t !== void 0 ? t : e;
}
var lt;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(lt || (lt = {}));
const W6 = 32;
var Kn;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Kn || (Kn = {}));
function Bc(e) {
  return e >= lt.ZERO && e <= lt.NINE;
}
function q6(e) {
  return e >= lt.UPPER_A && e <= lt.UPPER_F || e >= lt.LOWER_A && e <= lt.LOWER_F;
}
function K6(e) {
  return e >= lt.UPPER_A && e <= lt.UPPER_Z || e >= lt.LOWER_A && e <= lt.LOWER_Z || Bc(e);
}
function Q6(e) {
  return e === lt.EQUALS || K6(e);
}
var ct;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(ct || (ct = {}));
var Rn;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Rn || (Rn = {}));
class X6 {
  constructor(t, n, r) {
    this.decodeTree = t, this.emitCodePoint = n, this.errors = r, this.state = ct.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Rn.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = ct.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, n) {
    switch (this.state) {
      case ct.EntityStart:
        return t.charCodeAt(n) === lt.NUM ? (this.state = ct.NumericStart, this.consumed += 1, this.stateNumericStart(t, n + 1)) : (this.state = ct.NamedEntity, this.stateNamedEntity(t, n));
      case ct.NumericStart:
        return this.stateNumericStart(t, n);
      case ct.NumericDecimal:
        return this.stateNumericDecimal(t, n);
      case ct.NumericHex:
        return this.stateNumericHex(t, n);
      case ct.NamedEntity:
        return this.stateNamedEntity(t, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, n) {
    return n >= t.length ? -1 : (t.charCodeAt(n) | W6) === lt.LOWER_X ? (this.state = ct.NumericHex, this.consumed += 1, this.stateNumericHex(t, n + 1)) : (this.state = ct.NumericDecimal, this.stateNumericDecimal(t, n));
  }
  addToNumericResult(t, n, r, s) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(s, i) + Number.parseInt(t.substr(n, i), s), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const s = t.charCodeAt(n);
      if (Bc(s) || q6(s))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 16), this.emitNumericEntity(s, 3);
    }
    return this.addToNumericResult(t, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, n) {
    const r = n;
    for (; n < t.length; ) {
      const s = t.charCodeAt(n);
      if (Bc(s))
        n += 1;
      else
        return this.addToNumericResult(t, r, n, 10), this.emitNumericEntity(s, 2);
    }
    return this.addToNumericResult(t, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === lt.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Rn.Strict)
      return 0;
    return this.emitCodePoint(G6(this.result), this.consumed), this.errors && (t !== lt.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param input The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, n) {
    const { decodeTree: r } = this;
    let s = r[this.treeIndex], i = (s & Kn.VALUE_LENGTH) >> 14;
    for (; n < t.length; n++, this.excess++) {
      const a = t.charCodeAt(n);
      if (this.treeIndex = J6(r, s, this.treeIndex + Math.max(1, i), a), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Rn.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        Q6(a)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (s = r[this.treeIndex], i = (s & Kn.VALUE_LENGTH) >> 14, i !== 0) {
        if (a === lt.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== Rn.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: n, decodeTree: r } = this, s = (r[n] & Kn.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, s, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, n, r) {
    const { decodeTree: s } = this;
    return this.emitCodePoint(n === 1 ? s[t] & ~Kn.VALUE_LENGTH : s[t + 1], r), n === 3 && this.emitCodePoint(s[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case ct.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Rn.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case ct.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case ct.NumericHex:
        return this.emitNumericEntity(0, 3);
      case ct.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case ct.EntityStart:
        return 0;
    }
  }
}
function J6(e, t, n, r) {
  const s = (t & Kn.BRANCH_LENGTH) >> 7, i = t & Kn.JUMP_TABLE;
  if (s === 0)
    return i !== 0 && r === i ? n : -1;
  if (i) {
    const u = r - i;
    return u < 0 || u >= s ? -1 : e[n + u] - 1;
  }
  let a = n, o = a + s - 1;
  for (; a <= o; ) {
    const u = a + o >>> 1, c = e[u];
    if (c < r)
      a = u + 1;
    else if (c > r)
      o = u - 1;
    else
      return e[u + s];
  }
  return -1;
}
var W;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(W || (W = {}));
var Sr;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(Sr || (Sr = {}));
var Gt;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(Gt || (Gt = {}));
var L;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SEARCH = "search", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(L || (L = {}));
var f;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SEARCH = 94] = "SEARCH", e[e.SECTION = 95] = "SECTION", e[e.SELECT = 96] = "SELECT", e[e.SOURCE = 97] = "SOURCE", e[e.SMALL = 98] = "SMALL", e[e.SPAN = 99] = "SPAN", e[e.STRIKE = 100] = "STRIKE", e[e.STRONG = 101] = "STRONG", e[e.STYLE = 102] = "STYLE", e[e.SUB = 103] = "SUB", e[e.SUMMARY = 104] = "SUMMARY", e[e.SUP = 105] = "SUP", e[e.TABLE = 106] = "TABLE", e[e.TBODY = 107] = "TBODY", e[e.TEMPLATE = 108] = "TEMPLATE", e[e.TEXTAREA = 109] = "TEXTAREA", e[e.TFOOT = 110] = "TFOOT", e[e.TD = 111] = "TD", e[e.TH = 112] = "TH", e[e.THEAD = 113] = "THEAD", e[e.TITLE = 114] = "TITLE", e[e.TR = 115] = "TR", e[e.TRACK = 116] = "TRACK", e[e.TT = 117] = "TT", e[e.U = 118] = "U", e[e.UL = 119] = "UL", e[e.SVG = 120] = "SVG", e[e.VAR = 121] = "VAR", e[e.WBR = 122] = "WBR", e[e.XMP = 123] = "XMP";
})(f || (f = {}));
const Z6 = /* @__PURE__ */ new Map([
  [L.A, f.A],
  [L.ADDRESS, f.ADDRESS],
  [L.ANNOTATION_XML, f.ANNOTATION_XML],
  [L.APPLET, f.APPLET],
  [L.AREA, f.AREA],
  [L.ARTICLE, f.ARTICLE],
  [L.ASIDE, f.ASIDE],
  [L.B, f.B],
  [L.BASE, f.BASE],
  [L.BASEFONT, f.BASEFONT],
  [L.BGSOUND, f.BGSOUND],
  [L.BIG, f.BIG],
  [L.BLOCKQUOTE, f.BLOCKQUOTE],
  [L.BODY, f.BODY],
  [L.BR, f.BR],
  [L.BUTTON, f.BUTTON],
  [L.CAPTION, f.CAPTION],
  [L.CENTER, f.CENTER],
  [L.CODE, f.CODE],
  [L.COL, f.COL],
  [L.COLGROUP, f.COLGROUP],
  [L.DD, f.DD],
  [L.DESC, f.DESC],
  [L.DETAILS, f.DETAILS],
  [L.DIALOG, f.DIALOG],
  [L.DIR, f.DIR],
  [L.DIV, f.DIV],
  [L.DL, f.DL],
  [L.DT, f.DT],
  [L.EM, f.EM],
  [L.EMBED, f.EMBED],
  [L.FIELDSET, f.FIELDSET],
  [L.FIGCAPTION, f.FIGCAPTION],
  [L.FIGURE, f.FIGURE],
  [L.FONT, f.FONT],
  [L.FOOTER, f.FOOTER],
  [L.FOREIGN_OBJECT, f.FOREIGN_OBJECT],
  [L.FORM, f.FORM],
  [L.FRAME, f.FRAME],
  [L.FRAMESET, f.FRAMESET],
  [L.H1, f.H1],
  [L.H2, f.H2],
  [L.H3, f.H3],
  [L.H4, f.H4],
  [L.H5, f.H5],
  [L.H6, f.H6],
  [L.HEAD, f.HEAD],
  [L.HEADER, f.HEADER],
  [L.HGROUP, f.HGROUP],
  [L.HR, f.HR],
  [L.HTML, f.HTML],
  [L.I, f.I],
  [L.IMG, f.IMG],
  [L.IMAGE, f.IMAGE],
  [L.INPUT, f.INPUT],
  [L.IFRAME, f.IFRAME],
  [L.KEYGEN, f.KEYGEN],
  [L.LABEL, f.LABEL],
  [L.LI, f.LI],
  [L.LINK, f.LINK],
  [L.LISTING, f.LISTING],
  [L.MAIN, f.MAIN],
  [L.MALIGNMARK, f.MALIGNMARK],
  [L.MARQUEE, f.MARQUEE],
  [L.MATH, f.MATH],
  [L.MENU, f.MENU],
  [L.META, f.META],
  [L.MGLYPH, f.MGLYPH],
  [L.MI, f.MI],
  [L.MO, f.MO],
  [L.MN, f.MN],
  [L.MS, f.MS],
  [L.MTEXT, f.MTEXT],
  [L.NAV, f.NAV],
  [L.NOBR, f.NOBR],
  [L.NOFRAMES, f.NOFRAMES],
  [L.NOEMBED, f.NOEMBED],
  [L.NOSCRIPT, f.NOSCRIPT],
  [L.OBJECT, f.OBJECT],
  [L.OL, f.OL],
  [L.OPTGROUP, f.OPTGROUP],
  [L.OPTION, f.OPTION],
  [L.P, f.P],
  [L.PARAM, f.PARAM],
  [L.PLAINTEXT, f.PLAINTEXT],
  [L.PRE, f.PRE],
  [L.RB, f.RB],
  [L.RP, f.RP],
  [L.RT, f.RT],
  [L.RTC, f.RTC],
  [L.RUBY, f.RUBY],
  [L.S, f.S],
  [L.SCRIPT, f.SCRIPT],
  [L.SEARCH, f.SEARCH],
  [L.SECTION, f.SECTION],
  [L.SELECT, f.SELECT],
  [L.SOURCE, f.SOURCE],
  [L.SMALL, f.SMALL],
  [L.SPAN, f.SPAN],
  [L.STRIKE, f.STRIKE],
  [L.STRONG, f.STRONG],
  [L.STYLE, f.STYLE],
  [L.SUB, f.SUB],
  [L.SUMMARY, f.SUMMARY],
  [L.SUP, f.SUP],
  [L.TABLE, f.TABLE],
  [L.TBODY, f.TBODY],
  [L.TEMPLATE, f.TEMPLATE],
  [L.TEXTAREA, f.TEXTAREA],
  [L.TFOOT, f.TFOOT],
  [L.TD, f.TD],
  [L.TH, f.TH],
  [L.THEAD, f.THEAD],
  [L.TITLE, f.TITLE],
  [L.TR, f.TR],
  [L.TRACK, f.TRACK],
  [L.TT, f.TT],
  [L.U, f.U],
  [L.UL, f.UL],
  [L.SVG, f.SVG],
  [L.VAR, f.VAR],
  [L.WBR, f.WBR],
  [L.XMP, f.XMP]
]);
function Is(e) {
  var t;
  return (t = Z6.get(e)) !== null && t !== void 0 ? t : f.UNKNOWN;
}
const K = f, e4 = {
  [W.HTML]: /* @__PURE__ */ new Set([
    K.ADDRESS,
    K.APPLET,
    K.AREA,
    K.ARTICLE,
    K.ASIDE,
    K.BASE,
    K.BASEFONT,
    K.BGSOUND,
    K.BLOCKQUOTE,
    K.BODY,
    K.BR,
    K.BUTTON,
    K.CAPTION,
    K.CENTER,
    K.COL,
    K.COLGROUP,
    K.DD,
    K.DETAILS,
    K.DIR,
    K.DIV,
    K.DL,
    K.DT,
    K.EMBED,
    K.FIELDSET,
    K.FIGCAPTION,
    K.FIGURE,
    K.FOOTER,
    K.FORM,
    K.FRAME,
    K.FRAMESET,
    K.H1,
    K.H2,
    K.H3,
    K.H4,
    K.H5,
    K.H6,
    K.HEAD,
    K.HEADER,
    K.HGROUP,
    K.HR,
    K.HTML,
    K.IFRAME,
    K.IMG,
    K.INPUT,
    K.LI,
    K.LINK,
    K.LISTING,
    K.MAIN,
    K.MARQUEE,
    K.MENU,
    K.META,
    K.NAV,
    K.NOEMBED,
    K.NOFRAMES,
    K.NOSCRIPT,
    K.OBJECT,
    K.OL,
    K.P,
    K.PARAM,
    K.PLAINTEXT,
    K.PRE,
    K.SCRIPT,
    K.SECTION,
    K.SELECT,
    K.SOURCE,
    K.STYLE,
    K.SUMMARY,
    K.TABLE,
    K.TBODY,
    K.TD,
    K.TEMPLATE,
    K.TEXTAREA,
    K.TFOOT,
    K.TH,
    K.THEAD,
    K.TITLE,
    K.TR,
    K.TRACK,
    K.UL,
    K.WBR,
    K.XMP
  ]),
  [W.MATHML]: /* @__PURE__ */ new Set([K.MI, K.MO, K.MN, K.MS, K.MTEXT, K.ANNOTATION_XML]),
  [W.SVG]: /* @__PURE__ */ new Set([K.TITLE, K.FOREIGN_OBJECT, K.DESC]),
  [W.XLINK]: /* @__PURE__ */ new Set(),
  [W.XML]: /* @__PURE__ */ new Set(),
  [W.XMLNS]: /* @__PURE__ */ new Set()
}, Uc = /* @__PURE__ */ new Set([K.H1, K.H2, K.H3, K.H4, K.H5, K.H6]);
L.STYLE, L.SCRIPT, L.XMP, L.IFRAME, L.NOEMBED, L.NOFRAMES, L.PLAINTEXT;
var S;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 72] = "AMBIGUOUS_AMPERSAND";
})(S || (S = {}));
const nt = {
  DATA: S.DATA,
  RCDATA: S.RCDATA,
  RAWTEXT: S.RAWTEXT,
  SCRIPT_DATA: S.SCRIPT_DATA,
  PLAINTEXT: S.PLAINTEXT,
  CDATA_SECTION: S.CDATA_SECTION
};
function t4(e) {
  return e >= x.DIGIT_0 && e <= x.DIGIT_9;
}
function Ks(e) {
  return e >= x.LATIN_CAPITAL_A && e <= x.LATIN_CAPITAL_Z;
}
function n4(e) {
  return e >= x.LATIN_SMALL_A && e <= x.LATIN_SMALL_Z;
}
function Gn(e) {
  return n4(e) || Ks(e);
}
function fp(e) {
  return Gn(e) || t4(e);
}
function ha(e) {
  return e + 32;
}
function S_(e) {
  return e === x.SPACE || e === x.LINE_FEED || e === x.TABULATION || e === x.FORM_FEED;
}
function pp(e) {
  return S_(e) || e === x.SOLIDUS || e === x.GREATER_THAN_SIGN;
}
function r4(e) {
  return e === x.NULL ? j.nullCharacterReference : e > 1114111 ? j.characterReferenceOutsideUnicodeRange : A_(e) ? j.surrogateCharacterReference : x_(e) ? j.noncharacterCharacterReference : y_(e) || e === x.CARRIAGE_RETURN ? j.controlCharacterReference : null;
}
class s4 {
  constructor(t, n) {
    this.options = t, this.handler = n, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = S.DATA, this.returnState = S.DATA, this.entityStartPos = 0, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new z6(n), this.currentLocation = this.getCurrentLocation(-1), this.entityDecoder = new X6(V6, (r, s) => {
      this.preprocessor.pos = this.entityStartPos + s - 1, this._flushCodePointConsumedAsCharacterReference(r);
    }, n.onParseError ? {
      missingSemicolonAfterCharacterReference: () => {
        this._err(j.missingSemicolonAfterCharacterReference, 1);
      },
      absenceOfDigitsInNumericCharacterReference: (r) => {
        this._err(j.absenceOfDigitsInNumericCharacterReference, this.entityStartPos - this.preprocessor.pos + r);
      },
      validateNumericCharacterReference: (r) => {
        const s = r4(r);
        s && this._err(s, 1);
      }
    } : void 0);
  }
  //Errors
  _err(t, n = 0) {
    var r, s;
    (s = (r = this.handler).onParseError) === null || s === void 0 || s.call(r, this.preprocessor.getError(t, n));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t?.());
  }
  write(t, n, r) {
    this.active = !0, this.preprocessor.write(t, n), this._runParsingLoop(), this.paused || r?.();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this.preprocessor.retreat(this.consumedAfterSnapshot), this.consumedAfterSnapshot = 0, this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let n = 0; n < t; n++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, n) {
    return this.preprocessor.startsWith(t, n) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Ne.START_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Ne.END_TAG,
      tagName: "",
      tagID: f.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: Ne.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: Ne.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, n;
    const r = this.currentToken;
    if (C_(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const s = (t = (n = r.location).attrs) !== null && t !== void 0 ? t : n.attrs = /* @__PURE__ */ Object.create(null);
        s[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(j.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = Is(t.tagName), t.type === Ne.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(j.endTagWithAttributes), t.selfClosing && this._err(j.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case Ne.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Ne.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Ne.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: Ne.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: The specification uses only one type of character token (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type === t) {
        this.currentCharacterToken.chars += n;
        return;
      } else
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
    this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    const n = S_(t) ? Ne.WHITESPACE_CHARACTER : t === x.NULL ? Ne.NULL_CHARACTER : Ne.CHARACTER;
    this._appendCharToCurrentCharacterToken(n, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Ne.CHARACTER, t);
  }
  // Character reference helpers
  _startCharacterReference() {
    this.returnState = this.state, this.state = S.CHARACTER_REFERENCE, this.entityStartPos = this.preprocessor.pos, this.entityDecoder.startEntity(this._isCharacterReferenceInAttribute() ? Rn.Attribute : Rn.Legacy);
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === S.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === S.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === S.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case S.DATA: {
        this._stateData(t);
        break;
      }
      case S.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case S.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case S.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case S.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case S.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case S.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case S.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case S.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case S.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case S.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case S.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case S.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case S.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case S.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case S.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case S.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case S.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case S.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case S.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case S.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case S.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case S.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case S.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case S.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case S.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case S.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case S.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case S.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case S.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case S.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case S.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case S.COMMENT: {
        this._stateComment(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case S.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case S.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case S.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case S.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case S.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case S.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case S.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case S.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case S.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case S.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case S.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case S.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case S.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case S.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case S.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case S.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case S.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case S.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case S.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case S.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case S.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case S.CHARACTER_REFERENCE: {
        this._stateCharacterReference();
        break;
      }
      case S.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case x.LESS_THAN_SIGN: {
        this.state = S.TAG_OPEN;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case x.LESS_THAN_SIGN: {
        this.state = S.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (Gn(t))
      this._createStartTagToken(), this.state = S.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case x.EXCLAMATION_MARK: {
          this.state = S.MARKUP_DECLARATION_OPEN;
          break;
        }
        case x.SOLIDUS: {
          this.state = S.END_TAG_OPEN;
          break;
        }
        case x.QUESTION_MARK: {
          this._err(j.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = S.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case x.EOF: {
          this._err(j.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(j.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = S.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (Gn(t))
      this._createEndTagToken(), this.state = S.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case x.GREATER_THAN_SIGN: {
          this._err(j.missingEndTagName), this.state = S.DATA;
          break;
        }
        case x.EOF: {
          this._err(j.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(j.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = S.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case x.SOLIDUS: {
        this.state = S.SELF_CLOSING_START_TAG;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.tagName += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        n.tagName += String.fromCodePoint(Ks(t) ? ha(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === x.SOLIDUS ? this.state = S.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = S.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    Gn(t) ? (this.state = S.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = S.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const n = this.currentToken;
    switch (n.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = S.BEFORE_ATTRIBUTE_NAME, !1;
      case x.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = S.SELF_CLOSING_START_TAG, !1;
      case x.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = S.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === x.SOLIDUS ? this.state = S.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = S.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    Gn(t) ? (this.state = S.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = S.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case x.SOLIDUS: {
        this.state = S.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case x.EXCLAMATION_MARK: {
        this.state = S.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = S.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    Gn(t) ? (this.state = S.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === x.HYPHEN_MINUS ? (this.state = S.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === x.HYPHEN_MINUS ? (this.state = S.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = S.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === x.SOLIDUS ? this.state = S.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : Gn(t) ? (this._emitChars("<"), this.state = S.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    Gn(t) ? (this.state = S.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(vt.SCRIPT, !1) && pp(this.preprocessor.peek(vt.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < vt.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else this._ensureHibernation() || (this.state = S.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case x.LESS_THAN_SIGN: {
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Xe);
        break;
      }
      case x.EOF: {
        this._err(j.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === x.SOLIDUS ? (this.state = S.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(vt.SCRIPT, !1) && pp(this.preprocessor.peek(vt.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let n = 0; n < vt.SCRIPT.length; n++)
        this._emitCodePoint(this._consume());
      this.state = S.SCRIPT_DATA_ESCAPED;
    } else this._ensureHibernation() || (this.state = S.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.SOLIDUS:
      case x.GREATER_THAN_SIGN:
      case x.EOF: {
        this.state = S.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case x.EQUALS_SIGN: {
        this._err(j.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = S.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = S.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
      case x.SOLIDUS:
      case x.GREATER_THAN_SIGN:
      case x.EOF: {
        this._leaveAttrName(), this.state = S.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case x.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = S.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case x.QUOTATION_MARK:
      case x.APOSTROPHE:
      case x.LESS_THAN_SIGN: {
        this._err(j.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.name += Xe;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Ks(t) ? ha(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.SOLIDUS: {
        this.state = S.SELF_CLOSING_START_TAG;
        break;
      }
      case x.EQUALS_SIGN: {
        this.state = S.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = S.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.QUOTATION_MARK: {
        this.state = S.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this.state = S.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingAttributeValue), this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = S.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case x.QUOTATION_MARK: {
        this.state = S.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.value += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case x.APOSTROPHE: {
        this.state = S.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.value += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this._leaveAttrValue(), this.state = S.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case x.AMPERSAND: {
        this._startCharacterReference();
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), this.currentAttr.value += Xe;
        break;
      }
      case x.QUOTATION_MARK:
      case x.APOSTROPHE:
      case x.LESS_THAN_SIGN:
      case x.EQUALS_SIGN:
      case x.GRAVE_ACCENT: {
        this._err(j.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this._leaveAttrValue(), this.state = S.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case x.SOLIDUS: {
        this._leaveAttrValue(), this.state = S.SELF_CLOSING_START_TAG;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingWhitespaceBetweenAttributes), this.state = S.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        const n = this.currentToken;
        n.selfClosing = !0, this.state = S.DATA, this.emitCurrentTagToken();
        break;
      }
      case x.EOF: {
        this._err(j.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.unexpectedSolidusInTag), this.state = S.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const n = this.currentToken;
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EOF: {
        this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.data += Xe;
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(vt.DASH_DASH, !0) ? (this._createCommentToken(vt.DASH_DASH.length + 1), this.state = S.COMMENT_START) : this._consumeSequenceIfMatch(vt.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(vt.DOCTYPE.length + 1), this.state = S.DOCTYPE) : this._consumeSequenceIfMatch(vt.CDATA_START, !0) ? this.inForeignNode ? this.state = S.CDATA_SECTION : (this._err(j.cdataInHtmlContent), this._createCommentToken(vt.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = S.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(j.incorrectlyOpenedComment), this._createCommentToken(2), this.state = S.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_START_DASH;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptClosingOfEmptyComment), this.state = S.DATA;
        const n = this.currentToken;
        this.emitCurrentComment(n);
        break;
      }
      default:
        this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_END;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptClosingOfEmptyComment), this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_END_DASH;
        break;
      }
      case x.LESS_THAN_SIGN: {
        n.data += "<", this.state = S.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.data += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const n = this.currentToken;
    switch (t) {
      case x.EXCLAMATION_MARK: {
        n.data += "!", this.state = S.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case x.LESS_THAN_SIGN: {
        n.data += "<";
        break;
      }
      default:
        this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === x.HYPHEN_MINUS ? this.state = S.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = S.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === x.HYPHEN_MINUS ? this.state = S.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = S.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== x.GREATER_THAN_SIGN && t !== x.EOF && this._err(j.nestedComment), this.state = S.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        this.state = S.COMMENT_END;
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "-", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const n = this.currentToken;
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EXCLAMATION_MARK: {
        this.state = S.COMMENT_END_BANG;
        break;
      }
      case x.HYPHEN_MINUS: {
        n.data += "-";
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const n = this.currentToken;
    switch (t) {
      case x.HYPHEN_MINUS: {
        n.data += "--!", this.state = S.COMMENT_END_DASH;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.incorrectlyClosedComment), this.state = S.DATA, this.emitCurrentComment(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInComment), this.emitCurrentComment(n), this._emitEOFToken();
        break;
      }
      default:
        n.data += "--!", this.state = S.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_DOCTYPE_NAME;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), this._createDoctypeToken(null);
        const n = this.currentToken;
        n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingWhitespaceBeforeDoctypeName), this.state = S.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (Ks(t))
      this._createDoctypeToken(String.fromCharCode(ha(t))), this.state = S.DOCTYPE_NAME;
    else
      switch (t) {
        case x.SPACE:
        case x.LINE_FEED:
        case x.TABULATION:
        case x.FORM_FEED:
          break;
        case x.NULL: {
          this._err(j.unexpectedNullCharacter), this._createDoctypeToken(Xe), this.state = S.DOCTYPE_NAME;
          break;
        }
        case x.GREATER_THAN_SIGN: {
          this._err(j.missingDoctypeName), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
          break;
        }
        case x.EOF: {
          this._err(j.eofInDoctype), this._createDoctypeToken(null);
          const n = this.currentToken;
          n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = S.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.AFTER_DOCTYPE_NAME;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.name += Xe;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.name += String.fromCodePoint(Ks(t) ? ha(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(vt.PUBLIC, !1) ? this.state = S.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(vt.SYSTEM, !1) ? this.state = S.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(j.invalidCharacterSequenceAfterDoctypeName), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case x.QUOTATION_MARK: {
        this._err(j.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this._err(j.missingWhitespaceAfterDoctypePublicKeyword), n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.QUOTATION_MARK: {
        n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        n.publicId = "", this.state = S.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypePublicIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.QUOTATION_MARK: {
        this.state = S.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.publicId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.APOSTROPHE: {
        this.state = S.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.publicId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypePublicIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.QUOTATION_MARK: {
        this._err(j.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this._err(j.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.QUOTATION_MARK: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED: {
        this.state = S.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case x.QUOTATION_MARK: {
        this._err(j.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        this._err(j.missingWhitespaceAfterDoctypeSystemKeyword), n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.QUOTATION_MARK: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case x.APOSTROPHE: {
        n.systemId = "", this.state = S.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.missingDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.DATA, this.emitCurrentDoctype(n);
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.missingQuoteBeforeDoctypeSystemIdentifier), n.forceQuirks = !0, this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.QUOTATION_MARK: {
        this.state = S.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.systemId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const n = this.currentToken;
    switch (t) {
      case x.APOSTROPHE: {
        this.state = S.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter), n.systemId += Xe;
        break;
      }
      case x.GREATER_THAN_SIGN: {
        this._err(j.abruptDoctypeSystemIdentifier), n.forceQuirks = !0, this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        n.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const n = this.currentToken;
    switch (t) {
      case x.SPACE:
      case x.LINE_FEED:
      case x.TABULATION:
      case x.FORM_FEED:
        break;
      case x.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.EOF: {
        this._err(j.eofInDoctype), n.forceQuirks = !0, this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
      default:
        this._err(j.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = S.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const n = this.currentToken;
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(n), this.state = S.DATA;
        break;
      }
      case x.NULL: {
        this._err(j.unexpectedNullCharacter);
        break;
      }
      case x.EOF: {
        this.emitCurrentDoctype(n), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case x.RIGHT_SQUARE_BRACKET: {
        this.state = S.CDATA_SECTION_BRACKET;
        break;
      }
      case x.EOF: {
        this._err(j.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === x.RIGHT_SQUARE_BRACKET ? this.state = S.CDATA_SECTION_END : (this._emitChars("]"), this.state = S.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case x.GREATER_THAN_SIGN: {
        this.state = S.DATA;
        break;
      }
      case x.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = S.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference() {
    let t = this.entityDecoder.write(this.preprocessor.html, this.preprocessor.pos);
    if (t < 0)
      if (this.preprocessor.lastChunkWritten)
        t = this.entityDecoder.end();
      else {
        this.active = !1, this.preprocessor.pos = this.preprocessor.html.length - 1, this.consumedAfterSnapshot = 0, this.preprocessor.endOfChunkHit = !0;
        return;
      }
    t === 0 ? (this.preprocessor.pos = this.entityStartPos, this._flushCodePointConsumedAsCharacterReference(x.AMPERSAND), this.state = !this._isCharacterReferenceInAttribute() && fp(this.preprocessor.peek(1)) ? S.AMBIGUOUS_AMPERSAND : this.returnState) : this.state = this.returnState;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    fp(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === x.SEMICOLON && this._err(j.unknownNamedCharacterReference), this.state = this.returnState, this._callState(t));
  }
}
const w_ = /* @__PURE__ */ new Set([f.DD, f.DT, f.LI, f.OPTGROUP, f.OPTION, f.P, f.RB, f.RP, f.RT, f.RTC]), mp = /* @__PURE__ */ new Set([
  ...w_,
  f.CAPTION,
  f.COLGROUP,
  f.TBODY,
  f.TD,
  f.TFOOT,
  f.TH,
  f.THEAD,
  f.TR
]), Xa = /* @__PURE__ */ new Set([
  f.APPLET,
  f.CAPTION,
  f.HTML,
  f.MARQUEE,
  f.OBJECT,
  f.TABLE,
  f.TD,
  f.TEMPLATE,
  f.TH
]), i4 = /* @__PURE__ */ new Set([...Xa, f.OL, f.UL]), a4 = /* @__PURE__ */ new Set([...Xa, f.BUTTON]), gp = /* @__PURE__ */ new Set([f.ANNOTATION_XML, f.MI, f.MN, f.MO, f.MS, f.MTEXT]), Ep = /* @__PURE__ */ new Set([f.DESC, f.FOREIGN_OBJECT, f.TITLE]), o4 = /* @__PURE__ */ new Set([f.TR, f.TEMPLATE, f.HTML]), u4 = /* @__PURE__ */ new Set([f.TBODY, f.TFOOT, f.THEAD, f.TEMPLATE, f.HTML]), c4 = /* @__PURE__ */ new Set([f.TABLE, f.TEMPLATE, f.HTML]), l4 = /* @__PURE__ */ new Set([f.TD, f.TH]);
class d4 {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, n, r) {
    this.treeAdapter = n, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = f.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === f.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === W.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, n) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = n, this.currentTagId = n, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, n, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, n) {
    const r = this._indexOf(t);
    this.items[r] = n, r === this.stackTop && (this.current = n);
  }
  insertAfter(t, n, r) {
    const s = this._indexOf(t) + 1;
    this.items.splice(s, 0, n), this.tagIDs.splice(s, 0, r), this.stackTop++, s === this.stackTop && this._updateCurrentElement(), this.current && this.currentTagId !== void 0 && this.handler.onItemPush(this.current, this.currentTagId, s === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let n = this.stackTop + 1;
    do
      n = this.tagIDs.lastIndexOf(t, n - 1);
    while (n > 0 && this.treeAdapter.getNamespaceURI(this.items[n]) !== W.HTML);
    this.shortenToLength(Math.max(n, 0));
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const n = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(n, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const n = this._indexOf(t);
    this.shortenToLength(Math.max(n, 0));
  }
  popUntilPopped(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(Math.max(r, 0));
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(Uc, W.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(l4, W.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, n) {
    for (let r = this.stackTop; r >= 0; r--)
      if (t.has(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === n)
        return r;
    return -1;
  }
  clearBackTo(t, n) {
    const r = this._indexOfTagNames(t, n);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(c4, W.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(u4, W.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(o4, W.HTML);
  }
  remove(t) {
    const n = this._indexOf(t);
    n >= 0 && (n === this.stackTop ? this.pop() : (this.items.splice(n, 1), this.tagIDs.splice(n, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === f.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const n = this._indexOf(t) - 1;
    return n >= 0 ? this.items[n] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === f.HTML;
  }
  //Element in scope
  hasInDynamicScope(t, n) {
    for (let r = this.stackTop; r >= 0; r--) {
      const s = this.tagIDs[r];
      switch (this.treeAdapter.getNamespaceURI(this.items[r])) {
        case W.HTML: {
          if (s === t)
            return !0;
          if (n.has(s))
            return !1;
          break;
        }
        case W.SVG: {
          if (Ep.has(s))
            return !1;
          break;
        }
        case W.MATHML: {
          if (gp.has(s))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInScope(t) {
    return this.hasInDynamicScope(t, Xa);
  }
  hasInListItemScope(t) {
    return this.hasInDynamicScope(t, i4);
  }
  hasInButtonScope(t) {
    return this.hasInDynamicScope(t, a4);
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.tagIDs[t];
      switch (this.treeAdapter.getNamespaceURI(this.items[t])) {
        case W.HTML: {
          if (Uc.has(n))
            return !0;
          if (Xa.has(n))
            return !1;
          break;
        }
        case W.SVG: {
          if (Ep.has(n))
            return !1;
          break;
        }
        case W.MATHML: {
          if (gp.has(n))
            return !1;
          break;
        }
      }
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === W.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === W.HTML)
        switch (this.tagIDs[t]) {
          case f.TBODY:
          case f.THEAD:
          case f.TFOOT:
            return !0;
          case f.TABLE:
          case f.HTML:
            return !1;
        }
    return !0;
  }
  hasInSelectScope(t) {
    for (let n = this.stackTop; n >= 0; n--)
      if (this.treeAdapter.getNamespaceURI(this.items[n]) === W.HTML)
        switch (this.tagIDs[n]) {
          case t:
            return !0;
          case f.OPTION:
          case f.OPTGROUP:
            break;
          default:
            return !1;
        }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; this.currentTagId !== void 0 && w_.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; this.currentTagId !== void 0 && mp.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== void 0 && this.currentTagId !== t && mp.has(this.currentTagId); )
      this.pop();
  }
}
const Yu = 3;
var mn;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(mn || (mn = {}));
const bp = { type: mn.Marker };
class h4 {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, n) {
    const r = [], s = n.length, i = this.treeAdapter.getTagName(t), a = this.treeAdapter.getNamespaceURI(t);
    for (let o = 0; o < this.entries.length; o++) {
      const u = this.entries[o];
      if (u.type === mn.Marker)
        break;
      const { element: c } = u;
      if (this.treeAdapter.getTagName(c) === i && this.treeAdapter.getNamespaceURI(c) === a) {
        const l = this.treeAdapter.getAttrList(c);
        l.length === s && r.push({ idx: o, attrs: l });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < Yu)
      return;
    const n = this.treeAdapter.getAttrList(t), r = this._getNoahArkConditionCandidates(t, n);
    if (r.length < Yu)
      return;
    const s = new Map(n.map((a) => [a.name, a.value]));
    let i = 0;
    for (let a = 0; a < r.length; a++) {
      const o = r[a];
      o.attrs.every((u) => s.get(u.name) === u.value) && (i += 1, i >= Yu && this.entries.splice(o.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(bp);
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: mn.Element,
      element: t,
      token: n
    });
  }
  insertElementAfterBookmark(t, n) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: mn.Element,
      element: t,
      token: n
    });
  }
  removeEntry(t) {
    const n = this.entries.indexOf(t);
    n !== -1 && this.entries.splice(n, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(bp);
    t === -1 ? this.entries.length = 0 : this.entries.splice(0, t + 1);
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const n = this.entries.find((r) => r.type === mn.Marker || this.treeAdapter.getTagName(r.element) === t);
    return n && n.type === mn.Element ? n : null;
  }
  getElementEntry(t) {
    return this.entries.find((n) => n.type === mn.Element && n.element === t);
  }
}
const Wn = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: Gt.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, n) {
    return {
      nodeName: e,
      tagName: e,
      attrs: n,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  createTextNode(e) {
    return {
      nodeName: "#text",
      value: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, n) {
    const r = e.childNodes.indexOf(n);
    e.childNodes.splice(r, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, n, r) {
    const s = e.childNodes.find((i) => i.nodeName === "#documentType");
    if (s)
      s.name = t, s.publicId = n, s.systemId = r;
    else {
      const i = {
        nodeName: "#documentType",
        name: t,
        publicId: n,
        systemId: r,
        parentNode: null
      };
      Wn.appendChild(e, i);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const n = e.childNodes[e.childNodes.length - 1];
      if (Wn.isTextNode(n)) {
        n.value += t;
        return;
      }
    }
    Wn.appendChild(e, Wn.createTextNode(t));
  },
  insertTextBefore(e, t, n) {
    const r = e.childNodes[e.childNodes.indexOf(n) - 1];
    r && Wn.isTextNode(r) ? r.value += t : Wn.insertBefore(e, Wn.createTextNode(t), n);
  },
  adoptAttributes(e, t) {
    const n = new Set(e.attrs.map((r) => r.name));
    for (let r = 0; r < t.length; r++)
      n.has(t[r].name) || e.attrs.push(t[r]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = { ...e.sourceCodeLocation, ...t };
  }
}, I_ = "html", f4 = "about:legacy-compat", p4 = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", v_ = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], m4 = [
  ...v_,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], g4 = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), N_ = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], E4 = [
  ...N_,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function _p(e, t) {
  return t.some((n) => e.startsWith(n));
}
function b4(e) {
  return e.name === I_ && e.publicId === null && (e.systemId === null || e.systemId === f4);
}
function _4(e) {
  if (e.name !== I_)
    return Gt.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === p4)
    return Gt.QUIRKS;
  let { publicId: n } = e;
  if (n !== null) {
    if (n = n.toLowerCase(), g4.has(n))
      return Gt.QUIRKS;
    let r = t === null ? m4 : v_;
    if (_p(n, r))
      return Gt.QUIRKS;
    if (r = t === null ? N_ : E4, _p(n, r))
      return Gt.LIMITED_QUIRKS;
  }
  return Gt.NO_QUIRKS;
}
const Tp = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, T4 = "definitionurl", A4 = "definitionURL", y4 = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), x4 = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: W.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: W.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: W.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: W.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: W.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: W.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: W.XLINK }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: W.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: W.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: W.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: W.XMLNS }]
]), C4 = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), S4 = /* @__PURE__ */ new Set([
  f.B,
  f.BIG,
  f.BLOCKQUOTE,
  f.BODY,
  f.BR,
  f.CENTER,
  f.CODE,
  f.DD,
  f.DIV,
  f.DL,
  f.DT,
  f.EM,
  f.EMBED,
  f.H1,
  f.H2,
  f.H3,
  f.H4,
  f.H5,
  f.H6,
  f.HEAD,
  f.HR,
  f.I,
  f.IMG,
  f.LI,
  f.LISTING,
  f.MENU,
  f.META,
  f.NOBR,
  f.OL,
  f.P,
  f.PRE,
  f.RUBY,
  f.S,
  f.SMALL,
  f.SPAN,
  f.STRONG,
  f.STRIKE,
  f.SUB,
  f.SUP,
  f.TABLE,
  f.TT,
  f.U,
  f.UL,
  f.VAR
]);
function w4(e) {
  const t = e.tagID;
  return t === f.FONT && e.attrs.some(({ name: r }) => r === Sr.COLOR || r === Sr.SIZE || r === Sr.FACE) || S4.has(t);
}
function k_(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === T4) {
      e.attrs[t].name = A4;
      break;
    }
}
function R_(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = y4.get(e.attrs[t].name);
    n != null && (e.attrs[t].name = n);
  }
}
function ld(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = x4.get(e.attrs[t].name);
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
}
function I4(e) {
  const t = C4.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = Is(e.tagName));
}
function v4(e, t) {
  return t === W.MATHML && (e === f.MI || e === f.MO || e === f.MN || e === f.MS || e === f.MTEXT);
}
function N4(e, t, n) {
  if (t === W.MATHML && e === f.ANNOTATION_XML) {
    for (let r = 0; r < n.length; r++)
      if (n[r].name === Sr.ENCODING) {
        const s = n[r].value.toLowerCase();
        return s === Tp.TEXT_HTML || s === Tp.APPLICATION_XML;
      }
  }
  return t === W.SVG && (e === f.FOREIGN_OBJECT || e === f.DESC || e === f.TITLE);
}
function k4(e, t, n, r) {
  return (!r || r === W.HTML) && N4(e, t, n) || (!r || r === W.MATHML) && v4(e, t);
}
const R4 = "hidden", P4 = 8, O4 = 3;
var I;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(I || (I = {}));
const D4 = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, P_ = /* @__PURE__ */ new Set([f.TABLE, f.TBODY, f.TFOOT, f.THEAD, f.TR]), Ap = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: Wn,
  onParseError: null
};
class yp {
  constructor(t, n, r = null, s = null) {
    this.fragmentContext = r, this.scriptHandler = s, this.currentToken = null, this.stopped = !1, this.insertionMode = I.INITIAL, this.originalInsertionMode = I.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = {
      ...Ap,
      ...t
    }, this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = n ?? this.treeAdapter.createDocument(), this.tokenizer = new s4(this.options, this), this.activeFormattingElements = new h4(this.treeAdapter), this.fragmentContextID = r ? Is(this.treeAdapter.getTagName(r)) : f.UNKNOWN, this._setContextModes(r ?? this.document, this.fragmentContextID), this.openElements = new d4(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, n) {
    const r = new this(n);
    return r.tokenizer.write(t, !0), r.document;
  }
  static getFragmentParser(t, n) {
    const r = {
      ...Ap,
      ...n
    };
    t ?? (t = r.treeAdapter.createElement(L.TEMPLATE, W.HTML, []));
    const s = r.treeAdapter.createElement("documentmock", W.HTML, []), i = new this(r, s, t);
    return i.fragmentContextID === f.TEMPLATE && i.tmplInsertionModeStack.unshift(I.IN_TEMPLATE), i._initTokenizerForFragmentParsing(), i._insertFakeRootElement(), i._resetInsertionMode(), i._findFormInFragmentContext(), i;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), n = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, n), n;
  }
  //Errors
  /** @internal */
  _err(t, n, r) {
    var s;
    if (!this.onParseError)
      return;
    const i = (s = t.location) !== null && s !== void 0 ? s : D4, a = {
      code: n,
      startLine: i.startLine,
      startCol: i.startCol,
      startOffset: i.startOffset,
      endLine: r ? i.startLine : i.endLine,
      endCol: r ? i.startCol : i.endCol,
      endOffset: r ? i.startOffset : i.endOffset
    };
    this.onParseError(a);
  }
  //Stack events
  /** @internal */
  onItemPush(t, n, r) {
    var s, i;
    (i = (s = this.treeAdapter).onItemPush) === null || i === void 0 || i.call(s, t), r && this.openElements.stackTop > 0 && this._setContextModes(t, n);
  }
  /** @internal */
  onItemPop(t, n) {
    var r, s;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (s = (r = this.treeAdapter).onItemPop) === null || s === void 0 || s.call(r, t, this.openElements.current), n) {
      let i, a;
      this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, a = this.fragmentContextID) : { current: i, currentTagId: a } = this.openElements, this._setContextModes(i, a);
    }
  }
  _setContextModes(t, n) {
    const r = t === this.document || t && this.treeAdapter.getNamespaceURI(t) === W.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && t !== void 0 && n !== void 0 && !this._isIntegrationPoint(n, t);
  }
  /** @protected */
  _switchToTextParsing(t, n) {
    this._insertElement(t, W.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = I.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = I.TEXT, this.originalInsertionMode = I.IN_BODY, this.tokenizer.state = nt.PLAINTEXT;
  }
  //Fragment parsing
  /** @protected */
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  /** @protected */
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === L.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== W.HTML))
      switch (this.fragmentContextID) {
        case f.TITLE:
        case f.TEXTAREA: {
          this.tokenizer.state = nt.RCDATA;
          break;
        }
        case f.STYLE:
        case f.XMP:
        case f.IFRAME:
        case f.NOEMBED:
        case f.NOFRAMES:
        case f.NOSCRIPT: {
          this.tokenizer.state = nt.RAWTEXT;
          break;
        }
        case f.SCRIPT: {
          this.tokenizer.state = nt.SCRIPT_DATA;
          break;
        }
        case f.PLAINTEXT: {
          this.tokenizer.state = nt.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  /** @protected */
  _setDocumentType(t) {
    const n = t.name || "", r = t.publicId || "", s = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, n, r, s), t.location) {
      const a = this.treeAdapter.getChildNodes(this.document).find((o) => this.treeAdapter.isDocumentTypeNode(o));
      a && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
    }
  }
  /** @protected */
  _attachElementToTree(t, n) {
    if (this.options.sourceCodeLocationInfo) {
      const r = n && {
        ...n,
        startTag: n
      };
      this.treeAdapter.setNodeSourceCodeLocation(t, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r ?? this.document, t);
    }
  }
  /**
   * For self-closing tags. Add an element to the tree, but skip adding it
   * to the stack.
   */
  /** @protected */
  _appendElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location);
  }
  /** @protected */
  _insertElement(t, n) {
    const r = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID);
  }
  /** @protected */
  _insertFakeElement(t, n) {
    const r = this.treeAdapter.createElement(t, W.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, n);
  }
  /** @protected */
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, W.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, r), this._attachElementToTree(n, t.location), this.openElements.push(n, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  /** @protected */
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(L.HTML, W.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, f.HTML);
  }
  /** @protected */
  _appendCommentNode(t, n) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  /** @protected */
  _insertCharacters(t) {
    let n, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: n, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(n, t.chars, r) : this.treeAdapter.insertText(n, t.chars)) : (n = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(n, t.chars)), !t.location)
      return;
    const s = this.treeAdapter.getChildNodes(n), i = r ? s.lastIndexOf(r) : s.length, a = s[i - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(a)) {
      const { endLine: u, endCol: c, endOffset: l } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(a, { endLine: u, endCol: c, endOffset: l });
    } else this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(a, t.location);
  }
  /** @protected */
  _adoptNodes(t, n) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(n, r);
  }
  /** @protected */
  _setEndLocation(t, n) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && n.location) {
      const r = n.location, s = this.treeAdapter.getTagName(t), i = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        n.type === Ne.END_TAG && s === n.tagName ? {
          endTag: { ...r },
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, i);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let n, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (n = this.fragmentContext, r = this.fragmentContextID) : { current: n, currentTagId: r } = this.openElements, t.tagID === f.SVG && this.treeAdapter.getTagName(n) === L.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(n) === W.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === f.MGLYPH || t.tagID === f.MALIGNMARK) && r !== void 0 && !this._isIntegrationPoint(r, n, W.HTML)
    );
  }
  /** @protected */
  _processToken(t) {
    switch (t.type) {
      case Ne.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case Ne.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case Ne.COMMENT: {
        this.onComment(t);
        break;
      }
      case Ne.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case Ne.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case Ne.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case Ne.EOF: {
        this.onEof(t);
        break;
      }
      case Ne.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  /** @protected */
  _isIntegrationPoint(t, n, r) {
    const s = this.treeAdapter.getNamespaceURI(n), i = this.treeAdapter.getAttrList(n);
    return k4(t, s, i, r);
  }
  //Active formatting elements reconstruction
  /** @protected */
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const n = this.activeFormattingElements.entries.findIndex((s) => s.type === mn.Marker || this.openElements.contains(s.element)), r = n === -1 ? t - 1 : n - 1;
      for (let s = r; s >= 0; s--) {
        const i = this.activeFormattingElements.entries[s];
        this._insertElement(i.token, this.treeAdapter.getNamespaceURI(i.element)), i.element = this.openElements.current;
      }
    }
  }
  //Close elements
  /** @protected */
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = I.IN_ROW;
  }
  /** @protected */
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(f.P), this.openElements.popUntilTagNamePopped(f.P);
  }
  //Insertion modes
  /** @protected */
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case f.TR: {
          this.insertionMode = I.IN_ROW;
          return;
        }
        case f.TBODY:
        case f.THEAD:
        case f.TFOOT: {
          this.insertionMode = I.IN_TABLE_BODY;
          return;
        }
        case f.CAPTION: {
          this.insertionMode = I.IN_CAPTION;
          return;
        }
        case f.COLGROUP: {
          this.insertionMode = I.IN_COLUMN_GROUP;
          return;
        }
        case f.TABLE: {
          this.insertionMode = I.IN_TABLE;
          return;
        }
        case f.BODY: {
          this.insertionMode = I.IN_BODY;
          return;
        }
        case f.FRAMESET: {
          this.insertionMode = I.IN_FRAMESET;
          return;
        }
        case f.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case f.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case f.HTML: {
          this.insertionMode = this.headElement ? I.AFTER_HEAD : I.BEFORE_HEAD;
          return;
        }
        case f.TD:
        case f.TH: {
          if (t > 0) {
            this.insertionMode = I.IN_CELL;
            return;
          }
          break;
        }
        case f.HEAD: {
          if (t > 0) {
            this.insertionMode = I.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = I.IN_BODY;
  }
  /** @protected */
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const r = this.openElements.tagIDs[n];
        if (r === f.TEMPLATE)
          break;
        if (r === f.TABLE) {
          this.insertionMode = I.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = I.IN_SELECT;
  }
  //Foster parenting
  /** @protected */
  _isElementCausesFosterParenting(t) {
    return P_.has(t);
  }
  /** @protected */
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this.openElements.currentTagId !== void 0 && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  /** @protected */
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const n = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case f.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(n) === W.HTML)
            return { parent: this.treeAdapter.getTemplateContent(n), beforeElement: null };
          break;
        }
        case f.TABLE: {
          const r = this.treeAdapter.getParentNode(n);
          return r ? { parent: r, beforeElement: n } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  /** @protected */
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  //Special elements
  /** @protected */
  _isSpecialElement(t, n) {
    const r = this.treeAdapter.getNamespaceURI(t);
    return e4[r].has(n);
  }
  /** @internal */
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      lH(this, t);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL: {
        Vs(this, t);
        break;
      }
      case I.BEFORE_HTML: {
        ii(this, t);
        break;
      }
      case I.BEFORE_HEAD: {
        ai(this, t);
        break;
      }
      case I.IN_HEAD: {
        oi(this, t);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        ui(this, t);
        break;
      }
      case I.AFTER_HEAD: {
        ci(this, t);
        break;
      }
      case I.IN_BODY:
      case I.IN_CAPTION:
      case I.IN_CELL:
      case I.IN_TEMPLATE: {
        D_(this, t);
        break;
      }
      case I.TEXT:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Gu(this, t);
        break;
      }
      case I.IN_TABLE_TEXT: {
        F_(this, t);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Ja(this, t);
        break;
      }
      case I.AFTER_BODY: {
        Za(this, t);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Sa(this, t);
        break;
      }
    }
  }
  /** @internal */
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      cH(this, t);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL: {
        Vs(this, t);
        break;
      }
      case I.BEFORE_HTML: {
        ii(this, t);
        break;
      }
      case I.BEFORE_HEAD: {
        ai(this, t);
        break;
      }
      case I.IN_HEAD: {
        oi(this, t);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        ui(this, t);
        break;
      }
      case I.AFTER_HEAD: {
        ci(this, t);
        break;
      }
      case I.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Gu(this, t);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        Ja(this, t);
        break;
      }
      case I.AFTER_BODY: {
        Za(this, t);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Sa(this, t);
        break;
      }
    }
  }
  /** @internal */
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Fc(this, t);
      return;
    }
    switch (this.insertionMode) {
      case I.INITIAL:
      case I.BEFORE_HTML:
      case I.BEFORE_HEAD:
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD:
      case I.IN_BODY:
      case I.IN_TABLE:
      case I.IN_CAPTION:
      case I.IN_COLUMN_GROUP:
      case I.IN_TABLE_BODY:
      case I.IN_ROW:
      case I.IN_CELL:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE:
      case I.IN_TEMPLATE:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET: {
        Fc(this, t);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Ys(this, t);
        break;
      }
      case I.AFTER_BODY: {
        j4(this, t);
        break;
      }
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        $4(this, t);
        break;
      }
    }
  }
  /** @internal */
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case I.INITIAL: {
        z4(this, t);
        break;
      }
      case I.BEFORE_HEAD:
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD: {
        this._err(t, j.misplacedDoctype);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Ys(this, t);
        break;
      }
    }
  }
  /** @internal */
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, j.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   * @protected
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? dH(this, t) : this._startTagOutsideForeignContent(t);
  }
  /** @protected */
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        Vs(this, t);
        break;
      }
      case I.BEFORE_HTML: {
        V4(this, t);
        break;
      }
      case I.BEFORE_HEAD: {
        G4(this, t);
        break;
      }
      case I.IN_HEAD: {
        hn(this, t);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        K4(this, t);
        break;
      }
      case I.AFTER_HEAD: {
        X4(this, t);
        break;
      }
      case I.IN_BODY: {
        yt(this, t);
        break;
      }
      case I.IN_TABLE: {
        gs(this, t);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Ys(this, t);
        break;
      }
      case I.IN_CAPTION: {
        W5(this, t);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        fd(this, t);
        break;
      }
      case I.IN_TABLE_BODY: {
        Wo(this, t);
        break;
      }
      case I.IN_ROW: {
        qo(this, t);
        break;
      }
      case I.IN_CELL: {
        Q5(this, t);
        break;
      }
      case I.IN_SELECT: {
        z_(this, t);
        break;
      }
      case I.IN_SELECT_IN_TABLE: {
        J5(this, t);
        break;
      }
      case I.IN_TEMPLATE: {
        eH(this, t);
        break;
      }
      case I.AFTER_BODY: {
        nH(this, t);
        break;
      }
      case I.IN_FRAMESET: {
        rH(this, t);
        break;
      }
      case I.AFTER_FRAMESET: {
        iH(this, t);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        oH(this, t);
        break;
      }
      case I.AFTER_AFTER_FRAMESET: {
        uH(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? hH(this, t) : this._endTagOutsideForeignContent(t);
  }
  /** @protected */
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        Vs(this, t);
        break;
      }
      case I.BEFORE_HTML: {
        Y4(this, t);
        break;
      }
      case I.BEFORE_HEAD: {
        W4(this, t);
        break;
      }
      case I.IN_HEAD: {
        q4(this, t);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        Q4(this, t);
        break;
      }
      case I.AFTER_HEAD: {
        J4(this, t);
        break;
      }
      case I.IN_BODY: {
        Go(this, t);
        break;
      }
      case I.TEXT: {
        H5(this, t);
        break;
      }
      case I.IN_TABLE: {
        _i(this, t);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Ys(this, t);
        break;
      }
      case I.IN_CAPTION: {
        q5(this, t);
        break;
      }
      case I.IN_COLUMN_GROUP: {
        K5(this, t);
        break;
      }
      case I.IN_TABLE_BODY: {
        jc(this, t);
        break;
      }
      case I.IN_ROW: {
        $_(this, t);
        break;
      }
      case I.IN_CELL: {
        X5(this, t);
        break;
      }
      case I.IN_SELECT: {
        V_(this, t);
        break;
      }
      case I.IN_SELECT_IN_TABLE: {
        Z5(this, t);
        break;
      }
      case I.IN_TEMPLATE: {
        tH(this, t);
        break;
      }
      case I.AFTER_BODY: {
        G_(this, t);
        break;
      }
      case I.IN_FRAMESET: {
        sH(this, t);
        break;
      }
      case I.AFTER_FRAMESET: {
        aH(this, t);
        break;
      }
      case I.AFTER_AFTER_BODY: {
        Sa(this, t);
        break;
      }
    }
  }
  /** @internal */
  onEof(t) {
    switch (this.insertionMode) {
      case I.INITIAL: {
        Vs(this, t);
        break;
      }
      case I.BEFORE_HTML: {
        ii(this, t);
        break;
      }
      case I.BEFORE_HEAD: {
        ai(this, t);
        break;
      }
      case I.IN_HEAD: {
        oi(this, t);
        break;
      }
      case I.IN_HEAD_NO_SCRIPT: {
        ui(this, t);
        break;
      }
      case I.AFTER_HEAD: {
        ci(this, t);
        break;
      }
      case I.IN_BODY:
      case I.IN_TABLE:
      case I.IN_CAPTION:
      case I.IN_COLUMN_GROUP:
      case I.IN_TABLE_BODY:
      case I.IN_ROW:
      case I.IN_CELL:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE: {
        B_(this, t);
        break;
      }
      case I.TEXT: {
        B5(this, t);
        break;
      }
      case I.IN_TABLE_TEXT: {
        Ys(this, t);
        break;
      }
      case I.IN_TEMPLATE: {
        Y_(this, t);
        break;
      }
      case I.AFTER_BODY:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET:
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        hd(this, t);
        break;
      }
    }
  }
  /** @internal */
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === x.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case I.IN_HEAD:
      case I.IN_HEAD_NO_SCRIPT:
      case I.AFTER_HEAD:
      case I.TEXT:
      case I.IN_COLUMN_GROUP:
      case I.IN_SELECT:
      case I.IN_SELECT_IN_TABLE:
      case I.IN_FRAMESET:
      case I.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case I.IN_BODY:
      case I.IN_CAPTION:
      case I.IN_CELL:
      case I.IN_TEMPLATE:
      case I.AFTER_BODY:
      case I.AFTER_AFTER_BODY:
      case I.AFTER_AFTER_FRAMESET: {
        O_(this, t);
        break;
      }
      case I.IN_TABLE:
      case I.IN_TABLE_BODY:
      case I.IN_ROW: {
        Gu(this, t);
        break;
      }
      case I.IN_TABLE_TEXT: {
        U_(this, t);
        break;
      }
    }
  }
}
function L4(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagID) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : H_(e, t), n;
}
function M4(e, t) {
  let n = null, r = e.openElements.stackTop;
  for (; r >= 0; r--) {
    const s = e.openElements.items[r];
    if (s === t.element)
      break;
    e._isSpecialElement(s, e.openElements.tagIDs[r]) && (n = s);
  }
  return n || (e.openElements.shortenToLength(Math.max(r, 0)), e.activeFormattingElements.removeEntry(t)), n;
}
function H4(e, t, n) {
  let r = t, s = e.openElements.getCommonAncestor(t);
  for (let i = 0, a = s; a !== n; i++, a = s) {
    s = e.openElements.getCommonAncestor(a);
    const o = e.activeFormattingElements.getElementEntry(a), u = o && i >= O4;
    !o || u ? (u && e.activeFormattingElements.removeEntry(o), e.openElements.remove(a)) : (a = B4(e, o), r === t && (e.activeFormattingElements.bookmark = o), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(a, r), r = a);
  }
  return r;
}
function B4(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function U4(e, t, n) {
  const r = e.treeAdapter.getTagName(t), s = Is(r);
  if (e._isElementCausesFosterParenting(s))
    e._fosterParentElement(n);
  else {
    const i = e.treeAdapter.getNamespaceURI(t);
    s === f.TEMPLATE && i === W.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function F4(e, t, n) {
  const r = e.treeAdapter.getNamespaceURI(n.element), { token: s } = n, i = e.treeAdapter.createElement(s.tagName, r, s.attrs);
  e._adoptNodes(t, i), e.treeAdapter.appendChild(t, i), e.activeFormattingElements.insertElementAfterBookmark(i, s), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, i, s.tagID);
}
function dd(e, t) {
  for (let n = 0; n < P4; n++) {
    const r = L4(e, t);
    if (!r)
      break;
    const s = M4(e, r);
    if (!s)
      break;
    e.activeFormattingElements.bookmark = r;
    const i = H4(e, s, r.element), a = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(i), a && U4(e, a, i), F4(e, s, r);
  }
}
function Fc(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function j4(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function $4(e, t) {
  e._appendCommentNode(t, e.document);
}
function hd(e, t) {
  if (e.stopped = !0, t.location) {
    const n = e.fragmentContext ? 0 : 2;
    for (let r = e.openElements.stackTop; r >= n; r--)
      e._setEndLocation(e.openElements.items[r], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const r = e.openElements.items[0], s = e.treeAdapter.getNodeSourceCodeLocation(r);
      if (s && !s.endTag && (e._setEndLocation(r, t), e.openElements.stackTop >= 1)) {
        const i = e.openElements.items[1], a = e.treeAdapter.getNodeSourceCodeLocation(i);
        a && !a.endTag && e._setEndLocation(i, t);
      }
    }
  }
}
function z4(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? Gt.QUIRKS : _4(t);
  b4(t) || e._err(t, j.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = I.BEFORE_HTML;
}
function Vs(e, t) {
  e._err(t, j.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, Gt.QUIRKS), e.insertionMode = I.BEFORE_HTML, e._processToken(t);
}
function V4(e, t) {
  t.tagID === f.HTML ? (e._insertElement(t, W.HTML), e.insertionMode = I.BEFORE_HEAD) : ii(e, t);
}
function Y4(e, t) {
  const n = t.tagID;
  (n === f.HTML || n === f.HEAD || n === f.BODY || n === f.BR) && ii(e, t);
}
function ii(e, t) {
  e._insertFakeRootElement(), e.insertionMode = I.BEFORE_HEAD, e._processToken(t);
}
function G4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.HEAD: {
      e._insertElement(t, W.HTML), e.headElement = e.openElements.current, e.insertionMode = I.IN_HEAD;
      break;
    }
    default:
      ai(e, t);
  }
}
function W4(e, t) {
  const n = t.tagID;
  n === f.HEAD || n === f.BODY || n === f.HTML || n === f.BR ? ai(e, t) : e._err(t, j.endTagWithoutMatchingOpenElement);
}
function ai(e, t) {
  e._insertFakeElement(L.HEAD, f.HEAD), e.headElement = e.openElements.current, e.insertionMode = I.IN_HEAD, e._processToken(t);
}
function hn(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.TITLE: {
      e._switchToTextParsing(t, nt.RCDATA);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, nt.RAWTEXT) : (e._insertElement(t, W.HTML), e.insertionMode = I.IN_HEAD_NO_SCRIPT);
      break;
    }
    case f.NOFRAMES:
    case f.STYLE: {
      e._switchToTextParsing(t, nt.RAWTEXT);
      break;
    }
    case f.SCRIPT: {
      e._switchToTextParsing(t, nt.SCRIPT_DATA);
      break;
    }
    case f.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = I.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(I.IN_TEMPLATE);
      break;
    }
    case f.HEAD: {
      e._err(t, j.misplacedStartTagForHeadElement);
      break;
    }
    default:
      oi(e, t);
  }
}
function q4(e, t) {
  switch (t.tagID) {
    case f.HEAD: {
      e.openElements.pop(), e.insertionMode = I.AFTER_HEAD;
      break;
    }
    case f.BODY:
    case f.BR:
    case f.HTML: {
      oi(e, t);
      break;
    }
    case f.TEMPLATE: {
      jr(e, t);
      break;
    }
    default:
      e._err(t, j.endTagWithoutMatchingOpenElement);
  }
}
function jr(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== f.TEMPLATE && e._err(t, j.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, j.endTagWithoutMatchingOpenElement);
}
function oi(e, t) {
  e.openElements.pop(), e.insertionMode = I.AFTER_HEAD, e._processToken(t);
}
function K4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.BASEFONT:
    case f.BGSOUND:
    case f.HEAD:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.STYLE: {
      hn(e, t);
      break;
    }
    case f.NOSCRIPT: {
      e._err(t, j.nestedNoscriptInHead);
      break;
    }
    default:
      ui(e, t);
  }
}
function Q4(e, t) {
  switch (t.tagID) {
    case f.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = I.IN_HEAD;
      break;
    }
    case f.BR: {
      ui(e, t);
      break;
    }
    default:
      e._err(t, j.endTagWithoutMatchingOpenElement);
  }
}
function ui(e, t) {
  const n = t.type === Ne.EOF ? j.openElementsLeftAfterEof : j.disallowedContentInNoscriptInHead;
  e._err(t, n), e.openElements.pop(), e.insertionMode = I.IN_HEAD, e._processToken(t);
}
function X4(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.BODY: {
      e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = I.IN_BODY;
      break;
    }
    case f.FRAMESET: {
      e._insertElement(t, W.HTML), e.insertionMode = I.IN_FRAMESET;
      break;
    }
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      e._err(t, j.abandonedHeadElementChild), e.openElements.push(e.headElement, f.HEAD), hn(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case f.HEAD: {
      e._err(t, j.misplacedStartTagForHeadElement);
      break;
    }
    default:
      ci(e, t);
  }
}
function J4(e, t) {
  switch (t.tagID) {
    case f.BODY:
    case f.HTML:
    case f.BR: {
      ci(e, t);
      break;
    }
    case f.TEMPLATE: {
      jr(e, t);
      break;
    }
    default:
      e._err(t, j.endTagWithoutMatchingOpenElement);
  }
}
function ci(e, t) {
  e._insertFakeElement(L.BODY, f.BODY), e.insertionMode = I.IN_BODY, Yo(e, t);
}
function Yo(e, t) {
  switch (t.type) {
    case Ne.CHARACTER: {
      D_(e, t);
      break;
    }
    case Ne.WHITESPACE_CHARACTER: {
      O_(e, t);
      break;
    }
    case Ne.COMMENT: {
      Fc(e, t);
      break;
    }
    case Ne.START_TAG: {
      yt(e, t);
      break;
    }
    case Ne.END_TAG: {
      Go(e, t);
      break;
    }
    case Ne.EOF: {
      B_(e, t);
      break;
    }
  }
}
function O_(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function D_(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function Z4(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function e5(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function t5(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, W.HTML), e.insertionMode = I.IN_FRAMESET);
}
function n5(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML);
}
function r5(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e.openElements.currentTagId !== void 0 && Uc.has(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, W.HTML);
}
function s5(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function i5(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), n || (e.formElement = e.openElements.current));
}
function a5(e, t) {
  e.framesetOk = !1;
  const n = t.tagID;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const s = e.openElements.tagIDs[r];
    if (n === f.LI && s === f.LI || (n === f.DD || n === f.DT) && (s === f.DD || s === f.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(s), e.openElements.popUntilTagNamePopped(s);
      break;
    }
    if (s !== f.ADDRESS && s !== f.DIV && s !== f.P && e._isSpecialElement(e.openElements.items[r], s))
      break;
  }
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML);
}
function o5(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), e.tokenizer.state = nt.PLAINTEXT;
}
function u5(e, t) {
  e.openElements.hasInScope(f.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.framesetOk = !1;
}
function c5(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(L.A);
  n && (dd(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function l5(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function d5(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(f.NOBR) && (dd(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, W.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function h5(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function f5(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== Gt.QUIRKS && e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = I.IN_TABLE;
}
function L_(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, W.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function M_(e) {
  const t = C_(e, Sr.TYPE);
  return t != null && t.toLowerCase() === R4;
}
function p5(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, W.HTML), M_(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function m5(e, t) {
  e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
}
function g5(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._appendElement(t, W.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function E5(e, t) {
  t.tagName = L.IMG, t.tagID = f.IMG, L_(e, t);
}
function b5(e, t) {
  e._insertElement(t, W.HTML), e.skipNextNewLine = !0, e.tokenizer.state = nt.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = I.TEXT;
}
function _5(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, nt.RAWTEXT);
}
function T5(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, nt.RAWTEXT);
}
function xp(e, t) {
  e._switchToTextParsing(t, nt.RAWTEXT);
}
function A5(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === I.IN_TABLE || e.insertionMode === I.IN_CAPTION || e.insertionMode === I.IN_TABLE_BODY || e.insertionMode === I.IN_ROW || e.insertionMode === I.IN_CELL ? I.IN_SELECT_IN_TABLE : I.IN_SELECT;
}
function y5(e, t) {
  e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML);
}
function x5(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, W.HTML);
}
function C5(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(f.RTC), e._insertElement(t, W.HTML);
}
function S5(e, t) {
  e._reconstructActiveFormattingElements(), k_(t), ld(t), t.selfClosing ? e._appendElement(t, W.MATHML) : e._insertElement(t, W.MATHML), t.ackSelfClosing = !0;
}
function w5(e, t) {
  e._reconstructActiveFormattingElements(), R_(t), ld(t), t.selfClosing ? e._appendElement(t, W.SVG) : e._insertElement(t, W.SVG), t.ackSelfClosing = !0;
}
function Cp(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, W.HTML);
}
function yt(e, t) {
  switch (t.tagID) {
    case f.I:
    case f.S:
    case f.B:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      l5(e, t);
      break;
    }
    case f.A: {
      c5(e, t);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      r5(e, t);
      break;
    }
    case f.P:
    case f.DL:
    case f.OL:
    case f.UL:
    case f.DIV:
    case f.DIR:
    case f.NAV:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.DETAILS:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      n5(e, t);
      break;
    }
    case f.LI:
    case f.DD:
    case f.DT: {
      a5(e, t);
      break;
    }
    case f.BR:
    case f.IMG:
    case f.WBR:
    case f.AREA:
    case f.EMBED:
    case f.KEYGEN: {
      L_(e, t);
      break;
    }
    case f.HR: {
      g5(e, t);
      break;
    }
    case f.RB:
    case f.RTC: {
      x5(e, t);
      break;
    }
    case f.RT:
    case f.RP: {
      C5(e, t);
      break;
    }
    case f.PRE:
    case f.LISTING: {
      s5(e, t);
      break;
    }
    case f.XMP: {
      _5(e, t);
      break;
    }
    case f.SVG: {
      w5(e, t);
      break;
    }
    case f.HTML: {
      Z4(e, t);
      break;
    }
    case f.BASE:
    case f.LINK:
    case f.META:
    case f.STYLE:
    case f.TITLE:
    case f.SCRIPT:
    case f.BGSOUND:
    case f.BASEFONT:
    case f.TEMPLATE: {
      hn(e, t);
      break;
    }
    case f.BODY: {
      e5(e, t);
      break;
    }
    case f.FORM: {
      i5(e, t);
      break;
    }
    case f.NOBR: {
      d5(e, t);
      break;
    }
    case f.MATH: {
      S5(e, t);
      break;
    }
    case f.TABLE: {
      f5(e, t);
      break;
    }
    case f.INPUT: {
      p5(e, t);
      break;
    }
    case f.PARAM:
    case f.TRACK:
    case f.SOURCE: {
      m5(e, t);
      break;
    }
    case f.IMAGE: {
      E5(e, t);
      break;
    }
    case f.BUTTON: {
      u5(e, t);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      h5(e, t);
      break;
    }
    case f.IFRAME: {
      T5(e, t);
      break;
    }
    case f.SELECT: {
      A5(e, t);
      break;
    }
    case f.OPTION:
    case f.OPTGROUP: {
      y5(e, t);
      break;
    }
    case f.NOEMBED:
    case f.NOFRAMES: {
      xp(e, t);
      break;
    }
    case f.FRAMESET: {
      t5(e, t);
      break;
    }
    case f.TEXTAREA: {
      b5(e, t);
      break;
    }
    case f.NOSCRIPT: {
      e.options.scriptingEnabled ? xp(e, t) : Cp(e, t);
      break;
    }
    case f.PLAINTEXT: {
      o5(e, t);
      break;
    }
    case f.COL:
    case f.TH:
    case f.TD:
    case f.TR:
    case f.HEAD:
    case f.FRAME:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.CAPTION:
    case f.COLGROUP:
      break;
    default:
      Cp(e, t);
  }
}
function I5(e, t) {
  if (e.openElements.hasInScope(f.BODY) && (e.insertionMode = I.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const n = e.openElements.tryPeekProperlyNestedBodyElement();
    n && e._setEndLocation(n, t);
  }
}
function v5(e, t) {
  e.openElements.hasInScope(f.BODY) && (e.insertionMode = I.AFTER_BODY, G_(e, t));
}
function N5(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function k5(e) {
  const t = e.openElements.tmplCount > 0, { formElement: n } = e;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(f.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(f.FORM) : n && e.openElements.remove(n));
}
function R5(e) {
  e.openElements.hasInButtonScope(f.P) || e._insertFakeElement(L.P, f.P), e._closePElement();
}
function P5(e) {
  e.openElements.hasInListItemScope(f.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(f.LI), e.openElements.popUntilTagNamePopped(f.LI));
}
function O5(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function D5(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function L5(e, t) {
  const n = t.tagID;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function M5(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(L.BR, f.BR), e.openElements.pop(), e.framesetOk = !1;
}
function H_(e, t) {
  const n = t.tagName, r = t.tagID;
  for (let s = e.openElements.stackTop; s > 0; s--) {
    const i = e.openElements.items[s], a = e.openElements.tagIDs[s];
    if (r === a && (r !== f.UNKNOWN || e.treeAdapter.getTagName(i) === n)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.stackTop >= s && e.openElements.shortenToLength(s);
      break;
    }
    if (e._isSpecialElement(i, a))
      break;
  }
}
function Go(e, t) {
  switch (t.tagID) {
    case f.A:
    case f.B:
    case f.I:
    case f.S:
    case f.U:
    case f.EM:
    case f.TT:
    case f.BIG:
    case f.CODE:
    case f.FONT:
    case f.NOBR:
    case f.SMALL:
    case f.STRIKE:
    case f.STRONG: {
      dd(e, t);
      break;
    }
    case f.P: {
      R5(e);
      break;
    }
    case f.DL:
    case f.UL:
    case f.OL:
    case f.DIR:
    case f.DIV:
    case f.NAV:
    case f.PRE:
    case f.MAIN:
    case f.MENU:
    case f.ASIDE:
    case f.BUTTON:
    case f.CENTER:
    case f.FIGURE:
    case f.FOOTER:
    case f.HEADER:
    case f.HGROUP:
    case f.DIALOG:
    case f.ADDRESS:
    case f.ARTICLE:
    case f.DETAILS:
    case f.SEARCH:
    case f.SECTION:
    case f.SUMMARY:
    case f.LISTING:
    case f.FIELDSET:
    case f.BLOCKQUOTE:
    case f.FIGCAPTION: {
      N5(e, t);
      break;
    }
    case f.LI: {
      P5(e);
      break;
    }
    case f.DD:
    case f.DT: {
      O5(e, t);
      break;
    }
    case f.H1:
    case f.H2:
    case f.H3:
    case f.H4:
    case f.H5:
    case f.H6: {
      D5(e);
      break;
    }
    case f.BR: {
      M5(e);
      break;
    }
    case f.BODY: {
      I5(e, t);
      break;
    }
    case f.HTML: {
      v5(e, t);
      break;
    }
    case f.FORM: {
      k5(e);
      break;
    }
    case f.APPLET:
    case f.OBJECT:
    case f.MARQUEE: {
      L5(e, t);
      break;
    }
    case f.TEMPLATE: {
      jr(e, t);
      break;
    }
    default:
      H_(e, t);
  }
}
function B_(e, t) {
  e.tmplInsertionModeStack.length > 0 ? Y_(e, t) : hd(e, t);
}
function H5(e, t) {
  var n;
  t.tagID === f.SCRIPT && ((n = e.scriptHandler) === null || n === void 0 || n.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function B5(e, t) {
  e._err(t, j.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function Gu(e, t) {
  if (e.openElements.currentTagId !== void 0 && P_.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = I.IN_TABLE_TEXT, t.type) {
      case Ne.CHARACTER: {
        F_(e, t);
        break;
      }
      case Ne.WHITESPACE_CHARACTER: {
        U_(e, t);
        break;
      }
    }
  else
    Bi(e, t);
}
function U5(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, W.HTML), e.insertionMode = I.IN_CAPTION;
}
function F5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, W.HTML), e.insertionMode = I.IN_COLUMN_GROUP;
}
function j5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(L.COLGROUP, f.COLGROUP), e.insertionMode = I.IN_COLUMN_GROUP, fd(e, t);
}
function $5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, W.HTML), e.insertionMode = I.IN_TABLE_BODY;
}
function z5(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(L.TBODY, f.TBODY), e.insertionMode = I.IN_TABLE_BODY, Wo(e, t);
}
function V5(e, t) {
  e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function Y5(e, t) {
  M_(t) ? e._appendElement(t, W.HTML) : Bi(e, t), t.ackSelfClosing = !0;
}
function G5(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, W.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function gs(e, t) {
  switch (t.tagID) {
    case f.TD:
    case f.TH:
    case f.TR: {
      z5(e, t);
      break;
    }
    case f.STYLE:
    case f.SCRIPT:
    case f.TEMPLATE: {
      hn(e, t);
      break;
    }
    case f.COL: {
      j5(e, t);
      break;
    }
    case f.FORM: {
      G5(e, t);
      break;
    }
    case f.TABLE: {
      V5(e, t);
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      $5(e, t);
      break;
    }
    case f.INPUT: {
      Y5(e, t);
      break;
    }
    case f.CAPTION: {
      U5(e, t);
      break;
    }
    case f.COLGROUP: {
      F5(e, t);
      break;
    }
    default:
      Bi(e, t);
  }
}
function _i(e, t) {
  switch (t.tagID) {
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      jr(e, t);
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      Bi(e, t);
  }
}
function Bi(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, Yo(e, t), e.fosterParentingEnabled = n;
}
function U_(e, t) {
  e.pendingCharacterTokens.push(t);
}
function F_(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Ys(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      Bi(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const j_ = /* @__PURE__ */ new Set([f.CAPTION, f.COL, f.COLGROUP, f.TBODY, f.TD, f.TFOOT, f.TH, f.THEAD, f.TR]);
function W5(e, t) {
  const n = t.tagID;
  j_.has(n) ? e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = I.IN_TABLE, gs(e, t)) : yt(e, t);
}
function q5(e, t) {
  const n = t.tagID;
  switch (n) {
    case f.CAPTION:
    case f.TABLE: {
      e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = I.IN_TABLE, n === f.TABLE && _i(e, t));
      break;
    }
    case f.BODY:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TBODY:
    case f.TD:
    case f.TFOOT:
    case f.TH:
    case f.THEAD:
    case f.TR:
      break;
    default:
      Go(e, t);
  }
}
function fd(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.COL: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.TEMPLATE: {
      hn(e, t);
      break;
    }
    default:
      Ja(e, t);
  }
}
function K5(e, t) {
  switch (t.tagID) {
    case f.COLGROUP: {
      e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = I.IN_TABLE);
      break;
    }
    case f.TEMPLATE: {
      jr(e, t);
      break;
    }
    case f.COL:
      break;
    default:
      Ja(e, t);
  }
}
function Ja(e, t) {
  e.openElements.currentTagId === f.COLGROUP && (e.openElements.pop(), e.insertionMode = I.IN_TABLE, e._processToken(t));
}
function Wo(e, t) {
  switch (t.tagID) {
    case f.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, W.HTML), e.insertionMode = I.IN_ROW;
      break;
    }
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(L.TR, f.TR), e.insertionMode = I.IN_ROW, qo(e, t);
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE, gs(e, t));
      break;
    }
    default:
      gs(e, t);
  }
}
function jc(e, t) {
  const n = t.tagID;
  switch (t.tagID) {
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE);
      break;
    }
    case f.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE, _i(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
    case f.TR:
      break;
    default:
      _i(e, t);
  }
}
function qo(e, t) {
  switch (t.tagID) {
    case f.TH:
    case f.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, W.HTML), e.insertionMode = I.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY, Wo(e, t));
      break;
    }
    default:
      gs(e, t);
  }
}
function $_(e, t) {
  switch (t.tagID) {
    case f.TR: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY);
      break;
    }
    case f.TABLE: {
      e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY, jc(e, t));
      break;
    }
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(f.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = I.IN_TABLE_BODY, jc(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
    case f.TD:
    case f.TH:
      break;
    default:
      _i(e, t);
  }
}
function Q5(e, t) {
  const n = t.tagID;
  j_.has(n) ? (e.openElements.hasInTableScope(f.TD) || e.openElements.hasInTableScope(f.TH)) && (e._closeTableCell(), qo(e, t)) : yt(e, t);
}
function X5(e, t) {
  const n = t.tagID;
  switch (n) {
    case f.TD:
    case f.TH: {
      e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = I.IN_ROW);
      break;
    }
    case f.TABLE:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD:
    case f.TR: {
      e.openElements.hasInTableScope(n) && (e._closeTableCell(), $_(e, t));
      break;
    }
    case f.BODY:
    case f.CAPTION:
    case f.COL:
    case f.COLGROUP:
    case f.HTML:
      break;
    default:
      Go(e, t);
  }
}
function z_(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e._insertElement(t, W.HTML);
      break;
    }
    case f.OPTGROUP: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._insertElement(t, W.HTML);
      break;
    }
    case f.HR: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop(), e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.INPUT:
    case f.KEYGEN:
    case f.TEXTAREA:
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), t.tagID !== f.SELECT && e._processStartTag(t));
      break;
    }
    case f.SCRIPT:
    case f.TEMPLATE: {
      hn(e, t);
      break;
    }
  }
}
function V_(e, t) {
  switch (t.tagID) {
    case f.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === f.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === f.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === f.OPTGROUP && e.openElements.pop();
      break;
    }
    case f.OPTION: {
      e.openElements.currentTagId === f.OPTION && e.openElements.pop();
      break;
    }
    case f.SELECT: {
      e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode());
      break;
    }
    case f.TEMPLATE: {
      jr(e, t);
      break;
    }
  }
}
function J5(e, t) {
  const n = t.tagID;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : z_(e, t);
}
function Z5(e, t) {
  const n = t.tagID;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : V_(e, t);
}
function eH(e, t) {
  switch (t.tagID) {
    // First, handle tags that can start without a mode change
    case f.BASE:
    case f.BASEFONT:
    case f.BGSOUND:
    case f.LINK:
    case f.META:
    case f.NOFRAMES:
    case f.SCRIPT:
    case f.STYLE:
    case f.TEMPLATE:
    case f.TITLE: {
      hn(e, t);
      break;
    }
    // Re-process the token in the appropriate mode
    case f.CAPTION:
    case f.COLGROUP:
    case f.TBODY:
    case f.TFOOT:
    case f.THEAD: {
      e.tmplInsertionModeStack[0] = I.IN_TABLE, e.insertionMode = I.IN_TABLE, gs(e, t);
      break;
    }
    case f.COL: {
      e.tmplInsertionModeStack[0] = I.IN_COLUMN_GROUP, e.insertionMode = I.IN_COLUMN_GROUP, fd(e, t);
      break;
    }
    case f.TR: {
      e.tmplInsertionModeStack[0] = I.IN_TABLE_BODY, e.insertionMode = I.IN_TABLE_BODY, Wo(e, t);
      break;
    }
    case f.TD:
    case f.TH: {
      e.tmplInsertionModeStack[0] = I.IN_ROW, e.insertionMode = I.IN_ROW, qo(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = I.IN_BODY, e.insertionMode = I.IN_BODY, yt(e, t);
  }
}
function tH(e, t) {
  t.tagID === f.TEMPLATE && jr(e, t);
}
function Y_(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : hd(e, t);
}
function nH(e, t) {
  t.tagID === f.HTML ? yt(e, t) : Za(e, t);
}
function G_(e, t) {
  var n;
  if (t.tagID === f.HTML) {
    if (e.fragmentContext || (e.insertionMode = I.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === f.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const r = e.openElements.items[1];
      r && !(!((n = e.treeAdapter.getNodeSourceCodeLocation(r)) === null || n === void 0) && n.endTag) && e._setEndLocation(r, t);
    }
  } else
    Za(e, t);
}
function Za(e, t) {
  e.insertionMode = I.IN_BODY, Yo(e, t);
}
function rH(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.FRAMESET: {
      e._insertElement(t, W.HTML);
      break;
    }
    case f.FRAME: {
      e._appendElement(t, W.HTML), t.ackSelfClosing = !0;
      break;
    }
    case f.NOFRAMES: {
      hn(e, t);
      break;
    }
  }
}
function sH(e, t) {
  t.tagID === f.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== f.FRAMESET && (e.insertionMode = I.AFTER_FRAMESET));
}
function iH(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.NOFRAMES: {
      hn(e, t);
      break;
    }
  }
}
function aH(e, t) {
  t.tagID === f.HTML && (e.insertionMode = I.AFTER_AFTER_FRAMESET);
}
function oH(e, t) {
  t.tagID === f.HTML ? yt(e, t) : Sa(e, t);
}
function Sa(e, t) {
  e.insertionMode = I.IN_BODY, Yo(e, t);
}
function uH(e, t) {
  switch (t.tagID) {
    case f.HTML: {
      yt(e, t);
      break;
    }
    case f.NOFRAMES: {
      hn(e, t);
      break;
    }
  }
}
function cH(e, t) {
  t.chars = Xe, e._insertCharacters(t);
}
function lH(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function W_(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== W.HTML && e.openElements.currentTagId !== void 0 && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function dH(e, t) {
  if (w4(t))
    W_(e), e._startTagOutsideForeignContent(t);
  else {
    const n = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(n);
    r === W.MATHML ? k_(t) : r === W.SVG && (I4(t), R_(t)), ld(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function hH(e, t) {
  if (t.tagID === f.P || t.tagID === f.BR) {
    W_(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const r = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(r) === W.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const s = e.treeAdapter.getTagName(r);
    if (s.toLowerCase() === t.tagName) {
      t.tagName = s, e.openElements.shortenToLength(n);
      break;
    }
  }
}
L.AREA, L.BASE, L.BASEFONT, L.BGSOUND, L.BR, L.COL, L.EMBED, L.FRAME, L.HR, L.IMG, L.INPUT, L.KEYGEN, L.LINK, L.META, L.PARAM, L.SOURCE, L.TRACK, L.WBR;
const fH = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|textarea|title|xmp)(?=[\t\n\f\r />])/gi, pH = /* @__PURE__ */ new Set([
  "mdxFlowExpression",
  "mdxJsxFlowElement",
  "mdxJsxTextElement",
  "mdxTextExpression",
  "mdxjsEsm"
]), Sp = { sourceCodeLocationInfo: !0, scriptingEnabled: !1 };
function q_(e, t) {
  const n = CH(e), r = __("type", {
    handlers: { root: mH, element: gH, text: EH, comment: Q_, doctype: bH, raw: TH },
    unknown: AH
  }), s = {
    parser: n ? new yp(Sp) : yp.getFragmentParser(void 0, Sp),
    handle(o) {
      r(o, s);
    },
    stitches: !1,
    options: t || {}
  };
  r(e, s), vs(s, xn());
  const i = n ? s.parser.document : s.parser.getFragment(), a = S6(i, {
    // To do: support `space`?
    file: s.options.file
  });
  return s.stitches && Vo(a, "comment", function(o, u, c) {
    const l = (
      /** @type {Stitch} */
      /** @type {unknown} */
      o
    );
    if (l.value.stitch && c && u !== void 0) {
      const h = c.children;
      return h[u] = l.value.stitch, u;
    }
  }), a.type === "root" && a.children.length === 1 && a.children[0].type === e.type ? a.children[0] : a;
}
function K_(e, t) {
  let n = -1;
  if (e)
    for (; ++n < e.length; )
      t.handle(e[n]);
}
function mH(e, t) {
  K_(e.children, t);
}
function gH(e, t) {
  yH(e, t), K_(e.children, t), xH(e, t);
}
function EH(e, t) {
  t.parser.tokenizer.state > 4 && (t.parser.tokenizer.state = 0);
  const n = {
    type: Ne.CHARACTER,
    chars: e.value,
    location: Ui(e)
  };
  vs(t, xn(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function bH(e, t) {
  const n = {
    type: Ne.DOCTYPE,
    name: "html",
    forceQuirks: !1,
    publicId: "",
    systemId: "",
    location: Ui(e)
  };
  vs(t, xn(e)), t.parser.currentToken = n, t.parser._processToken(t.parser.currentToken);
}
function _H(e, t) {
  t.stitches = !0;
  const n = SH(e);
  if ("children" in e && "children" in n) {
    const r = (
      /** @type {Root} */
      q_({ type: "root", children: e.children }, t.options)
    );
    n.children = r.children;
  }
  Q_({ type: "comment", value: { stitch: n } }, t);
}
function Q_(e, t) {
  const n = e.value, r = {
    type: Ne.COMMENT,
    data: n,
    location: Ui(e)
  };
  vs(t, xn(e)), t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken);
}
function TH(e, t) {
  if (t.parser.tokenizer.preprocessor.html = "", t.parser.tokenizer.preprocessor.pos = -1, t.parser.tokenizer.preprocessor.lastGapPos = -2, t.parser.tokenizer.preprocessor.gapStack = [], t.parser.tokenizer.preprocessor.skipNextNewLine = !1, t.parser.tokenizer.preprocessor.lastChunkWritten = !1, t.parser.tokenizer.preprocessor.endOfChunkHit = !1, t.parser.tokenizer.preprocessor.isEol = !1, X_(t, xn(e)), t.parser.tokenizer.write(
    t.options.tagfilter ? e.value.replace(fH, "&lt;$1$2") : e.value,
    !1
  ), t.parser.tokenizer._runParsingLoop(), t.parser.tokenizer.state === 72 || // @ts-expect-error: removed.
  t.parser.tokenizer.state === 78) {
    t.parser.tokenizer.preprocessor.lastChunkWritten = !0;
    const n = t.parser.tokenizer._consume();
    t.parser.tokenizer._callState(n);
  }
}
function AH(e, t) {
  const n = (
    /** @type {Nodes} */
    e
  );
  if (t.options.passThrough && t.options.passThrough.includes(n.type))
    _H(n, t);
  else {
    let r = "";
    throw pH.has(n.type) && (r = ". It looks like you are using MDX nodes with `hast-util-raw` (or `rehype-raw`). If you use this because you are using remark or rehype plugins that inject `'html'` nodes, then please raise an issue with that plugin, as its a bad and slow idea. If you use this because you are using markdown syntax, then you have to configure this utility (or plugin) to pass through these nodes (see `passThrough` in docs), but you can also migrate to use the MDX syntax"), new Error("Cannot compile `" + n.type + "` node" + r);
  }
}
function vs(e, t) {
  X_(e, t);
  const n = e.parser.tokenizer.currentCharacterToken;
  n && n.location && (n.location.endLine = e.parser.tokenizer.preprocessor.line, n.location.endCol = e.parser.tokenizer.preprocessor.col + 1, n.location.endOffset = e.parser.tokenizer.preprocessor.offset + 1, e.parser.currentToken = n, e.parser._processToken(e.parser.currentToken)), e.parser.tokenizer.paused = !1, e.parser.tokenizer.inLoop = !1, e.parser.tokenizer.active = !1, e.parser.tokenizer.returnState = nt.DATA, e.parser.tokenizer.charRefCode = -1, e.parser.tokenizer.consumedAfterSnapshot = -1, e.parser.tokenizer.currentLocation = null, e.parser.tokenizer.currentCharacterToken = null, e.parser.tokenizer.currentToken = null, e.parser.tokenizer.currentAttr = { name: "", value: "" };
}
function X_(e, t) {
  if (t && t.offset !== void 0) {
    const n = {
      startLine: t.line,
      startCol: t.column,
      startOffset: t.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    e.parser.tokenizer.preprocessor.lineStartPos = -t.column + 1, e.parser.tokenizer.preprocessor.droppedBufferSize = t.offset, e.parser.tokenizer.preprocessor.line = t.line, e.parser.tokenizer.currentLocation = n;
  }
}
function yH(e, t) {
  const n = e.tagName.toLowerCase();
  if (t.parser.tokenizer.state === nt.PLAINTEXT) return;
  vs(t, xn(e));
  const r = t.parser.openElements.current;
  let s = "namespaceURI" in r ? r.namespaceURI : yr.html;
  s === yr.html && n === "svg" && (s = yr.svg);
  const i = k6(
    // Shallow clone to not delve into `children`: we only need the attributes.
    { ...e, children: [] },
    { space: s === yr.svg ? "svg" : "html" }
  ), a = {
    type: Ne.START_TAG,
    tagName: n,
    tagID: Is(n),
    // We always send start and end tags.
    selfClosing: !1,
    ackSelfClosing: !1,
    // Always element.
    /* c8 ignore next */
    attrs: "attrs" in i ? i.attrs : [],
    location: Ui(e)
  };
  t.parser.currentToken = a, t.parser._processToken(t.parser.currentToken), t.parser.tokenizer.lastStartTagName = n;
}
function xH(e, t) {
  const n = e.tagName.toLowerCase();
  if (!t.parser.tokenizer.inForeignNode && B6.includes(n) || t.parser.tokenizer.state === nt.PLAINTEXT) return;
  vs(t, Bo(e));
  const r = {
    type: Ne.END_TAG,
    tagName: n,
    tagID: Is(n),
    selfClosing: !1,
    ackSelfClosing: !1,
    attrs: [],
    location: Ui(e)
  };
  t.parser.currentToken = r, t.parser._processToken(t.parser.currentToken), // Current element is closed.
  n === t.parser.tokenizer.lastStartTagName && // `<textarea>` and `<title>`
  (t.parser.tokenizer.state === nt.RCDATA || // `<iframe>`, `<noembed>`, `<noframes>`, `<style>`, `<xmp>`
  t.parser.tokenizer.state === nt.RAWTEXT || // `<script>`
  t.parser.tokenizer.state === nt.SCRIPT_DATA) && (t.parser.tokenizer.state = nt.DATA);
}
function CH(e) {
  const t = e.type === "root" ? e.children[0] : e;
  return !!(t && (t.type === "doctype" || t.type === "element" && t.tagName.toLowerCase() === "html"));
}
function Ui(e) {
  const t = xn(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  }, n = Bo(e) || {
    line: void 0,
    column: void 0,
    offset: void 0
  };
  return {
    startLine: t.line,
    startCol: t.column,
    startOffset: t.offset,
    endLine: n.line,
    endCol: n.column,
    endOffset: n.offset
  };
}
function SH(e) {
  return "children" in e ? ms({ ...e, children: [] }) : ms(e);
}
function J_(e) {
  return function(t, n) {
    return (
      /** @type {Root} */
      q_(t, { ...e, file: n })
    );
  };
}
function wp(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, s = n.indexOf(t);
  for (; s !== -1; )
    r++, s = n.indexOf(t, s + t.length);
  return r;
}
function wH(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function IH(e, t, n) {
  const s = $o((n || {}).ignore || []), i = vH(t);
  let a = -1;
  for (; ++a < i.length; )
    l_(e, "text", o);
  function o(c, l) {
    let h = -1, m;
    for (; ++h < l.length; ) {
      const p = l[h], E = m ? m.children : void 0;
      if (s(
        p,
        E ? E.indexOf(p) : void 0,
        m
      ))
        return;
      m = p;
    }
    if (m)
      return u(c, l);
  }
  function u(c, l) {
    const h = l[l.length - 1], m = i[a][0], p = i[a][1];
    let E = 0;
    const _ = h.children.indexOf(c);
    let b = !1, T = [];
    m.lastIndex = 0;
    let C = m.exec(c.value);
    for (; C; ) {
      const R = C.index, D = {
        index: C.index,
        input: C.input,
        stack: [...l, c]
      };
      let w = p(...C, D);
      if (typeof w == "string" && (w = w.length > 0 ? { type: "text", value: w } : void 0), w === !1 ? m.lastIndex = R + 1 : (E !== R && T.push({
        type: "text",
        value: c.value.slice(E, R)
      }), Array.isArray(w) ? T.push(...w) : w && T.push(w), E = R + C[0].length, b = !0), !m.global)
        break;
      C = m.exec(c.value);
    }
    return b ? (E < c.value.length && T.push({ type: "text", value: c.value.slice(E) }), h.children.splice(_, 1, ...T)) : T = [c], _ + T.length;
  }
}
function vH(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const s = n[r];
    t.push([NH(s[0]), kH(s[1])]);
  }
  return t;
}
function NH(e) {
  return typeof e == "string" ? new RegExp(wH(e), "g") : e;
}
function kH(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const Wu = "phrasing", qu = ["autolink", "link", "image", "label"];
function RH() {
  return {
    transforms: [BH],
    enter: {
      literalAutolink: OH,
      literalAutolinkEmail: Ku,
      literalAutolinkHttp: Ku,
      literalAutolinkWww: Ku
    },
    exit: {
      literalAutolink: HH,
      literalAutolinkEmail: MH,
      literalAutolinkHttp: DH,
      literalAutolinkWww: LH
    }
  };
}
function PH() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: Wu,
        notInConstruct: qu
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: Wu,
        notInConstruct: qu
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: Wu,
        notInConstruct: qu
      }
    ]
  };
}
function OH(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Ku(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function DH(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function LH(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function MH(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function HH(e) {
  this.exit(e);
}
function BH(e) {
  IH(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, UH],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, FH]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function UH(e, t, n, r, s) {
  let i = "";
  if (!Z_(s) || (/^w/i.test(t) && (n = t + n, t = "", i = "http://"), !jH(n)))
    return !1;
  const a = $H(n + r);
  if (!a[0]) return !1;
  const o = {
    type: "link",
    title: null,
    url: i + t + a[0],
    children: [{ type: "text", value: t + a[0] }]
  };
  return a[1] ? [o, { type: "text", value: a[1] }] : o;
}
function FH(e, t, n, r) {
  return (
    // Not an expected previous character.
    !Z_(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function jH(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function $H(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const s = wp(e, "(");
  let i = wp(e, ")");
  for (; r !== -1 && s > i; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), i++;
  return [e, n];
}
function Z_(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Or(n) || Uo(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
eT.peek = XH;
function zH() {
  this.buffer();
}
function VH(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function YH() {
  this.buffer();
}
function GH(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function WH(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = an(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function qH(e) {
  this.exit(e);
}
function KH(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.identifier = an(
    this.sliceSerialize(e)
  ).toLowerCase(), n.label = t;
}
function QH(e) {
  this.exit(e);
}
function XH() {
  return "[";
}
function eT(e, t, n, r) {
  const s = n.createTracker(r);
  let i = s.move("[^");
  const a = n.enter("footnoteReference"), o = n.enter("reference");
  return i += s.move(
    n.safe(n.associationId(e), { after: "]", before: i })
  ), o(), a(), i += s.move("]"), i;
}
function JH() {
  return {
    enter: {
      gfmFootnoteCallString: zH,
      gfmFootnoteCall: VH,
      gfmFootnoteDefinitionLabelString: YH,
      gfmFootnoteDefinition: GH
    },
    exit: {
      gfmFootnoteCallString: WH,
      gfmFootnoteCall: qH,
      gfmFootnoteDefinitionLabelString: KH,
      gfmFootnoteDefinition: QH
    }
  };
}
function ZH(e) {
  let t = !1;
  return e && e.firstLineBlank && (t = !0), {
    handlers: { footnoteDefinition: n, footnoteReference: eT },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function n(r, s, i, a) {
    const o = i.createTracker(a);
    let u = o.move("[^");
    const c = i.enter("footnoteDefinition"), l = i.enter("label");
    return u += o.move(
      i.safe(i.associationId(r), { before: u, after: "]" })
    ), l(), u += o.move("]:"), r.children && r.children.length > 0 && (o.shift(4), u += o.move(
      (t ? `
` : " ") + i.indentLines(
        i.containerFlow(r, o.current()),
        t ? tT : e8
      )
    )), c(), u;
  }
}
function e8(e, t, n) {
  return t === 0 ? e : tT(e, t, n);
}
function tT(e, t, n) {
  return (n ? "" : "    ") + e;
}
const t8 = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
nT.peek = a8;
function n8() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: s8 },
    exit: { strikethrough: i8 }
  };
}
function r8() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: t8
      }
    ],
    handlers: { delete: nT }
  };
}
function s8(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function i8(e) {
  this.exit(e);
}
function nT(e, t, n, r) {
  const s = n.createTracker(r), i = n.enter("strikethrough");
  let a = s.move("~~");
  return a += n.containerPhrasing(e, {
    ...s.current(),
    before: a,
    after: "~"
  }), a += s.move("~~"), i(), a;
}
function a8() {
  return "~";
}
function o8(e) {
  return e.length;
}
function u8(e, t) {
  const n = t || {}, r = (n.align || []).concat(), s = n.stringLength || o8, i = [], a = [], o = [], u = [];
  let c = 0, l = -1;
  for (; ++l < e.length; ) {
    const g = [], _ = [];
    let b = -1;
    for (e[l].length > c && (c = e[l].length); ++b < e[l].length; ) {
      const T = c8(e[l][b]);
      if (n.alignDelimiters !== !1) {
        const C = s(T);
        _[b] = C, (u[b] === void 0 || C > u[b]) && (u[b] = C);
      }
      g.push(T);
    }
    a[l] = g, o[l] = _;
  }
  let h = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++h < c; )
      i[h] = Ip(r[h]);
  else {
    const g = Ip(r);
    for (; ++h < c; )
      i[h] = g;
  }
  h = -1;
  const m = [], p = [];
  for (; ++h < c; ) {
    const g = i[h];
    let _ = "", b = "";
    g === 99 ? (_ = ":", b = ":") : g === 108 ? _ = ":" : g === 114 && (b = ":");
    let T = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      u[h] - _.length - b.length
    );
    const C = _ + "-".repeat(T) + b;
    n.alignDelimiters !== !1 && (T = _.length + T + b.length, T > u[h] && (u[h] = T), p[h] = T), m[h] = C;
  }
  a.splice(1, 0, m), o.splice(1, 0, p), l = -1;
  const E = [];
  for (; ++l < a.length; ) {
    const g = a[l], _ = o[l];
    h = -1;
    const b = [];
    for (; ++h < c; ) {
      const T = g[h] || "";
      let C = "", R = "";
      if (n.alignDelimiters !== !1) {
        const D = u[h] - (_[h] || 0), w = i[h];
        w === 114 ? C = " ".repeat(D) : w === 99 ? D % 2 ? (C = " ".repeat(D / 2 + 0.5), R = " ".repeat(D / 2 - 0.5)) : (C = " ".repeat(D / 2), R = C) : R = " ".repeat(D);
      }
      n.delimiterStart !== !1 && !h && b.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && T === "") && (n.delimiterStart !== !1 || h) && b.push(" "), n.alignDelimiters !== !1 && b.push(C), b.push(T), n.alignDelimiters !== !1 && b.push(R), n.padding !== !1 && b.push(" "), (n.delimiterEnd !== !1 || h !== c - 1) && b.push("|");
    }
    E.push(
      n.delimiterEnd === !1 ? b.join("").replace(/ +$/, "") : b.join("")
    );
  }
  return E.join(`
`);
}
function c8(e) {
  return e == null ? "" : String(e);
}
function Ip(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function l8(e, t, n, r) {
  const s = n.enter("blockquote"), i = n.createTracker(r);
  i.move("> "), i.shift(2);
  const a = n.indentLines(
    n.containerFlow(e, i.current()),
    d8
  );
  return s(), a;
}
function d8(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function h8(e, t) {
  return vp(e, t.inConstruct, !0) && !vp(e, t.notInConstruct, !1);
}
function vp(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Np(e, t, n, r) {
  let s = -1;
  for (; ++s < n.unsafe.length; )
    if (n.unsafe[s].character === `
` && h8(n.stack, n.unsafe[s]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function f8(e, t) {
  const n = String(e);
  let r = n.indexOf(t), s = r, i = 0, a = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === s ? ++i > a && (a = i) : i = 1, s = r + t.length, r = n.indexOf(t, s);
  return a;
}
function p8(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function m8(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function g8(e, t, n, r) {
  const s = m8(n), i = e.value || "", a = s === "`" ? "GraveAccent" : "Tilde";
  if (p8(e, n)) {
    const h = n.enter("codeIndented"), m = n.indentLines(i, E8);
    return h(), m;
  }
  const o = n.createTracker(r), u = s.repeat(Math.max(f8(i, s) + 1, 3)), c = n.enter("codeFenced");
  let l = o.move(u);
  if (e.lang) {
    const h = n.enter(`codeFencedLang${a}`);
    l += o.move(
      n.safe(e.lang, {
        before: l,
        after: " ",
        encode: ["`"],
        ...o.current()
      })
    ), h();
  }
  if (e.lang && e.meta) {
    const h = n.enter(`codeFencedMeta${a}`);
    l += o.move(" "), l += o.move(
      n.safe(e.meta, {
        before: l,
        after: `
`,
        encode: ["`"],
        ...o.current()
      })
    ), h();
  }
  return l += o.move(`
`), i && (l += o.move(i + `
`)), l += o.move(u), c(), l;
}
function E8(e, t, n) {
  return (n ? "" : "    ") + e;
}
function pd(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function b8(e, t, n, r) {
  const s = pd(n), i = s === '"' ? "Quote" : "Apostrophe", a = n.enter("definition");
  let o = n.enter("label");
  const u = n.createTracker(r);
  let c = u.move("[");
  return c += u.move(
    n.safe(n.associationId(e), {
      before: c,
      after: "]",
      ...u.current()
    })
  ), c += u.move("]: "), o(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (o = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), o(), e.title && (o = n.enter(`title${i}`), c += u.move(" " + s), c += u.move(
    n.safe(e.title, {
      before: c,
      after: s,
      ...u.current()
    })
  ), c += u.move(s), o()), a(), c;
}
function _8(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
function Ti(e) {
  return "&#x" + e.toString(16).toUpperCase() + ";";
}
function eo(e, t, n) {
  const r = ps(e), s = ps(t);
  return r === void 0 ? s === void 0 ? (
    // Letter inside:
    // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    n === "_" ? { inside: !0, outside: !0 } : { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (letter, whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: encode outer (letter)
    { inside: !1, outside: !0 }
  ) : r === 1 ? s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode both (whitespace).
    { inside: !0, outside: !0 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === void 0 ? (
    // Letter inside: already forms.
    { inside: !1, outside: !1 }
  ) : s === 1 ? (
    // Whitespace inside: encode inner (whitespace).
    { inside: !0, outside: !1 }
  ) : (
    // Punctuation inside: already forms.
    { inside: !1, outside: !1 }
  );
}
rT.peek = T8;
function rT(e, t, n, r) {
  const s = _8(n), i = n.enter("emphasis"), a = n.createTracker(r), o = a.move(s);
  let u = a.move(
    n.containerPhrasing(e, {
      after: s,
      before: o,
      ...a.current()
    })
  );
  const c = u.charCodeAt(0), l = eo(
    r.before.charCodeAt(r.before.length - 1),
    c,
    s
  );
  l.inside && (u = Ti(c) + u.slice(1));
  const h = u.charCodeAt(u.length - 1), m = eo(r.after.charCodeAt(0), h, s);
  m.inside && (u = u.slice(0, -1) + Ti(h));
  const p = a.move(s);
  return i(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: l.outside
  }, o + u + p;
}
function T8(e, t, n) {
  return n.options.emphasis || "*";
}
function A8(e, t) {
  let n = !1;
  return Vo(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, Oc;
  }), !!((!e.depth || e.depth < 3) && Xl(e) && (t.options.setext || n));
}
function y8(e, t, n, r) {
  const s = Math.max(Math.min(6, e.depth || 1), 1), i = n.createTracker(r);
  if (A8(e, n)) {
    const l = n.enter("headingSetext"), h = n.enter("phrasing"), m = n.containerPhrasing(e, {
      ...i.current(),
      before: `
`,
      after: `
`
    });
    return h(), l(), m + `
` + (s === 1 ? "=" : "-").repeat(
      // The whole size…
      m.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(m.lastIndexOf("\r"), m.lastIndexOf(`
`)) + 1)
    );
  }
  const a = "#".repeat(s), o = n.enter("headingAtx"), u = n.enter("phrasing");
  i.move(a + " ");
  let c = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...i.current()
  });
  return /^[\t ]/.test(c) && (c = Ti(c.charCodeAt(0)) + c.slice(1)), c = c ? a + " " + c : a, n.options.closeAtx && (c += " " + a), u(), o(), c;
}
sT.peek = x8;
function sT(e) {
  return e.value || "";
}
function x8() {
  return "<";
}
iT.peek = C8;
function iT(e, t, n, r) {
  const s = pd(n), i = s === '"' ? "Quote" : "Apostrophe", a = n.enter("image");
  let o = n.enter("label");
  const u = n.createTracker(r);
  let c = u.move("![");
  return c += u.move(
    n.safe(e.alt, { before: c, after: "]", ...u.current() })
  ), c += u.move("]("), o(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (o = n.enter("destinationLiteral"), c += u.move("<"), c += u.move(
    n.safe(e.url, { before: c, after: ">", ...u.current() })
  ), c += u.move(">")) : (o = n.enter("destinationRaw"), c += u.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), o(), e.title && (o = n.enter(`title${i}`), c += u.move(" " + s), c += u.move(
    n.safe(e.title, {
      before: c,
      after: s,
      ...u.current()
    })
  ), c += u.move(s), o()), c += u.move(")"), a(), c;
}
function C8() {
  return "!";
}
aT.peek = S8;
function aT(e, t, n, r) {
  const s = e.referenceType, i = n.enter("imageReference");
  let a = n.enter("label");
  const o = n.createTracker(r);
  let u = o.move("![");
  const c = n.safe(e.alt, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(c + "]["), a();
  const l = n.stack;
  n.stack = [], a = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return a(), n.stack = l, i(), s === "full" || !c || c !== h ? u += o.move(h + "]") : s === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function S8() {
  return "!";
}
oT.peek = w8;
function oT(e, t, n) {
  let r = e.value || "", s = "`", i = -1;
  for (; new RegExp("(^|[^`])" + s + "([^`]|$)").test(r); )
    s += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++i < n.unsafe.length; ) {
    const a = n.unsafe[i], o = n.compilePattern(a);
    let u;
    if (a.atBreak)
      for (; u = o.exec(r); ) {
        let c = u.index;
        r.charCodeAt(c) === 10 && r.charCodeAt(c - 1) === 13 && c--, r = r.slice(0, c) + " " + r.slice(u.index + 1);
      }
  }
  return s + r + s;
}
function w8() {
  return "`";
}
function uT(e, t) {
  const n = Xl(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
cT.peek = I8;
function cT(e, t, n, r) {
  const s = pd(n), i = s === '"' ? "Quote" : "Apostrophe", a = n.createTracker(r);
  let o, u;
  if (uT(e, n)) {
    const l = n.stack;
    n.stack = [], o = n.enter("autolink");
    let h = a.move("<");
    return h += a.move(
      n.containerPhrasing(e, {
        before: h,
        after: ">",
        ...a.current()
      })
    ), h += a.move(">"), o(), n.stack = l, h;
  }
  o = n.enter("link"), u = n.enter("label");
  let c = a.move("[");
  return c += a.move(
    n.containerPhrasing(e, {
      before: c,
      after: "](",
      ...a.current()
    })
  ), c += a.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), c += a.move("<"), c += a.move(
    n.safe(e.url, { before: c, after: ">", ...a.current() })
  ), c += a.move(">")) : (u = n.enter("destinationRaw"), c += a.move(
    n.safe(e.url, {
      before: c,
      after: e.title ? " " : ")",
      ...a.current()
    })
  )), u(), e.title && (u = n.enter(`title${i}`), c += a.move(" " + s), c += a.move(
    n.safe(e.title, {
      before: c,
      after: s,
      ...a.current()
    })
  ), c += a.move(s), u()), c += a.move(")"), o(), c;
}
function I8(e, t, n) {
  return uT(e, n) ? "<" : "[";
}
lT.peek = v8;
function lT(e, t, n, r) {
  const s = e.referenceType, i = n.enter("linkReference");
  let a = n.enter("label");
  const o = n.createTracker(r);
  let u = o.move("[");
  const c = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...o.current()
  });
  u += o.move(c + "]["), a();
  const l = n.stack;
  n.stack = [], a = n.enter("reference");
  const h = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...o.current()
  });
  return a(), n.stack = l, i(), s === "full" || !c || c !== h ? u += o.move(h + "]") : s === "shortcut" ? u = u.slice(0, -1) : u += o.move("]"), u;
}
function v8() {
  return "[";
}
function md(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function N8(e) {
  const t = md(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function k8(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function dT(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function R8(e, t, n, r) {
  const s = n.enter("list"), i = n.bulletCurrent;
  let a = e.ordered ? k8(n) : md(n);
  const o = e.ordered ? a === "." ? ")" : "." : N8(n);
  let u = t && n.bulletLastUsed ? a === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const l = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (a === "*" || a === "-") && // Empty first list item:
      l && (!l.children || !l.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), dT(n) === a && l
    ) {
      let h = -1;
      for (; ++h < e.children.length; ) {
        const m = e.children[h];
        if (m && m.type === "listItem" && m.children && m.children[0] && m.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (a = o), n.bulletCurrent = a;
  const c = n.containerFlow(e, r);
  return n.bulletLastUsed = a, n.bulletCurrent = i, s(), c;
}
function P8(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function O8(e, t, n, r) {
  const s = P8(n);
  let i = n.bulletCurrent || md(n);
  t && t.type === "list" && t.ordered && (i = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + i);
  let a = i.length + 1;
  (s === "tab" || s === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4);
  const o = n.createTracker(r);
  o.move(i + " ".repeat(a - i.length)), o.shift(a);
  const u = n.enter("listItem"), c = n.indentLines(
    n.containerFlow(e, o.current()),
    l
  );
  return u(), c;
  function l(h, m, p) {
    return m ? (p ? "" : " ".repeat(a)) + h : (p ? i : i + " ".repeat(a - i.length)) + h;
  }
}
function D8(e, t, n, r) {
  const s = n.enter("paragraph"), i = n.enter("phrasing"), a = n.containerPhrasing(e, r);
  return i(), s(), a;
}
const L8 = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  $o([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function M8(e, t, n, r) {
  return (e.children.some(function(a) {
    return L8(a);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function H8(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
hT.peek = B8;
function hT(e, t, n, r) {
  const s = H8(n), i = n.enter("strong"), a = n.createTracker(r), o = a.move(s + s);
  let u = a.move(
    n.containerPhrasing(e, {
      after: s,
      before: o,
      ...a.current()
    })
  );
  const c = u.charCodeAt(0), l = eo(
    r.before.charCodeAt(r.before.length - 1),
    c,
    s
  );
  l.inside && (u = Ti(c) + u.slice(1));
  const h = u.charCodeAt(u.length - 1), m = eo(r.after.charCodeAt(0), h, s);
  m.inside && (u = u.slice(0, -1) + Ti(h));
  const p = a.move(s + s);
  return i(), n.attentionEncodeSurroundingInfo = {
    after: m.outside,
    before: l.outside
  }, o + u + p;
}
function B8(e, t, n) {
  return n.options.strong || "*";
}
function U8(e, t, n, r) {
  return n.safe(e.value, r);
}
function F8(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function j8(e, t, n) {
  const r = (dT(n) + (n.options.ruleSpaces ? " " : "")).repeat(F8(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const fT = {
  blockquote: l8,
  break: Np,
  code: g8,
  definition: b8,
  emphasis: rT,
  hardBreak: Np,
  heading: y8,
  html: sT,
  image: iT,
  imageReference: aT,
  inlineCode: oT,
  link: cT,
  linkReference: lT,
  list: R8,
  listItem: O8,
  paragraph: D8,
  root: M8,
  strong: hT,
  text: U8,
  thematicBreak: j8
};
function $8() {
  return {
    enter: {
      table: z8,
      tableData: kp,
      tableHeader: kp,
      tableRow: Y8
    },
    exit: {
      codeText: G8,
      table: V8,
      tableData: Qu,
      tableHeader: Qu,
      tableRow: Qu
    }
  };
}
function z8(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function V8(e) {
  this.exit(e), this.data.inTable = void 0;
}
function Y8(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Qu(e) {
  this.exit(e);
}
function kp(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function G8(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, W8));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function W8(e, t) {
  return t === "|" ? t : e;
}
function q8(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, s = t.stringLength, i = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: m,
      table: a,
      tableCell: u,
      tableRow: o
    }
  };
  function a(p, E, g, _) {
    return c(l(p, g, _), p.align);
  }
  function o(p, E, g, _) {
    const b = h(p, g, _), T = c([b]);
    return T.slice(0, T.indexOf(`
`));
  }
  function u(p, E, g, _) {
    const b = g.enter("tableCell"), T = g.enter("phrasing"), C = g.containerPhrasing(p, {
      ..._,
      before: i,
      after: i
    });
    return T(), b(), C;
  }
  function c(p, E) {
    return u8(p, {
      align: E,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: s
    });
  }
  function l(p, E, g) {
    const _ = p.children;
    let b = -1;
    const T = [], C = E.enter("table");
    for (; ++b < _.length; )
      T[b] = h(_[b], E, g);
    return C(), T;
  }
  function h(p, E, g) {
    const _ = p.children;
    let b = -1;
    const T = [], C = E.enter("tableRow");
    for (; ++b < _.length; )
      T[b] = u(_[b], p, E, g);
    return C(), T;
  }
  function m(p, E, g) {
    let _ = fT.inlineCode(p, E, g);
    return g.stack.includes("tableCell") && (_ = _.replace(/\|/g, "\\$&")), _;
  }
}
function K8() {
  return {
    exit: {
      taskListCheckValueChecked: Rp,
      taskListCheckValueUnchecked: Rp,
      paragraph: X8
    }
  };
}
function Q8() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: J8 }
  };
}
function Rp(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function X8(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const s = t.children;
      let i = -1, a;
      for (; ++i < s.length; ) {
        const o = s[i];
        if (o.type === "paragraph") {
          a = o;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function J8(e, t, n, r) {
  const s = e.children[0], i = typeof e.checked == "boolean" && s && s.type === "paragraph", a = "[" + (e.checked ? "x" : " ") + "] ", o = n.createTracker(r);
  i && o.move(a);
  let u = fT.listItem(e, t, n, {
    ...r,
    ...o.current()
  });
  return i && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, c)), u;
  function c(l) {
    return l + a;
  }
}
function Z8() {
  return [
    RH(),
    JH(),
    n8(),
    $8(),
    K8()
  ];
}
function eB(e) {
  return {
    extensions: [
      PH(),
      ZH(e),
      r8(),
      q8(e),
      Q8()
    ]
  };
}
const tB = {
  tokenize: oB,
  partial: !0
}, pT = {
  tokenize: uB,
  partial: !0
}, mT = {
  tokenize: cB,
  partial: !0
}, gT = {
  tokenize: lB,
  partial: !0
}, nB = {
  tokenize: dB,
  partial: !0
}, ET = {
  name: "wwwAutolink",
  tokenize: iB,
  previous: _T
}, bT = {
  name: "protocolAutolink",
  tokenize: aB,
  previous: TT
}, Fn = {
  name: "emailAutolink",
  tokenize: sB,
  previous: AT
}, Cn = {};
function rB() {
  return {
    text: Cn
  };
}
let Tr = 48;
for (; Tr < 123; )
  Cn[Tr] = Fn, Tr++, Tr === 58 ? Tr = 65 : Tr === 91 && (Tr = 97);
Cn[43] = Fn;
Cn[45] = Fn;
Cn[46] = Fn;
Cn[95] = Fn;
Cn[72] = [Fn, bT];
Cn[104] = [Fn, bT];
Cn[87] = [Fn, ET];
Cn[119] = [Fn, ET];
function sB(e, t, n) {
  const r = this;
  let s, i;
  return a;
  function a(h) {
    return !$c(h) || !AT.call(r, r.previous) || gd(r.events) ? n(h) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), o(h));
  }
  function o(h) {
    return $c(h) ? (e.consume(h), o) : h === 64 ? (e.consume(h), u) : n(h);
  }
  function u(h) {
    return h === 46 ? e.check(nB, l, c)(h) : h === 45 || h === 95 || bt(h) ? (i = !0, e.consume(h), u) : l(h);
  }
  function c(h) {
    return e.consume(h), s = !0, u;
  }
  function l(h) {
    return i && s && wt(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(h)) : n(h);
  }
}
function iB(e, t, n) {
  const r = this;
  return s;
  function s(a) {
    return a !== 87 && a !== 119 || !_T.call(r, r.previous) || gd(r.events) ? n(a) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(tB, e.attempt(pT, e.attempt(mT, i), n), n)(a));
  }
  function i(a) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(a);
  }
}
function aB(e, t, n) {
  const r = this;
  let s = "", i = !1;
  return a;
  function a(h) {
    return (h === 72 || h === 104) && TT.call(r, r.previous) && !gd(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), s += String.fromCodePoint(h), e.consume(h), o) : n(h);
  }
  function o(h) {
    if (wt(h) && s.length < 5)
      return s += String.fromCodePoint(h), e.consume(h), o;
    if (h === 58) {
      const m = s.toLowerCase();
      if (m === "http" || m === "https")
        return e.consume(h), u;
    }
    return n(h);
  }
  function u(h) {
    return h === 47 ? (e.consume(h), i ? c : (i = !0, u)) : n(h);
  }
  function c(h) {
    return h === null || Ka(h) || Ge(h) || Or(h) || Uo(h) ? n(h) : e.attempt(pT, e.attempt(mT, l), n)(h);
  }
  function l(h) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(h);
  }
}
function oB(e, t, n) {
  let r = 0;
  return s;
  function s(a) {
    return (a === 87 || a === 119) && r < 3 ? (r++, e.consume(a), s) : a === 46 && r === 3 ? (e.consume(a), i) : n(a);
  }
  function i(a) {
    return a === null ? n(a) : t(a);
  }
}
function uB(e, t, n) {
  let r, s, i;
  return a;
  function a(c) {
    return c === 46 || c === 95 ? e.check(gT, u, o)(c) : c === null || Ge(c) || Or(c) || c !== 45 && Uo(c) ? u(c) : (i = !0, e.consume(c), a);
  }
  function o(c) {
    return c === 95 ? r = !0 : (s = r, r = void 0), e.consume(c), a;
  }
  function u(c) {
    return s || r || !i ? n(c) : t(c);
  }
}
function cB(e, t) {
  let n = 0, r = 0;
  return s;
  function s(a) {
    return a === 40 ? (n++, e.consume(a), s) : a === 41 && r < n ? i(a) : a === 33 || a === 34 || a === 38 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 60 || a === 63 || a === 93 || a === 95 || a === 126 ? e.check(gT, t, i)(a) : a === null || Ge(a) || Or(a) ? t(a) : (e.consume(a), s);
  }
  function i(a) {
    return a === 41 && r++, e.consume(a), s;
  }
}
function lB(e, t, n) {
  return r;
  function r(o) {
    return o === 33 || o === 34 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 63 || o === 95 || o === 126 ? (e.consume(o), r) : o === 38 ? (e.consume(o), i) : o === 93 ? (e.consume(o), s) : (
      // `<` is an end.
      o === 60 || // So is whitespace.
      o === null || Ge(o) || Or(o) ? t(o) : n(o)
    );
  }
  function s(o) {
    return o === null || o === 40 || o === 91 || Ge(o) || Or(o) ? t(o) : r(o);
  }
  function i(o) {
    return wt(o) ? a(o) : n(o);
  }
  function a(o) {
    return o === 59 ? (e.consume(o), r) : wt(o) ? (e.consume(o), a) : n(o);
  }
}
function dB(e, t, n) {
  return r;
  function r(i) {
    return e.consume(i), s;
  }
  function s(i) {
    return bt(i) ? n(i) : t(i);
  }
}
function _T(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Ge(e);
}
function TT(e) {
  return !wt(e);
}
function AT(e) {
  return !(e === 47 || $c(e));
}
function $c(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || bt(e);
}
function gd(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const hB = {
  tokenize: TB,
  partial: !0
};
function fB() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: EB,
        continuation: {
          tokenize: bB
        },
        exit: _B
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: gB
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: pB,
        resolveTo: mB
      }
    }
  };
}
function pB(e, t, n) {
  const r = this;
  let s = r.events.length;
  const i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; s--; ) {
    const u = r.events[s][1];
    if (u.type === "labelImage") {
      a = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return o;
  function o(u) {
    if (!a || !a._balanced)
      return n(u);
    const c = an(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }));
    return c.codePointAt(0) !== 94 || !i.includes(c.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function mB(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, s = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  s.end.column++, s.end.offset++, s.end._bufferIndex++;
  const i = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, s.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, a = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, i.start),
    end: Object.assign({}, i.end)
  }, o = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", s, t],
    ["exit", s, t],
    // Everything in between.
    ["enter", i, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", i, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...o), e;
}
function gB(e, t, n) {
  const r = this, s = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i = 0, a;
  return o;
  function o(h) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(h) {
    return h !== 94 ? n(h) : (e.enter("gfmFootnoteCallMarker"), e.consume(h), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", c);
  }
  function c(h) {
    if (
      // Too long.
      i > 999 || // Closing brace with nothing.
      h === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      h === null || h === 91 || Ge(h)
    )
      return n(h);
    if (h === 93) {
      e.exit("chunkString");
      const m = e.exit("gfmFootnoteCallString");
      return s.includes(an(r.sliceSerialize(m))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(h), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(h);
    }
    return Ge(h) || (a = !0), i++, e.consume(h), h === 92 ? l : c;
  }
  function l(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), i++, c) : c(h);
  }
}
function EB(e, t, n) {
  const r = this, s = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let i, a = 0, o;
  return u;
  function u(E) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionLabelMarker"), c;
  }
  function c(E) {
    return E === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", l) : n(E);
  }
  function l(E) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      E === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      E === null || E === 91 || Ge(E)
    )
      return n(E);
    if (E === 93) {
      e.exit("chunkString");
      const g = e.exit("gfmFootnoteDefinitionLabelString");
      return i = an(r.sliceSerialize(g)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(E), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), m;
    }
    return Ge(E) || (o = !0), a++, e.consume(E), E === 92 ? h : l;
  }
  function h(E) {
    return E === 91 || E === 92 || E === 93 ? (e.consume(E), a++, l) : l(E);
  }
  function m(E) {
    return E === 58 ? (e.enter("definitionMarker"), e.consume(E), e.exit("definitionMarker"), s.includes(i) || s.push(i), Le(e, p, "gfmFootnoteDefinitionWhitespace")) : n(E);
  }
  function p(E) {
    return t(E);
  }
}
function bB(e, t, n) {
  return e.check(Mi, t, e.attempt(hB, t, n));
}
function _B(e) {
  e.exit("gfmFootnoteDefinition");
}
function TB(e, t, n) {
  const r = this;
  return Le(e, s, "gfmFootnoteDefinitionIndent", 5);
  function s(i) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === 4 ? t(i) : n(i);
  }
}
function AB(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: i,
    resolveAll: s
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function s(a, o) {
    let u = -1;
    for (; ++u < a.length; )
      if (a[u][0] === "enter" && a[u][1].type === "strikethroughSequenceTemporary" && a[u][1]._close) {
        let c = u;
        for (; c--; )
          if (a[c][0] === "exit" && a[c][1].type === "strikethroughSequenceTemporary" && a[c][1]._open && // If the sizes are the same:
          a[u][1].end.offset - a[u][1].start.offset === a[c][1].end.offset - a[c][1].start.offset) {
            a[u][1].type = "strikethroughSequence", a[c][1].type = "strikethroughSequence";
            const l = {
              type: "strikethrough",
              start: Object.assign({}, a[c][1].start),
              end: Object.assign({}, a[u][1].end)
            }, h = {
              type: "strikethroughText",
              start: Object.assign({}, a[c][1].end),
              end: Object.assign({}, a[u][1].start)
            }, m = [["enter", l, o], ["enter", a[c][1], o], ["exit", a[c][1], o], ["enter", h, o]], p = o.parser.constructs.insideSpan.null;
            p && Ut(m, m.length, 0, Fo(p, a.slice(c + 1, u), o)), Ut(m, m.length, 0, [["exit", h, o], ["enter", a[u][1], o], ["exit", a[u][1], o], ["exit", l, o]]), Ut(a, c - 1, u - c + 3, m), u = c + m.length - 2;
            break;
          }
      }
    for (u = -1; ++u < a.length; )
      a[u][1].type === "strikethroughSequenceTemporary" && (a[u][1].type = "data");
    return a;
  }
  function i(a, o, u) {
    const c = this.previous, l = this.events;
    let h = 0;
    return m;
    function m(E) {
      return c === 126 && l[l.length - 1][1].type !== "characterEscape" ? u(E) : (a.enter("strikethroughSequenceTemporary"), p(E));
    }
    function p(E) {
      const g = ps(c);
      if (E === 126)
        return h > 1 ? u(E) : (a.consume(E), h++, p);
      if (h < 2 && !n) return u(E);
      const _ = a.exit("strikethroughSequenceTemporary"), b = ps(E);
      return _._open = !b || b === 2 && !!g, _._close = !g || g === 2 && !!b, o(E);
    }
  }
}
class yB {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    xB(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(i, a) {
      return i[0] - a[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push(t.slice()), t.length = 0;
    let s = r.pop();
    for (; s; ) {
      for (const i of s)
        t.push(i);
      s = r.pop();
    }
    this.map.length = 0;
  }
}
function xB(e, t, n, r) {
  let s = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; s < e.map.length; ) {
      if (e.map[s][0] === t) {
        e.map[s][1] += n, e.map[s][2].push(...r);
        return;
      }
      s += 1;
    }
    e.map.push([t, n, r]);
  }
}
function CB(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const s = e[t];
    if (n) {
      if (s[0] === "enter")
        s[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (s[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const i = r.length - 1;
          r[i] = r[i] === "left" ? "center" : "right";
        }
      } else if (s[1].type === "tableDelimiterRow")
        break;
    } else s[0] === "enter" && s[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function SB() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: wB,
        resolveAll: IB
      }
    }
  };
}
function wB(e, t, n) {
  const r = this;
  let s = 0, i = 0, a;
  return o;
  function o(P) {
    let z = r.events.length - 1;
    for (; z > -1; ) {
      const M = r.events[z][1].type;
      if (M === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      M === "linePrefix") z--;
      else break;
    }
    const G = z > -1 ? r.events[z][1].type : null, F = G === "tableHead" || G === "tableRow" ? w : u;
    return F === w && r.parser.lazy[r.now().line] ? n(P) : F(P);
  }
  function u(P) {
    return e.enter("tableHead"), e.enter("tableRow"), c(P);
  }
  function c(P) {
    return P === 124 || (a = !0, i += 1), l(P);
  }
  function l(P) {
    return P === null ? n(P) : me(P) ? i > 1 ? (i = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(P), e.exit("lineEnding"), p) : n(P) : ke(P) ? Le(e, l, "whitespace")(P) : (i += 1, a && (a = !1, s += 1), P === 124 ? (e.enter("tableCellDivider"), e.consume(P), e.exit("tableCellDivider"), a = !0, l) : (e.enter("data"), h(P)));
  }
  function h(P) {
    return P === null || P === 124 || Ge(P) ? (e.exit("data"), l(P)) : (e.consume(P), P === 92 ? m : h);
  }
  function m(P) {
    return P === 92 || P === 124 ? (e.consume(P), h) : h(P);
  }
  function p(P) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(P) : (e.enter("tableDelimiterRow"), a = !1, ke(P) ? Le(e, E, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(P) : E(P));
  }
  function E(P) {
    return P === 45 || P === 58 ? _(P) : P === 124 ? (a = !0, e.enter("tableCellDivider"), e.consume(P), e.exit("tableCellDivider"), g) : D(P);
  }
  function g(P) {
    return ke(P) ? Le(e, _, "whitespace")(P) : _(P);
  }
  function _(P) {
    return P === 58 ? (i += 1, a = !0, e.enter("tableDelimiterMarker"), e.consume(P), e.exit("tableDelimiterMarker"), b) : P === 45 ? (i += 1, b(P)) : P === null || me(P) ? R(P) : D(P);
  }
  function b(P) {
    return P === 45 ? (e.enter("tableDelimiterFiller"), T(P)) : D(P);
  }
  function T(P) {
    return P === 45 ? (e.consume(P), T) : P === 58 ? (a = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(P), e.exit("tableDelimiterMarker"), C) : (e.exit("tableDelimiterFiller"), C(P));
  }
  function C(P) {
    return ke(P) ? Le(e, R, "whitespace")(P) : R(P);
  }
  function R(P) {
    return P === 124 ? E(P) : P === null || me(P) ? !a || s !== i ? D(P) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(P)) : D(P);
  }
  function D(P) {
    return n(P);
  }
  function w(P) {
    return e.enter("tableRow"), O(P);
  }
  function O(P) {
    return P === 124 ? (e.enter("tableCellDivider"), e.consume(P), e.exit("tableCellDivider"), O) : P === null || me(P) ? (e.exit("tableRow"), t(P)) : ke(P) ? Le(e, O, "whitespace")(P) : (e.enter("data"), U(P));
  }
  function U(P) {
    return P === null || P === 124 || Ge(P) ? (e.exit("data"), O(P)) : (e.consume(P), P === 92 ? q : U);
  }
  function q(P) {
    return P === 92 || P === 124 ? (e.consume(P), U) : U(P);
  }
}
function IB(e, t) {
  let n = -1, r = !0, s = 0, i = [0, 0, 0, 0], a = [0, 0, 0, 0], o = !1, u = 0, c, l, h;
  const m = new yB();
  for (; ++n < e.length; ) {
    const p = e[n], E = p[1];
    p[0] === "enter" ? E.type === "tableHead" ? (o = !1, u !== 0 && (Pp(m, t, u, c, l), l = void 0, u = 0), c = {
      type: "table",
      start: Object.assign({}, E.start),
      // Note: correct end is set later.
      end: Object.assign({}, E.end)
    }, m.add(n, 0, [["enter", c, t]])) : E.type === "tableRow" || E.type === "tableDelimiterRow" ? (r = !0, h = void 0, i = [0, 0, 0, 0], a = [0, n + 1, 0, 0], o && (o = !1, l = {
      type: "tableBody",
      start: Object.assign({}, E.start),
      // Note: correct end is set later.
      end: Object.assign({}, E.end)
    }, m.add(n, 0, [["enter", l, t]])), s = E.type === "tableDelimiterRow" ? 2 : l ? 3 : 1) : s && (E.type === "data" || E.type === "tableDelimiterMarker" || E.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (i[1] !== 0 && (a[0] = a[1], h = fa(m, t, i, s, void 0, h), i = [0, 0, 0, 0]), a[2] = n)) : E.type === "tableCellDivider" && (r ? r = !1 : (i[1] !== 0 && (a[0] = a[1], h = fa(m, t, i, s, void 0, h)), i = a, a = [i[1], n, 0, 0])) : E.type === "tableHead" ? (o = !0, u = n) : E.type === "tableRow" || E.type === "tableDelimiterRow" ? (u = n, i[1] !== 0 ? (a[0] = a[1], h = fa(m, t, i, s, n, h)) : a[1] !== 0 && (h = fa(m, t, a, s, n, h)), s = 0) : s && (E.type === "data" || E.type === "tableDelimiterMarker" || E.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (u !== 0 && Pp(m, t, u, c, l), m.consume(t.events), n = -1; ++n < t.events.length; ) {
    const p = t.events[n];
    p[0] === "enter" && p[1].type === "table" && (p[1]._align = CB(t.events, n));
  }
  return e;
}
function fa(e, t, n, r, s, i) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", o = "tableContent";
  n[0] !== 0 && (i.end = Object.assign({}, Zr(t.events, n[0])), e.add(n[0], 0, [["exit", i, t]]));
  const u = Zr(t.events, n[1]);
  if (i = {
    type: a,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", i, t]]), n[2] !== 0) {
    const c = Zr(t.events, n[2]), l = Zr(t.events, n[3]), h = {
      type: o,
      start: Object.assign({}, c),
      end: Object.assign({}, l)
    };
    if (e.add(n[2], 0, [["enter", h, t]]), r !== 2) {
      const m = t.events[n[2]], p = t.events[n[3]];
      if (m[1].end = Object.assign({}, p[1].end), m[1].type = "chunkText", m[1].contentType = "text", n[3] > n[2] + 1) {
        const E = n[2] + 1, g = n[3] - n[2] - 1;
        e.add(E, g, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", h, t]]);
  }
  return s !== void 0 && (i.end = Object.assign({}, Zr(t.events, s)), e.add(s, 0, [["exit", i, t]]), i = void 0), i;
}
function Pp(e, t, n, r, s) {
  const i = [], a = Zr(t.events, n);
  s && (s.end = Object.assign({}, a), i.push(["exit", s, t])), r.end = Object.assign({}, a), i.push(["exit", r, t]), e.add(n + 1, 0, i);
}
function Zr(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const vB = {
  name: "tasklistCheck",
  tokenize: kB
};
function NB() {
  return {
    text: {
      91: vB
    }
  };
}
function kB(e, t, n) {
  const r = this;
  return s;
  function s(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), i)
    );
  }
  function i(u) {
    return Ge(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), a) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), a) : n(u);
  }
  function a(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), o) : n(u);
  }
  function o(u) {
    return me(u) ? t(u) : ke(u) ? e.check({
      tokenize: RB
    }, t, n)(u) : n(u);
  }
}
function RB(e, t, n) {
  return Le(e, r, "whitespace");
  function r(s) {
    return s === null ? n(s) : t(s);
  }
}
function PB(e) {
  return Yb([
    rB(),
    fB(),
    AB(e),
    SB(),
    NB()
  ]);
}
const OB = {};
function yT(e) {
  const t = (
    /** @type {Processor<Root>} */
    this
  ), n = e || OB, r = t.data(), s = r.micromarkExtensions || (r.micromarkExtensions = []), i = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), a = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  s.push(PB(n)), i.push(Z8()), a.push(eB(n));
}
const Qt = Je(
  ({ children: e, tooltip: t, side: n = "bottom", className: r, ...s }, i) => /* @__PURE__ */ d.jsxs(UP, { children: [
    /* @__PURE__ */ d.jsx(FP, { asChild: !0, children: /* @__PURE__ */ d.jsxs(pt, { variant: "ghost", size: "icon", ...s, className: ue("size-6 p-1", r), ref: i, children: [
      e,
      /* @__PURE__ */ d.jsx("span", { className: "sr-only", children: t })
    ] }) }),
    /* @__PURE__ */ d.jsx(jP, { side: n, children: t })
  ] })
);
Qt.displayName = "TooltipIconButton";
const DB = "language-html", pa = "zai-html-preview", Gs = "zai-html-preview-download", Op = "--zai-html-preview-height", xT = "zaiHtmlPreviewHeight", CT = 1e4, LB = `<script>(function(){var report=function(){parent.postMessage({${xT}:document.documentElement.scrollHeight},'*')};addEventListener('load',report);if(window.ResizeObserver){new ResizeObserver(report).observe(document.documentElement)}})()<\/script>`, ma = (e) => e.replace(/&/g, "&amp;").replace(/"/g, "&quot;"), Dp = (e) => e.replace(/&/g, "&amp;").replace(/</g, "&lt;"), Lp = (e) => e.replace(/&[a-z]+;|&#\d+;/gi, " ").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60), ST = (e, t) => `${Lp(e.match(/<title[^>]*>([\s\S]*?)<\/title>/i)?.[1] ?? "") || Lp(t) || "preview"}.html`, MB = (e) => typeof e == "object" && e !== null && "props" in e, HB = (e) => {
  if (!MB(e)) return null;
  const { className: t, children: n } = e.props ?? {};
  if (!(t?.toLowerCase().split(/\s+/) ?? []).includes(DB)) return null;
  const s = Array.isArray(n) ? n.filter((i) => typeof i == "string").join("") : n;
  return typeof s == "string" && s.trim().length > 0 ? s : null;
}, BB = (e, t, n = e) => `<!doctype html>
<html>
<head>
<meta charset="utf-8">
<title>${Dp(t.title)}</title>
<style>
html,body{margin:0;height:100%;background:#fff}
#${pa}{display:block;border:0;width:100%;height:100%}
#${Gs}{position:fixed;top:12px;right:12px;z-index:1;padding:8px 14px;border:1px solid rgba(0,0,0,.15);border-radius:8px;background:rgba(255,255,255,.92);color:#111;font:600 13px/1 system-ui,sans-serif;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.15)}
#${Gs}:hover{background:#fff}
@media print{html,body{height:auto}#${pa}{height:var(${Op},100%)}#${Gs}{display:none}}
</style>
</head>
<body>
<iframe id="${pa}" title="${ma(t.title)}" sandbox="allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox" srcdoc="${ma(
  e + LB
)}"></iframe>
<button id="${Gs}" type="button" data-html="${ma(n)}" data-filename="${ma(
  ST(e, t.fileName)
)}">${Dp(t.download)}</button>
<script>
addEventListener('message', function (event) {
  var frame = document.getElementById('${pa}')
  if (!frame || event.source !== frame.contentWindow) return
  var height = event.data && event.data.${xT}
  if (typeof height !== 'number' || height <= 0) return
  frame.style.setProperty('${Op}', height + 'px')
})

document.getElementById('${Gs}').addEventListener('click', function () {
  var button = this
  var url = URL.createObjectURL(new Blob([button.dataset.html], { type: 'text/html;charset=utf-8' }))
  var link = document.createElement('a')
  link.href = url
  link.download = button.dataset.filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(function () { URL.revokeObjectURL(url) }, ${CT})
})
<\/script>
</body>
</html>`, UB = (e, t, n = e) => {
  const r = URL.createObjectURL(new Blob([n], { type: "text/html;charset=utf-8" })), s = document.createElement("a");
  s.href = r, s.download = ST(e, t.fileName), document.body.appendChild(s), s.click(), s.remove(), setTimeout(() => URL.revokeObjectURL(r), CT);
}, FB = (e, t, n = e) => {
  const r = BB(e, t, n), s = URL.createObjectURL(new Blob([r], { type: "text/html;charset=utf-8" }));
  return window.open(s, "_blank") ? !0 : (URL.revokeObjectURL(s), !1);
}, jB = (e) => e.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), $B = (e) => e.replace(/-{2,}/g, "-"), zB = (e) => `winnin:${e.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`, VB = (e, t) => {
  const n = Object.entries(t).filter(
    (a) => a[1] !== void 0 && a[1] !== null && a[1] !== ""
  );
  if (!n.length) return e;
  const r = `<!-- Winnin report
${n.map(([a, o]) => $B(`${a}: ${o}`)).join(`
`)}
-->`, s = n.map(([a, o]) => `<meta name="${zB(a)}" content="${jB(String(o))}">`).join(""), i = r + s;
  for (const a of [/<head\b[^>]*>/i, /<html\b[^>]*>/i]) {
    const o = e.match(a);
    if (o?.index !== void 0) {
      const u = o.index + o[0].length;
      return e.slice(0, u) + i + e.slice(u);
    }
  }
  return i + e;
}, Mp = (e, t) => {
  const n = Object.values(te).find(
    (u) => it(e, { path: u, exact: !0 })
  );
  if (!n) return null;
  const r = Bn[n];
  if (!r) return null;
  const i = { ...it(e, { path: n, exact: !0 })?.params };
  if (i.territoryId) {
    const [u, c] = i.territoryId.split(".");
    i.territoryType = xs[u], i.entityId = c, delete i.territoryId;
  }
  const a = ME(r), o = {};
  for (const u of a)
    if (u === "panelId" && t ? o.panelId = t : u === "tab" && i.territoryType && i.territoryType in sr ? o.tab = sr[i.territoryType] : i[u] && (o[u] = i[u]), !o[u]) return null;
  return Kt(r, o);
}, YB = Object.keys(xs).join("|"), GB = "yt|fb|in|tt|tw", WB = new RegExp(`^(?:${ge})?((?:${YB})\\.[a-zA-Z0-9_-]+)$`), qB = new RegExp(`^(?:${ge})?(post|creator)[:/](${GB})[:/]([a-zA-Z0-9_-]+)$`), KB = /\b(href|src)=("|')(.*?)\2/g, QB = /<a\b([^>]*\bhref=[^>]*)>/gi, XB = /\btarget=/i, JB = /\brel=/i, ZB = {
  post: te.POST,
  creator: te.CREATOR
}, eU = (e, t) => {
  const n = e.match(WB);
  if (n) return Ol(t ?? "", n[1]) || null;
  const r = e.match(qB);
  if (r) {
    const [, s, i, a] = r, o = Kt(ZB[s], {
      provider: i,
      id: a
    });
    return Mp(o, t);
  }
  return e.startsWith(ge) ? Mp(e, t) : null;
}, tU = (e, t, n = "") => e.replace(KB, (s, i, a, o) => {
  const u = eU(o.trim(), t);
  return u ? `${i}=${a}${u.startsWith("/") ? n + u : u}${a}` : s;
}).replace(QB, (s, i) => {
  const a = XB.test(i) ? "" : ' target="_blank"', o = JB.test(i) ? "" : ' rel="noopener noreferrer"';
  return `<a${i}${a}${o}>`;
}), vn = {
  title: {
    key: "zai.html-preview.title",
    defaultValue: "HTML preview"
  },
  open: {
    key: "zai.html-preview.open",
    defaultValue: "Open in a new tab"
  },
  linesCreated: (e) => ({
    key: "zai.html-preview.lines-created",
    parameters: e,
    defaultValue: "{count} lines created"
  }),
  lineCount: (e) => ({
    key: "zai.html-preview.line-count",
    parameters: e,
    defaultValue: "{count} lines"
  }),
  download: {
    key: "zai.html-preview.download",
    defaultValue: "Download"
  },
  fileName: {
    key: "zai.html-preview.file-name",
    defaultValue: "preview"
  }
}, Hp = `
  flex
  shrink-0
  items-center
  gap-1.5
  rounded-md
  border
  bg-background
  px-2.5
  py-1.5
  text-sm
  text-muted-foreground
  transition-colors
  enabled:hover:text-foreground
  enabled:hover:border-neutral-400
  dark:enabled:hover:border-neutral-500
  disabled:opacity-60
`, nU = ({ code: e }) => {
  const { t } = He(), { workspaceId: n, userId: r } = at(), s = J((g) => g?.message?.status?.type === "complete"), i = J((g) => g?.threadListItem?.remoteId ?? null), a = J((g) => g?.message?.id ?? null), o = se(() => tU(e, n, window.location.origin), [e, n]), u = e.trimEnd().split(`
`).length, c = {
    title: t(vn.title),
    download: t(vn.download),
    fileName: t(vn.fileName)
  }, l = se(() => QE(o), [o]), h = { workspaceId: n, thread: i, message: a, "HTML Title": l }, m = (g) => {
    const _ = crypto.randomUUID(), b = Wt.getGlobalContext(), T = {
      "HTML Id": _,
      "Download Source": g,
      "Thread Id": i,
      "Message Id": a,
      "User Id": r,
      "HTML Title": l,
      "HTML Size": o.length,
      "Saved At": (/* @__PURE__ */ new Date()).toISOString()
    }, C = VB(o, {
      "Workspace Id": b.workspaceId ?? n,
      "Workspace Name": b["Workspace Name"],
      "Company Id": b.companyId,
      "Company Name": b["Company Name"],
      "Company Type": b["Company Type"],
      "Contract Insights Plan": b["Contract Insights Plan"],
      ...T
    });
    return { htmlId: _, downloadCode: wk(C, Wt.getHtmlOpenTracking(T)) };
  }, p = () => {
    const { htmlId: g, downloadCode: _ } = m("preview-tab"), b = FB(o, c, _);
    Wt.track(rn.htmlOpen, { ...h, "HTML Id": g, "Popup Blocked": !b });
  }, E = () => {
    const { htmlId: g, downloadCode: _ } = m("card");
    UB(o, c, _), Wt.track(rn.htmlDownload, { ...h, "HTML Id": g });
  };
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: ue(
        "zai-html-preview-card clear-left my-5 flex w-full items-center gap-3 rounded-lg border bg-muted px-4 py-3",
        !s && "zai-html-preview-card--loading border-dashed"
      ),
      children: [
        /* @__PURE__ */ d.jsx(
          "span",
          {
            className: ue(
              "flex size-9 shrink-0 items-center justify-center rounded-md bg-background",
              s ? "text-primary" : "zai-html-preview-card__icon--loading text-muted-foreground"
            ),
            children: /* @__PURE__ */ d.jsx(XR, { size: 18 })
          }
        ),
        /* @__PURE__ */ d.jsxs("span", { className: "flex min-w-0 flex-col", children: [
          /* @__PURE__ */ d.jsx("span", { className: ue("truncate font-semibold", s ? "text-foreground" : "text-muted-foreground"), children: t(vn.title) }),
          /* @__PURE__ */ d.jsx("span", { "aria-live": "polite", className: "truncate text-sm text-muted-foreground", children: t(s ? vn.lineCount({ count: u }) : vn.linesCreated({ count: u })) })
        ] }),
        /* @__PURE__ */ d.jsx("div", { className: "zai-html-preview-card__actions ml-auto flex shrink-0 items-center gap-2", children: s && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsxs("button", { type: "button", onClick: p, className: Hp, children: [
            t(vn.open),
            /* @__PURE__ */ d.jsx(Eb, { size: 14 })
          ] }),
          /* @__PURE__ */ d.jsx(
            "button",
            {
              type: "button",
              onClick: E,
              "aria-label": t(vn.download),
              title: t(vn.download),
              className: Hp,
              children: /* @__PURE__ */ d.jsx(eP, { size: 14 })
            }
          )
        ] }) })
      ]
    }
  );
}, Ed = {
  isEnabled: (e) => Od.isEnabled(e),
  getValue: (e) => Od.getValue(e)
}, rU = {
  365: { unit: "months", value: 12 },
  730: { unit: "years", value: 2 },
  1095: { unit: "years", value: 3 }
}, Qn = {
  territoryGrouped: {
    key: "zai.widget.territory-type.grouped",
    defaultValue: "Visão geral"
  },
  territoryOwned: {
    key: "zai.widget.territory-type.owned",
    defaultValue: "Owned"
  },
  territoryEarned: {
    key: "zai.widget.territory-type.earned",
    defaultValue: "Earned (UGC)"
  },
  territoryPaid: {
    key: "zai.widget.territory-type.paid",
    defaultValue: "Paid"
  },
  lastNDays: (e) => ({
    key: "zai.widget.upload-date.last-n-days",
    parameters: e,
    defaultValue: "Últimos {days} dias"
  }),
  lastNMonths: (e) => ({
    key: "zai.widget.upload-date.last-n-months",
    parameters: e,
    defaultValue: "Últimos {months} meses"
  }),
  lastNYears: (e) => ({
    key: "zai.widget.upload-date.last-n-years",
    parameters: e,
    defaultValue: "Últimos {years} anos"
  })
}, wT = (e, t) => {
  switch (e) {
    case "earned":
      return t(Qn.territoryEarned);
    case "paid":
      return t(Qn.territoryPaid);
    case "selfContent":
    case "owned":
      return t(Qn.territoryOwned);
    default:
      return t(Qn.territoryGrouped);
  }
}, bd = (e, t) => {
  const n = rU[e];
  return n?.unit === "years" ? t(Qn.lastNYears({ years: n.value })) : n?.unit === "months" ? t(Qn.lastNMonths({ months: n.value })) : e >= 60 && e % 30 === 0 ? t(Qn.lastNMonths({ months: e / 30 })) : t(Qn.lastNDays({ days: e }));
};
var wa = { exports: {} }, sU = wa.exports, Bp;
function _d() {
  return Bp || (Bp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(sU, (function() {
      var n = 1e3, r = 6e4, s = 36e5, i = "millisecond", a = "second", o = "minute", u = "hour", c = "day", l = "week", h = "month", m = "quarter", p = "year", E = "date", g = "Invalid Date", _ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, b = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, T = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
        var H = ["th", "st", "nd", "rd"], B = M % 100;
        return "[" + M + (H[(B - 20) % 10] || H[B] || H[0]) + "]";
      } }, C = function(M, H, B) {
        var Y = String(M);
        return !Y || Y.length >= H ? M : "" + Array(H + 1 - Y.length).join(B) + M;
      }, R = { s: C, z: function(M) {
        var H = -M.utcOffset(), B = Math.abs(H), Y = Math.floor(B / 60), $ = B % 60;
        return (H <= 0 ? "+" : "-") + C(Y, 2, "0") + ":" + C($, 2, "0");
      }, m: function M(H, B) {
        if (H.date() < B.date()) return -M(B, H);
        var Y = 12 * (B.year() - H.year()) + (B.month() - H.month()), $ = H.clone().add(Y, h), Z = B - $ < 0, y = H.clone().add(Y + (Z ? -1 : 1), h);
        return +(-(Y + (B - $) / (Z ? $ - y : y - $)) || 0);
      }, a: function(M) {
        return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
      }, p: function(M) {
        return { M: h, y: p, w: l, d: c, D: E, h: u, m: o, s: a, ms: i, Q: m }[M] || String(M || "").toLowerCase().replace(/s$/, "");
      }, u: function(M) {
        return M === void 0;
      } }, D = "en", w = {};
      w[D] = T;
      var O = "$isDayjsObject", U = function(M) {
        return M instanceof G || !(!M || !M[O]);
      }, q = function M(H, B, Y) {
        var $;
        if (!H) return D;
        if (typeof H == "string") {
          var Z = H.toLowerCase();
          w[Z] && ($ = Z), B && (w[Z] = B, $ = Z);
          var y = H.split("-");
          if (!$ && y.length > 1) return M(y[0]);
        } else {
          var fe = H.name;
          w[fe] = H, $ = fe;
        }
        return !Y && $ && (D = $), $ || !Y && D;
      }, P = function(M, H) {
        if (U(M)) return M.clone();
        var B = typeof H == "object" ? H : {};
        return B.date = M, B.args = arguments, new G(B);
      }, z = R;
      z.l = q, z.i = U, z.w = function(M, H) {
        return P(M, { locale: H.$L, utc: H.$u, x: H.$x, $offset: H.$offset });
      };
      var G = (function() {
        function M(B) {
          this.$L = q(B.locale, null, !0), this.parse(B), this.$x = this.$x || B.x || {}, this[O] = !0;
        }
        var H = M.prototype;
        return H.parse = function(B) {
          this.$d = (function(Y) {
            var $ = Y.date, Z = Y.utc;
            if ($ === null) return /* @__PURE__ */ new Date(NaN);
            if (z.u($)) return /* @__PURE__ */ new Date();
            if ($ instanceof Date) return new Date($);
            if (typeof $ == "string" && !/Z$/i.test($)) {
              var y = $.match(_);
              if (y) {
                var fe = y[2] - 1 || 0, Ce = (y[7] || "0").substring(0, 3);
                return Z ? new Date(Date.UTC(y[1], fe, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, Ce)) : new Date(y[1], fe, y[3] || 1, y[4] || 0, y[5] || 0, y[6] || 0, Ce);
              }
            }
            return new Date($);
          })(B), this.init();
        }, H.init = function() {
          var B = this.$d;
          this.$y = B.getFullYear(), this.$M = B.getMonth(), this.$D = B.getDate(), this.$W = B.getDay(), this.$H = B.getHours(), this.$m = B.getMinutes(), this.$s = B.getSeconds(), this.$ms = B.getMilliseconds();
        }, H.$utils = function() {
          return z;
        }, H.isValid = function() {
          return this.$d.toString() !== g;
        }, H.isSame = function(B, Y) {
          var $ = P(B);
          return this.startOf(Y) <= $ && $ <= this.endOf(Y);
        }, H.isAfter = function(B, Y) {
          return P(B) < this.startOf(Y);
        }, H.isBefore = function(B, Y) {
          return this.endOf(Y) < P(B);
        }, H.$g = function(B, Y, $) {
          return z.u(B) ? this[Y] : this.set($, B);
        }, H.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, H.valueOf = function() {
          return this.$d.getTime();
        }, H.startOf = function(B, Y) {
          var $ = this, Z = !!z.u(Y) || Y, y = z.p(B), fe = function(he, le) {
            var ye = z.w($.$u ? Date.UTC($.$y, le, he) : new Date($.$y, le, he), $);
            return Z ? ye : ye.endOf(c);
          }, Ce = function(he, le) {
            return z.w($.toDate()[he].apply($.toDate("s"), (Z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(le)), $);
          }, v = this.$W, Se = this.$M, Te = this.$D, pe = "set" + (this.$u ? "UTC" : "");
          switch (y) {
            case p:
              return Z ? fe(1, 0) : fe(31, 11);
            case h:
              return Z ? fe(1, Se) : fe(0, Se + 1);
            case l:
              var re = this.$locale().weekStart || 0, Ae = (v < re ? v + 7 : v) - re;
              return fe(Z ? Te - Ae : Te + (6 - Ae), Se);
            case c:
            case E:
              return Ce(pe + "Hours", 0);
            case u:
              return Ce(pe + "Minutes", 1);
            case o:
              return Ce(pe + "Seconds", 2);
            case a:
              return Ce(pe + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, H.endOf = function(B) {
          return this.startOf(B, !1);
        }, H.$set = function(B, Y) {
          var $, Z = z.p(B), y = "set" + (this.$u ? "UTC" : ""), fe = ($ = {}, $[c] = y + "Date", $[E] = y + "Date", $[h] = y + "Month", $[p] = y + "FullYear", $[u] = y + "Hours", $[o] = y + "Minutes", $[a] = y + "Seconds", $[i] = y + "Milliseconds", $)[Z], Ce = Z === c ? this.$D + (Y - this.$W) : Y;
          if (Z === h || Z === p) {
            var v = this.clone().set(E, 1);
            v.$d[fe](Ce), v.init(), this.$d = v.set(E, Math.min(this.$D, v.daysInMonth())).$d;
          } else fe && this.$d[fe](Ce);
          return this.init(), this;
        }, H.set = function(B, Y) {
          return this.clone().$set(B, Y);
        }, H.get = function(B) {
          return this[z.p(B)]();
        }, H.add = function(B, Y) {
          var $, Z = this;
          B = Number(B);
          var y = z.p(Y), fe = function(Se) {
            var Te = P(Z);
            return z.w(Te.date(Te.date() + Math.round(Se * B)), Z);
          };
          if (y === h) return this.set(h, this.$M + B);
          if (y === p) return this.set(p, this.$y + B);
          if (y === c) return fe(1);
          if (y === l) return fe(7);
          var Ce = ($ = {}, $[o] = r, $[u] = s, $[a] = n, $)[y] || 1, v = this.$d.getTime() + B * Ce;
          return z.w(v, this);
        }, H.subtract = function(B, Y) {
          return this.add(-1 * B, Y);
        }, H.format = function(B) {
          var Y = this, $ = this.$locale();
          if (!this.isValid()) return $.invalidDate || g;
          var Z = B || "YYYY-MM-DDTHH:mm:ssZ", y = z.z(this), fe = this.$H, Ce = this.$m, v = this.$M, Se = $.weekdays, Te = $.months, pe = $.meridiem, re = function(le, ye, Pe, qe) {
            return le && (le[ye] || le(Y, Z)) || Pe[ye].slice(0, qe);
          }, Ae = function(le) {
            return z.s(fe % 12 || 12, le, "0");
          }, he = pe || function(le, ye, Pe) {
            var qe = le < 12 ? "AM" : "PM";
            return Pe ? qe.toLowerCase() : qe;
          };
          return Z.replace(b, (function(le, ye) {
            return ye || (function(Pe) {
              switch (Pe) {
                case "YY":
                  return String(Y.$y).slice(-2);
                case "YYYY":
                  return z.s(Y.$y, 4, "0");
                case "M":
                  return v + 1;
                case "MM":
                  return z.s(v + 1, 2, "0");
                case "MMM":
                  return re($.monthsShort, v, Te, 3);
                case "MMMM":
                  return re(Te, v);
                case "D":
                  return Y.$D;
                case "DD":
                  return z.s(Y.$D, 2, "0");
                case "d":
                  return String(Y.$W);
                case "dd":
                  return re($.weekdaysMin, Y.$W, Se, 2);
                case "ddd":
                  return re($.weekdaysShort, Y.$W, Se, 3);
                case "dddd":
                  return Se[Y.$W];
                case "H":
                  return String(fe);
                case "HH":
                  return z.s(fe, 2, "0");
                case "h":
                  return Ae(1);
                case "hh":
                  return Ae(2);
                case "a":
                  return he(fe, Ce, !0);
                case "A":
                  return he(fe, Ce, !1);
                case "m":
                  return String(Ce);
                case "mm":
                  return z.s(Ce, 2, "0");
                case "s":
                  return String(Y.$s);
                case "ss":
                  return z.s(Y.$s, 2, "0");
                case "SSS":
                  return z.s(Y.$ms, 3, "0");
                case "Z":
                  return y;
              }
              return null;
            })(le) || y.replace(":", "");
          }));
        }, H.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, H.diff = function(B, Y, $) {
          var Z, y = this, fe = z.p(Y), Ce = P(B), v = (Ce.utcOffset() - this.utcOffset()) * r, Se = this - Ce, Te = function() {
            return z.m(y, Ce);
          };
          switch (fe) {
            case p:
              Z = Te() / 12;
              break;
            case h:
              Z = Te();
              break;
            case m:
              Z = Te() / 3;
              break;
            case l:
              Z = (Se - v) / 6048e5;
              break;
            case c:
              Z = (Se - v) / 864e5;
              break;
            case u:
              Z = Se / s;
              break;
            case o:
              Z = Se / r;
              break;
            case a:
              Z = Se / n;
              break;
            default:
              Z = Se;
          }
          return $ ? Z : z.a(Z);
        }, H.daysInMonth = function() {
          return this.endOf(h).$D;
        }, H.$locale = function() {
          return w[this.$L];
        }, H.locale = function(B, Y) {
          if (!B) return this.$L;
          var $ = this.clone(), Z = q(B, Y, !0);
          return Z && ($.$L = Z), $;
        }, H.clone = function() {
          return z.w(this.$d, this);
        }, H.toDate = function() {
          return new Date(this.valueOf());
        }, H.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, H.toISOString = function() {
          return this.$d.toISOString();
        }, H.toString = function() {
          return this.$d.toUTCString();
        }, M;
      })(), F = G.prototype;
      return P.prototype = F, [["$ms", i], ["$s", a], ["$m", o], ["$H", u], ["$W", c], ["$M", h], ["$y", p], ["$D", E]].forEach((function(M) {
        F[M[1]] = function(H) {
          return this.$g(H, M[0], M[1]);
        };
      })), P.extend = function(M, H) {
        return M.$i || (M(H, G, P), M.$i = !0), P;
      }, P.locale = q, P.isDayjs = U, P.unix = function(M) {
        return P(1e3 * M);
      }, P.en = w[D], P.Ls = w, P.p = {}, P;
    }));
  })(wa)), wa.exports;
}
var iU = _d();
const wr = /* @__PURE__ */ Dr(iU), aU = (e) => sr[e] || sr.grouped, oU = (e, t) => {
  const n = {
    quarter: "MMM/YYYY",
    month: "MMM/YYYY",
    week: "MMM, DD YYYY",
    day: "MMM, DD YYYY"
  };
  return t === "quarter" ? `${wr(e).utc().format("MMM")}-${wr(e).add(2, "months").utc().format(n.quarter)}` : wr(e).utc().format(n[t]);
}, uU = ({
  provider: e = "all",
  territoryType: t = "grouped",
  timeRangeInDays: n = 30
}) => {
  const r = Ed.isEnabled("isNewPageBrandOverviewEnabled"), { workspaceId: s } = at(), i = Br(), { t: a } = He(), o = se(() => {
    const R = Kt(
      Bn[te.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE],
      {
        panelId: s,
        tab: aU(t)
      }
    ), D = wb({ provider: e, timeRangeInDays: n }).toString();
    return D ? `${R}?${D}` : R;
  }, [e, t, n, s]), [u, c] = ce([]), [l, h] = ce(!1), [m, p] = ce(!1), E = ne(async () => {
    if (s) {
      h(!0), p(!1);
      try {
        const R = await i.getBrandEngagementOverTimeData(
          {
            provider: e,
            territoryType: t,
            timeRangeInDays: n?.toString()
          },
          { isNewPageBrandOverviewEnabled: r }
        );
        c(R);
      } catch {
        p(!0), c([]);
      } finally {
        h(!1);
      }
    }
  }, [s, i, e, t, n, r]);
  _e(() => {
    E();
  }, [E]);
  const g = se(() => u?.map((R) => {
    const D = R.metrics.map((w) => w.totalEngagement);
    return {
      name: R.name,
      color: R.color,
      series: D
    };
  }) || [], [u]), _ = se(() => !u || u.length === 0 ? [] : u[0]?.metrics?.map((R) => R.date) || [], [u]), b = se(() => {
    const R = Ic(n);
    return _.map((D) => oU(D, R));
  }, [_, n]), T = se(
    () => g.length === 0 || g.flatMap((R) => R.series).every((R) => R === 0),
    [g]
  ), C = se(() => {
    const R = Pl[e], D = wT(t, a), w = bd(n, a);
    return [R, D, w].join(" · ");
  }, [e, t, n, a]);
  return {
    data: u,
    isLoading: l,
    isError: m,
    isEmpty: T,
    refetch: E,
    macroareaURL: o,
    chartEntities: g,
    chartLabels: b,
    subtitle: C
  };
}, Up = {
  chart: {
    key: "widget-error.chart.title",
    defaultValue: "O gráfico falhou ao carregar"
  },
  video: {
    key: "widget-error.video.title",
    defaultValue: "O vídeo falhou ao carregar"
  },
  creator: {
    key: "widget-error.creator.title",
    defaultValue: "O criador falhou ao carregar"
  },
  tryAgain: {
    key: "widget-error.try-again",
    defaultValue: "Tentar novamente"
  }
}, Ns = ({ refetch: e, name: t }) => {
  const { t: n } = He(), r = Up;
  return /* @__PURE__ */ d.jsxs("div", { className: "my-5 w-full flex flex-col items-center justify-center gap-4", children: [
    /* @__PURE__ */ d.jsx("strong", { children: n(r[t]) }),
    e && /* @__PURE__ */ d.jsx(pt, { variant: "highlight-border", onClick: e, children: n(Up.tryAgain) })
  ] });
}, IT = Tt("dark"), Td = ({ theme: e, children: t }) => /* @__PURE__ */ d.jsx(IT.Provider, { value: e, children: t }), hr = () => mt(IT), Fp = {
  accessMacroarea: {
    key: "brand-engagement-over-time.access-macroarea",
    defaultValue: "Acessar Engajamento"
  },
  noDataAvailable: {
    key: "brand-engagement-over-time.no-data-available",
    defaultValue: "Nenhum dado de engajamento disponível para o período selecionado"
  }
}, cU = () => /* @__PURE__ */ d.jsx("div", { className: "w-full h-96 flex items-center justify-center", children: /* @__PURE__ */ d.jsx("div", { className: "animate-pulse w-full h-96 bg-muted rounded-md" }) }), lU = ({
  isError: e,
  isLoading: t,
  isEmpty: n,
  macroareaURL: r,
  refetch: s,
  chartEntities: i,
  chartLabels: a,
  subtitle: o
}) => {
  const { t: u } = He(), c = hr();
  return /* @__PURE__ */ d.jsxs("div", { className: "my-5 w-full flex flex-col gap-6", children: [
    o && /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: o }),
    /* @__PURE__ */ d.jsx(
      Ur,
      {
        isLoading: t,
        isError: e,
        loadingComponent: /* @__PURE__ */ d.jsx(cU, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ns, { name: "chart", refetch: s }),
        isEmpty: n,
        emptyComponent: /* @__PURE__ */ d.jsx("div", { className: "flex justify-center items-center h-96", children: /* @__PURE__ */ d.jsx("p", { className: "text-center text-muted-foreground", children: u(Fp.noDataAvailable) }) }),
        children: /* @__PURE__ */ d.jsx("div", { className: "w-full", children: /* @__PURE__ */ d.jsx(
          ln.LineChart,
          {
            legend: { type: "default" },
            entities: i,
            xAxisLabels: a,
            tooltip: { type: "default", shared: !0, formatter: (l) => qt(l, 2) },
            customOptions: {
              yAxis: {
                labels: {
                  formatter: function() {
                    return qt(Number(this.value), 0);
                  }
                }
              }
            },
            theme: c,
            height: 600
          }
        ) })
      }
    ),
    !e && /* @__PURE__ */ d.jsx(pt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: r, target: "_blank", rel: "noopener noreferrer", children: u(Fp.accessMacroarea) }) })
  ] });
}, dU = (e = {}) => {
  const t = uU(e);
  return /* @__PURE__ */ d.jsx(lU, { ...e, ...t });
}, hU = ({ creatorId: e, performanceInMonths: t = 1 }) => {
  const { workspaceId: n } = at(), r = Br(), [s, i] = ce(!1), [a, o] = ce(!1), [u, c] = ce(null), l = ne(async () => {
    if (!(!e || !n))
      try {
        i(!0), o(!1);
        const h = await r.getCreatorData(e, { performanceInMonths: t });
        c(h);
      } catch {
        o(!0);
      } finally {
        i(!1);
      }
  }, [n, e, t, r]);
  return _e(() => {
    l();
  }, [l]), {
    isLoading: s,
    isError: a,
    data: u,
    fetch: l
  };
}, fU = [
  {
    NAME: "Afghanistan",
    ALPHA_2: "AF",
    ALPHA_3: "AFG",
    CODE: 4,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Åland Islands",
    ALPHA_2: "AX",
    ALPHA_3: "ALA",
    CODE: 248,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Albania",
    ALPHA_2: "AL",
    ALPHA_3: "ALB",
    CODE: 8,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Algeria",
    ALPHA_2: "DZ",
    ALPHA_3: "DZA",
    CODE: 12,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "American Samoa",
    ALPHA_2: "AS",
    ALPHA_3: "ASM",
    CODE: 16,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Andorra",
    ALPHA_2: "AD",
    ALPHA_3: "AND",
    CODE: 20,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Angola",
    ALPHA_2: "AO",
    ALPHA_3: "AGO",
    CODE: 24,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Anguilla",
    ALPHA_2: "AI",
    ALPHA_3: "AIA",
    CODE: 660,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Antarctica",
    ALPHA_2: "AQ",
    ALPHA_3: "ATA",
    CODE: 10,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Antigua And Barbuda",
    ALPHA_2: "AG",
    ALPHA_3: "ATG",
    CODE: 28,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Argentina",
    ALPHA_2: "AR",
    ALPHA_3: "ARG",
    CODE: 32,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Armenia",
    ALPHA_2: "AM",
    ALPHA_3: "ARM",
    CODE: 51,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Aruba",
    ALPHA_2: "AW",
    ALPHA_3: "ABW",
    CODE: 533,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Australia",
    ALPHA_2: "AU",
    ALPHA_3: "AUS",
    CODE: 36,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Austria",
    ALPHA_2: "AT",
    ALPHA_3: "AUT",
    CODE: 40,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Azerbaijan",
    ALPHA_2: "AZ",
    ALPHA_3: "AZE",
    CODE: 31,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bahamas",
    ALPHA_2: "BS",
    ALPHA_3: "BHS",
    CODE: 44,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bahrain",
    ALPHA_2: "BH",
    ALPHA_3: "BHR",
    CODE: 48,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bangladesh",
    ALPHA_2: "BD",
    ALPHA_3: "BGD",
    CODE: 50,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Barbados",
    ALPHA_2: "BB",
    ALPHA_3: "BRB",
    CODE: 52,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belarus",
    ALPHA_2: "BY",
    ALPHA_3: "BLR",
    CODE: 112,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belgium",
    ALPHA_2: "BE",
    ALPHA_3: "BEL",
    CODE: 56,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Belize",
    ALPHA_2: "BZ",
    ALPHA_3: "BLZ",
    CODE: 84,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Benin",
    ALPHA_2: "BJ",
    ALPHA_3: "BEN",
    CODE: 204,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bermuda",
    ALPHA_2: "BM",
    ALPHA_3: "BMU",
    CODE: 60,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bhutan",
    ALPHA_2: "BT",
    ALPHA_3: "BTN",
    CODE: 64,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bolivia",
    ALPHA_2: "BO",
    ALPHA_3: "BOL",
    CODE: 68,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bonaire, Sint Eustatius and Saba",
    ALPHA_2: "BQ",
    ALPHA_3: "BES",
    CODE: 535,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bosnia And Herzegovina",
    ALPHA_2: "BA",
    ALPHA_3: "BIH",
    CODE: 70,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Botswana",
    ALPHA_2: "BW",
    ALPHA_3: "BWA",
    CODE: 72,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bouvet Island",
    ALPHA_2: "BV",
    ALPHA_3: "BVT",
    CODE: 74,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Brazil",
    ALPHA_2: "BR",
    ALPHA_3: "BRA",
    CODE: 76,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "British Indian Ocean Territory",
    ALPHA_2: "IO",
    ALPHA_3: "IOT",
    CODE: 86,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Brunei Darussalam",
    ALPHA_2: "BN",
    ALPHA_3: "BRN",
    CODE: 96,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Bulgaria",
    ALPHA_2: "BG",
    ALPHA_3: "BGR",
    CODE: 100,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burkina Faso",
    ALPHA_2: "BF",
    ALPHA_3: "BFA",
    CODE: 854,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burundi",
    ALPHA_2: "BI",
    ALPHA_3: "BDI",
    CODE: 108,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cape Verde",
    ALPHA_2: "CV",
    ALPHA_3: "CPV",
    CODE: 132,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cambodia",
    ALPHA_2: "KH",
    ALPHA_3: "KHM",
    CODE: 116,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cameroon",
    ALPHA_2: "CM",
    ALPHA_3: "CMR",
    CODE: 120,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Canada",
    ALPHA_2: "CA",
    ALPHA_3: "CAN",
    CODE: 124,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cayman Islands",
    ALPHA_2: "KY",
    ALPHA_3: "CYM",
    CODE: 136,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Central African Republic",
    ALPHA_2: "CF",
    ALPHA_3: "CAF",
    CODE: 140,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Chad",
    ALPHA_2: "TD",
    ALPHA_3: "TCD",
    CODE: 148,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Chile",
    ALPHA_2: "CL",
    ALPHA_3: "CHL",
    CODE: 152,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "China",
    ALPHA_2: "CN",
    ALPHA_3: "CHN",
    CODE: 156,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Christmas Island",
    ALPHA_2: "CX",
    ALPHA_3: "CXR",
    CODE: 162,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cocos (keeling) Islands",
    ALPHA_2: "CC",
    ALPHA_3: "CCK",
    CODE: 166,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Colombia",
    ALPHA_2: "CO",
    ALPHA_3: "COL",
    CODE: 170,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Comoros",
    ALPHA_2: "KM",
    ALPHA_3: "COM",
    CODE: 174,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Congo",
    ALPHA_2: "CG",
    ALPHA_3: "COG",
    CODE: 178,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Congo, The Democratic Republic Of The",
    ALPHA_2: "CD",
    ALPHA_3: "COD",
    CODE: 180,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cook Islands",
    ALPHA_2: "CK",
    ALPHA_3: "COK",
    CODE: 184,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Costa Rica",
    ALPHA_2: "CR",
    ALPHA_3: "CRI",
    CODE: 188,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "CÔte D'ivoire",
    ALPHA_2: "CI",
    ALPHA_3: "CIV",
    CODE: 384,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Croatia",
    ALPHA_2: "HR",
    ALPHA_3: "HRV",
    CODE: 191,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cuba",
    ALPHA_2: "CU",
    ALPHA_3: "CUB",
    CODE: 192,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Curaçao",
    ALPHA_2: "CW",
    ALPHA_3: "CUW",
    CODE: 531,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Cyprus",
    ALPHA_2: "CY",
    ALPHA_3: "CYP",
    CODE: 196,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Czech Republic",
    ALPHA_2: "CZ",
    ALPHA_3: "CZE",
    CODE: 203,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Denmark",
    ALPHA_2: "DK",
    ALPHA_3: "DNK",
    CODE: 208,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Djibouti",
    ALPHA_2: "DJ",
    ALPHA_3: "DJI",
    CODE: 262,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Dominica",
    ALPHA_2: "DM",
    ALPHA_3: "DMA",
    CODE: 212,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Dominican Republic",
    ALPHA_2: "DO",
    ALPHA_3: "DOM",
    CODE: 214,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ecuador",
    ALPHA_2: "EC",
    ALPHA_3: "ECU",
    CODE: 218,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Egypt",
    ALPHA_2: "EG",
    ALPHA_3: "EGY",
    CODE: 818,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "El Salvador",
    ALPHA_2: "SV",
    ALPHA_3: "SLV",
    CODE: 222,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Equatorial Guinea",
    ALPHA_2: "GQ",
    ALPHA_3: "GNQ",
    CODE: 226,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Eritrea",
    ALPHA_2: "ER",
    ALPHA_3: "ERI",
    CODE: 232,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Estonia",
    ALPHA_2: "EE",
    ALPHA_3: "EST",
    CODE: 233,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Swaziland",
    ALPHA_2: "SZ",
    ALPHA_3: "SWZ",
    CODE: 748,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ethiopia",
    ALPHA_2: "ET",
    ALPHA_3: "ETH",
    CODE: 231,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Falkland Islands (malvinas)",
    ALPHA_2: "FK",
    ALPHA_3: "FLK",
    CODE: 238,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Faroe Islands",
    ALPHA_2: "FO",
    ALPHA_3: "FRO",
    CODE: 234,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Fiji",
    ALPHA_2: "FJ",
    ALPHA_3: "FJI",
    CODE: 242,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Finland",
    ALPHA_2: "FI",
    ALPHA_3: "FIN",
    CODE: 246,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "France",
    ALPHA_2: "FR",
    ALPHA_3: "FRA",
    CODE: 250,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Guiana",
    ALPHA_2: "GF",
    ALPHA_3: "GUF",
    CODE: 254,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Polynesia",
    ALPHA_2: "PF",
    ALPHA_3: "PYF",
    CODE: 258,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "French Southern Territories",
    ALPHA_2: "TF",
    ALPHA_3: "ATF",
    CODE: 260,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Gabon",
    ALPHA_2: "GA",
    ALPHA_3: "GAB",
    CODE: 266,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "The Gambia",
    ALPHA_2: "GM",
    ALPHA_3: "GMB",
    CODE: 270,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Georgia",
    ALPHA_2: "GE",
    ALPHA_3: "GEO",
    CODE: 268,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Germany",
    ALPHA_2: "DE",
    ALPHA_3: "DEU",
    CODE: 276,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ghana",
    ALPHA_2: "GH",
    ALPHA_3: "GHA",
    CODE: 288,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Gibraltar",
    ALPHA_2: "GI",
    ALPHA_3: "GIB",
    CODE: 292,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Greece",
    ALPHA_2: "GR",
    ALPHA_3: "GRC",
    CODE: 300,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Greenland",
    ALPHA_2: "GL",
    ALPHA_3: "GRL",
    CODE: 304,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Grenada",
    ALPHA_2: "GD",
    ALPHA_3: "GRD",
    CODE: 308,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guadeloupe",
    ALPHA_2: "GP",
    ALPHA_3: "GLP",
    CODE: 312,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guam",
    ALPHA_2: "GU",
    ALPHA_3: "GUM",
    CODE: 316,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guatemala",
    ALPHA_2: "GT",
    ALPHA_3: "GTM",
    CODE: 320,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guernsey",
    ALPHA_2: "GG",
    ALPHA_3: "GGY",
    CODE: 831,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guinea",
    ALPHA_2: "GN",
    ALPHA_3: "GIN",
    CODE: 324,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guinea-Bissau",
    ALPHA_2: "GW",
    ALPHA_3: "GNB",
    CODE: 624,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Guyana",
    ALPHA_2: "GY",
    ALPHA_3: "GUY",
    CODE: 328,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Haiti",
    ALPHA_2: "HT",
    ALPHA_3: "HTI",
    CODE: 332,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Heard Island And Mcdonald Islands",
    ALPHA_2: "HM",
    ALPHA_3: "HMD",
    CODE: 334,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Vatican City",
    ALPHA_2: "VA",
    ALPHA_3: "VAT",
    CODE: 336,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Honduras",
    ALPHA_2: "HN",
    ALPHA_3: "HND",
    CODE: 340,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Hong Kong",
    ALPHA_2: "HK",
    ALPHA_3: "HKG",
    CODE: 344,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Hungary",
    ALPHA_2: "HU",
    ALPHA_3: "HUN",
    CODE: 348,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iceland",
    ALPHA_2: "IS",
    ALPHA_3: "ISL",
    CODE: 352,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "India",
    ALPHA_2: "IN",
    ALPHA_3: "IND",
    CODE: 356,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Indonesia",
    ALPHA_2: "ID",
    ALPHA_3: "IDN",
    CODE: 360,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iran",
    ALPHA_2: "IR",
    ALPHA_3: "IRN",
    CODE: 364,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Iraq",
    ALPHA_2: "IQ",
    ALPHA_3: "IRQ",
    CODE: 368,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ireland",
    ALPHA_2: "IE",
    ALPHA_3: "IRL",
    CODE: 372,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Isle Of Man",
    ALPHA_2: "IM",
    ALPHA_3: "IMN",
    CODE: 833,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Israel",
    ALPHA_2: "IL",
    ALPHA_3: "ISR",
    CODE: 376,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Italy",
    ALPHA_2: "IT",
    ALPHA_3: "ITA",
    CODE: 380,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jamaica",
    ALPHA_2: "JM",
    ALPHA_3: "JAM",
    CODE: 388,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Japan",
    ALPHA_2: "JP",
    ALPHA_3: "JPN",
    CODE: 392,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jersey",
    ALPHA_2: "JE",
    ALPHA_3: "JEY",
    CODE: 832,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Jordan",
    ALPHA_2: "JO",
    ALPHA_3: "JOR",
    CODE: 400,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kazakhstan",
    ALPHA_2: "KZ",
    ALPHA_3: "KAZ",
    CODE: 398,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kenya",
    ALPHA_2: "KE",
    ALPHA_3: "KEN",
    CODE: 404,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kiribati",
    ALPHA_2: "KI",
    ALPHA_3: "KIR",
    CODE: 296,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "North Korea",
    ALPHA_2: "KP",
    ALPHA_3: "PRK",
    CODE: 408,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Korea",
    ALPHA_2: "KR",
    ALPHA_3: "KOR",
    CODE: 410,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kuwait",
    ALPHA_2: "KW",
    ALPHA_3: "KWT",
    CODE: 414,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Kyrgyzstan",
    ALPHA_2: "KG",
    ALPHA_3: "KGZ",
    CODE: 417,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lao People's Democratic Republic",
    ALPHA_2: "LA",
    ALPHA_3: "LAO",
    CODE: 418,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Latvia",
    ALPHA_2: "LV",
    ALPHA_3: "LVA",
    CODE: 428,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lebanon",
    ALPHA_2: "LB",
    ALPHA_3: "LBN",
    CODE: 422,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lesotho",
    ALPHA_2: "LS",
    ALPHA_3: "LSO",
    CODE: 426,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Liberia",
    ALPHA_2: "LR",
    ALPHA_3: "LBR",
    CODE: 430,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Libya",
    ALPHA_2: "LY",
    ALPHA_3: "LBY",
    CODE: 434,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Liechtenstein",
    ALPHA_2: "LI",
    ALPHA_3: "LIE",
    CODE: 438,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Lithuania",
    ALPHA_2: "LT",
    ALPHA_3: "LTU",
    CODE: 440,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Luxembourg",
    ALPHA_2: "LU",
    ALPHA_3: "LUX",
    CODE: 442,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Macao",
    ALPHA_2: "MO",
    ALPHA_3: "MAC",
    CODE: 446,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Republic of Macedonia",
    ALPHA_2: "MK",
    ALPHA_3: "MKD",
    CODE: 807,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Madagascar",
    ALPHA_2: "MG",
    ALPHA_3: "MDG",
    CODE: 450,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malawi",
    ALPHA_2: "MW",
    ALPHA_3: "MWI",
    CODE: 454,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malaysia",
    ALPHA_2: "MY",
    ALPHA_3: "MYS",
    CODE: 458,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Maldives",
    ALPHA_2: "MV",
    ALPHA_3: "MDV",
    CODE: 462,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mali",
    ALPHA_2: "ML",
    ALPHA_3: "MLI",
    CODE: 466,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Malta",
    ALPHA_2: "MT",
    ALPHA_3: "MLT",
    CODE: 470,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Marshall Islands",
    ALPHA_2: "MH",
    ALPHA_3: "MHL",
    CODE: 584,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Martinique",
    ALPHA_2: "MQ",
    ALPHA_3: "MTQ",
    CODE: 474,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mauritania",
    ALPHA_2: "MR",
    ALPHA_3: "MRT",
    CODE: 478,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mauritius",
    ALPHA_2: "MU",
    ALPHA_3: "MUS",
    CODE: 480,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mayotte",
    ALPHA_2: "YT",
    ALPHA_3: "MYT",
    CODE: 175,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mexico",
    ALPHA_2: "MX",
    ALPHA_3: "MEX",
    CODE: 484,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Micronesia, Federated States Of",
    ALPHA_2: "FM",
    ALPHA_3: "FSM",
    CODE: 583,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Moldova",
    ALPHA_2: "MD",
    ALPHA_3: "MDA",
    CODE: 498,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Monaco",
    ALPHA_2: "MC",
    ALPHA_3: "MCO",
    CODE: 492,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mongolia",
    ALPHA_2: "MN",
    ALPHA_3: "MNG",
    CODE: 496,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Montenegro",
    ALPHA_2: "ME",
    ALPHA_3: "MNE",
    CODE: 499,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Montserrat",
    ALPHA_2: "MS",
    ALPHA_3: "MSR",
    CODE: 500,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Morocco",
    ALPHA_2: "MA",
    ALPHA_3: "MAR",
    CODE: 504,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Mozambique",
    ALPHA_2: "MZ",
    ALPHA_3: "MOZ",
    CODE: 508,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Burma",
    ALPHA_2: "MM",
    ALPHA_3: "MMR",
    CODE: 104,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Namibia",
    ALPHA_2: "NA",
    ALPHA_3: "NAM",
    CODE: 516,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nauru",
    ALPHA_2: "NR",
    ALPHA_3: "NRU",
    CODE: 520,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nepal",
    ALPHA_2: "NP",
    ALPHA_3: "NPL",
    CODE: 524,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Netherlands",
    ALPHA_2: "NL",
    ALPHA_3: "NLD",
    CODE: 528,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "New Caledonia",
    ALPHA_2: "NC",
    ALPHA_3: "NCL",
    CODE: 540,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "New Zealand",
    ALPHA_2: "NZ",
    ALPHA_3: "NZL",
    CODE: 554,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nicaragua",
    ALPHA_2: "NI",
    ALPHA_3: "NIC",
    CODE: 558,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Niger",
    ALPHA_2: "NE",
    ALPHA_3: "NER",
    CODE: 562,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Nigeria",
    ALPHA_2: "NG",
    ALPHA_3: "NGA",
    CODE: 566,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Niue",
    ALPHA_2: "NU",
    ALPHA_3: "NIU",
    CODE: 570,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Norfolk Island",
    ALPHA_2: "NF",
    ALPHA_3: "NFK",
    CODE: 574,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Northern Mariana Islands",
    ALPHA_2: "MP",
    ALPHA_3: "MNP",
    CODE: 580,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Norway",
    ALPHA_2: "NO",
    ALPHA_3: "NOR",
    CODE: 578,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Oman",
    ALPHA_2: "OM",
    ALPHA_3: "OMN",
    CODE: 512,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Pakistan",
    ALPHA_2: "PK",
    ALPHA_3: "PAK",
    CODE: 586,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Palau",
    ALPHA_2: "PW",
    ALPHA_3: "PLW",
    CODE: 585,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Palestinian Territory",
    ALPHA_2: "PS",
    ALPHA_3: "PSE",
    CODE: 275,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Panama",
    ALPHA_2: "PA",
    ALPHA_3: "PAN",
    CODE: 591,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Papua New Guinea",
    ALPHA_2: "PG",
    ALPHA_3: "PNG",
    CODE: 598,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Paraguay",
    ALPHA_2: "PY",
    ALPHA_3: "PRY",
    CODE: 600,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Peru",
    ALPHA_2: "PE",
    ALPHA_3: "PER",
    CODE: 604,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Philippines",
    ALPHA_2: "PH",
    ALPHA_3: "PHL",
    CODE: 608,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Pitcairn",
    ALPHA_2: "PN",
    ALPHA_3: "PCN",
    CODE: 612,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Poland",
    ALPHA_2: "PL",
    ALPHA_3: "POL",
    CODE: 616,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Portugal",
    ALPHA_2: "PT",
    ALPHA_3: "PRT",
    CODE: 620,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Puerto Rico",
    ALPHA_2: "PR",
    ALPHA_3: "PRI",
    CODE: 630,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Qatar",
    ALPHA_2: "QA",
    ALPHA_3: "QAT",
    CODE: 634,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "RÉunion",
    ALPHA_2: "RE",
    ALPHA_3: "REU",
    CODE: 638,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Romania",
    ALPHA_2: "RO",
    ALPHA_3: "ROU",
    CODE: 642,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Russian Federation",
    ALPHA_2: "RU",
    ALPHA_3: "RUS",
    CODE: 643,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Rwanda",
    ALPHA_2: "RW",
    ALPHA_3: "RWA",
    CODE: 646,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Barthélemy",
    ALPHA_2: "BL",
    ALPHA_3: "BLM",
    CODE: 652,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Helena",
    ALPHA_2: "SH",
    ALPHA_3: "SHN",
    CODE: 654,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Kitts And Nevis",
    ALPHA_2: "KN",
    ALPHA_3: "KNA",
    CODE: 659,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Lucia",
    ALPHA_2: "LC",
    ALPHA_3: "LCA",
    CODE: 662,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Martin (French part)",
    ALPHA_2: "MF",
    ALPHA_3: "MAF",
    CODE: 663,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Pierre And Miquelon",
    ALPHA_2: "PM",
    ALPHA_3: "SPM",
    CODE: 666,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saint Vincent and the Grenadines",
    ALPHA_2: "VC",
    ALPHA_3: "VCT",
    CODE: 670,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Samoa",
    ALPHA_2: "WS",
    ALPHA_3: "WSM",
    CODE: 882,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "San Marino",
    ALPHA_2: "SM",
    ALPHA_3: "SMR",
    CODE: 674,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sao Tome And Principe",
    ALPHA_2: "ST",
    ALPHA_3: "STP",
    CODE: 678,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Saudi Arabia",
    ALPHA_2: "SA",
    ALPHA_3: "SAU",
    CODE: 682,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Senegal",
    ALPHA_2: "SN",
    ALPHA_3: "SEN",
    CODE: 686,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Serbia",
    ALPHA_2: "RS",
    ALPHA_3: "SRB",
    CODE: 688,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Seychelles",
    ALPHA_2: "SC",
    ALPHA_3: "SYC",
    CODE: 690,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sierra Leone",
    ALPHA_2: "SL",
    ALPHA_3: "SLE",
    CODE: 694,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Singapore",
    ALPHA_2: "SG",
    ALPHA_3: "SGP",
    CODE: 702,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sint Maarten (Dutch part)",
    ALPHA_2: "SX",
    ALPHA_3: "SXM",
    CODE: 534,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Slovakia",
    ALPHA_2: "SK",
    ALPHA_3: "SVK",
    CODE: 703,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Slovenia",
    ALPHA_2: "SI",
    ALPHA_3: "SVN",
    CODE: 705,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Solomon Islands",
    ALPHA_2: "SB",
    ALPHA_3: "SLB",
    CODE: 90,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Somalia",
    ALPHA_2: "SO",
    ALPHA_3: "SOM",
    CODE: 706,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Africa",
    ALPHA_2: "ZA",
    ALPHA_3: "ZAF",
    CODE: 710,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Georgia And The South Sandwich Islands",
    ALPHA_2: "GS",
    ALPHA_3: "SGS",
    CODE: 239,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "South Sudan",
    ALPHA_2: "SS",
    ALPHA_3: "SSD",
    CODE: 728,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Spain",
    ALPHA_2: "ES",
    ALPHA_3: "ESP",
    CODE: 724,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sri Lanka",
    ALPHA_2: "LK",
    ALPHA_3: "LKA",
    CODE: 144,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sudan",
    ALPHA_2: "SD",
    ALPHA_3: "SDN",
    CODE: 729,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Suriname",
    ALPHA_2: "SR",
    ALPHA_3: "SUR",
    CODE: 740,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Svalbard And Jan Mayen",
    ALPHA_2: "SJ",
    ALPHA_3: "SJM",
    CODE: 744,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Sweden",
    ALPHA_2: "SE",
    ALPHA_3: "SWE",
    CODE: 752,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Switzerland",
    ALPHA_2: "CH",
    ALPHA_3: "CHE",
    CODE: 756,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Syrian Arab Republic",
    ALPHA_2: "SY",
    ALPHA_3: "SYR",
    CODE: 760,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Taiwan",
    ALPHA_2: "TW",
    ALPHA_3: "TWN",
    CODE: 158,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tajikistan",
    ALPHA_2: "TJ",
    ALPHA_3: "TJK",
    CODE: 762,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tanzania, United Republic Of",
    ALPHA_2: "TZ",
    ALPHA_3: "TZA",
    CODE: 834,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Thailand",
    ALPHA_2: "TH",
    ALPHA_3: "THA",
    CODE: 764,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "East Timor",
    ALPHA_2: "TL",
    ALPHA_3: "TLS",
    CODE: 626,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Togo",
    ALPHA_2: "TG",
    ALPHA_3: "TGO",
    CODE: 768,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tokelau",
    ALPHA_2: "TK",
    ALPHA_3: "TKL",
    CODE: 772,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tonga",
    ALPHA_2: "TO",
    ALPHA_3: "TON",
    CODE: 776,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Trinidad And Tobago",
    ALPHA_2: "TT",
    ALPHA_3: "TTO",
    CODE: 780,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tunisia",
    ALPHA_2: "TN",
    ALPHA_3: "TUN",
    CODE: 788,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turkey",
    ALPHA_2: "TR",
    ALPHA_3: "TUR",
    CODE: 792,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turkmenistan",
    ALPHA_2: "TM",
    ALPHA_3: "TKM",
    CODE: 795,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Turks And Caicos Islands",
    ALPHA_2: "TC",
    ALPHA_3: "TCA",
    CODE: 796,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Tuvalu",
    ALPHA_2: "TV",
    ALPHA_3: "TUV",
    CODE: 798,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uganda",
    ALPHA_2: "UG",
    ALPHA_3: "UGA",
    CODE: 800,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Ukraine",
    ALPHA_2: "UA",
    ALPHA_3: "UKR",
    CODE: 804,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United Arab Emirates",
    ALPHA_2: "AE",
    ALPHA_3: "ARE",
    CODE: 784,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United Kingdom",
    ALPHA_2: "GB",
    ALPHA_3: "GBR",
    CODE: 826,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United States",
    ALPHA_2: "US",
    ALPHA_3: "USA",
    CODE: 840,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "United States Minor Outlying Islands",
    ALPHA_2: "UM",
    ALPHA_3: "UMI",
    CODE: 581,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uruguay",
    ALPHA_2: "UY",
    ALPHA_3: "URY",
    CODE: 858,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Uzbekistan",
    ALPHA_2: "UZ",
    ALPHA_3: "UZB",
    CODE: 860,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Vanuatu",
    ALPHA_2: "VU",
    ALPHA_3: "VUT",
    CODE: 548,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Venezuela",
    ALPHA_2: "VE",
    ALPHA_3: "VEN",
    CODE: 862,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Viet Nam",
    ALPHA_2: "VN",
    ALPHA_3: "VNM",
    CODE: 704,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "British Virgin Islands",
    ALPHA_2: "VG",
    ALPHA_3: "VGB",
    CODE: 92,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Virgin Islands, U.s.",
    ALPHA_2: "VI",
    ALPHA_3: "VIR",
    CODE: 850,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Wallis And Futuna",
    ALPHA_2: "WF",
    ALPHA_3: "WLF",
    CODE: 876,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Western Sahara",
    ALPHA_2: "EH",
    ALPHA_3: "ESH",
    CODE: 732,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Yemen",
    ALPHA_2: "YE",
    ALPHA_3: "YEM",
    CODE: 887,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Zambia",
    ALPHA_2: "ZM",
    ALPHA_3: "ZMB",
    CODE: 894,
    HAS_AUDIENCE: !0
  },
  {
    NAME: "Zimbabwe",
    ALPHA_2: "ZW",
    ALPHA_3: "ZWE",
    CODE: 716,
    HAS_AUDIENCE: !0
  }
], pU = ({ countryCode: e }) => {
  const t = e?.toUpperCase();
  return fU.find(
    (r) => r.ALPHA_2 === t || r.ALPHA_3 === t || r.NAME.toUpperCase() === t
  );
}, jp = {
  subscribers: {
    key: "creator-widget.subscribers",
    defaultValue: "Inscritos"
  },
  engagement: {
    key: "creator-widget.engagement",
    defaultValue: "Engajamento/Vídeo"
  }
}, mU = ({ creator: e, workspaceId: t, t: n }) => ({
  data: se(() => {
    if (!e || !t) return;
    const s = Kt(Bn[te.CREATOR], {
      id: e.id,
      provider: e.provider
    }), i = e.performance?.analytics;
    return {
      title: e.title,
      hasTrendTag: e.isTrending,
      creatorUrl: s,
      provider: e.provider,
      thumbnail: {
        imageUrl: e.thumbnail ?? ""
      },
      description: pU({ countryCode: e.country ?? "" })?.NAME,
      metrics: {
        data: [
          { title: n(jp.subscribers), value: qt(e.subscribers) },
          {
            title: n(jp.engagement),
            value: qt(i?.avgEngagement ?? 0),
            variation: i?.avgEngagementVariation && i.avgEngagementVariation !== 0 ? {
              value: `${Math.abs(i.avgEngagementVariation * 100).toFixed(1)}%`,
              sign: i.avgEngagementVariation > 0 ? "positive" : "negative"
            } : void 0
          }
        ]
      }
    };
  }, [t, e, n])
}), gU = () => /* @__PURE__ */ d.jsxs("div", { className: "flex w-full h-full gap-4", children: [
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-[100px] h-full min-h-[112px] shrink-0" }),
  /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col w-full h-[100%] gap-6", children: [
    /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }),
    /* @__PURE__ */ d.jsxs("div", { className: "flex w-full gap-6", children: [
      /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-2 w-[40%]", children: [
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }),
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-[80%] h-[10px]" })
      ] }),
      /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-2 w-[40%]", children: [
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-full h-4" }),
        /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-[6px] w-[80%] h-[10px]" })
      ] })
    ] })
  ] })
] }), EU = de(gU), bU = ({ data: e, refetch: t, showError: n, showLoading: r, theme: s }) => /* @__PURE__ */ d.jsx("div", { className: "w-[324px] min-h-[112px] mt-[20px] mb-[40px] px-4 flex float-left", children: /* @__PURE__ */ d.jsx(
  Ur,
  {
    isLoading: r,
    isError: n,
    loadingComponent: /* @__PURE__ */ d.jsx(EU, {}),
    errorComponent: /* @__PURE__ */ d.jsx(Ns, { name: "creator", refetch: t }),
    children: e && /* @__PURE__ */ d.jsx(
      ln.CreatorCardDefault,
      {
        ...e,
        theme: s,
        thumbnail: {
          ...e.thumbnail,
          IconProvider: /* @__PURE__ */ d.jsx(ln.Icon, { name: vb[e.provider] })
        }
      }
    )
  }
) }), _U = de(bU), TU = ({ creatorId: e, performanceInMonths: t }) => {
  const { workspaceId: n } = at(), r = hr(), { t: s } = He(), {
    data: i,
    fetch: a,
    isError: o,
    isLoading: u
  } = hU({
    creatorId: e,
    performanceInMonths: t
  }), c = mU({
    workspaceId: n,
    creator: i,
    t: s
  });
  return /* @__PURE__ */ d.jsx(
    _U,
    {
      ...c,
      theme: r,
      showError: o,
      showLoading: u,
      refetch: a
    }
  );
}, AU = de(TU), yU = ({ postId: e }) => {
  const { workspaceId: t } = at(), n = Br(), [r, s] = ce(!1), [i, a] = ce(!1), [o, u] = ce(null), c = ne(async () => {
    const l = `/api/workspace/${t}/posts/${e}`;
    if (!(!e || !t))
      try {
        s(!0), a(!1);
        const h = await n.getPostData(e);
        u(h);
      } catch (h) {
        console.error({
          log: "Zai Chat - Error to fetch post from backend",
          query: { name: l, variables: { postId: e } },
          error: h
        }), a(!0);
      } finally {
        s(!1);
      }
  }, [t, e, n]);
  return _e(() => {
    c();
  }, [c]), {
    isLoading: r,
    isError: i,
    data: o,
    fetch: c
  };
};
var Ia = { exports: {} }, xU = Ia.exports, $p;
function CU() {
  return $p || ($p = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(xU, (function() {
      return function(n, r, s) {
        n = n || {};
        var i = r.prototype, a = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function o(c, l, h, m) {
          return i.fromToBase(c, l, h, m);
        }
        s.en.relativeTime = a, i.fromToBase = function(c, l, h, m, p) {
          for (var E, g, _, b = h.$locale().relativeTime || a, T = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], C = T.length, R = 0; R < C; R += 1) {
            var D = T[R];
            D.d && (E = m ? s(c).diff(h, D.d, !0) : h.diff(c, D.d, !0));
            var w = (n.rounding || Math.round)(Math.abs(E));
            if (_ = E > 0, w <= D.r || !D.r) {
              w <= 1 && R > 0 && (D = T[R - 1]);
              var O = b[D.l];
              p && (w = p("" + w)), g = typeof O == "string" ? O.replace("%d", w) : O(w, l, D.l, _);
              break;
            }
          }
          if (l) return g;
          var U = _ ? b.future : b.past;
          return typeof U == "function" ? U(g) : U.replace("%s", g);
        }, i.to = function(c, l) {
          return o(c, l, this, !0);
        }, i.from = function(c, l) {
          return o(c, l, this);
        };
        var u = function(c) {
          return c.$u ? s.utc() : s();
        };
        i.toNow = function(c) {
          return this.to(u(this), c);
        }, i.fromNow = function(c) {
          return this.from(u(this), c);
        };
      };
    }));
  })(Ia)), Ia.exports;
}
var SU = CU();
const wU = /* @__PURE__ */ Dr(SU);
var va = { exports: {} }, IU = va.exports, zp;
function vU() {
  return zp || (zp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(IU, (function() {
      var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, s = /([+-]|\d\d)/g;
      return function(i, a, o) {
        var u = a.prototype;
        o.utc = function(g) {
          var _ = { date: g, utc: !0, args: arguments };
          return new a(_);
        }, u.utc = function(g) {
          var _ = o(this.toDate(), { locale: this.$L, utc: !0 });
          return g ? _.add(this.utcOffset(), n) : _;
        }, u.local = function() {
          return o(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = u.parse;
        u.parse = function(g) {
          g.utc && (this.$u = !0), this.$utils().u(g.$offset) || (this.$offset = g.$offset), c.call(this, g);
        };
        var l = u.init;
        u.init = function() {
          if (this.$u) {
            var g = this.$d;
            this.$y = g.getUTCFullYear(), this.$M = g.getUTCMonth(), this.$D = g.getUTCDate(), this.$W = g.getUTCDay(), this.$H = g.getUTCHours(), this.$m = g.getUTCMinutes(), this.$s = g.getUTCSeconds(), this.$ms = g.getUTCMilliseconds();
          } else l.call(this);
        };
        var h = u.utcOffset;
        u.utcOffset = function(g, _) {
          var b = this.$utils().u;
          if (b(g)) return this.$u ? 0 : b(this.$offset) ? h.call(this) : this.$offset;
          if (typeof g == "string" && (g = (function(D) {
            D === void 0 && (D = "");
            var w = D.match(r);
            if (!w) return null;
            var O = ("" + w[0]).match(s) || ["-", 0, 0], U = O[0], q = 60 * +O[1] + +O[2];
            return q === 0 ? 0 : U === "+" ? q : -q;
          })(g), g === null)) return this;
          var T = Math.abs(g) <= 16 ? 60 * g : g;
          if (T === 0) return this.utc(_);
          var C = this.clone();
          if (_) return C.$offset = T, C.$u = !1, C;
          var R = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          return (C = this.local().add(T + R, n)).$offset = T, C.$x.$localOffset = R, C;
        };
        var m = u.format;
        u.format = function(g) {
          var _ = g || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return m.call(this, _);
        }, u.valueOf = function() {
          var g = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * g;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var p = u.toDate;
        u.toDate = function(g) {
          return g === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : p.call(this);
        };
        var E = u.diff;
        u.diff = function(g, _, b) {
          if (g && this.$u === g.$u) return E.call(this, g, _, b);
          var T = this.local(), C = o(g).local();
          return E.call(T, C, _, b);
        };
      };
    }));
  })(va)), va.exports;
}
var NU = vU();
const kU = /* @__PURE__ */ Dr(NU);
var Na = { exports: {} }, RU = Na.exports, Vp;
function PU() {
  return Vp || (Vp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r();
    })(RU, (function() {
      return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(n) {
        var r = ["th", "st", "nd", "rd"], s = n % 100;
        return "[" + n + (r[(s - 20) % 10] || r[s] || r[0]) + "]";
      } };
    }));
  })(Na)), Na.exports;
}
PU();
var ka = { exports: {} }, OU = ka.exports, Yp;
function DU() {
  return Yp || (Yp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(_d());
    })(OU, (function(n) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var s = r(n), i = { name: "pt-br", weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"), weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"), weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"), months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"), monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"), ordinal: function(a) {
        return a + "º";
      }, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY [às] HH:mm", LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm" }, relativeTime: { future: "em %s", past: "há %s", s: "poucos segundos", m: "um minuto", mm: "%d minutos", h: "uma hora", hh: "%d horas", d: "um dia", dd: "%d dias", M: "um mês", MM: "%d meses", y: "um ano", yy: "%d anos" } };
      return s.default.locale(i, null, !0), i;
    }));
  })(ka)), ka.exports;
}
DU();
var Ra = { exports: {} }, LU = Ra.exports, Gp;
function MU() {
  return Gp || (Gp = 1, (function(e, t) {
    (function(n, r) {
      e.exports = r(_d());
    })(LU, (function(n) {
      function r(a) {
        return a && typeof a == "object" && "default" in a ? a : { default: a };
      }
      var s = r(n), i = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(a) {
        return a + "º";
      } };
      return s.default.locale(i, null, !0), i;
    }));
  })(Ra)), Ra.exports;
}
MU();
wr.extend(wU);
wr.extend(kU);
const yd = class yd {
  static formatDate(t, n = "MMM YYYY") {
    return wr(t).format(n);
  }
};
yd.getFormattedRelativeTime = (t, n) => wr(t).locale(n.toLowerCase()).fromNow();
let Zn = yd;
const HU = ({ post: e, workspaceId: t, currentLanguage: n }) => ({
  data: se(() => {
    if (!e || !t) return;
    const s = Kt(Bn[te.POST], {
      id: e.id,
      provider: e.provider,
      panelId: t
    });
    return {
      creatorUrl: e?.creator?.id && e?.creator?.provider ? Kt(Bn[te.CREATOR], {
        id: e?.creator?.id,
        provider: e?.creator?.provider
      }) : void 0,
      videoUrl: s,
      provider: e?.provider,
      thumbnail: {
        imageUrl: e?.thumbnail ?? ""
      },
      description: e?.title,
      metrics: {
        data: [
          { title: "Views", value: qt(e?.views) },
          { title: "Likes", value: qt(e?.likes) }
        ]
      },
      creator: {
        title: e?.creator?.title,
        description: Zn.getFormattedRelativeTime(e?.publishedAt, n),
        thumbnail: e?.creator?.thumbnail ?? ""
      }
    };
  }, [t, e, n])
}), BU = () => /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col w-full h-[312px] gap-4", children: [
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-[100%] h-[100%]" }),
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-[80%] h-4" }),
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-[50%] h-4" })
] }), UU = de(BU), FU = ({ data: e, refetch: t, showError: n, showLoading: r, theme: s }) => /* @__PURE__ */ d.jsx("div", { className: "w-[324px] min-h-[312px] mt-[20px] mb-[40px] px-4 flex float-left", children: /* @__PURE__ */ d.jsx(
  Ur,
  {
    isLoading: r,
    isError: n,
    loadingComponent: /* @__PURE__ */ d.jsx(UU, {}),
    errorComponent: /* @__PURE__ */ d.jsx(Ns, { name: "video", refetch: t }),
    children: e && /* @__PURE__ */ d.jsx(
      ln.VideoCardDefault,
      {
        ...e,
        theme: s,
        thumbnail: {
          ...e.thumbnail,
          IconProvider: /* @__PURE__ */ d.jsx(ln.Icon, { name: vb[e.provider], width: 30, height: 30 })
        }
      }
    )
  }
) }), jU = de(FU), $U = ({ postId: e }) => {
  const { workspaceId: t } = at(), n = hr(), { language: r } = Oi(), {
    data: s,
    fetch: i,
    isError: a,
    isLoading: o
  } = yU({
    postId: e
  }), u = HU({
    workspaceId: t,
    post: s,
    currentLanguage: r
  });
  return /* @__PURE__ */ d.jsx(jU, { ...u, theme: n, showError: a, showLoading: o, refetch: i });
}, zU = de($U), Ir = {
  categoryInfo: (e) => ({
    key: "share-of-attention-widget.category-info",
    parameters: e,
    defaultValue: "Categoria: {category} - País: {country} - Período: {period}"
  }),
  accessMacroarea: {
    key: "share-of-attention-widget.access-macroarea",
    defaultValue: "Acessar SoA"
  },
  emptyText: {
    key: "share-of-attention-widget.empty-text",
    defaultValue: "Dados insuficientes para exibir o gráfico no momento"
  },
  columnChart: {
    key: "share-of-attention-widget.column-chart",
    defaultValue: "Gráfico de Colunas"
  },
  lineChart: {
    key: "share-of-attention-widget.line-chart",
    defaultValue: "Gráfico de Linhas"
  },
  quarter: (e) => ({
    key: "share-of-attention-widget.quarter",
    parameters: e,
    defaultValue: "{quarter}º Trimestre"
  }),
  halfYear: (e) => ({
    key: "share-of-attention-widget.half-year",
    parameters: e,
    defaultValue: "{semester}º Semestre"
  })
}, VU = () => Intl.DateTimeFormat().resolvedOptions().timeZone, vT = (e, t) => {
  const n = Math.ceil((e.getUTCMonth() + 1) / 3);
  return t ? t(Ir.quarter({ quarter: n })) : `${n}º Trimestre`;
}, NT = (e, t) => {
  const n = e.getUTCMonth() + 1 <= 6 ? 1 : 2;
  return t ? t(Ir.halfYear({ semester: n })) : `${n}º Semestre`;
}, YU = (e, t, n = {}) => {
  const { timezone: r = VU(), locale: s = "en-US", translate: i } = n, a = new Date(e), o = {
    timeZone: r
  };
  switch (t) {
    case "monthly":
      return new Intl.DateTimeFormat(s, {
        ...o,
        month: "short"
      }).format(a);
    case "daily":
      return new Intl.DateTimeFormat("en-GB", {
        ...o,
        day: "2-digit",
        month: "2-digit"
      }).format(a);
    case "full":
      return new Intl.DateTimeFormat(s, {
        ...o,
        year: "numeric",
        month: "short",
        day: "numeric"
      }).format(a);
    case "quarterly":
      return vT(a, i);
    case "halfYearly":
      return NT(a, i);
    default:
      return e;
  }
}, GU = (e, t, n = "en-US", r) => YU(e, t, { timezone: "UTC", locale: n, translate: r }), Wp = (e, t, n) => {
  const r = new Date(e);
  switch (t) {
    case "monthly":
      return new Intl.DateTimeFormat("en-US", {
        timeZone: "UTC",
        month: "short",
        year: "numeric"
      }).format(r);
    case "daily":
    case "weekly":
      return new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      }).format(r);
    case "quarterly":
      return vT(r, n);
    case "halfYearly":
      return NT(r, n);
    default:
      return e;
  }
}, WU = ({
  period: e = "monthly",
  year: t = (/* @__PURE__ */ new Date()).getFullYear()
} = {}) => {
  const n = Ed.isEnabled("isSOAV3WithZaiEnabled"), { t: r } = He(), { workspaceId: s } = at(), i = Br(), a = Kt(Bn[te.SHARE_OF_ATTENTION_V2], {
    panelId: s
  }), [o, u] = ce(null), [c, l] = ce(!1), [h, m] = ce(!1), [p, E] = ce("column"), g = ne(async () => {
    if (s) {
      l(!0), m(!1);
      try {
        const w = await i.getShareOfAttentionData(
          {
            period: e,
            year: t.toString()
          },
          { isSOAV3WithZaiEnabled: n }
        );
        u(w);
      } catch {
        m(!0), u(null);
      } finally {
        l(!1);
      }
    }
  }, [s, e, t, i, n]);
  _e(() => {
    g();
  }, [g]);
  const _ = se(() => !o?.brands || o.brands.length === 0 ? [] : [...new Set(o.brands.flatMap((w) => w.scores.map((O) => O.date)))].sort(
    (w, O) => w.localeCompare(O)
  ), [o?.brands]), b = se(() => o?.brands ? o.brands.map((w) => {
    const O = new Map(w.scores.map((U) => [U.date, U.value]));
    return {
      name: w.name,
      color: w.color,
      series: _.map((U) => O.get(U) ?? 0)
    };
  }) : [], [o, _]), T = se(() => _.map((w) => GU(w, e, "en-US", r)), [_, e, r]), C = se(() => {
    if (!o?.category || _.length === 0) return "";
    const w = _[0], O = _[_.length - 1], U = `${Wp(w, e, r)} - ${Wp(O, e, r)}`;
    return r(
      Ir.categoryInfo({
        category: o.category.name,
        country: o.category.country,
        period: U
      })
    );
  }, [_, o?.category, e, r]), R = se(
    () => b.flatMap((w) => w.series).every((w) => w === 0),
    [b]
  ), D = se(() => [
    { value: "column", label: r(Ir.columnChart) },
    { value: "line", label: r(Ir.lineChart) }
  ], [r]);
  return {
    data: o,
    isLoading: c,
    isError: h,
    isEmpty: R,
    refetch: g,
    chartEntities: b,
    chartLabels: T,
    categoryInfo: C,
    macroareaURL: a,
    chartType: p,
    onChartTypeChange: E,
    chartTypeOptions: D
  };
};
function qU({ ...e }) {
  return /* @__PURE__ */ d.jsx(N2, { "data-slot": "select", ...e });
}
function KU({ ...e }) {
  return /* @__PURE__ */ d.jsx(R2, { "data-slot": "select-value", ...e });
}
function QU({
  className: e,
  size: t = "default",
  children: n,
  ...r
}) {
  return /* @__PURE__ */ d.jsxs(
    k2,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: ue(
        "border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ d.jsx(P2, { asChild: !0, children: /* @__PURE__ */ d.jsx(mb, { className: "size-4 opacity-50" }) })
      ]
    }
  );
}
function XU({
  className: e,
  children: t,
  position: n = "popper",
  align: r = "center",
  ...s
}) {
  const i = Lo();
  return /* @__PURE__ */ d.jsx(O2, { container: i ?? void 0, children: /* @__PURE__ */ d.jsxs(
    D2,
    {
      "data-slot": "select-content",
      className: ue(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: r,
      ...s,
      children: [
        /* @__PURE__ */ d.jsx(ZU, {}),
        /* @__PURE__ */ d.jsx(
          L2,
          {
            className: ue(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ d.jsx(eF, {})
      ]
    }
  ) });
}
function JU({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ d.jsxs(
    M2,
    {
      "data-slot": "select-item",
      className: ue(
        "focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: "absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ d.jsx(B2, { children: /* @__PURE__ */ d.jsx(Do, { className: "size-4" }) }) }),
        /* @__PURE__ */ d.jsx(H2, { children: t })
      ]
    }
  );
}
function ZU({ className: e, ...t }) {
  return /* @__PURE__ */ d.jsx(
    U2,
    {
      "data-slot": "select-scroll-up-button",
      className: ue("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ d.jsx(qR, { className: "size-4" })
    }
  );
}
function eF({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ d.jsx(
    F2,
    {
      "data-slot": "select-scroll-down-button",
      className: ue("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ d.jsx(mb, { className: "size-4" })
    }
  );
}
const tF = () => /* @__PURE__ */ d.jsx("div", { className: "flex justify-between items-end gap-2 px-4 h-112 w-full", children: Array.from({ length: 13 }).map((e, t) => /* @__PURE__ */ d.jsx(
  kt,
  {
    className: "bg-gray-600 rounded-lg flex-1 h-full"
  },
  `share-of-attention-widget-skeleton-item-${t}`
)) }), nF = ({
  categoryInfo: e,
  chartEntities: t,
  chartLabels: n,
  chartType: r,
  chartTypeOptions: s,
  isError: i,
  isEmpty: a,
  isLoading: o,
  macroareaURL: u,
  refetch: c,
  onChartTypeChange: l
}) => {
  const { t: h } = He(), m = hr();
  return /* @__PURE__ */ d.jsxs("div", { className: "w-full flex flex-col gap-5", children: [
    /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: e }),
    /* @__PURE__ */ d.jsxs("div", { className: "flex gap-2.5 justify-end items-center", children: [
      /* @__PURE__ */ d.jsxs(qU, { value: r, onValueChange: l, "aria-label": "Select Chart Type", children: [
        /* @__PURE__ */ d.jsx(QU, { className: "w-[180px] bg-secondary text-secondary-foreground hover:bg-secondary/80 border border-foreground/50", children: /* @__PURE__ */ d.jsx(KU, {}) }),
        /* @__PURE__ */ d.jsx(XU, { children: s.map((p) => /* @__PURE__ */ d.jsx(JU, { value: p.value, children: p.label }, p.value)) })
      ] }),
      !i && /* @__PURE__ */ d.jsx(pt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: u, target: "_blank", rel: "noopener noreferrer", children: h(Ir.accessMacroarea) }) })
    ] }),
    /* @__PURE__ */ d.jsx(
      Ur,
      {
        isLoading: o,
        isError: i,
        isEmpty: a,
        loadingComponent: /* @__PURE__ */ d.jsx(tF, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ns, { name: "chart", refetch: c }),
        emptyComponent: /* @__PURE__ */ d.jsx("p", { className: "text-neutral-500 font-bold text-center", children: h(Ir.emptyText) }),
        children: r === "column" ? /* @__PURE__ */ d.jsx(
          ln.ColumnsChart,
          {
            isStacked: !0,
            theme: m,
            entities: t,
            xAxisLabels: n,
            yAxisOptions: { min: 0, max: 100, labelFormatType: "percent" },
            tooltip: { type: "default", valueFormatType: "percent", props: { followPointer: !0 } },
            legend: { type: "default", toggleHideDisabled: !0 },
            scrollablePlotArea: { minWidth: n.length > 10 ? 1300 : void 0 },
            height: 600
          }
        ) : /* @__PURE__ */ d.jsx(
          ln.LineChart,
          {
            legend: { type: "default" },
            entities: t,
            xAxisLabels: n,
            tooltip: { type: "default", valueFormatType: "percent" },
            yAxisOptions: { labelFormatType: "percent" },
            theme: m,
            height: 600
          }
        )
      }
    )
  ] });
}, Xu = (e) => {
  const t = WU(e);
  return /* @__PURE__ */ d.jsx(nF, { ...t });
};
function Ju(e, t) {
  return {
    id: `${e.name}-${e.color}`,
    name: e.name,
    y: t,
    x: qt(t, 2),
    color: e.color
  };
}
const rF = ({
  provider: e = "all",
  territoryType: t = "grouped",
  timeRangeInDays: n = 30
}) => {
  const { workspaceId: r } = at(), s = Br(), { t: i } = He(), a = se(() => {
    const b = Kt(
      Bn[te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS],
      {
        panelId: r,
        tab: sr[t] || sr.grouped
      }
    ), T = wb({ provider: e, timeRangeInDays: n }).toString();
    return T ? `${b}?${T}` : b;
  }, [e, t, n, r]), [o, u] = ce([]), [c, l] = ce(!1), [h, m] = ce(!1), p = ne(async () => {
    if (r) {
      l(!0), m(!1);
      try {
        const b = Ed.isEnabled("isNewPageBrandOverviewEnabled"), T = await s.getSharesData(
          {
            provider: e?.toString(),
            territoryType: t,
            timeRangeInDays: n?.toString()
          },
          { isNewPageBrandOverviewEnabled: b }
        );
        u(T);
      } catch {
        m(!0), u([]);
      } finally {
        l(!1);
      }
    }
  }, [r, e, t, n, s]);
  _e(() => {
    p();
  }, [p]);
  const E = se(() => o.reduce(
    (b, T) => ({
      engagement: b.engagement + T.totalEngagement,
      views: b.views + T.totalViews,
      content: b.content + T.totalPosts
    }),
    { engagement: 0, views: 0, content: 0 }
  ), [o]), g = se(() => {
    const b = o.reduce(
      (T, C) => (T.engagement.push(Ju(C, C.totalEngagement)), T.views.push(Ju(C, C.totalViews)), T.content.push(Ju(C, C.totalPosts)), T),
      { engagement: [], views: [], content: [] }
    );
    return b.engagement.sort((T, C) => C.y - T.y), b.views.sort((T, C) => C.y - T.y), b.content.sort((T, C) => C.y - T.y), b;
  }, [o]), _ = se(() => {
    const b = Pl[e], T = wT(t, i), C = bd(n, i);
    return [b, T, C].join(" · ");
  }, [e, t, n, i]);
  return {
    data: o,
    isLoading: c,
    isError: h,
    refetch: p,
    chartEntities: g,
    totals: E,
    macroareaURL: a,
    subtitle: _
  };
}, Ar = {
  accessMacroarea: {
    key: "shares-widget.access-macroarea",
    defaultValue: "Acessar visão geral"
  },
  shareOfEngagement: {
    key: "shares-widget.share-of-engagement",
    defaultValue: "Share de engajamento"
  },
  shareOfViews: {
    key: "shares-widget.share-of-views",
    defaultValue: "Share de visualizações"
  },
  shareOfContent: {
    key: "shares-widget.share-of-content",
    defaultValue: "Share de conteúdo"
  },
  total: {
    key: "shares-widget.total",
    defaultValue: "Total"
  }
}, sF = () => /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col w-full py-5 ", children: [
  /* @__PURE__ */ d.jsx("div", { className: "flex flex-col md:flex-row justify-between items-center gap-8", children: Array.from({ length: 3 }).map((e, t) => /* @__PURE__ */ d.jsx("div", { className: "flex flex-col items-center flex-1", children: /* @__PURE__ */ d.jsx("div", { className: "mb-4", children: /* @__PURE__ */ d.jsx(i3, { index: t }) }) }, `shares-widget-skeleton-${t}`)) }),
  /* @__PURE__ */ d.jsx("div", { className: "flex flex-wrap justify-center items-center gap-8 mt-4", children: Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg w-24 h-4" }, t)) })
] }), Zu = ({
  totalTitle: e,
  totalValue: t,
  theme: n
}) => {
  const r = n === "dark" ? "#FFFFFF" : "#000000";
  return `
    <div style="text-align: center; line-height: 18px;">
      <span style="font-size: 12px; color: ${r};">${e}</span><br/>
      <span style="font-size: 16px; font-weight: 700; color: ${r};">${t}</span>
    </div>
  `;
}, iF = ({
  isLoading: e,
  isError: t,
  chartEntities: n,
  totals: r,
  macroareaURL: s,
  refetch: i,
  subtitle: a
}) => {
  const { t: o } = He(), u = hr(), { engagement: c, content: l, views: h } = n;
  return /* @__PURE__ */ d.jsxs("div", { className: "my-5 w-full flex flex-col gap-6", children: [
    a && /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: a }),
    /* @__PURE__ */ d.jsx(
      Ur,
      {
        isLoading: e,
        isError: t,
        loadingComponent: /* @__PURE__ */ d.jsx(sF, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ns, { name: "chart", refetch: i }),
        children: /* @__PURE__ */ d.jsx(
          ln.SyncMultipleDonut,
          {
            theme: u,
            syncOptions: ["highlight", "tooltip"],
            chartsGroup: [
              {
                id: "share-of-engagement-widget",
                titleOptions: {
                  text: o(Ar.shareOfEngagement)
                },
                entities: c,
                centerHtmlContent: Zu({
                  totalTitle: o(Ar.total),
                  totalValue: qt(r.engagement, 1),
                  theme: u
                })
              },
              {
                id: "share-of-views-widget",
                titleOptions: {
                  text: o(Ar.shareOfViews)
                },
                entities: h,
                centerHtmlContent: Zu({
                  totalTitle: o(Ar.total),
                  totalValue: qt(r.views, 1),
                  theme: u
                })
              },
              {
                id: "share-of-content-widget",
                titleOptions: {
                  text: o(Ar.shareOfContent)
                },
                entities: l,
                centerHtmlContent: Zu({
                  totalTitle: o(Ar.total),
                  totalValue: qt(r.content, 1),
                  theme: u
                })
              }
            ],
            yAxisOptions: { labelFormatType: "percent" },
            tooltip: { type: "inline", valueFormatType: "percent", props: { followPointer: !1 } },
            hasLegend: !0,
            dataLabels: { filter: { operator: ">", property: "percentage", value: 6 }, style: { fontSize: "12px" } },
            height: "120%"
          }
        )
      }
    ),
    !t && /* @__PURE__ */ d.jsx(pt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: s, target: "_blank", rel: "noopener noreferrer", children: o(Ar.accessMacroarea) }) })
  ] });
}, aF = (e) => {
  const t = rF(e);
  return /* @__PURE__ */ d.jsx(iF, { ...t });
}, zc = {
  emptyText: {
    key: "zai.widget.territory-relevance.empty-text",
    defaultValue: "Nenhum dado de relevância encontrado para este período"
  },
  accessMacroarea: {
    key: "zai.widget.territory-relevance.access-macroarea",
    defaultValue: "Acessar relevância"
  },
  relevanceIndex: {
    key: "zai.widget.territory-relevance.relevance-index",
    defaultValue: "Relevância"
  }
}, oF = ({
  territoryId: e,
  timeRange: t = "30"
} = {}) => {
  const { t: n } = He(), { workspaceId: r } = at(), s = Br(), [i, a] = ce(null), [o, u] = ce(!1), [c, l] = ce(!1), h = se(() => {
    if (!e || !r) return "";
    const b = Ol(r, e, "performance"), T = Yl(t);
    return T ? `${b}?uploadDate=${T}` : b;
  }, [e, r, t]), m = ne(async () => {
    if (!(!e || !r)) {
      u(!0), l(!1);
      try {
        const b = await s.getTerritoryRelevanceData({
          territoryId: e,
          timeRange: t
        });
        a(b);
      } catch {
        l(!0), a(null);
      } finally {
        u(!1);
      }
    }
  }, [e, t, r, s]);
  _e(() => {
    m();
  }, [m]);
  const p = se(() => i?.sparkline ? [
    {
      name: n(zc.relevanceIndex),
      color: Ue.winnin,
      series: i.sparkline.map((b) => b.value)
    }
  ] : [], [i, n]), E = se(() => i?.sparkline ? i.sparkline.map((b) => Zn.formatDate(b.date, "MMM, DD YYYY")) : [], [i]), g = se(() => p.length === 0 || p.flatMap((b) => b.series).every((b) => b === 0), [p]), _ = se(() => {
    if (!t) return "";
    if (t.includes(":")) {
      const [T, C] = t.split(":");
      return `${Zn.formatDate(T, "DD/MM/YYYY")} - ${Zn.formatDate(C, "DD/MM/YYYY")}`;
    }
    const b = Number(t);
    return isNaN(b) ? "" : bd(b, n);
  }, [t, n]);
  return {
    isLoading: o,
    isError: c,
    isEmpty: g,
    refetch: m,
    chartEntities: p,
    chartLabels: E,
    macroareaURL: h,
    subtitle: _
  };
}, uF = () => /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-4 h-96 w-full", children: [
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg h-8 w-3/4" }),
  /* @__PURE__ */ d.jsx(kt, { className: "bg-gray-600 rounded-lg flex-1 w-full" })
] }), cF = ({
  chartEntities: e,
  chartLabels: t,
  isError: n,
  isEmpty: r,
  isLoading: s,
  macroareaURL: i,
  refetch: a,
  subtitle: o
}) => {
  const { t: u } = He(), c = hr();
  return /* @__PURE__ */ d.jsxs("div", { className: "w-full flex flex-col gap-6", children: [
    o && /* @__PURE__ */ d.jsx("div", { className: "text-sm text-neutral-800 dark:text-white", children: o }),
    /* @__PURE__ */ d.jsx(
      Ur,
      {
        isLoading: s,
        isError: n,
        isEmpty: r,
        loadingComponent: /* @__PURE__ */ d.jsx(uF, {}),
        errorComponent: /* @__PURE__ */ d.jsx(Ns, { name: "chart", refetch: a }),
        emptyComponent: /* @__PURE__ */ d.jsx("p", { className: "text-neutral-500 font-bold text-center", children: u(zc.emptyText) }),
        children: /* @__PURE__ */ d.jsx(
          ln.LineChart,
          {
            legend: { type: "default", toggleHideDisabled: !0 },
            entities: e,
            xAxisLabels: t,
            tooltip: {
              type: "default",
              valueFormatType: "default",
              formatter: (l) => qt(l, 2)
            },
            yAxisOptions: { labelFormatType: "default" },
            customOptions: {
              yAxis: {
                labels: {
                  formatter: function({ value: l }) {
                    return qt(Number(l), 0);
                  }
                }
              }
            },
            theme: c,
            height: 400
          }
        )
      }
    ),
    !n && i && /* @__PURE__ */ d.jsx(pt, { variant: "highlight-border", asChild: !0, children: /* @__PURE__ */ d.jsx("a", { href: i, target: "_blank", rel: "noopener noreferrer", children: u(zc.accessMacroarea) }) })
  ] });
}, lF = (e) => {
  const t = oF(e);
  return /* @__PURE__ */ d.jsx(cF, { ...t });
}, dF = ({ type: e, uri: t }) => {
  if (e === "share-of-attention") {
    const n = it(t, {
      path: ut.SHARE_OF_ATTENTION,
      exact: !0
    });
    if (n?.params) {
      const a = n.params;
      return /* @__PURE__ */ d.jsx(Xu, { ...a });
    }
    const r = it(t, {
      path: ut.SHARE_OF_ATTENTION_V3,
      exact: !0
    });
    if (r?.params) {
      const a = r.params;
      return /* @__PURE__ */ d.jsx(Xu, { ...a });
    }
    const i = it(t, {
      path: ut.SHARE_OF_ATTENTION_V2,
      exact: !0
    })?.params;
    return /* @__PURE__ */ d.jsx(Xu, { ...i });
  }
  if (e === "shares") {
    let n = it(t, {
      path: ut.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS_V2,
      exact: !0
    });
    n || (n = it(t, {
      path: ut.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS,
      exact: !0
    }));
    const r = n?.params, s = r?.territoryType ? r : { ...r, territoryType: "grouped" };
    return /* @__PURE__ */ d.jsx(aF, { ...s });
  }
  if (e === "territory-performance") {
    const r = it(t, {
      path: ut.GET_TERRITORY_PERFORMANCE_RESOURCE,
      exact: !0
    })?.params, s = r?.territoryId?.split(".")?.[0]?.trim(), i = r?.territoryId?.split(".")?.[1]?.trim();
    return !!!(s && s in xs) || !i ? null : /* @__PURE__ */ d.jsx(lF, { ...r });
  }
  if (e === "brand-engagement-over-time") {
    const r = it(t, {
      path: ut.GET_BRAND_ENGAGEMENT_OVER_TIME_RESOURCE,
      exact: !0
    })?.params;
    return /* @__PURE__ */ d.jsx(dU, { ...r });
  }
  if (e === "post") {
    const r = it(t, {
      path: ut.POST,
      exact: !0
    })?.params, s = `${r?.provider}:${r?.id}`;
    return !r?.provider || !r?.id ? null : /* @__PURE__ */ d.jsx(zU, { postId: s });
  }
  if (e === "creator") {
    const r = it(t, {
      path: ut.CREATOR,
      exact: !0
    })?.params, s = `${r?.provider}:${r?.id}`;
    return !r?.provider || !r?.id ? null : /* @__PURE__ */ d.jsx(AU, { creatorId: s, performanceInMonths: 1 });
  }
  return /* @__PURE__ */ d.jsx("div", { className: "my-5 text-red-500", children: /* @__PURE__ */ d.jsx("p", { children: "Widget type not recognized" }) });
}, hF = () => {
  const { language: e } = Oi(), t = hr();
  return /* @__PURE__ */ d.jsx(
    p6,
    {
      remarkPlugins: [yT],
      rehypePlugins: [J_],
      className: ue("aui-md pseudo-element-after-first-running", `theme-${t}`, { [e]: !!e }),
      components: RT
    }
  );
};
de(hF);
const fF = ({ text: e, status: t }) => {
  const { language: n } = Oi(), r = hr();
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-status": t?.type,
      className: ue("aui-md pseudo-element-after-first-running", `theme-${r}`, { [n]: !!n }),
      children: /* @__PURE__ */ d.jsx(h_, { remarkPlugins: [yT], rehypePlugins: [J_], components: RT, children: e })
    }
  );
}, kT = de(fF), pF = ({ language: e, code: t }) => {
  const { isCopied: n, copyToClipboard: r } = mF(), s = () => {
    !t || n || r(t);
  };
  return /* @__PURE__ */ d.jsxs("div", { className: "flex items-center justify-between gap-4 rounded-t-lg bg-zinc-100 dark:bg-zinc-900 px-4 py-2 text-sm font-semibold text-foreground", children: [
    /* @__PURE__ */ d.jsx("span", { className: "lowercase [&>span]:text-xs", children: e }),
    /* @__PURE__ */ d.jsxs(Qt, { tooltip: "Copy", onClick: s, children: [
      !n && /* @__PURE__ */ d.jsx(Fl, {}),
      n && /* @__PURE__ */ d.jsx(Do, {})
    ] })
  ] });
}, mF = ({
  copiedDuration: e = 3e3
} = {}) => {
  const [t, n] = ce(!1);
  return { isCopied: t, copyToClipboard: (s) => {
    s && navigator.clipboard.writeText(s).then(() => {
      n(!0), setTimeout(() => n(!1), e);
    });
  } };
}, RT = JM({
  h1: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h1",
    {
      className: ue("mb-8 scroll-m-20 text-4xl font-extrabold tracking-tight last:mb-0 clear-left", e),
      ...t
    }
  ),
  h2: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h2",
    {
      className: ue(
        "mb-4 mt-8 scroll-m-20 text-3xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    }
  ),
  h3: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h3",
    {
      className: ue(
        "mb-4 mt-6 scroll-m-20 text-2xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    }
  ),
  h4: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "h4",
    {
      className: ue(
        "mb-4 mt-6 scroll-m-20 text-xl font-semibold tracking-tight first:mt-0 last:mb-0 clear-left",
        e
      ),
      ...t
    }
  ),
  h5: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("h5", { className: ue("my-4 text-lg font-semibold first:mt-0 last:mb-0 clear-left", e), ...t }),
  h6: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("h6", { className: ue("my-4 font-semibold first:mt-0 last:mb-0 clear-left", e), ...t }),
  p: ({ className: e, ...t }) => (
    // Prevent elements be a descendant of <p>
    /* @__PURE__ */ d.jsx("div", { className: ue("mb-5 mt-5 leading-7 first:mt-0 last:mb-0 clear-left", e), ...t })
  ),
  a: ({ className: e, ...t }) => /* @__PURE__ */ d.jsxs(
    "a",
    {
      target: "_blank",
      rel: "noopener noreferrer",
      className: ue(
        `
            text-primary
            font-medium
            text-sm
            py-0.5
            px-1.5
            border
            border-neutral-200
            dark:border-neutral-500
            bg-white
            dark:bg-neutral-800
            rounded-full
            whitespace-nowrap
            inline-flex
            items-center
            gap-0.5
            max-w-36
            hover:border-neutral-300
            dark:hover:border-neutral-400
            hover:bg-neutral-50
            dark:hover:bg-neutral-700
            hover:[&>span]:inline-flex
            clear-left
            `,
        e
      ),
      ...t,
      children: [
        /* @__PURE__ */ d.jsx("span", { className: "truncate", children: t.children }),
        /* @__PURE__ */ d.jsx("span", { className: "hidden", children: /* @__PURE__ */ d.jsx(Eb, { size: 16 }) })
      ]
    }
  ),
  blockquote: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("blockquote", { className: ue("border-l-2 pl-6 italic clear-left", e), ...t }),
  ul: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("ul", { className: ue("my-5 ml-6 list-disc [&>li]:mt-2 clear-left", e), ...t }),
  ol: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("ol", { className: ue("my-5 ml-6 list-decimal [&>li]:mt-2 clear-left", e), ...t }),
  li: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("li", { className: ue("clear-left", e), ...t }),
  hr: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("hr", { className: ue("my-5 border-b clear-left", e), ...t }),
  table: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("div", { className: "overflow-x-auto clear-left", children: /* @__PURE__ */ d.jsx("table", { className: ue("my-5 w-full border-separate border-spacing-0 overflow-y-auto", e), ...t }) }),
  th: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "th",
    {
      className: ue(
        "bg-muted px-4 py-2 text-left font-bold first:rounded-tl-lg last:rounded-tr-lg [&[align=center]]:text-center [&[align=right]]:text-right",
        e
      ),
      ...t
    }
  ),
  td: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "td",
    {
      className: ue(
        "border-b border-l px-4 py-2 text-left last:border-r [&[align=center]]:text-center [&[align=right]]:text-right",
        e
      ),
      ...t
    }
  ),
  tr: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx(
    "tr",
    {
      className: ue(
        "m-0 border-b p-0 first:border-t [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg",
        e
      ),
      ...t
    }
  ),
  sup: ({ className: e, ...t }) => /* @__PURE__ */ d.jsx("sup", { className: ue("[&>a]:text-xs [&>a]:no-underline clear-left", e), ...t }),
  pre: ({ className: e, children: t, ...n }) => {
    const r = HB(t);
    return r ? /* @__PURE__ */ d.jsx(nU, { code: r }) : /* @__PURE__ */ d.jsx(
      "pre",
      {
        className: ue(
          "overflow-x-auto rounded-b-lg bg-zinc-100 dark:bg-black p-4 text-foreground dark:text-white clear-left",
          e
        ),
        ...n,
        children: t
      }
    );
  },
  code: function({ className: t, ...n }) {
    const r = f_();
    return /* @__PURE__ */ d.jsx("code", { className: ue(!r && "bg-muted rounded border font-semibold clear-left", t), ...n });
  },
  embed: (e) => {
    const t = e["data-type"], n = e["data-uri"];
    return /* @__PURE__ */ d.jsx(dF, { type: t, uri: n });
  },
  CodeHeader: pF
}), ro = class ro {
};
ro.formatSoaDataUniverse = ({
  country: t,
  category: n,
  startDate: r,
  endDate: s
}) => {
  const i = [];
  return t && i.push(`Country: ${t}`), n && i.push(`Category: ${n}`), r && s && i.push(`Period: ${r} - ${s}`), i.length ? `Share of Attention - ${i.join(", ")}` : "";
}, ro.formatBrandSchema = ({
  brandName: t,
  provider: n,
  timeRangeInDays: r
}) => {
  const s = [];
  t && s.push(`${t}`);
  const i = Pl[n];
  return i && s.push(`${i}`), r && s.push(`Last ${r} days`), s.length ? `Brand (Engagement, Content, Views) - ${s.join(", ")}` : "";
};
let to = ro;
const gF = () => {
  const e = J((w) => w?.message?.content), t = J((w) => w?.message?.status?.type), n = se(() => e?.filter((w) => w.type === "tool-call") || [], [e]), r = n?.some((w) => na.SHARE_OF_ATTENTION.some((O) => it(w?.argsText, { path: O, exact: !0 }) !== null)), s = n?.some((w) => na.BRAND.some((O) => it(w?.argsText, { path: O, exact: !0 }) !== null)), i = n?.find((w) => na.SHARE_OF_ATTENTION.some((O) => it(w?.argsText, { path: O, exact: !0 }) !== null)), a = n?.find((w) => na.BRAND.some((O) => it(w?.argsText, { path: O, exact: !0 }) !== null)), o = i?.result?.[0]?.data, u = i?.argsText ? it(i?.argsText, {
    path: te.SHARE_OF_ATTENTION
  }) : null, c = o?.category, l = u?.params?.period, h = {
    daily: "dailySOA",
    weekly: "weeklySOA",
    monthly: "monthlySOA"
  }, m = h[l] || h.monthly, p = o?.myBrand?.[m] || [], E = p?.[0], g = p?.[p.length - 1], _ = a?.result?.[0]?.data?.getWorkspace?.workspaceBrand?.name, b = a?.argsText ? it(a?.argsText, {
    path: te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS
  }) : null, T = E?.date ? Zn.formatDate(E.date) : "", C = g?.date ? Zn.formatDate(g.date) : "", R = r ? to.formatSoaDataUniverse({
    country: c?.country,
    category: c?.name,
    startDate: T,
    endDate: C
  }) : "", D = s ? to.formatBrandSchema({
    brandName: _,
    provider: b?.params?.provider,
    timeRangeInDays: b?.params?.timeRangeInDays
  }) : "";
  return se(
    () => ({
      hasSoaToolCall: r,
      hasBrandToolCall: s,
      soaDataUniverse: R,
      brandDataUniverse: D,
      statusType: t
    }),
    [D, s, r, R, t]
  );
}, EF = ({
  hasSoaToolCall: e,
  hasBrandToolCall: t,
  soaDataUniverse: n,
  brandDataUniverse: r,
  statusType: s
}) => {
  const i = e && n, a = t && r;
  return !i && !a || s !== "complete" ? null : /* @__PURE__ */ d.jsxs("div", { className: "my-4 text-base text-muted-foreground", children: [
    /* @__PURE__ */ d.jsx("p", { children: "Data Universe:" }),
    i && /* @__PURE__ */ d.jsx("p", { children: n }),
    a && /* @__PURE__ */ d.jsx("p", { children: r })
  ] });
}, bF = () => {
  const e = gF();
  return /* @__PURE__ */ d.jsx(EF, { ...e });
}, PT = de(bF), ga = {
  dialogTitle: {
    key: "feedback-custom-dialog.title",
    defaultValue: "O que deu errado na sua experiência?"
  },
  dialogTextareaFeedback: {
    key: "feedback-custom-dialog.textarea-feedback",
    defaultValue: "(Opcional) Insira seu feedback aqui..."
  },
  dialogSendButton: {
    key: "feedback-custom-dialog.send-button",
    defaultValue: "Enviar"
  },
  dialogCancelButton: {
    key: "feedback-custom-dialog.cancel-button",
    defaultValue: "Cancelar"
  }
}, _F = de(({ onClose: e, onSend: t, t: n }) => /* @__PURE__ */ d.jsxs("div", { className: "feedback-custom-dialog fixed top-0 left-0 w-full h-full z-50 p-4 flex items-center justify-center", children: [
  /* @__PURE__ */ d.jsx(
    "div",
    {
      onClick: e,
      className: "feedback-custom-dialog-overlay absolute top-0 left-0 w-full h-full bg-black opacity-50"
    }
  ),
  /* @__PURE__ */ d.jsxs("div", { className: "feedback-custom-dialog-content relative bg-[#2E2E2E] max-w-[650px] w-full  border border-[#F1F4FA1A] p-8 flex flex-col gap-8 rounded-lg", children: [
    /* @__PURE__ */ d.jsx("h2", { className: "font-semibold text-3xl", children: n(ga.dialogTitle) }),
    /* @__PURE__ */ d.jsxs("form", { onSubmit: t, className: "feedback-custom-dialog-form flex flex-col gap-8", children: [
      /* @__PURE__ */ d.jsx("div", { className: "feedback-custom-dialog-form-row", children: /* @__PURE__ */ d.jsx(
        "textarea",
        {
          name: "textarea-feedback",
          id: "textarea-feedback",
          placeholder: n(ga.dialogTextareaFeedback),
          className: "w-full h-[109px] resize-none p-2 border bg-[#363636] border-[#E1E5ED1A] rounded-sm text-sm text-white placeholder-white"
        }
      ) }),
      /* @__PURE__ */ d.jsxs("div", { className: "feedback-custom-dialog-form-actions flex align-center justify-end gap-4", children: [
        /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "button",
            onClick: e,
            className: "feedback-custom-dialog-form-action-cancel py-2 px-4 rounded-sm text-sm text-white cursor-pointer",
            children: n(ga.dialogCancelButton)
          }
        ),
        /* @__PURE__ */ d.jsx(
          "button",
          {
            type: "submit",
            className: "feedback-custom-dialog-form-action-send py-2 px-4 rounded-sm bg-white text-sm text-black cursor-pointer",
            children: n(ga.dialogSendButton)
          }
        )
      ] })
    ] })
  ] })
] })), TF = ({ type: e, workspaceId: t, threadId: n, hasDialog: r }) => {
  const [s, i] = ce(!1), a = Ke(null), o = e === "positive" ? "Like" : "Dislike", u = ne(
    ({ message: E } = {}) => {
      const g = {
        workspaceId: t,
        thread: n,
        feedback: e
      };
      E && (g.message = E), Wt.track(rn.feedback, g);
    },
    [n, e, t]
  ), c = ({ active: E, element: g }) => {
    if (g.disabled = E, !E) {
      g.classList.add("text-[#4C5567]", "hover:text-[#4C5567]"), g.classList.remove("text-[#D0B2FF]", "hover:text-[#D0B2FF]", "hover:text-accent-foreground");
      return;
    }
    g.classList.add("text-[#D0B2FF]", "hover:text-[#D0B2FF]"), g.classList.remove("hover:text-accent-foreground", "disabled:opacity-50");
  }, l = () => {
    const E = a.current, g = document.querySelector(
      `[data-feedback-button-type="${e === "positive" ? "negative" : "positive"}"]`
    );
    return {
      currentButton: E,
      oppositeButton: g
    };
  };
  return {
    buttonRef: a,
    handleClick: () => {
      const { currentButton: E, oppositeButton: g } = l();
      if (r) {
        i(!0);
        return;
      }
      g && c({ active: !1, element: g }), c({ active: !0, element: E }), u();
    },
    tooltipMessage: o,
    showDialog: s,
    onDialogClose: () => i(!1),
    onDialogSend: (E) => {
      E.preventDefault();
      const { currentButton: g, oppositeButton: _ } = l(), T = new FormData(E.currentTarget).get("textarea-feedback").trim();
      _ && c({ active: !1, element: _ }), c({ active: !0, element: g }), u({ message: T }), i(!1);
    }
  };
}, OT = Je(
  ({
    IconComponent: e,
    TooltipIconButtonComponent: t,
    DialogComponent: n,
    tooltipMessage: r,
    type: s,
    showDialog: i,
    handleClick: a,
    onDialogClose: o,
    onDialogSend: u,
    t: c
  }, l) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(
      t,
      {
        ref: l,
        tooltip: r,
        onClick: a,
        "data-feedback-button-type": s,
        children: /* @__PURE__ */ d.jsx(e, {})
      }
    ),
    i && /* @__PURE__ */ d.jsx(n, { t: c, onClose: o, onSend: u })
  ] })
);
OT.displayName = "FeedbackCustomView";
const AF = de(OT), qp = de(({ type: e, hasDialog: t = !1 }) => {
  const { workspaceId: n } = at(), r = J((u) => u?.threadListItem?.remoteId), { t: s } = He(), { buttonRef: i, ...a } = TF({
    type: e,
    hasDialog: t,
    threadId: r,
    workspaceId: n
  }), o = e === "positive" ? bP : gP;
  return /* @__PURE__ */ d.jsx(
    AF,
    {
      ...a,
      ref: i,
      TooltipIconButtonComponent: Qt,
      IconComponent: o,
      DialogComponent: _F,
      type: e,
      t: s
    }
  );
}), yF = {
  analyze: s3,
  plan: o3,
  execute_step: a3,
  validate_step: c3,
  synthesize: bf,
  // `clarify` is never rendered (filtered out at accumulation time); mapped to
  // synthesize as a defensive fallback so the type stays exhaustive.
  clarify: bf
}, xF = {
  thinking: {
    key: "zai.progress-steps.thinking",
    defaultValue: "Pensando..."
  }
}, CF = () => {
  const { t: e } = He(), t = J((o) => o?.message?.content), n = J((o) => o?.message?.status), s = J((o) => o?.message?.metadata?.custom)?.zaiProgress, i = se(() => {
    const o = t?.findLast((c) => c.type === "text"), u = !!o && (o.text?.trim().length ?? 0) > 0;
    return n?.type === "running" && !u;
  }, [t, n?.type]), a = se(() => s?.entries?.length ? s.entries.map((o) => ({
    id: o.key,
    node: o.node,
    text: o.text,
    icon: yF[o.node],
    state: o.key === s.activeKey ? "active" : "done"
  })) : [], [s?.activeKey, s?.entries]);
  return {
    isVisible: i,
    header: e(xF.thinking),
    steps: a
  };
}, SF = () => {
  const { workspaceId: e } = at(), t = J((r) => r?.message?.content);
  return se(() => {
    const r = t?.filter((a) => a.type === "tool-call");
    return !r || r.length === 0 ? [] : r.map((a) => {
      const o = a?.argsText;
      if (!o) return null;
      for (const u of Object.values(te)) {
        const c = it(o, { path: u, exact: !0 });
        if (c) {
          const l = Bn[u];
          if (!l)
            return null;
          const h = { ...c.params };
          if (h.territoryId) {
            const [g, _] = h.territoryId.split("."), b = xs[g];
            h.territoryType = b, h.entityId = _, delete h.territoryId;
          }
          const m = ME(l), p = {};
          m.includes("panelId") && e && (p.panelId = e);
          for (const g of m)
            if (g === "tab" && h.territoryType && h.territoryType in sr ? p.tab = sr[h.territoryType] : g !== "panelId" && h[g] && (p[g] = h[g]), !p[g])
              return null;
          const E = Kt(l, p);
          return {
            uri: o,
            href: E,
            path: u,
            params: c.params
          };
        }
      }
      return null;
    }).filter((a) => a !== null).reduce(
      (a, o) => {
        const u = o?.uri;
        return a.ids?.includes(u) ? a : {
          ids: [...a.ids, u],
          sources: [...a.sources, o]
        };
      },
      {
        ids: [],
        sources: []
      }
    ).sources;
  }, [t, e]);
}, wF = () => {
  const { language: e } = Oi(), t = Ll(), [n, r] = ce(!1), [s, i] = ce(!1), [a, o] = ce([]), u = ne(async () => {
    try {
      r(!0), i(!1);
      const c = await t.getPrePrompts(e || "en");
      o(c);
    } catch {
      i(!0);
    } finally {
      r(!1);
    }
  }, [e, t]);
  return _e(() => {
    u();
  }, [u]), {
    isLoading: n,
    isError: s,
    data: a
  };
}, IF = (e, t, n = 18) => {
  const [r, s] = ce(t ? "" : e);
  return _e(() => {
    if (!t) {
      s(e);
      return;
    }
    s("");
    let i = 0;
    const a = setInterval(() => {
      i += 1, s(e.slice(0, i)), i >= e.length && clearInterval(a);
    }, n);
    return () => clearInterval(a);
  }, [e, t, n]), r;
}, vF = ({ step: e }) => {
  const t = e.icon, n = e.state === "active", r = IF(e.text, n);
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: ue("flex items-start gap-2 text-sm", n ? "text-foreground font-bold" : "text-muted-foreground"),
      children: [
        /* @__PURE__ */ d.jsx(t, { className: ue("size-5 shrink-0", n && "text-purple-600 dark:text-purple-300") }),
        /* @__PURE__ */ d.jsx("span", { className: "leading-6", children: r })
      ]
    }
  );
}, NF = ({ isVisible: e, header: t, steps: n }) => e ? /* @__PURE__ */ d.jsxs("div", { className: "flex flex-col gap-4 my-3", role: "status", "aria-live": "polite", "aria-atomic": "true", children: [
  /* @__PURE__ */ d.jsx("p", { className: "animate-pulse font-bold text-sm text-foreground", children: t }),
  n.length > 0 && /* @__PURE__ */ d.jsx("div", { className: "flex flex-col gap-4", children: n.map((r) => /* @__PURE__ */ d.jsx(vF, { step: r }, r.id)) })
] }) : null, DT = de(() => {
  const e = CF();
  return /* @__PURE__ */ d.jsx(NF, { ...e });
}), kF = () => {
  const e = SF();
  return {
    sources: se(() => {
      const n = e.reduce(
        (r, s) => (s && (r[s.href] || (r[s.href] = s)), r),
        {}
      );
      return Object.values(n);
    }, [e])
  };
};
function RF(e, t = 50) {
  if (e?.length <= t) return e;
  const n = Math.floor(t / 2);
  return `${e?.slice(0, n)}...${e?.slice(-n)}`;
}
const PF = ({ sources: e }) => !e || e.length <= 0 ? null : /* @__PURE__ */ d.jsxs($l, { children: [
  /* @__PURE__ */ d.jsx(zl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(
    pt,
    {
      variant: "outline",
      className: `
            text-primary
            font-medium
            text-sm
            py-0.5
            pr-2
            pl-1.5
            border
            border-neutral-300
            bg-neutral-100
            rounded-full
            whitespace-nowrap
            inline-flex
            items-center
            max-w-36
            hover:border-neutral-400
            hover:bg-neutral-200
            hover:[&>span]:inline-flex
            h-auto
          `,
      children: [
        /* @__PURE__ */ d.jsx(iP, { size: 16 }),
        "Sources"
      ]
    }
  ) }),
  /* @__PURE__ */ d.jsxs(
    Vl,
    {
      side: "top",
      align: "start",
      className: "border rounded-xl border-neutral-200 dark:border-neutral-500 bg-white dark:bg-neutral-800 w-fit max-w-xl",
      children: [
        /* @__PURE__ */ d.jsx("h4", { className: "text-sm text-muted-foreground mb-2", children: "Sources" }),
        /* @__PURE__ */ d.jsx("div", { className: "max-h-60 overflow-y-auto", children: e.map((t, n) => /* @__PURE__ */ d.jsxs(
          "a",
          {
            href: t.href,
            className: "flex items-center gap-1 hover:underline visited:text-purple-300",
            target: "_blank",
            rel: "noopener noreferrer",
            title: t.href,
            children: [
              /* @__PURE__ */ d.jsx(oP, { className: "shrink-0", size: 16 }),
              /* @__PURE__ */ d.jsx("span", { className: "truncate", children: RF(t.href) })
            ]
          },
          `source-item-${t.href}-${n}`
        )) })
      ]
    }
  )
] }), LT = () => {
  const e = kF();
  return /* @__PURE__ */ d.jsx(PF, { ...e });
}, MT = (e) => Object.values(te).find((n) => it(e, { path: n, exact: !0 }) !== null) || null, OF = {
  default: {
    key: "zai.tool.default.reasoning",
    defaultValue: "Processando informações"
  }
}, Kp = {
  my_brand: {
    key: "zai.tool.my-brand.reasoning",
    defaultValue: "Buscando informações da sua marca"
  },
  my_competitors: {
    key: "zai.tool.my-competitors.reasoning",
    defaultValue: "Buscando marcas concorrentes"
  },
  share_of_engagement: {
    key: "zai.tool.share-of-engagement-content-and-views.reasoning",
    defaultValue: "Analisando o engajamento da sua marca"
  },
  key_findings: {
    key: "zai.tool.key-findings.reasoning",
    defaultValue: "Coletando insights principais da sua marca"
  },
  share_of_attention: {
    key: "zai.tool.share-of-attention.reasoning",
    defaultValue: "Acessando o Share of Attention"
  },
  trending_territories: {
    key: "zai.tool.trending-territories.reasoning",
    defaultValue: "Identificando territórios em alta"
  },
  territory_resource: {
    key: "zai.tool.territory-resource.reasoning",
    defaultValue: "Carregando informações do território"
  },
  territory_tags: {
    key: "zai.tool.territory-tags.reasoning",
    defaultValue: "Buscando principais tags do território"
  },
  territory_niches: {
    key: "zai.tool.territory-niches.reasoning",
    defaultValue: "Identificando nichos do território"
  },
  territory_formats: {
    key: "zai.tool.territory-formats.reasoning",
    defaultValue: "Analisando formatos mais utilizados"
  },
  territory_creators: {
    key: "zai.tool.territory-creators.reasoning",
    defaultValue: "Buscando criadores relevantes no território"
  },
  territory_videos: {
    key: "zai.tool.territory-videos.reasoning",
    defaultValue: "Carregando vídeos do território"
  },
  territory_performance: {
    key: "zai.tool.territory-performance.reasoning",
    defaultValue: "Extraindo métricas do território"
  },
  territory_affinities: {
    key: "zai.tool.territory-affinities.reasoning",
    defaultValue: "Calculando afinidade com o território"
  },
  territory_audience: {
    key: "zai.tool.territory-audience.reasoning",
    defaultValue: "Analisando o público do território"
  },
  deep_analysis: {
    key: "zai.tool.deep-analysis.reasoning",
    defaultValue: "Realizando análise aprofundada do território"
  }
}, Qp = {
  my_brand: {
    key: "zai.tool.my-brand.resolved",
    defaultValue: "Informações da sua marca foram avaliadas"
  },
  my_competitors: {
    key: "zai.tool.my-competitors.resolved",
    defaultValue: "Marcas concorrentes interpretadas"
  },
  share_of_engagement: {
    key: "zai.tool.share-of-engagement-content-and-views.resolved",
    defaultValue: "Análise de engajamento concluída com sucesso"
  },
  key_findings: {
    key: "zai.tool.key-findings.resolved",
    defaultValue: "Insights principais coletados"
  },
  share_of_attention: {
    key: "zai.tool.share-of-attention.resolved",
    defaultValue: "Acessei o Share of Attention"
  },
  trending_territories: {
    key: "zai.tool.trending-territories.resolved",
    defaultValue: "Territórios em alta identificados"
  },
  territory_resource: {
    key: "zai.tool.territory-resource.resolved",
    defaultValue: "Informações do território carregadas"
  },
  territory_tags: {
    key: "zai.tool.territory-tags.resolved",
    defaultValue: "Tags principais carregadas"
  },
  territory_niches: {
    key: "zai.tool.territory-niches.resolved",
    defaultValue: "Nichos identificados"
  },
  territory_formats: {
    key: "zai.tool.territory-formats.resolved",
    defaultValue: "Formatos analisados"
  },
  territory_creators: {
    key: "zai.tool.territory-creators.resolved",
    defaultValue: "Criadores relevantes encontrados"
  },
  territory_videos: {
    key: "zai.tool.territory-videos.resolved",
    defaultValue: "Vídeos carregados"
  },
  territory_performance: {
    key: "zai.tool.territory-performance.resolved",
    defaultValue: "Métricas extraídas com sucesso"
  },
  territory_affinities: {
    key: "zai.tool.territory-affinities.resolved",
    defaultValue: "Afinidade calculada"
  },
  territory_audience: {
    key: "zai.tool.territory-audience.resolved",
    defaultValue: "Público analisado"
  },
  deep_analysis: {
    key: "zai.tool.deep-analysis.resolved",
    defaultValue: "Análise aprofundada concluída"
  }
}, DF = {
  [te.GET_MY_BRAND]: "my_brand",
  [te.GET_MY_COMPETITORS]: "my_competitors",
  [te.SHARE_OF_ENGAGEMENT_CONTENT_AND_VIEWS]: "share_of_engagement",
  [te.GET_KEY_FINDINGS]: "key_findings",
  [te.SHARE_OF_ATTENTION]: "share_of_attention",
  [te.SHARE_OF_ATTENTION_V2]: "share_of_attention",
  [te.GET_TRENDING_TERRITORIES]: "trending_territories",
  [te.GET_TERRITORY_RESOURCE]: "territory_resource",
  [te.GET_TERRITORY_TAGS_RESOURCE]: "territory_tags",
  [te.GET_TERRITORY_NICHES_RESOURCE]: "territory_niches",
  [te.GET_TERRITORY_FORMATS_RESOURCE]: "territory_formats",
  [te.GET_TERRITORY_CREATORS_RESOURCE]: "territory_creators",
  [te.GET_TERRITORY_VIDEOS_RESOURCE]: "territory_videos",
  [te.GET_TERRITORY_PERFORMANCE_RESOURCE]: "territory_performance",
  [te.GET_TERRITORY_AFFINITIES_RESOURCE]: "territory_affinities",
  [te.GET_TERRITORY_AUDIENCE_RESOURCE]: "territory_audience",
  [te.DEEP_ANALYSIS_RESOURCE]: "deep_analysis"
}, LF = () => {
  const { t: e } = He(), t = J((r) => r?.message?.content);
  return se(() => {
    const r = t?.filter((s) => s.type === "tool-call");
    return r?.length ? r.map((s) => {
      const i = MT(s.argsText || "");
      if (!i) return s;
      const a = DF[i] || "default", o = Kp[a] ? e(Kp[a]) : e(OF.default), u = Qp[a] ? e(Qp[a]) : void 0;
      return {
        ...s,
        toolUri: i,
        reasoningText: o,
        resolvedText: u
      };
    }) : [];
  }, [t, e]);
}, Xp = {
  checkedSources: {
    key: "zai.tool-group.checked-sources",
    defaultValue: "Chequei as fontes de dados"
  },
  processingUnknownTool: {
    key: "zai.tool-group.processing-unknown-tool",
    defaultValue: "Processando informações"
  }
}, MF = () => {
  const { t: e } = He(), t = LF(), n = J((c) => c?.message?.content), r = J((c) => c?.message?.status), s = t.length > 0, i = se(() => {
    const c = n?.findLast((h) => h.type === "text");
    return c && c.text?.trim().length > 0 ? !1 : r?.type === "running";
  }, [n, r?.type]), a = t?.filter((c) => MT(c.argsText || "") !== null), o = a && a.length > 0 ? a[a.length - 1] : void 0;
  return { title: se(() => i ? o?.reasoningText || o?.argsText || e(Xp.processingUnknownTool) : e(Xp.checkedSources), [e, i, o?.reasoningText, o?.argsText]), toolCalls: a, isRunning: i, hasToolCalls: s };
}, HF = ({ isRunning: e, toolCalls: t }) => {
  const n = e ? t?.slice(0, -1) : t, r = se(() => n ? Array.from(new Map(n.map((i) => [i.toolUri, i])).values()) : [], [n?.length]);
  return {
    checkedToolsCount: r ? r.length : 0,
    uniqueToolCalls: r
  };
}, BF = {
  thought: {
    key: "zai.checked-tools.thought",
    defaultValue: "Pensamento"
  }
}, UF = ({ uniqueToolCalls: e, checkedToolsCount: t }) => {
  const { t: n } = He();
  return /* @__PURE__ */ d.jsxs($l, { children: [
    /* @__PURE__ */ d.jsx(zl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(
      pt,
      {
        variant: "outline",
        disabled: t === 0,
        className: `
            text-primary
            font-normal
            text-base
            py-0.5
            pr-2
            pl-1.5
            border
            border-neutral-200
            bg-white
            rounded-full
            whitespace-nowrap
            inline-flex
            gap-1
            items-center
            max-w-36
            hover:border-neutral-300
            hover:bg-neutral-50
            hover:[&>span]:inline-flex
            h-auto
          `,
        children: [
          /* @__PURE__ */ d.jsx(gf, { className: "size-5 text-purple-600 dark:text-purple-300" }),
          t
        ]
      }
    ) }),
    /* @__PURE__ */ d.jsxs(
      Vl,
      {
        side: "top",
        align: "start",
        className: "border rounded-xl border-neutral-200 dark:border-neutral-500 bg-white dark:bg-neutral-800 w-fit max-w-xl",
        children: [
          /* @__PURE__ */ d.jsx("h4", { className: "text-sm text-muted-foreground mb-2", children: n(BF.thought) }),
          /* @__PURE__ */ d.jsx("div", { className: "max-h-60 overflow-y-auto", children: e.map((r) => /* @__PURE__ */ d.jsxs(
            "div",
            {
              className: "flex items-center gap-2 my-3 text-purple-600 dark:text-purple-300",
              children: [
                /* @__PURE__ */ d.jsx(gf, { size: 20 }),
                /* @__PURE__ */ d.jsx("p", { children: r.resolvedText })
              ]
            },
            `reasoning-text-${r.toolCallId}`
          )) })
        ]
      }
    )
  ] });
}, FF = (e) => {
  const t = HF(e);
  return /* @__PURE__ */ d.jsx(UF, { ...t });
}, jF = ({ title: e, isRunning: t, toolCalls: n, hasToolCalls: r }) => r ? /* @__PURE__ */ d.jsxs("div", { className: "flex items-center gap-2 my-3 text-purple-600 dark:text-purple-300", children: [
  t && /* @__PURE__ */ d.jsx("span", { className: "animate-spin size-5 border-2 border-purple-600 dark:border-purple-300 rounded-full border-t-transparent" }),
  /* @__PURE__ */ d.jsx("p", { children: e }),
  /* @__PURE__ */ d.jsx(FF, { toolCalls: n, isRunning: t })
] }) : null, $F = () => {
  const e = MF();
  return /* @__PURE__ */ d.jsx(jF, { ...e });
}, HT = de($F), Ad = ({ className: e, ...t }) => /* @__PURE__ */ d.jsxs(
  mE,
  {
    hideWhenSingleBranch: !0,
    className: ue("text-muted-foreground inline-flex items-center text-xs", e),
    ...t,
    children: [
      /* @__PURE__ */ d.jsx(dv, { asChild: !0, children: /* @__PURE__ */ d.jsx(Qt, { tooltip: "Previous", children: /* @__PURE__ */ d.jsx(gb, {}) }) }),
      /* @__PURE__ */ d.jsxs("span", { className: "font-medium", children: [
        /* @__PURE__ */ d.jsx(pE, {}),
        " / ",
        /* @__PURE__ */ d.jsx(fE, {})
      ] }),
      /* @__PURE__ */ d.jsx(cv, { asChild: !0, children: /* @__PURE__ */ d.jsx(Qt, { tooltip: "Next", children: /* @__PURE__ */ d.jsx(GR, {}) }) })
    ]
  }
), zF = () => /* @__PURE__ */ d.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", width: "16", height: "16", children: /* @__PURE__ */ d.jsx("rect", { width: "10", height: "10", x: "3", y: "3", rx: "2" }) }), Jp = (e) => /* @__PURE__ */ d.jsx(
  Qt,
  {
    variant: "default",
    side: "top",
    className: `
        my-3
        size-8
        p-2
        transition-opacity
        ease-in
        text-white
        bg-gradient-to-br
        from-purple-600
        to-violet-900
        hover:from-purple-700
        hover:to-purple-900
      `,
    ...e
  }
), VF = () => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
  /* @__PURE__ */ d.jsx(gi, { running: !1, children: /* @__PURE__ */ d.jsx(EE, { asChild: !0, children: /* @__PURE__ */ d.jsx(Jp, { tooltip: "Send", children: /* @__PURE__ */ d.jsx(pP, {}) }) }) }),
  /* @__PURE__ */ d.jsx(gi, { running: !0, children: /* @__PURE__ */ d.jsx(_E, { asChild: !0, children: /* @__PURE__ */ d.jsx(Jp, { tooltip: "Cancel", children: /* @__PURE__ */ d.jsx(zF, {}) }) }) })
] }), BT = () => {
  const { t: e } = He();
  return /* @__PURE__ */ d.jsxs(
    wl,
    {
      className: `
        focus-within:border-ring/20
        flex
        w-full
        flex-wrap
        items-center
        rounded-2xl
        border
        bg-white
        dark:bg-neutral-800
        px-3
        shadow-sm
        transition-colors
        ease-in
      `,
      children: [
        /* @__PURE__ */ d.jsx("div", { className: "flex items-center my-3", children: /* @__PURE__ */ d.jsx(Cb, { className: "size-7 text-neutral-500 dark:text-[#FFFFFF80]" }) }),
        /* @__PURE__ */ d.jsx(
          vl,
          {
            rows: 1,
            autoFocus: !0,
            placeholder: e($t.placeholder),
            className: `
          placeholder:text-muted-foreground
          max-h-40
          flex-grow
          resize-none
          border-none
          bg-transparent
          px-2
          py-4
          text-sm
          outline-none
          focus:ring-0
          disabled:cursor-not-allowed
        `
          }
        ),
        /* @__PURE__ */ d.jsx(VF, {})
      ]
    }
  );
}, UT = () => /* @__PURE__ */ d.jsxs(wl, { className: "bg-muted my-4 flex w-full max-w-[var(--thread-max-width)] flex-col gap-2 rounded-xl", children: [
  /* @__PURE__ */ d.jsx(vl, { className: "text-foreground flex h-8 w-full resize-none bg-transparent p-4 pb-0 outline-none" }),
  /* @__PURE__ */ d.jsxs("div", { className: "mx-3 mb-3 flex items-center justify-center gap-2 self-end", children: [
    /* @__PURE__ */ d.jsx(_E, { asChild: !0, children: /* @__PURE__ */ d.jsx(pt, { variant: "ghost", children: "Cancel" }) }),
    /* @__PURE__ */ d.jsx(EE, { asChild: !0, children: /* @__PURE__ */ d.jsx(pt, { children: "Send" }) })
  ] })
] }), YF = () => /* @__PURE__ */ d.jsx(
  go,
  {
    hideWhenRunning: !0,
    autohide: "not-last",
    className: "flex flex-col items-end col-start-1 row-start-2 mr-3 mt-2.5",
    children: /* @__PURE__ */ d.jsx(HC, { asChild: !0 })
  }
), FT = () => /* @__PURE__ */ d.jsxs(
  Po,
  {
    className: `
        flex
        justify-end
        gap-y-2
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
    children: [
      /* @__PURE__ */ d.jsx(YF, {}),
      /* @__PURE__ */ d.jsx(
        "div",
        {
          className: `
          bg-muted
          text-foreground
          max-w-[min(calc(var(--thread-max-width)*0.8),70%)]
          break-words
          rounded-lg
          py-2
          px-3
        `,
          children: /* @__PURE__ */ d.jsx(Oo, {})
        }
      ),
      /* @__PURE__ */ d.jsx(Ad, { className: "col-span-full col-start-1 row-start-3 -mr-1 justify-end" })
    ]
  }
), jT = ({ className: e }) => {
  const t = J((a) => a?.thread?.isLoading), { t: n } = He(), { isLoading: r, data: s } = wF(), i = t || r;
  return /* @__PURE__ */ d.jsx(
    kl,
    {
      className: ue("box-border flex h-full flex-col overflow-hidden rounded-xl", e),
      style: {
        "--thread-max-width": "42rem"
      },
      children: /* @__PURE__ */ d.jsxs(Rl, { className: "flex h-full flex-col items-center overflow-y-scroll scroll-smooth px-4 pt-8 mb-19", children: [
        i && /* @__PURE__ */ d.jsx("div", { className: "flex flex-grow items-center justify-center", children: n($t.loading) }),
        !i && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsx(qF, { suggestions: s }),
          /* @__PURE__ */ d.jsx(GF, {}),
          /* @__PURE__ */ d.jsx(gi, { empty: !1, children: /* @__PURE__ */ d.jsx("div", { className: "min-h-8 flex-grow" }) }),
          /* @__PURE__ */ d.jsxs("div", { className: "absolute self-center-safe bottom-0 mt-3 flex w-full max-w-[var(--thread-max-width)] flex-col items-center justify-end rounded-t-lg bg-inherit px-4 pb-9 z-[10]", children: [
            /* @__PURE__ */ d.jsx(WF, {}),
            /* @__PURE__ */ d.jsx(BT, {})
          ] })
        ] })
      ] })
    }
  );
}, GF = () => {
  const e = J((r) => r?.thread?.messages?.length), [t, n] = ce(!1);
  return os(() => {
    n(!0);
  }, []), !t || e === 0 ? null : /* @__PURE__ */ d.jsx(d.Fragment, { children: Array.from({ length: e }, (r, s) => /* @__PURE__ */ d.jsx(
    sl,
    {
      index: s,
      components: {
        UserMessage: FT,
        EditComposer: UT,
        AssistantMessage: XF
      }
    },
    s
  )) });
}, WF = () => {
  const { t: e } = He();
  return /* @__PURE__ */ d.jsx(RE, { asChild: !0, children: /* @__PURE__ */ d.jsx(
    Qt,
    {
      tooltip: e($t.scrollToBottom),
      variant: "outline",
      side: "top",
      className: "absolute -top-8 rounded-full disabled:invisible",
      children: /* @__PURE__ */ d.jsx(pb, {})
    }
  ) });
}, qF = ({ suggestions: e }) => {
  const { t } = He();
  return /* @__PURE__ */ d.jsx(NE, { children: /* @__PURE__ */ d.jsxs("div", { className: "flex w-full max-w-[var(--thread-max-width)] flex-grow flex-col justify-center gap-9", children: [
    /* @__PURE__ */ d.jsx("div", { className: "flex w-full flex-col items-center justify-center", children: /* @__PURE__ */ d.jsx("p", { className: "mt-4 font-semibold text-3xl", children: t($t.welcomeMessage) }) }),
    /* @__PURE__ */ d.jsx(KF, { suggestions: e })
  ] }) });
}, KF = ({ suggestions: e }) => /* @__PURE__ */ d.jsx("div", { className: "mt-3 flex w-full items-stretch justify-center gap-4 flex-wrap", children: e.map((t, n) => /* @__PURE__ */ d.jsx(
  QF,
  {
    id: t.id,
    prompt: t.text,
    method: "replace",
    autoSend: !0,
    children: t.text
  },
  `thread-welcome-suggestion-item-${n}`
)) }), QF = ({ id: e, prompt: t, method: n = "replace", autoSend: r = !1, children: s }) => {
  const { setIsPrePrompt: i } = Es(), { setQuickPromptId: a } = Vc();
  return /* @__PURE__ */ d.jsx(
    Jv,
    {
      onClick: () => {
        i(!0), a(e ? String(e) : null);
      },
      prompt: t,
      method: n,
      autoSend: r,
      asChild: !0,
      children: /* @__PURE__ */ d.jsxs(pt, { variant: "purple-gradient", size: "lg", className: "h-11 rounded-xl font-normal", children: [
        /* @__PURE__ */ d.jsx(u3, {}),
        s
      ] })
    }
  );
}, XF = () => {
  const { t: e } = He(), t = J((n) => n?.message?.status?.type === "complete");
  return /* @__PURE__ */ d.jsxs(
    Po,
    {
      className: `
        grid
        grid-cols-[auto_auto_1fr]
        grid-rows-[auto_1fr]
        relative
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `
          text-foreground
          max-w-[var(--thread-max-width)]
          break-words
          leading-7
          col-span-2
          col-start-2
          row-start-1
          my-1.5
        `,
            children: [
              /* @__PURE__ */ d.jsx(DT, {}),
              /* @__PURE__ */ d.jsx(HT, {}),
              /* @__PURE__ */ d.jsx(
                Oo,
                {
                  components: {
                    Text: kT,
                    ToolGroup: () => null,
                    tools: {
                      Fallback: void 0
                    }
                  }
                }
              ),
              t && /* @__PURE__ */ d.jsx(PT, {}),
              /* @__PURE__ */ d.jsx(Nl, { children: /* @__PURE__ */ d.jsx("div", { className: "rounded-lg p-2 text-sm bg-red-500/10 border border-red-500/20", children: /* @__PURE__ */ d.jsx("p", { children: e($t.somethingWentWrong) }) }) })
            ]
          }
        ),
        /* @__PURE__ */ d.jsx(JF, {}),
        /* @__PURE__ */ d.jsx(Ad, { className: "col-start-2 row-start-2 -ml-2 mr-2" })
      ]
    }
  );
}, JF = () => {
  const { t: e } = He();
  return /* @__PURE__ */ d.jsxs(
    go,
    {
      hideWhenRunning: !0,
      autohide: "never",
      autohideFloat: "single-branch",
      className: "items-center text-neutral-200 flex gap-1 col-start-3 row-start-2 -ml-1 data-[floating]:bg-background data-[floating]:absolute data-[floating]:rounded-md data-[floating]:border data-[floating]:p-1 data-[floating]:shadow-sm",
      children: [
        /* @__PURE__ */ d.jsx(nn, { hasContent: !0, children: /* @__PURE__ */ d.jsx(Gl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(Qt, { tooltip: e($t.copy), children: [
          /* @__PURE__ */ d.jsx(nn, { copied: !0, children: /* @__PURE__ */ d.jsx(Do, {}) }),
          /* @__PURE__ */ d.jsx(nn, { copied: !1, children: /* @__PURE__ */ d.jsx(Fl, {}) })
        ] }) }) }),
        /* @__PURE__ */ d.jsxs(nn, { last: !0, children: [
          /* @__PURE__ */ d.jsx(Ag, { asChild: !0, children: /* @__PURE__ */ d.jsx(Qt, { tooltip: "Refresh", children: /* @__PURE__ */ d.jsx(bb, {}) }) }),
          /* @__PURE__ */ d.jsxs(nn, { hasContent: !0, children: [
            /* @__PURE__ */ d.jsx(xg, { asChild: !0, children: /* @__PURE__ */ d.jsx(qp, { type: "positive" }) }),
            /* @__PURE__ */ d.jsx(Cg, { asChild: !0, children: /* @__PURE__ */ d.jsx(qp, { type: "negative", hasDialog: !0 }) })
          ] })
        ] }),
        /* @__PURE__ */ d.jsx(LT, {})
      ]
    }
  );
}, Nn = {
  threadId: "thread_id",
  threadPrompt: "thread_prompt",
  threadPromptPage: "thread_prompt_page",
  quickPromptId: "quick_prompt_id"
}, ZF = ({ children: e }) => {
  const t = J((O) => O?.threadListItem?.remoteId), n = J((O) => O?.threads?.threadIds), r = J((O) => O?.threads?.isLoading), s = J((O) => O?.thread?.isLoading), i = Re(), a = em(), { search: o, pathname: u } = p1(), c = se(() => new URLSearchParams(o), [o]), l = c.get(Nn.threadId), h = c.get(Nn.threadPrompt), m = c.get(Nn.threadPromptPage), p = c.get(Nn.quickPromptId), E = Ke(!0), { setIsPrePrompt: g, setPage: _ } = Es(), { setQuickPromptId: b } = Vc(), [T, C] = ce(!1), R = ne(() => {
    const O = `${u}?${c.toString()}`;
    a.replace(O);
  }, [a, c, u]), D = ne(() => {
    c.delete(Nn.threadPrompt), c.delete(Nn.threadPromptPage), c.delete(Nn.quickPromptId);
  }, [c]), w = ne(async () => {
    if (h)
      return new Promise((O) => {
        m && _({ page: m }), p && b(p), g(!0), E.current = !1, i.threads().switchToNewThread(), setTimeout(() => {
          i.thread().append({
            role: "user",
            content: [{ type: "text", text: h }]
          }), setTimeout(O, 100);
        }, 100);
      });
  }, [m, p, h, g, i, _, b]);
  return _e(() => {
    !r && !n.length || C(!0);
  }, [r, n]), _e(() => {
    s || !t || t === l || h || (E.current = !1, c.set(Nn.threadId, t), R());
  }, [t, s, l, c, u, R, h]), _e(() => {
    const O = n.find((U) => U === l);
    !E.current || !l || !i || !O || h || (E.current = !1, i.threads().switchToThread(O));
  }, [i, l, n, h]), _e(() => {
    !i || r || !T || !h || w().then(() => {
      D(), R();
    }).catch((O) => {
      console.error("INITIAL PROMPT BY URL", O);
    });
  }, [
    i,
    T,
    w,
    r,
    h,
    u,
    c,
    D,
    R
  ]), /* @__PURE__ */ d.jsx(d.Fragment, { children: e });
}, e9 = de(ZF), t9 = "zai-chat:modal-upload-open", n9 = "zai-chat:modal-info-open", Zp = "zai-chat:file-count-refetch", r9 = () => {
  const e = Ke(null), t = ne(() => {
    window.dispatchEvent(new CustomEvent(t9));
  }, []), n = ne(() => {
    window.dispatchEvent(new CustomEvent(n9));
  }, []);
  return _e(() => {
    const r = () => {
      e.current?.refetch();
    };
    return window.addEventListener(Zp, r), () => {
      window.removeEventListener(Zp, r);
    };
  }, []), {
    handleModalUploadOpen: t,
    handleModalInfoOpen: n,
    fileUploadRef: e
  };
};
function K9() {
  const { assistantUiIsReady: e } = at(), { handleModalUploadOpen: t, handleModalInfoOpen: n, fileUploadRef: r } = r9(), { setOrigin: s } = Es();
  return _e(() => {
    s({ origin: "center-stage" });
  }, [s]), /* @__PURE__ */ d.jsx("main", { id: "zai-chat-center-stage", className: "zai-chat-package dark", style: { height: "100%" }, children: /* @__PURE__ */ d.jsx(Td, { theme: "dark", children: /* @__PURE__ */ d.jsx(jl, { theme: "dark", children: e && /* @__PURE__ */ d.jsx(e9, { children: /* @__PURE__ */ d.jsxs(
    QP,
    {
      className: "h-full min-h-0 relative",
      style: {
        "--sidebar-width": "calc(328px + 2rem)"
      },
      children: [
        /* @__PURE__ */ d.jsx(l3, {}),
        /* @__PURE__ */ d.jsx("div", { className: "absolute bottom-0 px-4 pb-4", style: { width: "var(--sidebar-width)" }, children: /* @__PURE__ */ d.jsx(
          Nb,
          {
            onButtonClick: t,
            onInfoClick: n,
            ref: r
          }
        ) }),
        /* @__PURE__ */ d.jsx(JP, { className: "bg-transparent", children: /* @__PURE__ */ d.jsx("div", { className: "grid h-full p-4 pl-0", children: /* @__PURE__ */ d.jsx(Mo, { children: /* @__PURE__ */ d.jsx(jT, { className: "bg-background" }) }) }) })
      ]
    }
  ) }) }) }) });
}
const s9 = de(({ isOpen: e, children: t }) => /* @__PURE__ */ d.jsx("div", { className: "aside-modal-view-container", "data-open": e, "aria-hidden": !e, children: t })), i9 = de(({ children: e, isOpen: t }) => /* @__PURE__ */ d.jsx(s9, { isOpen: t, children: e })), a9 = de(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "button-arrow", onClick: e, children: /* @__PURE__ */ d.jsx(t, { width: 28, height: 28 }) })), o9 = de(({ handleClick: e }) => /* @__PURE__ */ d.jsx(a9, { handleClick: e, Icon: gb })), u9 = de(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "button-expand", onClick: e, children: /* @__PURE__ */ d.jsx(t, {}) })), c9 = de(({ handleClick: e }) => /* @__PURE__ */ d.jsx(u9, { handleClick: e, Icon: cP })), l9 = de(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "menu-hamburger", onClick: e, children: /* @__PURE__ */ d.jsx(t, {}) })), d9 = de(({ handleClick: e }) => /* @__PURE__ */ d.jsx(l9, { handleClick: e, Icon: FR })), h9 = de(({ handleClick: e, Icon: t }) => /* @__PURE__ */ d.jsx("button", { className: "button-x", onClick: e, children: /* @__PURE__ */ d.jsx(t, { width: 28, height: 28 }) })), f9 = de(({ handleClick: e }) => /* @__PURE__ */ d.jsx(h9, { handleClick: e, Icon: _b })), p9 = de(
  ({ handleButtonMenuClick: e, handleItemClick: t, CloseComponent: n }) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-aside-header", children: /* @__PURE__ */ d.jsx(n, { handleClick: () => e({ isOpen: !1 }) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-aside-content", children: /* @__PURE__ */ d.jsx(Ab, { handleItemClick: t }) })
  ] })
), m9 = () => /* @__PURE__ */ d.jsx(Mo, { children: /* @__PURE__ */ d.jsx(jT, {}) }), g9 = de(m9), E9 = de(
  ({
    handleButtonCloseClick: e,
    handleButtonMenuClick: t,
    handleButtonRedirectClick: n,
    LogoComponent: r,
    MenuComponent: s,
    CloseComponent: i,
    RedirectComponent: a
  }) => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-header-box-left", children: /* @__PURE__ */ d.jsx(s, { handleClick: () => t({ isOpen: !0 }) }) }),
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-header-box-middle", children: /* @__PURE__ */ d.jsx(r, {}) }),
    /* @__PURE__ */ d.jsxs("div", { className: "side-modal-view-header-box-right", children: [
      /* @__PURE__ */ d.jsx(a, { handleClick: n }),
      /* @__PURE__ */ d.jsx(i, { handleClick: e })
    ] })
  ] })
), b9 = ({
  isAsideModalOpen: e,
  setIsAsideModalOpen: t,
  threadId: n,
  mixpanelSetOrigin: r
}) => {
  const s = em(), [i, a] = ce({
    isAsideContentOpen: !1
  });
  _e(() => {
    e && (Wt.track(rn.sideChatOpen), r({ origin: "side-chat" }));
  }, [e, r]);
  const o = ne(
    ({ isOpen: h }) => a((m) => ({ ...m, isAsideContentOpen: h })),
    []
  ), u = ne(() => {
    Wt.track(rn.sideChatClose), t(!1);
  }, [t]), c = ne(
    () => s.push(`/zai${n ? `?${Nn.threadId}=${n}` : ""}`),
    [s, n]
  ), l = ne(
    () => a((h) => ({ ...h, isAsideContentOpen: !1 })),
    [a]
  );
  return {
    sideChatStates: i,
    handles: {
      sideChat: {
        handleButtonMenuClick: o,
        handleButtonCloseClick: u,
        handleButtonRedirectClick: c,
        handleThreadListItemClick: l
      }
    }
  };
}, _9 = de(
  ({
    ContentComponent: e,
    AsideContentComponent: t,
    AsideCloseComponent: n,
    HeaderComponent: r,
    HeaderLogoComponent: s,
    HeaderMenuComponent: i,
    HeaderCloseComponent: a,
    HeaderRedirectComponent: o,
    ...u
  }) => /* @__PURE__ */ d.jsxs("div", { className: "side-modal-view-container", children: [
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-header", children: /* @__PURE__ */ d.jsx(
      r,
      {
        handleButtonCloseClick: u.handleButtonCloseClick,
        handleButtonMenuClick: u.handleButtonMenuClick,
        handleButtonRedirectClick: u.handleButtonRedirectClick,
        LogoComponent: s,
        MenuComponent: i,
        CloseComponent: a,
        RedirectComponent: o
      }
    ) }),
    /* @__PURE__ */ d.jsx("div", { className: "side-modal-view-content h-full flex flex-col overflow-y-scroll", children: /* @__PURE__ */ d.jsx(e, {}) }),
    /* @__PURE__ */ d.jsx(
      "div",
      {
        className: "side-modal-view-aside",
        "data-open": u.isAsideContentOpen,
        "aria-hidden": !u.isAsideContentOpen,
        children: /* @__PURE__ */ d.jsx(
          t,
          {
            handleButtonMenuClick: u.handleButtonMenuClick,
            handleItemClick: u.handleThreadListItemClick,
            CloseComponent: n
          }
        )
      }
    )
  ] })
), T9 = de(({ isAsideModalOpen: e, setIsAsideModalOpen: t }) => {
  const n = J((i) => i?.threadListItem?.remoteId), { setOrigin: r } = Es(), s = b9({
    isAsideModalOpen: e,
    setIsAsideModalOpen: t,
    threadId: n,
    mixpanelSetOrigin: r
  });
  return /* @__PURE__ */ d.jsx(i9, { isOpen: e, children: /* @__PURE__ */ d.jsx(
    _9,
    {
      ...s.handles.sideChat,
      ...s.sideChatStates,
      HeaderComponent: E9,
      HeaderLogoComponent: Sb,
      HeaderMenuComponent: d9,
      HeaderCloseComponent: f9,
      HeaderRedirectComponent: c9,
      ContentComponent: g9,
      AsideContentComponent: p9,
      AsideCloseComponent: o9
    }
  ) });
});
function Q9({ isOpen: e, onOpenChange: t }) {
  const { assistantUiIsReady: n } = at();
  return /* @__PURE__ */ d.jsx("main", { className: "zai-chat-package dark", children: /* @__PURE__ */ d.jsx(Td, { theme: "dark", children: /* @__PURE__ */ d.jsx(jl, { theme: "dark", children: n && /* @__PURE__ */ d.jsx(T9, { isAsideModalOpen: e, setIsAsideModalOpen: t }) }) }) });
}
const Ea = 100, A9 = (e) => {
  const {
    contextKey: t,
    threadPrompt: n,
    skipResponseInteraction: r,
    mixpanelSetOrigin: s,
    mixpanelSetIsProactiveMessage: i,
    currentAssistUiThreadId: a,
    currentSectionThreadId: o,
    setCurrentSectionThreadId: u,
    getLastSentPrompt: c,
    setLastSentPrompt: l,
    assistRuntime: h
  } = e, [m, p] = ce(!1), [E, g] = ce(!1), _ = Ke(!1), b = se(
    () => n !== c(t),
    [t, c, n]
  );
  return _e(() => {
    !m || !a || u({ contextKey: t, id: a });
  }, [t, m, a, u]), _e(() => {
    if (_.current && !b || (_.current = !0, s({ origin: t }), g(!0), !b && a && o && a === o))
      return;
    if (!b && o) {
      h.threads().switchToThread(o);
      return;
    }
    if (b && o) {
      i(!0), h.threads().switchToThread(o);
      let C;
      const R = setTimeout(() => {
        h.thread().cancelRun(), C = setTimeout(() => {
          h.thread().append({
            role: "user",
            content: [{ type: "text", text: n }],
            runConfig: { custom: { skipResponseInteraction: r } }
          }), l({ contextKey: t, prompt: n });
        }, Ea);
      }, Ea);
      return () => {
        clearTimeout(R), clearTimeout(C);
      };
    }
    h.threads().switchToNewThread();
    const T = setTimeout(() => {
      i(!0), h.thread().append({
        role: "user",
        content: [{ type: "text", text: n }],
        runConfig: { custom: { skipResponseInteraction: r } }
      }), l({ contextKey: t, prompt: n }), setTimeout(() => p(!0), Ea);
    }, Ea);
    return () => clearTimeout(T);
  }, [
    t,
    n,
    r,
    a,
    o,
    b,
    s,
    i,
    h,
    l
  ]), {
    shouldRender: E
  };
}, y9 = {
  promptTitle: {
    key: "zai.section.heading-title",
    defaultValue: "Conversa com assistente..."
  }
}, x9 = 1, C9 = ({ className: e, welcomeMessage: t }) => {
  const n = J((s) => s?.thread?.isLoading), { t: r } = He();
  return /* @__PURE__ */ d.jsx(
    kl,
    {
      className: ue("box-border flex h-full flex-col overflow-hidden rounded-xl relative", e),
      style: { "--thread-max-width": "100%" },
      children: /* @__PURE__ */ d.jsxs(Rl, { className: "flex h-full flex-col items-center overflow-y-scroll scroll-smooth px-4 pt-8 mb-32", children: [
        n && /* @__PURE__ */ d.jsx("div", { className: "flex flex-grow items-center justify-center", children: t || r($t.loading) }),
        !n && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
          /* @__PURE__ */ d.jsx("h3", { className: "text-lg font-semibold mb-3 w-full", children: t || r(y9.promptTitle) }),
          /* @__PURE__ */ d.jsx(S9, {}),
          /* @__PURE__ */ d.jsx(gi, { empty: !1, children: /* @__PURE__ */ d.jsx("div", { className: "min-h-8 flex-grow" }) }),
          /* @__PURE__ */ d.jsxs("div", { className: "fixed self-center-safe bottom-0 flex w-full max-w-[68rem] flex-col items-center justify-end rounded-t-lg bg-inherit px-4 pb-7 z-[10]", children: [
            /* @__PURE__ */ d.jsx(w9, {}),
            /* @__PURE__ */ d.jsx(BT, {})
          ] }),
          /* @__PURE__ */ d.jsx(
            "div",
            {
              "aria-hidden": "true",
              className: "fixed bottom-0 left-0 right-0 h-30 bg-gradient-to-t from-background via-background/80 to-transparent pointer-events-none z-[5]"
            }
          )
        ] })
      ] })
    }
  );
}, S9 = () => {
  const e = J((r) => r?.thread?.messages?.length), [t, n] = ce(!1);
  return os(() => {
    n(!0);
  }, []), !t || e === 0 ? null : /* @__PURE__ */ d.jsx(d.Fragment, { children: Array.from({ length: e }, (r, s) => s < x9 ? null : /* @__PURE__ */ d.jsx(
    sl,
    {
      index: s,
      components: {
        UserMessage: FT,
        EditComposer: UT,
        AssistantMessage: I9
      }
    },
    s
  )) });
}, w9 = () => {
  const { t: e } = He();
  return /* @__PURE__ */ d.jsx(RE, { asChild: !0, children: /* @__PURE__ */ d.jsx(
    Qt,
    {
      tooltip: e($t.scrollToBottom),
      variant: "outline",
      side: "top",
      className: "absolute -top-8 rounded-full disabled:invisible",
      children: /* @__PURE__ */ d.jsx(pb, {})
    }
  ) });
}, I9 = () => {
  const { t: e } = He(), t = J((n) => n?.message?.status?.type === "complete");
  return /* @__PURE__ */ d.jsxs(
    Po,
    {
      className: `
        grid
        grid-cols-[auto_auto_1fr]
        grid-rows-[auto_1fr]
        relative
        w-full
        max-w-[var(--thread-max-width)]
        py-4
      `,
      children: [
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            className: `
          text-foreground
          max-w-[var(--thread-max-width)]
          break-words
          leading-7
          col-span-2
          col-start-2
          row-start-1
          my-1.5
        `,
            children: [
              /* @__PURE__ */ d.jsx(DT, {}),
              /* @__PURE__ */ d.jsx(HT, {}),
              /* @__PURE__ */ d.jsx(
                Oo,
                {
                  components: {
                    Text: kT,
                    ToolGroup: () => null,
                    tools: {
                      Fallback: void 0
                    }
                  }
                }
              ),
              t && /* @__PURE__ */ d.jsx(PT, {}),
              /* @__PURE__ */ d.jsx(Nl, { children: /* @__PURE__ */ d.jsx("div", { className: "rounded-lg p-2 text-sm bg-red-500/10 border border-red-500/20", children: /* @__PURE__ */ d.jsx("p", { children: e($t.somethingWentWrong) }) }) })
            ]
          }
        ),
        /* @__PURE__ */ d.jsx(v9, {}),
        /* @__PURE__ */ d.jsx(Ad, { className: "col-start-2 row-start-2 -ml-2 mr-2" })
      ]
    }
  );
}, v9 = () => {
  const { t: e } = He();
  return /* @__PURE__ */ d.jsxs(
    go,
    {
      hideWhenRunning: !0,
      autohide: "never",
      autohideFloat: "single-branch",
      className: "items-center text-muted-foreground flex gap-1 col-start-3 row-start-2 -ml-1 data-[floating]:bg-background data-[floating]:absolute data-[floating]:rounded-md data-[floating]:border data-[floating]:p-1 data-[floating]:shadow-sm",
      children: [
        /* @__PURE__ */ d.jsx(nn, { hasContent: !0, children: /* @__PURE__ */ d.jsx(Gl, { asChild: !0, children: /* @__PURE__ */ d.jsxs(Qt, { tooltip: e($t.copy), children: [
          /* @__PURE__ */ d.jsx(nn, { copied: !0, children: /* @__PURE__ */ d.jsx(Do, {}) }),
          /* @__PURE__ */ d.jsx(nn, { copied: !1, children: /* @__PURE__ */ d.jsx(Fl, {}) })
        ] }) }) }),
        /* @__PURE__ */ d.jsx(nn, { last: !0, children: /* @__PURE__ */ d.jsx(Ag, { asChild: !0, children: /* @__PURE__ */ d.jsx(Qt, { tooltip: "Refresh", children: /* @__PURE__ */ d.jsx(bb, {}) }) }) }),
        /* @__PURE__ */ d.jsx(LT, {})
      ]
    }
  );
}, N9 = (e) => /* @__PURE__ */ d.jsx(Mo, { children: /* @__PURE__ */ d.jsx(C9, { welcomeMessage: e.welcomeMessage }) }), k9 = ({
  contextKey: e,
  threadPrompt: t,
  theme: n = "light",
  welcomeMessage: r,
  skipResponseInteraction: s
}) => {
  const { setOrigin: i, setIsProactiveMessage: a } = Es(), o = Re(), u = J((E) => E?.threadListItem?.remoteId), { getCurrentThreadId: c, setCurrentThreadId: l, getLastPrompt: h, setLastPrompt: m } = om(), { shouldRender: p } = A9({
    contextKey: e,
    threadPrompt: t,
    skipResponseInteraction: s,
    mixpanelSetOrigin: i,
    mixpanelSetIsProactiveMessage: a,
    currentAssistUiThreadId: u,
    currentSectionThreadId: c(e),
    setCurrentSectionThreadId: l,
    getLastSentPrompt: h,
    setLastSentPrompt: m,
    assistRuntime: o
  });
  return p ? /* @__PURE__ */ d.jsx(
    "div",
    {
      className: `zai-chat-package ${n}`,
      style: { flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column", position: "relative" },
      children: /* @__PURE__ */ d.jsx(Td, { theme: n, children: /* @__PURE__ */ d.jsx(jl, { theme: n, children: /* @__PURE__ */ d.jsx(N9, { welcomeMessage: r }) }) })
    }
  ) : null;
}, X9 = (e) => {
  const { assistantUiIsReady: t } = at();
  return t ? /* @__PURE__ */ d.jsx(k9, { ...e }) : null;
};
export {
  Zp as ZAI_CHAT_FILE_COUNT_REFETCH_EVENT,
  n9 as ZAI_CHAT_MODAL_INFO_OPEN_EVENT,
  t9 as ZAI_CHAT_MODAL_UPLOAD_OPEN_EVENT,
  q9 as ZaiChatAccessProvider,
  K9 as ZaiChatCenterStage,
  X9 as ZaiChatSection,
  Q9 as ZaiChatSideChat
};
